var Globalize = require("globalize");

Globalize.load([{
  "supplemental": {
    "version": {
      "_number": "$Revision: 14929 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "metadata": {
      "alias": {
        "languageAlias": {
          "aa-SAAHO": {
            "_reason": "deprecated",
            "_replacement": "ssy"
          },
          "aam": {
            "_reason": "deprecated",
            "_replacement": "aas"
          },
          "aar": {
            "_reason": "overlong",
            "_replacement": "aa"
          },
          "abk": {
            "_reason": "overlong",
            "_replacement": "ab"
          },
          "adp": {
            "_reason": "deprecated",
            "_replacement": "dz"
          },
          "afr": {
            "_reason": "overlong",
            "_replacement": "af"
          },
          "aju": {
            "_reason": "macrolanguage",
            "_replacement": "jrb"
          },
          "aka": {
            "_reason": "overlong",
            "_replacement": "ak"
          },
          "alb": {
            "_reason": "bibliographic",
            "_replacement": "sq"
          },
          "als": {
            "_reason": "macrolanguage",
            "_replacement": "sq"
          },
          "amh": {
            "_reason": "overlong",
            "_replacement": "am"
          },
          "ara": {
            "_reason": "overlong",
            "_replacement": "ar"
          },
          "arb": {
            "_reason": "macrolanguage",
            "_replacement": "ar"
          },
          "arg": {
            "_reason": "overlong",
            "_replacement": "an"
          },
          "arm": {
            "_reason": "bibliographic",
            "_replacement": "hy"
          },
          "art-lojban": {
            "_reason": "deprecated",
            "_replacement": "jbo"
          },
          "asm": {
            "_reason": "overlong",
            "_replacement": "as"
          },
          "aue": {
            "_reason": "deprecated",
            "_replacement": "ktz"
          },
          "ava": {
            "_reason": "overlong",
            "_replacement": "av"
          },
          "ave": {
            "_reason": "overlong",
            "_replacement": "ae"
          },
          "aym": {
            "_reason": "overlong",
            "_replacement": "ay"
          },
          "ayr": {
            "_reason": "macrolanguage",
            "_replacement": "ay"
          },
          "ayx": {
            "_reason": "deprecated",
            "_replacement": "nun"
          },
          "az-AZ": {
            "_reason": "legacy",
            "_replacement": "az-Latn-AZ"
          },
          "aze": {
            "_reason": "overlong",
            "_replacement": "az"
          },
          "azj": {
            "_reason": "macrolanguage",
            "_replacement": "az"
          },
          "bak": {
            "_reason": "overlong",
            "_replacement": "ba"
          },
          "bam": {
            "_reason": "overlong",
            "_replacement": "bm"
          },
          "baq": {
            "_reason": "bibliographic",
            "_replacement": "eu"
          },
          "bcc": {
            "_reason": "macrolanguage",
            "_replacement": "bal"
          },
          "bcl": {
            "_reason": "macrolanguage",
            "_replacement": "bik"
          },
          "bel": {
            "_reason": "overlong",
            "_replacement": "be"
          },
          "ben": {
            "_reason": "overlong",
            "_replacement": "bn"
          },
          "bgm": {
            "_reason": "deprecated",
            "_replacement": "bcg"
          },
          "bh": {
            "_reason": "macrolanguage",
            "_replacement": "bho"
          },
          "bih": {
            "_reason": "overlong",
            "_replacement": "bho"
          },
          "bis": {
            "_reason": "overlong",
            "_replacement": "bi"
          },
          "bjd": {
            "_reason": "deprecated",
            "_replacement": "drl"
          },
          "bod": {
            "_reason": "overlong",
            "_replacement": "bo"
          },
          "bos": {
            "_reason": "overlong",
            "_replacement": "bs"
          },
          "bre": {
            "_reason": "overlong",
            "_replacement": "br"
          },
          "bs-BA": {
            "_reason": "legacy",
            "_replacement": "bs-Latn-BA"
          },
          "bul": {
            "_reason": "overlong",
            "_replacement": "bg"
          },
          "bur": {
            "_reason": "bibliographic",
            "_replacement": "my"
          },
          "bxk": {
            "_reason": "macrolanguage",
            "_replacement": "luy"
          },
          "bxr": {
            "_reason": "macrolanguage",
            "_replacement": "bua"
          },
          "cat": {
            "_reason": "overlong",
            "_replacement": "ca"
          },
          "ccq": {
            "_reason": "deprecated",
            "_replacement": "rki"
          },
          "cel-gaulish": {
            "_reason": "legacy",
            "_replacement": "xtg-x-cel-gaulish"
          },
          "ces": {
            "_reason": "overlong",
            "_replacement": "cs"
          },
          "cha": {
            "_reason": "overlong",
            "_replacement": "ch"
          },
          "che": {
            "_reason": "overlong",
            "_replacement": "ce"
          },
          "chi": {
            "_reason": "bibliographic",
            "_replacement": "zh"
          },
          "chu": {
            "_reason": "overlong",
            "_replacement": "cu"
          },
          "chv": {
            "_reason": "overlong",
            "_replacement": "cv"
          },
          "cjr": {
            "_reason": "deprecated",
            "_replacement": "mom"
          },
          "cka": {
            "_reason": "deprecated",
            "_replacement": "cmr"
          },
          "cld": {
            "_reason": "macrolanguage",
            "_replacement": "syr"
          },
          "cmk": {
            "_reason": "deprecated",
            "_replacement": "xch"
          },
          "cmn": {
            "_reason": "macrolanguage",
            "_replacement": "zh"
          },
          "cnr": {
            "_reason": "legacy",
            "_replacement": "sr-ME"
          },
          "cor": {
            "_reason": "overlong",
            "_replacement": "kw"
          },
          "cos": {
            "_reason": "overlong",
            "_replacement": "co"
          },
          "coy": {
            "_reason": "deprecated",
            "_replacement": "pij"
          },
          "cqu": {
            "_reason": "deprecated",
            "_replacement": "quh"
          },
          "cre": {
            "_reason": "overlong",
            "_replacement": "cr"
          },
          "cwd": {
            "_reason": "macrolanguage",
            "_replacement": "cr"
          },
          "cym": {
            "_reason": "overlong",
            "_replacement": "cy"
          },
          "cze": {
            "_reason": "bibliographic",
            "_replacement": "cs"
          },
          "dan": {
            "_reason": "overlong",
            "_replacement": "da"
          },
          "deu": {
            "_reason": "overlong",
            "_replacement": "de"
          },
          "dgo": {
            "_reason": "macrolanguage",
            "_replacement": "doi"
          },
          "dhd": {
            "_reason": "macrolanguage",
            "_replacement": "mwr"
          },
          "dik": {
            "_reason": "macrolanguage",
            "_replacement": "din"
          },
          "diq": {
            "_reason": "macrolanguage",
            "_replacement": "zza"
          },
          "div": {
            "_reason": "overlong",
            "_replacement": "dv"
          },
          "drh": {
            "_reason": "deprecated",
            "_replacement": "mn"
          },
          "drw": {
            "_reason": "deprecated",
            "_replacement": "fa-af"
          },
          "dut": {
            "_reason": "bibliographic",
            "_replacement": "nl"
          },
          "dzo": {
            "_reason": "overlong",
            "_replacement": "dz"
          },
          "ekk": {
            "_reason": "macrolanguage",
            "_replacement": "et"
          },
          "ell": {
            "_reason": "overlong",
            "_replacement": "el"
          },
          "emk": {
            "_reason": "macrolanguage",
            "_replacement": "man"
          },
          "eng": {
            "_reason": "overlong",
            "_replacement": "en"
          },
          "epo": {
            "_reason": "overlong",
            "_replacement": "eo"
          },
          "esk": {
            "_reason": "macrolanguage",
            "_replacement": "ik"
          },
          "est": {
            "_reason": "overlong",
            "_replacement": "et"
          },
          "eus": {
            "_reason": "overlong",
            "_replacement": "eu"
          },
          "ewe": {
            "_reason": "overlong",
            "_replacement": "ee"
          },
          "fao": {
            "_reason": "overlong",
            "_replacement": "fo"
          },
          "fas": {
            "_reason": "overlong",
            "_replacement": "fa"
          },
          "fat": {
            "_reason": "macrolanguage",
            "_replacement": "ak"
          },
          "fij": {
            "_reason": "overlong",
            "_replacement": "fj"
          },
          "fin": {
            "_reason": "overlong",
            "_replacement": "fi"
          },
          "fra": {
            "_reason": "overlong",
            "_replacement": "fr"
          },
          "fre": {
            "_reason": "bibliographic",
            "_replacement": "fr"
          },
          "fry": {
            "_reason": "overlong",
            "_replacement": "fy"
          },
          "fuc": {
            "_reason": "macrolanguage",
            "_replacement": "ff"
          },
          "ful": {
            "_reason": "overlong",
            "_replacement": "ff"
          },
          "gav": {
            "_reason": "deprecated",
            "_replacement": "dev"
          },
          "gaz": {
            "_reason": "macrolanguage",
            "_replacement": "om"
          },
          "gbo": {
            "_reason": "macrolanguage",
            "_replacement": "grb"
          },
          "geo": {
            "_reason": "bibliographic",
            "_replacement": "ka"
          },
          "ger": {
            "_reason": "bibliographic",
            "_replacement": "de"
          },
          "gfx": {
            "_reason": "deprecated",
            "_replacement": "vaj"
          },
          "ggn": {
            "_reason": "deprecated",
            "_replacement": "gvr"
          },
          "gla": {
            "_reason": "overlong",
            "_replacement": "gd"
          },
          "gle": {
            "_reason": "overlong",
            "_replacement": "ga"
          },
          "glg": {
            "_reason": "overlong",
            "_replacement": "gl"
          },
          "glv": {
            "_reason": "overlong",
            "_replacement": "gv"
          },
          "gno": {
            "_reason": "macrolanguage",
            "_replacement": "gon"
          },
          "gre": {
            "_reason": "bibliographic",
            "_replacement": "el"
          },
          "grn": {
            "_reason": "overlong",
            "_replacement": "gn"
          },
          "gti": {
            "_reason": "deprecated",
            "_replacement": "nyc"
          },
          "gug": {
            "_reason": "macrolanguage",
            "_replacement": "gn"
          },
          "guj": {
            "_reason": "overlong",
            "_replacement": "gu"
          },
          "guv": {
            "_reason": "deprecated",
            "_replacement": "duz"
          },
          "gya": {
            "_reason": "macrolanguage",
            "_replacement": "gba"
          },
          "ha-Latn-GH": {
            "_reason": "legacy",
            "_replacement": "ha-GH"
          },
          "ha-Latn-NE": {
            "_reason": "legacy",
            "_replacement": "ha-NE"
          },
          "ha-Latn-NG": {
            "_reason": "legacy",
            "_replacement": "ha-NG"
          },
          "hat": {
            "_reason": "overlong",
            "_replacement": "ht"
          },
          "hau": {
            "_reason": "overlong",
            "_replacement": "ha"
          },
          "hbs": {
            "_reason": "overlong",
            "_replacement": "sr-Latn"
          },
          "hdn": {
            "_reason": "macrolanguage",
            "_replacement": "hai"
          },
          "hea": {
            "_reason": "macrolanguage",
            "_replacement": "hmn"
          },
          "heb": {
            "_reason": "overlong",
            "_replacement": "he"
          },
          "her": {
            "_reason": "overlong",
            "_replacement": "hz"
          },
          "him": {
            "_reason": "macrolanguage",
            "_replacement": "srx"
          },
          "hin": {
            "_reason": "overlong",
            "_replacement": "hi"
          },
          "hmo": {
            "_reason": "overlong",
            "_replacement": "ho"
          },
          "hrr": {
            "_reason": "deprecated",
            "_replacement": "jal"
          },
          "hrv": {
            "_reason": "overlong",
            "_replacement": "hr"
          },
          "hun": {
            "_reason": "overlong",
            "_replacement": "hu"
          },
          "hye": {
            "_reason": "overlong",
            "_replacement": "hy"
          },
          "i-ami": {
            "_reason": "deprecated",
            "_replacement": "ami"
          },
          "i-bnn": {
            "_reason": "deprecated",
            "_replacement": "bnn"
          },
          "i-hak": {
            "_reason": "deprecated",
            "_replacement": "hak"
          },
          "i-klingon": {
            "_reason": "deprecated",
            "_replacement": "tlh"
          },
          "i-lux": {
            "_reason": "deprecated",
            "_replacement": "lb"
          },
          "i-navajo": {
            "_reason": "deprecated",
            "_replacement": "nv"
          },
          "i-pwn": {
            "_reason": "deprecated",
            "_replacement": "pwn"
          },
          "i-tao": {
            "_reason": "deprecated",
            "_replacement": "tao"
          },
          "i-tay": {
            "_reason": "deprecated",
            "_replacement": "tay"
          },
          "i-tsu": {
            "_reason": "deprecated",
            "_replacement": "tsu"
          },
          "i-default": {
            "_reason": "legacy",
            "_replacement": "en-x-i-default"
          },
          "i-enochian": {
            "_reason": "legacy",
            "_replacement": "und-x-i-enochian"
          },
          "i-mingo": {
            "_reason": "legacy",
            "_replacement": "see-x-i-mingo"
          },
          "ibi": {
            "_reason": "deprecated",
            "_replacement": "opa"
          },
          "ibo": {
            "_reason": "overlong",
            "_replacement": "ig"
          },
          "ice": {
            "_reason": "bibliographic",
            "_replacement": "is"
          },
          "ido": {
            "_reason": "overlong",
            "_replacement": "io"
          },
          "iii": {
            "_reason": "overlong",
            "_replacement": "ii"
          },
          "ike": {
            "_reason": "macrolanguage",
            "_replacement": "iu"
          },
          "iku": {
            "_reason": "overlong",
            "_replacement": "iu"
          },
          "ile": {
            "_reason": "overlong",
            "_replacement": "ie"
          },
          "ilw": {
            "_reason": "deprecated",
            "_replacement": "gal"
          },
          "in": {
            "_reason": "deprecated",
            "_replacement": "id"
          },
          "ina": {
            "_reason": "overlong",
            "_replacement": "ia"
          },
          "ind": {
            "_reason": "overlong",
            "_replacement": "id"
          },
          "ipk": {
            "_reason": "overlong",
            "_replacement": "ik"
          },
          "isl": {
            "_reason": "overlong",
            "_replacement": "is"
          },
          "ita": {
            "_reason": "overlong",
            "_replacement": "it"
          },
          "iw": {
            "_reason": "deprecated",
            "_replacement": "he"
          },
          "jav": {
            "_reason": "overlong",
            "_replacement": "jv"
          },
          "jeg": {
            "_reason": "deprecated",
            "_replacement": "oyb"
          },
          "ji": {
            "_reason": "deprecated",
            "_replacement": "yi"
          },
          "jpn": {
            "_reason": "overlong",
            "_replacement": "ja"
          },
          "jw": {
            "_reason": "deprecated",
            "_replacement": "jv"
          },
          "kal": {
            "_reason": "overlong",
            "_replacement": "kl"
          },
          "kan": {
            "_reason": "overlong",
            "_replacement": "kn"
          },
          "kas": {
            "_reason": "overlong",
            "_replacement": "ks"
          },
          "kat": {
            "_reason": "overlong",
            "_replacement": "ka"
          },
          "kau": {
            "_reason": "overlong",
            "_replacement": "kr"
          },
          "kaz": {
            "_reason": "overlong",
            "_replacement": "kk"
          },
          "kgc": {
            "_reason": "deprecated",
            "_replacement": "tdf"
          },
          "kgh": {
            "_reason": "deprecated",
            "_replacement": "kml"
          },
          "khk": {
            "_reason": "macrolanguage",
            "_replacement": "mn"
          },
          "khm": {
            "_reason": "overlong",
            "_replacement": "km"
          },
          "kik": {
            "_reason": "overlong",
            "_replacement": "ki"
          },
          "kin": {
            "_reason": "overlong",
            "_replacement": "rw"
          },
          "kir": {
            "_reason": "overlong",
            "_replacement": "ky"
          },
          "kk-Cyrl-KZ": {
            "_reason": "legacy",
            "_replacement": "kk-KZ"
          },
          "kmr": {
            "_reason": "macrolanguage",
            "_replacement": "ku"
          },
          "knc": {
            "_reason": "macrolanguage",
            "_replacement": "kr"
          },
          "kng": {
            "_reason": "macrolanguage",
            "_replacement": "kg"
          },
          "knn": {
            "_reason": "macrolanguage",
            "_replacement": "kok"
          },
          "koj": {
            "_reason": "deprecated",
            "_replacement": "kwv"
          },
          "kom": {
            "_reason": "overlong",
            "_replacement": "kv"
          },
          "kon": {
            "_reason": "overlong",
            "_replacement": "kg"
          },
          "kor": {
            "_reason": "overlong",
            "_replacement": "ko"
          },
          "kpv": {
            "_reason": "macrolanguage",
            "_replacement": "kv"
          },
          "krm": {
            "_reason": "deprecated",
            "_replacement": "bmf"
          },
          "ks-Arab-IN": {
            "_reason": "legacy",
            "_replacement": "ks-IN"
          },
          "ktr": {
            "_reason": "deprecated",
            "_replacement": "dtp"
          },
          "kua": {
            "_reason": "overlong",
            "_replacement": "kj"
          },
          "kur": {
            "_reason": "overlong",
            "_replacement": "ku"
          },
          "kvs": {
            "_reason": "deprecated",
            "_replacement": "gdj"
          },
          "kwq": {
            "_reason": "deprecated",
            "_replacement": "yam"
          },
          "kxe": {
            "_reason": "deprecated",
            "_replacement": "tvd"
          },
          "ky-Cyrl-KG": {
            "_reason": "legacy",
            "_replacement": "ky-KG"
          },
          "kzj": {
            "_reason": "deprecated",
            "_replacement": "dtp"
          },
          "kzt": {
            "_reason": "deprecated",
            "_replacement": "dtp"
          },
          "lao": {
            "_reason": "overlong",
            "_replacement": "lo"
          },
          "lat": {
            "_reason": "overlong",
            "_replacement": "la"
          },
          "lav": {
            "_reason": "overlong",
            "_replacement": "lv"
          },
          "lbk": {
            "_reason": "macrolanguage",
            "_replacement": "bnc"
          },
          "lii": {
            "_reason": "deprecated",
            "_replacement": "raq"
          },
          "lim": {
            "_reason": "overlong",
            "_replacement": "li"
          },
          "lin": {
            "_reason": "overlong",
            "_replacement": "ln"
          },
          "lit": {
            "_reason": "overlong",
            "_replacement": "lt"
          },
          "lmm": {
            "_reason": "deprecated",
            "_replacement": "rmx"
          },
          "ltz": {
            "_reason": "overlong",
            "_replacement": "lb"
          },
          "lub": {
            "_reason": "overlong",
            "_replacement": "lu"
          },
          "lug": {
            "_reason": "overlong",
            "_replacement": "lg"
          },
          "lvs": {
            "_reason": "macrolanguage",
            "_replacement": "lv"
          },
          "mac": {
            "_reason": "bibliographic",
            "_replacement": "mk"
          },
          "mah": {
            "_reason": "overlong",
            "_replacement": "mh"
          },
          "mal": {
            "_reason": "overlong",
            "_replacement": "ml"
          },
          "mao": {
            "_reason": "bibliographic",
            "_replacement": "mi"
          },
          "mar": {
            "_reason": "overlong",
            "_replacement": "mr"
          },
          "may": {
            "_reason": "bibliographic",
            "_replacement": "ms"
          },
          "meg": {
            "_reason": "deprecated",
            "_replacement": "cir"
          },
          "mhr": {
            "_reason": "macrolanguage",
            "_replacement": "chm"
          },
          "mkd": {
            "_reason": "overlong",
            "_replacement": "mk"
          },
          "mlg": {
            "_reason": "overlong",
            "_replacement": "mg"
          },
          "mlt": {
            "_reason": "overlong",
            "_replacement": "mt"
          },
          "mn-Cyrl-MN": {
            "_reason": "legacy",
            "_replacement": "mn-MN"
          },
          "mnk": {
            "_reason": "macrolanguage",
            "_replacement": "man"
          },
          "mo": {
            "_reason": "deprecated",
            "_replacement": "ro"
          },
          "mol": {
            "_reason": "overlong",
            "_replacement": "ro"
          },
          "mon": {
            "_reason": "overlong",
            "_replacement": "mn"
          },
          "mri": {
            "_reason": "overlong",
            "_replacement": "mi"
          },
          "ms-Latn-BN": {
            "_reason": "legacy",
            "_replacement": "ms-BN"
          },
          "ms-Latn-MY": {
            "_reason": "legacy",
            "_replacement": "ms-MY"
          },
          "ms-Latn-SG": {
            "_reason": "legacy",
            "_replacement": "ms-SG"
          },
          "msa": {
            "_reason": "overlong",
            "_replacement": "ms"
          },
          "mst": {
            "_reason": "deprecated",
            "_replacement": "mry"
          },
          "mup": {
            "_reason": "macrolanguage",
            "_replacement": "raj"
          },
          "mwj": {
            "_reason": "deprecated",
            "_replacement": "vaj"
          },
          "mya": {
            "_reason": "overlong",
            "_replacement": "my"
          },
          "myt": {
            "_reason": "deprecated",
            "_replacement": "mry"
          },
          "nad": {
            "_reason": "deprecated",
            "_replacement": "xny"
          },
          "nau": {
            "_reason": "overlong",
            "_replacement": "na"
          },
          "nav": {
            "_reason": "overlong",
            "_replacement": "nv"
          },
          "nbl": {
            "_reason": "overlong",
            "_replacement": "nr"
          },
          "ncp": {
            "_reason": "deprecated",
            "_replacement": "kdz"
          },
          "nde": {
            "_reason": "overlong",
            "_replacement": "nd"
          },
          "ndo": {
            "_reason": "overlong",
            "_replacement": "ng"
          },
          "nep": {
            "_reason": "overlong",
            "_replacement": "ne"
          },
          "nld": {
            "_reason": "overlong",
            "_replacement": "nl"
          },
          "nno": {
            "_reason": "overlong",
            "_replacement": "nn"
          },
          "nnx": {
            "_reason": "deprecated",
            "_replacement": "ngv"
          },
          "no": {
            "_reason": "legacy",
            "_replacement": "nb"
          },
          "no-bok": {
            "_reason": "deprecated",
            "_replacement": "nb"
          },
          "no-BOKMAL": {
            "_reason": "deprecated",
            "_replacement": "nb"
          },
          "no-nyn": {
            "_reason": "deprecated",
            "_replacement": "nn"
          },
          "no-NYNORSK": {
            "_reason": "deprecated",
            "_replacement": "nn"
          },
          "nob": {
            "_reason": "overlong",
            "_replacement": "nb"
          },
          "nor": {
            "_reason": "overlong",
            "_replacement": "nb"
          },
          "npi": {
            "_reason": "macrolanguage",
            "_replacement": "ne"
          },
          "nts": {
            "_reason": "deprecated",
            "_replacement": "pij"
          },
          "nya": {
            "_reason": "overlong",
            "_replacement": "ny"
          },
          "oci": {
            "_reason": "overlong",
            "_replacement": "oc"
          },
          "ojg": {
            "_reason": "macrolanguage",
            "_replacement": "oj"
          },
          "oji": {
            "_reason": "overlong",
            "_replacement": "oj"
          },
          "ori": {
            "_reason": "overlong",
            "_replacement": "or"
          },
          "orm": {
            "_reason": "overlong",
            "_replacement": "om"
          },
          "ory": {
            "_reason": "macrolanguage",
            "_replacement": "or"
          },
          "oss": {
            "_reason": "overlong",
            "_replacement": "os"
          },
          "oun": {
            "_reason": "deprecated",
            "_replacement": "vaj"
          },
          "pa-IN": {
            "_reason": "legacy",
            "_replacement": "pa-Guru-IN"
          },
          "pa-PK": {
            "_reason": "legacy",
            "_replacement": "pa-Arab-PK"
          },
          "pan": {
            "_reason": "overlong",
            "_replacement": "pa"
          },
          "pbu": {
            "_reason": "macrolanguage",
            "_replacement": "ps"
          },
          "pcr": {
            "_reason": "deprecated",
            "_replacement": "adx"
          },
          "per": {
            "_reason": "bibliographic",
            "_replacement": "fa"
          },
          "pes": {
            "_reason": "macrolanguage",
            "_replacement": "fa"
          },
          "pli": {
            "_reason": "overlong",
            "_replacement": "pi"
          },
          "plt": {
            "_reason": "macrolanguage",
            "_replacement": "mg"
          },
          "pmc": {
            "_reason": "deprecated",
            "_replacement": "huw"
          },
          "pmu": {
            "_reason": "deprecated",
            "_replacement": "phr"
          },
          "pnb": {
            "_reason": "macrolanguage",
            "_replacement": "lah"
          },
          "pol": {
            "_reason": "overlong",
            "_replacement": "pl"
          },
          "por": {
            "_reason": "overlong",
            "_replacement": "pt"
          },
          "ppa": {
            "_reason": "deprecated",
            "_replacement": "bfy"
          },
          "ppr": {
            "_reason": "deprecated",
            "_replacement": "lcq"
          },
          "prs": {
            "_reason": "overlong",
            "_replacement": "fa-AF"
          },
          "pry": {
            "_reason": "deprecated",
            "_replacement": "prt"
          },
          "pus": {
            "_reason": "overlong",
            "_replacement": "ps"
          },
          "puz": {
            "_reason": "deprecated",
            "_replacement": "pub"
          },
          "que": {
            "_reason": "overlong",
            "_replacement": "qu"
          },
          "quz": {
            "_reason": "macrolanguage",
            "_replacement": "qu"
          },
          "rmy": {
            "_reason": "macrolanguage",
            "_replacement": "rom"
          },
          "roh": {
            "_reason": "overlong",
            "_replacement": "rm"
          },
          "ron": {
            "_reason": "overlong",
            "_replacement": "ro"
          },
          "rum": {
            "_reason": "bibliographic",
            "_replacement": "ro"
          },
          "run": {
            "_reason": "overlong",
            "_replacement": "rn"
          },
          "rus": {
            "_reason": "overlong",
            "_replacement": "ru"
          },
          "sag": {
            "_reason": "overlong",
            "_replacement": "sg"
          },
          "san": {
            "_reason": "overlong",
            "_replacement": "sa"
          },
          "sca": {
            "_reason": "deprecated",
            "_replacement": "hle"
          },
          "scc": {
            "_reason": "deprecated",
            "_replacement": "sr"
          },
          "scr": {
            "_reason": "deprecated",
            "_replacement": "hr"
          },
          "sgn-BE-FR": {
            "_reason": "deprecated",
            "_replacement": "sfb"
          },
          "sgn-BE-NL": {
            "_reason": "deprecated",
            "_replacement": "vgt"
          },
          "sgn-CH-DE": {
            "_reason": "deprecated",
            "_replacement": "sgg"
          },
          "sh": {
            "_reason": "legacy",
            "_replacement": "sr-Latn"
          },
          "shi-MA": {
            "_reason": "legacy",
            "_replacement": "shi-Tfng-MA"
          },
          "sin": {
            "_reason": "overlong",
            "_replacement": "si"
          },
          "skk": {
            "_reason": "deprecated",
            "_replacement": "oyb"
          },
          "slk": {
            "_reason": "overlong",
            "_replacement": "sk"
          },
          "slo": {
            "_reason": "bibliographic",
            "_replacement": "sk"
          },
          "slv": {
            "_reason": "overlong",
            "_replacement": "sl"
          },
          "sme": {
            "_reason": "overlong",
            "_replacement": "se"
          },
          "smo": {
            "_reason": "overlong",
            "_replacement": "sm"
          },
          "sna": {
            "_reason": "overlong",
            "_replacement": "sn"
          },
          "snd": {
            "_reason": "overlong",
            "_replacement": "sd"
          },
          "som": {
            "_reason": "overlong",
            "_replacement": "so"
          },
          "sot": {
            "_reason": "overlong",
            "_replacement": "st"
          },
          "spa": {
            "_reason": "overlong",
            "_replacement": "es"
          },
          "spy": {
            "_reason": "macrolanguage",
            "_replacement": "kln"
          },
          "sqi": {
            "_reason": "overlong",
            "_replacement": "sq"
          },
          "sr-BA": {
            "_reason": "legacy",
            "_replacement": "sr-Cyrl-BA"
          },
          "sr-ME": {
            "_reason": "legacy",
            "_replacement": "sr-Latn-ME"
          },
          "sr-RS": {
            "_reason": "legacy",
            "_replacement": "sr-Cyrl-RS"
          },
          "sr-XK": {
            "_reason": "legacy",
            "_replacement": "sr-Cyrl-XK"
          },
          "src": {
            "_reason": "macrolanguage",
            "_replacement": "sc"
          },
          "srd": {
            "_reason": "overlong",
            "_replacement": "sc"
          },
          "srp": {
            "_reason": "overlong",
            "_replacement": "sr"
          },
          "ssw": {
            "_reason": "overlong",
            "_replacement": "ss"
          },
          "sun": {
            "_reason": "overlong",
            "_replacement": "su"
          },
          "swa": {
            "_reason": "overlong",
            "_replacement": "sw"
          },
          "swc": {
            "_reason": "overlong",
            "_replacement": "sw-CD"
          },
          "swe": {
            "_reason": "overlong",
            "_replacement": "sv"
          },
          "swh": {
            "_reason": "macrolanguage",
            "_replacement": "sw"
          },
          "tah": {
            "_reason": "overlong",
            "_replacement": "ty"
          },
          "tam": {
            "_reason": "overlong",
            "_replacement": "ta"
          },
          "tat": {
            "_reason": "overlong",
            "_replacement": "tt"
          },
          "tdu": {
            "_reason": "deprecated",
            "_replacement": "dtp"
          },
          "tel": {
            "_reason": "overlong",
            "_replacement": "te"
          },
          "tgk": {
            "_reason": "overlong",
            "_replacement": "tg"
          },
          "tgl": {
            "_reason": "overlong",
            "_replacement": "fil"
          },
          "tha": {
            "_reason": "overlong",
            "_replacement": "th"
          },
          "thc": {
            "_reason": "deprecated",
            "_replacement": "tpo"
          },
          "thx": {
            "_reason": "deprecated",
            "_replacement": "oyb"
          },
          "tib": {
            "_reason": "bibliographic",
            "_replacement": "bo"
          },
          "tie": {
            "_reason": "deprecated",
            "_replacement": "ras"
          },
          "tir": {
            "_reason": "overlong",
            "_replacement": "ti"
          },
          "tkk": {
            "_reason": "deprecated",
            "_replacement": "twm"
          },
          "tl": {
            "_reason": "legacy",
            "_replacement": "fil"
          },
          "tlw": {
            "_reason": "deprecated",
            "_replacement": "weo"
          },
          "tmp": {
            "_reason": "deprecated",
            "_replacement": "tyj"
          },
          "tne": {
            "_reason": "deprecated",
            "_replacement": "kak"
          },
          "tnf": {
            "_reason": "deprecated",
            "_replacement": "fa-af"
          },
          "ton": {
            "_reason": "overlong",
            "_replacement": "to"
          },
          "tsf": {
            "_reason": "deprecated",
            "_replacement": "taj"
          },
          "tsn": {
            "_reason": "overlong",
            "_replacement": "tn"
          },
          "tso": {
            "_reason": "overlong",
            "_replacement": "ts"
          },
          "ttq": {
            "_reason": "macrolanguage",
            "_replacement": "tmh"
          },
          "tuk": {
            "_reason": "overlong",
            "_replacement": "tk"
          },
          "tur": {
            "_reason": "overlong",
            "_replacement": "tr"
          },
          "tw": {
            "_reason": "macrolanguage",
            "_replacement": "ak"
          },
          "twi": {
            "_reason": "overlong",
            "_replacement": "ak"
          },
          "tzm-Latn-MA": {
            "_reason": "legacy",
            "_replacement": "tzm-MA"
          },
          "ug-Arab-CN": {
            "_reason": "legacy",
            "_replacement": "ug-CN"
          },
          "uig": {
            "_reason": "overlong",
            "_replacement": "ug"
          },
          "ukr": {
            "_reason": "overlong",
            "_replacement": "uk"
          },
          "umu": {
            "_reason": "macrolanguage",
            "_replacement": "del"
          },
          "uok": {
            "_reason": "deprecated",
            "_replacement": "ema"
          },
          "urd": {
            "_reason": "overlong",
            "_replacement": "ur"
          },
          "uz-AF": {
            "_reason": "legacy",
            "_replacement": "uz-Arab-AF"
          },
          "uz-UZ": {
            "_reason": "legacy",
            "_replacement": "uz-Latn-UZ"
          },
          "uzb": {
            "_reason": "overlong",
            "_replacement": "uz"
          },
          "uzn": {
            "_reason": "macrolanguage",
            "_replacement": "uz"
          },
          "vai-LR": {
            "_reason": "legacy",
            "_replacement": "vai-Vaii-LR"
          },
          "ven": {
            "_reason": "overlong",
            "_replacement": "ve"
          },
          "vie": {
            "_reason": "overlong",
            "_replacement": "vi"
          },
          "vol": {
            "_reason": "overlong",
            "_replacement": "vo"
          },
          "wel": {
            "_reason": "bibliographic",
            "_replacement": "cy"
          },
          "wln": {
            "_reason": "overlong",
            "_replacement": "wa"
          },
          "wol": {
            "_reason": "overlong",
            "_replacement": "wo"
          },
          "xba": {
            "_reason": "deprecated",
            "_replacement": "cax"
          },
          "xho": {
            "_reason": "overlong",
            "_replacement": "xh"
          },
          "xia": {
            "_reason": "deprecated",
            "_replacement": "acn"
          },
          "xkh": {
            "_reason": "deprecated",
            "_replacement": "waw"
          },
          "xpe": {
            "_reason": "macrolanguage",
            "_replacement": "kpe"
          },
          "xsj": {
            "_reason": "deprecated",
            "_replacement": "suj"
          },
          "xsl": {
            "_reason": "macrolanguage",
            "_replacement": "den"
          },
          "ybd": {
            "_reason": "deprecated",
            "_replacement": "rki"
          },
          "ydd": {
            "_reason": "macrolanguage",
            "_replacement": "yi"
          },
          "yid": {
            "_reason": "overlong",
            "_replacement": "yi"
          },
          "yma": {
            "_reason": "deprecated",
            "_replacement": "lrr"
          },
          "ymt": {
            "_reason": "deprecated",
            "_replacement": "mtm"
          },
          "yor": {
            "_reason": "overlong",
            "_replacement": "yo"
          },
          "yos": {
            "_reason": "deprecated",
            "_replacement": "zom"
          },
          "yue-CN": {
            "_reason": "legacy",
            "_replacement": "yue-Hans-CN"
          },
          "yue-HK": {
            "_reason": "legacy",
            "_replacement": "yue-Hant-HK"
          },
          "yuu": {
            "_reason": "deprecated",
            "_replacement": "yug"
          },
          "zai": {
            "_reason": "macrolanguage",
            "_replacement": "zap"
          },
          "zh-CN": {
            "_reason": "legacy",
            "_replacement": "zh-Hans-CN"
          },
          "zh-guoyu": {
            "_reason": "deprecated",
            "_replacement": "zh"
          },
          "zh-hakka": {
            "_reason": "deprecated",
            "_replacement": "hak"
          },
          "zh-HK": {
            "_reason": "legacy",
            "_replacement": "zh-Hant-HK"
          },
          "zh-min-nan": {
            "_reason": "deprecated",
            "_replacement": "nan"
          },
          "zh-MO": {
            "_reason": "legacy",
            "_replacement": "zh-Hant-MO"
          },
          "zh-SG": {
            "_reason": "legacy",
            "_replacement": "zh-Hans-SG"
          },
          "zh-TW": {
            "_reason": "legacy",
            "_replacement": "zh-Hant-TW"
          },
          "zh-xiang": {
            "_reason": "deprecated",
            "_replacement": "hsn"
          },
          "zh-min": {
            "_reason": "legacy",
            "_replacement": "nan-x-zh-min"
          },
          "zha": {
            "_reason": "overlong",
            "_replacement": "za"
          },
          "zho": {
            "_reason": "overlong",
            "_replacement": "zh"
          },
          "zsm": {
            "_reason": "macrolanguage",
            "_replacement": "ms"
          },
          "zul": {
            "_reason": "overlong",
            "_replacement": "zu"
          },
          "zyb": {
            "_reason": "macrolanguage",
            "_replacement": "za"
          }
        },
        "scriptAlias": {
          "Qaai": {
            "_reason": "deprecated",
            "_replacement": "Zinh"
          }
        },
        "territoryAlias": {
          "100": {
            "_reason": "overlong",
            "_replacement": "BG"
          },
          "104": {
            "_reason": "overlong",
            "_replacement": "MM"
          },
          "108": {
            "_reason": "overlong",
            "_replacement": "BI"
          },
          "112": {
            "_reason": "overlong",
            "_replacement": "BY"
          },
          "116": {
            "_reason": "overlong",
            "_replacement": "KH"
          },
          "120": {
            "_reason": "overlong",
            "_replacement": "CM"
          },
          "124": {
            "_reason": "overlong",
            "_replacement": "CA"
          },
          "132": {
            "_reason": "overlong",
            "_replacement": "CV"
          },
          "136": {
            "_reason": "overlong",
            "_replacement": "KY"
          },
          "140": {
            "_reason": "overlong",
            "_replacement": "CF"
          },
          "144": {
            "_reason": "overlong",
            "_replacement": "LK"
          },
          "148": {
            "_reason": "overlong",
            "_replacement": "TD"
          },
          "152": {
            "_reason": "overlong",
            "_replacement": "CL"
          },
          "156": {
            "_reason": "overlong",
            "_replacement": "CN"
          },
          "158": {
            "_reason": "overlong",
            "_replacement": "TW"
          },
          "162": {
            "_reason": "overlong",
            "_replacement": "CX"
          },
          "166": {
            "_reason": "overlong",
            "_replacement": "CC"
          },
          "170": {
            "_reason": "overlong",
            "_replacement": "CO"
          },
          "172": {
            "_reason": "deprecated",
            "_replacement": "RU AM AZ BY GE KG KZ MD TJ TM UA UZ"
          },
          "174": {
            "_reason": "overlong",
            "_replacement": "KM"
          },
          "175": {
            "_reason": "overlong",
            "_replacement": "YT"
          },
          "178": {
            "_reason": "overlong",
            "_replacement": "CG"
          },
          "180": {
            "_reason": "overlong",
            "_replacement": "CD"
          },
          "184": {
            "_reason": "overlong",
            "_replacement": "CK"
          },
          "188": {
            "_reason": "overlong",
            "_replacement": "CR"
          },
          "191": {
            "_reason": "overlong",
            "_replacement": "HR"
          },
          "192": {
            "_reason": "overlong",
            "_replacement": "CU"
          },
          "196": {
            "_reason": "overlong",
            "_replacement": "CY"
          },
          "200": {
            "_reason": "deprecated",
            "_replacement": "CZ SK"
          },
          "203": {
            "_reason": "overlong",
            "_replacement": "CZ"
          },
          "204": {
            "_reason": "overlong",
            "_replacement": "BJ"
          },
          "208": {
            "_reason": "overlong",
            "_replacement": "DK"
          },
          "212": {
            "_reason": "overlong",
            "_replacement": "DM"
          },
          "214": {
            "_reason": "overlong",
            "_replacement": "DO"
          },
          "218": {
            "_reason": "overlong",
            "_replacement": "EC"
          },
          "222": {
            "_reason": "overlong",
            "_replacement": "SV"
          },
          "226": {
            "_reason": "overlong",
            "_replacement": "GQ"
          },
          "230": {
            "_reason": "deprecated",
            "_replacement": "ET"
          },
          "231": {
            "_reason": "overlong",
            "_replacement": "ET"
          },
          "232": {
            "_reason": "overlong",
            "_replacement": "ER"
          },
          "233": {
            "_reason": "overlong",
            "_replacement": "EE"
          },
          "234": {
            "_reason": "overlong",
            "_replacement": "FO"
          },
          "238": {
            "_reason": "overlong",
            "_replacement": "FK"
          },
          "239": {
            "_reason": "overlong",
            "_replacement": "GS"
          },
          "242": {
            "_reason": "overlong",
            "_replacement": "FJ"
          },
          "246": {
            "_reason": "overlong",
            "_replacement": "FI"
          },
          "248": {
            "_reason": "overlong",
            "_replacement": "AX"
          },
          "249": {
            "_reason": "overlong",
            "_replacement": "FR"
          },
          "250": {
            "_reason": "overlong",
            "_replacement": "FR"
          },
          "254": {
            "_reason": "overlong",
            "_replacement": "GF"
          },
          "258": {
            "_reason": "overlong",
            "_replacement": "PF"
          },
          "260": {
            "_reason": "overlong",
            "_replacement": "TF"
          },
          "262": {
            "_reason": "overlong",
            "_replacement": "DJ"
          },
          "266": {
            "_reason": "overlong",
            "_replacement": "GA"
          },
          "268": {
            "_reason": "overlong",
            "_replacement": "GE"
          },
          "270": {
            "_reason": "overlong",
            "_replacement": "GM"
          },
          "275": {
            "_reason": "overlong",
            "_replacement": "PS"
          },
          "276": {
            "_reason": "overlong",
            "_replacement": "DE"
          },
          "278": {
            "_reason": "overlong",
            "_replacement": "DE"
          },
          "280": {
            "_reason": "deprecated",
            "_replacement": "DE"
          },
          "288": {
            "_reason": "overlong",
            "_replacement": "GH"
          },
          "292": {
            "_reason": "overlong",
            "_replacement": "GI"
          },
          "296": {
            "_reason": "overlong",
            "_replacement": "KI"
          },
          "300": {
            "_reason": "overlong",
            "_replacement": "GR"
          },
          "304": {
            "_reason": "overlong",
            "_replacement": "GL"
          },
          "308": {
            "_reason": "overlong",
            "_replacement": "GD"
          },
          "312": {
            "_reason": "overlong",
            "_replacement": "GP"
          },
          "316": {
            "_reason": "overlong",
            "_replacement": "GU"
          },
          "320": {
            "_reason": "overlong",
            "_replacement": "GT"
          },
          "324": {
            "_reason": "overlong",
            "_replacement": "GN"
          },
          "328": {
            "_reason": "overlong",
            "_replacement": "GY"
          },
          "332": {
            "_reason": "overlong",
            "_replacement": "HT"
          },
          "334": {
            "_reason": "overlong",
            "_replacement": "HM"
          },
          "336": {
            "_reason": "overlong",
            "_replacement": "VA"
          },
          "340": {
            "_reason": "overlong",
            "_replacement": "HN"
          },
          "344": {
            "_reason": "overlong",
            "_replacement": "HK"
          },
          "348": {
            "_reason": "overlong",
            "_replacement": "HU"
          },
          "352": {
            "_reason": "overlong",
            "_replacement": "IS"
          },
          "356": {
            "_reason": "overlong",
            "_replacement": "IN"
          },
          "360": {
            "_reason": "overlong",
            "_replacement": "ID"
          },
          "364": {
            "_reason": "overlong",
            "_replacement": "IR"
          },
          "368": {
            "_reason": "overlong",
            "_replacement": "IQ"
          },
          "372": {
            "_reason": "overlong",
            "_replacement": "IE"
          },
          "376": {
            "_reason": "overlong",
            "_replacement": "IL"
          },
          "380": {
            "_reason": "overlong",
            "_replacement": "IT"
          },
          "384": {
            "_reason": "overlong",
            "_replacement": "CI"
          },
          "388": {
            "_reason": "overlong",
            "_replacement": "JM"
          },
          "392": {
            "_reason": "overlong",
            "_replacement": "JP"
          },
          "398": {
            "_reason": "overlong",
            "_replacement": "KZ"
          },
          "400": {
            "_reason": "overlong",
            "_replacement": "JO"
          },
          "404": {
            "_reason": "overlong",
            "_replacement": "KE"
          },
          "408": {
            "_reason": "overlong",
            "_replacement": "KP"
          },
          "410": {
            "_reason": "overlong",
            "_replacement": "KR"
          },
          "414": {
            "_reason": "overlong",
            "_replacement": "KW"
          },
          "417": {
            "_reason": "overlong",
            "_replacement": "KG"
          },
          "418": {
            "_reason": "overlong",
            "_replacement": "LA"
          },
          "422": {
            "_reason": "overlong",
            "_replacement": "LB"
          },
          "426": {
            "_reason": "overlong",
            "_replacement": "LS"
          },
          "428": {
            "_reason": "overlong",
            "_replacement": "LV"
          },
          "430": {
            "_reason": "overlong",
            "_replacement": "LR"
          },
          "434": {
            "_reason": "overlong",
            "_replacement": "LY"
          },
          "438": {
            "_reason": "overlong",
            "_replacement": "LI"
          },
          "440": {
            "_reason": "overlong",
            "_replacement": "LT"
          },
          "442": {
            "_reason": "overlong",
            "_replacement": "LU"
          },
          "446": {
            "_reason": "overlong",
            "_replacement": "MO"
          },
          "450": {
            "_reason": "overlong",
            "_replacement": "MG"
          },
          "454": {
            "_reason": "overlong",
            "_replacement": "MW"
          },
          "458": {
            "_reason": "overlong",
            "_replacement": "MY"
          },
          "462": {
            "_reason": "overlong",
            "_replacement": "MV"
          },
          "466": {
            "_reason": "overlong",
            "_replacement": "ML"
          },
          "470": {
            "_reason": "overlong",
            "_replacement": "MT"
          },
          "474": {
            "_reason": "overlong",
            "_replacement": "MQ"
          },
          "478": {
            "_reason": "overlong",
            "_replacement": "MR"
          },
          "480": {
            "_reason": "overlong",
            "_replacement": "MU"
          },
          "484": {
            "_reason": "overlong",
            "_replacement": "MX"
          },
          "492": {
            "_reason": "overlong",
            "_replacement": "MC"
          },
          "496": {
            "_reason": "overlong",
            "_replacement": "MN"
          },
          "498": {
            "_reason": "overlong",
            "_replacement": "MD"
          },
          "499": {
            "_reason": "overlong",
            "_replacement": "ME"
          },
          "500": {
            "_reason": "overlong",
            "_replacement": "MS"
          },
          "504": {
            "_reason": "overlong",
            "_replacement": "MA"
          },
          "508": {
            "_reason": "overlong",
            "_replacement": "MZ"
          },
          "512": {
            "_reason": "overlong",
            "_replacement": "OM"
          },
          "516": {
            "_reason": "overlong",
            "_replacement": "NA"
          },
          "520": {
            "_reason": "overlong",
            "_replacement": "NR"
          },
          "524": {
            "_reason": "overlong",
            "_replacement": "NP"
          },
          "528": {
            "_reason": "overlong",
            "_replacement": "NL"
          },
          "530": {
            "_reason": "overlong",
            "_replacement": "CW SX BQ"
          },
          "531": {
            "_reason": "overlong",
            "_replacement": "CW"
          },
          "532": {
            "_reason": "deprecated",
            "_replacement": "CW SX BQ"
          },
          "533": {
            "_reason": "overlong",
            "_replacement": "AW"
          },
          "534": {
            "_reason": "overlong",
            "_replacement": "SX"
          },
          "535": {
            "_reason": "overlong",
            "_replacement": "BQ"
          },
          "536": {
            "_reason": "overlong",
            "_replacement": "SA IQ"
          },
          "540": {
            "_reason": "overlong",
            "_replacement": "NC"
          },
          "548": {
            "_reason": "overlong",
            "_replacement": "VU"
          },
          "554": {
            "_reason": "overlong",
            "_replacement": "NZ"
          },
          "558": {
            "_reason": "overlong",
            "_replacement": "NI"
          },
          "562": {
            "_reason": "overlong",
            "_replacement": "NE"
          },
          "566": {
            "_reason": "overlong",
            "_replacement": "NG"
          },
          "570": {
            "_reason": "overlong",
            "_replacement": "NU"
          },
          "574": {
            "_reason": "overlong",
            "_replacement": "NF"
          },
          "578": {
            "_reason": "overlong",
            "_replacement": "NO"
          },
          "580": {
            "_reason": "overlong",
            "_replacement": "MP"
          },
          "581": {
            "_reason": "overlong",
            "_replacement": "UM"
          },
          "582": {
            "_reason": "deprecated",
            "_replacement": "FM MH MP PW"
          },
          "583": {
            "_reason": "overlong",
            "_replacement": "FM"
          },
          "584": {
            "_reason": "overlong",
            "_replacement": "MH"
          },
          "585": {
            "_reason": "overlong",
            "_replacement": "PW"
          },
          "586": {
            "_reason": "overlong",
            "_replacement": "PK"
          },
          "591": {
            "_reason": "overlong",
            "_replacement": "PA"
          },
          "598": {
            "_reason": "overlong",
            "_replacement": "PG"
          },
          "600": {
            "_reason": "overlong",
            "_replacement": "PY"
          },
          "604": {
            "_reason": "overlong",
            "_replacement": "PE"
          },
          "608": {
            "_reason": "overlong",
            "_replacement": "PH"
          },
          "612": {
            "_reason": "overlong",
            "_replacement": "PN"
          },
          "616": {
            "_reason": "overlong",
            "_replacement": "PL"
          },
          "620": {
            "_reason": "overlong",
            "_replacement": "PT"
          },
          "624": {
            "_reason": "overlong",
            "_replacement": "GW"
          },
          "626": {
            "_reason": "overlong",
            "_replacement": "TL"
          },
          "630": {
            "_reason": "overlong",
            "_replacement": "PR"
          },
          "634": {
            "_reason": "overlong",
            "_replacement": "QA"
          },
          "638": {
            "_reason": "overlong",
            "_replacement": "RE"
          },
          "642": {
            "_reason": "overlong",
            "_replacement": "RO"
          },
          "643": {
            "_reason": "overlong",
            "_replacement": "RU"
          },
          "646": {
            "_reason": "overlong",
            "_replacement": "RW"
          },
          "652": {
            "_reason": "overlong",
            "_replacement": "BL"
          },
          "654": {
            "_reason": "overlong",
            "_replacement": "SH"
          },
          "659": {
            "_reason": "overlong",
            "_replacement": "KN"
          },
          "660": {
            "_reason": "overlong",
            "_replacement": "AI"
          },
          "662": {
            "_reason": "overlong",
            "_replacement": "LC"
          },
          "663": {
            "_reason": "overlong",
            "_replacement": "MF"
          },
          "666": {
            "_reason": "overlong",
            "_replacement": "PM"
          },
          "670": {
            "_reason": "overlong",
            "_replacement": "VC"
          },
          "674": {
            "_reason": "overlong",
            "_replacement": "SM"
          },
          "678": {
            "_reason": "overlong",
            "_replacement": "ST"
          },
          "682": {
            "_reason": "overlong",
            "_replacement": "SA"
          },
          "686": {
            "_reason": "overlong",
            "_replacement": "SN"
          },
          "688": {
            "_reason": "overlong",
            "_replacement": "RS"
          },
          "690": {
            "_reason": "overlong",
            "_replacement": "SC"
          },
          "694": {
            "_reason": "overlong",
            "_replacement": "SL"
          },
          "702": {
            "_reason": "overlong",
            "_replacement": "SG"
          },
          "703": {
            "_reason": "overlong",
            "_replacement": "SK"
          },
          "704": {
            "_reason": "overlong",
            "_replacement": "VN"
          },
          "705": {
            "_reason": "overlong",
            "_replacement": "SI"
          },
          "706": {
            "_reason": "overlong",
            "_replacement": "SO"
          },
          "710": {
            "_reason": "overlong",
            "_replacement": "ZA"
          },
          "716": {
            "_reason": "overlong",
            "_replacement": "ZW"
          },
          "720": {
            "_reason": "overlong",
            "_replacement": "YE"
          },
          "724": {
            "_reason": "overlong",
            "_replacement": "ES"
          },
          "728": {
            "_reason": "overlong",
            "_replacement": "SS"
          },
          "729": {
            "_reason": "overlong",
            "_replacement": "SD"
          },
          "732": {
            "_reason": "overlong",
            "_replacement": "EH"
          },
          "736": {
            "_reason": "deprecated",
            "_replacement": "SD"
          },
          "740": {
            "_reason": "overlong",
            "_replacement": "SR"
          },
          "744": {
            "_reason": "overlong",
            "_replacement": "SJ"
          },
          "748": {
            "_reason": "overlong",
            "_replacement": "SZ"
          },
          "752": {
            "_reason": "overlong",
            "_replacement": "SE"
          },
          "756": {
            "_reason": "overlong",
            "_replacement": "CH"
          },
          "760": {
            "_reason": "overlong",
            "_replacement": "SY"
          },
          "762": {
            "_reason": "overlong",
            "_replacement": "TJ"
          },
          "764": {
            "_reason": "overlong",
            "_replacement": "TH"
          },
          "768": {
            "_reason": "overlong",
            "_replacement": "TG"
          },
          "772": {
            "_reason": "overlong",
            "_replacement": "TK"
          },
          "776": {
            "_reason": "overlong",
            "_replacement": "TO"
          },
          "780": {
            "_reason": "overlong",
            "_replacement": "TT"
          },
          "784": {
            "_reason": "overlong",
            "_replacement": "AE"
          },
          "788": {
            "_reason": "overlong",
            "_replacement": "TN"
          },
          "792": {
            "_reason": "overlong",
            "_replacement": "TR"
          },
          "795": {
            "_reason": "overlong",
            "_replacement": "TM"
          },
          "796": {
            "_reason": "overlong",
            "_replacement": "TC"
          },
          "798": {
            "_reason": "overlong",
            "_replacement": "TV"
          },
          "800": {
            "_reason": "overlong",
            "_replacement": "UG"
          },
          "804": {
            "_reason": "overlong",
            "_replacement": "UA"
          },
          "807": {
            "_reason": "overlong",
            "_replacement": "MK"
          },
          "810": {
            "_reason": "overlong",
            "_replacement": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ"
          },
          "818": {
            "_reason": "overlong",
            "_replacement": "EG"
          },
          "826": {
            "_reason": "overlong",
            "_replacement": "GB"
          },
          "830": {
            "_reason": "deprecated",
            "_replacement": "JE GG"
          },
          "831": {
            "_reason": "overlong",
            "_replacement": "GG"
          },
          "832": {
            "_reason": "overlong",
            "_replacement": "JE"
          },
          "833": {
            "_reason": "overlong",
            "_replacement": "IM"
          },
          "834": {
            "_reason": "overlong",
            "_replacement": "TZ"
          },
          "840": {
            "_reason": "overlong",
            "_replacement": "US"
          },
          "850": {
            "_reason": "overlong",
            "_replacement": "VI"
          },
          "854": {
            "_reason": "overlong",
            "_replacement": "BF"
          },
          "858": {
            "_reason": "overlong",
            "_replacement": "UY"
          },
          "860": {
            "_reason": "overlong",
            "_replacement": "UZ"
          },
          "862": {
            "_reason": "overlong",
            "_replacement": "VE"
          },
          "876": {
            "_reason": "overlong",
            "_replacement": "WF"
          },
          "882": {
            "_reason": "overlong",
            "_replacement": "WS"
          },
          "886": {
            "_reason": "deprecated",
            "_replacement": "YE"
          },
          "887": {
            "_reason": "overlong",
            "_replacement": "YE"
          },
          "890": {
            "_reason": "deprecated",
            "_replacement": "RS ME SI HR MK BA"
          },
          "891": {
            "_reason": "overlong",
            "_replacement": "RS ME"
          },
          "894": {
            "_reason": "overlong",
            "_replacement": "ZM"
          },
          "958": {
            "_reason": "overlong",
            "_replacement": "AA"
          },
          "959": {
            "_reason": "overlong",
            "_replacement": "QM"
          },
          "960": {
            "_reason": "overlong",
            "_replacement": "QN"
          },
          "962": {
            "_reason": "overlong",
            "_replacement": "QP"
          },
          "963": {
            "_reason": "overlong",
            "_replacement": "QQ"
          },
          "964": {
            "_reason": "overlong",
            "_replacement": "QR"
          },
          "965": {
            "_reason": "overlong",
            "_replacement": "QS"
          },
          "966": {
            "_reason": "overlong",
            "_replacement": "QT"
          },
          "967": {
            "_reason": "overlong",
            "_replacement": "EU"
          },
          "968": {
            "_reason": "overlong",
            "_replacement": "QV"
          },
          "969": {
            "_reason": "overlong",
            "_replacement": "QW"
          },
          "970": {
            "_reason": "overlong",
            "_replacement": "QX"
          },
          "971": {
            "_reason": "overlong",
            "_replacement": "QY"
          },
          "972": {
            "_reason": "overlong",
            "_replacement": "QZ"
          },
          "973": {
            "_reason": "overlong",
            "_replacement": "XA"
          },
          "974": {
            "_reason": "overlong",
            "_replacement": "XB"
          },
          "975": {
            "_reason": "overlong",
            "_replacement": "XC"
          },
          "976": {
            "_reason": "overlong",
            "_replacement": "XD"
          },
          "977": {
            "_reason": "overlong",
            "_replacement": "XE"
          },
          "978": {
            "_reason": "overlong",
            "_replacement": "XF"
          },
          "979": {
            "_reason": "overlong",
            "_replacement": "XG"
          },
          "980": {
            "_reason": "overlong",
            "_replacement": "XH"
          },
          "981": {
            "_reason": "overlong",
            "_replacement": "XI"
          },
          "982": {
            "_reason": "overlong",
            "_replacement": "XJ"
          },
          "983": {
            "_reason": "overlong",
            "_replacement": "XK"
          },
          "984": {
            "_reason": "overlong",
            "_replacement": "XL"
          },
          "985": {
            "_reason": "overlong",
            "_replacement": "XM"
          },
          "986": {
            "_reason": "overlong",
            "_replacement": "XN"
          },
          "987": {
            "_reason": "overlong",
            "_replacement": "XO"
          },
          "988": {
            "_reason": "overlong",
            "_replacement": "XP"
          },
          "989": {
            "_reason": "overlong",
            "_replacement": "XQ"
          },
          "990": {
            "_reason": "overlong",
            "_replacement": "XR"
          },
          "991": {
            "_reason": "overlong",
            "_replacement": "XS"
          },
          "992": {
            "_reason": "overlong",
            "_replacement": "XT"
          },
          "993": {
            "_reason": "overlong",
            "_replacement": "XU"
          },
          "994": {
            "_reason": "overlong",
            "_replacement": "XV"
          },
          "995": {
            "_reason": "overlong",
            "_replacement": "XW"
          },
          "996": {
            "_reason": "overlong",
            "_replacement": "XX"
          },
          "997": {
            "_reason": "overlong",
            "_replacement": "XY"
          },
          "998": {
            "_reason": "overlong",
            "_replacement": "XZ"
          },
          "999": {
            "_reason": "overlong",
            "_replacement": "ZZ"
          },
          "004": {
            "_reason": "overlong",
            "_replacement": "AF"
          },
          "008": {
            "_reason": "overlong",
            "_replacement": "AL"
          },
          "010": {
            "_reason": "overlong",
            "_replacement": "AQ"
          },
          "012": {
            "_reason": "overlong",
            "_replacement": "DZ"
          },
          "016": {
            "_reason": "overlong",
            "_replacement": "AS"
          },
          "020": {
            "_reason": "overlong",
            "_replacement": "AD"
          },
          "024": {
            "_reason": "overlong",
            "_replacement": "AO"
          },
          "028": {
            "_reason": "overlong",
            "_replacement": "AG"
          },
          "031": {
            "_reason": "overlong",
            "_replacement": "AZ"
          },
          "032": {
            "_reason": "overlong",
            "_replacement": "AR"
          },
          "036": {
            "_reason": "overlong",
            "_replacement": "AU"
          },
          "040": {
            "_reason": "overlong",
            "_replacement": "AT"
          },
          "044": {
            "_reason": "overlong",
            "_replacement": "BS"
          },
          "048": {
            "_reason": "overlong",
            "_replacement": "BH"
          },
          "050": {
            "_reason": "overlong",
            "_replacement": "BD"
          },
          "051": {
            "_reason": "overlong",
            "_replacement": "AM"
          },
          "052": {
            "_reason": "overlong",
            "_replacement": "BB"
          },
          "056": {
            "_reason": "overlong",
            "_replacement": "BE"
          },
          "060": {
            "_reason": "overlong",
            "_replacement": "BM"
          },
          "062": {
            "_reason": "deprecated",
            "_replacement": "034 143"
          },
          "064": {
            "_reason": "overlong",
            "_replacement": "BT"
          },
          "068": {
            "_reason": "overlong",
            "_replacement": "BO"
          },
          "070": {
            "_reason": "overlong",
            "_replacement": "BA"
          },
          "072": {
            "_reason": "overlong",
            "_replacement": "BW"
          },
          "074": {
            "_reason": "overlong",
            "_replacement": "BV"
          },
          "076": {
            "_reason": "overlong",
            "_replacement": "BR"
          },
          "084": {
            "_reason": "overlong",
            "_replacement": "BZ"
          },
          "086": {
            "_reason": "overlong",
            "_replacement": "IO"
          },
          "090": {
            "_reason": "overlong",
            "_replacement": "SB"
          },
          "092": {
            "_reason": "overlong",
            "_replacement": "VG"
          },
          "096": {
            "_reason": "overlong",
            "_replacement": "BN"
          },
          "AAA": {
            "_reason": "overlong",
            "_replacement": "AA"
          },
          "ABW": {
            "_reason": "overlong",
            "_replacement": "AW"
          },
          "AFG": {
            "_reason": "overlong",
            "_replacement": "AF"
          },
          "AGO": {
            "_reason": "overlong",
            "_replacement": "AO"
          },
          "AIA": {
            "_reason": "overlong",
            "_replacement": "AI"
          },
          "ALA": {
            "_reason": "overlong",
            "_replacement": "AX"
          },
          "ALB": {
            "_reason": "overlong",
            "_replacement": "AL"
          },
          "AN": {
            "_reason": "deprecated",
            "_replacement": "CW SX BQ"
          },
          "AND": {
            "_reason": "overlong",
            "_replacement": "AD"
          },
          "ANT": {
            "_reason": "overlong",
            "_replacement": "CW SX BQ"
          },
          "ARE": {
            "_reason": "overlong",
            "_replacement": "AE"
          },
          "ARG": {
            "_reason": "overlong",
            "_replacement": "AR"
          },
          "ARM": {
            "_reason": "overlong",
            "_replacement": "AM"
          },
          "ASC": {
            "_reason": "overlong",
            "_replacement": "AC"
          },
          "ASM": {
            "_reason": "overlong",
            "_replacement": "AS"
          },
          "ATA": {
            "_reason": "overlong",
            "_replacement": "AQ"
          },
          "ATF": {
            "_reason": "overlong",
            "_replacement": "TF"
          },
          "ATG": {
            "_reason": "overlong",
            "_replacement": "AG"
          },
          "AUS": {
            "_reason": "overlong",
            "_replacement": "AU"
          },
          "AUT": {
            "_reason": "overlong",
            "_replacement": "AT"
          },
          "AZE": {
            "_reason": "overlong",
            "_replacement": "AZ"
          },
          "BDI": {
            "_reason": "overlong",
            "_replacement": "BI"
          },
          "BEL": {
            "_reason": "overlong",
            "_replacement": "BE"
          },
          "BEN": {
            "_reason": "overlong",
            "_replacement": "BJ"
          },
          "BES": {
            "_reason": "overlong",
            "_replacement": "BQ"
          },
          "BFA": {
            "_reason": "overlong",
            "_replacement": "BF"
          },
          "BGD": {
            "_reason": "overlong",
            "_replacement": "BD"
          },
          "BGR": {
            "_reason": "overlong",
            "_replacement": "BG"
          },
          "BHR": {
            "_reason": "overlong",
            "_replacement": "BH"
          },
          "BHS": {
            "_reason": "overlong",
            "_replacement": "BS"
          },
          "BIH": {
            "_reason": "overlong",
            "_replacement": "BA"
          },
          "BLM": {
            "_reason": "overlong",
            "_replacement": "BL"
          },
          "BLR": {
            "_reason": "overlong",
            "_replacement": "BY"
          },
          "BLZ": {
            "_reason": "overlong",
            "_replacement": "BZ"
          },
          "BMU": {
            "_reason": "overlong",
            "_replacement": "BM"
          },
          "BOL": {
            "_reason": "overlong",
            "_replacement": "BO"
          },
          "BRA": {
            "_reason": "overlong",
            "_replacement": "BR"
          },
          "BRB": {
            "_reason": "overlong",
            "_replacement": "BB"
          },
          "BRN": {
            "_reason": "overlong",
            "_replacement": "BN"
          },
          "BTN": {
            "_reason": "overlong",
            "_replacement": "BT"
          },
          "BU": {
            "_reason": "deprecated",
            "_replacement": "MM"
          },
          "BUR": {
            "_reason": "overlong",
            "_replacement": "MM"
          },
          "BVT": {
            "_reason": "overlong",
            "_replacement": "BV"
          },
          "BWA": {
            "_reason": "overlong",
            "_replacement": "BW"
          },
          "CAF": {
            "_reason": "overlong",
            "_replacement": "CF"
          },
          "CAN": {
            "_reason": "overlong",
            "_replacement": "CA"
          },
          "CCK": {
            "_reason": "overlong",
            "_replacement": "CC"
          },
          "CHE": {
            "_reason": "overlong",
            "_replacement": "CH"
          },
          "CHL": {
            "_reason": "overlong",
            "_replacement": "CL"
          },
          "CHN": {
            "_reason": "overlong",
            "_replacement": "CN"
          },
          "CIV": {
            "_reason": "overlong",
            "_replacement": "CI"
          },
          "CMR": {
            "_reason": "overlong",
            "_replacement": "CM"
          },
          "COD": {
            "_reason": "overlong",
            "_replacement": "CD"
          },
          "COG": {
            "_reason": "overlong",
            "_replacement": "CG"
          },
          "COK": {
            "_reason": "overlong",
            "_replacement": "CK"
          },
          "COL": {
            "_reason": "overlong",
            "_replacement": "CO"
          },
          "COM": {
            "_reason": "overlong",
            "_replacement": "KM"
          },
          "CPT": {
            "_reason": "overlong",
            "_replacement": "CP"
          },
          "CPV": {
            "_reason": "overlong",
            "_replacement": "CV"
          },
          "CRI": {
            "_reason": "overlong",
            "_replacement": "CR"
          },
          "CS": {
            "_reason": "deprecated",
            "_replacement": "RS ME"
          },
          "CT": {
            "_reason": "deprecated",
            "_replacement": "KI"
          },
          "CUB": {
            "_reason": "overlong",
            "_replacement": "CU"
          },
          "CUW": {
            "_reason": "overlong",
            "_replacement": "CW"
          },
          "CXR": {
            "_reason": "overlong",
            "_replacement": "CX"
          },
          "CYM": {
            "_reason": "overlong",
            "_replacement": "KY"
          },
          "CYP": {
            "_reason": "overlong",
            "_replacement": "CY"
          },
          "CZE": {
            "_reason": "overlong",
            "_replacement": "CZ"
          },
          "DD": {
            "_reason": "deprecated",
            "_replacement": "DE"
          },
          "DDR": {
            "_reason": "overlong",
            "_replacement": "DE"
          },
          "DEU": {
            "_reason": "overlong",
            "_replacement": "DE"
          },
          "DGA": {
            "_reason": "overlong",
            "_replacement": "DG"
          },
          "DJI": {
            "_reason": "overlong",
            "_replacement": "DJ"
          },
          "DMA": {
            "_reason": "overlong",
            "_replacement": "DM"
          },
          "DNK": {
            "_reason": "overlong",
            "_replacement": "DK"
          },
          "DOM": {
            "_reason": "overlong",
            "_replacement": "DO"
          },
          "DY": {
            "_reason": "deprecated",
            "_replacement": "BJ"
          },
          "DZA": {
            "_reason": "overlong",
            "_replacement": "DZ"
          },
          "ECU": {
            "_reason": "overlong",
            "_replacement": "EC"
          },
          "EGY": {
            "_reason": "overlong",
            "_replacement": "EG"
          },
          "ERI": {
            "_reason": "overlong",
            "_replacement": "ER"
          },
          "ESH": {
            "_reason": "overlong",
            "_replacement": "EH"
          },
          "ESP": {
            "_reason": "overlong",
            "_replacement": "ES"
          },
          "EST": {
            "_reason": "overlong",
            "_replacement": "EE"
          },
          "ETH": {
            "_reason": "overlong",
            "_replacement": "ET"
          },
          "FIN": {
            "_reason": "overlong",
            "_replacement": "FI"
          },
          "FJI": {
            "_reason": "overlong",
            "_replacement": "FJ"
          },
          "FLK": {
            "_reason": "overlong",
            "_replacement": "FK"
          },
          "FQ": {
            "_reason": "deprecated",
            "_replacement": "AQ TF"
          },
          "FRA": {
            "_reason": "overlong",
            "_replacement": "FR"
          },
          "FRO": {
            "_reason": "overlong",
            "_replacement": "FO"
          },
          "FSM": {
            "_reason": "overlong",
            "_replacement": "FM"
          },
          "FX": {
            "_reason": "deprecated",
            "_replacement": "FR"
          },
          "FXX": {
            "_reason": "overlong",
            "_replacement": "FR"
          },
          "GAB": {
            "_reason": "overlong",
            "_replacement": "GA"
          },
          "GBR": {
            "_reason": "overlong",
            "_replacement": "GB"
          },
          "GEO": {
            "_reason": "overlong",
            "_replacement": "GE"
          },
          "GGY": {
            "_reason": "overlong",
            "_replacement": "GG"
          },
          "GHA": {
            "_reason": "overlong",
            "_replacement": "GH"
          },
          "GIB": {
            "_reason": "overlong",
            "_replacement": "GI"
          },
          "GIN": {
            "_reason": "overlong",
            "_replacement": "GN"
          },
          "GLP": {
            "_reason": "overlong",
            "_replacement": "GP"
          },
          "GMB": {
            "_reason": "overlong",
            "_replacement": "GM"
          },
          "GNB": {
            "_reason": "overlong",
            "_replacement": "GW"
          },
          "GNQ": {
            "_reason": "overlong",
            "_replacement": "GQ"
          },
          "GRC": {
            "_reason": "overlong",
            "_replacement": "GR"
          },
          "GRD": {
            "_reason": "overlong",
            "_replacement": "GD"
          },
          "GRL": {
            "_reason": "overlong",
            "_replacement": "GL"
          },
          "GTM": {
            "_reason": "overlong",
            "_replacement": "GT"
          },
          "GUF": {
            "_reason": "overlong",
            "_replacement": "GF"
          },
          "GUM": {
            "_reason": "overlong",
            "_replacement": "GU"
          },
          "GUY": {
            "_reason": "overlong",
            "_replacement": "GY"
          },
          "HKG": {
            "_reason": "overlong",
            "_replacement": "HK"
          },
          "HMD": {
            "_reason": "overlong",
            "_replacement": "HM"
          },
          "HND": {
            "_reason": "overlong",
            "_replacement": "HN"
          },
          "HRV": {
            "_reason": "overlong",
            "_replacement": "HR"
          },
          "HTI": {
            "_reason": "overlong",
            "_replacement": "HT"
          },
          "HUN": {
            "_reason": "overlong",
            "_replacement": "HU"
          },
          "HV": {
            "_reason": "deprecated",
            "_replacement": "BF"
          },
          "IDN": {
            "_reason": "overlong",
            "_replacement": "ID"
          },
          "IMN": {
            "_reason": "overlong",
            "_replacement": "IM"
          },
          "IND": {
            "_reason": "overlong",
            "_replacement": "IN"
          },
          "IOT": {
            "_reason": "overlong",
            "_replacement": "IO"
          },
          "IRL": {
            "_reason": "overlong",
            "_replacement": "IE"
          },
          "IRN": {
            "_reason": "overlong",
            "_replacement": "IR"
          },
          "IRQ": {
            "_reason": "overlong",
            "_replacement": "IQ"
          },
          "ISL": {
            "_reason": "overlong",
            "_replacement": "IS"
          },
          "ISR": {
            "_reason": "overlong",
            "_replacement": "IL"
          },
          "ITA": {
            "_reason": "overlong",
            "_replacement": "IT"
          },
          "JAM": {
            "_reason": "overlong",
            "_replacement": "JM"
          },
          "JEY": {
            "_reason": "overlong",
            "_replacement": "JE"
          },
          "JOR": {
            "_reason": "overlong",
            "_replacement": "JO"
          },
          "JPN": {
            "_reason": "overlong",
            "_replacement": "JP"
          },
          "JT": {
            "_reason": "deprecated",
            "_replacement": "UM"
          },
          "KAZ": {
            "_reason": "overlong",
            "_replacement": "KZ"
          },
          "KEN": {
            "_reason": "overlong",
            "_replacement": "KE"
          },
          "KGZ": {
            "_reason": "overlong",
            "_replacement": "KG"
          },
          "KHM": {
            "_reason": "overlong",
            "_replacement": "KH"
          },
          "KIR": {
            "_reason": "overlong",
            "_replacement": "KI"
          },
          "KNA": {
            "_reason": "overlong",
            "_replacement": "KN"
          },
          "KOR": {
            "_reason": "overlong",
            "_replacement": "KR"
          },
          "KWT": {
            "_reason": "overlong",
            "_replacement": "KW"
          },
          "LAO": {
            "_reason": "overlong",
            "_replacement": "LA"
          },
          "LBN": {
            "_reason": "overlong",
            "_replacement": "LB"
          },
          "LBR": {
            "_reason": "overlong",
            "_replacement": "LR"
          },
          "LBY": {
            "_reason": "overlong",
            "_replacement": "LY"
          },
          "LCA": {
            "_reason": "overlong",
            "_replacement": "LC"
          },
          "LIE": {
            "_reason": "overlong",
            "_replacement": "LI"
          },
          "LKA": {
            "_reason": "overlong",
            "_replacement": "LK"
          },
          "LSO": {
            "_reason": "overlong",
            "_replacement": "LS"
          },
          "LTU": {
            "_reason": "overlong",
            "_replacement": "LT"
          },
          "LUX": {
            "_reason": "overlong",
            "_replacement": "LU"
          },
          "LVA": {
            "_reason": "overlong",
            "_replacement": "LV"
          },
          "MAC": {
            "_reason": "overlong",
            "_replacement": "MO"
          },
          "MAF": {
            "_reason": "overlong",
            "_replacement": "MF"
          },
          "MAR": {
            "_reason": "overlong",
            "_replacement": "MA"
          },
          "MCO": {
            "_reason": "overlong",
            "_replacement": "MC"
          },
          "MDA": {
            "_reason": "overlong",
            "_replacement": "MD"
          },
          "MDG": {
            "_reason": "overlong",
            "_replacement": "MG"
          },
          "MDV": {
            "_reason": "overlong",
            "_replacement": "MV"
          },
          "MEX": {
            "_reason": "overlong",
            "_replacement": "MX"
          },
          "MHL": {
            "_reason": "overlong",
            "_replacement": "MH"
          },
          "MI": {
            "_reason": "deprecated",
            "_replacement": "UM"
          },
          "MKD": {
            "_reason": "overlong",
            "_replacement": "MK"
          },
          "MLI": {
            "_reason": "overlong",
            "_replacement": "ML"
          },
          "MLT": {
            "_reason": "overlong",
            "_replacement": "MT"
          },
          "MMR": {
            "_reason": "overlong",
            "_replacement": "MM"
          },
          "MNE": {
            "_reason": "overlong",
            "_replacement": "ME"
          },
          "MNG": {
            "_reason": "overlong",
            "_replacement": "MN"
          },
          "MNP": {
            "_reason": "overlong",
            "_replacement": "MP"
          },
          "MOZ": {
            "_reason": "overlong",
            "_replacement": "MZ"
          },
          "MRT": {
            "_reason": "overlong",
            "_replacement": "MR"
          },
          "MSR": {
            "_reason": "overlong",
            "_replacement": "MS"
          },
          "MTQ": {
            "_reason": "overlong",
            "_replacement": "MQ"
          },
          "MUS": {
            "_reason": "overlong",
            "_replacement": "MU"
          },
          "MWI": {
            "_reason": "overlong",
            "_replacement": "MW"
          },
          "MYS": {
            "_reason": "overlong",
            "_replacement": "MY"
          },
          "MYT": {
            "_reason": "overlong",
            "_replacement": "YT"
          },
          "NAM": {
            "_reason": "overlong",
            "_replacement": "NA"
          },
          "NCL": {
            "_reason": "overlong",
            "_replacement": "NC"
          },
          "NER": {
            "_reason": "overlong",
            "_replacement": "NE"
          },
          "NFK": {
            "_reason": "overlong",
            "_replacement": "NF"
          },
          "NGA": {
            "_reason": "overlong",
            "_replacement": "NG"
          },
          "NH": {
            "_reason": "deprecated",
            "_replacement": "VU"
          },
          "NIC": {
            "_reason": "overlong",
            "_replacement": "NI"
          },
          "NIU": {
            "_reason": "overlong",
            "_replacement": "NU"
          },
          "NLD": {
            "_reason": "overlong",
            "_replacement": "NL"
          },
          "NOR": {
            "_reason": "overlong",
            "_replacement": "NO"
          },
          "NPL": {
            "_reason": "overlong",
            "_replacement": "NP"
          },
          "NQ": {
            "_reason": "deprecated",
            "_replacement": "AQ"
          },
          "NRU": {
            "_reason": "overlong",
            "_replacement": "NR"
          },
          "NT": {
            "_reason": "deprecated",
            "_replacement": "SA IQ"
          },
          "NTZ": {
            "_reason": "overlong",
            "_replacement": "SA IQ"
          },
          "NZL": {
            "_reason": "overlong",
            "_replacement": "NZ"
          },
          "OMN": {
            "_reason": "overlong",
            "_replacement": "OM"
          },
          "PAK": {
            "_reason": "overlong",
            "_replacement": "PK"
          },
          "PAN": {
            "_reason": "overlong",
            "_replacement": "PA"
          },
          "PC": {
            "_reason": "deprecated",
            "_replacement": "FM MH MP PW"
          },
          "PCN": {
            "_reason": "overlong",
            "_replacement": "PN"
          },
          "PER": {
            "_reason": "overlong",
            "_replacement": "PE"
          },
          "PHL": {
            "_reason": "overlong",
            "_replacement": "PH"
          },
          "PLW": {
            "_reason": "overlong",
            "_replacement": "PW"
          },
          "PNG": {
            "_reason": "overlong",
            "_replacement": "PG"
          },
          "POL": {
            "_reason": "overlong",
            "_replacement": "PL"
          },
          "PRI": {
            "_reason": "overlong",
            "_replacement": "PR"
          },
          "PRK": {
            "_reason": "overlong",
            "_replacement": "KP"
          },
          "PRT": {
            "_reason": "overlong",
            "_replacement": "PT"
          },
          "PRY": {
            "_reason": "overlong",
            "_replacement": "PY"
          },
          "PSE": {
            "_reason": "overlong",
            "_replacement": "PS"
          },
          "PU": {
            "_reason": "deprecated",
            "_replacement": "UM"
          },
          "PYF": {
            "_reason": "overlong",
            "_replacement": "PF"
          },
          "PZ": {
            "_reason": "deprecated",
            "_replacement": "PA"
          },
          "QAT": {
            "_reason": "overlong",
            "_replacement": "QA"
          },
          "QMM": {
            "_reason": "overlong",
            "_replacement": "QM"
          },
          "QNN": {
            "_reason": "overlong",
            "_replacement": "QN"
          },
          "QPP": {
            "_reason": "overlong",
            "_replacement": "QP"
          },
          "QQQ": {
            "_reason": "overlong",
            "_replacement": "QQ"
          },
          "QRR": {
            "_reason": "overlong",
            "_replacement": "QR"
          },
          "QSS": {
            "_reason": "overlong",
            "_replacement": "QS"
          },
          "QTT": {
            "_reason": "overlong",
            "_replacement": "QT"
          },
          "QU": {
            "_reason": "deprecated",
            "_replacement": "EU"
          },
          "QUU": {
            "_reason": "overlong",
            "_replacement": "EU"
          },
          "QVV": {
            "_reason": "overlong",
            "_replacement": "QV"
          },
          "QWW": {
            "_reason": "overlong",
            "_replacement": "QW"
          },
          "QXX": {
            "_reason": "overlong",
            "_replacement": "QX"
          },
          "QYY": {
            "_reason": "overlong",
            "_replacement": "QY"
          },
          "QZZ": {
            "_reason": "overlong",
            "_replacement": "QZ"
          },
          "REU": {
            "_reason": "overlong",
            "_replacement": "RE"
          },
          "RH": {
            "_reason": "deprecated",
            "_replacement": "ZW"
          },
          "ROU": {
            "_reason": "overlong",
            "_replacement": "RO"
          },
          "RUS": {
            "_reason": "overlong",
            "_replacement": "RU"
          },
          "RWA": {
            "_reason": "overlong",
            "_replacement": "RW"
          },
          "SAU": {
            "_reason": "overlong",
            "_replacement": "SA"
          },
          "SCG": {
            "_reason": "overlong",
            "_replacement": "RS ME"
          },
          "SDN": {
            "_reason": "overlong",
            "_replacement": "SD"
          },
          "SEN": {
            "_reason": "overlong",
            "_replacement": "SN"
          },
          "SGP": {
            "_reason": "overlong",
            "_replacement": "SG"
          },
          "SGS": {
            "_reason": "overlong",
            "_replacement": "GS"
          },
          "SHN": {
            "_reason": "overlong",
            "_replacement": "SH"
          },
          "SJM": {
            "_reason": "overlong",
            "_replacement": "SJ"
          },
          "SLB": {
            "_reason": "overlong",
            "_replacement": "SB"
          },
          "SLE": {
            "_reason": "overlong",
            "_replacement": "SL"
          },
          "SLV": {
            "_reason": "overlong",
            "_replacement": "SV"
          },
          "SMR": {
            "_reason": "overlong",
            "_replacement": "SM"
          },
          "SOM": {
            "_reason": "overlong",
            "_replacement": "SO"
          },
          "SPM": {
            "_reason": "overlong",
            "_replacement": "PM"
          },
          "SRB": {
            "_reason": "overlong",
            "_replacement": "RS"
          },
          "SSD": {
            "_reason": "overlong",
            "_replacement": "SS"
          },
          "STP": {
            "_reason": "overlong",
            "_replacement": "ST"
          },
          "SU": {
            "_reason": "deprecated",
            "_replacement": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ"
          },
          "SUN": {
            "_reason": "overlong",
            "_replacement": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ"
          },
          "SUR": {
            "_reason": "overlong",
            "_replacement": "SR"
          },
          "SVK": {
            "_reason": "overlong",
            "_replacement": "SK"
          },
          "SVN": {
            "_reason": "overlong",
            "_replacement": "SI"
          },
          "SWE": {
            "_reason": "overlong",
            "_replacement": "SE"
          },
          "SWZ": {
            "_reason": "overlong",
            "_replacement": "SZ"
          },
          "SXM": {
            "_reason": "overlong",
            "_replacement": "SX"
          },
          "SYC": {
            "_reason": "overlong",
            "_replacement": "SC"
          },
          "SYR": {
            "_reason": "overlong",
            "_replacement": "SY"
          },
          "TAA": {
            "_reason": "overlong",
            "_replacement": "TA"
          },
          "TCA": {
            "_reason": "overlong",
            "_replacement": "TC"
          },
          "TCD": {
            "_reason": "overlong",
            "_replacement": "TD"
          },
          "TGO": {
            "_reason": "overlong",
            "_replacement": "TG"
          },
          "THA": {
            "_reason": "overlong",
            "_replacement": "TH"
          },
          "TJK": {
            "_reason": "overlong",
            "_replacement": "TJ"
          },
          "TKL": {
            "_reason": "overlong",
            "_replacement": "TK"
          },
          "TKM": {
            "_reason": "overlong",
            "_replacement": "TM"
          },
          "TLS": {
            "_reason": "overlong",
            "_replacement": "TL"
          },
          "TMP": {
            "_reason": "overlong",
            "_replacement": "TL"
          },
          "TON": {
            "_reason": "overlong",
            "_replacement": "TO"
          },
          "TP": {
            "_reason": "deprecated",
            "_replacement": "TL"
          },
          "TTO": {
            "_reason": "overlong",
            "_replacement": "TT"
          },
          "TUN": {
            "_reason": "overlong",
            "_replacement": "TN"
          },
          "TUR": {
            "_reason": "overlong",
            "_replacement": "TR"
          },
          "TUV": {
            "_reason": "overlong",
            "_replacement": "TV"
          },
          "TWN": {
            "_reason": "overlong",
            "_replacement": "TW"
          },
          "TZA": {
            "_reason": "overlong",
            "_replacement": "TZ"
          },
          "UGA": {
            "_reason": "overlong",
            "_replacement": "UG"
          },
          "UK": {
            "_reason": "deprecated",
            "_replacement": "GB"
          },
          "UKR": {
            "_reason": "overlong",
            "_replacement": "UA"
          },
          "UMI": {
            "_reason": "overlong",
            "_replacement": "UM"
          },
          "URY": {
            "_reason": "overlong",
            "_replacement": "UY"
          },
          "USA": {
            "_reason": "overlong",
            "_replacement": "US"
          },
          "UZB": {
            "_reason": "overlong",
            "_replacement": "UZ"
          },
          "VAT": {
            "_reason": "overlong",
            "_replacement": "VA"
          },
          "VCT": {
            "_reason": "overlong",
            "_replacement": "VC"
          },
          "VD": {
            "_reason": "deprecated",
            "_replacement": "VN"
          },
          "VEN": {
            "_reason": "overlong",
            "_replacement": "VE"
          },
          "VGB": {
            "_reason": "overlong",
            "_replacement": "VG"
          },
          "VIR": {
            "_reason": "overlong",
            "_replacement": "VI"
          },
          "VNM": {
            "_reason": "overlong",
            "_replacement": "VN"
          },
          "VUT": {
            "_reason": "overlong",
            "_replacement": "VU"
          },
          "WK": {
            "_reason": "deprecated",
            "_replacement": "UM"
          },
          "WLF": {
            "_reason": "overlong",
            "_replacement": "WF"
          },
          "WSM": {
            "_reason": "overlong",
            "_replacement": "WS"
          },
          "XAA": {
            "_reason": "overlong",
            "_replacement": "XA"
          },
          "XBB": {
            "_reason": "overlong",
            "_replacement": "XB"
          },
          "XCC": {
            "_reason": "overlong",
            "_replacement": "XC"
          },
          "XDD": {
            "_reason": "overlong",
            "_replacement": "XD"
          },
          "XEE": {
            "_reason": "overlong",
            "_replacement": "XE"
          },
          "XFF": {
            "_reason": "overlong",
            "_replacement": "XF"
          },
          "XGG": {
            "_reason": "overlong",
            "_replacement": "XG"
          },
          "XHH": {
            "_reason": "overlong",
            "_replacement": "XH"
          },
          "XII": {
            "_reason": "overlong",
            "_replacement": "XI"
          },
          "XJJ": {
            "_reason": "overlong",
            "_replacement": "XJ"
          },
          "XKK": {
            "_reason": "overlong",
            "_replacement": "XK"
          },
          "XLL": {
            "_reason": "overlong",
            "_replacement": "XL"
          },
          "XMM": {
            "_reason": "overlong",
            "_replacement": "XM"
          },
          "XNN": {
            "_reason": "overlong",
            "_replacement": "XN"
          },
          "XOO": {
            "_reason": "overlong",
            "_replacement": "XO"
          },
          "XPP": {
            "_reason": "overlong",
            "_replacement": "XP"
          },
          "XQQ": {
            "_reason": "overlong",
            "_replacement": "XQ"
          },
          "XRR": {
            "_reason": "overlong",
            "_replacement": "XR"
          },
          "XSS": {
            "_reason": "overlong",
            "_replacement": "XS"
          },
          "XTT": {
            "_reason": "overlong",
            "_replacement": "XT"
          },
          "XUU": {
            "_reason": "overlong",
            "_replacement": "XU"
          },
          "XVV": {
            "_reason": "overlong",
            "_replacement": "XV"
          },
          "XWW": {
            "_reason": "overlong",
            "_replacement": "XW"
          },
          "XXX": {
            "_reason": "overlong",
            "_replacement": "XX"
          },
          "XYY": {
            "_reason": "overlong",
            "_replacement": "XY"
          },
          "XZZ": {
            "_reason": "overlong",
            "_replacement": "XZ"
          },
          "YD": {
            "_reason": "deprecated",
            "_replacement": "YE"
          },
          "YEM": {
            "_reason": "overlong",
            "_replacement": "YE"
          },
          "YMD": {
            "_reason": "overlong",
            "_replacement": "YE"
          },
          "YU": {
            "_reason": "deprecated",
            "_replacement": "RS ME"
          },
          "YUG": {
            "_reason": "overlong",
            "_replacement": "RS ME"
          },
          "ZAF": {
            "_reason": "overlong",
            "_replacement": "ZA"
          },
          "ZAR": {
            "_reason": "overlong",
            "_replacement": "CD"
          },
          "ZMB": {
            "_reason": "overlong",
            "_replacement": "ZM"
          },
          "ZR": {
            "_reason": "deprecated",
            "_replacement": "CD"
          },
          "ZWE": {
            "_reason": "overlong",
            "_replacement": "ZW"
          },
          "ZZZ": {
            "_reason": "overlong",
            "_replacement": "ZZ"
          }
        },
        "variantAlias": {
          "AALAND": {
            "_reason": "deprecated",
            "_replacement": "AX"
          },
          "arevela": {
            "_reason": "deprecated",
            "_replacement": "hy"
          },
          "arevmda": {
            "_reason": "deprecated",
            "_replacement": "hyw"
          },
          "heploc": {
            "_reason": "deprecated",
            "_replacement": "alalc97"
          },
          "HEPLOC": {
            "_reason": "deprecated",
            "_replacement": "ALALC97"
          },
          "POLYTONI": {
            "_reason": "deprecated",
            "_replacement": "POLYTON"
          }
        },
        "zoneAlias": {
          "Africa": {
            "Timbuktu": {
              "_reason": "deprecated",
              "_replacement": "Africa/Bamako"
            }
          },
          "America": {
            "Montreal": {
              "_reason": "deprecated",
              "_replacement": "America/Toronto"
            },
            "Shiprock": {
              "_reason": "deprecated",
              "_replacement": "America/Denver"
            }
          },
          "Antarctica": {
            "South_Pole": {
              "_reason": "deprecated",
              "_replacement": "Pacific/Auckland"
            }
          },
          "Asia": {
            "Chongqing": {
              "_reason": "deprecated",
              "_replacement": "Asia/Shanghai"
            },
            "Harbin": {
              "_reason": "deprecated",
              "_replacement": "Asia/Shanghai"
            },
            "Kashgar": {
              "_reason": "deprecated",
              "_replacement": "Asia/Urumqi"
            }
          },
          "Atlantic": {
            "Jan_Mayen": {
              "_reason": "deprecated",
              "_replacement": "Europe/Oslo"
            }
          },
          "EST": {
            "_reason": "deprecated",
            "_replacement": "America/Indianapolis"
          },
          "Europe": {
            "Belfast": {
              "_reason": "deprecated",
              "_replacement": "Europe/London"
            }
          },
          "HST": {
            "_reason": "deprecated",
            "_replacement": "Pacific/Honolulu"
          },
          "MST": {
            "_reason": "deprecated",
            "_replacement": "America/Phoenix"
          },
          "Pacific": {
            "Yap": {
              "_reason": "deprecated",
              "_replacement": "Pacific/Truk"
            }
          },
          "SystemV": {
            "AST4": {
              "_reason": "deprecated",
              "_replacement": "America/Puerto_Rico"
            },
            "AST4ADT": {
              "_reason": "deprecated",
              "_replacement": "America/Halifax"
            },
            "CST6": {
              "_reason": "deprecated",
              "_replacement": "America/Regina"
            },
            "CST6CDT": {
              "_reason": "deprecated",
              "_replacement": "America/Chicago"
            },
            "EST5": {
              "_reason": "deprecated",
              "_replacement": "America/Indianapolis"
            },
            "EST5EDT": {
              "_reason": "deprecated",
              "_replacement": "America/New_York"
            },
            "HST10": {
              "_reason": "deprecated",
              "_replacement": "Pacific/Honolulu"
            },
            "MST7": {
              "_reason": "deprecated",
              "_replacement": "America/Phoenix"
            },
            "MST7MDT": {
              "_reason": "deprecated",
              "_replacement": "America/Denver"
            },
            "PST8": {
              "_reason": "deprecated",
              "_replacement": "Pacific/Pitcairn"
            },
            "PST8PDT": {
              "_reason": "deprecated",
              "_replacement": "America/Los_Angeles"
            },
            "YST9": {
              "_reason": "deprecated",
              "_replacement": "Pacific/Gambier"
            },
            "YST9YDT": {
              "_reason": "deprecated",
              "_replacement": "America/Anchorage"
            }
          }
        }
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "calendarData": {
      "buddhist": {
        "calendarSystem": "solar",
        "eras": {
          "0": {
            "_start": "-542-01-01"
          }
        }
      },
      "chinese": {
        "calendarSystem": "lunisolar",
        "eras": {
          "0": {
            "_start": "-2636-01-01"
          }
        }
      },
      "coptic": {
        "calendarSystem": "other",
        "eras": {
          "0": {
            "_end": "284-08-28"
          },
          "1": {
            "_start": "284-08-29"
          }
        }
      },
      "dangi": {
        "calendarSystem": "lunisolar",
        "eras": {
          "0": {
            "_start": "-2332-01-01"
          }
        }
      },
      "ethiopic": {
        "calendarSystem": "other",
        "eras": {
          "0": {
            "_end": "8-08-28"
          },
          "1": {
            "_start": "8-08-29"
          }
        }
      },
      "ethiopic-amete-alem": {
        "eras": {
          "0": {
            "_end": "-5492-08-29"
          }
        }
      },
      "generic": {},
      "gregorian": {
        "calendarSystem": "solar",
        "eras": {
          "0": {
            "_end": "0-12-31"
          },
          "1": {
            "_start": "1-01-01"
          }
        }
      },
      "hebrew": {
        "calendarSystem": "lunisolar",
        "eras": {
          "0": {
            "_start": "-3760-10-7"
          }
        }
      },
      "indian": {
        "eras": {
          "0": {
            "_start": "79-01-01"
          }
        }
      },
      "islamic": {
        "calendarSystem": "lunar",
        "eras": {
          "0": {
            "_start": "622-7-15"
          }
        }
      },
      "islamic-civil": {
        "calendarSystem": "lunar",
        "eras": {
          "0": {
            "_start": "622-7-16"
          }
        }
      },
      "islamic-rgsa": {
        "calendarSystem": "lunar",
        "eras": {
          "0": {
            "_start": "622-7-15"
          }
        }
      },
      "islamic-tbla": {
        "calendarSystem": "lunar",
        "eras": {
          "0": {
            "_start": "622-7-15"
          }
        }
      },
      "islamic-umalqura": {
        "calendarSystem": "lunar",
        "eras": {
          "0": {
            "_start": "622-7-15"
          }
        }
      },
      "japanese": {
        "calendarSystem": "solar",
        "eras": {
          "0": {
            "_start": "645-6-19"
          },
          "1": {
            "_start": "650-2-15"
          },
          "2": {
            "_start": "672-1-1"
          },
          "3": {
            "_start": "686-7-20"
          },
          "4": {
            "_start": "701-3-21"
          },
          "5": {
            "_start": "704-5-10"
          },
          "6": {
            "_start": "708-1-11"
          },
          "7": {
            "_start": "715-9-2"
          },
          "8": {
            "_start": "717-11-17"
          },
          "9": {
            "_start": "724-2-4"
          },
          "10": {
            "_start": "729-8-5"
          },
          "11": {
            "_start": "749-4-14"
          },
          "12": {
            "_start": "749-7-2"
          },
          "13": {
            "_start": "757-8-18"
          },
          "14": {
            "_start": "765-1-7"
          },
          "15": {
            "_start": "767-8-16"
          },
          "16": {
            "_start": "770-10-1"
          },
          "17": {
            "_start": "781-1-1"
          },
          "18": {
            "_start": "782-8-19"
          },
          "19": {
            "_start": "806-5-18"
          },
          "20": {
            "_start": "810-9-19"
          },
          "21": {
            "_start": "824-1-5"
          },
          "22": {
            "_start": "834-1-3"
          },
          "23": {
            "_start": "848-6-13"
          },
          "24": {
            "_start": "851-4-28"
          },
          "25": {
            "_start": "854-11-30"
          },
          "26": {
            "_start": "857-2-21"
          },
          "27": {
            "_start": "859-4-15"
          },
          "28": {
            "_start": "877-4-16"
          },
          "29": {
            "_start": "885-2-21"
          },
          "30": {
            "_start": "889-4-27"
          },
          "31": {
            "_start": "898-4-26"
          },
          "32": {
            "_start": "901-7-15"
          },
          "33": {
            "_start": "923-4-11"
          },
          "34": {
            "_start": "931-4-26"
          },
          "35": {
            "_start": "938-5-22"
          },
          "36": {
            "_start": "947-4-22"
          },
          "37": {
            "_start": "957-10-27"
          },
          "38": {
            "_start": "961-2-16"
          },
          "39": {
            "_start": "964-7-10"
          },
          "40": {
            "_start": "968-8-13"
          },
          "41": {
            "_start": "970-3-25"
          },
          "42": {
            "_start": "973-12-20"
          },
          "43": {
            "_start": "976-7-13"
          },
          "44": {
            "_start": "978-11-29"
          },
          "45": {
            "_start": "983-4-15"
          },
          "46": {
            "_start": "985-4-27"
          },
          "47": {
            "_start": "987-4-5"
          },
          "48": {
            "_start": "989-8-8"
          },
          "49": {
            "_start": "990-11-7"
          },
          "50": {
            "_start": "995-2-22"
          },
          "51": {
            "_start": "999-1-13"
          },
          "52": {
            "_start": "1004-7-20"
          },
          "53": {
            "_start": "1012-12-25"
          },
          "54": {
            "_start": "1017-4-23"
          },
          "55": {
            "_start": "1021-2-2"
          },
          "56": {
            "_start": "1024-7-13"
          },
          "57": {
            "_start": "1028-7-25"
          },
          "58": {
            "_start": "1037-4-21"
          },
          "59": {
            "_start": "1040-11-10"
          },
          "60": {
            "_start": "1044-11-24"
          },
          "61": {
            "_start": "1046-4-14"
          },
          "62": {
            "_start": "1053-1-11"
          },
          "63": {
            "_start": "1058-8-29"
          },
          "64": {
            "_start": "1065-8-2"
          },
          "65": {
            "_start": "1069-4-13"
          },
          "66": {
            "_start": "1074-8-23"
          },
          "67": {
            "_start": "1077-11-17"
          },
          "68": {
            "_start": "1081-2-10"
          },
          "69": {
            "_start": "1084-2-7"
          },
          "70": {
            "_start": "1087-4-7"
          },
          "71": {
            "_start": "1094-12-15"
          },
          "72": {
            "_start": "1096-12-17"
          },
          "73": {
            "_start": "1097-11-21"
          },
          "74": {
            "_start": "1099-8-28"
          },
          "75": {
            "_start": "1104-2-10"
          },
          "76": {
            "_start": "1106-4-9"
          },
          "77": {
            "_start": "1108-8-3"
          },
          "78": {
            "_start": "1110-7-13"
          },
          "79": {
            "_start": "1113-7-13"
          },
          "80": {
            "_start": "1118-4-3"
          },
          "81": {
            "_start": "1120-4-10"
          },
          "82": {
            "_start": "1124-4-3"
          },
          "83": {
            "_start": "1126-1-22"
          },
          "84": {
            "_start": "1131-1-29"
          },
          "85": {
            "_start": "1132-8-11"
          },
          "86": {
            "_start": "1135-4-27"
          },
          "87": {
            "_start": "1141-7-10"
          },
          "88": {
            "_start": "1142-4-28"
          },
          "89": {
            "_start": "1144-2-23"
          },
          "90": {
            "_start": "1145-7-22"
          },
          "91": {
            "_start": "1151-1-26"
          },
          "92": {
            "_start": "1154-10-28"
          },
          "93": {
            "_start": "1156-4-27"
          },
          "94": {
            "_start": "1159-4-20"
          },
          "95": {
            "_start": "1160-1-10"
          },
          "96": {
            "_start": "1161-9-4"
          },
          "97": {
            "_start": "1163-3-29"
          },
          "98": {
            "_start": "1165-6-5"
          },
          "99": {
            "_start": "1166-8-27"
          },
          "100": {
            "_start": "1169-4-8"
          },
          "101": {
            "_start": "1171-4-21"
          },
          "102": {
            "_start": "1175-7-28"
          },
          "103": {
            "_start": "1177-8-4"
          },
          "104": {
            "_start": "1181-7-14"
          },
          "105": {
            "_start": "1182-5-27"
          },
          "106": {
            "_start": "1184-4-16"
          },
          "107": {
            "_start": "1185-8-14"
          },
          "108": {
            "_start": "1190-4-11"
          },
          "109": {
            "_start": "1199-4-27"
          },
          "110": {
            "_start": "1201-2-13"
          },
          "111": {
            "_start": "1204-2-20"
          },
          "112": {
            "_start": "1206-4-27"
          },
          "113": {
            "_start": "1207-10-25"
          },
          "114": {
            "_start": "1211-3-9"
          },
          "115": {
            "_start": "1213-12-6"
          },
          "116": {
            "_start": "1219-4-12"
          },
          "117": {
            "_start": "1222-4-13"
          },
          "118": {
            "_start": "1224-11-20"
          },
          "119": {
            "_start": "1225-4-20"
          },
          "120": {
            "_start": "1227-12-10"
          },
          "121": {
            "_start": "1229-3-5"
          },
          "122": {
            "_start": "1232-4-2"
          },
          "123": {
            "_start": "1233-4-15"
          },
          "124": {
            "_start": "1234-11-5"
          },
          "125": {
            "_start": "1235-9-19"
          },
          "126": {
            "_start": "1238-11-23"
          },
          "127": {
            "_start": "1239-2-7"
          },
          "128": {
            "_start": "1240-7-16"
          },
          "129": {
            "_start": "1243-2-26"
          },
          "130": {
            "_start": "1247-2-28"
          },
          "131": {
            "_start": "1249-3-18"
          },
          "132": {
            "_start": "1256-10-5"
          },
          "133": {
            "_start": "1257-3-14"
          },
          "134": {
            "_start": "1259-3-26"
          },
          "135": {
            "_start": "1260-4-13"
          },
          "136": {
            "_start": "1261-2-20"
          },
          "137": {
            "_start": "1264-2-28"
          },
          "138": {
            "_start": "1275-4-25"
          },
          "139": {
            "_start": "1278-2-29"
          },
          "140": {
            "_start": "1288-4-28"
          },
          "141": {
            "_start": "1293-8-5"
          },
          "142": {
            "_start": "1299-4-25"
          },
          "143": {
            "_start": "1302-11-21"
          },
          "144": {
            "_start": "1303-8-5"
          },
          "145": {
            "_start": "1306-12-14"
          },
          "146": {
            "_start": "1308-10-9"
          },
          "147": {
            "_start": "1311-4-28"
          },
          "148": {
            "_start": "1312-3-20"
          },
          "149": {
            "_start": "1317-2-3"
          },
          "150": {
            "_start": "1319-4-28"
          },
          "151": {
            "_start": "1321-2-23"
          },
          "152": {
            "_start": "1324-12-9"
          },
          "153": {
            "_start": "1326-4-26"
          },
          "154": {
            "_start": "1329-8-29"
          },
          "155": {
            "_start": "1331-8-9"
          },
          "156": {
            "_start": "1334-1-29"
          },
          "157": {
            "_start": "1336-2-29"
          },
          "158": {
            "_start": "1340-4-28"
          },
          "159": {
            "_start": "1346-12-8"
          },
          "160": {
            "_start": "1370-7-24"
          },
          "161": {
            "_start": "1372-4-1"
          },
          "162": {
            "_start": "1375-5-27"
          },
          "163": {
            "_start": "1379-3-22"
          },
          "164": {
            "_start": "1381-2-10"
          },
          "165": {
            "_start": "1384-4-28"
          },
          "166": {
            "_start": "1387-8-22"
          },
          "167": {
            "_start": "1387-8-23"
          },
          "168": {
            "_start": "1389-2-9"
          },
          "169": {
            "_start": "1390-3-26"
          },
          "170": {
            "_start": "1394-7-5"
          },
          "171": {
            "_start": "1428-4-27"
          },
          "172": {
            "_start": "1429-9-5"
          },
          "173": {
            "_start": "1441-2-17"
          },
          "174": {
            "_start": "1444-2-5"
          },
          "175": {
            "_start": "1449-7-28"
          },
          "176": {
            "_start": "1452-7-25"
          },
          "177": {
            "_start": "1455-7-25"
          },
          "178": {
            "_start": "1457-9-28"
          },
          "179": {
            "_start": "1460-12-21"
          },
          "180": {
            "_start": "1466-2-28"
          },
          "181": {
            "_start": "1467-3-3"
          },
          "182": {
            "_start": "1469-4-28"
          },
          "183": {
            "_start": "1487-7-29"
          },
          "184": {
            "_start": "1489-8-21"
          },
          "185": {
            "_start": "1492-7-19"
          },
          "186": {
            "_start": "1501-2-29"
          },
          "187": {
            "_start": "1504-2-30"
          },
          "188": {
            "_start": "1521-8-23"
          },
          "189": {
            "_start": "1528-8-20"
          },
          "190": {
            "_start": "1532-7-29"
          },
          "191": {
            "_start": "1555-10-23"
          },
          "192": {
            "_start": "1558-2-28"
          },
          "193": {
            "_start": "1570-4-23"
          },
          "194": {
            "_start": "1573-7-28"
          },
          "195": {
            "_start": "1592-12-8"
          },
          "196": {
            "_start": "1596-10-27"
          },
          "197": {
            "_start": "1615-7-13"
          },
          "198": {
            "_start": "1624-2-30"
          },
          "199": {
            "_start": "1644-12-16"
          },
          "200": {
            "_start": "1648-2-15"
          },
          "201": {
            "_start": "1652-9-18"
          },
          "202": {
            "_start": "1655-4-13"
          },
          "203": {
            "_start": "1658-7-23"
          },
          "204": {
            "_start": "1661-4-25"
          },
          "205": {
            "_start": "1673-9-21"
          },
          "206": {
            "_start": "1681-9-29"
          },
          "207": {
            "_start": "1684-2-21"
          },
          "208": {
            "_start": "1688-9-30"
          },
          "209": {
            "_start": "1704-3-13"
          },
          "210": {
            "_start": "1711-4-25"
          },
          "211": {
            "_start": "1716-6-22"
          },
          "212": {
            "_start": "1736-4-28"
          },
          "213": {
            "_start": "1741-2-27"
          },
          "214": {
            "_start": "1744-2-21"
          },
          "215": {
            "_start": "1748-7-12"
          },
          "216": {
            "_start": "1751-10-27"
          },
          "217": {
            "_start": "1764-6-2"
          },
          "218": {
            "_start": "1772-11-16"
          },
          "219": {
            "_start": "1781-4-2"
          },
          "220": {
            "_start": "1789-1-25"
          },
          "221": {
            "_start": "1801-2-5"
          },
          "222": {
            "_start": "1804-2-11"
          },
          "223": {
            "_start": "1818-4-22"
          },
          "224": {
            "_start": "1830-12-10"
          },
          "225": {
            "_start": "1844-12-2"
          },
          "226": {
            "_start": "1848-2-28"
          },
          "227": {
            "_start": "1854-11-27"
          },
          "228": {
            "_start": "1860-3-18"
          },
          "229": {
            "_start": "1861-2-19"
          },
          "230": {
            "_start": "1864-2-20"
          },
          "231": {
            "_start": "1865-4-7"
          },
          "232": {
            "_start": "1868-9-8"
          },
          "233": {
            "_start": "1912-7-30"
          },
          "234": {
            "_start": "1926-12-25"
          },
          "235": {
            "_start": "1989-1-8"
          },
          "236": {
            "_start": "2019-5-1"
          }
        }
      },
      "persian": {
        "calendarSystem": "solar",
        "eras": {
          "0": {
            "_start": "622-01-01"
          }
        }
      },
      "roc": {
        "eras": {
          "0": {
            "_end": "1911-12-31"
          },
          "1": {
            "_start": "1912-01-01"
          }
        }
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "calendarPreferenceData": {
      "001": "gregorian",
      "AE": "gregorian islamic-umalqura islamic islamic-civil islamic-tbla",
      "AF": "persian gregorian islamic islamic-civil islamic-tbla",
      "BH": "gregorian islamic-umalqura islamic islamic-civil islamic-tbla",
      "CN": "gregorian chinese",
      "CX": "gregorian chinese",
      "DJ": "gregorian islamic islamic-civil islamic-tbla",
      "DZ": "gregorian islamic islamic-civil islamic-tbla",
      "EG": "gregorian coptic islamic islamic-civil islamic-tbla",
      "EH": "gregorian islamic islamic-civil islamic-tbla",
      "ER": "gregorian islamic islamic-civil islamic-tbla",
      "ET": "gregorian ethiopic",
      "HK": "gregorian chinese",
      "IL": "gregorian hebrew islamic islamic-civil islamic-tbla",
      "IN": "gregorian indian",
      "IQ": "gregorian islamic islamic-civil islamic-tbla",
      "IR": "persian gregorian islamic islamic-civil islamic-tbla",
      "JO": "gregorian islamic islamic-civil islamic-tbla",
      "JP": "gregorian japanese",
      "KM": "gregorian islamic islamic-civil islamic-tbla",
      "KR": "gregorian dangi",
      "KW": "gregorian islamic-umalqura islamic islamic-civil islamic-tbla",
      "LB": "gregorian islamic islamic-civil islamic-tbla",
      "LY": "gregorian islamic islamic-civil islamic-tbla",
      "MA": "gregorian islamic islamic-civil islamic-tbla",
      "MO": "gregorian chinese",
      "MR": "gregorian islamic islamic-civil islamic-tbla",
      "OM": "gregorian islamic islamic-civil islamic-tbla",
      "PS": "gregorian islamic islamic-civil islamic-tbla",
      "QA": "gregorian islamic-umalqura islamic islamic-civil islamic-tbla",
      "SA": "islamic-umalqura gregorian islamic islamic-rgsa",
      "SD": "gregorian islamic islamic-civil islamic-tbla",
      "SG": "gregorian chinese",
      "SY": "gregorian islamic islamic-civil islamic-tbla",
      "TD": "gregorian islamic islamic-civil islamic-tbla",
      "TH": "buddhist gregorian",
      "TN": "gregorian islamic islamic-civil islamic-tbla",
      "TW": "gregorian roc chinese",
      "YE": "gregorian islamic islamic-civil islamic-tbla"
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 11914 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "characters": {
      "character-fallback": {
        "U+00AD": [{
          "substitute": "-"
        }],
        "U+FF9E": [{
          "substitute": "゛"
        }],
        "U+FF9F": [{
          "substitute": "゜"
        }],
        "U+3000": [{
          "substitute": "  "
        }],
        "U+2010": [{
          "substitute": "-"
        }],
        "U+2011": [{
          "substitute": "-"
        }],
        "U+2012": [{
          "substitute": "-"
        }],
        "U+2013": [{
          "substitute": "-"
        }],
        "U+2014": [{
          "substitute": "-"
        }],
        "U+2015": [{
          "substitute": "—"
        }, {
          "substitute": "-"
        }],
        "U+066B": [{
          "substitute": ","
        }],
        "U+066C": [{
          "substitute": "'"
        }],
        "U+2018": [{
          "substitute": "'"
        }],
        "U+2019": [{
          "substitute": "'"
        }],
        "U+201A": [{
          "substitute": ","
        }],
        "U+201B": [{
          "substitute": "'"
        }],
        "U+201C": [{
          "substitute": "\\\""
        }],
        "U+201D": [{
          "substitute": "\\\""
        }],
        "U+201E": [{
          "substitute": ",,"
        }],
        "U+201F": [{
          "substitute": "\\\""
        }],
        "U+00AB": [{
          "substitute": "<<"
        }],
        "U+00BB": [{
          "substitute": ">>"
        }],
        "U+FF5F": [{
          "substitute": "(("
        }],
        "U+FF60": [{
          "substitute": "))"
        }],
        "U+2022": [{
          "substitute": "·"
        }],
        "U+2027": [{
          "substitute": "·"
        }],
        "U+05BE": [{
          "substitute": "‐"
        }, {
          "substitute": "-"
        }],
        "U+05F3": [{
          "substitute": "'"
        }],
        "U+05F4": [{
          "substitute": "\\\""
        }],
        "U+FFE3": [{
          "substitute": "¯"
        }],
        "U+00A9": [{
          "substitute": "(C)"
        }],
        "U+00AE": [{
          "substitute": "(R)"
        }],
        "U+211E": [{
          "substitute": "Rx"
        }],
        "U+220F": [{
          "substitute": "Π"
        }],
        "U+2211": [{
          "substitute": "Σ"
        }],
        "U+2212": [{
          "substitute": "-"
        }],
        "U+2215": [{
          "substitute": "/"
        }],
        "U+2044": [{
          "substitute": "/"
        }],
        "U+2216": [{
          "substitute": "\\\\"
        }],
        "U+2223": [{
          "substitute": "|"
        }],
        "U+2225": [{
          "substitute": "‖"
        }, {
          "substitute": "||"
        }],
        "U+058F": [{
          "substitute": "AMD"
        }],
        "U+060B": [{
          "substitute": "AFN"
        }],
        "U+09F3": [{
          "substitute": "BDT"
        }],
        "U+0E3F": [{
          "substitute": "THB"
        }],
        "U+17DB": [{
          "substitute": "KHR"
        }],
        "U+20A0": [{
          "substitute": "CE"
        }],
        "U+20A1": [{
          "substitute": "CRC"
        }],
        "U+20A2": [{
          "substitute": "Cr"
        }],
        "U+20A3": [{
          "substitute": "Fr."
        }],
        "U+20A4": [{
          "substitute": "L."
        }, {
          "substitute": "£"
        }],
        "U+20A6": [{
          "substitute": "NGN"
        }],
        "U+20A7": [{
          "substitute": "Pts"
        }],
        "U+20A9": [{
          "substitute": "KRW"
        }],
        "U+FFE6": [{
          "substitute": "KRW"
        }],
        "U+20AA": [{
          "substitute": "שח"
        }, {
          "substitute": "ILS"
        }],
        "U+20AB": [{
          "substitute": "đ"
        }, {
          "substitute": "VND"
        }],
        "U+20AC": [{
          "substitute": "EUR"
        }],
        "U+20AD": [{
          "substitute": "LAK"
        }],
        "U+20AE": [{
          "substitute": "MNT"
        }],
        "U+20AF": [{
          "substitute": "GRD"
        }],
        "U+20B1": [{
          "substitute": "PHP"
        }],
        "U+20B2": [{
          "substitute": "PYG"
        }],
        "U+20B4": [{
          "substitute": "UAH"
        }],
        "U+20B5": [{
          "substitute": "¢"
        }, {
          "substitute": "Ȼ"
        }, {
          "substitute": "GHS"
        }],
        "U+20B8": [{
          "substitute": "KZT"
        }],
        "U+20B9": [{
          "substitute": "INR"
        }],
        "U+20BA": [{
          "substitute": "TL"
        }],
        "U+20BC": [{
          "substitute": "AZN"
        }],
        "U+20BD": [{
          "substitute": "RUB"
        }],
        "U+20BE": [{
          "substitute": "GEL"
        }],
        "U+215F": [{
          "substitute": " 1/"
        }],
        "U+00BD": [{
          "substitute": " 1/2"
        }],
        "U+2153": [{
          "substitute": " 1/3"
        }],
        "U+00BC": [{
          "substitute": " 1/4"
        }],
        "U+2155": [{
          "substitute": " 1/5"
        }],
        "U+2159": [{
          "substitute": " 1/6"
        }],
        "U+215B": [{
          "substitute": " 1/8"
        }],
        "U+2154": [{
          "substitute": " 2/3"
        }],
        "U+2156": [{
          "substitute": " 2/5"
        }],
        "U+00BE": [{
          "substitute": " 3/4"
        }],
        "U+2157": [{
          "substitute": " 3/5"
        }],
        "U+215C": [{
          "substitute": " 3/8"
        }],
        "U+2158": [{
          "substitute": " 4/5"
        }],
        "U+215A": [{
          "substitute": " 5/6"
        }],
        "U+215D": [{
          "substitute": " 5/8"
        }],
        "U+215E": [{
          "substitute": " 7/8"
        }],
        "U+33DF": [{
          "substitute": "A/m"
        }],
        "U+00E6": [{
          "substitute": "ae"
        }],
        "U+00C6": [{
          "substitute": "AE"
        }],
        "U+33C6": [{
          "substitute": "C/kg"
        }],
        "U+33C4": [{
          "substitute": "CC"
        }],
        "U+33A0": [{
          "substitute": "cm²"
        }],
        "U+33A4": [{
          "substitute": "cm³"
        }],
        "U+3378": [{
          "substitute": "dm²"
        }],
        "U+3379": [{
          "substitute": "dm³"
        }],
        "U+33A2": [{
          "substitute": "km²"
        }],
        "U+33A6": [{
          "substitute": "km³"
        }],
        "U+33A7": [{
          "substitute": "m/s"
        }],
        "U+33A8": [{
          "substitute": "m∕s²"
        }, {
          "substitute": "m/s²"
        }],
        "U+33A1": [{
          "substitute": "m²"
        }],
        "U+33A5": [{
          "substitute": "m³"
        }],
        "U+339F": [{
          "substitute": "mm²"
        }],
        "U+33A3": [{
          "substitute": "mm³"
        }],
        "U+0153": [{
          "substitute": "oe"
        }],
        "U+0152": [{
          "substitute": "OE"
        }],
        "U+33D7": [{
          "substitute": "pH"
        }],
        "U+33AE": [{
          "substitute": "rad/s"
        }],
        "U+33AF": [{
          "substitute": "rad∕s²"
        }, {
          "substitute": "rad/s²"
        }],
        "U+0219": [{
          "substitute": "ş"
        }],
        "U+0218": [{
          "substitute": "Ş"
        }],
        "U+00DF": [{
          "substitute": "ss"
        }],
        "U+FB05": [{
          "substitute": "ſt"
        }],
        "U+021B": [{
          "substitute": "ţ"
        }],
        "U+021A": [{
          "substitute": "Ţ"
        }],
        "U+33DE": [{
          "substitute": "V/m"
        }],
        "U+0149": [{
          "substitute": "'n"
        }],
        "U+FFA1": [{
          "substitute": "ㄱ"
        }],
        "U+FFA2": [{
          "substitute": "ㄲ"
        }],
        "U+FFA4": [{
          "substitute": "ㄴ"
        }],
        "U+FFA7": [{
          "substitute": "ㄷ"
        }],
        "U+FFA8": [{
          "substitute": "ㄸ"
        }],
        "U+FFA9": [{
          "substitute": "ㄹ"
        }],
        "U+FFB1": [{
          "substitute": "ㅁ"
        }],
        "U+FFB2": [{
          "substitute": "ㅂ"
        }],
        "U+FFB3": [{
          "substitute": "ㅃ"
        }],
        "U+FFB5": [{
          "substitute": "ㅅ"
        }],
        "U+FFB6": [{
          "substitute": "ㅆ"
        }],
        "U+FFB7": [{
          "substitute": "ㅇ"
        }],
        "U+FFB8": [{
          "substitute": "ㅈ"
        }],
        "U+FFB9": [{
          "substitute": "ㅉ"
        }],
        "U+FFBA": [{
          "substitute": "ㅊ"
        }],
        "U+FFBB": [{
          "substitute": "ㅋ"
        }],
        "U+FFBC": [{
          "substitute": "ㅌ"
        }],
        "U+FFBD": [{
          "substitute": "ㅍ"
        }],
        "U+FFBE": [{
          "substitute": "ㅎ"
        }],
        "U+FFB0": [{
          "substitute": "ㅀ"
        }],
        "U+FFB4": [{
          "substitute": "ㅄ"
        }],
        "U+FFA0": [{
          "substitute": "ㅤ"
        }],
        "U+FFC2": [{
          "substitute": "ㅏ"
        }],
        "U+FFC3": [{
          "substitute": "ㅐ"
        }],
        "U+FFC4": [{
          "substitute": "ㅑ"
        }],
        "U+FFC5": [{
          "substitute": "ㅒ"
        }],
        "U+FFC6": [{
          "substitute": "ㅓ"
        }],
        "U+FFC7": [{
          "substitute": "ㅔ"
        }],
        "U+FFCA": [{
          "substitute": "ㅕ"
        }],
        "U+FFCB": [{
          "substitute": "ㅖ"
        }],
        "U+FFCC": [{
          "substitute": "ㅗ"
        }],
        "U+FFCD": [{
          "substitute": "ㅘ"
        }],
        "U+FFCE": [{
          "substitute": "ㅙ"
        }],
        "U+FFCF": [{
          "substitute": "ㅚ"
        }],
        "U+FFD2": [{
          "substitute": "ㅛ"
        }],
        "U+FFD3": [{
          "substitute": "ㅜ"
        }],
        "U+FFD4": [{
          "substitute": "ㅝ"
        }],
        "U+FFD5": [{
          "substitute": "ㅞ"
        }],
        "U+FFD6": [{
          "substitute": "ㅟ"
        }],
        "U+FFD7": [{
          "substitute": "ㅠ"
        }],
        "U+FFDA": [{
          "substitute": "ㅡ"
        }],
        "U+FFDB": [{
          "substitute": "ㅢ"
        }],
        "U+FFDC": [{
          "substitute": "ㅣ"
        }],
        "U+FFA3": [{
          "substitute": "ㄳ"
        }],
        "U+FFA5": [{
          "substitute": "ㄵ"
        }],
        "U+FFA6": [{
          "substitute": "ㄶ"
        }],
        "U+FFAA": [{
          "substitute": "ㄺ"
        }],
        "U+FFAB": [{
          "substitute": "ㄻ"
        }],
        "U+FFAC": [{
          "substitute": "ㄼ"
        }],
        "U+FFAD": [{
          "substitute": "ㄽ"
        }],
        "U+FFAE": [{
          "substitute": "ㄾ"
        }],
        "U+FFAF": [{
          "substitute": "ㄿ"
        }]
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "codeMappings": {
      "AA": {
        "_numeric": "958",
        "_alpha3": "AAA"
      },
      "AC": {
        "_alpha3": "ASC"
      },
      "AD": {
        "_numeric": "020",
        "_alpha3": "AND",
        "_fips10": "AN"
      },
      "AE": {
        "_numeric": "784",
        "_alpha3": "ARE"
      },
      "AF": {
        "_numeric": "004",
        "_alpha3": "AFG"
      },
      "AG": {
        "_numeric": "028",
        "_alpha3": "ATG",
        "_fips10": "AC"
      },
      "AI": {
        "_numeric": "660",
        "_alpha3": "AIA",
        "_fips10": "AV"
      },
      "AL": {
        "_numeric": "008",
        "_alpha3": "ALB"
      },
      "AM": {
        "_numeric": "051",
        "_alpha3": "ARM"
      },
      "AN": {
        "_numeric": "530",
        "_alpha3": "ANT",
        "_fips10": "NT"
      },
      "AO": {
        "_numeric": "024",
        "_alpha3": "AGO"
      },
      "AQ": {
        "_numeric": "010",
        "_alpha3": "ATA",
        "_fips10": "AY"
      },
      "AR": {
        "_numeric": "032",
        "_alpha3": "ARG"
      },
      "AS": {
        "_numeric": "016",
        "_alpha3": "ASM",
        "_fips10": "AQ"
      },
      "AT": {
        "_numeric": "040",
        "_alpha3": "AUT",
        "_fips10": "AU"
      },
      "AU": {
        "_numeric": "036",
        "_alpha3": "AUS",
        "_fips10": "AS"
      },
      "AW": {
        "_numeric": "533",
        "_alpha3": "ABW",
        "_fips10": "AA"
      },
      "AX": {
        "_numeric": "248",
        "_alpha3": "ALA"
      },
      "AZ": {
        "_numeric": "031",
        "_alpha3": "AZE",
        "_fips10": "AJ"
      },
      "BA": {
        "_numeric": "070",
        "_alpha3": "BIH",
        "_fips10": "BK"
      },
      "BB": {
        "_numeric": "052",
        "_alpha3": "BRB"
      },
      "BD": {
        "_numeric": "050",
        "_alpha3": "BGD",
        "_fips10": "BG"
      },
      "BE": {
        "_numeric": "056",
        "_alpha3": "BEL"
      },
      "BF": {
        "_numeric": "854",
        "_alpha3": "BFA",
        "_fips10": "UV"
      },
      "BG": {
        "_numeric": "100",
        "_alpha3": "BGR",
        "_fips10": "BU"
      },
      "BH": {
        "_numeric": "048",
        "_alpha3": "BHR",
        "_fips10": "BA"
      },
      "BI": {
        "_numeric": "108",
        "_alpha3": "BDI",
        "_fips10": "BY"
      },
      "BJ": {
        "_numeric": "204",
        "_alpha3": "BEN",
        "_fips10": "BN"
      },
      "BL": {
        "_numeric": "652",
        "_alpha3": "BLM",
        "_fips10": "TB"
      },
      "BM": {
        "_numeric": "060",
        "_alpha3": "BMU",
        "_fips10": "BD"
      },
      "BN": {
        "_numeric": "096",
        "_alpha3": "BRN",
        "_fips10": "BX"
      },
      "BO": {
        "_numeric": "068",
        "_alpha3": "BOL",
        "_fips10": "BL"
      },
      "BQ": {
        "_numeric": "535",
        "_alpha3": "BES"
      },
      "BR": {
        "_numeric": "076",
        "_alpha3": "BRA"
      },
      "BS": {
        "_numeric": "044",
        "_alpha3": "BHS",
        "_fips10": "BF"
      },
      "BT": {
        "_numeric": "064",
        "_alpha3": "BTN"
      },
      "BU": {
        "_numeric": "104",
        "_alpha3": "BUR"
      },
      "BV": {
        "_numeric": "074",
        "_alpha3": "BVT"
      },
      "BW": {
        "_numeric": "072",
        "_alpha3": "BWA",
        "_fips10": "BC"
      },
      "BY": {
        "_numeric": "112",
        "_alpha3": "BLR",
        "_fips10": "BO"
      },
      "BZ": {
        "_numeric": "084",
        "_alpha3": "BLZ",
        "_fips10": "BH"
      },
      "CA": {
        "_numeric": "124",
        "_alpha3": "CAN"
      },
      "CC": {
        "_numeric": "166",
        "_alpha3": "CCK",
        "_fips10": "CK"
      },
      "CD": {
        "_numeric": "180",
        "_alpha3": "COD",
        "_fips10": "CG"
      },
      "CF": {
        "_numeric": "140",
        "_alpha3": "CAF",
        "_fips10": "CT"
      },
      "CG": {
        "_numeric": "178",
        "_alpha3": "COG",
        "_fips10": "CF"
      },
      "CH": {
        "_numeric": "756",
        "_alpha3": "CHE",
        "_fips10": "SZ"
      },
      "CI": {
        "_numeric": "384",
        "_alpha3": "CIV",
        "_fips10": "IV"
      },
      "CK": {
        "_numeric": "184",
        "_alpha3": "COK",
        "_fips10": "CW"
      },
      "CL": {
        "_numeric": "152",
        "_alpha3": "CHL",
        "_fips10": "CI"
      },
      "CM": {
        "_numeric": "120",
        "_alpha3": "CMR"
      },
      "CN": {
        "_numeric": "156",
        "_alpha3": "CHN",
        "_fips10": "CH"
      },
      "CO": {
        "_numeric": "170",
        "_alpha3": "COL"
      },
      "CP": {
        "_alpha3": "CPT"
      },
      "CR": {
        "_numeric": "188",
        "_alpha3": "CRI",
        "_fips10": "CS"
      },
      "CS": {
        "_numeric": "891",
        "_alpha3": "SCG",
        "_fips10": "YI"
      },
      "CU": {
        "_numeric": "192",
        "_alpha3": "CUB"
      },
      "CV": {
        "_numeric": "132",
        "_alpha3": "CPV"
      },
      "CW": {
        "_numeric": "531",
        "_alpha3": "CUW"
      },
      "CX": {
        "_numeric": "162",
        "_alpha3": "CXR",
        "_fips10": "KT"
      },
      "CY": {
        "_numeric": "196",
        "_alpha3": "CYP"
      },
      "CZ": {
        "_numeric": "203",
        "_alpha3": "CZE",
        "_fips10": "EZ"
      },
      "DD": {
        "_numeric": "278",
        "_alpha3": "DDR"
      },
      "DE": {
        "_numeric": "276",
        "_alpha3": "DEU",
        "_fips10": "GM"
      },
      "DG": {
        "_alpha3": "DGA"
      },
      "DJ": {
        "_numeric": "262",
        "_alpha3": "DJI"
      },
      "DK": {
        "_numeric": "208",
        "_alpha3": "DNK",
        "_fips10": "DA"
      },
      "DM": {
        "_numeric": "212",
        "_alpha3": "DMA",
        "_fips10": "DO"
      },
      "DO": {
        "_numeric": "214",
        "_alpha3": "DOM",
        "_fips10": "DR"
      },
      "DZ": {
        "_numeric": "012",
        "_alpha3": "DZA",
        "_fips10": "AG"
      },
      "EA": {},
      "EC": {
        "_numeric": "218",
        "_alpha3": "ECU"
      },
      "EE": {
        "_numeric": "233",
        "_alpha3": "EST",
        "_fips10": "EN"
      },
      "EG": {
        "_numeric": "818",
        "_alpha3": "EGY"
      },
      "EH": {
        "_numeric": "732",
        "_alpha3": "ESH",
        "_fips10": "WI"
      },
      "ER": {
        "_numeric": "232",
        "_alpha3": "ERI"
      },
      "ES": {
        "_numeric": "724",
        "_alpha3": "ESP",
        "_fips10": "SP"
      },
      "ET": {
        "_numeric": "231",
        "_alpha3": "ETH"
      },
      "EU": {
        "_numeric": "967",
        "_alpha3": "QUU"
      },
      "FI": {
        "_numeric": "246",
        "_alpha3": "FIN"
      },
      "FJ": {
        "_numeric": "242",
        "_alpha3": "FJI"
      },
      "FK": {
        "_numeric": "238",
        "_alpha3": "FLK"
      },
      "FM": {
        "_numeric": "583",
        "_alpha3": "FSM"
      },
      "FO": {
        "_numeric": "234",
        "_alpha3": "FRO"
      },
      "FR": {
        "_numeric": "250",
        "_alpha3": "FRA"
      },
      "FX": {
        "_numeric": "249",
        "_alpha3": "FXX"
      },
      "GA": {
        "_numeric": "266",
        "_alpha3": "GAB",
        "_fips10": "GB"
      },
      "GB": {
        "_numeric": "826",
        "_alpha3": "GBR",
        "_fips10": "UK"
      },
      "GD": {
        "_numeric": "308",
        "_alpha3": "GRD",
        "_fips10": "GJ"
      },
      "GE": {
        "_numeric": "268",
        "_alpha3": "GEO",
        "_fips10": "GG"
      },
      "GF": {
        "_numeric": "254",
        "_alpha3": "GUF",
        "_fips10": "FG"
      },
      "GG": {
        "_numeric": "831",
        "_alpha3": "GGY",
        "_fips10": "GK"
      },
      "GH": {
        "_numeric": "288",
        "_alpha3": "GHA"
      },
      "GI": {
        "_numeric": "292",
        "_alpha3": "GIB"
      },
      "GL": {
        "_numeric": "304",
        "_alpha3": "GRL"
      },
      "GM": {
        "_numeric": "270",
        "_alpha3": "GMB",
        "_fips10": "GA"
      },
      "GN": {
        "_numeric": "324",
        "_alpha3": "GIN",
        "_fips10": "GV"
      },
      "GP": {
        "_numeric": "312",
        "_alpha3": "GLP"
      },
      "GQ": {
        "_numeric": "226",
        "_alpha3": "GNQ",
        "_fips10": "EK"
      },
      "GR": {
        "_numeric": "300",
        "_alpha3": "GRC"
      },
      "GS": {
        "_numeric": "239",
        "_alpha3": "SGS",
        "_fips10": "SX"
      },
      "GT": {
        "_numeric": "320",
        "_alpha3": "GTM"
      },
      "GU": {
        "_numeric": "316",
        "_alpha3": "GUM",
        "_fips10": "GQ"
      },
      "GW": {
        "_numeric": "624",
        "_alpha3": "GNB",
        "_fips10": "PU"
      },
      "GY": {
        "_numeric": "328",
        "_alpha3": "GUY"
      },
      "HK": {
        "_numeric": "344",
        "_alpha3": "HKG"
      },
      "HM": {
        "_numeric": "334",
        "_alpha3": "HMD"
      },
      "HN": {
        "_numeric": "340",
        "_alpha3": "HND",
        "_fips10": "HO"
      },
      "HR": {
        "_numeric": "191",
        "_alpha3": "HRV"
      },
      "HT": {
        "_numeric": "332",
        "_alpha3": "HTI",
        "_fips10": "HA"
      },
      "HU": {
        "_numeric": "348",
        "_alpha3": "HUN"
      },
      "IC": {},
      "ID": {
        "_numeric": "360",
        "_alpha3": "IDN"
      },
      "IE": {
        "_numeric": "372",
        "_alpha3": "IRL",
        "_fips10": "EI"
      },
      "IL": {
        "_numeric": "376",
        "_alpha3": "ISR",
        "_fips10": "IS"
      },
      "IM": {
        "_numeric": "833",
        "_alpha3": "IMN"
      },
      "IN": {
        "_numeric": "356",
        "_alpha3": "IND"
      },
      "IO": {
        "_numeric": "086",
        "_alpha3": "IOT"
      },
      "IQ": {
        "_numeric": "368",
        "_alpha3": "IRQ",
        "_fips10": "IZ"
      },
      "IR": {
        "_numeric": "364",
        "_alpha3": "IRN"
      },
      "IS": {
        "_numeric": "352",
        "_alpha3": "ISL",
        "_fips10": "IC"
      },
      "IT": {
        "_numeric": "380",
        "_alpha3": "ITA"
      },
      "JE": {
        "_numeric": "832",
        "_alpha3": "JEY"
      },
      "JM": {
        "_numeric": "388",
        "_alpha3": "JAM"
      },
      "JO": {
        "_numeric": "400",
        "_alpha3": "JOR"
      },
      "JP": {
        "_numeric": "392",
        "_alpha3": "JPN",
        "_fips10": "JA"
      },
      "KE": {
        "_numeric": "404",
        "_alpha3": "KEN"
      },
      "KG": {
        "_numeric": "417",
        "_alpha3": "KGZ"
      },
      "KH": {
        "_numeric": "116",
        "_alpha3": "KHM",
        "_fips10": "CB"
      },
      "KI": {
        "_numeric": "296",
        "_alpha3": "KIR",
        "_fips10": "KR"
      },
      "KM": {
        "_numeric": "174",
        "_alpha3": "COM",
        "_fips10": "CN"
      },
      "KN": {
        "_numeric": "659",
        "_alpha3": "KNA",
        "_fips10": "SC"
      },
      "KP": {
        "_numeric": "408",
        "_alpha3": "PRK",
        "_fips10": "KN"
      },
      "KR": {
        "_numeric": "410",
        "_alpha3": "KOR",
        "_fips10": "KS"
      },
      "KW": {
        "_numeric": "414",
        "_alpha3": "KWT",
        "_fips10": "KU"
      },
      "KY": {
        "_numeric": "136",
        "_alpha3": "CYM",
        "_fips10": "CJ"
      },
      "KZ": {
        "_numeric": "398",
        "_alpha3": "KAZ"
      },
      "LA": {
        "_numeric": "418",
        "_alpha3": "LAO"
      },
      "LB": {
        "_numeric": "422",
        "_alpha3": "LBN",
        "_fips10": "LE"
      },
      "LC": {
        "_numeric": "662",
        "_alpha3": "LCA",
        "_fips10": "ST"
      },
      "LI": {
        "_numeric": "438",
        "_alpha3": "LIE",
        "_fips10": "LS"
      },
      "LK": {
        "_numeric": "144",
        "_alpha3": "LKA",
        "_fips10": "CE"
      },
      "LR": {
        "_numeric": "430",
        "_alpha3": "LBR",
        "_fips10": "LI"
      },
      "LS": {
        "_numeric": "426",
        "_alpha3": "LSO",
        "_fips10": "LT"
      },
      "LT": {
        "_numeric": "440",
        "_alpha3": "LTU",
        "_fips10": "LH"
      },
      "LU": {
        "_numeric": "442",
        "_alpha3": "LUX"
      },
      "LV": {
        "_numeric": "428",
        "_alpha3": "LVA",
        "_fips10": "LG"
      },
      "LY": {
        "_numeric": "434",
        "_alpha3": "LBY"
      },
      "MA": {
        "_numeric": "504",
        "_alpha3": "MAR",
        "_fips10": "MO"
      },
      "MC": {
        "_numeric": "492",
        "_alpha3": "MCO",
        "_fips10": "MN"
      },
      "MD": {
        "_numeric": "498",
        "_alpha3": "MDA"
      },
      "ME": {
        "_numeric": "499",
        "_alpha3": "MNE",
        "_fips10": "MJ"
      },
      "MF": {
        "_numeric": "663",
        "_alpha3": "MAF",
        "_fips10": "RN"
      },
      "MG": {
        "_numeric": "450",
        "_alpha3": "MDG",
        "_fips10": "MA"
      },
      "MH": {
        "_numeric": "584",
        "_alpha3": "MHL",
        "_fips10": "RM"
      },
      "MK": {
        "_numeric": "807",
        "_alpha3": "MKD"
      },
      "ML": {
        "_numeric": "466",
        "_alpha3": "MLI"
      },
      "MM": {
        "_numeric": "104",
        "_alpha3": "MMR",
        "_fips10": "BM"
      },
      "MN": {
        "_numeric": "496",
        "_alpha3": "MNG",
        "_fips10": "MG"
      },
      "MO": {
        "_numeric": "446",
        "_alpha3": "MAC",
        "_fips10": "MC"
      },
      "MP": {
        "_numeric": "580",
        "_alpha3": "MNP",
        "_fips10": "CQ"
      },
      "MQ": {
        "_numeric": "474",
        "_alpha3": "MTQ",
        "_fips10": "MB"
      },
      "MR": {
        "_numeric": "478",
        "_alpha3": "MRT"
      },
      "MS": {
        "_numeric": "500",
        "_alpha3": "MSR",
        "_fips10": "MH"
      },
      "MT": {
        "_numeric": "470",
        "_alpha3": "MLT"
      },
      "MU": {
        "_numeric": "480",
        "_alpha3": "MUS",
        "_fips10": "MP"
      },
      "MV": {
        "_numeric": "462",
        "_alpha3": "MDV"
      },
      "MW": {
        "_numeric": "454",
        "_alpha3": "MWI",
        "_fips10": "MI"
      },
      "MX": {
        "_numeric": "484",
        "_alpha3": "MEX"
      },
      "MY": {
        "_numeric": "458",
        "_alpha3": "MYS"
      },
      "MZ": {
        "_numeric": "508",
        "_alpha3": "MOZ"
      },
      "NA": {
        "_numeric": "516",
        "_alpha3": "NAM",
        "_fips10": "WA"
      },
      "NC": {
        "_numeric": "540",
        "_alpha3": "NCL"
      },
      "NE": {
        "_numeric": "562",
        "_alpha3": "NER",
        "_fips10": "NG"
      },
      "NF": {
        "_numeric": "574",
        "_alpha3": "NFK"
      },
      "NG": {
        "_numeric": "566",
        "_alpha3": "NGA",
        "_fips10": "NI"
      },
      "NI": {
        "_numeric": "558",
        "_alpha3": "NIC",
        "_fips10": "NU"
      },
      "NL": {
        "_numeric": "528",
        "_alpha3": "NLD"
      },
      "NO": {
        "_numeric": "578",
        "_alpha3": "NOR"
      },
      "NP": {
        "_numeric": "524",
        "_alpha3": "NPL"
      },
      "NR": {
        "_numeric": "520",
        "_alpha3": "NRU"
      },
      "NT": {
        "_numeric": "536",
        "_alpha3": "NTZ"
      },
      "NU": {
        "_numeric": "570",
        "_alpha3": "NIU",
        "_fips10": "NE"
      },
      "NZ": {
        "_numeric": "554",
        "_alpha3": "NZL"
      },
      "OM": {
        "_numeric": "512",
        "_alpha3": "OMN",
        "_fips10": "MU"
      },
      "PA": {
        "_numeric": "591",
        "_alpha3": "PAN",
        "_fips10": "PM"
      },
      "PE": {
        "_numeric": "604",
        "_alpha3": "PER"
      },
      "PF": {
        "_numeric": "258",
        "_alpha3": "PYF",
        "_fips10": "FP"
      },
      "PG": {
        "_numeric": "598",
        "_alpha3": "PNG",
        "_fips10": "PP"
      },
      "PH": {
        "_numeric": "608",
        "_alpha3": "PHL",
        "_fips10": "RP"
      },
      "PK": {
        "_numeric": "586",
        "_alpha3": "PAK"
      },
      "PL": {
        "_numeric": "616",
        "_alpha3": "POL"
      },
      "PM": {
        "_numeric": "666",
        "_alpha3": "SPM",
        "_fips10": "SB"
      },
      "PN": {
        "_numeric": "612",
        "_alpha3": "PCN",
        "_fips10": "PC"
      },
      "PR": {
        "_numeric": "630",
        "_alpha3": "PRI",
        "_fips10": "RQ"
      },
      "PS": {
        "_numeric": "275",
        "_alpha3": "PSE",
        "_fips10": "GZ"
      },
      "PT": {
        "_numeric": "620",
        "_alpha3": "PRT",
        "_fips10": "PO"
      },
      "PW": {
        "_numeric": "585",
        "_alpha3": "PLW",
        "_fips10": "PS"
      },
      "PY": {
        "_numeric": "600",
        "_alpha3": "PRY",
        "_fips10": "PA"
      },
      "QA": {
        "_numeric": "634",
        "_alpha3": "QAT"
      },
      "QM": {
        "_numeric": "959",
        "_alpha3": "QMM"
      },
      "QN": {
        "_numeric": "960",
        "_alpha3": "QNN"
      },
      "QO": {
        "_numeric": "961",
        "_alpha3": "QOO"
      },
      "QP": {
        "_numeric": "962",
        "_alpha3": "QPP"
      },
      "QQ": {
        "_numeric": "963",
        "_alpha3": "QQQ"
      },
      "QR": {
        "_numeric": "964",
        "_alpha3": "QRR"
      },
      "QS": {
        "_numeric": "965",
        "_alpha3": "QSS"
      },
      "QT": {
        "_numeric": "966",
        "_alpha3": "QTT"
      },
      "QU": {
        "_numeric": "967",
        "_alpha3": "QUU"
      },
      "QV": {
        "_numeric": "968",
        "_alpha3": "QVV"
      },
      "QW": {
        "_numeric": "969",
        "_alpha3": "QWW"
      },
      "QX": {
        "_numeric": "970",
        "_alpha3": "QXX"
      },
      "QY": {
        "_numeric": "971",
        "_alpha3": "QYY"
      },
      "QZ": {
        "_numeric": "972",
        "_alpha3": "QZZ"
      },
      "RE": {
        "_numeric": "638",
        "_alpha3": "REU"
      },
      "RO": {
        "_numeric": "642",
        "_alpha3": "ROU"
      },
      "RS": {
        "_numeric": "688",
        "_alpha3": "SRB",
        "_fips10": "RB"
      },
      "RU": {
        "_numeric": "643",
        "_alpha3": "RUS",
        "_fips10": "RS"
      },
      "RW": {
        "_numeric": "646",
        "_alpha3": "RWA"
      },
      "SA": {
        "_numeric": "682",
        "_alpha3": "SAU"
      },
      "SB": {
        "_numeric": "090",
        "_alpha3": "SLB",
        "_fips10": "BP"
      },
      "SC": {
        "_numeric": "690",
        "_alpha3": "SYC",
        "_fips10": "SE"
      },
      "SD": {
        "_numeric": "729",
        "_alpha3": "SDN",
        "_fips10": "SU"
      },
      "SE": {
        "_numeric": "752",
        "_alpha3": "SWE",
        "_fips10": "SW"
      },
      "SG": {
        "_numeric": "702",
        "_alpha3": "SGP",
        "_fips10": "SN"
      },
      "SH": {
        "_numeric": "654",
        "_alpha3": "SHN"
      },
      "SI": {
        "_numeric": "705",
        "_alpha3": "SVN"
      },
      "SJ": {
        "_numeric": "744",
        "_alpha3": "SJM",
        "_fips10": "SV"
      },
      "SK": {
        "_numeric": "703",
        "_alpha3": "SVK",
        "_fips10": "LO"
      },
      "SL": {
        "_numeric": "694",
        "_alpha3": "SLE"
      },
      "SM": {
        "_numeric": "674",
        "_alpha3": "SMR"
      },
      "SN": {
        "_numeric": "686",
        "_alpha3": "SEN",
        "_fips10": "SG"
      },
      "SO": {
        "_numeric": "706",
        "_alpha3": "SOM"
      },
      "SR": {
        "_numeric": "740",
        "_alpha3": "SUR",
        "_fips10": "NS"
      },
      "SS": {
        "_numeric": "728",
        "_alpha3": "SSD"
      },
      "ST": {
        "_numeric": "678",
        "_alpha3": "STP",
        "_fips10": "TP"
      },
      "SU": {
        "_numeric": "810",
        "_alpha3": "SUN"
      },
      "SV": {
        "_numeric": "222",
        "_alpha3": "SLV",
        "_fips10": "ES"
      },
      "SX": {
        "_numeric": "534",
        "_alpha3": "SXM"
      },
      "SY": {
        "_numeric": "760",
        "_alpha3": "SYR"
      },
      "SZ": {
        "_numeric": "748",
        "_alpha3": "SWZ",
        "_fips10": "WZ"
      },
      "TA": {
        "_alpha3": "TAA"
      },
      "TC": {
        "_numeric": "796",
        "_alpha3": "TCA",
        "_fips10": "TK"
      },
      "TD": {
        "_numeric": "148",
        "_alpha3": "TCD",
        "_fips10": "CD"
      },
      "TF": {
        "_numeric": "260",
        "_alpha3": "ATF",
        "_fips10": "FS"
      },
      "TG": {
        "_numeric": "768",
        "_alpha3": "TGO",
        "_fips10": "TO"
      },
      "TH": {
        "_numeric": "764",
        "_alpha3": "THA"
      },
      "TJ": {
        "_numeric": "762",
        "_alpha3": "TJK",
        "_fips10": "TI"
      },
      "TK": {
        "_numeric": "772",
        "_alpha3": "TKL",
        "_fips10": "TL"
      },
      "TL": {
        "_numeric": "626",
        "_alpha3": "TLS",
        "_fips10": "TT"
      },
      "TM": {
        "_numeric": "795",
        "_alpha3": "TKM",
        "_fips10": "TX"
      },
      "TN": {
        "_numeric": "788",
        "_alpha3": "TUN",
        "_fips10": "TS"
      },
      "TO": {
        "_numeric": "776",
        "_alpha3": "TON",
        "_fips10": "TN"
      },
      "TP": {
        "_numeric": "626",
        "_alpha3": "TMP"
      },
      "TR": {
        "_numeric": "792",
        "_alpha3": "TUR",
        "_fips10": "TU"
      },
      "TT": {
        "_numeric": "780",
        "_alpha3": "TTO",
        "_fips10": "TD"
      },
      "TV": {
        "_numeric": "798",
        "_alpha3": "TUV"
      },
      "TW": {
        "_numeric": "158",
        "_alpha3": "TWN"
      },
      "TZ": {
        "_numeric": "834",
        "_alpha3": "TZA"
      },
      "UA": {
        "_numeric": "804",
        "_alpha3": "UKR",
        "_fips10": "UP"
      },
      "UG": {
        "_numeric": "800",
        "_alpha3": "UGA"
      },
      "UM": {
        "_numeric": "581",
        "_alpha3": "UMI"
      },
      "US": {
        "_numeric": "840",
        "_alpha3": "USA"
      },
      "UY": {
        "_numeric": "858",
        "_alpha3": "URY"
      },
      "UZ": {
        "_numeric": "860",
        "_alpha3": "UZB"
      },
      "VA": {
        "_numeric": "336",
        "_alpha3": "VAT",
        "_fips10": "VT"
      },
      "VC": {
        "_numeric": "670",
        "_alpha3": "VCT"
      },
      "VE": {
        "_numeric": "862",
        "_alpha3": "VEN"
      },
      "VG": {
        "_numeric": "092",
        "_alpha3": "VGB",
        "_fips10": "VI"
      },
      "VI": {
        "_numeric": "850",
        "_alpha3": "VIR",
        "_fips10": "VQ"
      },
      "VN": {
        "_numeric": "704",
        "_alpha3": "VNM",
        "_fips10": "VM"
      },
      "VU": {
        "_numeric": "548",
        "_alpha3": "VUT",
        "_fips10": "NH"
      },
      "WF": {
        "_numeric": "876",
        "_alpha3": "WLF"
      },
      "WS": {
        "_numeric": "882",
        "_alpha3": "WSM"
      },
      "XA": {
        "_numeric": "973",
        "_alpha3": "XAA"
      },
      "XB": {
        "_numeric": "974",
        "_alpha3": "XBB"
      },
      "XC": {
        "_numeric": "975",
        "_alpha3": "XCC"
      },
      "XD": {
        "_numeric": "976",
        "_alpha3": "XDD"
      },
      "XE": {
        "_numeric": "977",
        "_alpha3": "XEE"
      },
      "XF": {
        "_numeric": "978",
        "_alpha3": "XFF"
      },
      "XG": {
        "_numeric": "979",
        "_alpha3": "XGG"
      },
      "XH": {
        "_numeric": "980",
        "_alpha3": "XHH"
      },
      "XI": {
        "_numeric": "981",
        "_alpha3": "XII"
      },
      "XJ": {
        "_numeric": "982",
        "_alpha3": "XJJ"
      },
      "XK": {
        "_numeric": "983",
        "_alpha3": "XKK"
      },
      "XL": {
        "_numeric": "984",
        "_alpha3": "XLL"
      },
      "XM": {
        "_numeric": "985",
        "_alpha3": "XMM"
      },
      "XN": {
        "_numeric": "986",
        "_alpha3": "XNN"
      },
      "XO": {
        "_numeric": "987",
        "_alpha3": "XOO"
      },
      "XP": {
        "_numeric": "988",
        "_alpha3": "XPP"
      },
      "XQ": {
        "_numeric": "989",
        "_alpha3": "XQQ"
      },
      "XR": {
        "_numeric": "990",
        "_alpha3": "XRR"
      },
      "XS": {
        "_numeric": "991",
        "_alpha3": "XSS"
      },
      "XT": {
        "_numeric": "992",
        "_alpha3": "XTT"
      },
      "XU": {
        "_numeric": "993",
        "_alpha3": "XUU"
      },
      "XV": {
        "_numeric": "994",
        "_alpha3": "XVV"
      },
      "XW": {
        "_numeric": "995",
        "_alpha3": "XWW"
      },
      "XX": {
        "_numeric": "996",
        "_alpha3": "XXX"
      },
      "XY": {
        "_numeric": "997",
        "_alpha3": "XYY"
      },
      "XZ": {
        "_numeric": "998",
        "_alpha3": "XZZ"
      },
      "YD": {
        "_numeric": "720",
        "_alpha3": "YMD"
      },
      "YE": {
        "_numeric": "887",
        "_alpha3": "YEM",
        "_fips10": "YM"
      },
      "YT": {
        "_numeric": "175",
        "_alpha3": "MYT",
        "_fips10": "MF"
      },
      "YU": {
        "_numeric": "891",
        "_alpha3": "YUG"
      },
      "ZA": {
        "_numeric": "710",
        "_alpha3": "ZAF",
        "_fips10": "SF"
      },
      "ZM": {
        "_numeric": "894",
        "_alpha3": "ZMB",
        "_fips10": "ZA"
      },
      "ZR": {
        "_numeric": "180",
        "_alpha3": "ZAR"
      },
      "ZW": {
        "_numeric": "716",
        "_alpha3": "ZWE",
        "_fips10": "ZI"
      },
      "ZZ": {
        "_numeric": "999",
        "_alpha3": "ZZZ"
      },
      "AED": {
        "_numeric": "784"
      },
      "AFN": {
        "_numeric": "971"
      },
      "ALL": {
        "_numeric": "8"
      },
      "AMD": {
        "_numeric": "51"
      },
      "ANG": {
        "_numeric": "532"
      },
      "AOA": {
        "_numeric": "973"
      },
      "ARS": {
        "_numeric": "32"
      },
      "AUD": {
        "_numeric": "36"
      },
      "AWG": {
        "_numeric": "533"
      },
      "AZN": {
        "_numeric": "944"
      },
      "BAM": {
        "_numeric": "977"
      },
      "BBD": {
        "_numeric": "52"
      },
      "BDT": {
        "_numeric": "50"
      },
      "BGN": {
        "_numeric": "975"
      },
      "BHD": {
        "_numeric": "48"
      },
      "BIF": {
        "_numeric": "108"
      },
      "BMD": {
        "_numeric": "60"
      },
      "BND": {
        "_numeric": "96"
      },
      "BOB": {
        "_numeric": "68"
      },
      "BOV": {
        "_numeric": "984"
      },
      "BRL": {
        "_numeric": "986"
      },
      "BSD": {
        "_numeric": "44"
      },
      "BTN": {
        "_numeric": "64"
      },
      "BWP": {
        "_numeric": "72"
      },
      "BYR": {
        "_numeric": "974"
      },
      "BZD": {
        "_numeric": "84"
      },
      "CAD": {
        "_numeric": "124"
      },
      "CDF": {
        "_numeric": "976"
      },
      "CHE": {
        "_numeric": "947"
      },
      "CHF": {
        "_numeric": "756"
      },
      "CHW": {
        "_numeric": "948"
      },
      "CLF": {
        "_numeric": "990"
      },
      "CLP": {
        "_numeric": "152"
      },
      "CNH": {
        "_numeric": "156"
      },
      "CNY": {
        "_numeric": "156"
      },
      "COP": {
        "_numeric": "170"
      },
      "COU": {
        "_numeric": "970"
      },
      "CRC": {
        "_numeric": "188"
      },
      "CUC": {
        "_numeric": "931"
      },
      "CUP": {
        "_numeric": "192"
      },
      "CVE": {
        "_numeric": "132"
      },
      "CZK": {
        "_numeric": "203"
      },
      "DJF": {
        "_numeric": "262"
      },
      "DKK": {
        "_numeric": "208"
      },
      "DOP": {
        "_numeric": "214"
      },
      "DZD": {
        "_numeric": "12"
      },
      "EGP": {
        "_numeric": "818"
      },
      "ERN": {
        "_numeric": "232"
      },
      "ETB": {
        "_numeric": "230"
      },
      "EUR": {
        "_numeric": "978"
      },
      "FJD": {
        "_numeric": "242"
      },
      "FKP": {
        "_numeric": "238"
      },
      "GBP": {
        "_numeric": "826"
      },
      "GEL": {
        "_numeric": "981"
      },
      "GHS": {
        "_numeric": "936"
      },
      "GIP": {
        "_numeric": "292"
      },
      "GMD": {
        "_numeric": "270"
      },
      "GNF": {
        "_numeric": "324"
      },
      "GTQ": {
        "_numeric": "320"
      },
      "GYD": {
        "_numeric": "328"
      },
      "HKD": {
        "_numeric": "344"
      },
      "HNL": {
        "_numeric": "340"
      },
      "HRK": {
        "_numeric": "191"
      },
      "HTG": {
        "_numeric": "332"
      },
      "HUF": {
        "_numeric": "348"
      },
      "IDR": {
        "_numeric": "360"
      },
      "ILS": {
        "_numeric": "376"
      },
      "INR": {
        "_numeric": "356"
      },
      "IQD": {
        "_numeric": "368"
      },
      "IRR": {
        "_numeric": "364"
      },
      "ISK": {
        "_numeric": "352"
      },
      "JMD": {
        "_numeric": "388"
      },
      "JOD": {
        "_numeric": "400"
      },
      "JPY": {
        "_numeric": "392"
      },
      "KES": {
        "_numeric": "404"
      },
      "KGS": {
        "_numeric": "417"
      },
      "KHR": {
        "_numeric": "116"
      },
      "KMF": {
        "_numeric": "174"
      },
      "KPW": {
        "_numeric": "408"
      },
      "KRW": {
        "_numeric": "410"
      },
      "KWD": {
        "_numeric": "414"
      },
      "KYD": {
        "_numeric": "136"
      },
      "KZT": {
        "_numeric": "398"
      },
      "LAK": {
        "_numeric": "418"
      },
      "LBP": {
        "_numeric": "422"
      },
      "LKR": {
        "_numeric": "144"
      },
      "LRD": {
        "_numeric": "430"
      },
      "LSL": {
        "_numeric": "426"
      },
      "LTL": {
        "_numeric": "440"
      },
      "LYD": {
        "_numeric": "434"
      },
      "MAD": {
        "_numeric": "504"
      },
      "MDL": {
        "_numeric": "498"
      },
      "MGA": {
        "_numeric": "969"
      },
      "MKD": {
        "_numeric": "807"
      },
      "MMK": {
        "_numeric": "104"
      },
      "MNT": {
        "_numeric": "496"
      },
      "MOP": {
        "_numeric": "446"
      },
      "MRO": {
        "_numeric": "478"
      },
      "MRU": {
        "_numeric": "929"
      },
      "MUR": {
        "_numeric": "480"
      },
      "MVR": {
        "_numeric": "462"
      },
      "MWK": {
        "_numeric": "454"
      },
      "MXN": {
        "_numeric": "484"
      },
      "MXV": {
        "_numeric": "979"
      },
      "MYR": {
        "_numeric": "458"
      },
      "MZN": {
        "_numeric": "943"
      },
      "NAD": {
        "_numeric": "516"
      },
      "NGN": {
        "_numeric": "566"
      },
      "NIO": {
        "_numeric": "558"
      },
      "NOK": {
        "_numeric": "578"
      },
      "NPR": {
        "_numeric": "524"
      },
      "NZD": {
        "_numeric": "554"
      },
      "OMR": {
        "_numeric": "512"
      },
      "PAB": {
        "_numeric": "590"
      },
      "PEN": {
        "_numeric": "604"
      },
      "PGK": {
        "_numeric": "598"
      },
      "PHP": {
        "_numeric": "608"
      },
      "PKR": {
        "_numeric": "586"
      },
      "PLN": {
        "_numeric": "985"
      },
      "PYG": {
        "_numeric": "600"
      },
      "QAR": {
        "_numeric": "634"
      },
      "RON": {
        "_numeric": "946"
      },
      "RSD": {
        "_numeric": "941"
      },
      "RUB": {
        "_numeric": "643"
      },
      "RWF": {
        "_numeric": "646"
      },
      "SAR": {
        "_numeric": "682"
      },
      "SBD": {
        "_numeric": "90"
      },
      "SCR": {
        "_numeric": "690"
      },
      "SDG": {
        "_numeric": "938"
      },
      "SEK": {
        "_numeric": "752"
      },
      "SGD": {
        "_numeric": "702"
      },
      "SHP": {
        "_numeric": "654"
      },
      "SLL": {
        "_numeric": "694"
      },
      "SOS": {
        "_numeric": "706"
      },
      "SRD": {
        "_numeric": "968"
      },
      "SSP": {
        "_numeric": "728"
      },
      "STD": {
        "_numeric": "678"
      },
      "STN": {
        "_numeric": "930"
      },
      "SYP": {
        "_numeric": "760"
      },
      "SZL": {
        "_numeric": "748"
      },
      "THB": {
        "_numeric": "764"
      },
      "TJS": {
        "_numeric": "972"
      },
      "TMT": {
        "_numeric": "934"
      },
      "TND": {
        "_numeric": "788"
      },
      "TOP": {
        "_numeric": "776"
      },
      "TRY": {
        "_numeric": "949"
      },
      "TTD": {
        "_numeric": "780"
      },
      "TWD": {
        "_numeric": "901"
      },
      "TZS": {
        "_numeric": "834"
      },
      "UAH": {
        "_numeric": "980"
      },
      "UGX": {
        "_numeric": "800"
      },
      "USD": {
        "_numeric": "840"
      },
      "USN": {
        "_numeric": "997"
      },
      "UYI": {
        "_numeric": "940"
      },
      "UYU": {
        "_numeric": "858"
      },
      "UYW": {
        "_numeric": "927"
      },
      "UZS": {
        "_numeric": "860"
      },
      "VEF": {
        "_numeric": "937"
      },
      "VES": {
        "_numeric": "928"
      },
      "VND": {
        "_numeric": "704"
      },
      "VUV": {
        "_numeric": "548"
      },
      "WST": {
        "_numeric": "882"
      },
      "XAF": {
        "_numeric": "950"
      },
      "XAG": {
        "_numeric": "961"
      },
      "XAU": {
        "_numeric": "959"
      },
      "XBA": {
        "_numeric": "955"
      },
      "XBB": {
        "_numeric": "956"
      },
      "XBC": {
        "_numeric": "957"
      },
      "XBD": {
        "_numeric": "958"
      },
      "XCD": {
        "_numeric": "951"
      },
      "XDR": {
        "_numeric": "960"
      },
      "XOF": {
        "_numeric": "952"
      },
      "XPD": {
        "_numeric": "964"
      },
      "XPF": {
        "_numeric": "953"
      },
      "XPT": {
        "_numeric": "962"
      },
      "XSU": {
        "_numeric": "994"
      },
      "XTS": {
        "_numeric": "963"
      },
      "XUA": {
        "_numeric": "965"
      },
      "XXX": {
        "_numeric": "999"
      },
      "YER": {
        "_numeric": "886"
      },
      "ZAR": {
        "_numeric": "710"
      },
      "ZMW": {
        "_numeric": "967"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "currencyData": {
      "fractions": {
        "ADP": {
          "_rounding": "0",
          "_digits": "0"
        },
        "AFN": {
          "_rounding": "0",
          "_digits": "0"
        },
        "ALL": {
          "_rounding": "0",
          "_digits": "0"
        },
        "AMD": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "BHD": {
          "_rounding": "0",
          "_digits": "3"
        },
        "BIF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "BYN": {
          "_rounding": "0",
          "_digits": "2"
        },
        "BYR": {
          "_rounding": "0",
          "_digits": "0"
        },
        "CAD": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "5"
        },
        "CHF": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "5"
        },
        "CLF": {
          "_rounding": "0",
          "_digits": "4"
        },
        "CLP": {
          "_rounding": "0",
          "_digits": "0"
        },
        "COP": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "CRC": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "CZK": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "DEFAULT": {
          "_rounding": "0",
          "_digits": "2"
        },
        "DJF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "DKK": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "50"
        },
        "ESP": {
          "_rounding": "0",
          "_digits": "0"
        },
        "GNF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "GYD": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "HUF": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "IDR": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "IQD": {
          "_rounding": "0",
          "_digits": "0"
        },
        "IRR": {
          "_rounding": "0",
          "_digits": "0"
        },
        "ISK": {
          "_rounding": "0",
          "_digits": "0"
        },
        "ITL": {
          "_rounding": "0",
          "_digits": "0"
        },
        "JOD": {
          "_rounding": "0",
          "_digits": "3"
        },
        "JPY": {
          "_rounding": "0",
          "_digits": "0"
        },
        "KMF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "KPW": {
          "_rounding": "0",
          "_digits": "0"
        },
        "KRW": {
          "_rounding": "0",
          "_digits": "0"
        },
        "KWD": {
          "_rounding": "0",
          "_digits": "3"
        },
        "LAK": {
          "_rounding": "0",
          "_digits": "0"
        },
        "LBP": {
          "_rounding": "0",
          "_digits": "0"
        },
        "LUF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "LYD": {
          "_rounding": "0",
          "_digits": "3"
        },
        "MGA": {
          "_rounding": "0",
          "_digits": "0"
        },
        "MGF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "MMK": {
          "_rounding": "0",
          "_digits": "0"
        },
        "MNT": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "MRO": {
          "_rounding": "0",
          "_digits": "0"
        },
        "MUR": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "NOK": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "OMR": {
          "_rounding": "0",
          "_digits": "3"
        },
        "PKR": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "PYG": {
          "_rounding": "0",
          "_digits": "0"
        },
        "RSD": {
          "_rounding": "0",
          "_digits": "0"
        },
        "RWF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "SEK": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "SLL": {
          "_rounding": "0",
          "_digits": "0"
        },
        "SOS": {
          "_rounding": "0",
          "_digits": "0"
        },
        "STD": {
          "_rounding": "0",
          "_digits": "0"
        },
        "SYP": {
          "_rounding": "0",
          "_digits": "0"
        },
        "TMM": {
          "_rounding": "0",
          "_digits": "0"
        },
        "TND": {
          "_rounding": "0",
          "_digits": "3"
        },
        "TRL": {
          "_rounding": "0",
          "_digits": "0"
        },
        "TWD": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "TZS": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "UGX": {
          "_rounding": "0",
          "_digits": "0"
        },
        "UYI": {
          "_rounding": "0",
          "_digits": "0"
        },
        "UYW": {
          "_rounding": "0",
          "_digits": "4"
        },
        "UZS": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "VEF": {
          "_rounding": "0",
          "_digits": "2",
          "_cashRounding": "0",
          "_cashDigits": "0"
        },
        "VND": {
          "_rounding": "0",
          "_digits": "0"
        },
        "VUV": {
          "_rounding": "0",
          "_digits": "0"
        },
        "XAF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "XOF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "XPF": {
          "_rounding": "0",
          "_digits": "0"
        },
        "YER": {
          "_rounding": "0",
          "_digits": "0"
        },
        "ZMK": {
          "_rounding": "0",
          "_digits": "0"
        },
        "ZWD": {
          "_rounding": "0",
          "_digits": "0"
        }
      },
      "region": {
        "AC": [{
          "SHP": {
            "_from": "1976-01-01"
          }
        }],
        "AD": [{
          "ESP": {
            "_from": "1873-01-01",
            "_to": "2002-02-28"
          }
        }, {
          "ADP": {
            "_from": "1936-01-01",
            "_to": "2001-12-31"
          }
        }, {
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "AE": [{
          "AED": {
            "_from": "1973-05-19"
          }
        }],
        "AF": [{
          "AFA": {
            "_from": "1927-03-14",
            "_to": "2002-12-31"
          }
        }, {
          "AFN": {
            "_from": "2002-10-07"
          }
        }],
        "AG": [{
          "XCD": {
            "_from": "1965-10-06"
          }
        }],
        "AI": [{
          "XCD": {
            "_from": "1965-10-06"
          }
        }],
        "AL": [{
          "ALK": {
            "_from": "1946-11-01",
            "_to": "1965-08-16"
          }
        }, {
          "ALL": {
            "_from": "1965-08-16"
          }
        }],
        "AM": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }, {
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1993-11-22"
          }
        }, {
          "AMD": {
            "_from": "1993-11-22"
          }
        }],
        "AO": [{
          "AOK": {
            "_from": "1977-01-08",
            "_to": "1991-03-01"
          }
        }, {
          "AON": {
            "_from": "1990-09-25",
            "_to": "2000-02-01"
          }
        }, {
          "AOR": {
            "_from": "1995-07-01",
            "_to": "2000-02-01"
          }
        }, {
          "AOA": {
            "_from": "1999-12-13"
          }
        }],
        "AQ": [{
          "XXX": {
            "_tender": "false"
          }
        }],
        "AR": [{
          "ARM": {
            "_from": "1881-11-05",
            "_to": "1970-01-01"
          }
        }, {
          "ARL": {
            "_from": "1970-01-01",
            "_to": "1983-06-01"
          }
        }, {
          "ARP": {
            "_from": "1983-06-01",
            "_to": "1985-06-14"
          }
        }, {
          "ARA": {
            "_from": "1985-06-14",
            "_to": "1992-01-01"
          }
        }, {
          "ARS": {
            "_from": "1992-01-01"
          }
        }],
        "AS": [{
          "USD": {
            "_from": "1904-07-16"
          }
        }],
        "AT": [{
          "ATS": {
            "_from": "1947-12-04",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "AU": [{
          "AUD": {
            "_from": "1966-02-14"
          }
        }],
        "AW": [{
          "ANG": {
            "_from": "1940-05-10",
            "_to": "1986-01-01"
          }
        }, {
          "AWG": {
            "_from": "1986-01-01"
          }
        }],
        "AX": [{
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "AZ": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }, {
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1994-01-01"
          }
        }, {
          "AZM": {
            "_from": "1993-11-22",
            "_to": "2006-12-31"
          }
        }, {
          "AZN": {
            "_from": "2006-01-01"
          }
        }],
        "BA": [{
          "YUD": {
            "_from": "1966-01-01",
            "_to": "1990-01-01"
          }
        }, {
          "YUN": {
            "_from": "1990-01-01",
            "_to": "1992-07-01"
          }
        }, {
          "YUR": {
            "_from": "1992-07-01",
            "_to": "1993-10-01"
          }
        }, {
          "BAD": {
            "_from": "1992-07-01",
            "_to": "1994-08-15"
          }
        }, {
          "BAN": {
            "_from": "1994-08-15",
            "_to": "1997-07-01"
          }
        }, {
          "BAM": {
            "_from": "1995-01-01"
          }
        }],
        "BB": [{
          "XCD": {
            "_from": "1965-10-06",
            "_to": "1973-12-03"
          }
        }, {
          "BBD": {
            "_from": "1973-12-03"
          }
        }],
        "BD": [{
          "INR": {
            "_from": "1835-08-17",
            "_to": "1948-04-01"
          }
        }, {
          "PKR": {
            "_from": "1948-04-01",
            "_to": "1972-01-01"
          }
        }, {
          "BDT": {
            "_from": "1972-01-01"
          }
        }],
        "BE": [{
          "NLG": {
            "_from": "1816-12-15",
            "_to": "1831-02-07"
          }
        }, {
          "BEF": {
            "_from": "1831-02-07",
            "_to": "2002-02-28"
          }
        }, {
          "BEC": {
            "_tender": "false",
            "_from": "1970-01-01",
            "_to": "1990-03-05"
          }
        }, {
          "BEL": {
            "_tender": "false",
            "_from": "1970-01-01",
            "_to": "1990-03-05"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "BF": [{
          "XOF": {
            "_from": "1984-08-04"
          }
        }],
        "BG": [{
          "BGO": {
            "_from": "1879-07-08",
            "_to": "1952-05-12"
          }
        }, {
          "BGM": {
            "_from": "1952-05-12",
            "_to": "1962-01-01"
          }
        }, {
          "BGL": {
            "_from": "1962-01-01",
            "_to": "1999-07-05"
          }
        }, {
          "BGN": {
            "_from": "1999-07-05"
          }
        }],
        "BH": [{
          "BHD": {
            "_from": "1965-10-16"
          }
        }],
        "BI": [{
          "BIF": {
            "_from": "1964-05-19"
          }
        }],
        "BJ": [{
          "XOF": {
            "_from": "1975-11-30"
          }
        }],
        "BL": [{
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "BM": [{
          "BMD": {
            "_from": "1970-02-06"
          }
        }],
        "BN": [{
          "MYR": {
            "_from": "1963-09-16",
            "_to": "1967-06-12"
          }
        }, {
          "BND": {
            "_from": "1967-06-12"
          }
        }],
        "BO": [{
          "BOV": {
            "_tender": "false"
          }
        }, {
          "BOL": {
            "_from": "1863-06-23",
            "_to": "1963-01-01"
          }
        }, {
          "BOP": {
            "_from": "1963-01-01",
            "_to": "1986-12-31"
          }
        }, {
          "BOB": {
            "_from": "1987-01-01"
          }
        }],
        "BQ": [{
          "ANG": {
            "_from": "2010-10-10",
            "_to": "2011-01-01"
          }
        }, {
          "USD": {
            "_from": "2011-01-01"
          }
        }],
        "BR": [{
          "BRZ": {
            "_from": "1942-11-01",
            "_to": "1967-02-13"
          }
        }, {
          "BRB": {
            "_from": "1967-02-13",
            "_to": "1986-02-28"
          }
        }, {
          "BRC": {
            "_from": "1986-02-28",
            "_to": "1989-01-15"
          }
        }, {
          "BRN": {
            "_from": "1989-01-15",
            "_to": "1990-03-16"
          }
        }, {
          "BRE": {
            "_from": "1990-03-16",
            "_to": "1993-08-01"
          }
        }, {
          "BRR": {
            "_from": "1993-08-01",
            "_to": "1994-07-01"
          }
        }, {
          "BRL": {
            "_from": "1994-07-01"
          }
        }],
        "BS": [{
          "BSD": {
            "_from": "1966-05-25"
          }
        }],
        "BT": [{
          "INR": {
            "_from": "1907-01-01"
          }
        }, {
          "BTN": {
            "_from": "1974-04-16"
          }
        }],
        "BU": [{
          "BUK": {
            "_from": "1952-07-01",
            "_to": "1989-06-18"
          }
        }],
        "BV": [{
          "NOK": {
            "_from": "1905-06-07"
          }
        }],
        "BW": [{
          "ZAR": {
            "_from": "1961-02-14",
            "_to": "1976-08-23"
          }
        }, {
          "BWP": {
            "_from": "1976-08-23"
          }
        }],
        "BY": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }, {
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1994-11-08"
          }
        }, {
          "BYB": {
            "_from": "1994-08-01",
            "_to": "2000-12-31"
          }
        }, {
          "BYR": {
            "_from": "2000-01-01",
            "_to": "2017-01-01"
          }
        }, {
          "BYN": {
            "_from": "2016-07-01"
          }
        }],
        "BZ": [{
          "BZD": {
            "_from": "1974-01-01"
          }
        }],
        "CA": [{
          "CAD": {
            "_from": "1858-01-01"
          }
        }],
        "CC": [{
          "AUD": {
            "_from": "1966-02-14"
          }
        }],
        "CD": [{
          "ZRZ": {
            "_from": "1971-10-27",
            "_to": "1993-11-01"
          }
        }, {
          "ZRN": {
            "_from": "1993-11-01",
            "_to": "1998-07-01"
          }
        }, {
          "CDF": {
            "_from": "1998-07-01"
          }
        }],
        "CF": [{
          "XAF": {
            "_from": "1993-01-01"
          }
        }],
        "CG": [{
          "XAF": {
            "_from": "1993-01-01"
          }
        }],
        "CH": [{
          "CHE": {
            "_tender": "false"
          }
        }, {
          "CHW": {
            "_tender": "false"
          }
        }, {
          "CHF": {
            "_from": "1799-03-17"
          }
        }],
        "CI": [{
          "XOF": {
            "_from": "1958-12-04"
          }
        }],
        "CK": [{
          "NZD": {
            "_from": "1967-07-10"
          }
        }],
        "CL": [{
          "CLF": {
            "_tender": "false"
          }
        }, {
          "CLE": {
            "_from": "1960-01-01",
            "_to": "1975-09-29"
          }
        }, {
          "CLP": {
            "_from": "1975-09-29"
          }
        }],
        "CM": [{
          "XAF": {
            "_from": "1973-04-01"
          }
        }],
        "CN": [{
          "CNY": {
            "_from": "1953-03-01"
          }
        }, {
          "CNX": {
            "_tender": "false",
            "_from": "1979-01-01",
            "_to": "1998-12-31"
          }
        }, {
          "CNH": {
            "_tender": "false",
            "_from": "2010-07-19"
          }
        }],
        "CO": [{
          "COU": {
            "_tender": "false"
          }
        }, {
          "COP": {
            "_from": "1905-01-01"
          }
        }],
        "CP": [{
          "XXX": {
            "_tender": "false"
          }
        }],
        "CR": [{
          "CRC": {
            "_from": "1896-10-26"
          }
        }],
        "CS": [{
          "YUM": {
            "_from": "1994-01-24",
            "_to": "2002-05-15"
          }
        }, {
          "CSD": {
            "_from": "2002-05-15",
            "_to": "2006-06-03"
          }
        }, {
          "EUR": {
            "_from": "2003-02-04",
            "_to": "2006-06-03"
          }
        }],
        "CU": [{
          "CUP": {
            "_from": "1859-01-01"
          }
        }, {
          "USD": {
            "_from": "1899-01-01",
            "_to": "1959-01-01"
          }
        }, {
          "CUC": {
            "_from": "1994-01-01"
          }
        }],
        "CV": [{
          "PTE": {
            "_from": "1911-05-22",
            "_to": "1975-07-05"
          }
        }, {
          "CVE": {
            "_from": "1914-01-01"
          }
        }],
        "CW": [{
          "ANG": {
            "_from": "2010-10-10"
          }
        }],
        "CX": [{
          "AUD": {
            "_from": "1966-02-14"
          }
        }],
        "CY": [{
          "CYP": {
            "_from": "1914-09-10",
            "_to": "2008-01-31"
          }
        }, {
          "EUR": {
            "_from": "2008-01-01"
          }
        }],
        "CZ": [{
          "CSK": {
            "_from": "1953-06-01",
            "_to": "1993-03-01"
          }
        }, {
          "CZK": {
            "_from": "1993-01-01"
          }
        }],
        "DD": [{
          "DDM": {
            "_from": "1948-07-20",
            "_to": "1990-10-02"
          }
        }],
        "DE": [{
          "DEM": {
            "_from": "1948-06-20",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "DG": [{
          "USD": {
            "_from": "1965-11-08"
          }
        }],
        "DJ": [{
          "DJF": {
            "_from": "1977-06-27"
          }
        }],
        "DK": [{
          "DKK": {
            "_from": "1873-05-27"
          }
        }],
        "DM": [{
          "XCD": {
            "_from": "1965-10-06"
          }
        }],
        "DO": [{
          "USD": {
            "_from": "1905-06-21",
            "_to": "1947-10-01"
          }
        }, {
          "DOP": {
            "_from": "1947-10-01"
          }
        }],
        "DZ": [{
          "DZD": {
            "_from": "1964-04-01"
          }
        }],
        "EA": [{
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "EC": [{
          "ECS": {
            "_from": "1884-04-01",
            "_to": "2000-10-02"
          }
        }, {
          "ECV": {
            "_tender": "false",
            "_from": "1993-05-23",
            "_to": "2000-01-09"
          }
        }, {
          "USD": {
            "_from": "2000-10-02"
          }
        }],
        "EE": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1992-06-20"
          }
        }, {
          "EEK": {
            "_from": "1992-06-21",
            "_to": "2010-12-31"
          }
        }, {
          "EUR": {
            "_from": "2011-01-01"
          }
        }],
        "EG": [{
          "EGP": {
            "_from": "1885-11-14"
          }
        }],
        "EH": [{
          "MAD": {
            "_from": "1976-02-26"
          }
        }],
        "ER": [{
          "ETB": {
            "_from": "1993-05-24",
            "_to": "1997-11-08"
          }
        }, {
          "ERN": {
            "_from": "1997-11-08"
          }
        }],
        "ES": [{
          "ESP": {
            "_from": "1868-10-19",
            "_to": "2002-02-28"
          }
        }, {
          "ESB": {
            "_tender": "false",
            "_from": "1975-01-01",
            "_to": "1994-12-31"
          }
        }, {
          "ESA": {
            "_tender": "false",
            "_from": "1978-01-01",
            "_to": "1981-12-31"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "ET": [{
          "ETB": {
            "_from": "1976-09-15"
          }
        }],
        "EU": [{
          "XEU": {
            "_tender": "false",
            "_from": "1979-01-01",
            "_to": "1998-12-31"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "FI": [{
          "FIM": {
            "_from": "1963-01-01",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "FJ": [{
          "FJD": {
            "_from": "1969-01-13"
          }
        }],
        "FK": [{
          "FKP": {
            "_from": "1901-01-01"
          }
        }],
        "FM": [{
          "JPY": {
            "_from": "1914-10-03",
            "_to": "1944-01-01"
          }
        }, {
          "USD": {
            "_from": "1944-01-01"
          }
        }],
        "FO": [{
          "DKK": {
            "_from": "1948-01-01"
          }
        }],
        "FR": [{
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "GA": [{
          "XAF": {
            "_from": "1993-01-01"
          }
        }],
        "GB": [{
          "GBP": {
            "_from": "1694-07-27"
          }
        }],
        "GD": [{
          "XCD": {
            "_from": "1967-02-27"
          }
        }],
        "GE": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }, {
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1993-06-11"
          }
        }, {
          "GEK": {
            "_from": "1993-04-05",
            "_to": "1995-09-25"
          }
        }, {
          "GEL": {
            "_from": "1995-09-23"
          }
        }],
        "GF": [{
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "GG": [{
          "GBP": {
            "_from": "1830-01-01"
          }
        }],
        "GH": [{
          "GHC": {
            "_from": "1979-03-09",
            "_to": "2007-12-31"
          }
        }, {
          "GHS": {
            "_from": "2007-07-03"
          }
        }],
        "GI": [{
          "GIP": {
            "_from": "1713-01-01"
          }
        }],
        "GL": [{
          "DKK": {
            "_from": "1873-05-27"
          }
        }],
        "GM": [{
          "GMD": {
            "_from": "1971-07-01"
          }
        }],
        "GN": [{
          "GNS": {
            "_from": "1972-10-02",
            "_to": "1986-01-06"
          }
        }, {
          "GNF": {
            "_from": "1986-01-06"
          }
        }],
        "GP": [{
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "GQ": [{
          "GQE": {
            "_from": "1975-07-07",
            "_to": "1986-06-01"
          }
        }, {
          "XAF": {
            "_from": "1993-01-01"
          }
        }],
        "GR": [{
          "GRD": {
            "_from": "1954-05-01",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "2001-01-01"
          }
        }],
        "GS": [{
          "GBP": {
            "_from": "1908-01-01"
          }
        }],
        "GT": [{
          "GTQ": {
            "_from": "1925-05-27"
          }
        }],
        "GU": [{
          "USD": {
            "_from": "1944-08-21"
          }
        }],
        "GW": [{
          "GWE": {
            "_from": "1914-01-01",
            "_to": "1976-02-28"
          }
        }, {
          "GWP": {
            "_from": "1976-02-28",
            "_to": "1997-03-31"
          }
        }, {
          "XOF": {
            "_from": "1997-03-31"
          }
        }],
        "GY": [{
          "GYD": {
            "_from": "1966-05-26"
          }
        }],
        "HK": [{
          "HKD": {
            "_from": "1895-02-02"
          }
        }],
        "HM": [{
          "AUD": {
            "_from": "1967-02-16"
          }
        }],
        "HN": [{
          "HNL": {
            "_from": "1926-04-03"
          }
        }],
        "HR": [{
          "YUD": {
            "_from": "1966-01-01",
            "_to": "1990-01-01"
          }
        }, {
          "YUN": {
            "_from": "1990-01-01",
            "_to": "1991-12-23"
          }
        }, {
          "HRD": {
            "_from": "1991-12-23",
            "_to": "1995-01-01"
          }
        }, {
          "HRK": {
            "_from": "1994-05-30"
          }
        }],
        "HT": [{
          "HTG": {
            "_from": "1872-08-26"
          }
        }, {
          "USD": {
            "_from": "1915-01-01"
          }
        }],
        "HU": [{
          "HUF": {
            "_from": "1946-07-23"
          }
        }],
        "IC": [{
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "ID": [{
          "IDR": {
            "_from": "1965-12-13"
          }
        }],
        "IE": [{
          "GBP": {
            "_from": "1800-01-01",
            "_to": "1922-01-01"
          }
        }, {
          "IEP": {
            "_from": "1922-01-01",
            "_to": "2002-02-09"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "IL": [{
          "ILP": {
            "_from": "1948-08-16",
            "_to": "1980-02-22"
          }
        }, {
          "ILR": {
            "_from": "1980-02-22",
            "_to": "1985-09-04"
          }
        }, {
          "ILS": {
            "_from": "1985-09-04"
          }
        }],
        "IM": [{
          "GBP": {
            "_from": "1840-01-03"
          }
        }],
        "IN": [{
          "INR": {
            "_from": "1835-08-17"
          }
        }],
        "IO": [{
          "USD": {
            "_from": "1965-11-08"
          }
        }],
        "IQ": [{
          "EGP": {
            "_from": "1920-11-11",
            "_to": "1931-04-19"
          }
        }, {
          "INR": {
            "_from": "1920-11-11",
            "_to": "1931-04-19"
          }
        }, {
          "IQD": {
            "_from": "1931-04-19"
          }
        }],
        "IR": [{
          "IRR": {
            "_from": "1932-05-13"
          }
        }],
        "IS": [{
          "DKK": {
            "_from": "1873-05-27",
            "_to": "1918-12-01"
          }
        }, {
          "ISJ": {
            "_from": "1918-12-01",
            "_to": "1981-01-01"
          }
        }, {
          "ISK": {
            "_from": "1981-01-01"
          }
        }],
        "IT": [{
          "ITL": {
            "_from": "1862-08-24",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "JE": [{
          "GBP": {
            "_from": "1837-01-01"
          }
        }],
        "JM": [{
          "JMD": {
            "_from": "1969-09-08"
          }
        }],
        "JO": [{
          "JOD": {
            "_from": "1950-07-01"
          }
        }],
        "JP": [{
          "JPY": {
            "_from": "1871-06-01"
          }
        }],
        "KE": [{
          "KES": {
            "_from": "1966-09-14"
          }
        }],
        "KG": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }, {
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1993-05-10"
          }
        }, {
          "KGS": {
            "_from": "1993-05-10"
          }
        }],
        "KH": [{
          "KHR": {
            "_from": "1980-03-20"
          }
        }],
        "KI": [{
          "AUD": {
            "_from": "1966-02-14"
          }
        }],
        "KM": [{
          "KMF": {
            "_from": "1975-07-06"
          }
        }],
        "KN": [{
          "XCD": {
            "_from": "1965-10-06"
          }
        }],
        "KP": [{
          "KPW": {
            "_from": "1959-04-17"
          }
        }],
        "KR": [{
          "KRO": {
            "_from": "1945-08-15",
            "_to": "1953-02-15"
          }
        }, {
          "KRH": {
            "_from": "1953-02-15",
            "_to": "1962-06-10"
          }
        }, {
          "KRW": {
            "_from": "1962-06-10"
          }
        }],
        "KW": [{
          "KWD": {
            "_from": "1961-04-01"
          }
        }],
        "KY": [{
          "JMD": {
            "_from": "1969-09-08",
            "_to": "1971-01-01"
          }
        }, {
          "KYD": {
            "_from": "1971-01-01"
          }
        }],
        "KZ": [{
          "KZT": {
            "_from": "1993-11-05"
          }
        }],
        "LA": [{
          "LAK": {
            "_from": "1979-12-10"
          }
        }],
        "LB": [{
          "LBP": {
            "_from": "1948-02-02"
          }
        }],
        "LC": [{
          "XCD": {
            "_from": "1965-10-06"
          }
        }],
        "LI": [{
          "CHF": {
            "_from": "1921-02-01"
          }
        }],
        "LK": [{
          "LKR": {
            "_from": "1978-05-22"
          }
        }],
        "LR": [{
          "LRD": {
            "_from": "1944-01-01"
          }
        }],
        "LS": [{
          "ZAR": {
            "_from": "1961-02-14"
          }
        }, {
          "LSL": {
            "_from": "1980-01-22"
          }
        }],
        "LT": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1992-10-01"
          }
        }, {
          "LTT": {
            "_from": "1992-10-01",
            "_to": "1993-06-25"
          }
        }, {
          "LTL": {
            "_from": "1993-06-25",
            "_to": "2014-12-31"
          }
        }, {
          "EUR": {
            "_from": "2015-01-01"
          }
        }],
        "LU": [{
          "LUF": {
            "_from": "1944-09-04",
            "_to": "2002-02-28"
          }
        }, {
          "LUC": {
            "_tender": "false",
            "_from": "1970-01-01",
            "_to": "1990-03-05"
          }
        }, {
          "LUL": {
            "_tender": "false",
            "_from": "1970-01-01",
            "_to": "1990-03-05"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "LV": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1992-07-20"
          }
        }, {
          "LVR": {
            "_from": "1992-05-07",
            "_to": "1993-10-17"
          }
        }, {
          "LVL": {
            "_from": "1993-06-28",
            "_to": "2013-12-31"
          }
        }, {
          "EUR": {
            "_from": "2014-01-01"
          }
        }],
        "LY": [{
          "LYD": {
            "_from": "1971-09-01"
          }
        }],
        "MA": [{
          "MAF": {
            "_from": "1881-01-01",
            "_to": "1959-10-17"
          }
        }, {
          "MAD": {
            "_from": "1959-10-17"
          }
        }],
        "MC": [{
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "MCF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "MD": [{
          "MDC": {
            "_from": "1992-06-01",
            "_to": "1993-11-29"
          }
        }, {
          "MDL": {
            "_from": "1993-11-29"
          }
        }],
        "ME": [{
          "YUM": {
            "_from": "1994-01-24",
            "_to": "2002-05-15"
          }
        }, {
          "DEM": {
            "_from": "1999-10-02",
            "_to": "2002-05-15"
          }
        }, {
          "EUR": {
            "_from": "2002-01-01"
          }
        }],
        "MF": [{
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "MG": [{
          "MGF": {
            "_from": "1963-07-01",
            "_to": "2004-12-31"
          }
        }, {
          "MGA": {
            "_from": "1983-11-01"
          }
        }],
        "MH": [{
          "USD": {
            "_from": "1944-01-01"
          }
        }],
        "MK": [{
          "MKN": {
            "_from": "1992-04-26",
            "_to": "1993-05-20"
          }
        }, {
          "MKD": {
            "_from": "1993-05-20"
          }
        }],
        "ML": [{
          "XOF": {
            "_from": "1958-11-24",
            "_to": "1962-07-02"
          }
        }, {
          "MLF": {
            "_from": "1962-07-02",
            "_to": "1984-08-31"
          }
        }, {
          "XOF": {
            "_from": "1984-06-01"
          }
        }],
        "MM": [{
          "BUK": {
            "_from": "1952-07-01",
            "_to": "1989-06-18"
          }
        }, {
          "MMK": {
            "_from": "1989-06-18"
          }
        }],
        "MN": [{
          "MNT": {
            "_from": "1915-03-01"
          }
        }],
        "MO": [{
          "MOP": {
            "_from": "1901-01-01"
          }
        }],
        "MP": [{
          "USD": {
            "_from": "1944-01-01"
          }
        }],
        "MQ": [{
          "FRF": {
            "_from": "1960-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "MR": [{
          "XOF": {
            "_from": "1958-11-28",
            "_to": "1973-06-29"
          }
        }, {
          "MRO": {
            "_from": "1973-06-29",
            "_to": "2018-06-30"
          }
        }, {
          "MRU": {
            "_from": "2018-01-01"
          }
        }],
        "MS": [{
          "XCD": {
            "_from": "1967-02-27"
          }
        }],
        "MT": [{
          "MTP": {
            "_from": "1914-08-13",
            "_to": "1968-06-07"
          }
        }, {
          "MTL": {
            "_from": "1968-06-07",
            "_to": "2008-01-31"
          }
        }, {
          "EUR": {
            "_from": "2008-01-01"
          }
        }],
        "MU": [{
          "MUR": {
            "_from": "1934-04-01"
          }
        }],
        "MV": [{
          "MVP": {
            "_from": "1947-01-01",
            "_to": "1981-07-01"
          }
        }, {
          "MVR": {
            "_from": "1981-07-01"
          }
        }],
        "MW": [{
          "MWK": {
            "_from": "1971-02-15"
          }
        }],
        "MX": [{
          "MXV": {
            "_tender": "false"
          }
        }, {
          "MXP": {
            "_from": "1822-01-01",
            "_to": "1992-12-31"
          }
        }, {
          "MXN": {
            "_from": "1993-01-01"
          }
        }],
        "MY": [{
          "MYR": {
            "_from": "1963-09-16"
          }
        }],
        "MZ": [{
          "MZE": {
            "_from": "1975-06-25",
            "_to": "1980-06-16"
          }
        }, {
          "MZM": {
            "_from": "1980-06-16",
            "_to": "2006-12-31"
          }
        }, {
          "MZN": {
            "_from": "2006-07-01"
          }
        }],
        "NA": [{
          "ZAR": {
            "_from": "1961-02-14"
          }
        }, {
          "NAD": {
            "_from": "1993-01-01"
          }
        }],
        "NC": [{
          "XPF": {
            "_from": "1985-01-01"
          }
        }],
        "NE": [{
          "XOF": {
            "_from": "1958-12-19"
          }
        }],
        "NF": [{
          "AUD": {
            "_from": "1966-02-14"
          }
        }],
        "NG": [{
          "NGN": {
            "_from": "1973-01-01"
          }
        }],
        "NI": [{
          "NIC": {
            "_from": "1988-02-15",
            "_to": "1991-04-30"
          }
        }, {
          "NIO": {
            "_from": "1991-04-30"
          }
        }],
        "NL": [{
          "NLG": {
            "_from": "1813-01-01",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "NO": [{
          "SEK": {
            "_from": "1873-05-27",
            "_to": "1905-06-07"
          }
        }, {
          "NOK": {
            "_from": "1905-06-07"
          }
        }],
        "NP": [{
          "INR": {
            "_from": "1870-01-01",
            "_to": "1966-10-17"
          }
        }, {
          "NPR": {
            "_from": "1933-01-01"
          }
        }],
        "NR": [{
          "AUD": {
            "_from": "1966-02-14"
          }
        }],
        "NU": [{
          "NZD": {
            "_from": "1967-07-10"
          }
        }],
        "NZ": [{
          "NZD": {
            "_from": "1967-07-10"
          }
        }],
        "OM": [{
          "OMR": {
            "_from": "1972-11-11"
          }
        }],
        "PA": [{
          "PAB": {
            "_from": "1903-11-04"
          }
        }, {
          "USD": {
            "_from": "1903-11-18"
          }
        }],
        "PE": [{
          "PES": {
            "_from": "1863-02-14",
            "_to": "1985-02-01"
          }
        }, {
          "PEI": {
            "_from": "1985-02-01",
            "_to": "1991-07-01"
          }
        }, {
          "PEN": {
            "_from": "1991-07-01"
          }
        }],
        "PF": [{
          "XPF": {
            "_from": "1945-12-26"
          }
        }],
        "PG": [{
          "AUD": {
            "_from": "1966-02-14",
            "_to": "1975-09-16"
          }
        }, {
          "PGK": {
            "_from": "1975-09-16"
          }
        }],
        "PH": [{
          "PHP": {
            "_from": "1946-07-04"
          }
        }],
        "PK": [{
          "INR": {
            "_from": "1835-08-17",
            "_to": "1947-08-15"
          }
        }, {
          "PKR": {
            "_from": "1948-04-01"
          }
        }],
        "PL": [{
          "PLZ": {
            "_from": "1950-10-28",
            "_to": "1994-12-31"
          }
        }, {
          "PLN": {
            "_from": "1995-01-01"
          }
        }],
        "PM": [{
          "FRF": {
            "_from": "1972-12-21",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "PN": [{
          "NZD": {
            "_from": "1969-01-13"
          }
        }],
        "PR": [{
          "ESP": {
            "_from": "1800-01-01",
            "_to": "1898-12-10"
          }
        }, {
          "USD": {
            "_from": "1898-12-10"
          }
        }],
        "PS": [{
          "JOD": {
            "_from": "1950-07-01",
            "_to": "1967-06-01"
          }
        }, {
          "ILP": {
            "_from": "1967-06-01",
            "_to": "1980-02-22"
          }
        }, {
          "ILS": {
            "_from": "1985-09-04"
          }
        }, {
          "JOD": {
            "_from": "1996-02-12"
          }
        }],
        "PT": [{
          "PTE": {
            "_from": "1911-05-22",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "PW": [{
          "USD": {
            "_from": "1944-01-01"
          }
        }],
        "PY": [{
          "PYG": {
            "_from": "1943-11-01"
          }
        }],
        "QA": [{
          "QAR": {
            "_from": "1973-05-19"
          }
        }],
        "RE": [{
          "FRF": {
            "_from": "1975-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "RO": [{
          "ROL": {
            "_from": "1952-01-28",
            "_to": "2006-12-31"
          }
        }, {
          "RON": {
            "_from": "2005-07-01"
          }
        }],
        "RS": [{
          "YUM": {
            "_from": "1994-01-24",
            "_to": "2002-05-15"
          }
        }, {
          "CSD": {
            "_from": "2002-05-15",
            "_to": "2006-10-25"
          }
        }, {
          "RSD": {
            "_from": "2006-10-25"
          }
        }],
        "RU": [{
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1998-12-31"
          }
        }, {
          "RUB": {
            "_from": "1999-01-01"
          }
        }],
        "RW": [{
          "RWF": {
            "_from": "1964-05-19"
          }
        }],
        "SA": [{
          "SAR": {
            "_from": "1952-10-22"
          }
        }],
        "SB": [{
          "AUD": {
            "_from": "1966-02-14",
            "_to": "1978-06-30"
          }
        }, {
          "SBD": {
            "_from": "1977-10-24"
          }
        }],
        "SC": [{
          "SCR": {
            "_from": "1903-11-01"
          }
        }],
        "SD": [{
          "EGP": {
            "_from": "1889-01-19",
            "_to": "1958-01-01"
          }
        }, {
          "GBP": {
            "_from": "1889-01-19",
            "_to": "1958-01-01"
          }
        }, {
          "SDP": {
            "_from": "1957-04-08",
            "_to": "1998-06-01"
          }
        }, {
          "SDD": {
            "_from": "1992-06-08",
            "_to": "2007-06-30"
          }
        }, {
          "SDG": {
            "_from": "2007-01-10"
          }
        }],
        "SE": [{
          "SEK": {
            "_from": "1873-05-27"
          }
        }],
        "SG": [{
          "MYR": {
            "_from": "1963-09-16",
            "_to": "1967-06-12"
          }
        }, {
          "SGD": {
            "_from": "1967-06-12"
          }
        }],
        "SH": [{
          "SHP": {
            "_from": "1917-02-15"
          }
        }],
        "SI": [{
          "SIT": {
            "_from": "1992-10-07",
            "_to": "2007-01-14"
          }
        }, {
          "EUR": {
            "_from": "2007-01-01"
          }
        }],
        "SJ": [{
          "NOK": {
            "_from": "1905-06-07"
          }
        }],
        "SK": [{
          "CSK": {
            "_from": "1953-06-01",
            "_to": "1992-12-31"
          }
        }, {
          "SKK": {
            "_from": "1992-12-31",
            "_to": "2009-01-01"
          }
        }, {
          "EUR": {
            "_from": "2009-01-01"
          }
        }],
        "SL": [{
          "GBP": {
            "_from": "1808-11-30",
            "_to": "1966-02-04"
          }
        }, {
          "SLL": {
            "_from": "1964-08-04"
          }
        }],
        "SM": [{
          "ITL": {
            "_from": "1865-12-23",
            "_to": "2001-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "SN": [{
          "XOF": {
            "_from": "1959-04-04"
          }
        }],
        "SO": [{
          "SOS": {
            "_from": "1960-07-01"
          }
        }],
        "SR": [{
          "NLG": {
            "_from": "1815-11-20",
            "_to": "1940-05-10"
          }
        }, {
          "SRG": {
            "_from": "1940-05-10",
            "_to": "2003-12-31"
          }
        }, {
          "SRD": {
            "_from": "2004-01-01"
          }
        }],
        "SS": [{
          "SDG": {
            "_from": "2007-01-10",
            "_to": "2011-09-01"
          }
        }, {
          "SSP": {
            "_from": "2011-07-18"
          }
        }],
        "ST": [{
          "STD": {
            "_from": "1977-09-08",
            "_to": "2017-12-31"
          }
        }, {
          "STN": {
            "_from": "2018-01-01"
          }
        }],
        "SU": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }],
        "SV": [{
          "SVC": {
            "_from": "1919-11-11",
            "_to": "2001-01-01"
          }
        }, {
          "USD": {
            "_from": "2001-01-01"
          }
        }],
        "SX": [{
          "ANG": {
            "_from": "2010-10-10"
          }
        }],
        "SY": [{
          "SYP": {
            "_from": "1948-01-01"
          }
        }],
        "SZ": [{
          "SZL": {
            "_from": "1974-09-06"
          }
        }],
        "TA": [{
          "GBP": {
            "_from": "1938-01-12"
          }
        }],
        "TC": [{
          "USD": {
            "_from": "1969-09-08"
          }
        }],
        "TD": [{
          "XAF": {
            "_from": "1993-01-01"
          }
        }],
        "TF": [{
          "FRF": {
            "_from": "1959-01-01",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "TG": [{
          "XOF": {
            "_from": "1958-11-28"
          }
        }],
        "TH": [{
          "THB": {
            "_from": "1928-04-15"
          }
        }],
        "TJ": [{
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1995-05-10"
          }
        }, {
          "TJR": {
            "_from": "1995-05-10",
            "_to": "2000-10-25"
          }
        }, {
          "TJS": {
            "_from": "2000-10-26"
          }
        }],
        "TK": [{
          "NZD": {
            "_from": "1967-07-10"
          }
        }],
        "TL": [{
          "TPE": {
            "_from": "1959-01-02",
            "_to": "2002-05-20"
          }
        }, {
          "IDR": {
            "_from": "1975-12-07",
            "_to": "2002-05-20"
          }
        }, {
          "USD": {
            "_from": "1999-10-20"
          }
        }],
        "TM": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }, {
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1993-11-01"
          }
        }, {
          "TMM": {
            "_from": "1993-11-01",
            "_to": "2009-01-01"
          }
        }, {
          "TMT": {
            "_from": "2009-01-01"
          }
        }],
        "TN": [{
          "TND": {
            "_from": "1958-11-01"
          }
        }],
        "TO": [{
          "TOP": {
            "_from": "1966-02-14"
          }
        }],
        "TP": [{
          "TPE": {
            "_from": "1959-01-02",
            "_to": "2002-05-20"
          }
        }, {
          "IDR": {
            "_from": "1975-12-07",
            "_to": "2002-05-20"
          }
        }],
        "TR": [{
          "TRL": {
            "_from": "1922-11-01",
            "_to": "2005-12-31"
          }
        }, {
          "TRY": {
            "_from": "2005-01-01"
          }
        }],
        "TT": [{
          "TTD": {
            "_from": "1964-01-01"
          }
        }],
        "TV": [{
          "AUD": {
            "_from": "1966-02-14"
          }
        }],
        "TW": [{
          "TWD": {
            "_from": "1949-06-15"
          }
        }],
        "TZ": [{
          "TZS": {
            "_from": "1966-06-14"
          }
        }],
        "UA": [{
          "SUR": {
            "_from": "1961-01-01",
            "_to": "1991-12-25"
          }
        }, {
          "RUR": {
            "_from": "1991-12-25",
            "_to": "1992-11-13"
          }
        }, {
          "UAK": {
            "_from": "1992-11-13",
            "_to": "1993-10-17"
          }
        }, {
          "UAH": {
            "_from": "1996-09-02"
          }
        }],
        "UG": [{
          "UGS": {
            "_from": "1966-08-15",
            "_to": "1987-05-15"
          }
        }, {
          "UGX": {
            "_from": "1987-05-15"
          }
        }],
        "UM": [{
          "USD": {
            "_from": "1944-01-01"
          }
        }],
        "US": [{
          "USN": {
            "_tender": "false"
          }
        }, {
          "USS": {
            "_tender": "false",
            "_to": "2014-03-01"
          }
        }, {
          "USD": {
            "_from": "1792-01-01"
          }
        }],
        "UY": [{
          "UYI": {
            "_tender": "false"
          }
        }, {
          "UYW": {
            "_tender": "false"
          }
        }, {
          "UYP": {
            "_from": "1975-07-01",
            "_to": "1993-03-01"
          }
        }, {
          "UYU": {
            "_from": "1993-03-01"
          }
        }],
        "UZ": [{
          "UZS": {
            "_from": "1994-07-01"
          }
        }],
        "VA": [{
          "ITL": {
            "_from": "1870-10-19",
            "_to": "2002-02-28"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "VC": [{
          "XCD": {
            "_from": "1965-10-06"
          }
        }],
        "VE": [{
          "VEB": {
            "_from": "1871-05-11",
            "_to": "2008-06-30"
          }
        }, {
          "VEF": {
            "_from": "2008-01-01",
            "_to": "2018-08-20"
          }
        }, {
          "VES": {
            "_from": "2018-08-20"
          }
        }],
        "VG": [{
          "USD": {
            "_from": "1833-01-01"
          }
        }, {
          "GBP": {
            "_from": "1833-01-01",
            "_to": "1959-01-01"
          }
        }],
        "VI": [{
          "USD": {
            "_from": "1837-01-01"
          }
        }],
        "VN": [{
          "VNN": {
            "_from": "1978-05-03",
            "_to": "1985-09-14"
          }
        }, {
          "VND": {
            "_from": "1985-09-14"
          }
        }],
        "VU": [{
          "VUV": {
            "_from": "1981-01-01"
          }
        }],
        "WF": [{
          "XPF": {
            "_from": "1961-07-30"
          }
        }],
        "WS": [{
          "WST": {
            "_from": "1967-07-10"
          }
        }],
        "XK": [{
          "YUM": {
            "_from": "1994-01-24",
            "_to": "1999-09-30"
          }
        }, {
          "DEM": {
            "_from": "1999-09-01",
            "_to": "2002-03-09"
          }
        }, {
          "EUR": {
            "_from": "2002-01-01"
          }
        }],
        "YD": [{
          "YDD": {
            "_from": "1965-04-01",
            "_to": "1996-01-01"
          }
        }],
        "YE": [{
          "YER": {
            "_from": "1990-05-22"
          }
        }],
        "YT": [{
          "KMF": {
            "_from": "1975-01-01",
            "_to": "1976-02-23"
          }
        }, {
          "FRF": {
            "_from": "1976-02-23",
            "_to": "2002-02-17"
          }
        }, {
          "EUR": {
            "_from": "1999-01-01"
          }
        }],
        "YU": [{
          "YUD": {
            "_from": "1966-01-01",
            "_to": "1990-01-01"
          }
        }, {
          "YUN": {
            "_from": "1990-01-01",
            "_to": "1992-07-24"
          }
        }, {
          "YUM": {
            "_from": "1994-01-24",
            "_to": "2002-05-15"
          }
        }],
        "ZA": [{
          "ZAR": {
            "_from": "1961-02-14"
          }
        }, {
          "ZAL": {
            "_tender": "false",
            "_from": "1985-09-01",
            "_to": "1995-03-13"
          }
        }],
        "ZM": [{
          "ZMK": {
            "_from": "1968-01-16",
            "_to": "2013-01-01"
          }
        }, {
          "ZMW": {
            "_from": "2013-01-01"
          }
        }],
        "ZR": [{
          "ZRZ": {
            "_from": "1971-10-27",
            "_to": "1993-11-01"
          }
        }, {
          "ZRN": {
            "_from": "1993-11-01",
            "_to": "1998-07-31"
          }
        }],
        "ZW": [{
          "RHD": {
            "_from": "1970-02-17",
            "_to": "1980-04-18"
          }
        }, {
          "ZWD": {
            "_from": "1980-04-18",
            "_to": "2008-08-01"
          }
        }, {
          "ZWR": {
            "_from": "2008-08-01",
            "_to": "2009-02-02"
          }
        }, {
          "ZWL": {
            "_from": "2009-02-02",
            "_to": "2009-04-12"
          }
        }, {
          "USD": {
            "_from": "2009-04-12"
          }
        }],
        "ZZ": [{
          "XAG": {
            "_tender": "false"
          }
        }, {
          "XAU": {
            "_tender": "false"
          }
        }, {
          "XBA": {
            "_tender": "false"
          }
        }, {
          "XBB": {
            "_tender": "false"
          }
        }, {
          "XBC": {
            "_tender": "false"
          }
        }, {
          "XBD": {
            "_tender": "false"
          }
        }, {
          "XDR": {
            "_tender": "false"
          }
        }, {
          "XPD": {
            "_tender": "false"
          }
        }, {
          "XPT": {
            "_tender": "false"
          }
        }, {
          "XSU": {
            "_tender": "false"
          }
        }, {
          "XTS": {
            "_tender": "false"
          }
        }, {
          "XUA": {
            "_tender": "false"
          }
        }, {
          "XXX": {
            "_tender": "false"
          }
        }, {
          "XRE": {
            "_tender": "false",
            "_to": "1999-11-30"
          }
        }, {
          "XFU": {
            "_tender": "false",
            "_to": "2013-11-30"
          }
        }, {
          "XFO": {
            "_tender": "false",
            "_from": "1930-01-01",
            "_to": "2003-04-01"
          }
        }]
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14794 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "dayPeriodRuleSet": {
      "af": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "00:00"
        }
      },
      "am": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ar": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "13:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "03:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "01:00",
          "_from": "00:00"
        },
        "night2": {
          "_before": "03:00",
          "_from": "01:00"
        }
      },
      "az": {
        "afternoon1": {
          "_before": "17:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "19:00",
          "_from": "17:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "19:00"
        },
        "night2": {
          "_before": "04:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "bg": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "14:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "11:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "14:00",
          "_from": "11:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "22:00"
        }
      },
      "bn": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "evening1": {
          "_before": "20:00",
          "_from": "18:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "20:00"
        }
      },
      "bs": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ca": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "19:00",
          "_from": "13:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "19:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "21:00"
        }
      },
      "ccp": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "evening1": {
          "_before": "20:00",
          "_from": "18:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "20:00"
        }
      },
      "chr": {
        "afternoon1": {
          "_before": "24:00",
          "_from": "12:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "cs": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "09:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "09:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "22:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "cy": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "da": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "05:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "00:00"
        }
      },
      "de": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "13:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "05:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "00:00"
        }
      },
      "ee": {
        "afternoon1": {
          "_before": "14:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "14:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "morning1": {
          "_before": "05:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "21:00"
        }
      },
      "el": {
        "afternoon1": {
          "_before": "17:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "20:00",
          "_from": "17:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "20:00"
        }
      },
      "en": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "es": {
        "evening1": {
          "_before": "20:00",
          "_from": "12:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "20:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "es-CO": {
        "evening1": {
          "_before": "20:00",
          "_from": "12:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "00:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "20:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "et": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "23:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "23:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "eu": {
        "afternoon1": {
          "_before": "14:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "19:00",
          "_from": "14:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "19:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "21:00"
        }
      },
      "fa": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "19:00",
          "_from": "13:00"
        },
        "morning1": {
          "_before": "04:00",
          "_from": "01:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "19:00"
        },
        "night2": {
          "_before": "01:00",
          "_from": "00:00"
        }
      },
      "fi": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "23:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "05:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "23:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "fil": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "fr": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "gl": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "13:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "21:00"
        }
      },
      "gsw": {
        "afternoon1": {
          "_before": "14:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "14:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "00:00"
        }
      },
      "gu": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "20:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "20:00"
        }
      },
      "he": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "03:00",
          "_from": "22:00"
        },
        "night2": {
          "_before": "06:00",
          "_from": "03:00"
        }
      },
      "hi": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "20:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "20:00"
        }
      },
      "hr": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "hu": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "09:00",
          "_from": "06:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "09:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "21:00"
        },
        "night2": {
          "_before": "06:00",
          "_from": "04:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "hy": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "id": {
        "afternoon1": {
          "_before": "15:00",
          "_from": "10:00"
        },
        "evening1": {
          "_before": "18:00",
          "_from": "15:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "00:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "is": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "it": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ja": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "19:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "23:00",
          "_from": "19:00"
        },
        "night2": {
          "_before": "04:00",
          "_from": "23:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ka": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "kk": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "km": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "00:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "kn": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        }
      },
      "ko": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "03:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "03:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ky": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "lo": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "20:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "20:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "lt": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "lv": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "23:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "23:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "mk": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ml": {
        "afternoon1": {
          "_before": "14:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "15:00",
          "_from": "14:00"
        },
        "evening1": {
          "_before": "18:00",
          "_from": "15:00"
        },
        "evening2": {
          "_before": "19:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "03:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "03:00",
          "_from": "19:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "mn": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "mr": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "evening2": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ms": {
        "afternoon1": {
          "_before": "14:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "19:00",
          "_from": "14:00"
        },
        "morning1": {
          "_before": "01:00",
          "_from": "00:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "01:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "19:00"
        }
      },
      "my": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "19:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "00:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "19:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "nb": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "06:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        }
      },
      "ne": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "19:00",
          "_from": "16:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "19:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "22:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "nl": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        }
      },
      "pa": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "21:00"
        }
      },
      "pl": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "06:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "pt": {
        "afternoon1": {
          "_before": "19:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "19:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ro": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "22:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "root": {
        "am": {
          "_before": "12:00",
          "_from": "00:00"
        },
        "pm": {
          "_before": "24:00",
          "_from": "12:00"
        }
      },
      "ru": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "si": {
        "afternoon1": {
          "_before": "14:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "18:00",
          "_from": "14:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "01:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "night2": {
          "_before": "01:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "sk": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "09:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "09:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "22:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "sl": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "06:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "22:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "sq": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "09:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "09:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "sr": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "sv": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "10:00",
          "_from": "05:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "10:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "00:00"
        }
      },
      "sw": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "19:00",
          "_from": "16:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "07:00",
          "_from": "04:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "07:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "19:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ta": {
        "afternoon1": {
          "_before": "14:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "16:00",
          "_from": "14:00"
        },
        "evening1": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "evening2": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "05:00",
          "_from": "03:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "05:00"
        },
        "night1": {
          "_before": "03:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "te": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        }
      },
      "th": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "16:00",
          "_from": "13:00"
        },
        "evening1": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "evening2": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "tr": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "19:00",
          "_from": "18:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "19:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "11:00",
          "_from": "06:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "11:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "uk": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "00:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "ur": {
        "afternoon1": {
          "_before": "16:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "18:00",
          "_from": "16:00"
        },
        "evening1": {
          "_before": "20:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "20:00"
        }
      },
      "uz": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "11:00"
        },
        "evening1": {
          "_before": "22:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "11:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "06:00",
          "_from": "22:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "vi": {
        "afternoon1": {
          "_before": "18:00",
          "_from": "12:00"
        },
        "evening1": {
          "_before": "21:00",
          "_from": "18:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "12:00",
          "_from": "04:00"
        },
        "night1": {
          "_before": "04:00",
          "_from": "21:00"
        },
        "noon": {
          "_at": "12:00"
        }
      },
      "yue": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "19:00",
          "_from": "13:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "19:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "08:00",
          "_from": "05:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "08:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "00:00"
        }
      },
      "zh": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "12:00"
        },
        "afternoon2": {
          "_before": "19:00",
          "_from": "13:00"
        },
        "evening1": {
          "_before": "24:00",
          "_from": "19:00"
        },
        "midnight": {
          "_at": "00:00"
        },
        "morning1": {
          "_before": "08:00",
          "_from": "05:00"
        },
        "morning2": {
          "_before": "12:00",
          "_from": "08:00"
        },
        "night1": {
          "_before": "05:00",
          "_from": "00:00"
        }
      },
      "zu": {
        "afternoon1": {
          "_before": "13:00",
          "_from": "10:00"
        },
        "evening1": {
          "_before": "19:00",
          "_from": "13:00"
        },
        "morning1": {
          "_before": "06:00",
          "_from": "00:00"
        },
        "morning2": {
          "_before": "10:00",
          "_from": "06:00"
        },
        "night1": {
          "_before": "24:00",
          "_from": "19:00"
        }
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 11914 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "gender": {
      "personList": {
        "ar": "maleTaints",
        "ca": "maleTaints",
        "cs": "maleTaints",
        "es": "maleTaints",
        "fr": "maleTaints",
        "he": "maleTaints",
        "hi": "maleTaints",
        "hr": "maleTaints",
        "it": "maleTaints",
        "lt": "maleTaints",
        "lv": "maleTaints",
        "mr": "maleTaints",
        "nl": "maleTaints",
        "pl": "maleTaints",
        "pt": "maleTaints",
        "ro": "maleTaints",
        "ru": "maleTaints",
        "sk": "maleTaints",
        "sl": "maleTaints",
        "sr": "maleTaints",
        "uk": "maleTaints",
        "ur": "maleTaints",
        "zh": "maleTaints",
        "zh-Hant": "maleTaints",
        "el": "mixedNeutral",
        "is": "mixedNeutral",
        "af": "neutral",
        "bg": "neutral",
        "bn": "neutral",
        "da": "neutral",
        "de": "neutral",
        "en": "neutral",
        "et": "neutral",
        "eu": "neutral",
        "fa": "neutral",
        "fi": "neutral",
        "fil": "neutral",
        "gu": "neutral",
        "hu": "neutral",
        "id": "neutral",
        "ja": "neutral",
        "kn": "neutral",
        "ko": "neutral",
        "ml": "neutral",
        "ms": "neutral",
        "no": "neutral",
        "sv": "neutral",
        "sw": "neutral",
        "ta": "neutral",
        "te": "neutral",
        "th": "neutral",
        "tr": "neutral",
        "vi": "neutral",
        "zu": "neutral"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "languageData": {
      "aa": {
        "_scripts": ["Latn"]
      },
      "aa-alt-secondary": {
        "_territories": ["DJ", "ET"]
      },
      "ab": {
        "_scripts": ["Cyrl"]
      },
      "ab-alt-secondary": {
        "_territories": ["GE"]
      },
      "abq": {
        "_scripts": ["Cyrl"]
      },
      "abr": {
        "_scripts": ["Latn"]
      },
      "abr-alt-secondary": {
        "_territories": ["GH"]
      },
      "ace": {
        "_scripts": ["Latn"]
      },
      "ace-alt-secondary": {
        "_territories": ["ID"]
      },
      "ach": {
        "_scripts": ["Latn"]
      },
      "ach-alt-secondary": {
        "_territories": ["UG"]
      },
      "ada": {
        "_scripts": ["Latn"]
      },
      "ady": {
        "_scripts": ["Cyrl"]
      },
      "ady-alt-secondary": {
        "_territories": ["RU"]
      },
      "ae-alt-secondary": {
        "_scripts": ["Avst"]
      },
      "aeb": {
        "_scripts": ["Arab"]
      },
      "aeb-alt-secondary": {
        "_territories": ["TN"]
      },
      "af": {
        "_scripts": ["Latn"]
      },
      "af-alt-secondary": {
        "_territories": ["NA", "ZA"]
      },
      "agq": {
        "_scripts": ["Latn"]
      },
      "aii": {
        "_scripts": ["Cyrl"]
      },
      "aii-alt-secondary": {
        "_scripts": ["Syrc"]
      },
      "ain-alt-secondary": {
        "_scripts": ["Kana", "Latn"]
      },
      "ak": {
        "_scripts": ["Latn"]
      },
      "ak-alt-secondary": {
        "_territories": ["GH"]
      },
      "akk-alt-secondary": {
        "_scripts": ["Xsux"]
      },
      "akz": {
        "_scripts": ["Latn"]
      },
      "ale": {
        "_scripts": ["Latn"]
      },
      "aln": {
        "_scripts": ["Latn"]
      },
      "aln-alt-secondary": {
        "_territories": ["XK"]
      },
      "alt": {
        "_scripts": ["Cyrl"]
      },
      "am": {
        "_territories": ["ET"],
        "_scripts": ["Ethi"]
      },
      "amo": {
        "_scripts": ["Latn"]
      },
      "an": {
        "_scripts": ["Latn"]
      },
      "ang-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "anp": {
        "_scripts": ["Deva"]
      },
      "aoz": {
        "_scripts": ["Latn"]
      },
      "ar": {
        "_territories": ["AE", "BH", "DJ", "DZ", "EG", "EH", "ER", "IL", "IQ", "JO", "KM", "KW", "LB", "LY", "MA", "MR", "OM", "PS", "QA", "SA", "SD", "SO", "SY", "TD", "TN", "YE"],
        "_scripts": ["Arab"]
      },
      "ar-alt-secondary": {
        "_territories": ["IR", "SS"],
        "_scripts": ["Syrc"]
      },
      "arc-alt-secondary": {
        "_scripts": ["Armi", "Nbat", "Palm"]
      },
      "arn": {
        "_scripts": ["Latn"]
      },
      "aro": {
        "_scripts": ["Latn"]
      },
      "arp": {
        "_scripts": ["Latn"]
      },
      "arq": {
        "_scripts": ["Arab"]
      },
      "arq-alt-secondary": {
        "_territories": ["DZ"]
      },
      "arw-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "ary": {
        "_scripts": ["Arab"]
      },
      "ary-alt-secondary": {
        "_territories": ["MA"]
      },
      "arz": {
        "_scripts": ["Arab"]
      },
      "arz-alt-secondary": {
        "_territories": ["EG"]
      },
      "as": {
        "_scripts": ["Beng"]
      },
      "as-alt-secondary": {
        "_territories": ["IN"]
      },
      "asa": {
        "_scripts": ["Latn"]
      },
      "ast": {
        "_scripts": ["Latn"]
      },
      "ast-alt-secondary": {
        "_territories": ["ES"]
      },
      "atj": {
        "_scripts": ["Latn"]
      },
      "av": {
        "_scripts": ["Cyrl"]
      },
      "av-alt-secondary": {
        "_territories": ["RU"]
      },
      "avk-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "awa": {
        "_scripts": ["Deva"]
      },
      "awa-alt-secondary": {
        "_territories": ["IN"]
      },
      "ay": {
        "_territories": ["BO"],
        "_scripts": ["Latn"]
      },
      "az": {
        "_territories": ["AZ"],
        "_scripts": ["Arab", "Cyrl", "Latn"]
      },
      "az-alt-secondary": {
        "_territories": ["IQ", "IR", "RU"]
      },
      "ba": {
        "_scripts": ["Cyrl"]
      },
      "ba-alt-secondary": {
        "_territories": ["RU"]
      },
      "bal": {
        "_scripts": ["Arab"]
      },
      "bal-alt-secondary": {
        "_territories": ["AF", "IR", "PK"],
        "_scripts": ["Latn"]
      },
      "ban": {
        "_scripts": ["Latn"]
      },
      "ban-alt-secondary": {
        "_territories": ["ID"],
        "_scripts": ["Bali"]
      },
      "bap": {
        "_scripts": ["Deva"]
      },
      "bar": {
        "_scripts": ["Latn"]
      },
      "bar-alt-secondary": {
        "_territories": ["AT", "DE"]
      },
      "bas": {
        "_scripts": ["Latn"]
      },
      "bax": {
        "_scripts": ["Bamu"]
      },
      "bbc": {
        "_scripts": ["Latn"]
      },
      "bbc-alt-secondary": {
        "_territories": ["ID"],
        "_scripts": ["Batk"]
      },
      "bbj": {
        "_scripts": ["Latn"]
      },
      "bci": {
        "_scripts": ["Latn"]
      },
      "bci-alt-secondary": {
        "_territories": ["CI"]
      },
      "be": {
        "_territories": ["BY"],
        "_scripts": ["Cyrl"]
      },
      "bej": {
        "_scripts": ["Arab"]
      },
      "bej-alt-secondary": {
        "_territories": ["SD"]
      },
      "bem": {
        "_scripts": ["Latn"]
      },
      "bem-alt-secondary": {
        "_territories": ["ZM"]
      },
      "bew": {
        "_scripts": ["Latn"]
      },
      "bew-alt-secondary": {
        "_territories": ["ID"]
      },
      "bez": {
        "_scripts": ["Latn"]
      },
      "bfd": {
        "_scripts": ["Latn"]
      },
      "bfq": {
        "_scripts": ["Taml"]
      },
      "bft": {
        "_scripts": ["Arab"]
      },
      "bft-alt-secondary": {
        "_scripts": ["Tibt"]
      },
      "bfy": {
        "_scripts": ["Deva"]
      },
      "bg": {
        "_territories": ["BG"],
        "_scripts": ["Cyrl"]
      },
      "bgc": {
        "_scripts": ["Deva"]
      },
      "bgc-alt-secondary": {
        "_territories": ["IN"]
      },
      "bgn": {
        "_scripts": ["Arab"]
      },
      "bgn-alt-secondary": {
        "_territories": ["PK"]
      },
      "bgx": {
        "_scripts": ["Grek"]
      },
      "bhb": {
        "_scripts": ["Deva"]
      },
      "bhb-alt-secondary": {
        "_territories": ["IN"]
      },
      "bhi": {
        "_scripts": ["Deva"]
      },
      "bhi-alt-secondary": {
        "_territories": ["IN"]
      },
      "bhk": {
        "_scripts": ["Latn"]
      },
      "bhk-alt-secondary": {
        "_territories": ["PH"]
      },
      "bho": {
        "_scripts": ["Deva"]
      },
      "bho-alt-secondary": {
        "_territories": ["IN", "MU", "NP"]
      },
      "bi": {
        "_territories": ["VU"],
        "_scripts": ["Latn"]
      },
      "bik": {
        "_scripts": ["Latn"]
      },
      "bik-alt-secondary": {
        "_territories": ["PH"]
      },
      "bin": {
        "_scripts": ["Latn"]
      },
      "bin-alt-secondary": {
        "_territories": ["NG"]
      },
      "bjj": {
        "_scripts": ["Deva"]
      },
      "bjj-alt-secondary": {
        "_territories": ["IN"]
      },
      "bjn": {
        "_scripts": ["Latn"]
      },
      "bjn-alt-secondary": {
        "_territories": ["ID"]
      },
      "bjt-alt-secondary": {
        "_territories": ["SN"]
      },
      "bkm": {
        "_scripts": ["Latn"]
      },
      "bku": {
        "_scripts": ["Latn"]
      },
      "bku-alt-secondary": {
        "_scripts": ["Buhd"]
      },
      "bla": {
        "_scripts": ["Latn"]
      },
      "blt": {
        "_scripts": ["Tavt"]
      },
      "bm": {
        "_scripts": ["Latn", "Nkoo"]
      },
      "bm-alt-secondary": {
        "_territories": ["ML"]
      },
      "bmq": {
        "_scripts": ["Latn"]
      },
      "bn": {
        "_territories": ["BD"],
        "_scripts": ["Beng"]
      },
      "bn-alt-secondary": {
        "_territories": ["IN"]
      },
      "bo": {
        "_scripts": ["Tibt"]
      },
      "bo-alt-secondary": {
        "_territories": ["CN"]
      },
      "bpy": {
        "_scripts": ["Beng"]
      },
      "bqi": {
        "_scripts": ["Arab"]
      },
      "bqi-alt-secondary": {
        "_territories": ["IR"]
      },
      "bqv": {
        "_scripts": ["Latn"]
      },
      "br": {
        "_scripts": ["Latn"]
      },
      "bra": {
        "_scripts": ["Deva"]
      },
      "brh": {
        "_scripts": ["Arab"]
      },
      "brh-alt-secondary": {
        "_territories": ["PK"],
        "_scripts": ["Latn"]
      },
      "brx": {
        "_scripts": ["Deva"]
      },
      "brx-alt-secondary": {
        "_territories": ["IN"]
      },
      "bs": {
        "_territories": ["BA"],
        "_scripts": ["Cyrl", "Latn"]
      },
      "bsc-alt-secondary": {
        "_territories": ["SN"]
      },
      "bss": {
        "_scripts": ["Latn"]
      },
      "bto": {
        "_scripts": ["Latn"]
      },
      "btv": {
        "_scripts": ["Deva"]
      },
      "bua": {
        "_scripts": ["Cyrl"]
      },
      "buc": {
        "_scripts": ["Latn"]
      },
      "buc-alt-secondary": {
        "_territories": ["YT"]
      },
      "bug": {
        "_scripts": ["Latn"]
      },
      "bug-alt-secondary": {
        "_territories": ["ID"],
        "_scripts": ["Bugi"]
      },
      "bum": {
        "_scripts": ["Latn"]
      },
      "bum-alt-secondary": {
        "_territories": ["CM"]
      },
      "bvb": {
        "_scripts": ["Latn"]
      },
      "byn": {
        "_scripts": ["Ethi"]
      },
      "byv": {
        "_scripts": ["Latn"]
      },
      "bze": {
        "_scripts": ["Latn"]
      },
      "bzx": {
        "_scripts": ["Latn"]
      },
      "ca": {
        "_territories": ["AD"],
        "_scripts": ["Latn"]
      },
      "ca-alt-secondary": {
        "_territories": ["ES"]
      },
      "cad": {
        "_scripts": ["Latn"]
      },
      "car": {
        "_scripts": ["Latn"]
      },
      "cay": {
        "_scripts": ["Latn"]
      },
      "cch": {
        "_scripts": ["Latn"]
      },
      "ccp": {
        "_scripts": ["Beng", "Cakm"]
      },
      "ce": {
        "_scripts": ["Cyrl"]
      },
      "ce-alt-secondary": {
        "_territories": ["RU"]
      },
      "ceb": {
        "_scripts": ["Latn"]
      },
      "ceb-alt-secondary": {
        "_territories": ["PH"]
      },
      "cgg": {
        "_scripts": ["Latn"]
      },
      "cgg-alt-secondary": {
        "_territories": ["UG"]
      },
      "ch": {
        "_territories": ["GU"],
        "_scripts": ["Latn"]
      },
      "chk": {
        "_scripts": ["Latn"]
      },
      "chk-alt-secondary": {
        "_territories": ["FM"]
      },
      "chm": {
        "_scripts": ["Cyrl"]
      },
      "chn-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "cho": {
        "_scripts": ["Latn"]
      },
      "chp": {
        "_scripts": ["Latn"]
      },
      "chp-alt-secondary": {
        "_scripts": ["Cans"]
      },
      "chr": {
        "_scripts": ["Cher"]
      },
      "chy": {
        "_scripts": ["Latn"]
      },
      "cja": {
        "_scripts": ["Arab"]
      },
      "cja-alt-secondary": {
        "_scripts": ["Cham"]
      },
      "cjm": {
        "_scripts": ["Cham"]
      },
      "cjm-alt-secondary": {
        "_scripts": ["Arab"]
      },
      "cjs": {
        "_scripts": ["Cyrl"]
      },
      "ckb": {
        "_scripts": ["Arab"]
      },
      "ckb-alt-secondary": {
        "_territories": ["IQ", "IR"]
      },
      "ckt": {
        "_scripts": ["Cyrl"]
      },
      "co": {
        "_scripts": ["Latn"]
      },
      "cop-alt-secondary": {
        "_scripts": ["Arab", "Copt", "Grek"]
      },
      "cps": {
        "_scripts": ["Latn"]
      },
      "cr": {
        "_scripts": ["Cans", "Latn"]
      },
      "crh": {
        "_scripts": ["Cyrl"]
      },
      "crj": {
        "_scripts": ["Cans"]
      },
      "crj-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "crk": {
        "_scripts": ["Cans"]
      },
      "crl": {
        "_scripts": ["Cans"]
      },
      "crl-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "crm": {
        "_scripts": ["Cans"]
      },
      "crs": {
        "_scripts": ["Latn"]
      },
      "crs-alt-secondary": {
        "_territories": ["SC"]
      },
      "cs": {
        "_territories": ["CZ"],
        "_scripts": ["Latn"]
      },
      "cs-alt-secondary": {
        "_territories": ["SK"]
      },
      "csb-alt-secondary": {
        "_territories": ["PL"],
        "_scripts": ["Latn"]
      },
      "csw": {
        "_scripts": ["Cans"]
      },
      "ctd": {
        "_scripts": ["Latn"]
      },
      "cu-alt-secondary": {
        "_scripts": ["Cyrl"]
      },
      "cv": {
        "_scripts": ["Cyrl"]
      },
      "cv-alt-secondary": {
        "_territories": ["RU"]
      },
      "cy": {
        "_scripts": ["Latn"]
      },
      "cy-alt-secondary": {
        "_territories": ["GB"]
      },
      "da": {
        "_territories": ["DK"],
        "_scripts": ["Latn"]
      },
      "da-alt-secondary": {
        "_territories": ["DE"]
      },
      "dak": {
        "_scripts": ["Latn"]
      },
      "dar": {
        "_scripts": ["Cyrl"]
      },
      "dav": {
        "_scripts": ["Latn"]
      },
      "dcc": {
        "_scripts": ["Arab"]
      },
      "dcc-alt-secondary": {
        "_territories": ["IN"]
      },
      "de": {
        "_territories": ["AT", "BE", "CH", "DE", "LI", "LU"],
        "_scripts": ["Latn"]
      },
      "de-alt-secondary": {
        "_territories": ["BR", "CZ", "DK", "FR", "GB", "HU", "KZ", "NL", "PL", "SI", "SK", "US"],
        "_scripts": ["Runr"]
      },
      "del": {
        "_scripts": ["Latn"]
      },
      "den": {
        "_scripts": ["Latn"]
      },
      "den-alt-secondary": {
        "_scripts": ["Cans"]
      },
      "dgr": {
        "_scripts": ["Latn"]
      },
      "din": {
        "_scripts": ["Latn"]
      },
      "dje": {
        "_scripts": ["Latn"]
      },
      "dje-alt-secondary": {
        "_territories": ["NE"]
      },
      "dng": {
        "_scripts": ["Cyrl"]
      },
      "dnj": {
        "_scripts": ["Latn"]
      },
      "dnj-alt-secondary": {
        "_territories": ["CI"]
      },
      "doi": {
        "_scripts": ["Arab"]
      },
      "doi-alt-secondary": {
        "_territories": ["IN"],
        "_scripts": ["Takr"]
      },
      "dsb": {
        "_scripts": ["Latn"]
      },
      "dtm": {
        "_scripts": ["Latn"]
      },
      "dtp": {
        "_scripts": ["Latn"]
      },
      "dty": {
        "_scripts": ["Deva"]
      },
      "dua": {
        "_scripts": ["Latn"]
      },
      "dum-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "dv": {
        "_territories": ["MV"],
        "_scripts": ["Thaa"]
      },
      "dyo": {
        "_scripts": ["Latn"]
      },
      "dyo-alt-secondary": {
        "_territories": ["SN"],
        "_scripts": ["Arab"]
      },
      "dyu": {
        "_scripts": ["Latn"]
      },
      "dyu-alt-secondary": {
        "_territories": ["BF"]
      },
      "dz": {
        "_territories": ["BT"],
        "_scripts": ["Tibt"]
      },
      "ebu": {
        "_scripts": ["Latn"]
      },
      "ee": {
        "_scripts": ["Latn"]
      },
      "ee-alt-secondary": {
        "_territories": ["GH", "TG"]
      },
      "efi": {
        "_scripts": ["Latn"]
      },
      "efi-alt-secondary": {
        "_territories": ["NG"]
      },
      "egl": {
        "_scripts": ["Latn"]
      },
      "egy-alt-secondary": {
        "_scripts": ["Egyp"]
      },
      "eka": {
        "_scripts": ["Latn"]
      },
      "eky": {
        "_scripts": ["Kali"]
      },
      "el": {
        "_territories": ["CY", "GR"],
        "_scripts": ["Grek"]
      },
      "en": {
        "_territories": ["AG", "AI", "AS", "AU", "BB", "BI", "BM", "BS", "BW", "BZ", "CA", "CC", "CK", "CM", "CX", "DG", "DM", "ER", "FJ", "FK", "FM", "GB", "GD", "GG", "GH", "GI", "GM", "GU", "GY", "HK", "IE", "IM", "IN", "IO", "JE", "JM", "KE", "KI", "KN", "KY", "LC", "LR", "LS", "MG", "MH", "MP", "MS", "MT", "MU", "MW", "NA", "NF", "NG", "NR", "NU", "NZ", "PG", "PH", "PK", "PN", "PR", "PW", "RW", "SB", "SC", "SD", "SG", "SH", "SL", "SS", "SX", "SZ", "TC", "TK", "TO", "TT", "TV", "TZ", "UG", "UM", "US", "VC", "VG", "VI", "VU", "WS", "ZA", "ZM", "ZW"],
        "_scripts": ["Latn"]
      },
      "en-alt-secondary": {
        "_territories": ["AC", "AE", "AR", "AT", "BA", "BD", "BE", "BG", "BR", "CH", "CL", "CY", "CZ", "DE", "DK", "DZ", "EE", "EG", "ES", "ET", "FI", "FR", "GR", "HR", "HU", "IL", "IQ", "IT", "JO", "KZ", "LB", "LK", "LT", "LU", "LV", "MA", "MX", "MY", "NL", "PL", "PT", "RO", "SE", "SI", "SK", "TA", "TH", "TR", "YE"],
        "_scripts": ["Dsrt", "Shaw"]
      },
      "enm-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "eo": {
        "_scripts": ["Latn"]
      },
      "es": {
        "_territories": ["AR", "BO", "CL", "CO", "CR", "CU", "DO", "EA", "EC", "ES", "GQ", "GT", "HN", "IC", "MX", "NI", "PA", "PE", "PR", "PY", "SV", "UY", "VE"],
        "_scripts": ["Latn"]
      },
      "es-alt-secondary": {
        "_territories": ["AD", "BZ", "DE", "FR", "GI", "PH", "PT", "RO", "US"]
      },
      "esu": {
        "_scripts": ["Latn"]
      },
      "et": {
        "_territories": ["EE"],
        "_scripts": ["Latn"]
      },
      "ett-alt-secondary": {
        "_scripts": ["Ital", "Latn"]
      },
      "eu": {
        "_scripts": ["Latn"]
      },
      "eu-alt-secondary": {
        "_territories": ["ES"]
      },
      "evn": {
        "_scripts": ["Cyrl"]
      },
      "ewo": {
        "_scripts": ["Latn"]
      },
      "ext": {
        "_scripts": ["Latn"]
      },
      "fa": {
        "_territories": ["AF", "IR"],
        "_scripts": ["Arab"]
      },
      "fa-alt-secondary": {
        "_territories": ["PK"]
      },
      "fan": {
        "_scripts": ["Latn"]
      },
      "fan-alt-secondary": {
        "_territories": ["GQ"]
      },
      "ff": {
        "_scripts": ["Latn", "Adlm"]
      },
      "ff-alt-secondary": {
        "_territories": ["GN", "SN"]
      },
      "ffm": {
        "_scripts": ["Latn"]
      },
      "ffm-alt-secondary": {
        "_territories": ["ML"]
      },
      "fi": {
        "_territories": ["FI"],
        "_scripts": ["Latn"]
      },
      "fi-alt-secondary": {
        "_territories": ["EE", "SE"]
      },
      "fia": {
        "_scripts": ["Arab"]
      },
      "fil": {
        "_territories": ["PH"],
        "_scripts": ["Latn"]
      },
      "fil-alt-secondary": {
        "_territories": ["US"],
        "_scripts": ["Tglg"]
      },
      "fit": {
        "_scripts": ["Latn"]
      },
      "fj": {
        "_territories": ["FJ"],
        "_scripts": ["Latn"]
      },
      "fo": {
        "_territories": ["FO"],
        "_scripts": ["Latn"]
      },
      "fon": {
        "_scripts": ["Latn"]
      },
      "fon-alt-secondary": {
        "_territories": ["BJ"]
      },
      "fr": {
        "_territories": ["BE", "BF", "BI", "BJ", "BL", "CA", "CD", "CF", "CG", "CH", "CI", "CM", "DJ", "DZ", "FR", "GA", "GF", "GN", "GP", "GQ", "HT", "KM", "LU", "MA", "MC", "MF", "MG", "ML", "MQ", "MU", "NC", "NE", "PF", "PM", "RE", "RW", "SC", "SN", "SY", "TD", "TG", "TN", "VU", "WF", "YT"],
        "_scripts": ["Latn"]
      },
      "fr-alt-secondary": {
        "_territories": ["DE", "GB", "IT", "NL", "PT", "RO", "TF", "US"],
        "_scripts": ["Dupl"]
      },
      "frc": {
        "_scripts": ["Latn"]
      },
      "frm-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "fro-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "frp": {
        "_scripts": ["Latn"]
      },
      "frr": {
        "_scripts": ["Latn"]
      },
      "frs": {
        "_scripts": ["Latn"]
      },
      "fud": {
        "_scripts": ["Latn"]
      },
      "fud-alt-secondary": {
        "_territories": ["WF"]
      },
      "fuq": {
        "_scripts": ["Latn"]
      },
      "fuq-alt-secondary": {
        "_territories": ["NE"]
      },
      "fur": {
        "_scripts": ["Latn"]
      },
      "fuv": {
        "_scripts": ["Latn"]
      },
      "fuv-alt-secondary": {
        "_territories": ["NG"]
      },
      "fvr": {
        "_scripts": ["Latn"]
      },
      "fvr-alt-secondary": {
        "_territories": ["SD"]
      },
      "fy": {
        "_scripts": ["Latn"]
      },
      "fy-alt-secondary": {
        "_territories": ["NL"]
      },
      "ga": {
        "_territories": ["IE"],
        "_scripts": ["Latn"]
      },
      "ga-alt-secondary": {
        "_territories": ["GB"]
      },
      "gaa": {
        "_scripts": ["Latn"]
      },
      "gaa-alt-secondary": {
        "_territories": ["GH"]
      },
      "gag": {
        "_scripts": ["Latn"]
      },
      "gag-alt-secondary": {
        "_scripts": ["Cyrl"]
      },
      "gan": {
        "_scripts": ["Hans"]
      },
      "gan-alt-secondary": {
        "_territories": ["CN"]
      },
      "gay": {
        "_scripts": ["Latn"]
      },
      "gba": {
        "_scripts": ["Latn"]
      },
      "gbm": {
        "_scripts": ["Deva"]
      },
      "gbm-alt-secondary": {
        "_territories": ["IN"]
      },
      "gbz": {
        "_scripts": ["Arab"]
      },
      "gcr": {
        "_scripts": ["Latn"]
      },
      "gcr-alt-secondary": {
        "_territories": ["GF"]
      },
      "gd": {
        "_scripts": ["Latn"]
      },
      "gd-alt-secondary": {
        "_territories": ["GB"]
      },
      "gez-alt-secondary": {
        "_scripts": ["Ethi"]
      },
      "gil": {
        "_territories": ["KI"],
        "_scripts": ["Latn"]
      },
      "gjk": {
        "_scripts": ["Arab"]
      },
      "gju": {
        "_scripts": ["Arab"]
      },
      "gl": {
        "_scripts": ["Latn"]
      },
      "gl-alt-secondary": {
        "_territories": ["ES"]
      },
      "gld": {
        "_scripts": ["Cyrl"]
      },
      "glk": {
        "_scripts": ["Arab"]
      },
      "glk-alt-secondary": {
        "_territories": ["IR"]
      },
      "gmh-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "gn": {
        "_territories": ["PY"],
        "_scripts": ["Latn"]
      },
      "goh-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "gom": {
        "_scripts": ["Deva"]
      },
      "gom-alt-secondary": {
        "_territories": ["IN"]
      },
      "gon": {
        "_scripts": ["Deva", "Telu"]
      },
      "gon-alt-secondary": {
        "_territories": ["IN"]
      },
      "gor": {
        "_scripts": ["Latn"]
      },
      "gor-alt-secondary": {
        "_territories": ["ID"]
      },
      "gos": {
        "_scripts": ["Latn"]
      },
      "got-alt-secondary": {
        "_scripts": ["Goth"]
      },
      "grb": {
        "_scripts": ["Latn"]
      },
      "grc-alt-secondary": {
        "_scripts": ["Cprt", "Grek", "Linb"]
      },
      "grt": {
        "_scripts": ["Beng"]
      },
      "gsw": {
        "_territories": ["CH", "LI"],
        "_scripts": ["Latn"]
      },
      "gsw-alt-secondary": {
        "_territories": ["DE"]
      },
      "gu": {
        "_scripts": ["Gujr"]
      },
      "gu-alt-secondary": {
        "_territories": ["IN"]
      },
      "gub": {
        "_scripts": ["Latn"]
      },
      "guc": {
        "_scripts": ["Latn"]
      },
      "gur": {
        "_scripts": ["Latn"]
      },
      "guz": {
        "_scripts": ["Latn"]
      },
      "guz-alt-secondary": {
        "_territories": ["KE"]
      },
      "gv": {
        "_territories": ["IM"],
        "_scripts": ["Latn"]
      },
      "gvr": {
        "_scripts": ["Deva"]
      },
      "gvr-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "gwi": {
        "_scripts": ["Latn"]
      },
      "ha": {
        "_scripts": ["Arab", "Latn"]
      },
      "ha-alt-secondary": {
        "_territories": ["NE", "NG"]
      },
      "hai": {
        "_scripts": ["Latn"]
      },
      "hak": {
        "_scripts": ["Hans"]
      },
      "hak-alt-secondary": {
        "_territories": ["CN"]
      },
      "haw": {
        "_scripts": ["Latn"]
      },
      "haw-alt-secondary": {
        "_territories": ["US"]
      },
      "haz": {
        "_scripts": ["Arab"]
      },
      "haz-alt-secondary": {
        "_territories": ["AF"]
      },
      "he": {
        "_territories": ["IL"],
        "_scripts": ["Hebr"]
      },
      "hi": {
        "_territories": ["IN"],
        "_scripts": ["Deva"]
      },
      "hi-alt-secondary": {
        "_territories": ["FJ", "ZA"],
        "_scripts": ["Mahj"]
      },
      "hif": {
        "_territories": ["FJ"],
        "_scripts": ["Deva", "Latn"]
      },
      "hil": {
        "_scripts": ["Latn"]
      },
      "hil-alt-secondary": {
        "_territories": ["PH"]
      },
      "hit-alt-secondary": {
        "_scripts": ["Xsux"]
      },
      "hmd": {
        "_scripts": ["Plrd"]
      },
      "hmn": {
        "_scripts": ["Latn"]
      },
      "hmn-alt-secondary": {
        "_scripts": ["Hmng"]
      },
      "hnd": {
        "_scripts": ["Arab"]
      },
      "hne": {
        "_scripts": ["Deva"]
      },
      "hne-alt-secondary": {
        "_territories": ["IN"]
      },
      "hnj": {
        "_scripts": ["Laoo"]
      },
      "hnn": {
        "_scripts": ["Latn"]
      },
      "hnn-alt-secondary": {
        "_scripts": ["Hano"]
      },
      "hno": {
        "_scripts": ["Arab"]
      },
      "hno-alt-secondary": {
        "_territories": ["PK"]
      },
      "ho": {
        "_territories": ["PG"],
        "_scripts": ["Latn"]
      },
      "hoc": {
        "_scripts": ["Deva"]
      },
      "hoc-alt-secondary": {
        "_territories": ["IN"],
        "_scripts": ["Wara"]
      },
      "hoj": {
        "_scripts": ["Deva"]
      },
      "hoj-alt-secondary": {
        "_territories": ["IN"]
      },
      "hop": {
        "_scripts": ["Latn"]
      },
      "hr": {
        "_territories": ["BA", "HR"],
        "_scripts": ["Latn"]
      },
      "hr-alt-secondary": {
        "_territories": ["AT", "RS", "SI"]
      },
      "hsb": {
        "_scripts": ["Latn"]
      },
      "hsn": {
        "_scripts": ["Hans"]
      },
      "hsn-alt-secondary": {
        "_territories": ["CN"]
      },
      "ht": {
        "_territories": ["HT"],
        "_scripts": ["Latn"]
      },
      "hu": {
        "_territories": ["HU"],
        "_scripts": ["Latn"]
      },
      "hu-alt-secondary": {
        "_territories": ["AT", "RO", "RS"]
      },
      "hup": {
        "_scripts": ["Latn"]
      },
      "hy": {
        "_territories": ["AM"],
        "_scripts": ["Armn"]
      },
      "hy-alt-secondary": {
        "_territories": ["RU"]
      },
      "hz": {
        "_scripts": ["Latn"]
      },
      "ia-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "iba": {
        "_scripts": ["Latn"]
      },
      "ibb": {
        "_scripts": ["Latn"]
      },
      "ibb-alt-secondary": {
        "_territories": ["NG"]
      },
      "id": {
        "_territories": ["ID"],
        "_scripts": ["Latn"]
      },
      "id-alt-secondary": {
        "_scripts": ["Arab"]
      },
      "ife": {
        "_scripts": ["Latn"]
      },
      "ig": {
        "_scripts": ["Latn"]
      },
      "ig-alt-secondary": {
        "_territories": ["NG"]
      },
      "ii": {
        "_scripts": ["Yiii"]
      },
      "ii-alt-secondary": {
        "_territories": ["CN"],
        "_scripts": ["Latn"]
      },
      "ik": {
        "_scripts": ["Latn"]
      },
      "ikt": {
        "_scripts": ["Latn"]
      },
      "ikt-alt-secondary": {
        "_territories": ["CA"]
      },
      "ilo": {
        "_scripts": ["Latn"]
      },
      "ilo-alt-secondary": {
        "_territories": ["PH"]
      },
      "inh": {
        "_scripts": ["Cyrl"]
      },
      "inh-alt-secondary": {
        "_territories": ["RU"],
        "_scripts": ["Arab", "Latn"]
      },
      "is": {
        "_territories": ["IS"],
        "_scripts": ["Latn"]
      },
      "it": {
        "_territories": ["CH", "IT", "SM", "VA"],
        "_scripts": ["Latn"]
      },
      "it-alt-secondary": {
        "_territories": ["DE", "FR", "HR", "MT", "US"]
      },
      "iu": {
        "_scripts": ["Cans", "Latn"]
      },
      "iu-alt-secondary": {
        "_territories": ["CA"]
      },
      "izh": {
        "_scripts": ["Latn"]
      },
      "ja": {
        "_territories": ["JP"],
        "_scripts": ["Jpan"]
      },
      "jam": {
        "_scripts": ["Latn"]
      },
      "jam-alt-secondary": {
        "_territories": ["JM"]
      },
      "jgo": {
        "_scripts": ["Latn"]
      },
      "jmc": {
        "_scripts": ["Latn"]
      },
      "jml": {
        "_scripts": ["Deva"]
      },
      "jpr": {
        "_scripts": ["Hebr"]
      },
      "jrb": {
        "_scripts": ["Hebr"]
      },
      "jut-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "jv": {
        "_scripts": ["Latn"]
      },
      "jv-alt-secondary": {
        "_territories": ["ID"],
        "_scripts": ["Java"]
      },
      "ka": {
        "_territories": ["GE"],
        "_scripts": ["Geor"]
      },
      "kaa": {
        "_scripts": ["Cyrl"]
      },
      "kab": {
        "_scripts": ["Latn"]
      },
      "kab-alt-secondary": {
        "_territories": ["DZ"]
      },
      "kac": {
        "_scripts": ["Latn"]
      },
      "kaj": {
        "_scripts": ["Latn"]
      },
      "kam": {
        "_scripts": ["Latn"]
      },
      "kam-alt-secondary": {
        "_territories": ["KE"]
      },
      "kao": {
        "_scripts": ["Latn"]
      },
      "kbd": {
        "_scripts": ["Cyrl"]
      },
      "kbd-alt-secondary": {
        "_territories": ["RU"]
      },
      "kca": {
        "_scripts": ["Cyrl"]
      },
      "kcg": {
        "_scripts": ["Latn"]
      },
      "kck": {
        "_scripts": ["Latn"]
      },
      "kde": {
        "_scripts": ["Latn"]
      },
      "kde-alt-secondary": {
        "_territories": ["TZ"]
      },
      "kdt": {
        "_scripts": ["Thai"]
      },
      "kea": {
        "_scripts": ["Latn"]
      },
      "kea-alt-secondary": {
        "_territories": ["CV"]
      },
      "kfo": {
        "_scripts": ["Latn"]
      },
      "kfr": {
        "_scripts": ["Deva"]
      },
      "kfy": {
        "_scripts": ["Deva"]
      },
      "kfy-alt-secondary": {
        "_territories": ["IN"]
      },
      "kg": {
        "_scripts": ["Latn"]
      },
      "kg-alt-secondary": {
        "_territories": ["CD"]
      },
      "kge": {
        "_scripts": ["Latn"]
      },
      "kgp": {
        "_scripts": ["Latn"]
      },
      "kha": {
        "_scripts": ["Latn"]
      },
      "kha-alt-secondary": {
        "_territories": ["IN"],
        "_scripts": ["Beng"]
      },
      "khb": {
        "_scripts": ["Talu"]
      },
      "khn": {
        "_scripts": ["Deva"]
      },
      "khn-alt-secondary": {
        "_territories": ["IN"]
      },
      "khq": {
        "_scripts": ["Latn"]
      },
      "kht": {
        "_scripts": ["Mymr"]
      },
      "khw": {
        "_scripts": ["Arab"]
      },
      "ki": {
        "_scripts": ["Latn"]
      },
      "ki-alt-secondary": {
        "_territories": ["KE"]
      },
      "kiu": {
        "_scripts": ["Latn"]
      },
      "kj": {
        "_scripts": ["Latn"]
      },
      "kj-alt-secondary": {
        "_territories": ["NA"]
      },
      "kjg": {
        "_scripts": ["Laoo"]
      },
      "kjg-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "kjh": {
        "_scripts": ["Cyrl"]
      },
      "kk": {
        "_territories": ["KZ"],
        "_scripts": ["Arab", "Cyrl"]
      },
      "kk-alt-secondary": {
        "_territories": ["CN"]
      },
      "kkj": {
        "_scripts": ["Latn"]
      },
      "kl": {
        "_territories": ["GL"],
        "_scripts": ["Latn"]
      },
      "kl-alt-secondary": {
        "_territories": ["DK"]
      },
      "kln": {
        "_scripts": ["Latn"]
      },
      "kln-alt-secondary": {
        "_territories": ["KE"]
      },
      "km": {
        "_territories": ["KH"],
        "_scripts": ["Khmr"]
      },
      "kmb": {
        "_scripts": ["Latn"]
      },
      "kmb-alt-secondary": {
        "_territories": ["AO"]
      },
      "kn": {
        "_scripts": ["Knda"]
      },
      "kn-alt-secondary": {
        "_territories": ["IN"]
      },
      "knf-alt-secondary": {
        "_territories": ["SN"]
      },
      "ko": {
        "_territories": ["KP", "KR"],
        "_scripts": ["Kore"]
      },
      "ko-alt-secondary": {
        "_territories": ["CN", "US"]
      },
      "koi": {
        "_scripts": ["Cyrl"]
      },
      "koi-alt-secondary": {
        "_territories": ["RU"]
      },
      "kok": {
        "_scripts": ["Deva"]
      },
      "kok-alt-secondary": {
        "_territories": ["IN"]
      },
      "kos": {
        "_scripts": ["Latn"]
      },
      "kpe": {
        "_scripts": ["Latn"]
      },
      "kpy": {
        "_scripts": ["Cyrl"]
      },
      "kr": {
        "_scripts": ["Latn"]
      },
      "krc": {
        "_scripts": ["Cyrl"]
      },
      "krc-alt-secondary": {
        "_territories": ["RU"]
      },
      "kri": {
        "_scripts": ["Latn"]
      },
      "kri-alt-secondary": {
        "_territories": ["SL"]
      },
      "krj": {
        "_scripts": ["Latn"]
      },
      "krl": {
        "_scripts": ["Latn"]
      },
      "kru": {
        "_scripts": ["Deva"]
      },
      "kru-alt-secondary": {
        "_territories": ["IN"]
      },
      "ks": {
        "_scripts": ["Arab", "Deva"]
      },
      "ks-alt-secondary": {
        "_territories": ["IN"]
      },
      "ksb": {
        "_scripts": ["Latn"]
      },
      "ksf": {
        "_scripts": ["Latn"]
      },
      "ksh": {
        "_scripts": ["Latn"]
      },
      "ku": {
        "_scripts": ["Arab", "Cyrl", "Latn"]
      },
      "ku-alt-secondary": {
        "_territories": ["SY", "TR"]
      },
      "kum": {
        "_scripts": ["Cyrl"]
      },
      "kum-alt-secondary": {
        "_territories": ["RU"]
      },
      "kut": {
        "_scripts": ["Latn"]
      },
      "kv": {
        "_scripts": ["Cyrl"]
      },
      "kv-alt-secondary": {
        "_territories": ["RU"],
        "_scripts": ["Perm"]
      },
      "kvr": {
        "_scripts": ["Latn"]
      },
      "kvx": {
        "_scripts": ["Arab"]
      },
      "kw": {
        "_scripts": ["Latn"]
      },
      "kxm": {
        "_scripts": ["Thai"]
      },
      "kxm-alt-secondary": {
        "_territories": ["TH"]
      },
      "kxp": {
        "_scripts": ["Arab"]
      },
      "ky": {
        "_territories": ["KG"],
        "_scripts": ["Arab", "Cyrl", "Latn"]
      },
      "kyu": {
        "_scripts": ["Kali"]
      },
      "la-alt-secondary": {
        "_territories": ["VA"],
        "_scripts": ["Latn"]
      },
      "lab-alt-secondary": {
        "_scripts": ["Lina"]
      },
      "lad": {
        "_scripts": ["Hebr"]
      },
      "lag": {
        "_scripts": ["Latn"]
      },
      "lah": {
        "_scripts": ["Arab"]
      },
      "lah-alt-secondary": {
        "_territories": ["PK"]
      },
      "laj": {
        "_scripts": ["Latn"]
      },
      "laj-alt-secondary": {
        "_territories": ["UG"]
      },
      "lam": {
        "_scripts": ["Latn"]
      },
      "lb": {
        "_territories": ["LU"],
        "_scripts": ["Latn"]
      },
      "lbe": {
        "_scripts": ["Cyrl"]
      },
      "lbe-alt-secondary": {
        "_territories": ["RU"]
      },
      "lbw": {
        "_scripts": ["Latn"]
      },
      "lcp": {
        "_scripts": ["Thai"]
      },
      "lep": {
        "_scripts": ["Lepc"]
      },
      "lez": {
        "_scripts": ["Cyrl"]
      },
      "lez-alt-secondary": {
        "_territories": ["RU"],
        "_scripts": ["Aghb"]
      },
      "lfn-alt-secondary": {
        "_scripts": ["Cyrl", "Latn"]
      },
      "lg": {
        "_scripts": ["Latn"]
      },
      "lg-alt-secondary": {
        "_territories": ["UG"]
      },
      "li": {
        "_scripts": ["Latn"]
      },
      "lif": {
        "_scripts": ["Deva", "Limb"]
      },
      "lij": {
        "_scripts": ["Latn"]
      },
      "lis": {
        "_scripts": ["Lisu"]
      },
      "liv-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "ljp": {
        "_scripts": ["Latn"]
      },
      "ljp-alt-secondary": {
        "_territories": ["ID"]
      },
      "lki": {
        "_scripts": ["Arab"]
      },
      "lkt": {
        "_scripts": ["Latn"]
      },
      "lmn": {
        "_scripts": ["Telu"]
      },
      "lmn-alt-secondary": {
        "_territories": ["IN"]
      },
      "lmo": {
        "_scripts": ["Latn"]
      },
      "ln": {
        "_scripts": ["Latn"]
      },
      "ln-alt-secondary": {
        "_territories": ["CD"]
      },
      "lo": {
        "_territories": ["LA"],
        "_scripts": ["Laoo"]
      },
      "lol": {
        "_scripts": ["Latn"]
      },
      "loz": {
        "_scripts": ["Latn"]
      },
      "lrc": {
        "_scripts": ["Arab"]
      },
      "lrc-alt-secondary": {
        "_territories": ["IR"]
      },
      "lt": {
        "_territories": ["LT"],
        "_scripts": ["Latn"]
      },
      "lt-alt-secondary": {
        "_territories": ["PL"]
      },
      "ltg": {
        "_scripts": ["Latn"]
      },
      "lu": {
        "_scripts": ["Latn"]
      },
      "lu-alt-secondary": {
        "_territories": ["CD"]
      },
      "lua": {
        "_scripts": ["Latn"]
      },
      "lua-alt-secondary": {
        "_territories": ["CD"]
      },
      "lui-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "lun": {
        "_scripts": ["Latn"]
      },
      "luo": {
        "_scripts": ["Latn"]
      },
      "luo-alt-secondary": {
        "_territories": ["KE"]
      },
      "lus": {
        "_scripts": ["Beng"]
      },
      "lut-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "luy": {
        "_scripts": ["Latn"]
      },
      "luy-alt-secondary": {
        "_territories": ["KE"]
      },
      "luz": {
        "_scripts": ["Arab"]
      },
      "luz-alt-secondary": {
        "_territories": ["IR"]
      },
      "lv": {
        "_territories": ["LV"],
        "_scripts": ["Latn"]
      },
      "lwl": {
        "_scripts": ["Thai"]
      },
      "lzh-alt-secondary": {
        "_scripts": ["Hans"]
      },
      "lzz": {
        "_scripts": ["Geor", "Latn"]
      },
      "mad": {
        "_scripts": ["Latn"]
      },
      "mad-alt-secondary": {
        "_territories": ["ID"]
      },
      "maf": {
        "_scripts": ["Latn"]
      },
      "mag": {
        "_scripts": ["Deva"]
      },
      "mag-alt-secondary": {
        "_territories": ["IN"]
      },
      "mai": {
        "_scripts": ["Deva"]
      },
      "mai-alt-secondary": {
        "_territories": ["IN", "NP"],
        "_scripts": ["Tirh"]
      },
      "mak": {
        "_scripts": ["Latn"]
      },
      "mak-alt-secondary": {
        "_territories": ["ID"],
        "_scripts": ["Bugi"]
      },
      "man": {
        "_scripts": ["Latn", "Nkoo"]
      },
      "man-alt-secondary": {
        "_territories": ["GM", "GN"]
      },
      "mas": {
        "_scripts": ["Latn"]
      },
      "maz": {
        "_scripts": ["Latn"]
      },
      "mdf": {
        "_scripts": ["Cyrl"]
      },
      "mdf-alt-secondary": {
        "_territories": ["RU"]
      },
      "mdh": {
        "_scripts": ["Latn"]
      },
      "mdh-alt-secondary": {
        "_territories": ["PH"]
      },
      "mdr": {
        "_scripts": ["Latn"]
      },
      "mdr-alt-secondary": {
        "_scripts": ["Bugi"]
      },
      "mdt": {
        "_scripts": ["Latn"]
      },
      "men": {
        "_scripts": ["Latn"]
      },
      "men-alt-secondary": {
        "_territories": ["SL"],
        "_scripts": ["Mend"]
      },
      "mer": {
        "_scripts": ["Latn"]
      },
      "mer-alt-secondary": {
        "_territories": ["KE"]
      },
      "mey-alt-secondary": {
        "_territories": ["SN"]
      },
      "mfa": {
        "_scripts": ["Arab"]
      },
      "mfa-alt-secondary": {
        "_territories": ["TH"]
      },
      "mfe": {
        "_scripts": ["Latn"]
      },
      "mfe-alt-secondary": {
        "_territories": ["MU"]
      },
      "mfv-alt-secondary": {
        "_territories": ["SN"]
      },
      "mg": {
        "_territories": ["MG"],
        "_scripts": ["Latn"]
      },
      "mgh": {
        "_scripts": ["Latn"]
      },
      "mgh-alt-secondary": {
        "_territories": ["MZ"]
      },
      "mgo": {
        "_scripts": ["Latn"]
      },
      "mgp": {
        "_scripts": ["Deva"]
      },
      "mgy": {
        "_scripts": ["Latn"]
      },
      "mh": {
        "_territories": ["MH"],
        "_scripts": ["Latn"]
      },
      "mi": {
        "_territories": ["NZ"],
        "_scripts": ["Latn"]
      },
      "mic": {
        "_scripts": ["Latn"]
      },
      "min": {
        "_scripts": ["Latn"]
      },
      "min-alt-secondary": {
        "_territories": ["ID"]
      },
      "mk": {
        "_territories": ["MK"],
        "_scripts": ["Cyrl"]
      },
      "ml": {
        "_scripts": ["Mlym"]
      },
      "ml-alt-secondary": {
        "_territories": ["IN"]
      },
      "mls": {
        "_scripts": ["Latn"]
      },
      "mn": {
        "_territories": ["MN"],
        "_scripts": ["Cyrl", "Mong"]
      },
      "mn-alt-secondary": {
        "_territories": ["CN"],
        "_scripts": ["Phag"]
      },
      "mnc-alt-secondary": {
        "_scripts": ["Mong"]
      },
      "mni": {
        "_scripts": ["Beng"]
      },
      "mni-alt-secondary": {
        "_territories": ["IN"],
        "_scripts": ["Mtei"]
      },
      "mns": {
        "_scripts": ["Cyrl"]
      },
      "mnw": {
        "_scripts": ["Mymr"]
      },
      "moe": {
        "_scripts": ["Latn"]
      },
      "moh": {
        "_scripts": ["Latn"]
      },
      "mos": {
        "_scripts": ["Latn"]
      },
      "mos-alt-secondary": {
        "_territories": ["BF"]
      },
      "mr": {
        "_scripts": ["Deva"]
      },
      "mr-alt-secondary": {
        "_territories": ["IN"],
        "_scripts": ["Modi"]
      },
      "mrd": {
        "_scripts": ["Deva"]
      },
      "mrj": {
        "_scripts": ["Cyrl"]
      },
      "mro": {
        "_scripts": ["Latn"]
      },
      "mro-alt-secondary": {
        "_scripts": ["Mroo"]
      },
      "ms": {
        "_territories": ["BN", "MY", "SG"],
        "_scripts": ["Arab", "Latn"]
      },
      "ms-alt-secondary": {
        "_territories": ["CC", "ID"]
      },
      "mt": {
        "_territories": ["MT"],
        "_scripts": ["Latn"]
      },
      "mtr": {
        "_scripts": ["Deva"]
      },
      "mtr-alt-secondary": {
        "_territories": ["IN"]
      },
      "mua": {
        "_scripts": ["Latn"]
      },
      "mus": {
        "_scripts": ["Latn"]
      },
      "mvy": {
        "_scripts": ["Arab"]
      },
      "mwk": {
        "_scripts": ["Latn"]
      },
      "mwl": {
        "_scripts": ["Latn"]
      },
      "mwr": {
        "_scripts": ["Deva"]
      },
      "mwr-alt-secondary": {
        "_territories": ["IN"]
      },
      "mwv": {
        "_scripts": ["Latn"]
      },
      "mxc": {
        "_scripts": ["Latn"]
      },
      "my": {
        "_territories": ["MM"],
        "_scripts": ["Mymr"]
      },
      "myv": {
        "_scripts": ["Cyrl"]
      },
      "myv-alt-secondary": {
        "_territories": ["RU"]
      },
      "myx": {
        "_scripts": ["Latn"]
      },
      "myx-alt-secondary": {
        "_territories": ["UG"]
      },
      "myz-alt-secondary": {
        "_scripts": ["Mand"]
      },
      "mzn": {
        "_scripts": ["Arab"]
      },
      "mzn-alt-secondary": {
        "_territories": ["IR"]
      },
      "na": {
        "_territories": ["NR"],
        "_scripts": ["Latn"]
      },
      "nan": {
        "_scripts": ["Hans"]
      },
      "nan-alt-secondary": {
        "_territories": ["CN"]
      },
      "nap": {
        "_scripts": ["Latn"]
      },
      "naq": {
        "_scripts": ["Latn"]
      },
      "nb": {
        "_territories": ["NO", "SJ"],
        "_scripts": ["Latn"]
      },
      "nch": {
        "_scripts": ["Latn"]
      },
      "nd": {
        "_territories": ["ZW"],
        "_scripts": ["Latn"]
      },
      "ndc": {
        "_scripts": ["Latn"]
      },
      "ndc-alt-secondary": {
        "_territories": ["MZ"]
      },
      "nds": {
        "_scripts": ["Latn"]
      },
      "nds-alt-secondary": {
        "_territories": ["DE", "NL"]
      },
      "ne": {
        "_territories": ["NP"],
        "_scripts": ["Deva"]
      },
      "ne-alt-secondary": {
        "_territories": ["IN"]
      },
      "new": {
        "_scripts": ["Deva"]
      },
      "ng": {
        "_scripts": ["Latn"]
      },
      "ng-alt-secondary": {
        "_territories": ["NA"]
      },
      "ngl": {
        "_scripts": ["Latn"]
      },
      "ngl-alt-secondary": {
        "_territories": ["MZ"]
      },
      "nhe": {
        "_scripts": ["Latn"]
      },
      "nhw": {
        "_scripts": ["Latn"]
      },
      "nia": {
        "_scripts": ["Latn"]
      },
      "nij": {
        "_scripts": ["Latn"]
      },
      "niu": {
        "_territories": ["NU"],
        "_scripts": ["Latn"]
      },
      "njo": {
        "_scripts": ["Latn"]
      },
      "nl": {
        "_territories": ["AW", "BE", "BQ", "CW", "NL", "SR", "SX"],
        "_scripts": ["Latn"]
      },
      "nl-alt-secondary": {
        "_territories": ["DE"]
      },
      "nmg": {
        "_scripts": ["Latn"]
      },
      "nn": {
        "_territories": ["NO"],
        "_scripts": ["Latn"]
      },
      "nnh": {
        "_scripts": ["Latn"]
      },
      "nod": {
        "_scripts": ["Lana"]
      },
      "nod-alt-secondary": {
        "_territories": ["TH"]
      },
      "noe": {
        "_scripts": ["Deva"]
      },
      "noe-alt-secondary": {
        "_territories": ["IN"]
      },
      "nog": {
        "_scripts": ["Cyrl"]
      },
      "non-alt-secondary": {
        "_scripts": ["Runr"]
      },
      "nov-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "nqo": {
        "_scripts": ["Nkoo"]
      },
      "nr": {
        "_scripts": ["Latn"]
      },
      "nr-alt-secondary": {
        "_territories": ["ZA"]
      },
      "nsk": {
        "_scripts": ["Cans"]
      },
      "nsk-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "nso": {
        "_scripts": ["Latn"]
      },
      "nso-alt-secondary": {
        "_territories": ["ZA"]
      },
      "nus": {
        "_scripts": ["Latn"]
      },
      "nv": {
        "_scripts": ["Latn"]
      },
      "nxq": {
        "_scripts": ["Latn"]
      },
      "ny": {
        "_territories": ["MW"],
        "_scripts": ["Latn"]
      },
      "ny-alt-secondary": {
        "_territories": ["ZM"]
      },
      "nym": {
        "_scripts": ["Latn"]
      },
      "nym-alt-secondary": {
        "_territories": ["TZ"]
      },
      "nyn": {
        "_scripts": ["Latn"]
      },
      "nyn-alt-secondary": {
        "_territories": ["UG"]
      },
      "nyo": {
        "_scripts": ["Latn"]
      },
      "nzi": {
        "_scripts": ["Latn"]
      },
      "oc": {
        "_scripts": ["Latn"]
      },
      "oc-alt-secondary": {
        "_territories": ["FR"]
      },
      "oj": {
        "_scripts": ["Cans"]
      },
      "oj-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "om": {
        "_scripts": ["Latn"]
      },
      "om-alt-secondary": {
        "_territories": ["ET"],
        "_scripts": ["Ethi"]
      },
      "or": {
        "_scripts": ["Orya"]
      },
      "or-alt-secondary": {
        "_territories": ["IN"]
      },
      "os": {
        "_scripts": ["Cyrl"]
      },
      "os-alt-secondary": {
        "_territories": ["GE"]
      },
      "osa": {
        "_scripts": ["Latn"]
      },
      "osc-alt-secondary": {
        "_scripts": ["Ital", "Latn"]
      },
      "otk-alt-secondary": {
        "_scripts": ["Orkh"]
      },
      "pa": {
        "_scripts": ["Arab", "Guru"]
      },
      "pa-alt-secondary": {
        "_territories": ["IN", "PK"]
      },
      "pag": {
        "_scripts": ["Latn"]
      },
      "pag-alt-secondary": {
        "_territories": ["PH"]
      },
      "pal-alt-secondary": {
        "_scripts": ["Phli", "Phlp"]
      },
      "pam": {
        "_scripts": ["Latn"]
      },
      "pam-alt-secondary": {
        "_territories": ["PH"]
      },
      "pap": {
        "_territories": ["AW", "CW"],
        "_scripts": ["Latn"]
      },
      "pap-alt-secondary": {
        "_territories": ["BQ"]
      },
      "pau": {
        "_territories": ["PW"],
        "_scripts": ["Latn"]
      },
      "pcd": {
        "_scripts": ["Latn"]
      },
      "pcm": {
        "_scripts": ["Latn"]
      },
      "pcm-alt-secondary": {
        "_territories": ["NG"]
      },
      "pdc": {
        "_scripts": ["Latn"]
      },
      "pdt": {
        "_scripts": ["Latn"]
      },
      "peo-alt-secondary": {
        "_scripts": ["Xpeo"]
      },
      "pfl": {
        "_scripts": ["Latn"]
      },
      "phn-alt-secondary": {
        "_scripts": ["Phnx"]
      },
      "pi-alt-secondary": {
        "_scripts": ["Deva", "Sinh", "Thai"]
      },
      "pko": {
        "_scripts": ["Latn"]
      },
      "pl": {
        "_territories": ["PL"],
        "_scripts": ["Latn"]
      },
      "pl-alt-secondary": {
        "_territories": ["UA"]
      },
      "pms": {
        "_scripts": ["Latn"]
      },
      "pnt": {
        "_scripts": ["Cyrl", "Grek", "Latn"]
      },
      "pon": {
        "_scripts": ["Latn"]
      },
      "pon-alt-secondary": {
        "_territories": ["FM"]
      },
      "prd": {
        "_scripts": ["Arab"]
      },
      "prg-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "pro-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "ps": {
        "_territories": ["AF"],
        "_scripts": ["Arab"]
      },
      "ps-alt-secondary": {
        "_territories": ["PK"]
      },
      "pt": {
        "_territories": ["AO", "BR", "CV", "GQ", "GW", "MO", "MZ", "PT", "ST", "TL"],
        "_scripts": ["Latn"]
      },
      "puu": {
        "_scripts": ["Latn"]
      },
      "qu": {
        "_territories": ["BO", "EC", "PE"],
        "_scripts": ["Latn"]
      },
      "quc": {
        "_scripts": ["Latn"]
      },
      "quc-alt-secondary": {
        "_territories": ["GT"]
      },
      "qug": {
        "_scripts": ["Latn"]
      },
      "raj": {
        "_scripts": ["Deva"]
      },
      "raj-alt-secondary": {
        "_territories": ["IN"]
      },
      "rap": {
        "_scripts": ["Latn"]
      },
      "rar": {
        "_scripts": ["Latn"]
      },
      "rcf": {
        "_scripts": ["Latn"]
      },
      "rcf-alt-secondary": {
        "_territories": ["RE"]
      },
      "rej": {
        "_scripts": ["Latn"]
      },
      "rej-alt-secondary": {
        "_territories": ["ID"],
        "_scripts": ["Rjng"]
      },
      "rgn": {
        "_scripts": ["Latn"]
      },
      "ria": {
        "_scripts": ["Latn"]
      },
      "rif": {
        "_scripts": ["Latn", "Tfng"]
      },
      "rif-alt-secondary": {
        "_territories": ["MA"]
      },
      "rjs": {
        "_scripts": ["Deva"]
      },
      "rkt": {
        "_scripts": ["Beng"]
      },
      "rkt-alt-secondary": {
        "_territories": ["BD", "IN"]
      },
      "rm": {
        "_scripts": ["Latn"]
      },
      "rm-alt-secondary": {
        "_territories": ["CH"]
      },
      "rmf": {
        "_scripts": ["Latn"]
      },
      "rmo": {
        "_scripts": ["Latn"]
      },
      "rmt": {
        "_scripts": ["Arab"]
      },
      "rmt-alt-secondary": {
        "_territories": ["IR"]
      },
      "rmu": {
        "_scripts": ["Latn"]
      },
      "rn": {
        "_territories": ["BI"],
        "_scripts": ["Latn"]
      },
      "rng": {
        "_scripts": ["Latn"]
      },
      "ro": {
        "_territories": ["MD", "RO"],
        "_scripts": ["Latn"]
      },
      "ro-alt-secondary": {
        "_territories": ["RS"],
        "_scripts": ["Cyrl"]
      },
      "rob": {
        "_scripts": ["Latn"]
      },
      "rof": {
        "_scripts": ["Latn"]
      },
      "rom": {
        "_scripts": ["Latn"]
      },
      "rom-alt-secondary": {
        "_scripts": ["Cyrl"]
      },
      "rtm": {
        "_scripts": ["Latn"]
      },
      "ru": {
        "_territories": ["BY", "KG", "KZ", "RU", "UA"],
        "_scripts": ["Cyrl"]
      },
      "ru-alt-secondary": {
        "_territories": ["BG", "DE", "EE", "LT", "LV", "PL", "SJ", "TJ", "UZ"]
      },
      "rue": {
        "_scripts": ["Cyrl"]
      },
      "rug": {
        "_scripts": ["Latn"]
      },
      "rup": {
        "_scripts": ["Latn"]
      },
      "rw": {
        "_territories": ["RW"],
        "_scripts": ["Latn"]
      },
      "rwk": {
        "_scripts": ["Latn"]
      },
      "ryu": {
        "_scripts": ["Kana"]
      },
      "sa-alt-secondary": {
        "_territories": ["IN"],
        "_scripts": ["Deva", "Gran", "Shrd", "Sidd", "Sinh"]
      },
      "sad": {
        "_scripts": ["Latn"]
      },
      "saf": {
        "_scripts": ["Latn"]
      },
      "sah": {
        "_scripts": ["Cyrl"]
      },
      "sah-alt-secondary": {
        "_territories": ["RU"]
      },
      "sam-alt-secondary": {
        "_scripts": ["Hebr", "Samr"]
      },
      "saq": {
        "_scripts": ["Latn"]
      },
      "sas": {
        "_scripts": ["Latn"]
      },
      "sas-alt-secondary": {
        "_territories": ["ID"]
      },
      "sat": {
        "_scripts": ["Latn"]
      },
      "sat-alt-secondary": {
        "_territories": ["IN"],
        "_scripts": ["Beng", "Deva", "Olck", "Orya"]
      },
      "sav-alt-secondary": {
        "_territories": ["SN"]
      },
      "saz": {
        "_scripts": ["Saur"]
      },
      "sbp": {
        "_scripts": ["Latn"]
      },
      "sc": {
        "_scripts": ["Latn"]
      },
      "sc-alt-secondary": {
        "_territories": ["IT"]
      },
      "sck": {
        "_scripts": ["Deva"]
      },
      "sck-alt-secondary": {
        "_territories": ["IN"]
      },
      "scn": {
        "_scripts": ["Latn"]
      },
      "sco": {
        "_scripts": ["Latn"]
      },
      "sco-alt-secondary": {
        "_territories": ["GB"]
      },
      "scs": {
        "_scripts": ["Latn"]
      },
      "sd": {
        "_scripts": ["Arab", "Deva"]
      },
      "sd-alt-secondary": {
        "_territories": ["IN", "PK"],
        "_scripts": ["Khoj", "Sind"]
      },
      "sdc": {
        "_scripts": ["Latn"]
      },
      "sdh": {
        "_scripts": ["Arab"]
      },
      "sdh-alt-secondary": {
        "_territories": ["IR"]
      },
      "se": {
        "_scripts": ["Latn"]
      },
      "se-alt-secondary": {
        "_territories": ["NO"],
        "_scripts": ["Cyrl"]
      },
      "see": {
        "_scripts": ["Latn"]
      },
      "sef": {
        "_scripts": ["Latn"]
      },
      "sef-alt-secondary": {
        "_territories": ["CI"]
      },
      "seh": {
        "_scripts": ["Latn"]
      },
      "seh-alt-secondary": {
        "_territories": ["MZ"]
      },
      "sei": {
        "_scripts": ["Latn"]
      },
      "sel-alt-secondary": {
        "_scripts": ["Cyrl"]
      },
      "ses": {
        "_scripts": ["Latn"]
      },
      "sg": {
        "_territories": ["CF"],
        "_scripts": ["Latn"]
      },
      "sga-alt-secondary": {
        "_scripts": ["Latn", "Ogam"]
      },
      "sgs": {
        "_scripts": ["Latn"]
      },
      "shi": {
        "_scripts": ["Arab", "Latn", "Tfng"]
      },
      "shi-alt-secondary": {
        "_territories": ["MA"]
      },
      "shn": {
        "_scripts": ["Mymr"]
      },
      "shn-alt-secondary": {
        "_territories": ["MM"]
      },
      "si": {
        "_territories": ["LK"],
        "_scripts": ["Sinh"]
      },
      "sid": {
        "_scripts": ["Latn"]
      },
      "sid-alt-secondary": {
        "_territories": ["ET"]
      },
      "sk": {
        "_territories": ["SK"],
        "_scripts": ["Latn"]
      },
      "sk-alt-secondary": {
        "_territories": ["CZ", "RS"]
      },
      "skr": {
        "_scripts": ["Arab"]
      },
      "skr-alt-secondary": {
        "_territories": ["PK"]
      },
      "sl": {
        "_territories": ["SI"],
        "_scripts": ["Latn"]
      },
      "sl-alt-secondary": {
        "_territories": ["AT"]
      },
      "sli": {
        "_scripts": ["Latn"]
      },
      "sly": {
        "_scripts": ["Latn"]
      },
      "sm": {
        "_territories": ["AS", "WS"],
        "_scripts": ["Latn"]
      },
      "sma": {
        "_scripts": ["Latn"]
      },
      "smj": {
        "_scripts": ["Latn"]
      },
      "smn": {
        "_scripts": ["Latn"]
      },
      "smp-alt-secondary": {
        "_scripts": ["Samr"]
      },
      "sms": {
        "_scripts": ["Latn"]
      },
      "sn": {
        "_territories": ["ZW"],
        "_scripts": ["Latn"]
      },
      "snf-alt-secondary": {
        "_territories": ["SN"]
      },
      "snk": {
        "_scripts": ["Latn"]
      },
      "snk-alt-secondary": {
        "_territories": ["ML"]
      },
      "so": {
        "_territories": ["SO"],
        "_scripts": ["Latn"]
      },
      "so-alt-secondary": {
        "_territories": ["DJ", "ET"],
        "_scripts": ["Arab", "Osma"]
      },
      "sou": {
        "_scripts": ["Thai"]
      },
      "sou-alt-secondary": {
        "_territories": ["TH"]
      },
      "sq": {
        "_territories": ["AL", "XK"],
        "_scripts": ["Latn"]
      },
      "sq-alt-secondary": {
        "_territories": ["MK", "RS"],
        "_scripts": ["Elba"]
      },
      "sr": {
        "_territories": ["BA", "ME", "RS", "XK"],
        "_scripts": ["Cyrl", "Latn"]
      },
      "srb": {
        "_scripts": ["Latn"]
      },
      "srb-alt-secondary": {
        "_scripts": ["Sora"]
      },
      "srn": {
        "_scripts": ["Latn"]
      },
      "srn-alt-secondary": {
        "_territories": ["SR"]
      },
      "srr": {
        "_scripts": ["Latn"]
      },
      "srr-alt-secondary": {
        "_territories": ["SN"]
      },
      "srx": {
        "_scripts": ["Deva"]
      },
      "ss": {
        "_territories": ["SZ"],
        "_scripts": ["Latn"]
      },
      "ss-alt-secondary": {
        "_territories": ["ZA"]
      },
      "ssy": {
        "_scripts": ["Latn"]
      },
      "st": {
        "_territories": ["LS"],
        "_scripts": ["Latn"]
      },
      "st-alt-secondary": {
        "_territories": ["ZA"]
      },
      "stq": {
        "_scripts": ["Latn"]
      },
      "su": {
        "_scripts": ["Latn"]
      },
      "su-alt-secondary": {
        "_territories": ["ID"],
        "_scripts": ["Sund"]
      },
      "suk": {
        "_scripts": ["Latn"]
      },
      "suk-alt-secondary": {
        "_territories": ["TZ"]
      },
      "sus": {
        "_scripts": ["Latn"]
      },
      "sus-alt-secondary": {
        "_territories": ["GN"],
        "_scripts": ["Arab"]
      },
      "sv": {
        "_territories": ["AX", "FI", "SE"],
        "_scripts": ["Latn"]
      },
      "sw": {
        "_territories": ["KE", "TZ", "UG"],
        "_scripts": ["Latn"]
      },
      "sw-alt-secondary": {
        "_territories": ["CD"]
      },
      "swb": {
        "_scripts": ["Arab"]
      },
      "swb-alt-secondary": {
        "_territories": ["YT"],
        "_scripts": ["Latn"]
      },
      "swg": {
        "_scripts": ["Latn"]
      },
      "swv": {
        "_scripts": ["Deva"]
      },
      "swv-alt-secondary": {
        "_territories": ["IN"]
      },
      "sxn": {
        "_scripts": ["Latn"]
      },
      "syi": {
        "_scripts": ["Latn"]
      },
      "syl": {
        "_scripts": ["Beng"]
      },
      "syl-alt-secondary": {
        "_territories": ["BD"],
        "_scripts": ["Sylo"]
      },
      "syr-alt-secondary": {
        "_scripts": ["Syrc"]
      },
      "szl": {
        "_scripts": ["Latn"]
      },
      "ta": {
        "_territories": ["LK", "SG"],
        "_scripts": ["Taml"]
      },
      "ta-alt-secondary": {
        "_territories": ["IN", "MY"]
      },
      "tab": {
        "_scripts": ["Cyrl"]
      },
      "taj": {
        "_scripts": ["Deva"]
      },
      "taj-alt-secondary": {
        "_scripts": ["Tibt"]
      },
      "tbw": {
        "_scripts": ["Latn"]
      },
      "tbw-alt-secondary": {
        "_scripts": ["Tagb"]
      },
      "tcy": {
        "_scripts": ["Knda"]
      },
      "tcy-alt-secondary": {
        "_territories": ["IN"]
      },
      "tdd": {
        "_scripts": ["Tale"]
      },
      "tdg": {
        "_scripts": ["Deva"]
      },
      "tdg-alt-secondary": {
        "_scripts": ["Tibt"]
      },
      "tdh": {
        "_scripts": ["Deva"]
      },
      "te": {
        "_scripts": ["Telu"]
      },
      "te-alt-secondary": {
        "_territories": ["IN"]
      },
      "tem": {
        "_scripts": ["Latn"]
      },
      "tem-alt-secondary": {
        "_territories": ["SL"]
      },
      "teo": {
        "_scripts": ["Latn"]
      },
      "teo-alt-secondary": {
        "_territories": ["UG"]
      },
      "ter": {
        "_scripts": ["Latn"]
      },
      "tet": {
        "_territories": ["TL"],
        "_scripts": ["Latn"]
      },
      "tg": {
        "_territories": ["TJ"],
        "_scripts": ["Arab", "Cyrl", "Latn"]
      },
      "th": {
        "_territories": ["TH"],
        "_scripts": ["Thai"]
      },
      "thl": {
        "_scripts": ["Deva"]
      },
      "thq": {
        "_scripts": ["Deva"]
      },
      "thr": {
        "_scripts": ["Deva"]
      },
      "ti": {
        "_territories": ["ER"],
        "_scripts": ["Ethi"]
      },
      "ti-alt-secondary": {
        "_territories": ["ET"]
      },
      "tig": {
        "_scripts": ["Ethi"]
      },
      "tig-alt-secondary": {
        "_territories": ["ER"]
      },
      "tiv": {
        "_scripts": ["Latn"]
      },
      "tiv-alt-secondary": {
        "_territories": ["NG"]
      },
      "tk": {
        "_territories": ["TM"],
        "_scripts": ["Arab", "Cyrl", "Latn"]
      },
      "tk-alt-secondary": {
        "_territories": ["AF", "IR"]
      },
      "tkl": {
        "_territories": ["TK"],
        "_scripts": ["Latn"]
      },
      "tkr": {
        "_scripts": ["Cyrl", "Latn"]
      },
      "tkt": {
        "_scripts": ["Deva"]
      },
      "tli": {
        "_scripts": ["Latn"]
      },
      "tly": {
        "_scripts": ["Arab", "Cyrl", "Latn"]
      },
      "tmh": {
        "_scripts": ["Latn"]
      },
      "tmh-alt-secondary": {
        "_territories": ["NE"]
      },
      "tn": {
        "_territories": ["BW"],
        "_scripts": ["Latn"]
      },
      "tn-alt-secondary": {
        "_territories": ["ZA"]
      },
      "tnr-alt-secondary": {
        "_territories": ["SN"]
      },
      "to": {
        "_territories": ["TO"],
        "_scripts": ["Latn"]
      },
      "tog": {
        "_scripts": ["Latn"]
      },
      "tpi": {
        "_territories": ["PG"],
        "_scripts": ["Latn"]
      },
      "tr": {
        "_territories": ["CY", "TR"],
        "_scripts": ["Latn"]
      },
      "tr-alt-secondary": {
        "_territories": ["DE"],
        "_scripts": ["Arab"]
      },
      "tru": {
        "_scripts": ["Latn"]
      },
      "tru-alt-secondary": {
        "_scripts": ["Syrc"]
      },
      "trv": {
        "_scripts": ["Latn"]
      },
      "ts": {
        "_scripts": ["Latn"]
      },
      "ts-alt-secondary": {
        "_territories": ["MZ", "ZA"]
      },
      "tsd": {
        "_scripts": ["Grek"]
      },
      "tsg": {
        "_scripts": ["Latn"]
      },
      "tsg-alt-secondary": {
        "_territories": ["PH"]
      },
      "tsi": {
        "_scripts": ["Latn"]
      },
      "tsj": {
        "_scripts": ["Tibt"]
      },
      "tt": {
        "_scripts": ["Cyrl"]
      },
      "tt-alt-secondary": {
        "_territories": ["RU"]
      },
      "ttj": {
        "_scripts": ["Latn"]
      },
      "tts": {
        "_scripts": ["Thai"]
      },
      "tts-alt-secondary": {
        "_territories": ["TH"]
      },
      "ttt": {
        "_scripts": ["Cyrl", "Latn"]
      },
      "ttt-alt-secondary": {
        "_scripts": ["Arab"]
      },
      "tum": {
        "_scripts": ["Latn"]
      },
      "tum-alt-secondary": {
        "_territories": ["MW"]
      },
      "tvl": {
        "_territories": ["TV"],
        "_scripts": ["Latn"]
      },
      "twq": {
        "_scripts": ["Latn"]
      },
      "ty": {
        "_territories": ["PF"],
        "_scripts": ["Latn"]
      },
      "tyv": {
        "_scripts": ["Cyrl"]
      },
      "tyv-alt-secondary": {
        "_territories": ["RU"]
      },
      "tzm": {
        "_territories": ["MA"],
        "_scripts": ["Latn", "Tfng"]
      },
      "ude": {
        "_scripts": ["Cyrl"]
      },
      "udm": {
        "_scripts": ["Cyrl"]
      },
      "udm-alt-secondary": {
        "_territories": ["RU"],
        "_scripts": ["Latn"]
      },
      "ug": {
        "_scripts": ["Arab", "Cyrl"]
      },
      "ug-alt-secondary": {
        "_territories": ["CN"],
        "_scripts": ["Latn"]
      },
      "uga-alt-secondary": {
        "_scripts": ["Ugar"]
      },
      "uk": {
        "_territories": ["UA"],
        "_scripts": ["Cyrl"]
      },
      "uk-alt-secondary": {
        "_territories": ["RS"]
      },
      "uli": {
        "_scripts": ["Latn"]
      },
      "umb": {
        "_scripts": ["Latn"]
      },
      "umb-alt-secondary": {
        "_territories": ["AO"]
      },
      "und-alt-secondary": {
        "_territories": ["AQ", "BV", "CP", "GS", "HM"]
      },
      "unr": {
        "_scripts": ["Beng", "Deva"]
      },
      "unr-alt-secondary": {
        "_territories": ["IN"]
      },
      "unx": {
        "_scripts": ["Beng", "Deva"]
      },
      "ur": {
        "_territories": ["PK"],
        "_scripts": ["Arab"]
      },
      "ur-alt-secondary": {
        "_territories": ["IN"]
      },
      "uz": {
        "_territories": ["UZ"],
        "_scripts": ["Arab", "Cyrl", "Latn"]
      },
      "uz-alt-secondary": {
        "_territories": ["AF"]
      },
      "vai": {
        "_scripts": ["Latn", "Vaii"]
      },
      "ve": {
        "_scripts": ["Latn"]
      },
      "ve-alt-secondary": {
        "_territories": ["ZA"]
      },
      "vec": {
        "_scripts": ["Latn"]
      },
      "vep": {
        "_scripts": ["Latn"]
      },
      "vi": {
        "_territories": ["VN"],
        "_scripts": ["Latn"]
      },
      "vi-alt-secondary": {
        "_territories": ["US"],
        "_scripts": ["Hani"]
      },
      "vic": {
        "_scripts": ["Latn"]
      },
      "vls": {
        "_scripts": ["Latn"]
      },
      "vls-alt-secondary": {
        "_territories": ["BE"]
      },
      "vmf": {
        "_scripts": ["Latn"]
      },
      "vmf-alt-secondary": {
        "_territories": ["DE"]
      },
      "vmw": {
        "_scripts": ["Latn"]
      },
      "vmw-alt-secondary": {
        "_territories": ["MZ"]
      },
      "vo-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "vot-alt-secondary": {
        "_scripts": ["Latn"]
      },
      "vro": {
        "_scripts": ["Latn"]
      },
      "vun": {
        "_scripts": ["Latn"]
      },
      "wa": {
        "_scripts": ["Latn"]
      },
      "wae": {
        "_scripts": ["Latn"]
      },
      "wal": {
        "_scripts": ["Ethi"]
      },
      "wal-alt-secondary": {
        "_territories": ["ET"]
      },
      "war": {
        "_scripts": ["Latn"]
      },
      "war-alt-secondary": {
        "_territories": ["PH"]
      },
      "was": {
        "_scripts": ["Latn"]
      },
      "wbp": {
        "_scripts": ["Latn"]
      },
      "wbq": {
        "_scripts": ["Telu"]
      },
      "wbq-alt-secondary": {
        "_territories": ["IN"]
      },
      "wbr": {
        "_scripts": ["Deva"]
      },
      "wbr-alt-secondary": {
        "_territories": ["IN"]
      },
      "wls": {
        "_scripts": ["Latn"]
      },
      "wls-alt-secondary": {
        "_territories": ["WF"]
      },
      "wni": {
        "_territories": ["KM"],
        "_scripts": ["Arab"]
      },
      "wo": {
        "_territories": ["SN"],
        "_scripts": ["Latn"]
      },
      "wo-alt-secondary": {
        "_scripts": ["Arab"]
      },
      "wtm": {
        "_scripts": ["Deva"]
      },
      "wtm-alt-secondary": {
        "_territories": ["IN"]
      },
      "wuu": {
        "_scripts": ["Hans"]
      },
      "wuu-alt-secondary": {
        "_territories": ["CN"]
      },
      "xal": {
        "_scripts": ["Cyrl"]
      },
      "xav": {
        "_scripts": ["Latn"]
      },
      "xcr-alt-secondary": {
        "_scripts": ["Cari"]
      },
      "xh": {
        "_scripts": ["Latn"]
      },
      "xh-alt-secondary": {
        "_territories": ["ZA"]
      },
      "xlc-alt-secondary": {
        "_scripts": ["Lyci"]
      },
      "xld-alt-secondary": {
        "_scripts": ["Lydi"]
      },
      "xmf": {
        "_scripts": ["Geor"]
      },
      "xmn-alt-secondary": {
        "_scripts": ["Mani"]
      },
      "xmr-alt-secondary": {
        "_scripts": ["Merc"]
      },
      "xna-alt-secondary": {
        "_scripts": ["Narb"]
      },
      "xnr": {
        "_scripts": ["Deva"]
      },
      "xnr-alt-secondary": {
        "_territories": ["IN"]
      },
      "xog": {
        "_scripts": ["Latn"]
      },
      "xog-alt-secondary": {
        "_territories": ["UG"]
      },
      "xpr-alt-secondary": {
        "_scripts": ["Prti"]
      },
      "xsa-alt-secondary": {
        "_scripts": ["Sarb"]
      },
      "xsr": {
        "_scripts": ["Deva"]
      },
      "xum-alt-secondary": {
        "_scripts": ["Ital", "Latn"]
      },
      "yao": {
        "_scripts": ["Latn"]
      },
      "yap": {
        "_scripts": ["Latn"]
      },
      "yav": {
        "_scripts": ["Latn"]
      },
      "ybb": {
        "_scripts": ["Latn"]
      },
      "yi": {
        "_scripts": ["Hebr"]
      },
      "yo": {
        "_territories": ["NG"],
        "_scripts": ["Latn"]
      },
      "yrk": {
        "_scripts": ["Cyrl"]
      },
      "yrl": {
        "_scripts": ["Latn"]
      },
      "yua": {
        "_scripts": ["Latn"]
      },
      "yue": {
        "_scripts": ["Hans", "Hant"]
      },
      "yue-alt-secondary": {
        "_territories": ["CN", "HK"]
      },
      "za": {
        "_scripts": ["Latn"]
      },
      "za-alt-secondary": {
        "_territories": ["CN"],
        "_scripts": ["Hans"]
      },
      "zag": {
        "_scripts": ["Latn"]
      },
      "zap": {
        "_scripts": ["Latn"]
      },
      "zdj": {
        "_territories": ["KM"],
        "_scripts": ["Arab"]
      },
      "zea": {
        "_scripts": ["Latn"]
      },
      "zen-alt-secondary": {
        "_scripts": ["Tfng"]
      },
      "zgh": {
        "_scripts": ["Tfng"]
      },
      "zgh-alt-secondary": {
        "_territories": ["MA"]
      },
      "zh": {
        "_territories": ["CN", "HK", "MO", "SG", "TW"],
        "_scripts": ["Hans", "Hant"]
      },
      "zh-alt-secondary": {
        "_territories": ["ID", "MY", "TH", "US", "VN"],
        "_scripts": ["Bopo", "Phag"]
      },
      "zmi": {
        "_scripts": ["Latn"]
      },
      "zu": {
        "_scripts": ["Latn"]
      },
      "zu-alt-secondary": {
        "_territories": ["ZA"]
      },
      "zun": {
        "_scripts": ["Latn"]
      },
      "zza": {
        "_scripts": ["Latn"]
      },
      "zza-alt-secondary": {
        "_territories": ["TR"]
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 13868 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "languageGroups": {
      "aav": "irr kdt mkh mun nyl sss tth",
      "afa": "ber bxe cdc cop cus egy omv sem zwa",
      "alg": "alq arp atj ats bla chy ciw cr del kic mez mia mic mjy moe nnt oj ojs ojw otw pim pot qyp sac sjw unm wam xlb xlo xnt xpq",
      "alv": "aba abi abr abu ada adj agq ajg ak anw ati avi ayb azo bad bai bax bba bce bci bda beh bfd bfl bgj bim bin bju bkc bkm blo bmq bnt bqj bsc cae cou cwt dag dai dop dur dyo ebr ee efi fap ff fod fon gaa gba gej gjn gkn goy gur gux ig ijo jab kbp kcj kdh keu kia kma knf kqs kro krx kss kzc kzr ldm lee lmp lob mdd mfq mfv mgo mlo mnh mor mos mql mua myk mzm mzv mzw naj ndv nfr nga ngb nie nku ntm nza nzi ogc oku otr ozm pbo pbp pil pny pug sav sev shz snf soy spp srr tbz tem tfi tik tiv tkq tnr tui tuz urh wci wo wwa xsm xwe yav yky yo",
      "apa": "apj apk apl apw nv",
      "aqa": "alc",
      "aql": "alg wiy yur",
      "art": "afh avk bzt dws eo ia ie igs io jbo ldn lfn neu nov qya rmv sjn tlh tzl vo zbl",
      "ath": "aht apa bcr bea caf chp clc crx den dgr gwi haa hup ing kkz koy kuu srs tau tcb tgx tht tol",
      "auf": "aru cul dny pad swx",
      "aus": "bck dbl ddj gbu gni kdd kjn kld mep nha nuy piu pkn vma vmb wbp wmt xbp xrg yii yij",
      "awd": "aca ame apu bae brg ccc cui gob guc guh guo ign inp kpc mbn not pbg pib pio plu tae trn ycn",
      "azc": "chl com cup hch hop lui mfy mnr nah ntp ood opt pao par pia ppl ser shh stp tac tar tla tub var xaw xgf yaq",
      "bai": "bbj bko byv fmp jgo nla nnh nnz nwe xmg ybb",
      "bat": "lt ltg lv ndf olt prg sgs svx sxl xcu xgl xsv xzm",
      "ber": "cnu grr jbe jbn kab mzb nxm oua rif sds shi shy siz taq thv tmh tzm zen zgh",
      "bnt": "abb asa auh bas beb bem beq bez bip bja bkh bkw bng bni bqz brf btb bum bvb bwt bxg cgg cjk cwe dav dez dma dua ebu eko eto ewo fan fip guz haq heh hke hoo hz jmc kam kck kcv kde kg ki kj kkj kmb koo koq kqn ksb ksf kws kzo lag lch lg lik ln lol loz lu lua lue lun luy lyn mbo mdw mer mgh mhb mhw mye nba nd ndc ng ngc ngl njx nmg nnb nr nse nso ny nyf nym nyn pic rn rng rof rw rwk rwm sbp seh shr sn snq sop ss st suk sw swb tll tn toi ts tum umb ve vif vmk vun wdd wlc wni xh xog yao zdj zmw zu",
      "btk": "akb bbc btd btm bts btx btz",
      "cau": "ccn ccs",
      "cba": "bzd cbg chb kog mbp mot tuf",
      "ccn": "ab abq ady agx akv ani aqc av bbl bdk bph ce cji dar ddo gdo gin huz inh kap kbd khv kjj kpt kry kva lbe lez rut tab tin tkr uby udi",
      "ccs": "ka lzz sva xmf",
      "cdc": "anc ank bid daa ha hed lme maf mcn mmy mpi mse mug nnc nnn pip sor tmc zim zuy",
      "cdd": "ari cad kii paw wic",
      "cel": "br cy ga gd gv kw mga nrc obt owl sga wlm xbm xcb xce xga xpi",
      "cmc": "ace cje cjm hro huq jra rad rog",
      "cpf": "acf cks crs gcf gcr ht kmv lou mfe rcf",
      "cpp": "aoa cri fab kea mzs pap pov pre srm xmm",
      "csu": "avu bdh bex bot kcm led mdi mdj mhi mwm myb niy sba",
      "cus": "aa arv bej bji byn dal irk om orc sid so ssn ssy",
      "day": "bth lra sdo sne",
      "dmn": "bib bm bqc dnj dyu goa kao knk kno knu kpe lom man men mlq moa mwk rkm snk sus vai xkg yal",
      "dra": "brh gon iru kfa kfc kff kmj kn kru kxl kxu kxv mjt mjv ml muv ta tcx tcy te",
      "esx": "ale ik iu kl ypk ysr",
      "euq": "eu",
      "fiu": "chm et fi fit fkv hu izh kca koi krl kv liv mdf mns mrj myv olo smi udm vep vot vro",
      "fox": "bnn bzg ckv dru fos pwn pyu ssf sxr tay trv tsu uun xnb xsy",
      "gem": "gme gmq gmw",
      "gme": "got xvn",
      "gmq": "da fo is nb nn non nrn ovd rmg sv",
      "gmw": "af ang cim de dum en enm frk frr fy gct gmh gml goh gos gsw ksh lb li lng mhn nds nl odt ofs osx pdc pfl sco stq swg wae wep wym yec yi zea",
      "grk": "cpg el gmy grc pnt tsd yej",
      "hmx": "bje bpn buh bwn cqd hmd hml hmn hnj ium mji mmr mww pha pnu shx",
      "hok": "acv atw boi cid coc crz esq inz kju klb kyh mov mrc obi peb pef pej peq pom poo ppi puy sei sht sln veo was ynn yuf yum",
      "iir": "ask bsh inc ira prn wbk xvi",
      "inc": "as awa bgc bhb bho bjj bkk bn bns bpy bra ccp ctg dml doi dv emx gu gwc gwt hi hif hne khw kls kok ks lah mag mai mr mvy mwr ne or pa phl pra raj rml rmq rmt rom scl sd sdg si skr syl ur",
      "ine": "aln anp bat cel cms gem grk hit hlu hy iir imy itc plq scx sdt sla sq txb txh xcl xcr xdc xlc xld xlg xls xmk xpg xps xsd xto xve",
      "ira": "ae bal bsg ckb fa glk hac haz isk jdt jpr kho ku lrc lsa mzn oru os pal peo prc ps sgh sgl sgy siy smy sog sqo srh tg tly ttt wbl xbc xco xpr xsc yai zum zza",
      "iro": "cay chr lre moh ntw one ono see sqn tus wya",
      "itc": "la osc roa spx xfa xum",
      "jpx": "ja",
      "kar": "kvq",
      "khi": "hts ktz kwz naq nmn sad",
      "kro": "ald bsq dic grb gud gxx ney nwb wec",
      "map": "fox lcl lnd poz",
      "mkh": "bbh bgk blr caq cbn crv cwg huo jah jhi kha kjg km lbn mhe mlf mml mnw mqt mra mtq ncb oyb ply prk pry rka scb sea sii tef tnz tpu tyh uuu vi vwa wbm xao xnh zng",
      "mul": "aav afa aqa aql art auf aus awd azc cau cba cdd dra esx euq hmx hok ine iro jpx khi map myn nic omq paa sal sgn sio sit ssa tai tup tut urj wak xnd",
      "mun": "hoc pcj sat unr",
      "myn": "acr agu caa cac cak ctu hus itz ixl jac kek kjb knj mam mhc mop poc poh quc qum quv toj ttc tzh tzj tzo usp yua",
      "nah": "nci",
      "ngb": "sg",
      "ngf": "bjz ekg uhn",
      "nic": "alv dmn eka kdo lam nqo nyo tog znd",
      "nub": "fia onw",
      "omq": "cco coz czn ixc maj maq miz mxb oto pbs pmq pmz tpc tpl tpx trs zap zaw ztq zty",
      "omv": "aiw bcq bwo dim doz jnj mdx noz she wal zay",
      "oto": "otm",
      "paa": "aau anz ddg gak kax kmo lvk mok nas ngf pgu saj tcm tft tif tlb tqu waj wli yee zuh",
      "phi": "akl bik blf bno bnq ceb cps fil gor hil ibg ibl ify ilk ilo kak krj kyj kyk loc mdh mno mog mrw msb pag pam rth sgd snl sxn tbl tdn tne tnt tnw tom txs war",
      "plf": "alo amv gal hbu kje lti mhs szn tet tlv txn wha",
      "poz": "aol bhp end hvn ivv kei kvh mqy nxe ple plf pqe pqw ski tao xbr xxk",
      "pqe": "agw ahb aia aie aji akr alm alu ane anx apb app apr asz aty aua aud aul auq aut baa bch bcm bcu bgt bhc bhw biq bjk blp blq bnk bnr bpa brr btr buk bvc bvd bwd bxa bxf bzh bzq cal cam chk crc ddi dgg dhv dob dor drr erg erk etn faf far fj frt fud fut fwa gdd gei gfk gga ggt ghn gil gli gmb goo gri grz gzn hah hao haw hiw hla hoa hrw iai irh jae jaj jaz kbm kdk khl kij kji kkk klv koa kos kpg kqw krf ksd ksg ktm kvc kwd kwf kxr kzk kzu lbb lbv lcm lek ler leu lga lgb lgk lgl lgr lgu lht lib lid lkn lle llf llp llu llx lmg lml lmu lmv loj los lpa lrv lrz lww mee mek met meu mft mgl mh mi mkj mkv mky mla mln mlu mlv mme mmg mmt mmw mmx mna mnv mox mpr mpy mqa mqm mrb mrl mrm mrn mrq mrv msq mte mtt mvo mwc mwh mwi mwo mxe na nal ncc ncf ncn nee nem nen nfl ngr niu nke nkr nlg nmb nmk nms nmt nnd npn nsn nss nsw nua nuw nwi olr omb onu ora pek pex pfa pgk pif piv piz pkg pma pme pmt pnh pon pop ppn pri pss psw ptp ptv puw pwg rai rak rap rar ray roe rri rro rug sax sbb sbc sbe sbh sgz sij sjr sku slz sm sns sob sol sov sps ssg stn stw swp szw tbc tbe tbf tbj tgc tgi tgp tgs tio tkl tkp tkw tlm tlr tlx tmb tmi tmy tnk tnl tnn tnp tnx to tox tpv tpz tql tqp tsr ttu ttv tuc tva tvk tvl twp ty ubr uge uli upv urr urv utp uve uvl vao vmg vnk vnm vra vrs vrt wiv wls woe wuv wwo wyy xsi yap yly zgr",
      "pqw": "abl abs abx ban bdg bdl bdr beg bew bjn bkz bsu btk buc bug ch cia cmc day dbj drg dtr dun dup duq duw eno gay goq iba id jv kaw kge kjc kjk kqr ktq kvr kxd kyi kys lbw lbx lce lcf ley liw ljp llk mad mak mdr mfa mfb mg mhy min mkm mqn ms mtd mui mwv mxr myl mzq nia nij nrm otd pau pdo pel phi pku pse raz ree rej sas sda sjm skh slm sml smr smw snv ssb sse su sya tdi tdu tdx tjg tkg tlk twy txy ulu vkl vko wow wru xkq xmv xmw xmz yka zbc zbe zbw",
      "pra": "pi sa",
      "roa": "an ast ca co cpf cpp dlm egl es ext fax fr frc frm fro frp fur gl ist it lad lij lld lmo mwl mxi nap nrf oc osp pcd pms pt rgn rm ro ruo rup ruq sc scn sdc sdn vec wa",
      "sal": "cjh clm col coo cow crd fla hur lil nok oka qun shs spo squ str thp",
      "sdv": "ach alz anu bfa ddd din enb eyo kdj keo kln kpz lky lot lpx luo mas mqu muz niq nsg nub nus saq sgc shk tec teo toq tuv tuy",
      "sem": "aao acw acy aeb afb aii ajt akk am amw apc ar arc arq ary arz ayl gdq gez har he jrb mey mt phn sam shu smp sqr syc ti tig tmr uga xaa xeb xpu",
      "sgn": "csn fcs fsl ils isg rsl",
      "sio": "asb bll cro dak hid iow ksk lkt mhq ofo oma osa qua sto tta win xwc",
      "sit": "dz ero grt hmr hni ii jkr kac kar lbj lus mni my new njh njm nmy nwc nxq qvy sxg tbq tsj txg xsr zhx",
      "sla": "zle zls zlw",
      "smi": "se sia sjd sje sjt sma smj smn sms",
      "son": "ddn dje kcy khq ses twq",
      "ssa": "csu dzg fvr gly guk ikx kbl kie kmq kr lgn mde mls rou sdv son teu tuq udu wti xmr xom",
      "sw": "swc",
      "syd": "mtm nio sel xas yrk",
      "tai": "lo th",
      "tbq": "adx anm bo bqh brx duu ers gqi gro jya lhu lpo mxj njo nun trp twm",
      "trk": "aib alt az azb ba chg cjs clw crh cv dlg gag ili jct kaa kdr kim kjh kk klj kmz krc kum ky ota otk qwm qxq sah slr tk tr tt tyv ug uz uzs xpc ybe",
      "tup": "eme gn gui guq gyr kay kgk kpn ktn kyr mpu myu nhd psm skf srq tpj tpr tpw twt wyr yrl",
      "tut": "nog trk tuw xgn",
      "tuw": "eve evn gld juc mnc neg oaa oac orh sjo ude ulc",
      "urj": "fiu syd",
      "wak": "dtd has hei kwk myh nuk",
      "wen": "dsb hsb",
      "xgn": "bua dta kxs mhj mjg mn mvf peh sce xal xwo yuy",
      "xnd": "ath eya hoi tfn tli",
      "ypk": "ems ess esu ynk",
      "zhx": "cdo cjy cpx czh czo gan hak hsn ltc mnp nan och wuu wxa yue zh",
      "zle": "be orv ru rue uk",
      "zls": "bg bs cu hr mk sl sr",
      "zlw": "cs csb czk pl pox sk szl wen",
      "znd": "zne"
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14755 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "languageMatching": {
      "written": [{
        "nb": {
          "_percent": "99"
        }
      }, {
        "bs": {
          "_percent": "96"
        }
      }, {
        "bs": {
          "_percent": "96"
        }
      }, {
        "hr": {
          "_percent": "96"
        }
      }, {
        "sr": {
          "_percent": "96"
        }
      }, {
        "aa": {
          "_percent": "96"
        }
      }, {
        "de": {
          "_percent": "96",
          "_oneway": "true"
        }
      }, {
        "de": {
          "_percent": "96",
          "_oneway": "true"
        }
      }, {
        "no": {
          "_percent": "92"
        }
      }, {
        "nb": {
          "_percent": "92"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "nl": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fil": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ar": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fi": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "da": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "nl": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "id": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "tr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "it": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "bg": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "id": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "nb": {
          "_percent": "90"
        }
      }, {
        "no": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "de": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "id": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "zh": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_percent": "90",
          "_oneway": "true"
        }
      }, {
        "sr": {
          "_percent": "95"
        }
      }, {
        "zh": {
          "_percent": "85",
          "_oneway": "true"
        }
      }, {
        "zh": {
          "_percent": "81",
          "_oneway": "true"
        }
      }, {
        "zh": {
          "_percent": "97"
        }
      }, {
        "pt": {
          "_percent": "96"
        }
      }, {
        "pt": {
          "_percent": "92"
        }
      }, {
        "pt": {
          "_percent": "92"
        }
      }, {
        "pt": {
          "_percent": "96"
        }
      }, {
        "en": {
          "_percent": "94"
        }
      }, {
        "en": {
          "_percent": "96"
        }
      }, {
        "en": {
          "_percent": "96"
        }
      }, {
        "en": {
          "_percent": "95"
        }
      }, {
        "es": {
          "_percent": "92"
        }
      }, {
        "es": {
          "_percent": "96"
        }
      }, {
        "es": {
          "_percent": "95"
        }
      }, {
        "*": {
          "_percent": "20"
        }
      }, {
        "*": {
          "_percent": "60"
        }
      }, {
        "*": {
          "_percent": "96"
        }
      }],
      "written-new": [{
        "paradigmLocales": {
          "_locales": "en en-GB es es-419 pt-BR pt-PT"
        }
      }, {
        "$americas": {
          "_value": "019"
        }
      }, {
        "$cnsar": {
          "_value": "HK+MO"
        }
      }, {
        "$enUS": {
          "_value": "AS+GU+MH+MP+PR+UM+US+VI"
        }
      }, {
        "$maghreb": {
          "_value": "MA+DZ+TN+LY+MR+EH"
        }
      }, {
        "nb": {
          "_distance": "1"
        }
      }, {
        "bs": {
          "_distance": "4"
        }
      }, {
        "bs": {
          "_distance": "4"
        }
      }, {
        "hr": {
          "_distance": "4"
        }
      }, {
        "sr": {
          "_distance": "4"
        }
      }, {
        "aa": {
          "_distance": "4"
        }
      }, {
        "de": {
          "_distance": "4",
          "_oneway": "true"
        }
      }, {
        "de": {
          "_distance": "4",
          "_oneway": "true"
        }
      }, {
        "no": {
          "_distance": "8"
        }
      }, {
        "nb": {
          "_distance": "8"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "nl": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fil": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ar": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fi": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "da": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "nl": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "id": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "tr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "it": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "bg": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "id": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "nb": {
          "_distance": "10"
        }
      }, {
        "no": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "es": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "de": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "hi": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "id": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "zh": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "fr": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "*": {
          "_distance": "80"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "ru": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "en": {
          "_distance": "10",
          "_oneway": "true"
        }
      }, {
        "sr": {
          "_distance": "5"
        }
      }, {
        "zh": {
          "_distance": "15",
          "_oneway": "true"
        }
      }, {
        "zh": {
          "_distance": "19",
          "_oneway": "true"
        }
      }, {
        "*": {
          "_distance": "50"
        }
      }, {
        "ar": {
          "_distance": "4"
        }
      }, {
        "ar": {
          "_distance": "4"
        }
      }, {
        "ar": {
          "_distance": "5"
        }
      }, {
        "en": {
          "_distance": "4"
        }
      }, {
        "en": {
          "_distance": "3"
        }
      }, {
        "en": {
          "_distance": "4"
        }
      }, {
        "en": {
          "_distance": "5"
        }
      }, {
        "es": {
          "_distance": "4"
        }
      }, {
        "es": {
          "_distance": "4"
        }
      }, {
        "es": {
          "_distance": "5"
        }
      }, {
        "pt": {
          "_distance": "4"
        }
      }, {
        "pt": {
          "_distance": "4"
        }
      }, {
        "pt": {
          "_distance": "5"
        }
      }, {
        "zh": {
          "_distance": "4"
        }
      }, {
        "zh": {
          "_distance": "4"
        }
      }, {
        "zh": {
          "_distance": "5"
        }
      }, {
        "*": {
          "_distance": "4"
        }
      }]
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14881 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "likelySubtags": {
      "aa": "aa-Latn-ET",
      "aai": "aai-Latn-ZZ",
      "aak": "aak-Latn-ZZ",
      "aau": "aau-Latn-ZZ",
      "ab": "ab-Cyrl-GE",
      "abi": "abi-Latn-ZZ",
      "abq": "abq-Cyrl-ZZ",
      "abr": "abr-Latn-GH",
      "abt": "abt-Latn-ZZ",
      "aby": "aby-Latn-ZZ",
      "acd": "acd-Latn-ZZ",
      "ace": "ace-Latn-ID",
      "ach": "ach-Latn-UG",
      "ada": "ada-Latn-GH",
      "ade": "ade-Latn-ZZ",
      "adj": "adj-Latn-ZZ",
      "ady": "ady-Cyrl-RU",
      "adz": "adz-Latn-ZZ",
      "ae": "ae-Avst-IR",
      "aeb": "aeb-Arab-TN",
      "aey": "aey-Latn-ZZ",
      "af": "af-Latn-ZA",
      "agc": "agc-Latn-ZZ",
      "agd": "agd-Latn-ZZ",
      "agg": "agg-Latn-ZZ",
      "agm": "agm-Latn-ZZ",
      "ago": "ago-Latn-ZZ",
      "agq": "agq-Latn-CM",
      "aha": "aha-Latn-ZZ",
      "ahl": "ahl-Latn-ZZ",
      "aho": "aho-Ahom-IN",
      "ajg": "ajg-Latn-ZZ",
      "ak": "ak-Latn-GH",
      "akk": "akk-Xsux-IQ",
      "ala": "ala-Latn-ZZ",
      "ali": "ali-Latn-ZZ",
      "aln": "aln-Latn-XK",
      "alt": "alt-Cyrl-RU",
      "am": "am-Ethi-ET",
      "amm": "amm-Latn-ZZ",
      "amn": "amn-Latn-ZZ",
      "amo": "amo-Latn-NG",
      "amp": "amp-Latn-ZZ",
      "anc": "anc-Latn-ZZ",
      "ank": "ank-Latn-ZZ",
      "ann": "ann-Latn-ZZ",
      "any": "any-Latn-ZZ",
      "aoj": "aoj-Latn-ZZ",
      "aom": "aom-Latn-ZZ",
      "aoz": "aoz-Latn-ID",
      "apc": "apc-Arab-ZZ",
      "apd": "apd-Arab-TG",
      "ape": "ape-Latn-ZZ",
      "apr": "apr-Latn-ZZ",
      "aps": "aps-Latn-ZZ",
      "apz": "apz-Latn-ZZ",
      "ar": "ar-Arab-EG",
      "arc": "arc-Armi-IR",
      "arc-Nbat": "arc-Nbat-JO",
      "arc-Palm": "arc-Palm-SY",
      "arh": "arh-Latn-ZZ",
      "arn": "arn-Latn-CL",
      "aro": "aro-Latn-BO",
      "arq": "arq-Arab-DZ",
      "ary": "ary-Arab-MA",
      "arz": "arz-Arab-EG",
      "as": "as-Beng-IN",
      "asa": "asa-Latn-TZ",
      "ase": "ase-Sgnw-US",
      "asg": "asg-Latn-ZZ",
      "aso": "aso-Latn-ZZ",
      "ast": "ast-Latn-ES",
      "ata": "ata-Latn-ZZ",
      "atg": "atg-Latn-ZZ",
      "atj": "atj-Latn-CA",
      "auy": "auy-Latn-ZZ",
      "av": "av-Cyrl-RU",
      "avl": "avl-Arab-ZZ",
      "avn": "avn-Latn-ZZ",
      "avt": "avt-Latn-ZZ",
      "avu": "avu-Latn-ZZ",
      "awa": "awa-Deva-IN",
      "awb": "awb-Latn-ZZ",
      "awo": "awo-Latn-ZZ",
      "awx": "awx-Latn-ZZ",
      "ay": "ay-Latn-BO",
      "ayb": "ayb-Latn-ZZ",
      "az": "az-Latn-AZ",
      "az-Arab": "az-Arab-IR",
      "az-IQ": "az-Arab-IQ",
      "az-IR": "az-Arab-IR",
      "az-RU": "az-Cyrl-RU",
      "ba": "ba-Cyrl-RU",
      "bal": "bal-Arab-PK",
      "ban": "ban-Latn-ID",
      "bap": "bap-Deva-NP",
      "bar": "bar-Latn-AT",
      "bas": "bas-Latn-CM",
      "bav": "bav-Latn-ZZ",
      "bax": "bax-Bamu-CM",
      "bba": "bba-Latn-ZZ",
      "bbb": "bbb-Latn-ZZ",
      "bbc": "bbc-Latn-ID",
      "bbd": "bbd-Latn-ZZ",
      "bbj": "bbj-Latn-CM",
      "bbp": "bbp-Latn-ZZ",
      "bbr": "bbr-Latn-ZZ",
      "bcf": "bcf-Latn-ZZ",
      "bch": "bch-Latn-ZZ",
      "bci": "bci-Latn-CI",
      "bcm": "bcm-Latn-ZZ",
      "bcn": "bcn-Latn-ZZ",
      "bco": "bco-Latn-ZZ",
      "bcq": "bcq-Ethi-ZZ",
      "bcu": "bcu-Latn-ZZ",
      "bdd": "bdd-Latn-ZZ",
      "be": "be-Cyrl-BY",
      "bef": "bef-Latn-ZZ",
      "beh": "beh-Latn-ZZ",
      "bej": "bej-Arab-SD",
      "bem": "bem-Latn-ZM",
      "bet": "bet-Latn-ZZ",
      "bew": "bew-Latn-ID",
      "bex": "bex-Latn-ZZ",
      "bez": "bez-Latn-TZ",
      "bfd": "bfd-Latn-CM",
      "bfq": "bfq-Taml-IN",
      "bft": "bft-Arab-PK",
      "bfy": "bfy-Deva-IN",
      "bg": "bg-Cyrl-BG",
      "bgc": "bgc-Deva-IN",
      "bgn": "bgn-Arab-PK",
      "bgx": "bgx-Grek-TR",
      "bhb": "bhb-Deva-IN",
      "bhg": "bhg-Latn-ZZ",
      "bhi": "bhi-Deva-IN",
      "bhk": "bhk-Latn-PH",
      "bhl": "bhl-Latn-ZZ",
      "bho": "bho-Deva-IN",
      "bhy": "bhy-Latn-ZZ",
      "bi": "bi-Latn-VU",
      "bib": "bib-Latn-ZZ",
      "big": "big-Latn-ZZ",
      "bik": "bik-Latn-PH",
      "bim": "bim-Latn-ZZ",
      "bin": "bin-Latn-NG",
      "bio": "bio-Latn-ZZ",
      "biq": "biq-Latn-ZZ",
      "bjh": "bjh-Latn-ZZ",
      "bji": "bji-Ethi-ZZ",
      "bjj": "bjj-Deva-IN",
      "bjn": "bjn-Latn-ID",
      "bjo": "bjo-Latn-ZZ",
      "bjr": "bjr-Latn-ZZ",
      "bjt": "bjt-Latn-SN",
      "bjz": "bjz-Latn-ZZ",
      "bkc": "bkc-Latn-ZZ",
      "bkm": "bkm-Latn-CM",
      "bkq": "bkq-Latn-ZZ",
      "bku": "bku-Latn-PH",
      "bkv": "bkv-Latn-ZZ",
      "blt": "blt-Tavt-VN",
      "bm": "bm-Latn-ML",
      "bmh": "bmh-Latn-ZZ",
      "bmk": "bmk-Latn-ZZ",
      "bmq": "bmq-Latn-ML",
      "bmu": "bmu-Latn-ZZ",
      "bn": "bn-Beng-BD",
      "bng": "bng-Latn-ZZ",
      "bnm": "bnm-Latn-ZZ",
      "bnp": "bnp-Latn-ZZ",
      "bo": "bo-Tibt-CN",
      "boj": "boj-Latn-ZZ",
      "bom": "bom-Latn-ZZ",
      "bon": "bon-Latn-ZZ",
      "bpy": "bpy-Beng-IN",
      "bqc": "bqc-Latn-ZZ",
      "bqi": "bqi-Arab-IR",
      "bqp": "bqp-Latn-ZZ",
      "bqv": "bqv-Latn-CI",
      "br": "br-Latn-FR",
      "bra": "bra-Deva-IN",
      "brh": "brh-Arab-PK",
      "brx": "brx-Deva-IN",
      "brz": "brz-Latn-ZZ",
      "bs": "bs-Latn-BA",
      "bsj": "bsj-Latn-ZZ",
      "bsq": "bsq-Bass-LR",
      "bss": "bss-Latn-CM",
      "bst": "bst-Ethi-ZZ",
      "bto": "bto-Latn-PH",
      "btt": "btt-Latn-ZZ",
      "btv": "btv-Deva-PK",
      "bua": "bua-Cyrl-RU",
      "buc": "buc-Latn-YT",
      "bud": "bud-Latn-ZZ",
      "bug": "bug-Latn-ID",
      "buk": "buk-Latn-ZZ",
      "bum": "bum-Latn-CM",
      "buo": "buo-Latn-ZZ",
      "bus": "bus-Latn-ZZ",
      "buu": "buu-Latn-ZZ",
      "bvb": "bvb-Latn-GQ",
      "bwd": "bwd-Latn-ZZ",
      "bwr": "bwr-Latn-ZZ",
      "bxh": "bxh-Latn-ZZ",
      "bye": "bye-Latn-ZZ",
      "byn": "byn-Ethi-ER",
      "byr": "byr-Latn-ZZ",
      "bys": "bys-Latn-ZZ",
      "byv": "byv-Latn-CM",
      "byx": "byx-Latn-ZZ",
      "bza": "bza-Latn-ZZ",
      "bze": "bze-Latn-ML",
      "bzf": "bzf-Latn-ZZ",
      "bzh": "bzh-Latn-ZZ",
      "bzw": "bzw-Latn-ZZ",
      "ca": "ca-Latn-ES",
      "can": "can-Latn-ZZ",
      "cbj": "cbj-Latn-ZZ",
      "cch": "cch-Latn-NG",
      "ccp": "ccp-Cakm-BD",
      "ce": "ce-Cyrl-RU",
      "ceb": "ceb-Latn-PH",
      "cfa": "cfa-Latn-ZZ",
      "cgg": "cgg-Latn-UG",
      "ch": "ch-Latn-GU",
      "chk": "chk-Latn-FM",
      "chm": "chm-Cyrl-RU",
      "cho": "cho-Latn-US",
      "chp": "chp-Latn-CA",
      "chr": "chr-Cher-US",
      "cja": "cja-Arab-KH",
      "cjm": "cjm-Cham-VN",
      "cjv": "cjv-Latn-ZZ",
      "ckb": "ckb-Arab-IQ",
      "ckl": "ckl-Latn-ZZ",
      "cko": "cko-Latn-ZZ",
      "cky": "cky-Latn-ZZ",
      "cla": "cla-Latn-ZZ",
      "cme": "cme-Latn-ZZ",
      "cmg": "cmg-Soyo-MN",
      "co": "co-Latn-FR",
      "cop": "cop-Copt-EG",
      "cps": "cps-Latn-PH",
      "cr": "cr-Cans-CA",
      "crh": "crh-Cyrl-UA",
      "crj": "crj-Cans-CA",
      "crk": "crk-Cans-CA",
      "crl": "crl-Cans-CA",
      "crm": "crm-Cans-CA",
      "crs": "crs-Latn-SC",
      "cs": "cs-Latn-CZ",
      "csb": "csb-Latn-PL",
      "csw": "csw-Cans-CA",
      "ctd": "ctd-Pauc-MM",
      "cu": "cu-Cyrl-RU",
      "cu-Glag": "cu-Glag-BG",
      "cv": "cv-Cyrl-RU",
      "cy": "cy-Latn-GB",
      "da": "da-Latn-DK",
      "dad": "dad-Latn-ZZ",
      "daf": "daf-Latn-ZZ",
      "dag": "dag-Latn-ZZ",
      "dah": "dah-Latn-ZZ",
      "dak": "dak-Latn-US",
      "dar": "dar-Cyrl-RU",
      "dav": "dav-Latn-KE",
      "dbd": "dbd-Latn-ZZ",
      "dbq": "dbq-Latn-ZZ",
      "dcc": "dcc-Arab-IN",
      "ddn": "ddn-Latn-ZZ",
      "de": "de-Latn-DE",
      "ded": "ded-Latn-ZZ",
      "den": "den-Latn-CA",
      "dga": "dga-Latn-ZZ",
      "dgh": "dgh-Latn-ZZ",
      "dgi": "dgi-Latn-ZZ",
      "dgl": "dgl-Arab-ZZ",
      "dgr": "dgr-Latn-CA",
      "dgz": "dgz-Latn-ZZ",
      "dia": "dia-Latn-ZZ",
      "dje": "dje-Latn-NE",
      "dnj": "dnj-Latn-CI",
      "dob": "dob-Latn-ZZ",
      "doi": "doi-Arab-IN",
      "dop": "dop-Latn-ZZ",
      "dow": "dow-Latn-ZZ",
      "dri": "dri-Latn-ZZ",
      "drs": "drs-Ethi-ZZ",
      "dsb": "dsb-Latn-DE",
      "dtm": "dtm-Latn-ML",
      "dtp": "dtp-Latn-MY",
      "dts": "dts-Latn-ZZ",
      "dty": "dty-Deva-NP",
      "dua": "dua-Latn-CM",
      "duc": "duc-Latn-ZZ",
      "dud": "dud-Latn-ZZ",
      "dug": "dug-Latn-ZZ",
      "dv": "dv-Thaa-MV",
      "dva": "dva-Latn-ZZ",
      "dww": "dww-Latn-ZZ",
      "dyo": "dyo-Latn-SN",
      "dyu": "dyu-Latn-BF",
      "dz": "dz-Tibt-BT",
      "dzg": "dzg-Latn-ZZ",
      "ebu": "ebu-Latn-KE",
      "ee": "ee-Latn-GH",
      "efi": "efi-Latn-NG",
      "egl": "egl-Latn-IT",
      "egy": "egy-Egyp-EG",
      "eka": "eka-Latn-ZZ",
      "eky": "eky-Kali-MM",
      "el": "el-Grek-GR",
      "ema": "ema-Latn-ZZ",
      "emi": "emi-Latn-ZZ",
      "en": "en-Latn-US",
      "en-Shaw": "en-Shaw-GB",
      "enn": "enn-Latn-ZZ",
      "enq": "enq-Latn-ZZ",
      "eo": "eo-Latn-001",
      "eri": "eri-Latn-ZZ",
      "es": "es-Latn-ES",
      "esg": "esg-Gonm-IN",
      "esu": "esu-Latn-US",
      "et": "et-Latn-EE",
      "etr": "etr-Latn-ZZ",
      "ett": "ett-Ital-IT",
      "etu": "etu-Latn-ZZ",
      "etx": "etx-Latn-ZZ",
      "eu": "eu-Latn-ES",
      "ewo": "ewo-Latn-CM",
      "ext": "ext-Latn-ES",
      "fa": "fa-Arab-IR",
      "faa": "faa-Latn-ZZ",
      "fab": "fab-Latn-ZZ",
      "fag": "fag-Latn-ZZ",
      "fai": "fai-Latn-ZZ",
      "fan": "fan-Latn-GQ",
      "ff": "ff-Latn-SN",
      "ff-Adlm": "ff-Adlm-GN",
      "ffi": "ffi-Latn-ZZ",
      "ffm": "ffm-Latn-ML",
      "fi": "fi-Latn-FI",
      "fia": "fia-Arab-SD",
      "fil": "fil-Latn-PH",
      "fit": "fit-Latn-SE",
      "fj": "fj-Latn-FJ",
      "flr": "flr-Latn-ZZ",
      "fmp": "fmp-Latn-ZZ",
      "fo": "fo-Latn-FO",
      "fod": "fod-Latn-ZZ",
      "fon": "fon-Latn-BJ",
      "for": "for-Latn-ZZ",
      "fpe": "fpe-Latn-ZZ",
      "fqs": "fqs-Latn-ZZ",
      "fr": "fr-Latn-FR",
      "frc": "frc-Latn-US",
      "frp": "frp-Latn-FR",
      "frr": "frr-Latn-DE",
      "frs": "frs-Latn-DE",
      "fub": "fub-Arab-CM",
      "fud": "fud-Latn-WF",
      "fue": "fue-Latn-ZZ",
      "fuf": "fuf-Latn-GN",
      "fuh": "fuh-Latn-ZZ",
      "fuq": "fuq-Latn-NE",
      "fur": "fur-Latn-IT",
      "fuv": "fuv-Latn-NG",
      "fuy": "fuy-Latn-ZZ",
      "fvr": "fvr-Latn-SD",
      "fy": "fy-Latn-NL",
      "ga": "ga-Latn-IE",
      "gaa": "gaa-Latn-GH",
      "gaf": "gaf-Latn-ZZ",
      "gag": "gag-Latn-MD",
      "gah": "gah-Latn-ZZ",
      "gaj": "gaj-Latn-ZZ",
      "gam": "gam-Latn-ZZ",
      "gan": "gan-Hans-CN",
      "gaw": "gaw-Latn-ZZ",
      "gay": "gay-Latn-ID",
      "gba": "gba-Latn-ZZ",
      "gbf": "gbf-Latn-ZZ",
      "gbm": "gbm-Deva-IN",
      "gby": "gby-Latn-ZZ",
      "gbz": "gbz-Arab-IR",
      "gcr": "gcr-Latn-GF",
      "gd": "gd-Latn-GB",
      "gde": "gde-Latn-ZZ",
      "gdn": "gdn-Latn-ZZ",
      "gdr": "gdr-Latn-ZZ",
      "geb": "geb-Latn-ZZ",
      "gej": "gej-Latn-ZZ",
      "gel": "gel-Latn-ZZ",
      "gez": "gez-Ethi-ET",
      "gfk": "gfk-Latn-ZZ",
      "ggn": "ggn-Deva-NP",
      "ghs": "ghs-Latn-ZZ",
      "gil": "gil-Latn-KI",
      "gim": "gim-Latn-ZZ",
      "gjk": "gjk-Arab-PK",
      "gjn": "gjn-Latn-ZZ",
      "gju": "gju-Arab-PK",
      "gkn": "gkn-Latn-ZZ",
      "gkp": "gkp-Latn-ZZ",
      "gl": "gl-Latn-ES",
      "glk": "glk-Arab-IR",
      "gmm": "gmm-Latn-ZZ",
      "gmv": "gmv-Ethi-ZZ",
      "gn": "gn-Latn-PY",
      "gnd": "gnd-Latn-ZZ",
      "gng": "gng-Latn-ZZ",
      "god": "god-Latn-ZZ",
      "gof": "gof-Ethi-ZZ",
      "goi": "goi-Latn-ZZ",
      "gom": "gom-Deva-IN",
      "gon": "gon-Telu-IN",
      "gor": "gor-Latn-ID",
      "gos": "gos-Latn-NL",
      "got": "got-Goth-UA",
      "grb": "grb-Latn-ZZ",
      "grc": "grc-Cprt-CY",
      "grc-Linb": "grc-Linb-GR",
      "grt": "grt-Beng-IN",
      "grw": "grw-Latn-ZZ",
      "gsw": "gsw-Latn-CH",
      "gu": "gu-Gujr-IN",
      "gub": "gub-Latn-BR",
      "guc": "guc-Latn-CO",
      "gud": "gud-Latn-ZZ",
      "gur": "gur-Latn-GH",
      "guw": "guw-Latn-ZZ",
      "gux": "gux-Latn-ZZ",
      "guz": "guz-Latn-KE",
      "gv": "gv-Latn-IM",
      "gvf": "gvf-Latn-ZZ",
      "gvr": "gvr-Deva-NP",
      "gvs": "gvs-Latn-ZZ",
      "gwc": "gwc-Arab-ZZ",
      "gwi": "gwi-Latn-CA",
      "gwt": "gwt-Arab-ZZ",
      "gyi": "gyi-Latn-ZZ",
      "ha": "ha-Latn-NG",
      "ha-CM": "ha-Arab-CM",
      "ha-SD": "ha-Arab-SD",
      "hag": "hag-Latn-ZZ",
      "hak": "hak-Hans-CN",
      "ham": "ham-Latn-ZZ",
      "haw": "haw-Latn-US",
      "haz": "haz-Arab-AF",
      "hbb": "hbb-Latn-ZZ",
      "hdy": "hdy-Ethi-ZZ",
      "he": "he-Hebr-IL",
      "hhy": "hhy-Latn-ZZ",
      "hi": "hi-Deva-IN",
      "hia": "hia-Latn-ZZ",
      "hif": "hif-Latn-FJ",
      "hig": "hig-Latn-ZZ",
      "hih": "hih-Latn-ZZ",
      "hil": "hil-Latn-PH",
      "hla": "hla-Latn-ZZ",
      "hlu": "hlu-Hluw-TR",
      "hmd": "hmd-Plrd-CN",
      "hmt": "hmt-Latn-ZZ",
      "hnd": "hnd-Arab-PK",
      "hne": "hne-Deva-IN",
      "hnj": "hnj-Hmng-LA",
      "hnn": "hnn-Latn-PH",
      "hno": "hno-Arab-PK",
      "ho": "ho-Latn-PG",
      "hoc": "hoc-Deva-IN",
      "hoj": "hoj-Deva-IN",
      "hot": "hot-Latn-ZZ",
      "hr": "hr-Latn-HR",
      "hsb": "hsb-Latn-DE",
      "hsn": "hsn-Hans-CN",
      "ht": "ht-Latn-HT",
      "hu": "hu-Latn-HU",
      "hui": "hui-Latn-ZZ",
      "hy": "hy-Armn-AM",
      "hz": "hz-Latn-NA",
      "ia": "ia-Latn-001",
      "ian": "ian-Latn-ZZ",
      "iar": "iar-Latn-ZZ",
      "iba": "iba-Latn-MY",
      "ibb": "ibb-Latn-NG",
      "iby": "iby-Latn-ZZ",
      "ica": "ica-Latn-ZZ",
      "ich": "ich-Latn-ZZ",
      "id": "id-Latn-ID",
      "idd": "idd-Latn-ZZ",
      "idi": "idi-Latn-ZZ",
      "idu": "idu-Latn-ZZ",
      "ife": "ife-Latn-TG",
      "ig": "ig-Latn-NG",
      "igb": "igb-Latn-ZZ",
      "ige": "ige-Latn-ZZ",
      "ii": "ii-Yiii-CN",
      "ijj": "ijj-Latn-ZZ",
      "ik": "ik-Latn-US",
      "ikk": "ikk-Latn-ZZ",
      "ikt": "ikt-Latn-CA",
      "ikw": "ikw-Latn-ZZ",
      "ikx": "ikx-Latn-ZZ",
      "ilo": "ilo-Latn-PH",
      "imo": "imo-Latn-ZZ",
      "in": "in-Latn-ID",
      "inh": "inh-Cyrl-RU",
      "io": "io-Latn-001",
      "iou": "iou-Latn-ZZ",
      "iri": "iri-Latn-ZZ",
      "is": "is-Latn-IS",
      "it": "it-Latn-IT",
      "iu": "iu-Cans-CA",
      "iw": "iw-Hebr-IL",
      "iwm": "iwm-Latn-ZZ",
      "iws": "iws-Latn-ZZ",
      "izh": "izh-Latn-RU",
      "izi": "izi-Latn-ZZ",
      "ja": "ja-Jpan-JP",
      "jab": "jab-Latn-ZZ",
      "jam": "jam-Latn-JM",
      "jbo": "jbo-Latn-001",
      "jbu": "jbu-Latn-ZZ",
      "jen": "jen-Latn-ZZ",
      "jgk": "jgk-Latn-ZZ",
      "jgo": "jgo-Latn-CM",
      "ji": "ji-Hebr-UA",
      "jib": "jib-Latn-ZZ",
      "jmc": "jmc-Latn-TZ",
      "jml": "jml-Deva-NP",
      "jra": "jra-Latn-ZZ",
      "jut": "jut-Latn-DK",
      "jv": "jv-Latn-ID",
      "jw": "jw-Latn-ID",
      "ka": "ka-Geor-GE",
      "kaa": "kaa-Cyrl-UZ",
      "kab": "kab-Latn-DZ",
      "kac": "kac-Latn-MM",
      "kad": "kad-Latn-ZZ",
      "kai": "kai-Latn-ZZ",
      "kaj": "kaj-Latn-NG",
      "kam": "kam-Latn-KE",
      "kao": "kao-Latn-ML",
      "kbd": "kbd-Cyrl-RU",
      "kbm": "kbm-Latn-ZZ",
      "kbp": "kbp-Latn-ZZ",
      "kbq": "kbq-Latn-ZZ",
      "kbx": "kbx-Latn-ZZ",
      "kby": "kby-Arab-NE",
      "kcg": "kcg-Latn-NG",
      "kck": "kck-Latn-ZW",
      "kcl": "kcl-Latn-ZZ",
      "kct": "kct-Latn-ZZ",
      "kde": "kde-Latn-TZ",
      "kdh": "kdh-Arab-TG",
      "kdl": "kdl-Latn-ZZ",
      "kdt": "kdt-Thai-TH",
      "kea": "kea-Latn-CV",
      "ken": "ken-Latn-CM",
      "kez": "kez-Latn-ZZ",
      "kfo": "kfo-Latn-CI",
      "kfr": "kfr-Deva-IN",
      "kfy": "kfy-Deva-IN",
      "kg": "kg-Latn-CD",
      "kge": "kge-Latn-ID",
      "kgf": "kgf-Latn-ZZ",
      "kgp": "kgp-Latn-BR",
      "kha": "kha-Latn-IN",
      "khb": "khb-Talu-CN",
      "khn": "khn-Deva-IN",
      "khq": "khq-Latn-ML",
      "khs": "khs-Latn-ZZ",
      "kht": "kht-Mymr-IN",
      "khw": "khw-Arab-PK",
      "khz": "khz-Latn-ZZ",
      "ki": "ki-Latn-KE",
      "kij": "kij-Latn-ZZ",
      "kiu": "kiu-Latn-TR",
      "kiw": "kiw-Latn-ZZ",
      "kj": "kj-Latn-NA",
      "kjd": "kjd-Latn-ZZ",
      "kjg": "kjg-Laoo-LA",
      "kjs": "kjs-Latn-ZZ",
      "kjy": "kjy-Latn-ZZ",
      "kk": "kk-Cyrl-KZ",
      "kk-AF": "kk-Arab-AF",
      "kk-Arab": "kk-Arab-CN",
      "kk-CN": "kk-Arab-CN",
      "kk-IR": "kk-Arab-IR",
      "kk-MN": "kk-Arab-MN",
      "kkc": "kkc-Latn-ZZ",
      "kkj": "kkj-Latn-CM",
      "kl": "kl-Latn-GL",
      "kln": "kln-Latn-KE",
      "klq": "klq-Latn-ZZ",
      "klt": "klt-Latn-ZZ",
      "klx": "klx-Latn-ZZ",
      "km": "km-Khmr-KH",
      "kmb": "kmb-Latn-AO",
      "kmh": "kmh-Latn-ZZ",
      "kmo": "kmo-Latn-ZZ",
      "kms": "kms-Latn-ZZ",
      "kmu": "kmu-Latn-ZZ",
      "kmw": "kmw-Latn-ZZ",
      "kn": "kn-Knda-IN",
      "knf": "knf-Latn-GW",
      "knp": "knp-Latn-ZZ",
      "ko": "ko-Kore-KR",
      "koi": "koi-Cyrl-RU",
      "kok": "kok-Deva-IN",
      "kol": "kol-Latn-ZZ",
      "kos": "kos-Latn-FM",
      "koz": "koz-Latn-ZZ",
      "kpe": "kpe-Latn-LR",
      "kpf": "kpf-Latn-ZZ",
      "kpo": "kpo-Latn-ZZ",
      "kpr": "kpr-Latn-ZZ",
      "kpx": "kpx-Latn-ZZ",
      "kqb": "kqb-Latn-ZZ",
      "kqf": "kqf-Latn-ZZ",
      "kqs": "kqs-Latn-ZZ",
      "kqy": "kqy-Ethi-ZZ",
      "kr": "kr-Latn-ZZ",
      "krc": "krc-Cyrl-RU",
      "kri": "kri-Latn-SL",
      "krj": "krj-Latn-PH",
      "krl": "krl-Latn-RU",
      "krs": "krs-Latn-ZZ",
      "kru": "kru-Deva-IN",
      "ks": "ks-Arab-IN",
      "ksb": "ksb-Latn-TZ",
      "ksd": "ksd-Latn-ZZ",
      "ksf": "ksf-Latn-CM",
      "ksh": "ksh-Latn-DE",
      "ksj": "ksj-Latn-ZZ",
      "ksr": "ksr-Latn-ZZ",
      "ktb": "ktb-Ethi-ZZ",
      "ktm": "ktm-Latn-ZZ",
      "kto": "kto-Latn-ZZ",
      "ku": "ku-Latn-TR",
      "ku-Arab": "ku-Arab-IQ",
      "ku-LB": "ku-Arab-LB",
      "kub": "kub-Latn-ZZ",
      "kud": "kud-Latn-ZZ",
      "kue": "kue-Latn-ZZ",
      "kuj": "kuj-Latn-ZZ",
      "kum": "kum-Cyrl-RU",
      "kun": "kun-Latn-ZZ",
      "kup": "kup-Latn-ZZ",
      "kus": "kus-Latn-ZZ",
      "kv": "kv-Cyrl-RU",
      "kvg": "kvg-Latn-ZZ",
      "kvr": "kvr-Latn-ID",
      "kvx": "kvx-Arab-PK",
      "kw": "kw-Latn-GB",
      "kwj": "kwj-Latn-ZZ",
      "kwo": "kwo-Latn-ZZ",
      "kxa": "kxa-Latn-ZZ",
      "kxc": "kxc-Ethi-ZZ",
      "kxm": "kxm-Thai-TH",
      "kxp": "kxp-Arab-PK",
      "kxw": "kxw-Latn-ZZ",
      "kxz": "kxz-Latn-ZZ",
      "ky": "ky-Cyrl-KG",
      "ky-Arab": "ky-Arab-CN",
      "ky-CN": "ky-Arab-CN",
      "ky-Latn": "ky-Latn-TR",
      "ky-TR": "ky-Latn-TR",
      "kye": "kye-Latn-ZZ",
      "kyx": "kyx-Latn-ZZ",
      "kzr": "kzr-Latn-ZZ",
      "la": "la-Latn-VA",
      "lab": "lab-Lina-GR",
      "lad": "lad-Hebr-IL",
      "lag": "lag-Latn-TZ",
      "lah": "lah-Arab-PK",
      "laj": "laj-Latn-UG",
      "las": "las-Latn-ZZ",
      "lb": "lb-Latn-LU",
      "lbe": "lbe-Cyrl-RU",
      "lbu": "lbu-Latn-ZZ",
      "lbw": "lbw-Latn-ID",
      "lcm": "lcm-Latn-ZZ",
      "lcp": "lcp-Thai-CN",
      "ldb": "ldb-Latn-ZZ",
      "led": "led-Latn-ZZ",
      "lee": "lee-Latn-ZZ",
      "lem": "lem-Latn-ZZ",
      "lep": "lep-Lepc-IN",
      "leq": "leq-Latn-ZZ",
      "leu": "leu-Latn-ZZ",
      "lez": "lez-Cyrl-RU",
      "lg": "lg-Latn-UG",
      "lgg": "lgg-Latn-ZZ",
      "li": "li-Latn-NL",
      "lia": "lia-Latn-ZZ",
      "lid": "lid-Latn-ZZ",
      "lif": "lif-Deva-NP",
      "lif-Limb": "lif-Limb-IN",
      "lig": "lig-Latn-ZZ",
      "lih": "lih-Latn-ZZ",
      "lij": "lij-Latn-IT",
      "lis": "lis-Lisu-CN",
      "ljp": "ljp-Latn-ID",
      "lki": "lki-Arab-IR",
      "lkt": "lkt-Latn-US",
      "lle": "lle-Latn-ZZ",
      "lln": "lln-Latn-ZZ",
      "lmn": "lmn-Telu-IN",
      "lmo": "lmo-Latn-IT",
      "lmp": "lmp-Latn-ZZ",
      "ln": "ln-Latn-CD",
      "lns": "lns-Latn-ZZ",
      "lnu": "lnu-Latn-ZZ",
      "lo": "lo-Laoo-LA",
      "loj": "loj-Latn-ZZ",
      "lok": "lok-Latn-ZZ",
      "lol": "lol-Latn-CD",
      "lor": "lor-Latn-ZZ",
      "los": "los-Latn-ZZ",
      "loz": "loz-Latn-ZM",
      "lrc": "lrc-Arab-IR",
      "lt": "lt-Latn-LT",
      "ltg": "ltg-Latn-LV",
      "lu": "lu-Latn-CD",
      "lua": "lua-Latn-CD",
      "luo": "luo-Latn-KE",
      "luy": "luy-Latn-KE",
      "luz": "luz-Arab-IR",
      "lv": "lv-Latn-LV",
      "lwl": "lwl-Thai-TH",
      "lzh": "lzh-Hans-CN",
      "lzz": "lzz-Latn-TR",
      "mad": "mad-Latn-ID",
      "maf": "maf-Latn-CM",
      "mag": "mag-Deva-IN",
      "mai": "mai-Deva-IN",
      "mak": "mak-Latn-ID",
      "man": "man-Latn-GM",
      "man-GN": "man-Nkoo-GN",
      "man-Nkoo": "man-Nkoo-GN",
      "mas": "mas-Latn-KE",
      "maw": "maw-Latn-ZZ",
      "maz": "maz-Latn-MX",
      "mbh": "mbh-Latn-ZZ",
      "mbo": "mbo-Latn-ZZ",
      "mbq": "mbq-Latn-ZZ",
      "mbu": "mbu-Latn-ZZ",
      "mbw": "mbw-Latn-ZZ",
      "mci": "mci-Latn-ZZ",
      "mcp": "mcp-Latn-ZZ",
      "mcq": "mcq-Latn-ZZ",
      "mcr": "mcr-Latn-ZZ",
      "mcu": "mcu-Latn-ZZ",
      "mda": "mda-Latn-ZZ",
      "mde": "mde-Arab-ZZ",
      "mdf": "mdf-Cyrl-RU",
      "mdh": "mdh-Latn-PH",
      "mdj": "mdj-Latn-ZZ",
      "mdr": "mdr-Latn-ID",
      "mdx": "mdx-Ethi-ZZ",
      "med": "med-Latn-ZZ",
      "mee": "mee-Latn-ZZ",
      "mek": "mek-Latn-ZZ",
      "men": "men-Latn-SL",
      "mer": "mer-Latn-KE",
      "met": "met-Latn-ZZ",
      "meu": "meu-Latn-ZZ",
      "mfa": "mfa-Arab-TH",
      "mfe": "mfe-Latn-MU",
      "mfn": "mfn-Latn-ZZ",
      "mfo": "mfo-Latn-ZZ",
      "mfq": "mfq-Latn-ZZ",
      "mg": "mg-Latn-MG",
      "mgh": "mgh-Latn-MZ",
      "mgl": "mgl-Latn-ZZ",
      "mgo": "mgo-Latn-CM",
      "mgp": "mgp-Deva-NP",
      "mgy": "mgy-Latn-TZ",
      "mh": "mh-Latn-MH",
      "mhi": "mhi-Latn-ZZ",
      "mhl": "mhl-Latn-ZZ",
      "mi": "mi-Latn-NZ",
      "mif": "mif-Latn-ZZ",
      "min": "min-Latn-ID",
      "mis": "mis-Hatr-IQ",
      "mis-Medf": "mis-Medf-NG",
      "miw": "miw-Latn-ZZ",
      "mk": "mk-Cyrl-MK",
      "mki": "mki-Arab-ZZ",
      "mkl": "mkl-Latn-ZZ",
      "mkp": "mkp-Latn-ZZ",
      "mkw": "mkw-Latn-ZZ",
      "ml": "ml-Mlym-IN",
      "mle": "mle-Latn-ZZ",
      "mlp": "mlp-Latn-ZZ",
      "mls": "mls-Latn-SD",
      "mmo": "mmo-Latn-ZZ",
      "mmu": "mmu-Latn-ZZ",
      "mmx": "mmx-Latn-ZZ",
      "mn": "mn-Cyrl-MN",
      "mn-CN": "mn-Mong-CN",
      "mn-Mong": "mn-Mong-CN",
      "mna": "mna-Latn-ZZ",
      "mnf": "mnf-Latn-ZZ",
      "mni": "mni-Beng-IN",
      "mnw": "mnw-Mymr-MM",
      "moa": "moa-Latn-ZZ",
      "moe": "moe-Latn-CA",
      "moh": "moh-Latn-CA",
      "mos": "mos-Latn-BF",
      "mox": "mox-Latn-ZZ",
      "mpp": "mpp-Latn-ZZ",
      "mps": "mps-Latn-ZZ",
      "mpt": "mpt-Latn-ZZ",
      "mpx": "mpx-Latn-ZZ",
      "mql": "mql-Latn-ZZ",
      "mr": "mr-Deva-IN",
      "mrd": "mrd-Deva-NP",
      "mrj": "mrj-Cyrl-RU",
      "mro": "mro-Mroo-BD",
      "ms": "ms-Latn-MY",
      "ms-CC": "ms-Arab-CC",
      "ms-ID": "ms-Arab-ID",
      "mt": "mt-Latn-MT",
      "mtc": "mtc-Latn-ZZ",
      "mtf": "mtf-Latn-ZZ",
      "mti": "mti-Latn-ZZ",
      "mtr": "mtr-Deva-IN",
      "mua": "mua-Latn-CM",
      "mur": "mur-Latn-ZZ",
      "mus": "mus-Latn-US",
      "mva": "mva-Latn-ZZ",
      "mvn": "mvn-Latn-ZZ",
      "mvy": "mvy-Arab-PK",
      "mwk": "mwk-Latn-ML",
      "mwr": "mwr-Deva-IN",
      "mwv": "mwv-Latn-ID",
      "mww": "mww-Hmnp-US",
      "mxc": "mxc-Latn-ZW",
      "mxm": "mxm-Latn-ZZ",
      "my": "my-Mymr-MM",
      "myk": "myk-Latn-ZZ",
      "mym": "mym-Ethi-ZZ",
      "myv": "myv-Cyrl-RU",
      "myw": "myw-Latn-ZZ",
      "myx": "myx-Latn-UG",
      "myz": "myz-Mand-IR",
      "mzk": "mzk-Latn-ZZ",
      "mzm": "mzm-Latn-ZZ",
      "mzn": "mzn-Arab-IR",
      "mzp": "mzp-Latn-ZZ",
      "mzw": "mzw-Latn-ZZ",
      "mzz": "mzz-Latn-ZZ",
      "na": "na-Latn-NR",
      "nac": "nac-Latn-ZZ",
      "naf": "naf-Latn-ZZ",
      "nak": "nak-Latn-ZZ",
      "nan": "nan-Hans-CN",
      "nap": "nap-Latn-IT",
      "naq": "naq-Latn-NA",
      "nas": "nas-Latn-ZZ",
      "nb": "nb-Latn-NO",
      "nca": "nca-Latn-ZZ",
      "nce": "nce-Latn-ZZ",
      "ncf": "ncf-Latn-ZZ",
      "nch": "nch-Latn-MX",
      "nco": "nco-Latn-ZZ",
      "ncu": "ncu-Latn-ZZ",
      "nd": "nd-Latn-ZW",
      "ndc": "ndc-Latn-MZ",
      "nds": "nds-Latn-DE",
      "ne": "ne-Deva-NP",
      "neb": "neb-Latn-ZZ",
      "new": "new-Deva-NP",
      "nex": "nex-Latn-ZZ",
      "nfr": "nfr-Latn-ZZ",
      "ng": "ng-Latn-NA",
      "nga": "nga-Latn-ZZ",
      "ngb": "ngb-Latn-ZZ",
      "ngl": "ngl-Latn-MZ",
      "nhb": "nhb-Latn-ZZ",
      "nhe": "nhe-Latn-MX",
      "nhw": "nhw-Latn-MX",
      "nif": "nif-Latn-ZZ",
      "nii": "nii-Latn-ZZ",
      "nij": "nij-Latn-ID",
      "nin": "nin-Latn-ZZ",
      "niu": "niu-Latn-NU",
      "niy": "niy-Latn-ZZ",
      "niz": "niz-Latn-ZZ",
      "njo": "njo-Latn-IN",
      "nkg": "nkg-Latn-ZZ",
      "nko": "nko-Latn-ZZ",
      "nl": "nl-Latn-NL",
      "nmg": "nmg-Latn-CM",
      "nmz": "nmz-Latn-ZZ",
      "nn": "nn-Latn-NO",
      "nnf": "nnf-Latn-ZZ",
      "nnh": "nnh-Latn-CM",
      "nnk": "nnk-Latn-ZZ",
      "nnm": "nnm-Latn-ZZ",
      "nnp": "nnp-Wcho-IN",
      "no": "no-Latn-NO",
      "nod": "nod-Lana-TH",
      "noe": "noe-Deva-IN",
      "non": "non-Runr-SE",
      "nop": "nop-Latn-ZZ",
      "nou": "nou-Latn-ZZ",
      "nqo": "nqo-Nkoo-GN",
      "nr": "nr-Latn-ZA",
      "nrb": "nrb-Latn-ZZ",
      "nsk": "nsk-Cans-CA",
      "nsn": "nsn-Latn-ZZ",
      "nso": "nso-Latn-ZA",
      "nss": "nss-Latn-ZZ",
      "ntm": "ntm-Latn-ZZ",
      "ntr": "ntr-Latn-ZZ",
      "nui": "nui-Latn-ZZ",
      "nup": "nup-Latn-ZZ",
      "nus": "nus-Latn-SS",
      "nuv": "nuv-Latn-ZZ",
      "nux": "nux-Latn-ZZ",
      "nv": "nv-Latn-US",
      "nwb": "nwb-Latn-ZZ",
      "nxq": "nxq-Latn-CN",
      "nxr": "nxr-Latn-ZZ",
      "ny": "ny-Latn-MW",
      "nym": "nym-Latn-TZ",
      "nyn": "nyn-Latn-UG",
      "nzi": "nzi-Latn-GH",
      "oc": "oc-Latn-FR",
      "ogc": "ogc-Latn-ZZ",
      "okr": "okr-Latn-ZZ",
      "okv": "okv-Latn-ZZ",
      "om": "om-Latn-ET",
      "ong": "ong-Latn-ZZ",
      "onn": "onn-Latn-ZZ",
      "ons": "ons-Latn-ZZ",
      "opm": "opm-Latn-ZZ",
      "or": "or-Orya-IN",
      "oro": "oro-Latn-ZZ",
      "oru": "oru-Arab-ZZ",
      "os": "os-Cyrl-GE",
      "osa": "osa-Osge-US",
      "ota": "ota-Arab-ZZ",
      "otk": "otk-Orkh-MN",
      "ozm": "ozm-Latn-ZZ",
      "pa": "pa-Guru-IN",
      "pa-Arab": "pa-Arab-PK",
      "pa-PK": "pa-Arab-PK",
      "pag": "pag-Latn-PH",
      "pal": "pal-Phli-IR",
      "pal-Phlp": "pal-Phlp-CN",
      "pam": "pam-Latn-PH",
      "pap": "pap-Latn-AW",
      "pau": "pau-Latn-PW",
      "pbi": "pbi-Latn-ZZ",
      "pcd": "pcd-Latn-FR",
      "pcm": "pcm-Latn-NG",
      "pdc": "pdc-Latn-US",
      "pdt": "pdt-Latn-CA",
      "ped": "ped-Latn-ZZ",
      "peo": "peo-Xpeo-IR",
      "pex": "pex-Latn-ZZ",
      "pfl": "pfl-Latn-DE",
      "phl": "phl-Arab-ZZ",
      "phn": "phn-Phnx-LB",
      "pil": "pil-Latn-ZZ",
      "pip": "pip-Latn-ZZ",
      "pka": "pka-Brah-IN",
      "pko": "pko-Latn-KE",
      "pl": "pl-Latn-PL",
      "pla": "pla-Latn-ZZ",
      "pms": "pms-Latn-IT",
      "png": "png-Latn-ZZ",
      "pnn": "pnn-Latn-ZZ",
      "pnt": "pnt-Grek-GR",
      "pon": "pon-Latn-FM",
      "ppo": "ppo-Latn-ZZ",
      "pra": "pra-Khar-PK",
      "prd": "prd-Arab-IR",
      "prg": "prg-Latn-001",
      "ps": "ps-Arab-AF",
      "pss": "pss-Latn-ZZ",
      "pt": "pt-Latn-BR",
      "ptp": "ptp-Latn-ZZ",
      "puu": "puu-Latn-GA",
      "pwa": "pwa-Latn-ZZ",
      "qu": "qu-Latn-PE",
      "quc": "quc-Latn-GT",
      "qug": "qug-Latn-EC",
      "rai": "rai-Latn-ZZ",
      "raj": "raj-Deva-IN",
      "rao": "rao-Latn-ZZ",
      "rcf": "rcf-Latn-RE",
      "rej": "rej-Latn-ID",
      "rel": "rel-Latn-ZZ",
      "res": "res-Latn-ZZ",
      "rgn": "rgn-Latn-IT",
      "rhg": "rhg-Arab-MM",
      "ria": "ria-Latn-IN",
      "rif": "rif-Tfng-MA",
      "rif-NL": "rif-Latn-NL",
      "rjs": "rjs-Deva-NP",
      "rkt": "rkt-Beng-BD",
      "rm": "rm-Latn-CH",
      "rmf": "rmf-Latn-FI",
      "rmo": "rmo-Latn-CH",
      "rmt": "rmt-Arab-IR",
      "rmu": "rmu-Latn-SE",
      "rn": "rn-Latn-BI",
      "rna": "rna-Latn-ZZ",
      "rng": "rng-Latn-MZ",
      "ro": "ro-Latn-RO",
      "rob": "rob-Latn-ID",
      "rof": "rof-Latn-TZ",
      "roo": "roo-Latn-ZZ",
      "rro": "rro-Latn-ZZ",
      "rtm": "rtm-Latn-FJ",
      "ru": "ru-Cyrl-RU",
      "rue": "rue-Cyrl-UA",
      "rug": "rug-Latn-SB",
      "rw": "rw-Latn-RW",
      "rwk": "rwk-Latn-TZ",
      "rwo": "rwo-Latn-ZZ",
      "ryu": "ryu-Kana-JP",
      "sa": "sa-Deva-IN",
      "saf": "saf-Latn-GH",
      "sah": "sah-Cyrl-RU",
      "saq": "saq-Latn-KE",
      "sas": "sas-Latn-ID",
      "sat": "sat-Latn-IN",
      "sav": "sav-Latn-SN",
      "saz": "saz-Saur-IN",
      "sba": "sba-Latn-ZZ",
      "sbe": "sbe-Latn-ZZ",
      "sbp": "sbp-Latn-TZ",
      "sc": "sc-Latn-IT",
      "sck": "sck-Deva-IN",
      "scl": "scl-Arab-ZZ",
      "scn": "scn-Latn-IT",
      "sco": "sco-Latn-GB",
      "scs": "scs-Latn-CA",
      "sd": "sd-Arab-PK",
      "sd-Deva": "sd-Deva-IN",
      "sd-Khoj": "sd-Khoj-IN",
      "sd-Sind": "sd-Sind-IN",
      "sdc": "sdc-Latn-IT",
      "sdh": "sdh-Arab-IR",
      "se": "se-Latn-NO",
      "sef": "sef-Latn-CI",
      "seh": "seh-Latn-MZ",
      "sei": "sei-Latn-MX",
      "ses": "ses-Latn-ML",
      "sg": "sg-Latn-CF",
      "sga": "sga-Ogam-IE",
      "sgs": "sgs-Latn-LT",
      "sgw": "sgw-Ethi-ZZ",
      "sgz": "sgz-Latn-ZZ",
      "shi": "shi-Tfng-MA",
      "shk": "shk-Latn-ZZ",
      "shn": "shn-Mymr-MM",
      "shu": "shu-Arab-ZZ",
      "si": "si-Sinh-LK",
      "sid": "sid-Latn-ET",
      "sig": "sig-Latn-ZZ",
      "sil": "sil-Latn-ZZ",
      "sim": "sim-Latn-ZZ",
      "sjr": "sjr-Latn-ZZ",
      "sk": "sk-Latn-SK",
      "skc": "skc-Latn-ZZ",
      "skr": "skr-Arab-PK",
      "sks": "sks-Latn-ZZ",
      "sl": "sl-Latn-SI",
      "sld": "sld-Latn-ZZ",
      "sli": "sli-Latn-PL",
      "sll": "sll-Latn-ZZ",
      "sly": "sly-Latn-ID",
      "sm": "sm-Latn-WS",
      "sma": "sma-Latn-SE",
      "smj": "smj-Latn-SE",
      "smn": "smn-Latn-FI",
      "smp": "smp-Samr-IL",
      "smq": "smq-Latn-ZZ",
      "sms": "sms-Latn-FI",
      "sn": "sn-Latn-ZW",
      "snc": "snc-Latn-ZZ",
      "snk": "snk-Latn-ML",
      "snp": "snp-Latn-ZZ",
      "snx": "snx-Latn-ZZ",
      "sny": "sny-Latn-ZZ",
      "so": "so-Latn-SO",
      "sog": "sog-Sogd-UZ",
      "sok": "sok-Latn-ZZ",
      "soq": "soq-Latn-ZZ",
      "sou": "sou-Thai-TH",
      "soy": "soy-Latn-ZZ",
      "spd": "spd-Latn-ZZ",
      "spl": "spl-Latn-ZZ",
      "sps": "sps-Latn-ZZ",
      "sq": "sq-Latn-AL",
      "sr": "sr-Cyrl-RS",
      "sr-ME": "sr-Latn-ME",
      "sr-RO": "sr-Latn-RO",
      "sr-RU": "sr-Latn-RU",
      "sr-TR": "sr-Latn-TR",
      "srb": "srb-Sora-IN",
      "srn": "srn-Latn-SR",
      "srr": "srr-Latn-SN",
      "srx": "srx-Deva-IN",
      "ss": "ss-Latn-ZA",
      "ssd": "ssd-Latn-ZZ",
      "ssg": "ssg-Latn-ZZ",
      "ssy": "ssy-Latn-ER",
      "st": "st-Latn-ZA",
      "stk": "stk-Latn-ZZ",
      "stq": "stq-Latn-DE",
      "su": "su-Latn-ID",
      "sua": "sua-Latn-ZZ",
      "sue": "sue-Latn-ZZ",
      "suk": "suk-Latn-TZ",
      "sur": "sur-Latn-ZZ",
      "sus": "sus-Latn-GN",
      "sv": "sv-Latn-SE",
      "sw": "sw-Latn-TZ",
      "swb": "swb-Arab-YT",
      "swc": "swc-Latn-CD",
      "swg": "swg-Latn-DE",
      "swp": "swp-Latn-ZZ",
      "swv": "swv-Deva-IN",
      "sxn": "sxn-Latn-ID",
      "sxw": "sxw-Latn-ZZ",
      "syl": "syl-Beng-BD",
      "syr": "syr-Syrc-IQ",
      "szl": "szl-Latn-PL",
      "ta": "ta-Taml-IN",
      "taj": "taj-Deva-NP",
      "tal": "tal-Latn-ZZ",
      "tan": "tan-Latn-ZZ",
      "taq": "taq-Latn-ZZ",
      "tbc": "tbc-Latn-ZZ",
      "tbd": "tbd-Latn-ZZ",
      "tbf": "tbf-Latn-ZZ",
      "tbg": "tbg-Latn-ZZ",
      "tbo": "tbo-Latn-ZZ",
      "tbw": "tbw-Latn-PH",
      "tbz": "tbz-Latn-ZZ",
      "tci": "tci-Latn-ZZ",
      "tcy": "tcy-Knda-IN",
      "tdd": "tdd-Tale-CN",
      "tdg": "tdg-Deva-NP",
      "tdh": "tdh-Deva-NP",
      "te": "te-Telu-IN",
      "ted": "ted-Latn-ZZ",
      "tem": "tem-Latn-SL",
      "teo": "teo-Latn-UG",
      "tet": "tet-Latn-TL",
      "tfi": "tfi-Latn-ZZ",
      "tg": "tg-Cyrl-TJ",
      "tg-Arab": "tg-Arab-PK",
      "tg-PK": "tg-Arab-PK",
      "tgc": "tgc-Latn-ZZ",
      "tgo": "tgo-Latn-ZZ",
      "tgu": "tgu-Latn-ZZ",
      "th": "th-Thai-TH",
      "thl": "thl-Deva-NP",
      "thq": "thq-Deva-NP",
      "thr": "thr-Deva-NP",
      "ti": "ti-Ethi-ET",
      "tif": "tif-Latn-ZZ",
      "tig": "tig-Ethi-ER",
      "tik": "tik-Latn-ZZ",
      "tim": "tim-Latn-ZZ",
      "tio": "tio-Latn-ZZ",
      "tiv": "tiv-Latn-NG",
      "tk": "tk-Latn-TM",
      "tkl": "tkl-Latn-TK",
      "tkr": "tkr-Latn-AZ",
      "tkt": "tkt-Deva-NP",
      "tl": "tl-Latn-PH",
      "tlf": "tlf-Latn-ZZ",
      "tlx": "tlx-Latn-ZZ",
      "tly": "tly-Latn-AZ",
      "tmh": "tmh-Latn-NE",
      "tmy": "tmy-Latn-ZZ",
      "tn": "tn-Latn-ZA",
      "tnh": "tnh-Latn-ZZ",
      "to": "to-Latn-TO",
      "tof": "tof-Latn-ZZ",
      "tog": "tog-Latn-MW",
      "toq": "toq-Latn-ZZ",
      "tpi": "tpi-Latn-PG",
      "tpm": "tpm-Latn-ZZ",
      "tpz": "tpz-Latn-ZZ",
      "tqo": "tqo-Latn-ZZ",
      "tr": "tr-Latn-TR",
      "tru": "tru-Latn-TR",
      "trv": "trv-Latn-TW",
      "trw": "trw-Arab-ZZ",
      "ts": "ts-Latn-ZA",
      "tsd": "tsd-Grek-GR",
      "tsf": "tsf-Deva-NP",
      "tsg": "tsg-Latn-PH",
      "tsj": "tsj-Tibt-BT",
      "tsw": "tsw-Latn-ZZ",
      "tt": "tt-Cyrl-RU",
      "ttd": "ttd-Latn-ZZ",
      "tte": "tte-Latn-ZZ",
      "ttj": "ttj-Latn-UG",
      "ttr": "ttr-Latn-ZZ",
      "tts": "tts-Thai-TH",
      "ttt": "ttt-Latn-AZ",
      "tuh": "tuh-Latn-ZZ",
      "tul": "tul-Latn-ZZ",
      "tum": "tum-Latn-MW",
      "tuq": "tuq-Latn-ZZ",
      "tvd": "tvd-Latn-ZZ",
      "tvl": "tvl-Latn-TV",
      "tvu": "tvu-Latn-ZZ",
      "twh": "twh-Latn-ZZ",
      "twq": "twq-Latn-NE",
      "txg": "txg-Tang-CN",
      "ty": "ty-Latn-PF",
      "tya": "tya-Latn-ZZ",
      "tyv": "tyv-Cyrl-RU",
      "tzm": "tzm-Latn-MA",
      "ubu": "ubu-Latn-ZZ",
      "udm": "udm-Cyrl-RU",
      "ug": "ug-Arab-CN",
      "ug-Cyrl": "ug-Cyrl-KZ",
      "ug-KZ": "ug-Cyrl-KZ",
      "ug-MN": "ug-Cyrl-MN",
      "uga": "uga-Ugar-SY",
      "uk": "uk-Cyrl-UA",
      "uli": "uli-Latn-FM",
      "umb": "umb-Latn-AO",
      "und": "en-Latn-US",
      "und-002": "en-Latn-NG",
      "und-003": "en-Latn-US",
      "und-005": "pt-Latn-BR",
      "und-009": "en-Latn-AU",
      "und-011": "en-Latn-NG",
      "und-013": "es-Latn-MX",
      "und-014": "sw-Latn-TZ",
      "und-015": "ar-Arab-EG",
      "und-017": "sw-Latn-CD",
      "und-018": "en-Latn-ZA",
      "und-019": "en-Latn-US",
      "und-021": "en-Latn-US",
      "und-029": "es-Latn-CU",
      "und-030": "zh-Hans-CN",
      "und-034": "hi-Deva-IN",
      "und-035": "id-Latn-ID",
      "und-039": "it-Latn-IT",
      "und-053": "en-Latn-AU",
      "und-054": "en-Latn-PG",
      "und-057": "en-Latn-GU",
      "und-061": "sm-Latn-WS",
      "und-142": "zh-Hans-CN",
      "und-143": "uz-Latn-UZ",
      "und-145": "ar-Arab-SA",
      "und-150": "ru-Cyrl-RU",
      "und-151": "ru-Cyrl-RU",
      "und-154": "en-Latn-GB",
      "und-155": "de-Latn-DE",
      "und-202": "en-Latn-NG",
      "und-419": "es-Latn-419",
      "und-AD": "ca-Latn-AD",
      "und-Adlm": "ff-Adlm-GN",
      "und-AE": "ar-Arab-AE",
      "und-AF": "fa-Arab-AF",
      "und-Aghb": "lez-Aghb-RU",
      "und-Ahom": "aho-Ahom-IN",
      "und-AL": "sq-Latn-AL",
      "und-AM": "hy-Armn-AM",
      "und-AO": "pt-Latn-AO",
      "und-AQ": "und-Latn-AQ",
      "und-AR": "es-Latn-AR",
      "und-Arab": "ar-Arab-EG",
      "und-Arab-CC": "ms-Arab-CC",
      "und-Arab-CN": "ug-Arab-CN",
      "und-Arab-GB": "ks-Arab-GB",
      "und-Arab-ID": "ms-Arab-ID",
      "und-Arab-IN": "ur-Arab-IN",
      "und-Arab-KH": "cja-Arab-KH",
      "und-Arab-MM": "rhg-Arab-MM",
      "und-Arab-MN": "kk-Arab-MN",
      "und-Arab-MU": "ur-Arab-MU",
      "und-Arab-NG": "ha-Arab-NG",
      "und-Arab-PK": "ur-Arab-PK",
      "und-Arab-TG": "apd-Arab-TG",
      "und-Arab-TH": "mfa-Arab-TH",
      "und-Arab-TJ": "fa-Arab-TJ",
      "und-Arab-TR": "az-Arab-TR",
      "und-Arab-YT": "swb-Arab-YT",
      "und-Armi": "arc-Armi-IR",
      "und-Armn": "hy-Armn-AM",
      "und-AS": "sm-Latn-AS",
      "und-AT": "de-Latn-AT",
      "und-Avst": "ae-Avst-IR",
      "und-AW": "nl-Latn-AW",
      "und-AX": "sv-Latn-AX",
      "und-AZ": "az-Latn-AZ",
      "und-BA": "bs-Latn-BA",
      "und-Bali": "ban-Bali-ID",
      "und-Bamu": "bax-Bamu-CM",
      "und-Bass": "bsq-Bass-LR",
      "und-Batk": "bbc-Batk-ID",
      "und-BD": "bn-Beng-BD",
      "und-BE": "nl-Latn-BE",
      "und-Beng": "bn-Beng-BD",
      "und-BF": "fr-Latn-BF",
      "und-BG": "bg-Cyrl-BG",
      "und-BH": "ar-Arab-BH",
      "und-Bhks": "sa-Bhks-IN",
      "und-BI": "rn-Latn-BI",
      "und-BJ": "fr-Latn-BJ",
      "und-BL": "fr-Latn-BL",
      "und-BN": "ms-Latn-BN",
      "und-BO": "es-Latn-BO",
      "und-Bopo": "zh-Bopo-TW",
      "und-BQ": "pap-Latn-BQ",
      "und-BR": "pt-Latn-BR",
      "und-Brah": "pka-Brah-IN",
      "und-Brai": "fr-Brai-FR",
      "und-BT": "dz-Tibt-BT",
      "und-Bugi": "bug-Bugi-ID",
      "und-Buhd": "bku-Buhd-PH",
      "und-BV": "und-Latn-BV",
      "und-BY": "be-Cyrl-BY",
      "und-Cakm": "ccp-Cakm-BD",
      "und-Cans": "cr-Cans-CA",
      "und-Cari": "xcr-Cari-TR",
      "und-CD": "sw-Latn-CD",
      "und-CF": "fr-Latn-CF",
      "und-CG": "fr-Latn-CG",
      "und-CH": "de-Latn-CH",
      "und-Cham": "cjm-Cham-VN",
      "und-Cher": "chr-Cher-US",
      "und-CI": "fr-Latn-CI",
      "und-CL": "es-Latn-CL",
      "und-CM": "fr-Latn-CM",
      "und-CN": "zh-Hans-CN",
      "und-CO": "es-Latn-CO",
      "und-Copt": "cop-Copt-EG",
      "und-CP": "und-Latn-CP",
      "und-Cprt": "grc-Cprt-CY",
      "und-CR": "es-Latn-CR",
      "und-CU": "es-Latn-CU",
      "und-CV": "pt-Latn-CV",
      "und-CW": "pap-Latn-CW",
      "und-CY": "el-Grek-CY",
      "und-Cyrl": "ru-Cyrl-RU",
      "und-Cyrl-AL": "mk-Cyrl-AL",
      "und-Cyrl-BA": "sr-Cyrl-BA",
      "und-Cyrl-GE": "ab-Cyrl-GE",
      "und-Cyrl-GR": "mk-Cyrl-GR",
      "und-Cyrl-MD": "uk-Cyrl-MD",
      "und-Cyrl-RO": "bg-Cyrl-RO",
      "und-Cyrl-SK": "uk-Cyrl-SK",
      "und-Cyrl-TR": "kbd-Cyrl-TR",
      "und-Cyrl-XK": "sr-Cyrl-XK",
      "und-CZ": "cs-Latn-CZ",
      "und-DE": "de-Latn-DE",
      "und-Deva": "hi-Deva-IN",
      "und-Deva-BT": "ne-Deva-BT",
      "und-Deva-FJ": "hif-Deva-FJ",
      "und-Deva-MU": "bho-Deva-MU",
      "und-Deva-PK": "btv-Deva-PK",
      "und-DJ": "aa-Latn-DJ",
      "und-DK": "da-Latn-DK",
      "und-DO": "es-Latn-DO",
      "und-Dogr": "doi-Dogr-IN",
      "und-Dupl": "fr-Dupl-FR",
      "und-DZ": "ar-Arab-DZ",
      "und-EA": "es-Latn-EA",
      "und-EC": "es-Latn-EC",
      "und-EE": "et-Latn-EE",
      "und-EG": "ar-Arab-EG",
      "und-Egyp": "egy-Egyp-EG",
      "und-EH": "ar-Arab-EH",
      "und-Elba": "sq-Elba-AL",
      "und-Elym": "arc-Elym-IR",
      "und-ER": "ti-Ethi-ER",
      "und-ES": "es-Latn-ES",
      "und-ET": "am-Ethi-ET",
      "und-Ethi": "am-Ethi-ET",
      "und-EU": "en-Latn-GB",
      "und-EZ": "de-Latn-EZ",
      "und-FI": "fi-Latn-FI",
      "und-FO": "fo-Latn-FO",
      "und-FR": "fr-Latn-FR",
      "und-GA": "fr-Latn-GA",
      "und-GE": "ka-Geor-GE",
      "und-Geor": "ka-Geor-GE",
      "und-GF": "fr-Latn-GF",
      "und-GH": "ak-Latn-GH",
      "und-GL": "kl-Latn-GL",
      "und-Glag": "cu-Glag-BG",
      "und-GN": "fr-Latn-GN",
      "und-Gong": "wsg-Gong-IN",
      "und-Gonm": "esg-Gonm-IN",
      "und-Goth": "got-Goth-UA",
      "und-GP": "fr-Latn-GP",
      "und-GQ": "es-Latn-GQ",
      "und-GR": "el-Grek-GR",
      "und-Gran": "sa-Gran-IN",
      "und-Grek": "el-Grek-GR",
      "und-Grek-TR": "bgx-Grek-TR",
      "und-GS": "und-Latn-GS",
      "und-GT": "es-Latn-GT",
      "und-Gujr": "gu-Gujr-IN",
      "und-Guru": "pa-Guru-IN",
      "und-GW": "pt-Latn-GW",
      "und-Hanb": "zh-Hanb-TW",
      "und-Hang": "ko-Hang-KR",
      "und-Hani": "zh-Hani-CN",
      "und-Hano": "hnn-Hano-PH",
      "und-Hans": "zh-Hans-CN",
      "und-Hant": "zh-Hant-TW",
      "und-Hatr": "mis-Hatr-IQ",
      "und-Hebr": "he-Hebr-IL",
      "und-Hebr-CA": "yi-Hebr-CA",
      "und-Hebr-GB": "yi-Hebr-GB",
      "und-Hebr-SE": "yi-Hebr-SE",
      "und-Hebr-UA": "yi-Hebr-UA",
      "und-Hebr-US": "yi-Hebr-US",
      "und-Hira": "ja-Hira-JP",
      "und-HK": "zh-Hant-HK",
      "und-Hluw": "hlu-Hluw-TR",
      "und-HM": "und-Latn-HM",
      "und-Hmng": "hnj-Hmng-LA",
      "und-Hmnp": "mww-Hmnp-US",
      "und-HN": "es-Latn-HN",
      "und-HR": "hr-Latn-HR",
      "und-HT": "ht-Latn-HT",
      "und-HU": "hu-Latn-HU",
      "und-Hung": "hu-Hung-HU",
      "und-IC": "es-Latn-IC",
      "und-ID": "id-Latn-ID",
      "und-IL": "he-Hebr-IL",
      "und-IN": "hi-Deva-IN",
      "und-IQ": "ar-Arab-IQ",
      "und-IR": "fa-Arab-IR",
      "und-IS": "is-Latn-IS",
      "und-IT": "it-Latn-IT",
      "und-Ital": "ett-Ital-IT",
      "und-Jamo": "ko-Jamo-KR",
      "und-Java": "jv-Java-ID",
      "und-JO": "ar-Arab-JO",
      "und-JP": "ja-Jpan-JP",
      "und-Jpan": "ja-Jpan-JP",
      "und-Kali": "eky-Kali-MM",
      "und-Kana": "ja-Kana-JP",
      "und-KE": "sw-Latn-KE",
      "und-KG": "ky-Cyrl-KG",
      "und-KH": "km-Khmr-KH",
      "und-Khar": "pra-Khar-PK",
      "und-Khmr": "km-Khmr-KH",
      "und-Khoj": "sd-Khoj-IN",
      "und-KM": "ar-Arab-KM",
      "und-Knda": "kn-Knda-IN",
      "und-Kore": "ko-Kore-KR",
      "und-KP": "ko-Kore-KP",
      "und-KR": "ko-Kore-KR",
      "und-Kthi": "bho-Kthi-IN",
      "und-KW": "ar-Arab-KW",
      "und-KZ": "ru-Cyrl-KZ",
      "und-LA": "lo-Laoo-LA",
      "und-Lana": "nod-Lana-TH",
      "und-Laoo": "lo-Laoo-LA",
      "und-Latn-AF": "tk-Latn-AF",
      "und-Latn-AM": "ku-Latn-AM",
      "und-Latn-CN": "za-Latn-CN",
      "und-Latn-CY": "tr-Latn-CY",
      "und-Latn-DZ": "fr-Latn-DZ",
      "und-Latn-ET": "en-Latn-ET",
      "und-Latn-GE": "ku-Latn-GE",
      "und-Latn-IR": "tk-Latn-IR",
      "und-Latn-KM": "fr-Latn-KM",
      "und-Latn-MA": "fr-Latn-MA",
      "und-Latn-MK": "sq-Latn-MK",
      "und-Latn-MM": "kac-Latn-MM",
      "und-Latn-MO": "pt-Latn-MO",
      "und-Latn-MR": "fr-Latn-MR",
      "und-Latn-RU": "krl-Latn-RU",
      "und-Latn-SY": "fr-Latn-SY",
      "und-Latn-TN": "fr-Latn-TN",
      "und-Latn-TW": "trv-Latn-TW",
      "und-Latn-UA": "pl-Latn-UA",
      "und-LB": "ar-Arab-LB",
      "und-Lepc": "lep-Lepc-IN",
      "und-LI": "de-Latn-LI",
      "und-Limb": "lif-Limb-IN",
      "und-Lina": "lab-Lina-GR",
      "und-Linb": "grc-Linb-GR",
      "und-Lisu": "lis-Lisu-CN",
      "und-LK": "si-Sinh-LK",
      "und-LS": "st-Latn-LS",
      "und-LT": "lt-Latn-LT",
      "und-LU": "fr-Latn-LU",
      "und-LV": "lv-Latn-LV",
      "und-LY": "ar-Arab-LY",
      "und-Lyci": "xlc-Lyci-TR",
      "und-Lydi": "xld-Lydi-TR",
      "und-MA": "ar-Arab-MA",
      "und-Mahj": "hi-Mahj-IN",
      "und-Maka": "mak-Maka-ID",
      "und-Mand": "myz-Mand-IR",
      "und-Mani": "xmn-Mani-CN",
      "und-Marc": "bo-Marc-CN",
      "und-MC": "fr-Latn-MC",
      "und-MD": "ro-Latn-MD",
      "und-ME": "sr-Latn-ME",
      "und-Medf": "mis-Medf-NG",
      "und-Mend": "men-Mend-SL",
      "und-Merc": "xmr-Merc-SD",
      "und-Mero": "xmr-Mero-SD",
      "und-MF": "fr-Latn-MF",
      "und-MG": "mg-Latn-MG",
      "und-MK": "mk-Cyrl-MK",
      "und-ML": "bm-Latn-ML",
      "und-Mlym": "ml-Mlym-IN",
      "und-MM": "my-Mymr-MM",
      "und-MN": "mn-Cyrl-MN",
      "und-MO": "zh-Hant-MO",
      "und-Modi": "mr-Modi-IN",
      "und-Mong": "mn-Mong-CN",
      "und-MQ": "fr-Latn-MQ",
      "und-MR": "ar-Arab-MR",
      "und-Mroo": "mro-Mroo-BD",
      "und-MT": "mt-Latn-MT",
      "und-Mtei": "mni-Mtei-IN",
      "und-MU": "mfe-Latn-MU",
      "und-Mult": "skr-Mult-PK",
      "und-MV": "dv-Thaa-MV",
      "und-MX": "es-Latn-MX",
      "und-MY": "ms-Latn-MY",
      "und-Mymr": "my-Mymr-MM",
      "und-Mymr-IN": "kht-Mymr-IN",
      "und-Mymr-TH": "mnw-Mymr-TH",
      "und-MZ": "pt-Latn-MZ",
      "und-NA": "af-Latn-NA",
      "und-Nand": "sa-Nand-IN",
      "und-Narb": "xna-Narb-SA",
      "und-Nbat": "arc-Nbat-JO",
      "und-NC": "fr-Latn-NC",
      "und-NE": "ha-Latn-NE",
      "und-Newa": "new-Newa-NP",
      "und-NI": "es-Latn-NI",
      "und-Nkoo": "man-Nkoo-GN",
      "und-NL": "nl-Latn-NL",
      "und-NO": "nb-Latn-NO",
      "und-NP": "ne-Deva-NP",
      "und-Nshu": "zhx-Nshu-CN",
      "und-Ogam": "sga-Ogam-IE",
      "und-Olck": "sat-Olck-IN",
      "und-OM": "ar-Arab-OM",
      "und-Orkh": "otk-Orkh-MN",
      "und-Orya": "or-Orya-IN",
      "und-Osge": "osa-Osge-US",
      "und-Osma": "so-Osma-SO",
      "und-PA": "es-Latn-PA",
      "und-Palm": "arc-Palm-SY",
      "und-Pauc": "ctd-Pauc-MM",
      "und-PE": "es-Latn-PE",
      "und-Perm": "kv-Perm-RU",
      "und-PF": "fr-Latn-PF",
      "und-PG": "tpi-Latn-PG",
      "und-PH": "fil-Latn-PH",
      "und-Phag": "lzh-Phag-CN",
      "und-Phli": "pal-Phli-IR",
      "und-Phlp": "pal-Phlp-CN",
      "und-Phnx": "phn-Phnx-LB",
      "und-PK": "ur-Arab-PK",
      "und-PL": "pl-Latn-PL",
      "und-Plrd": "hmd-Plrd-CN",
      "und-PM": "fr-Latn-PM",
      "und-PR": "es-Latn-PR",
      "und-Prti": "xpr-Prti-IR",
      "und-PS": "ar-Arab-PS",
      "und-PT": "pt-Latn-PT",
      "und-PW": "pau-Latn-PW",
      "und-PY": "gn-Latn-PY",
      "und-QA": "ar-Arab-QA",
      "und-QO": "en-Latn-DG",
      "und-RE": "fr-Latn-RE",
      "und-Rjng": "rej-Rjng-ID",
      "und-RO": "ro-Latn-RO",
      "und-Rohg": "rhg-Rohg-MM",
      "und-RS": "sr-Cyrl-RS",
      "und-RU": "ru-Cyrl-RU",
      "und-Runr": "non-Runr-SE",
      "und-RW": "rw-Latn-RW",
      "und-SA": "ar-Arab-SA",
      "und-Samr": "smp-Samr-IL",
      "und-Sarb": "xsa-Sarb-YE",
      "und-Saur": "saz-Saur-IN",
      "und-SC": "fr-Latn-SC",
      "und-SD": "ar-Arab-SD",
      "und-SE": "sv-Latn-SE",
      "und-Sgnw": "ase-Sgnw-US",
      "und-Shaw": "en-Shaw-GB",
      "und-Shrd": "sa-Shrd-IN",
      "und-SI": "sl-Latn-SI",
      "und-Sidd": "sa-Sidd-IN",
      "und-Sind": "sd-Sind-IN",
      "und-Sinh": "si-Sinh-LK",
      "und-SJ": "nb-Latn-SJ",
      "und-SK": "sk-Latn-SK",
      "und-SM": "it-Latn-SM",
      "und-SN": "fr-Latn-SN",
      "und-SO": "so-Latn-SO",
      "und-Sogd": "sog-Sogd-UZ",
      "und-Sogo": "sog-Sogo-UZ",
      "und-Sora": "srb-Sora-IN",
      "und-Soyo": "cmg-Soyo-MN",
      "und-SR": "nl-Latn-SR",
      "und-ST": "pt-Latn-ST",
      "und-Sund": "su-Sund-ID",
      "und-SV": "es-Latn-SV",
      "und-SY": "ar-Arab-SY",
      "und-Sylo": "syl-Sylo-BD",
      "und-Syrc": "syr-Syrc-IQ",
      "und-Tagb": "tbw-Tagb-PH",
      "und-Takr": "doi-Takr-IN",
      "und-Tale": "tdd-Tale-CN",
      "und-Talu": "khb-Talu-CN",
      "und-Taml": "ta-Taml-IN",
      "und-Tang": "txg-Tang-CN",
      "und-Tavt": "blt-Tavt-VN",
      "und-TD": "fr-Latn-TD",
      "und-Telu": "te-Telu-IN",
      "und-TF": "fr-Latn-TF",
      "und-Tfng": "zgh-Tfng-MA",
      "und-TG": "fr-Latn-TG",
      "und-Tglg": "fil-Tglg-PH",
      "und-TH": "th-Thai-TH",
      "und-Thaa": "dv-Thaa-MV",
      "und-Thai": "th-Thai-TH",
      "und-Thai-CN": "lcp-Thai-CN",
      "und-Thai-KH": "kdt-Thai-KH",
      "und-Thai-LA": "kdt-Thai-LA",
      "und-Tibt": "bo-Tibt-CN",
      "und-Tirh": "mai-Tirh-IN",
      "und-TJ": "tg-Cyrl-TJ",
      "und-TK": "tkl-Latn-TK",
      "und-TL": "pt-Latn-TL",
      "und-TM": "tk-Latn-TM",
      "und-TN": "ar-Arab-TN",
      "und-TO": "to-Latn-TO",
      "und-TR": "tr-Latn-TR",
      "und-TV": "tvl-Latn-TV",
      "und-TW": "zh-Hant-TW",
      "und-TZ": "sw-Latn-TZ",
      "und-UA": "uk-Cyrl-UA",
      "und-UG": "sw-Latn-UG",
      "und-Ugar": "uga-Ugar-SY",
      "und-UY": "es-Latn-UY",
      "und-UZ": "uz-Latn-UZ",
      "und-VA": "it-Latn-VA",
      "und-Vaii": "vai-Vaii-LR",
      "und-VE": "es-Latn-VE",
      "und-VN": "vi-Latn-VN",
      "und-VU": "bi-Latn-VU",
      "und-Wara": "hoc-Wara-IN",
      "und-Wcho": "nnp-Wcho-IN",
      "und-WF": "fr-Latn-WF",
      "und-WS": "sm-Latn-WS",
      "und-XK": "sq-Latn-XK",
      "und-Xpeo": "peo-Xpeo-IR",
      "und-Xsux": "akk-Xsux-IQ",
      "und-YE": "ar-Arab-YE",
      "und-Yiii": "ii-Yiii-CN",
      "und-YT": "fr-Latn-YT",
      "und-Zanb": "cmg-Zanb-MN",
      "und-ZW": "sn-Latn-ZW",
      "unr": "unr-Beng-IN",
      "unr-Deva": "unr-Deva-NP",
      "unr-NP": "unr-Deva-NP",
      "unx": "unx-Beng-IN",
      "ur": "ur-Arab-PK",
      "uri": "uri-Latn-ZZ",
      "urt": "urt-Latn-ZZ",
      "urw": "urw-Latn-ZZ",
      "usa": "usa-Latn-ZZ",
      "utr": "utr-Latn-ZZ",
      "uvh": "uvh-Latn-ZZ",
      "uvl": "uvl-Latn-ZZ",
      "uz": "uz-Latn-UZ",
      "uz-AF": "uz-Arab-AF",
      "uz-Arab": "uz-Arab-AF",
      "uz-CN": "uz-Cyrl-CN",
      "vag": "vag-Latn-ZZ",
      "vai": "vai-Vaii-LR",
      "van": "van-Latn-ZZ",
      "ve": "ve-Latn-ZA",
      "vec": "vec-Latn-IT",
      "vep": "vep-Latn-RU",
      "vi": "vi-Latn-VN",
      "vic": "vic-Latn-SX",
      "viv": "viv-Latn-ZZ",
      "vls": "vls-Latn-BE",
      "vmf": "vmf-Latn-DE",
      "vmw": "vmw-Latn-MZ",
      "vo": "vo-Latn-001",
      "vot": "vot-Latn-RU",
      "vro": "vro-Latn-EE",
      "vun": "vun-Latn-TZ",
      "vut": "vut-Latn-ZZ",
      "wa": "wa-Latn-BE",
      "wae": "wae-Latn-CH",
      "waj": "waj-Latn-ZZ",
      "wal": "wal-Ethi-ET",
      "wan": "wan-Latn-ZZ",
      "war": "war-Latn-PH",
      "wbp": "wbp-Latn-AU",
      "wbq": "wbq-Telu-IN",
      "wbr": "wbr-Deva-IN",
      "wci": "wci-Latn-ZZ",
      "wer": "wer-Latn-ZZ",
      "wgi": "wgi-Latn-ZZ",
      "whg": "whg-Latn-ZZ",
      "wib": "wib-Latn-ZZ",
      "wiu": "wiu-Latn-ZZ",
      "wiv": "wiv-Latn-ZZ",
      "wja": "wja-Latn-ZZ",
      "wji": "wji-Latn-ZZ",
      "wls": "wls-Latn-WF",
      "wmo": "wmo-Latn-ZZ",
      "wnc": "wnc-Latn-ZZ",
      "wni": "wni-Arab-KM",
      "wnu": "wnu-Latn-ZZ",
      "wo": "wo-Latn-SN",
      "wob": "wob-Latn-ZZ",
      "wos": "wos-Latn-ZZ",
      "wrs": "wrs-Latn-ZZ",
      "wsg": "wsg-Gong-IN",
      "wsk": "wsk-Latn-ZZ",
      "wtm": "wtm-Deva-IN",
      "wuu": "wuu-Hans-CN",
      "wuv": "wuv-Latn-ZZ",
      "wwa": "wwa-Latn-ZZ",
      "xav": "xav-Latn-BR",
      "xbi": "xbi-Latn-ZZ",
      "xcr": "xcr-Cari-TR",
      "xes": "xes-Latn-ZZ",
      "xh": "xh-Latn-ZA",
      "xla": "xla-Latn-ZZ",
      "xlc": "xlc-Lyci-TR",
      "xld": "xld-Lydi-TR",
      "xmf": "xmf-Geor-GE",
      "xmn": "xmn-Mani-CN",
      "xmr": "xmr-Merc-SD",
      "xna": "xna-Narb-SA",
      "xnr": "xnr-Deva-IN",
      "xog": "xog-Latn-UG",
      "xon": "xon-Latn-ZZ",
      "xpr": "xpr-Prti-IR",
      "xrb": "xrb-Latn-ZZ",
      "xsa": "xsa-Sarb-YE",
      "xsi": "xsi-Latn-ZZ",
      "xsm": "xsm-Latn-ZZ",
      "xsr": "xsr-Deva-NP",
      "xwe": "xwe-Latn-ZZ",
      "yam": "yam-Latn-ZZ",
      "yao": "yao-Latn-MZ",
      "yap": "yap-Latn-FM",
      "yas": "yas-Latn-ZZ",
      "yat": "yat-Latn-ZZ",
      "yav": "yav-Latn-CM",
      "yay": "yay-Latn-ZZ",
      "yaz": "yaz-Latn-ZZ",
      "yba": "yba-Latn-ZZ",
      "ybb": "ybb-Latn-CM",
      "yby": "yby-Latn-ZZ",
      "yer": "yer-Latn-ZZ",
      "ygr": "ygr-Latn-ZZ",
      "ygw": "ygw-Latn-ZZ",
      "yi": "yi-Hebr-001",
      "yko": "yko-Latn-ZZ",
      "yle": "yle-Latn-ZZ",
      "ylg": "ylg-Latn-ZZ",
      "yll": "yll-Latn-ZZ",
      "yml": "yml-Latn-ZZ",
      "yo": "yo-Latn-NG",
      "yon": "yon-Latn-ZZ",
      "yrb": "yrb-Latn-ZZ",
      "yre": "yre-Latn-ZZ",
      "yrl": "yrl-Latn-BR",
      "yss": "yss-Latn-ZZ",
      "yua": "yua-Latn-MX",
      "yue": "yue-Hant-HK",
      "yue-CN": "yue-Hans-CN",
      "yue-Hans": "yue-Hans-CN",
      "yuj": "yuj-Latn-ZZ",
      "yut": "yut-Latn-ZZ",
      "yuw": "yuw-Latn-ZZ",
      "za": "za-Latn-CN",
      "zag": "zag-Latn-SD",
      "zdj": "zdj-Arab-KM",
      "zea": "zea-Latn-NL",
      "zgh": "zgh-Tfng-MA",
      "zh": "zh-Hans-CN",
      "zh-AU": "zh-Hant-AU",
      "zh-BN": "zh-Hant-BN",
      "zh-Bopo": "zh-Bopo-TW",
      "zh-GB": "zh-Hant-GB",
      "zh-GF": "zh-Hant-GF",
      "zh-Hanb": "zh-Hanb-TW",
      "zh-Hant": "zh-Hant-TW",
      "zh-HK": "zh-Hant-HK",
      "zh-ID": "zh-Hant-ID",
      "zh-MO": "zh-Hant-MO",
      "zh-MY": "zh-Hant-MY",
      "zh-PA": "zh-Hant-PA",
      "zh-PF": "zh-Hant-PF",
      "zh-PH": "zh-Hant-PH",
      "zh-SR": "zh-Hant-SR",
      "zh-TH": "zh-Hant-TH",
      "zh-TW": "zh-Hant-TW",
      "zh-US": "zh-Hant-US",
      "zh-VN": "zh-Hant-VN",
      "zhx": "zhx-Nshu-CN",
      "zia": "zia-Latn-ZZ",
      "zlm": "zlm-Latn-TG",
      "zmi": "zmi-Latn-MY",
      "zne": "zne-Latn-ZZ",
      "zu": "zu-Latn-ZA",
      "zza": "zza-Latn-TR"
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "measurementData": {
      "measurementSystem": {
        "001": "metric",
        "GB": "UK",
        "LR": "US",
        "MM": "US",
        "US": "US"
      },
      "measurementSystem-category-temperature": {
        "BS": "US",
        "BZ": "US",
        "KY": "US",
        "LR": "metric",
        "MM": "metric",
        "PR": "US",
        "PW": "US"
      },
      "paperSize": {
        "001": "A4",
        "BZ": "US-Letter",
        "CA": "US-Letter",
        "CL": "US-Letter",
        "CO": "US-Letter",
        "CR": "US-Letter",
        "GT": "US-Letter",
        "MX": "US-Letter",
        "NI": "US-Letter",
        "PA": "US-Letter",
        "PH": "US-Letter",
        "PR": "US-Letter",
        "SV": "US-Letter",
        "US": "US-Letter",
        "VE": "US-Letter"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "metaZones": {
      "metazoneInfo": {
        "timezone": {
          "Africa": {
            "Abidjan": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Accra": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Addis_Ababa": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Algiers": [{
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_to": "1977-10-20 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1977-10-20 23:00",
                "_to": "1979-10-25 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_from": "1979-10-25 23:00",
                "_to": "1981-05-01 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1981-05-01 00:00"
              }
            }],
            "Asmera": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Bamako": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Bangui": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Banjul": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Bissau": [{
              "usesMetazone": {
                "_mzone": "Africa_FarWestern",
                "_to": "1975-01-01 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1975-01-01 01:00"
              }
            }],
            "Blantyre": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Brazzaville": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Bujumbura": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Cairo": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Casablanca": [{
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_to": "1984-03-16 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1984-03-16 00:00",
                "_to": "1985-12-31 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_from": "1985-12-31 23:00",
                "_to": "2018-10-28 02:00"
              }
            }],
            "Ceuta": [{
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_to": "1984-03-16 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1984-03-16 00:00"
              }
            }],
            "Conakry": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Dakar": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Dar_es_Salaam": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Djibouti": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Douala": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "El_Aaiun": [{
              "usesMetazone": {
                "_mzone": "Africa_FarWestern",
                "_to": "1976-04-14 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_from": "1976-04-14 01:00",
                "_to": "2018-10-28 02:00"
              }
            }],
            "Freetown": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Gaborone": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Harare": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Johannesburg": [{
              "usesMetazone": {
                "_mzone": "Africa_Southern"
              }
            }],
            "Juba": [{
              "usesMetazone": {
                "_mzone": "Africa_Central",
                "_to": "2000-01-15 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Africa_Eastern",
                "_from": "2000-01-15 10:00"
              }
            }],
            "Kampala": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Khartoum": [{
              "usesMetazone": {
                "_mzone": "Africa_Central",
                "_to": "2000-01-15 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Africa_Eastern",
                "_from": "2000-01-15 10:00",
                "_to": "2017-10-31 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Africa_Central",
                "_from": "2017-10-31 21:00"
              }
            }],
            "Kigali": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Kinshasa": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Lagos": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Libreville": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Lome": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Luanda": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Lubumbashi": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Lusaka": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Malabo": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Maputo": [{
              "usesMetazone": {
                "_mzone": "Africa_Central"
              }
            }],
            "Maseru": [{
              "usesMetazone": {
                "_mzone": "Africa_Southern"
              }
            }],
            "Mbabane": [{
              "usesMetazone": {
                "_mzone": "Africa_Southern"
              }
            }],
            "Mogadishu": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Monrovia": [{
              "usesMetazone": {
                "_mzone": "Liberia",
                "_to": "1972-05-01 00:45"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1972-05-01 00:45"
              }
            }],
            "Nairobi": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Ndjamena": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Niamey": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Nouakchott": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Ouagadougou": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Porto-Novo": [{
              "usesMetazone": {
                "_mzone": "Africa_Western"
              }
            }],
            "Sao_Tome": [{
              "usesMetazone": {
                "_mzone": "GMT",
                "_to": "2018-01-01 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Africa_Western",
                "_from": "2018-01-01 01:00",
                "_to": "2019-01-01 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "2019-01-01 01:00"
              }
            }],
            "Tripoli": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_to": "1981-12-31 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1981-12-31 22:00",
                "_to": "1990-05-03 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1990-05-03 23:00",
                "_to": "1996-09-29 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1996-09-29 22:00",
                "_to": "1997-10-03 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1997-10-03 22:00",
                "_to": "2012-11-10 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "2012-11-10 00:00",
                "_to": "2013-10-25 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "2013-10-25 00:00"
              }
            }],
            "Tunis": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Windhoek": [{
              "usesMetazone": {
                "_mzone": "Africa_Southern",
                "_to": "1990-03-20 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Africa_Central",
                "_from": "1990-03-20 22:00",
                "_to": "1994-03-20 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Africa_Western",
                "_from": "1994-03-20 22:00",
                "_to": "2017-10-23 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Africa_Central",
                "_from": "2017-10-23 22:00"
              }
            }]
          },
          "America": {
            "Adak": [{
              "usesMetazone": {
                "_mzone": "Bering",
                "_to": "1983-10-30 12:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Hawaii_Aleutian",
                "_from": "1983-11-30 10:00"
              }
            }],
            "Anchorage": [{
              "usesMetazone": {
                "_mzone": "Alaska_Hawaii",
                "_to": "1983-10-30 11:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yukon",
                "_from": "1983-10-30 11:00",
                "_to": "1983-11-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Alaska",
                "_from": "1983-11-30 09:00"
              }
            }],
            "Anguilla": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Antigua": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Araguaina": [{
              "usesMetazone": {
                "_mzone": "Brasilia"
              }
            }],
            "Argentina": {
              "La_Rioja": [{
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1991-03-01 02:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "1991-03-01 02:00",
                  "_to": "1991-05-07 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-05-07 04:00",
                  "_to": "2004-06-01 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "2004-06-01 03:00",
                  "_to": "2004-06-20 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-06-20 04:00"
                }
              }],
              "Rio_Gallegos": [{
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "2004-06-01 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "2004-06-01 03:00",
                  "_to": "2004-06-20 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-06-20 04:00"
                }
              }],
              "Salta": [{
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1991-03-03 02:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-10-20 04:00"
                }
              }],
              "San_Juan": [{
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1991-03-01 02:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "1991-03-01 02:00",
                  "_to": "1991-05-07 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-05-07 04:00",
                  "_to": "2004-05-31 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "2004-05-31 03:00",
                  "_to": "2004-07-25 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-07-25 04:00"
                }
              }],
              "San_Luis": [{
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1990-03-14 02:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "1990-03-14 02:00",
                  "_to": "1991-06-01 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-06-01 04:00",
                  "_to": "1999-10-03 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "1999-10-03 03:00",
                  "_to": "2000-03-03 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2000-03-03 03:00",
                  "_to": "2004-05-31 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "2004-05-31 03:00",
                  "_to": "2004-07-25 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-07-25 04:00",
                  "_to": "2008-01-21 02:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "2008-01-21 02:00"
                }
              }],
              "Tucuman": [{
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1991-03-03 02:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-10-20 04:00",
                  "_to": "2004-06-01 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "2004-06-01 03:00",
                  "_to": "2004-06-13 04:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-06-13 04:00"
                }
              }],
              "Ushuaia": [{
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "2004-05-30 03:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-06-20 04:00"
                }
              }]
            },
            "Aruba": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Asuncion": [{
              "usesMetazone": {
                "_mzone": "Paraguay"
              }
            }],
            "Bahia": [{
              "usesMetazone": {
                "_mzone": "Brasilia"
              }
            }],
            "Bahia_Banderas": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "1970-01-01 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_from": "1970-01-01 08:00",
                "_to": "2010-04-04 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "2010-04-04 09:00"
              }
            }],
            "Barbados": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Belem": [{
              "usesMetazone": {
                "_mzone": "Brasilia"
              }
            }],
            "Belize": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Blanc-Sablon": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Boa_Vista": [{
              "usesMetazone": {
                "_mzone": "Amazon"
              }
            }],
            "Bogota": [{
              "usesMetazone": {
                "_mzone": "Colombia"
              }
            }],
            "Boise": [{
              "usesMetazone": {
                "_mzone": "America_Mountain"
              }
            }],
            "Buenos_Aires": [{
              "usesMetazone": {
                "_mzone": "Argentina"
              }
            }],
            "Cambridge_Bay": [{
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_to": "1999-10-31 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1999-10-31 08:00",
                "_to": "2000-10-29 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2000-10-29 07:00",
                "_to": "2000-11-05 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "2000-11-05 05:00",
                "_to": "2001-04-01 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_from": "2001-04-01 09:00"
              }
            }],
            "Campo_Grande": [{
              "usesMetazone": {
                "_mzone": "Amazon"
              }
            }],
            "Cancun": [{
              "usesMetazone": {
                "_mzone": "America_Central",
                "_to": "1981-12-23 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "1981-12-23 06:00",
                "_to": "1998-08-02 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1998-08-02 06:00",
                "_to": "2015-02-01 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2015-02-01 08:00"
              }
            }],
            "Caracas": [{
              "usesMetazone": {
                "_mzone": "Venezuela"
              }
            }],
            "Catamarca": [{
              "usesMetazone": {
                "_mzone": "Argentina",
                "_to": "1991-03-03 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Argentina",
                "_from": "1991-10-20 04:00",
                "_to": "2004-06-01 03:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Argentina_Western",
                "_from": "2004-06-01 03:00",
                "_to": "2004-06-20 04:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Argentina",
                "_from": "2004-06-20 04:00"
              }
            }],
            "Cayenne": [{
              "usesMetazone": {
                "_mzone": "French_Guiana"
              }
            }],
            "Cayman": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Chicago": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Chihuahua": [{
              "usesMetazone": {
                "_mzone": "America_Central",
                "_to": "1998-04-05 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Mexico_Pacific",
                "_from": "1998-04-05 09:00"
              }
            }],
            "Coral_Harbour": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Cordoba": [{
              "usesMetazone": {
                "_mzone": "Argentina",
                "_to": "1991-03-03 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Argentina",
                "_from": "1991-10-20 04:00"
              }
            }],
            "Costa_Rica": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Creston": [{
              "usesMetazone": {
                "_mzone": "America_Mountain"
              }
            }],
            "Cuiaba": [{
              "usesMetazone": {
                "_mzone": "Amazon"
              }
            }],
            "Curacao": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Danmarkshavn": [{
              "usesMetazone": {
                "_mzone": "Greenland_Western",
                "_to": "1996-01-01 03:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1996-01-01 03:00"
              }
            }],
            "Dawson": [{
              "usesMetazone": {
                "_mzone": "Yukon",
                "_to": "1973-10-28 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_from": "1973-10-28 09:00"
              }
            }],
            "Dawson_Creek": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "1972-08-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_from": "1972-08-30 09:00"
              }
            }],
            "Denver": [{
              "usesMetazone": {
                "_mzone": "America_Mountain"
              }
            }],
            "Detroit": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Dominica": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Edmonton": [{
              "usesMetazone": {
                "_mzone": "America_Mountain"
              }
            }],
            "Eirunepe": [{
              "usesMetazone": {
                "_mzone": "Acre",
                "_to": "2008-06-24 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Amazon",
                "_from": "2008-06-24 05:00",
                "_to": "2013-11-10 04:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Acre",
                "_from": "2013-11-10 04:00"
              }
            }],
            "El_Salvador": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Fort_Nelson": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "2015-03-08 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_from": "2015-03-08 10:00"
              }
            }],
            "Fortaleza": [{
              "usesMetazone": {
                "_mzone": "Brasilia"
              }
            }],
            "Glace_Bay": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Godthab": [{
              "usesMetazone": {
                "_mzone": "Greenland_Western"
              }
            }],
            "Goose_Bay": [{
              "usesMetazone": {
                "_mzone": "Atlantic",
                "_to": "1988-04-03 04:01"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Goose_Bay",
                "_from": "1988-04-03 04:01",
                "_to": "1988-10-30 02:01"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Atlantic",
                "_from": "1988-10-30 02:01"
              }
            }],
            "Grand_Turk": [{
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_to": "2015-11-01 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Atlantic",
                "_from": "2015-11-01 06:00",
                "_to": "2018-03-11 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2018-03-11 07:00"
              }
            }],
            "Grenada": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Guadeloupe": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Guatemala": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Guayaquil": [{
              "usesMetazone": {
                "_mzone": "Ecuador"
              }
            }],
            "Guyana": [{
              "usesMetazone": {
                "_mzone": "Guyana"
              }
            }],
            "Halifax": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Havana": [{
              "usesMetazone": {
                "_mzone": "Cuba"
              }
            }],
            "Hermosillo": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "1970-01-01 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Mexico_Pacific",
                "_from": "1970-01-01 08:00"
              }
            }],
            "Indiana": {
              "Knox": [{
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1991-10-27 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1991-10-27 07:00",
                  "_to": "2006-04-02 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2006-04-02 07:00"
                }
              }],
              "Marengo": [{
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "1974-01-06 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1974-01-06 07:00",
                  "_to": "1974-10-27 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1974-10-27 07:00"
                }
              }],
              "Petersburg": [{
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1977-10-30 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1977-10-30 07:00",
                  "_to": "2006-04-02 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2006-04-02 07:00",
                  "_to": "2007-11-04 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2007-11-04 07:00"
                }
              }],
              "Tell_City": [{
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "2006-04-02 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2006-04-02 07:00"
                }
              }],
              "Vevay": [{
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }],
              "Vincennes": [{
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "2006-04-02 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2006-04-02 07:00",
                  "_to": "2007-11-04 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2007-11-04 07:00"
                }
              }],
              "Winamac": [{
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "2006-04-02 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2006-04-02 07:00",
                  "_to": "2007-03-11 08:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2007-03-11 08:00"
                }
              }]
            },
            "Indianapolis": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Inuvik": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "1979-04-29 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_from": "1979-04-29 10:00"
              }
            }],
            "Iqaluit": [{
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_to": "1999-10-31 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1999-10-31 06:00",
                "_to": "2000-10-29 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2000-10-29 07:00"
              }
            }],
            "Jamaica": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Jujuy": [{
              "usesMetazone": {
                "_mzone": "Argentina",
                "_to": "1990-03-04 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Argentina",
                "_from": "1991-10-06 04:00"
              }
            }],
            "Juneau": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "1980-04-27 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yukon",
                "_from": "1980-04-27 10:00",
                "_to": "1980-10-26 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_from": "1980-10-26 10:00",
                "_to": "1983-10-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yukon",
                "_from": "1983-10-30 09:00",
                "_to": "1983-11-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Alaska",
                "_from": "1983-11-30 09:00"
              }
            }],
            "Kentucky": {
              "Monticello": [{
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "2000-10-29 07:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2000-10-29 07:00"
                }
              }]
            },
            "Kralendijk": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "La_Paz": [{
              "usesMetazone": {
                "_mzone": "Bolivia"
              }
            }],
            "Lima": [{
              "usesMetazone": {
                "_mzone": "Peru"
              }
            }],
            "Los_Angeles": [{
              "usesMetazone": {
                "_mzone": "America_Pacific"
              }
            }],
            "Louisville": [{
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_to": "1974-01-06 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1974-01-06 07:00",
                "_to": "1974-10-27 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "1974-10-27 07:00"
              }
            }],
            "Lower_Princes": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Maceio": [{
              "usesMetazone": {
                "_mzone": "Brasilia"
              }
            }],
            "Managua": [{
              "usesMetazone": {
                "_mzone": "America_Central",
                "_to": "1973-05-01 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "1973-05-01 06:00",
                "_to": "1975-02-16 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1975-02-16 05:00",
                "_to": "1992-01-01 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "1992-01-01 10:00",
                "_to": "1992-09-24 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1992-09-24 05:00",
                "_to": "1993-01-01 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "1993-01-01 06:00",
                "_to": "1997-01-01 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1997-01-01 05:00"
              }
            }],
            "Manaus": [{
              "usesMetazone": {
                "_mzone": "Amazon"
              }
            }],
            "Marigot": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Martinique": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Matamoros": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Mazatlan": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "1970-01-01 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Mexico_Pacific",
                "_from": "1970-01-01 08:00"
              }
            }],
            "Mendoza": [{
              "usesMetazone": {
                "_mzone": "Argentina",
                "_to": "1990-03-04 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Argentina",
                "_from": "1992-10-18 04:00",
                "_to": "2004-05-23 03:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Argentina",
                "_from": "2004-09-26 04:00"
              }
            }],
            "Menominee": [{
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_to": "1973-04-29 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1973-04-29 07:00"
              }
            }],
            "Merida": [{
              "usesMetazone": {
                "_mzone": "America_Central",
                "_to": "1981-12-23 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "1981-12-23 06:00",
                "_to": "1982-12-02 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1982-12-02 05:00"
              }
            }],
            "Metlakatla": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "2015-11-01 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Alaska",
                "_from": "2015-11-01 10:00",
                "_to": "2018-11-04 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_from": "2018-11-04 10:00",
                "_to": "2019-01-20 10:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Alaska",
                "_from": "2019-01-20 10:00"
              }
            }],
            "Mexico_City": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Miquelon": [{
              "usesMetazone": {
                "_mzone": "Atlantic",
                "_to": "1980-05-01 04:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Pierre_Miquelon",
                "_from": "1980-05-01 04:00"
              }
            }],
            "Moncton": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Monterrey": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Montevideo": [{
              "usesMetazone": {
                "_mzone": "Uruguay"
              }
            }],
            "Montserrat": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Nassau": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "New_York": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Nipigon": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Nome": [{
              "usesMetazone": {
                "_mzone": "Bering",
                "_to": "1983-10-30 12:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yukon",
                "_from": "1983-10-30 12:00",
                "_to": "1983-11-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Alaska",
                "_from": "1983-11-30 09:00"
              }
            }],
            "Noronha": [{
              "usesMetazone": {
                "_mzone": "Noronha"
              }
            }],
            "North_Dakota": {
              "Beulah": [{
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_to": "2010-11-07 08:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2010-11-07 08:00"
                }
              }],
              "Center": [{
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_to": "1992-10-25 08:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1992-10-25 08:00"
                }
              }],
              "New_Salem": [{
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_to": "2003-10-26 08:00"
                }
              }, {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2003-10-26 08:00"
                }
              }]
            },
            "Ojinaga": [{
              "usesMetazone": {
                "_mzone": "America_Central",
                "_to": "1998-04-05 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_from": "1998-04-05 09:00"
              }
            }],
            "Panama": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Pangnirtung": [{
              "usesMetazone": {
                "_mzone": "Atlantic",
                "_to": "1995-04-02 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "1995-04-02 06:00",
                "_to": "1999-10-31 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1999-10-31 06:00",
                "_to": "2000-10-29 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2000-10-29 07:00"
              }
            }],
            "Paramaribo": [{
              "usesMetazone": {
                "_mzone": "Dutch_Guiana",
                "_to": "1975-11-20 03:30"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Suriname",
                "_from": "1975-11-20 03:30"
              }
            }],
            "Phoenix": [{
              "usesMetazone": {
                "_mzone": "America_Mountain"
              }
            }],
            "Port_of_Spain": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Port-au-Prince": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Porto_Velho": [{
              "usesMetazone": {
                "_mzone": "Amazon"
              }
            }],
            "Puerto_Rico": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Punta_Arenas": [{
              "usesMetazone": {
                "_mzone": "Chile",
                "_to": "2016-12-03 23:00"
              }
            }],
            "Rainy_River": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Rankin_Inlet": [{
              "usesMetazone": {
                "_mzone": "America_Central",
                "_to": "2000-10-29 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2000-10-29 07:00",
                "_to": "2001-04-01 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "2001-04-01 08:00"
              }
            }],
            "Recife": [{
              "usesMetazone": {
                "_mzone": "Brasilia"
              }
            }],
            "Regina": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Resolute": [{
              "usesMetazone": {
                "_mzone": "America_Central",
                "_to": "2000-10-29 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2000-10-29 07:00",
                "_to": "2001-04-01 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "2001-04-01 08:00",
                "_to": "2006-10-29 07:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2006-10-29 07:00",
                "_to": "2007-03-11 08:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "2007-03-11 08:00"
              }
            }],
            "Rio_Branco": [{
              "usesMetazone": {
                "_mzone": "Acre",
                "_to": "2008-06-24 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Amazon",
                "_from": "2008-06-24 05:00",
                "_to": "2013-11-10 04:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Acre",
                "_from": "2013-11-10 04:00"
              }
            }],
            "Santa_Isabel": [{
              "usesMetazone": {
                "_mzone": "Mexico_Northwest"
              }
            }],
            "Santarem": [{
              "usesMetazone": {
                "_mzone": "Amazon",
                "_to": "2008-06-24 04:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Brasilia",
                "_from": "2008-06-24 04:00"
              }
            }],
            "Santiago": [{
              "usesMetazone": {
                "_mzone": "Chile"
              }
            }],
            "Santo_Domingo": [{
              "usesMetazone": {
                "_mzone": "Dominican",
                "_to": "1974-10-27 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Atlantic",
                "_from": "1974-10-27 05:00",
                "_to": "2000-10-29 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Eastern",
                "_from": "2000-10-29 06:00",
                "_to": "2000-12-03 06:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Atlantic",
                "_from": "2000-12-03 06:00"
              }
            }],
            "Sao_Paulo": [{
              "usesMetazone": {
                "_mzone": "Brasilia"
              }
            }],
            "Scoresbysund": [{
              "usesMetazone": {
                "_mzone": "Greenland_Central",
                "_to": "1981-03-29 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Greenland_Eastern",
                "_from": "1981-03-29 02:00"
              }
            }],
            "Sitka": [{
              "usesMetazone": {
                "_mzone": "America_Pacific",
                "_to": "1983-10-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yukon",
                "_from": "1983-10-30 09:00",
                "_to": "1983-11-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Alaska",
                "_from": "1983-11-30 09:00"
              }
            }],
            "St_Barthelemy": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "St_Johns": [{
              "usesMetazone": {
                "_mzone": "Newfoundland"
              }
            }],
            "St_Kitts": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "St_Lucia": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "St_Thomas": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "St_Vincent": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Swift_Current": [{
              "usesMetazone": {
                "_mzone": "America_Mountain",
                "_to": "1972-04-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "America_Central",
                "_from": "1972-04-30 09:00"
              }
            }],
            "Tegucigalpa": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Thule": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Thunder_Bay": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Tijuana": [{
              "usesMetazone": {
                "_mzone": "America_Pacific"
              }
            }],
            "Toronto": [{
              "usesMetazone": {
                "_mzone": "America_Eastern"
              }
            }],
            "Tortola": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Vancouver": [{
              "usesMetazone": {
                "_mzone": "America_Pacific"
              }
            }],
            "Whitehorse": [{
              "usesMetazone": {
                "_mzone": "America_Pacific"
              }
            }],
            "Winnipeg": [{
              "usesMetazone": {
                "_mzone": "America_Central"
              }
            }],
            "Yakutat": [{
              "usesMetazone": {
                "_mzone": "Yukon",
                "_to": "1983-11-30 09:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Alaska",
                "_from": "1983-11-30 09:00"
              }
            }],
            "Yellowknife": [{
              "usesMetazone": {
                "_mzone": "America_Mountain"
              }
            }]
          },
          "Antarctica": {
            "Casey": [{
              "usesMetazone": {
                "_mzone": "Australia_Western",
                "_to": "2009-10-17 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Casey",
                "_from": "2009-10-17 18:00",
                "_to": "2010-03-04 15:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Australia_Western",
                "_from": "2010-03-04 15:00",
                "_to": "2011-10-27 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Casey",
                "_from": "2011-10-27 18:00",
                "_to": "2012-02-21 17:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Australia_Western",
                "_from": "2012-02-21 17:00",
                "_to": "2016-10-21 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Casey",
                "_from": "2016-10-21 16:00",
                "_to": "2018-03-10 17:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Australia_Western",
                "_from": "2018-03-10 17:00"
              }
            }],
            "Davis": [{
              "usesMetazone": {
                "_mzone": "Davis"
              }
            }],
            "DumontDUrville": [{
              "usesMetazone": {
                "_mzone": "DumontDUrville"
              }
            }],
            "Macquarie": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern",
                "_to": "2010-04-03 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Macquarie",
                "_from": "2010-04-03 16:00"
              }
            }],
            "Mawson": [{
              "usesMetazone": {
                "_mzone": "Mawson"
              }
            }],
            "McMurdo": [{
              "usesMetazone": {
                "_mzone": "New_Zealand"
              }
            }],
            "Palmer": [{
              "usesMetazone": {
                "_mzone": "Argentina",
                "_to": "1982-05-01 03:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Chile",
                "_from": "1982-05-01 03:00",
                "_to": "2016-12-03 23:00"
              }
            }],
            "Rothera": [{
              "usesMetazone": {
                "_mzone": "Rothera"
              }
            }],
            "Syowa": [{
              "usesMetazone": {
                "_mzone": "Syowa"
              }
            }],
            "Troll": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Vostok": [{
              "usesMetazone": {
                "_mzone": "Vostok"
              }
            }]
          },
          "Arctic": {
            "Longyearbyen": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }]
          },
          "Asia": {
            "Aden": [{
              "usesMetazone": {
                "_mzone": "Arabian"
              }
            }],
            "Almaty": [{
              "usesMetazone": {
                "_mzone": "Almaty",
                "_to": "2004-10-30 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Kazakhstan_Eastern",
                "_from": "2004-10-30 20:00"
              }
            }],
            "Amman": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Anadyr": [{
              "usesMetazone": {
                "_mzone": "Anadyr",
                "_to": "2010-03-27 14:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Magadan",
                "_from": "2010-03-27 14:00",
                "_to": "2014-10-25 14:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Anadyr",
                "_from": "2014-10-25 14:00"
              }
            }],
            "Aqtau": [{
              "usesMetazone": {
                "_mzone": "Shevchenko",
                "_to": "1991-12-15 19:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Aqtau",
                "_from": "1991-12-15 19:00",
                "_to": "2004-10-30 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Kazakhstan_Western",
                "_from": "2004-10-30 22:00"
              }
            }],
            "Aqtobe": [{
              "usesMetazone": {
                "_mzone": "Aktyubinsk",
                "_to": "1991-12-15 19:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Aqtobe",
                "_from": "1991-12-15 19:00",
                "_to": "2004-10-30 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Kazakhstan_Western",
                "_from": "2005-10-30 21:00"
              }
            }],
            "Ashgabat": [{
              "usesMetazone": {
                "_mzone": "Ashkhabad",
                "_to": "1991-10-26 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Turkmenistan",
                "_from": "1991-10-26 20:00"
              }
            }],
            "Atyrau": [{
              "usesMetazone": {
                "_mzone": "Kazakhstan_Western",
                "_from": "2004-10-30 22:00"
              }
            }],
            "Baghdad": [{
              "usesMetazone": {
                "_mzone": "Arabian"
              }
            }],
            "Bahrain": [{
              "usesMetazone": {
                "_mzone": "Gulf",
                "_to": "1972-05-31 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Arabian",
                "_from": "1972-05-31 20:00"
              }
            }],
            "Baku": [{
              "usesMetazone": {
                "_mzone": "Baku",
                "_to": "1991-08-29 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Azerbaijan",
                "_from": "1991-08-29 20:00"
              }
            }],
            "Bangkok": [{
              "usesMetazone": {
                "_mzone": "Indochina"
              }
            }],
            "Beirut": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Bishkek": [{
              "usesMetazone": {
                "_mzone": "Frunze",
                "_to": "1991-08-30 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Kyrgystan",
                "_from": "1991-08-30 20:00"
              }
            }],
            "Brunei": [{
              "usesMetazone": {
                "_mzone": "Brunei"
              }
            }],
            "Calcutta": [{
              "usesMetazone": {
                "_mzone": "India"
              }
            }],
            "Chita": [{
              "usesMetazone": {
                "_mzone": "Yakutsk",
                "_to": "2014-10-25 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Irkutsk",
                "_from": "2014-10-25 16:00",
                "_to": "2016-03-26 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yakutsk",
                "_from": "2016-03-26 18:00"
              }
            }],
            "Choibalsan": [{
              "usesMetazone": {
                "_mzone": "Mongolia",
                "_to": "1983-03-31 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Choibalsan",
                "_from": "1983-03-31 16:00"
              }
            }],
            "Colombo": [{
              "usesMetazone": {
                "_mzone": "India",
                "_to": "1996-05-24 18:30"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Lanka",
                "_from": "1996-05-24 18:30",
                "_to": "2006-04-14 18:30"
              }
            }, {
              "usesMetazone": {
                "_mzone": "India",
                "_from": "2006-04-14 18:30"
              }
            }],
            "Damascus": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Dhaka": [{
              "usesMetazone": {
                "_mzone": "Dacca",
                "_to": "1971-03-25 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Bangladesh",
                "_from": "1971-03-25 18:00"
              }
            }],
            "Dili": [{
              "usesMetazone": {
                "_mzone": "East_Timor",
                "_to": "1976-05-02 15:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Indonesia_Central",
                "_from": "1976-05-02 15:00",
                "_to": "2000-09-16 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "East_Timor",
                "_from": "2000-09-16 16:00"
              }
            }],
            "Dubai": [{
              "usesMetazone": {
                "_mzone": "Gulf"
              }
            }],
            "Dushanbe": [{
              "usesMetazone": {
                "_mzone": "Dushanbe",
                "_to": "1991-09-08 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Tajikistan",
                "_from": "1991-09-08 21:00"
              }
            }],
            "Famagusta": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_to": "2016-09-07 21:00"
              }
            }],
            "Gaza": [{
              "usesMetazone": {
                "_mzone": "Israel",
                "_to": "1995-12-31 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1995-12-31 22:00"
              }
            }],
            "Hebron": [{
              "usesMetazone": {
                "_mzone": "Israel",
                "_to": "1995-12-31 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1995-12-31 22:00"
              }
            }],
            "Hong_Kong": [{
              "usesMetazone": {
                "_mzone": "Hong_Kong"
              }
            }],
            "Hovd": [{
              "usesMetazone": {
                "_mzone": "Hovd"
              }
            }],
            "Irkutsk": [{
              "usesMetazone": {
                "_mzone": "Irkutsk"
              }
            }],
            "Jakarta": [{
              "usesMetazone": {
                "_mzone": "Indonesia_Western"
              }
            }],
            "Jayapura": [{
              "usesMetazone": {
                "_mzone": "Indonesia_Eastern"
              }
            }],
            "Jerusalem": [{
              "usesMetazone": {
                "_mzone": "Israel"
              }
            }],
            "Kabul": [{
              "usesMetazone": {
                "_mzone": "Afghanistan"
              }
            }],
            "Kamchatka": [{
              "usesMetazone": {
                "_mzone": "Kamchatka"
              }
            }],
            "Karachi": [{
              "usesMetazone": {
                "_mzone": "Karachi",
                "_to": "1971-03-25 19:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Pakistan",
                "_from": "1971-03-25 19:00"
              }
            }],
            "Katmandu": [{
              "usesMetazone": {
                "_mzone": "Nepal"
              }
            }],
            "Khandyga": [{
              "usesMetazone": {
                "_mzone": "Yakutsk",
                "_to": "2003-12-31 15:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Vladivostok",
                "_from": "2003-12-31 15:00",
                "_to": "2011-09-12 13:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yakutsk",
                "_from": "2011-09-12 13:00"
              }
            }],
            "Krasnoyarsk": [{
              "usesMetazone": {
                "_mzone": "Krasnoyarsk"
              }
            }],
            "Kuala_Lumpur": [{
              "usesMetazone": {
                "_mzone": "Malaya",
                "_to": "1981-12-31 16:30"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Malaysia",
                "_from": "1981-12-31 16:30"
              }
            }],
            "Kuching": [{
              "usesMetazone": {
                "_mzone": "Borneo",
                "_to": "1981-12-31 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Malaysia",
                "_from": "1981-12-31 16:00"
              }
            }],
            "Kuwait": [{
              "usesMetazone": {
                "_mzone": "Arabian"
              }
            }],
            "Macau": [{
              "usesMetazone": {
                "_mzone": "Macau",
                "_to": "1999-12-19 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "China",
                "_from": "1999-12-19 16:00"
              }
            }],
            "Magadan": [{
              "usesMetazone": {
                "_mzone": "Magadan"
              }
            }],
            "Makassar": [{
              "usesMetazone": {
                "_mzone": "Indonesia_Central"
              }
            }],
            "Manila": [{
              "usesMetazone": {
                "_mzone": "Philippines"
              }
            }],
            "Muscat": [{
              "usesMetazone": {
                "_mzone": "Gulf"
              }
            }],
            "Nicosia": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Novokuznetsk": [{
              "usesMetazone": {
                "_mzone": "Krasnoyarsk",
                "_to": "2010-03-27 19:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Novosibirsk",
                "_from": "2010-03-27 19:00",
                "_to": "2014-10-25 19:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Krasnoyarsk",
                "_from": "2014-10-25 19:00"
              }
            }],
            "Novosibirsk": [{
              "usesMetazone": {
                "_mzone": "Novosibirsk"
              }
            }],
            "Omsk": [{
              "usesMetazone": {
                "_mzone": "Omsk"
              }
            }],
            "Oral": [{
              "usesMetazone": {
                "_mzone": "Uralsk",
                "_to": "1991-12-15 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Oral",
                "_from": "1991-12-15 20:00",
                "_to": "2004-10-30 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Kazakhstan_Western",
                "_from": "2004-10-30 22:00"
              }
            }],
            "Phnom_Penh": [{
              "usesMetazone": {
                "_mzone": "Indochina"
              }
            }],
            "Pontianak": [{
              "usesMetazone": {
                "_mzone": "Indonesia_Central",
                "_to": "1987-12-31 16:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Indonesia_Western",
                "_from": "1987-12-31 16:00"
              }
            }],
            "Pyongyang": [{
              "usesMetazone": {
                "_mzone": "Korea",
                "_to": "2015-08-14 15:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Pyongyang",
                "_from": "2015-08-14 15:00",
                "_to": "2018-05-04 15:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Korea",
                "_from": "2018-05-04 15:00"
              }
            }],
            "Qatar": [{
              "usesMetazone": {
                "_mzone": "Gulf",
                "_to": "1972-05-31 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Arabian",
                "_from": "1972-05-31 20:00"
              }
            }],
            "Qostanay": [{
              "usesMetazone": {
                "_mzone": "Kazakhstan_Eastern",
                "_from": "2004-10-30 21:00"
              }
            }],
            "Qyzylorda": [{
              "usesMetazone": {
                "_mzone": "Kizilorda",
                "_to": "1991-12-15 19:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Qyzylorda",
                "_from": "1991-12-15 19:00",
                "_to": "2004-10-30 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Kazakhstan_Eastern",
                "_from": "2004-10-30 21:00",
                "_to": "2018-12-20 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Kazakhstan_Western",
                "_from": "2018-12-20 18:00"
              }
            }],
            "Rangoon": [{
              "usesMetazone": {
                "_mzone": "Myanmar"
              }
            }],
            "Riyadh": [{
              "usesMetazone": {
                "_mzone": "Arabian"
              }
            }],
            "Saigon": [{
              "usesMetazone": {
                "_mzone": "Indochina",
                "_from": "1975-06-12 16:00"
              }
            }],
            "Sakhalin": [{
              "usesMetazone": {
                "_mzone": "Sakhalin"
              }
            }],
            "Samarkand": [{
              "usesMetazone": {
                "_mzone": "Samarkand",
                "_to": "1981-09-30 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Tashkent",
                "_from": "1981-09-30 18:00",
                "_to": "1982-03-31 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Samarkand",
                "_from": "1982-03-31 18:00",
                "_to": "1991-08-31 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Uzbekistan",
                "_from": "1991-08-31 18:00"
              }
            }],
            "Seoul": [{
              "usesMetazone": {
                "_mzone": "Korea"
              }
            }],
            "Shanghai": [{
              "usesMetazone": {
                "_mzone": "China"
              }
            }],
            "Singapore": [{
              "usesMetazone": {
                "_mzone": "Singapore"
              }
            }],
            "Srednekolymsk": [{
              "usesMetazone": {
                "_mzone": "Magadan",
                "_to": "2014-10-25 14:00"
              }
            }],
            "Taipei": [{
              "usesMetazone": {
                "_mzone": "Taipei"
              }
            }],
            "Tashkent": [{
              "usesMetazone": {
                "_mzone": "Tashkent",
                "_to": "1991-08-31 18:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Uzbekistan",
                "_from": "1991-08-31 18:00"
              }
            }],
            "Tbilisi": [{
              "usesMetazone": {
                "_mzone": "Tbilisi",
                "_to": "1991-04-08 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Georgia",
                "_from": "1991-04-08 20:00"
              }
            }],
            "Tehran": [{
              "usesMetazone": {
                "_mzone": "Iran"
              }
            }],
            "Thimphu": [{
              "usesMetazone": {
                "_mzone": "India",
                "_to": "1987-09-30 18:30"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Bhutan",
                "_from": "1987-09-30 18:30"
              }
            }],
            "Tokyo": [{
              "usesMetazone": {
                "_mzone": "Japan"
              }
            }],
            "Ulaanbaatar": [{
              "usesMetazone": {
                "_mzone": "Mongolia"
              }
            }],
            "Urumqi": [{
              "usesMetazone": {
                "_mzone": "Urumqi"
              }
            }],
            "Ust-Nera": [{
              "usesMetazone": {
                "_mzone": "Yakutsk",
                "_to": "1981-03-31 15:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Magadan",
                "_from": "1981-03-31 15:00",
                "_to": "2011-09-12 12:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Vladivostok",
                "_from": "2011-09-12 12:00"
              }
            }],
            "Vientiane": [{
              "usesMetazone": {
                "_mzone": "Indochina"
              }
            }],
            "Vladivostok": [{
              "usesMetazone": {
                "_mzone": "Vladivostok"
              }
            }],
            "Yakutsk": [{
              "usesMetazone": {
                "_mzone": "Yakutsk"
              }
            }],
            "Yekaterinburg": [{
              "usesMetazone": {
                "_mzone": "Sverdlovsk",
                "_to": "1992-01-18 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Yekaterinburg",
                "_from": "1992-01-18 22:00"
              }
            }],
            "Yerevan": [{
              "usesMetazone": {
                "_mzone": "Yerevan",
                "_to": "1991-09-22 20:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Armenia",
                "_from": "1991-09-22 20:00"
              }
            }]
          },
          "Atlantic": {
            "Azores": [{
              "usesMetazone": {
                "_mzone": "Azores",
                "_to": "1992-09-27 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_from": "1992-09-27 02:00",
                "_to": "1993-03-28 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Azores",
                "_from": "1993-03-28 01:00"
              }
            }],
            "Bermuda": [{
              "usesMetazone": {
                "_mzone": "Atlantic"
              }
            }],
            "Canary": [{
              "usesMetazone": {
                "_mzone": "Europe_Western"
              }
            }],
            "Cape_Verde": [{
              "usesMetazone": {
                "_mzone": "Cape_Verde"
              }
            }],
            "Faeroe": [{
              "usesMetazone": {
                "_mzone": "Europe_Western"
              }
            }],
            "Madeira": [{
              "usesMetazone": {
                "_mzone": "Europe_Western"
              }
            }],
            "Reykjavik": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "South_Georgia": [{
              "usesMetazone": {
                "_mzone": "South_Georgia"
              }
            }],
            "St_Helena": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }],
            "Stanley": [{
              "usesMetazone": {
                "_mzone": "Falkland"
              }
            }]
          },
          "Australia": {
            "Adelaide": [{
              "usesMetazone": {
                "_mzone": "Australia_Central"
              }
            }],
            "Brisbane": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern"
              }
            }],
            "Broken_Hill": [{
              "usesMetazone": {
                "_mzone": "Australia_Central"
              }
            }],
            "Currie": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern"
              }
            }],
            "Darwin": [{
              "usesMetazone": {
                "_mzone": "Australia_Central"
              }
            }],
            "Eucla": [{
              "usesMetazone": {
                "_mzone": "Australia_CentralWestern"
              }
            }],
            "Hobart": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern"
              }
            }],
            "Lindeman": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern"
              }
            }],
            "Lord_Howe": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern",
                "_to": "1981-02-28 14:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Lord_Howe",
                "_from": "1981-02-28 14:00"
              }
            }],
            "Melbourne": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern"
              }
            }],
            "Perth": [{
              "usesMetazone": {
                "_mzone": "Australia_Western"
              }
            }],
            "Sydney": [{
              "usesMetazone": {
                "_mzone": "Australia_Eastern"
              }
            }]
          },
          "CST6CDT": [{
            "usesMetazone": {
              "_mzone": "America_Central"
            }
          }],
          "EST5EDT": [{
            "usesMetazone": {
              "_mzone": "America_Eastern"
            }
          }],
          "Etc": {
            "GMT": [{
              "usesMetazone": {
                "_mzone": "GMT"
              }
            }]
          },
          "Europe": {
            "Amsterdam": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Andorra": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Astrakhan": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "1992-03-28 22:00",
                "_to": "2016-03-26 23:00"
              }
            }],
            "Athens": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Belgrade": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Berlin": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Bratislava": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Brussels": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Bucharest": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Budapest": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Busingen": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Chisinau": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1990-05-05 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1990-05-05 21:00"
              }
            }],
            "Copenhagen": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Dublin": [{
              "usesMetazone": {
                "_mzone": "Irish",
                "_to": "1971-10-31 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1971-10-31 02:00"
              }
            }],
            "Gibraltar": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Guernsey": [{
              "usesMetazone": {
                "_mzone": "British",
                "_to": "1971-10-31 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1971-10-31 02:00"
              }
            }],
            "Helsinki": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Isle_of_Man": [{
              "usesMetazone": {
                "_mzone": "British",
                "_to": "1971-10-31 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1971-10-31 02:00"
              }
            }],
            "Istanbul": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_to": "1978-10-14 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Turkey",
                "_from": "1978-10-14 21:00",
                "_to": "1985-04-19 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1985-04-19 21:00",
                "_to": "2016-09-06 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Turkey",
                "_from": "2016-09-06 21:00"
              }
            }],
            "Jersey": [{
              "usesMetazone": {
                "_mzone": "British",
                "_to": "1971-10-31 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1971-10-31 02:00"
              }
            }],
            "Kaliningrad": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1989-03-25 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1989-03-25 23:00",
                "_to": "2011-03-27 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Further_Eastern",
                "_from": "2011-03-27 00:00",
                "_to": "2014-10-25 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "2014-10-25 23:00"
              }
            }],
            "Kiev": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1990-06-30 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1990-06-30 22:00"
              }
            }],
            "Lisbon": [{
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_to": "1976-09-26 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_from": "1976-09-26 00:00",
                "_to": "1992-09-27 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1992-09-27 01:00",
                "_to": "1996-03-31 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Western",
                "_from": "1996-03-31 01:00"
              }
            }],
            "Ljubljana": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "London": [{
              "usesMetazone": {
                "_mzone": "British",
                "_to": "1971-10-31 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "GMT",
                "_from": "1971-10-31 02:00"
              }
            }],
            "Luxembourg": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Madrid": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Malta": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Mariehamn": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Minsk": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1991-03-30 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1991-03-30 23:00",
                "_to": "2011-03-27 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Further_Eastern",
                "_from": "2011-03-27 00:00",
                "_to": "2014-10-26 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "2014-10-26 22:00"
              }
            }],
            "Monaco": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Moscow": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1991-03-30 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1991-03-30 23:00",
                "_to": "1992-01-19 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "1992-01-19 00:00"
              }
            }],
            "Oslo": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Paris": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Podgorica": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Prague": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Riga": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1989-03-25 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1989-03-25 23:00"
              }
            }],
            "Rome": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Samara": [{
              "usesMetazone": {
                "_mzone": "Kuybyshev",
                "_to": "1989-03-25 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "1989-03-25 22:00",
                "_to": "1991-03-30 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1991-03-30 23:00",
                "_to": "1991-09-29 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Samara",
                "_from": "1991-09-29 00:00"
              }
            }],
            "San_Marino": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Sarajevo": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Saratov": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "1992-03-28 22:00",
                "_to": "2016-12-03 23:00"
              }
            }],
            "Simferopol": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1990-06-30 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1990-06-30 23:00",
                "_to": "1994-04-30 21:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "1994-04-30 21:00",
                "_to": "1997-03-30 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1997-03-30 01:00",
                "_to": "2014-03-30 00:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "2014-03-30 00:00"
              }
            }],
            "Skopje": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Sofia": [{
              "usesMetazone": {
                "_mzone": "Europe_Eastern"
              }
            }],
            "Stockholm": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Tallinn": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1989-03-25 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1989-03-25 23:00"
              }
            }],
            "Tirane": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Ulyanovsk": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "1992-01-19 00:00",
                "_to": "2016-03-26 23:00"
              }
            }],
            "Uzhgorod": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1990-06-30 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1990-06-30 23:00",
                "_to": "1991-03-31 02:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1991-03-31 02:00"
              }
            }],
            "Vaduz": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Vatican": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Vienna": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Vilnius": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1989-03-25 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1989-03-25 23:00",
                "_to": "1998-03-29 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Central",
                "_from": "1998-03-29 01:00",
                "_to": "1999-10-31 01:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1999-10-31 01:00"
              }
            }],
            "Volgograd": [{
              "usesMetazone": {
                "_mzone": "Volgograd",
                "_to": "1992-03-28 22:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Moscow",
                "_from": "1992-03-28 22:00",
                "_to": "2018-10-27 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Volgograd",
                "_from": "2018-10-27 23:00"
              }
            }],
            "Warsaw": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Zagreb": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }],
            "Zaporozhye": [{
              "usesMetazone": {
                "_mzone": "Moscow",
                "_to": "1991-03-30 23:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Europe_Eastern",
                "_from": "1991-03-30 23:00"
              }
            }],
            "Zurich": [{
              "usesMetazone": {
                "_mzone": "Europe_Central"
              }
            }]
          },
          "Indian": {
            "Antananarivo": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Chagos": [{
              "usesMetazone": {
                "_mzone": "Indian_Ocean"
              }
            }],
            "Christmas": [{
              "usesMetazone": {
                "_mzone": "Christmas"
              }
            }],
            "Cocos": [{
              "usesMetazone": {
                "_mzone": "Cocos"
              }
            }],
            "Comoro": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Kerguelen": [{
              "usesMetazone": {
                "_mzone": "French_Southern"
              }
            }],
            "Mahe": [{
              "usesMetazone": {
                "_mzone": "Seychelles"
              }
            }],
            "Maldives": [{
              "usesMetazone": {
                "_mzone": "Maldives"
              }
            }],
            "Mauritius": [{
              "usesMetazone": {
                "_mzone": "Mauritius"
              }
            }],
            "Mayotte": [{
              "usesMetazone": {
                "_mzone": "Africa_Eastern"
              }
            }],
            "Reunion": [{
              "usesMetazone": {
                "_mzone": "Reunion"
              }
            }]
          },
          "MST7MDT": [{
            "usesMetazone": {
              "_mzone": "America_Mountain"
            }
          }],
          "Pacific": {
            "Apia": [{
              "usesMetazone": {
                "_mzone": "Apia"
              }
            }],
            "Auckland": [{
              "usesMetazone": {
                "_mzone": "New_Zealand"
              }
            }],
            "Bougainville": [{
              "usesMetazone": {
                "_mzone": "Papua_New_Guinea",
                "_to": "2014-12-27 16:00"
              }
            }],
            "Chatham": [{
              "usesMetazone": {
                "_mzone": "Chatham"
              }
            }],
            "Easter": [{
              "usesMetazone": {
                "_mzone": "Easter"
              }
            }],
            "Efate": [{
              "usesMetazone": {
                "_mzone": "Vanuatu"
              }
            }],
            "Enderbury": [{
              "usesMetazone": {
                "_mzone": "Phoenix_Islands"
              }
            }],
            "Fakaofo": [{
              "usesMetazone": {
                "_mzone": "Tokelau"
              }
            }],
            "Fiji": [{
              "usesMetazone": {
                "_mzone": "Fiji"
              }
            }],
            "Funafuti": [{
              "usesMetazone": {
                "_mzone": "Tuvalu"
              }
            }],
            "Galapagos": [{
              "usesMetazone": {
                "_mzone": "Ecuador",
                "_to": "1986-01-01 05:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Galapagos",
                "_from": "1986-01-01 05:00"
              }
            }],
            "Gambier": [{
              "usesMetazone": {
                "_mzone": "Gambier"
              }
            }],
            "Guadalcanal": [{
              "usesMetazone": {
                "_mzone": "Solomon"
              }
            }],
            "Guam": [{
              "usesMetazone": {
                "_mzone": "Guam",
                "_to": "2000-12-22 14:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Chamorro",
                "_from": "2000-12-22 14:00"
              }
            }],
            "Honolulu": [{
              "usesMetazone": {
                "_mzone": "Alaska_Hawaii",
                "_to": "1983-10-30 11:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Hawaii_Aleutian",
                "_from": "1983-10-30 11:00"
              }
            }],
            "Johnston": [{
              "usesMetazone": {
                "_mzone": "Alaska_Hawaii",
                "_to": "1983-10-30 11:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Hawaii_Aleutian",
                "_from": "1983-10-30 11:00"
              }
            }],
            "Kiritimati": [{
              "usesMetazone": {
                "_mzone": "Line_Islands"
              }
            }],
            "Kosrae": [{
              "usesMetazone": {
                "_mzone": "Kosrae"
              }
            }],
            "Kwajalein": [{
              "usesMetazone": {
                "_mzone": "Kwajalein",
                "_to": "1993-08-21 12:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Marshall_Islands",
                "_from": "1993-08-21 12:00"
              }
            }],
            "Majuro": [{
              "usesMetazone": {
                "_mzone": "Marshall_Islands"
              }
            }],
            "Marquesas": [{
              "usesMetazone": {
                "_mzone": "Marquesas"
              }
            }],
            "Midway": [{
              "usesMetazone": {
                "_mzone": "Bering",
                "_to": "1983-10-30 12:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Samoa",
                "_from": "1983-10-30 12:00"
              }
            }],
            "Nauru": [{
              "usesMetazone": {
                "_mzone": "Nauru"
              }
            }],
            "Niue": [{
              "usesMetazone": {
                "_mzone": "Niue"
              }
            }],
            "Norfolk": [{
              "usesMetazone": {
                "_mzone": "Norfolk"
              }
            }],
            "Noumea": [{
              "usesMetazone": {
                "_mzone": "New_Caledonia"
              }
            }],
            "Pago_Pago": [{
              "usesMetazone": {
                "_mzone": "Bering",
                "_to": "1983-10-30 12:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Samoa",
                "_from": "1983-10-30 12:00"
              }
            }],
            "Palau": [{
              "usesMetazone": {
                "_mzone": "Palau"
              }
            }],
            "Pitcairn": [{
              "usesMetazone": {
                "_mzone": "Pitcairn"
              }
            }],
            "Ponape": [{
              "usesMetazone": {
                "_mzone": "Ponape"
              }
            }],
            "Port_Moresby": [{
              "usesMetazone": {
                "_mzone": "Papua_New_Guinea"
              }
            }],
            "Rarotonga": [{
              "usesMetazone": {
                "_mzone": "Cook"
              }
            }],
            "Saipan": [{
              "usesMetazone": {
                "_mzone": "North_Mariana",
                "_to": "2000-12-22 14:00"
              }
            }, {
              "usesMetazone": {
                "_mzone": "Chamorro",
                "_from": "2000-12-22 14:00"
              }
            }],
            "Tahiti": [{
              "usesMetazone": {
                "_mzone": "Tahiti"
              }
            }],
            "Tarawa": [{
              "usesMetazone": {
                "_mzone": "Gilbert_Islands"
              }
            }],
            "Tongatapu": [{
              "usesMetazone": {
                "_mzone": "Tonga"
              }
            }],
            "Truk": [{
              "usesMetazone": {
                "_mzone": "Truk"
              }
            }],
            "Wake": [{
              "usesMetazone": {
                "_mzone": "Wake"
              }
            }],
            "Wallis": [{
              "usesMetazone": {
                "_mzone": "Wallis"
              }
            }]
          },
          "PST8PDT": [{
            "usesMetazone": {
              "_mzone": "America_Pacific"
            }
          }]
        }
      },
      "metazones": [{
        "mapZone": {
          "_other": "Acre",
          "_type": "America/Rio_Branco",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Afghanistan",
          "_type": "Asia/Kabul",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Maputo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Bujumbura",
          "_territory": "BI"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Gaborone",
          "_territory": "BW"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Lubumbashi",
          "_territory": "CD"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Blantyre",
          "_territory": "MW"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Kigali",
          "_territory": "RW"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Lusaka",
          "_territory": "ZM"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Central",
          "_type": "Africa/Harare",
          "_territory": "ZW"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Africa/Nairobi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Africa/Djibouti",
          "_territory": "DJ"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Africa/Asmera",
          "_territory": "ER"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Africa/Addis_Ababa",
          "_territory": "ET"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Indian/Comoro",
          "_territory": "KM"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Indian/Antananarivo",
          "_territory": "MG"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Africa/Mogadishu",
          "_territory": "SO"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Africa/Dar_es_Salaam",
          "_territory": "TZ"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Africa/Kampala",
          "_territory": "UG"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Eastern",
          "_type": "Indian/Mayotte",
          "_territory": "YT"
        }
      }, {
        "mapZone": {
          "_other": "Africa_FarWestern",
          "_type": "Africa/El_Aaiun",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Southern",
          "_type": "Africa/Johannesburg",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Southern",
          "_type": "Africa/Maseru",
          "_territory": "LS"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Southern",
          "_type": "Africa/Mbabane",
          "_territory": "SZ"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Lagos",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Luanda",
          "_territory": "AO"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Porto-Novo",
          "_territory": "BJ"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Kinshasa",
          "_territory": "CD"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Bangui",
          "_territory": "CF"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Brazzaville",
          "_territory": "CG"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Douala",
          "_territory": "CM"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Libreville",
          "_territory": "GA"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Malabo",
          "_territory": "GQ"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Niamey",
          "_territory": "NE"
        }
      }, {
        "mapZone": {
          "_other": "Africa_Western",
          "_type": "Africa/Ndjamena",
          "_territory": "TD"
        }
      }, {
        "mapZone": {
          "_other": "Aktyubinsk",
          "_type": "Asia/Aqtobe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Alaska",
          "_type": "America/Juneau",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Alaska_Hawaii",
          "_type": "America/Anchorage",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Almaty",
          "_type": "Asia/Almaty",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Amazon",
          "_type": "America/Manaus",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/Chicago",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/Belize",
          "_territory": "BZ"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/Winnipeg",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/Costa_Rica",
          "_territory": "CR"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/Guatemala",
          "_territory": "GT"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/Tegucigalpa",
          "_territory": "HN"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/Mexico_City",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "America_Central",
          "_type": "America/El_Salvador",
          "_territory": "SV"
        }
      }, {
        "mapZone": {
          "_other": "America_Eastern",
          "_type": "America/New_York",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "America_Eastern",
          "_type": "America/Nassau",
          "_territory": "BS"
        }
      }, {
        "mapZone": {
          "_other": "America_Eastern",
          "_type": "America/Toronto",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "America_Eastern",
          "_type": "America/Port-au-Prince",
          "_territory": "HT"
        }
      }, {
        "mapZone": {
          "_other": "America_Eastern",
          "_type": "America/Jamaica",
          "_territory": "JM"
        }
      }, {
        "mapZone": {
          "_other": "America_Eastern",
          "_type": "America/Cayman",
          "_territory": "KY"
        }
      }, {
        "mapZone": {
          "_other": "America_Eastern",
          "_type": "America/Panama",
          "_territory": "PA"
        }
      }, {
        "mapZone": {
          "_other": "America_Mountain",
          "_type": "America/Denver",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "America_Mountain",
          "_type": "America/Edmonton",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "America_Mountain",
          "_type": "America/Hermosillo",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "America_Pacific",
          "_type": "America/Los_Angeles",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "America_Pacific",
          "_type": "America/Vancouver",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "America_Pacific",
          "_type": "America/Tijuana",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "Anadyr",
          "_type": "Asia/Anadyr",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Apia",
          "_type": "Pacific/Apia",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Aqtau",
          "_type": "Asia/Aqtau",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Aqtobe",
          "_type": "Asia/Aqtobe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Arabian",
          "_type": "Asia/Riyadh",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Arabian",
          "_type": "Asia/Bahrain",
          "_territory": "BH"
        }
      }, {
        "mapZone": {
          "_other": "Arabian",
          "_type": "Asia/Baghdad",
          "_territory": "IQ"
        }
      }, {
        "mapZone": {
          "_other": "Arabian",
          "_type": "Asia/Kuwait",
          "_territory": "KW"
        }
      }, {
        "mapZone": {
          "_other": "Arabian",
          "_type": "Asia/Qatar",
          "_territory": "QA"
        }
      }, {
        "mapZone": {
          "_other": "Arabian",
          "_type": "Asia/Aden",
          "_territory": "YE"
        }
      }, {
        "mapZone": {
          "_other": "Argentina",
          "_type": "America/Buenos_Aires",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Argentina_Western",
          "_type": "America/Argentina/San_Luis",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Armenia",
          "_type": "Asia/Yerevan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Ashkhabad",
          "_type": "Asia/Ashgabat",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Halifax",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Antigua",
          "_territory": "AG"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Anguilla",
          "_territory": "AI"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Aruba",
          "_territory": "AW"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Barbados",
          "_territory": "BB"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "Atlantic/Bermuda",
          "_territory": "BM"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Kralendijk",
          "_territory": "BQ"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Curacao",
          "_territory": "CW"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Dominica",
          "_territory": "DM"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Grenada",
          "_territory": "GD"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Thule",
          "_territory": "GL"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Guadeloupe",
          "_territory": "GP"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/St_Kitts",
          "_territory": "KN"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/St_Lucia",
          "_territory": "LC"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Marigot",
          "_territory": "MF"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Martinique",
          "_territory": "MQ"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Montserrat",
          "_territory": "MS"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Puerto_Rico",
          "_territory": "PR"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Lower_Princes",
          "_territory": "SX"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Port_of_Spain",
          "_territory": "TT"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/St_Vincent",
          "_territory": "VC"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/Tortola",
          "_territory": "VG"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic",
          "_type": "America/St_Thomas",
          "_territory": "VI"
        }
      }, {
        "mapZone": {
          "_other": "Australia_Central",
          "_type": "Australia/Adelaide",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Australia_CentralWestern",
          "_type": "Australia/Eucla",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Australia_Eastern",
          "_type": "Australia/Sydney",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Australia_Western",
          "_type": "Australia/Perth",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Azerbaijan",
          "_type": "Asia/Baku",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Azores",
          "_type": "Atlantic/Azores",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Baku",
          "_type": "Asia/Baku",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Bangladesh",
          "_type": "Asia/Dhaka",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Bering",
          "_type": "America/Adak",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Bhutan",
          "_type": "Asia/Thimphu",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Bolivia",
          "_type": "America/La_Paz",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Borneo",
          "_type": "Asia/Kuching",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Brasilia",
          "_type": "America/Sao_Paulo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "British",
          "_type": "Europe/London",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Brunei",
          "_type": "Asia/Brunei",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Cape_Verde",
          "_type": "Atlantic/Cape_Verde",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Casey",
          "_type": "Antarctica/Casey",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Chamorro",
          "_type": "Pacific/Saipan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Chamorro",
          "_type": "Pacific/Guam",
          "_territory": "GU"
        }
      }, {
        "mapZone": {
          "_other": "Chatham",
          "_type": "Pacific/Chatham",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Chile",
          "_type": "America/Santiago",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "China",
          "_type": "Asia/Shanghai",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Choibalsan",
          "_type": "Asia/Choibalsan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Christmas",
          "_type": "Indian/Christmas",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Cocos",
          "_type": "Indian/Cocos",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Colombia",
          "_type": "America/Bogota",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Cook",
          "_type": "Pacific/Rarotonga",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Cuba",
          "_type": "America/Havana",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Dacca",
          "_type": "Asia/Dhaka",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Davis",
          "_type": "Antarctica/Davis",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Dominican",
          "_type": "America/Santo_Domingo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "DumontDUrville",
          "_type": "Antarctica/DumontDUrville",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Dushanbe",
          "_type": "Asia/Dushanbe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Dutch_Guiana",
          "_type": "America/Paramaribo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "East_Timor",
          "_type": "Asia/Dili",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Easter",
          "_type": "Pacific/Easter",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Ecuador",
          "_type": "America/Guayaquil",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Paris",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Andorra",
          "_territory": "AD"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Tirane",
          "_territory": "AL"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Vienna",
          "_territory": "AT"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Sarajevo",
          "_territory": "BA"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Brussels",
          "_territory": "BE"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Zurich",
          "_territory": "CH"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Prague",
          "_territory": "CZ"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Berlin",
          "_territory": "DE"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Copenhagen",
          "_territory": "DK"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Madrid",
          "_territory": "ES"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Gibraltar",
          "_territory": "GI"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Zagreb",
          "_territory": "HR"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Budapest",
          "_territory": "HU"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Rome",
          "_territory": "IT"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Vaduz",
          "_territory": "LI"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Luxembourg",
          "_territory": "LU"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Monaco",
          "_territory": "MC"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Podgorica",
          "_territory": "ME"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Skopje",
          "_territory": "MK"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Malta",
          "_territory": "MT"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Amsterdam",
          "_territory": "NL"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Oslo",
          "_territory": "NO"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Warsaw",
          "_territory": "PL"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Belgrade",
          "_territory": "RS"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Stockholm",
          "_territory": "SE"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Ljubljana",
          "_territory": "SI"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Bratislava",
          "_territory": "SK"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/San_Marino",
          "_territory": "SM"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Africa/Tunis",
          "_territory": "TN"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Vatican",
          "_territory": "VA"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Central",
          "_type": "Europe/Belgrade",
          "_territory": "XK"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Europe/Bucharest",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Europe/Mariehamn",
          "_territory": "AX"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Europe/Sofia",
          "_territory": "BG"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Asia/Nicosia",
          "_territory": "CY"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Africa/Cairo",
          "_territory": "EG"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Europe/Helsinki",
          "_territory": "FI"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Europe/Athens",
          "_territory": "GR"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Asia/Amman",
          "_territory": "JO"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Asia/Beirut",
          "_territory": "LB"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Eastern",
          "_type": "Asia/Damascus",
          "_territory": "SY"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Further_Eastern",
          "_type": "Europe/Minsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Further_Eastern",
          "_type": "Europe/Kaliningrad",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Western",
          "_type": "Atlantic/Canary",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Europe_Western",
          "_type": "Atlantic/Faeroe",
          "_territory": "FO"
        }
      }, {
        "mapZone": {
          "_other": "Falkland",
          "_type": "Atlantic/Stanley",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Fiji",
          "_type": "Pacific/Fiji",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "French_Guiana",
          "_type": "America/Cayenne",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "French_Southern",
          "_type": "Indian/Kerguelen",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Frunze",
          "_type": "Asia/Bishkek",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Galapagos",
          "_type": "Pacific/Galapagos",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Gambier",
          "_type": "Pacific/Gambier",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Georgia",
          "_type": "Asia/Tbilisi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Gilbert_Islands",
          "_type": "Pacific/Tarawa",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Atlantic/Reykjavik",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Ouagadougou",
          "_territory": "BF"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Abidjan",
          "_territory": "CI"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Europe/London",
          "_territory": "GB"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Accra",
          "_territory": "GH"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Banjul",
          "_territory": "GM"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Conakry",
          "_territory": "GN"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Europe/Dublin",
          "_territory": "IE"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Bamako",
          "_territory": "ML"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Nouakchott",
          "_territory": "MR"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Atlantic/St_Helena",
          "_territory": "SH"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Freetown",
          "_territory": "SL"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Dakar",
          "_territory": "SN"
        }
      }, {
        "mapZone": {
          "_other": "GMT",
          "_type": "Africa/Lome",
          "_territory": "TG"
        }
      }, {
        "mapZone": {
          "_other": "Goose_Bay",
          "_type": "America/Goose_Bay",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Greenland_Central",
          "_type": "America/Scoresbysund",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Greenland_Eastern",
          "_type": "America/Scoresbysund",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Greenland_Western",
          "_type": "America/Godthab",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Guam",
          "_type": "Pacific/Guam",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Gulf",
          "_type": "Asia/Dubai",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Gulf",
          "_type": "Asia/Muscat",
          "_territory": "OM"
        }
      }, {
        "mapZone": {
          "_other": "Guyana",
          "_type": "America/Guyana",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Hawaii_Aleutian",
          "_type": "Pacific/Honolulu",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Hong_Kong",
          "_type": "Asia/Hong_Kong",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Hovd",
          "_type": "Asia/Hovd",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "India",
          "_type": "Asia/Calcutta",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "India",
          "_type": "Asia/Colombo",
          "_territory": "LK"
        }
      }, {
        "mapZone": {
          "_other": "Indian_Ocean",
          "_type": "Indian/Chagos",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Indochina",
          "_type": "Asia/Bangkok",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Indochina",
          "_type": "Asia/Phnom_Penh",
          "_territory": "KH"
        }
      }, {
        "mapZone": {
          "_other": "Indochina",
          "_type": "Asia/Vientiane",
          "_territory": "LA"
        }
      }, {
        "mapZone": {
          "_other": "Indonesia_Central",
          "_type": "Asia/Makassar",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Indonesia_Eastern",
          "_type": "Asia/Jayapura",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Indonesia_Western",
          "_type": "Asia/Jakarta",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Iran",
          "_type": "Asia/Tehran",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Irish",
          "_type": "Europe/Dublin",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Irkutsk",
          "_type": "Asia/Irkutsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Israel",
          "_type": "Asia/Jerusalem",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Japan",
          "_type": "Asia/Tokyo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kamchatka",
          "_type": "Asia/Kamchatka",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Karachi",
          "_type": "Asia/Karachi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kazakhstan_Eastern",
          "_type": "Asia/Almaty",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kazakhstan_Western",
          "_type": "Asia/Aqtobe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kizilorda",
          "_type": "Asia/Qyzylorda",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Korea",
          "_type": "Asia/Seoul",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kosrae",
          "_type": "Pacific/Kosrae",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Krasnoyarsk",
          "_type": "Asia/Krasnoyarsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kuybyshev",
          "_type": "Europe/Samara",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kwajalein",
          "_type": "Pacific/Kwajalein",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kyrgystan",
          "_type": "Asia/Bishkek",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Lanka",
          "_type": "Asia/Colombo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Liberia",
          "_type": "Africa/Monrovia",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Line_Islands",
          "_type": "Pacific/Kiritimati",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Lord_Howe",
          "_type": "Australia/Lord_Howe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Macau",
          "_type": "Asia/Macau",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Macquarie",
          "_type": "Antarctica/Macquarie",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Magadan",
          "_type": "Asia/Magadan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Malaya",
          "_type": "Asia/Kuala_Lumpur",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Malaysia",
          "_type": "Asia/Kuching",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Maldives",
          "_type": "Indian/Maldives",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Marquesas",
          "_type": "Pacific/Marquesas",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Marshall_Islands",
          "_type": "Pacific/Majuro",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mauritius",
          "_type": "Indian/Mauritius",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mawson",
          "_type": "Antarctica/Mawson",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mexico_Northwest",
          "_type": "America/Santa_Isabel",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mexico_Pacific",
          "_type": "America/Mazatlan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mongolia",
          "_type": "Asia/Ulaanbaatar",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Moscow",
          "_type": "Europe/Moscow",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Myanmar",
          "_type": "Asia/Rangoon",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Nauru",
          "_type": "Pacific/Nauru",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Nepal",
          "_type": "Asia/Katmandu",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "New_Caledonia",
          "_type": "Pacific/Noumea",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "New_Zealand",
          "_type": "Pacific/Auckland",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "New_Zealand",
          "_type": "Antarctica/McMurdo",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "Newfoundland",
          "_type": "America/St_Johns",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Niue",
          "_type": "Pacific/Niue",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Norfolk",
          "_type": "Pacific/Norfolk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Noronha",
          "_type": "America/Noronha",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "North_Mariana",
          "_type": "Pacific/Saipan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Novosibirsk",
          "_type": "Asia/Novosibirsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Omsk",
          "_type": "Asia/Omsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Oral",
          "_type": "Asia/Oral",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pakistan",
          "_type": "Asia/Karachi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Palau",
          "_type": "Pacific/Palau",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Papua_New_Guinea",
          "_type": "Pacific/Port_Moresby",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Paraguay",
          "_type": "America/Asuncion",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Peru",
          "_type": "America/Lima",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Philippines",
          "_type": "Asia/Manila",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Phoenix_Islands",
          "_type": "Pacific/Enderbury",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pierre_Miquelon",
          "_type": "America/Miquelon",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pitcairn",
          "_type": "Pacific/Pitcairn",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Ponape",
          "_type": "Pacific/Ponape",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pyongyang",
          "_type": "Asia/Pyongyang",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Qyzylorda",
          "_type": "Asia/Qyzylorda",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Reunion",
          "_type": "Indian/Reunion",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Rothera",
          "_type": "Antarctica/Rothera",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Sakhalin",
          "_type": "Asia/Sakhalin",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Samara",
          "_type": "Europe/Samara",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Samarkand",
          "_type": "Asia/Samarkand",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Samoa",
          "_type": "Pacific/Pago_Pago",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Seychelles",
          "_type": "Indian/Mahe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Shevchenko",
          "_type": "Asia/Aqtau",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Singapore",
          "_type": "Asia/Singapore",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Solomon",
          "_type": "Pacific/Guadalcanal",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "South_Georgia",
          "_type": "Atlantic/South_Georgia",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Suriname",
          "_type": "America/Paramaribo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Sverdlovsk",
          "_type": "Asia/Yekaterinburg",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Syowa",
          "_type": "Antarctica/Syowa",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tahiti",
          "_type": "Pacific/Tahiti",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Taipei",
          "_type": "Asia/Taipei",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tajikistan",
          "_type": "Asia/Dushanbe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tashkent",
          "_type": "Asia/Tashkent",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tbilisi",
          "_type": "Asia/Tbilisi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tokelau",
          "_type": "Pacific/Fakaofo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tonga",
          "_type": "Pacific/Tongatapu",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Truk",
          "_type": "Pacific/Truk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Turkey",
          "_type": "Europe/Istanbul",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Turkmenistan",
          "_type": "Asia/Ashgabat",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tuvalu",
          "_type": "Pacific/Funafuti",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Uralsk",
          "_type": "Asia/Oral",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Uruguay",
          "_type": "America/Montevideo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Urumqi",
          "_type": "Asia/Urumqi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Uzbekistan",
          "_type": "Asia/Tashkent",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Vanuatu",
          "_type": "Pacific/Efate",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Venezuela",
          "_type": "America/Caracas",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Vladivostok",
          "_type": "Asia/Vladivostok",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Volgograd",
          "_type": "Europe/Volgograd",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Vostok",
          "_type": "Antarctica/Vostok",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Wake",
          "_type": "Pacific/Wake",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Wallis",
          "_type": "Pacific/Wallis",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Yakutsk",
          "_type": "Asia/Yakutsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Yekaterinburg",
          "_type": "Asia/Yekaterinburg",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Yerevan",
          "_type": "Asia/Yerevan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Yukon",
          "_type": "America/Yakutat",
          "_territory": "001"
        }
      }]
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14872 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "numberingSystems": {
      "adlm": {
        "_digits": "𞥐𞥑𞥒𞥓𞥔𞥕𞥖𞥗𞥘𞥙",
        "_type": "numeric"
      },
      "ahom": {
        "_digits": "𑜰𑜱𑜲𑜳𑜴𑜵𑜶𑜷𑜸𑜹",
        "_type": "numeric"
      },
      "arab": {
        "_digits": "٠١٢٣٤٥٦٧٨٩",
        "_type": "numeric"
      },
      "arabext": {
        "_digits": "۰۱۲۳۴۵۶۷۸۹",
        "_type": "numeric"
      },
      "armn": {
        "_rules": "armenian-upper",
        "_type": "algorithmic"
      },
      "armnlow": {
        "_rules": "armenian-lower",
        "_type": "algorithmic"
      },
      "bali": {
        "_digits": "᭐᭑᭒᭓᭔᭕᭖᭗᭘᭙",
        "_type": "numeric"
      },
      "beng": {
        "_digits": "০১২৩৪৫৬৭৮৯",
        "_type": "numeric"
      },
      "bhks": {
        "_digits": "𑱐𑱑𑱒𑱓𑱔𑱕𑱖𑱗𑱘𑱙",
        "_type": "numeric"
      },
      "brah": {
        "_digits": "𑁦𑁧𑁨𑁩𑁪𑁫𑁬𑁭𑁮𑁯",
        "_type": "numeric"
      },
      "cakm": {
        "_digits": "𑄶𑄷𑄸𑄹𑄺𑄻𑄼𑄽𑄾𑄿",
        "_type": "numeric"
      },
      "cham": {
        "_digits": "꩐꩑꩒꩓꩔꩕꩖꩗꩘꩙",
        "_type": "numeric"
      },
      "cyrl": {
        "_rules": "cyrillic-lower",
        "_type": "algorithmic"
      },
      "deva": {
        "_digits": "०१२३४५६७८९",
        "_type": "numeric"
      },
      "ethi": {
        "_rules": "ethiopic",
        "_type": "algorithmic"
      },
      "fullwide": {
        "_digits": "０１２３４５６７８９",
        "_type": "numeric"
      },
      "geor": {
        "_rules": "georgian",
        "_type": "algorithmic"
      },
      "gong": {
        "_digits": "𑶠𑶡𑶢𑶣𑶤𑶥𑶦𑶧𑶨𑶩",
        "_type": "numeric"
      },
      "gonm": {
        "_digits": "𑵐𑵑𑵒𑵓𑵔𑵕𑵖𑵗𑵘𑵙",
        "_type": "numeric"
      },
      "grek": {
        "_rules": "greek-upper",
        "_type": "algorithmic"
      },
      "greklow": {
        "_rules": "greek-lower",
        "_type": "algorithmic"
      },
      "gujr": {
        "_digits": "૦૧૨૩૪૫૬૭૮૯",
        "_type": "numeric"
      },
      "guru": {
        "_digits": "੦੧੨੩੪੫੬੭੮੯",
        "_type": "numeric"
      },
      "hanidays": {
        "_rules": "zh/SpelloutRules/spellout-numbering-days",
        "_type": "algorithmic"
      },
      "hanidec": {
        "_digits": "〇一二三四五六七八九",
        "_type": "numeric"
      },
      "hans": {
        "_rules": "zh/SpelloutRules/spellout-cardinal",
        "_type": "algorithmic"
      },
      "hansfin": {
        "_rules": "zh/SpelloutRules/spellout-cardinal-financial",
        "_type": "algorithmic"
      },
      "hant": {
        "_rules": "zh_Hant/SpelloutRules/spellout-cardinal",
        "_type": "algorithmic"
      },
      "hantfin": {
        "_rules": "zh_Hant/SpelloutRules/spellout-cardinal-financial",
        "_type": "algorithmic"
      },
      "hebr": {
        "_rules": "hebrew",
        "_type": "algorithmic"
      },
      "hmng": {
        "_digits": "𖭐𖭑𖭒𖭓𖭔𖭕𖭖𖭗𖭘𖭙",
        "_type": "numeric"
      },
      "hmnp": {
        "_digits": "𞅀𞅁𞅂𞅃𞅄𞅅𞅆𞅇𞅈𞅉",
        "_type": "numeric"
      },
      "java": {
        "_digits": "꧐꧑꧒꧓꧔꧕꧖꧗꧘꧙",
        "_type": "numeric"
      },
      "jpan": {
        "_rules": "ja/SpelloutRules/spellout-cardinal",
        "_type": "algorithmic"
      },
      "jpanfin": {
        "_rules": "ja/SpelloutRules/spellout-cardinal-financial",
        "_type": "algorithmic"
      },
      "jpanyear": {
        "_rules": "ja/SpelloutRules/spellout-numbering-year-latn",
        "_type": "algorithmic"
      },
      "kali": {
        "_digits": "꤀꤁꤂꤃꤄꤅꤆꤇꤈꤉",
        "_type": "numeric"
      },
      "khmr": {
        "_digits": "០១២៣៤៥៦៧៨៩",
        "_type": "numeric"
      },
      "knda": {
        "_digits": "೦೧೨೩೪೫೬೭೮೯",
        "_type": "numeric"
      },
      "lana": {
        "_digits": "᪀᪁᪂᪃᪄᪅᪆᪇᪈᪉",
        "_type": "numeric"
      },
      "lanatham": {
        "_digits": "᪐᪑᪒᪓᪔᪕᪖᪗᪘᪙",
        "_type": "numeric"
      },
      "laoo": {
        "_digits": "໐໑໒໓໔໕໖໗໘໙",
        "_type": "numeric"
      },
      "latn": {
        "_digits": "0123456789",
        "_type": "numeric"
      },
      "lepc": {
        "_digits": "᱀᱁᱂᱃᱄᱅᱆᱇᱈᱉",
        "_type": "numeric"
      },
      "limb": {
        "_digits": "᥆᥇᥈᥉᥊᥋᥌᥍᥎᥏",
        "_type": "numeric"
      },
      "mathbold": {
        "_digits": "𝟎𝟏𝟐𝟑𝟒𝟓𝟔𝟕𝟖𝟗",
        "_type": "numeric"
      },
      "mathdbl": {
        "_digits": "𝟘𝟙𝟚𝟛𝟜𝟝𝟞𝟟𝟠𝟡",
        "_type": "numeric"
      },
      "mathmono": {
        "_digits": "𝟶𝟷𝟸𝟹𝟺𝟻𝟼𝟽𝟾𝟿",
        "_type": "numeric"
      },
      "mathsanb": {
        "_digits": "𝟬𝟭𝟮𝟯𝟰𝟱𝟲𝟳𝟴𝟵",
        "_type": "numeric"
      },
      "mathsans": {
        "_digits": "𝟢𝟣𝟤𝟥𝟦𝟧𝟨𝟩𝟪𝟫",
        "_type": "numeric"
      },
      "mlym": {
        "_digits": "൦൧൨൩൪൫൬൭൮൯",
        "_type": "numeric"
      },
      "modi": {
        "_digits": "𑙐𑙑𑙒𑙓𑙔𑙕𑙖𑙗𑙘𑙙",
        "_type": "numeric"
      },
      "mong": {
        "_digits": "᠐᠑᠒᠓᠔᠕᠖᠗᠘᠙",
        "_type": "numeric"
      },
      "mroo": {
        "_digits": "𖩠𖩡𖩢𖩣𖩤𖩥𖩦𖩧𖩨𖩩",
        "_type": "numeric"
      },
      "mtei": {
        "_digits": "꯰꯱꯲꯳꯴꯵꯶꯷꯸꯹",
        "_type": "numeric"
      },
      "mymr": {
        "_digits": "၀၁၂၃၄၅၆၇၈၉",
        "_type": "numeric"
      },
      "mymrshan": {
        "_digits": "႐႑႒႓႔႕႖႗႘႙",
        "_type": "numeric"
      },
      "mymrtlng": {
        "_digits": "꧰꧱꧲꧳꧴꧵꧶꧷꧸꧹",
        "_type": "numeric"
      },
      "newa": {
        "_digits": "𑑐𑑑𑑒𑑓𑑔𑑕𑑖𑑗𑑘𑑙",
        "_type": "numeric"
      },
      "nkoo": {
        "_digits": "߀߁߂߃߄߅߆߇߈߉",
        "_type": "numeric"
      },
      "olck": {
        "_digits": "᱐᱑᱒᱓᱔᱕᱖᱗᱘᱙",
        "_type": "numeric"
      },
      "orya": {
        "_digits": "୦୧୨୩୪୫୬୭୮୯",
        "_type": "numeric"
      },
      "osma": {
        "_digits": "𐒠𐒡𐒢𐒣𐒤𐒥𐒦𐒧𐒨𐒩",
        "_type": "numeric"
      },
      "rohg": {
        "_digits": "𐴰𐴱𐴲𐴳𐴴𐴵𐴶𐴷𐴸𐴹",
        "_type": "numeric"
      },
      "roman": {
        "_rules": "roman-upper",
        "_type": "algorithmic"
      },
      "romanlow": {
        "_rules": "roman-lower",
        "_type": "algorithmic"
      },
      "saur": {
        "_digits": "꣐꣑꣒꣓꣔꣕꣖꣗꣘꣙",
        "_type": "numeric"
      },
      "shrd": {
        "_digits": "𑇐𑇑𑇒𑇓𑇔𑇕𑇖𑇗𑇘𑇙",
        "_type": "numeric"
      },
      "sind": {
        "_digits": "𑋰𑋱𑋲𑋳𑋴𑋵𑋶𑋷𑋸𑋹",
        "_type": "numeric"
      },
      "sinh": {
        "_digits": "෦෧෨෩෪෫෬෭෮෯",
        "_type": "numeric"
      },
      "sora": {
        "_digits": "𑃰𑃱𑃲𑃳𑃴𑃵𑃶𑃷𑃸𑃹",
        "_type": "numeric"
      },
      "sund": {
        "_digits": "᮰᮱᮲᮳᮴᮵᮶᮷᮸᮹",
        "_type": "numeric"
      },
      "takr": {
        "_digits": "𑛀𑛁𑛂𑛃𑛄𑛅𑛆𑛇𑛈𑛉",
        "_type": "numeric"
      },
      "talu": {
        "_digits": "᧐᧑᧒᧓᧔᧕᧖᧗᧘᧙",
        "_type": "numeric"
      },
      "taml": {
        "_rules": "tamil",
        "_type": "algorithmic"
      },
      "tamldec": {
        "_digits": "௦௧௨௩௪௫௬௭௮௯",
        "_type": "numeric"
      },
      "telu": {
        "_digits": "౦౧౨౩౪౫౬౭౮౯",
        "_type": "numeric"
      },
      "thai": {
        "_digits": "๐๑๒๓๔๕๖๗๘๙",
        "_type": "numeric"
      },
      "tibt": {
        "_digits": "༠༡༢༣༤༥༦༧༨༩",
        "_type": "numeric"
      },
      "tirh": {
        "_digits": "𑓐𑓑𑓒𑓓𑓔𑓕𑓖𑓗𑓘𑓙",
        "_type": "numeric"
      },
      "vaii": {
        "_digits": "꘠꘡꘢꘣꘤꘥꘦꘧꘨꘩",
        "_type": "numeric"
      },
      "wara": {
        "_digits": "𑣠𑣡𑣢𑣣𑣤𑣥𑣦𑣧𑣨𑣩",
        "_type": "numeric"
      },
      "wcho": {
        "_digits": "𞋰𞋱𞋲𞋳𞋴𞋵𞋶𞋷𞋸𞋹",
        "_type": "numeric"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14855 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "plurals-type-ordinal": {
      "af": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "am": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ar": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "as": {
        "pluralRule-count-one": "n = 1,5,7,8,9,10 @integer 1, 5, 7~10",
        "pluralRule-count-two": "n = 2,3 @integer 2, 3",
        "pluralRule-count-few": "n = 4 @integer 4",
        "pluralRule-count-many": "n = 6 @integer 6",
        "pluralRule-count-other": " @integer 0, 11~25, 100, 1000, 10000, 100000, 1000000, …"
      },
      "az": {
        "pluralRule-count-one": "i % 10 = 1,2,5,7,8 or i % 100 = 20,50,70,80 @integer 1, 2, 5, 7, 8, 11, 12, 15, 17, 18, 20~22, 25, 101, 1001, …",
        "pluralRule-count-few": "i % 10 = 3,4 or i % 1000 = 100,200,300,400,500,600,700,800,900 @integer 3, 4, 13, 14, 23, 24, 33, 34, 43, 44, 53, 54, 63, 64, 73, 74, 100, 1003, …",
        "pluralRule-count-many": "i = 0 or i % 10 = 6 or i % 100 = 40,60,90 @integer 0, 6, 16, 26, 36, 40, 46, 56, 106, 1006, …",
        "pluralRule-count-other": " @integer 9, 10, 19, 29, 30, 39, 49, 59, 69, 79, 109, 1000, 10000, 100000, 1000000, …"
      },
      "be": {
        "pluralRule-count-few": "n % 10 = 2,3 and n % 100 != 12,13 @integer 2, 3, 22, 23, 32, 33, 42, 43, 52, 53, 62, 63, 72, 73, 82, 83, 102, 1002, …",
        "pluralRule-count-other": " @integer 0, 1, 4~17, 100, 1000, 10000, 100000, 1000000, …"
      },
      "bg": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "bn": {
        "pluralRule-count-one": "n = 1,5,7,8,9,10 @integer 1, 5, 7~10",
        "pluralRule-count-two": "n = 2,3 @integer 2, 3",
        "pluralRule-count-few": "n = 4 @integer 4",
        "pluralRule-count-many": "n = 6 @integer 6",
        "pluralRule-count-other": " @integer 0, 11~25, 100, 1000, 10000, 100000, 1000000, …"
      },
      "bs": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ca": {
        "pluralRule-count-one": "n = 1,3 @integer 1, 3",
        "pluralRule-count-two": "n = 2 @integer 2",
        "pluralRule-count-few": "n = 4 @integer 4",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ce": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "cs": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "cy": {
        "pluralRule-count-zero": "n = 0,7,8,9 @integer 0, 7~9",
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-two": "n = 2 @integer 2",
        "pluralRule-count-few": "n = 3,4 @integer 3, 4",
        "pluralRule-count-many": "n = 5,6 @integer 5, 6",
        "pluralRule-count-other": " @integer 10~25, 100, 1000, 10000, 100000, 1000000, …"
      },
      "da": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "de": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "dsb": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "el": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "en": {
        "pluralRule-count-one": "n % 10 = 1 and n % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, …",
        "pluralRule-count-two": "n % 10 = 2 and n % 100 != 12 @integer 2, 22, 32, 42, 52, 62, 72, 82, 102, 1002, …",
        "pluralRule-count-few": "n % 10 = 3 and n % 100 != 13 @integer 3, 23, 33, 43, 53, 63, 73, 83, 103, 1003, …",
        "pluralRule-count-other": " @integer 0, 4~18, 100, 1000, 10000, 100000, 1000000, …"
      },
      "es": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "et": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "eu": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "fa": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "fi": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "fil": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "fr": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "fy": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ga": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "gd": {
        "pluralRule-count-one": "n = 1,11 @integer 1, 11",
        "pluralRule-count-two": "n = 2,12 @integer 2, 12",
        "pluralRule-count-few": "n = 3,13 @integer 3, 13",
        "pluralRule-count-other": " @integer 0, 4~10, 14~21, 100, 1000, 10000, 100000, 1000000, …"
      },
      "gl": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "gsw": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "gu": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-two": "n = 2,3 @integer 2, 3",
        "pluralRule-count-few": "n = 4 @integer 4",
        "pluralRule-count-many": "n = 6 @integer 6",
        "pluralRule-count-other": " @integer 0, 5, 7~20, 100, 1000, 10000, 100000, 1000000, …"
      },
      "he": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "hi": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-two": "n = 2,3 @integer 2, 3",
        "pluralRule-count-few": "n = 4 @integer 4",
        "pluralRule-count-many": "n = 6 @integer 6",
        "pluralRule-count-other": " @integer 0, 5, 7~20, 100, 1000, 10000, 100000, 1000000, …"
      },
      "hr": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "hsb": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "hu": {
        "pluralRule-count-one": "n = 1,5 @integer 1, 5",
        "pluralRule-count-other": " @integer 0, 2~4, 6~17, 100, 1000, 10000, 100000, 1000000, …"
      },
      "hy": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ia": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "id": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "in": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "is": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "it": {
        "pluralRule-count-many": "n = 11,8,80,800 @integer 8, 11, 80, 800",
        "pluralRule-count-other": " @integer 0~7, 9, 10, 12~17, 100, 1000, 10000, 100000, 1000000, …"
      },
      "iw": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ja": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ka": {
        "pluralRule-count-one": "i = 1 @integer 1",
        "pluralRule-count-many": "i = 0 or i % 100 = 2..20,40,60,80 @integer 0, 2~16, 102, 1002, …",
        "pluralRule-count-other": " @integer 21~36, 100, 1000, 10000, 100000, 1000000, …"
      },
      "kk": {
        "pluralRule-count-many": "n % 10 = 6 or n % 10 = 9 or n % 10 = 0 and n != 0 @integer 6, 9, 10, 16, 19, 20, 26, 29, 30, 36, 39, 40, 100, 1000, 10000, 100000, 1000000, …",
        "pluralRule-count-other": " @integer 0~5, 7, 8, 11~15, 17, 18, 21, 101, 1001, …"
      },
      "km": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "kn": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ko": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "kw": {
        "pluralRule-count-one": "n = 1..4 or n % 100 = 1..4,21..24,41..44,61..64,81..84 @integer 1~4, 21~24, 41~44, 61~64, 101, 1001, …",
        "pluralRule-count-many": "n = 5 or n % 100 = 5 @integer 5, 105, 205, 305, 405, 505, 605, 705, 1005, …",
        "pluralRule-count-other": " @integer 0, 6~20, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ky": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "lo": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "lt": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "lv": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "mk": {
        "pluralRule-count-one": "i % 10 = 1 and i % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, …",
        "pluralRule-count-two": "i % 10 = 2 and i % 100 != 12 @integer 2, 22, 32, 42, 52, 62, 72, 82, 102, 1002, …",
        "pluralRule-count-many": "i % 10 = 7,8 and i % 100 != 17,18 @integer 7, 8, 27, 28, 37, 38, 47, 48, 57, 58, 67, 68, 77, 78, 87, 88, 107, 1007, …",
        "pluralRule-count-other": " @integer 0, 3~6, 9~19, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ml": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "mn": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "mo": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "mr": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-two": "n = 2,3 @integer 2, 3",
        "pluralRule-count-few": "n = 4 @integer 4",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ms": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "my": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "nb": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ne": {
        "pluralRule-count-one": "n = 1..4 @integer 1~4",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"
      },
      "nl": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "or": {
        "pluralRule-count-one": "n = 1,5,7..9 @integer 1, 5, 7~9",
        "pluralRule-count-two": "n = 2,3 @integer 2, 3",
        "pluralRule-count-few": "n = 4 @integer 4",
        "pluralRule-count-many": "n = 6 @integer 6",
        "pluralRule-count-other": " @integer 0, 10~24, 100, 1000, 10000, 100000, 1000000, …"
      },
      "pa": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "pl": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "prg": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ps": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "pt": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ro": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "root": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ru": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sc": {
        "pluralRule-count-many": "n = 11,8,80,800 @integer 8, 11, 80, 800",
        "pluralRule-count-other": " @integer 0~7, 9, 10, 12~17, 100, 1000, 10000, 100000, 1000000, …"
      },
      "scn": {
        "pluralRule-count-many": "n = 11,8,80,800 @integer 8, 11, 80, 800",
        "pluralRule-count-other": " @integer 0~7, 9, 10, 12~17, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sd": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sh": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "si": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sk": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sl": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sq": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-many": "n % 10 = 4 and n % 100 != 14 @integer 4, 24, 34, 44, 54, 64, 74, 84, 104, 1004, …",
        "pluralRule-count-other": " @integer 0, 2, 3, 5~17, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sr": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sv": {
        "pluralRule-count-one": "n % 10 = 1,2 and n % 100 != 11,12 @integer 1, 2, 21, 22, 31, 32, 41, 42, 51, 52, 61, 62, 71, 72, 81, 82, 101, 1001, …",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sw": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ta": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "te": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "th": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "tk": {
        "pluralRule-count-few": "n % 10 = 6,9 or n = 10 @integer 6, 9, 10, 16, 19, 26, 29, 36, 39, 106, 1006, …",
        "pluralRule-count-other": " @integer 0~5, 7, 8, 11~15, 17, 18, 20, 100, 1000, 10000, 100000, 1000000, …"
      },
      "tl": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "tr": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "uk": {
        "pluralRule-count-few": "n % 10 = 3 and n % 100 != 13 @integer 3, 23, 33, 43, 53, 63, 73, 83, 103, 1003, …",
        "pluralRule-count-other": " @integer 0~2, 4~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "ur": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "uz": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "vi": {
        "pluralRule-count-one": "n = 1 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, …"
      },
      "yue": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "zh": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      },
      "zu": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, …"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "parentLocales": {
      "parentLocale": {
        "en-150": "en-001",
        "en-AG": "en-001",
        "en-AI": "en-001",
        "en-AU": "en-001",
        "en-BB": "en-001",
        "en-BM": "en-001",
        "en-BS": "en-001",
        "en-BW": "en-001",
        "en-BZ": "en-001",
        "en-CA": "en-001",
        "en-CC": "en-001",
        "en-CK": "en-001",
        "en-CM": "en-001",
        "en-CX": "en-001",
        "en-CY": "en-001",
        "en-DG": "en-001",
        "en-DM": "en-001",
        "en-ER": "en-001",
        "en-FJ": "en-001",
        "en-FK": "en-001",
        "en-FM": "en-001",
        "en-GB": "en-001",
        "en-GD": "en-001",
        "en-GG": "en-001",
        "en-GH": "en-001",
        "en-GI": "en-001",
        "en-GM": "en-001",
        "en-GY": "en-001",
        "en-HK": "en-001",
        "en-IE": "en-001",
        "en-IL": "en-001",
        "en-IM": "en-001",
        "en-IN": "en-001",
        "en-IO": "en-001",
        "en-JE": "en-001",
        "en-JM": "en-001",
        "en-KE": "en-001",
        "en-KI": "en-001",
        "en-KN": "en-001",
        "en-KY": "en-001",
        "en-LC": "en-001",
        "en-LR": "en-001",
        "en-LS": "en-001",
        "en-MG": "en-001",
        "en-MO": "en-001",
        "en-MS": "en-001",
        "en-MT": "en-001",
        "en-MU": "en-001",
        "en-MW": "en-001",
        "en-MY": "en-001",
        "en-NA": "en-001",
        "en-NF": "en-001",
        "en-NG": "en-001",
        "en-NR": "en-001",
        "en-NU": "en-001",
        "en-NZ": "en-001",
        "en-PG": "en-001",
        "en-PH": "en-001",
        "en-PK": "en-001",
        "en-PN": "en-001",
        "en-PW": "en-001",
        "en-RW": "en-001",
        "en-SB": "en-001",
        "en-SC": "en-001",
        "en-SD": "en-001",
        "en-SG": "en-001",
        "en-SH": "en-001",
        "en-SL": "en-001",
        "en-SS": "en-001",
        "en-SX": "en-001",
        "en-SZ": "en-001",
        "en-TC": "en-001",
        "en-TK": "en-001",
        "en-TO": "en-001",
        "en-TT": "en-001",
        "en-TV": "en-001",
        "en-TZ": "en-001",
        "en-UG": "en-001",
        "en-VC": "en-001",
        "en-VG": "en-001",
        "en-VU": "en-001",
        "en-WS": "en-001",
        "en-ZA": "en-001",
        "en-ZM": "en-001",
        "en-ZW": "en-001",
        "en-AT": "en-150",
        "en-BE": "en-150",
        "en-CH": "en-150",
        "en-DE": "en-150",
        "en-DK": "en-150",
        "en-FI": "en-150",
        "en-NL": "en-150",
        "en-SE": "en-150",
        "en-SI": "en-150",
        "es-AR": "es-419",
        "es-BO": "es-419",
        "es-BR": "es-419",
        "es-BZ": "es-419",
        "es-CL": "es-419",
        "es-CO": "es-419",
        "es-CR": "es-419",
        "es-CU": "es-419",
        "es-DO": "es-419",
        "es-EC": "es-419",
        "es-GT": "es-419",
        "es-HN": "es-419",
        "es-MX": "es-419",
        "es-NI": "es-419",
        "es-PA": "es-419",
        "es-PE": "es-419",
        "es-PR": "es-419",
        "es-PY": "es-419",
        "es-SV": "es-419",
        "es-US": "es-419",
        "es-UY": "es-419",
        "es-VE": "es-419",
        "pt-AO": "pt-PT",
        "pt-CH": "pt-PT",
        "pt-CV": "pt-PT",
        "pt-FR": "pt-PT",
        "pt-GQ": "pt-PT",
        "pt-GW": "pt-PT",
        "pt-LU": "pt-PT",
        "pt-MO": "pt-PT",
        "pt-MZ": "pt-PT",
        "pt-ST": "pt-PT",
        "pt-TL": "pt-PT",
        "az-Arab": "root",
        "az-Cyrl": "root",
        "blt-Latn": "root",
        "bm-Nkoo": "root",
        "bs-Cyrl": "root",
        "byn-Latn": "root",
        "cu-Glag": "root",
        "dje-Arab": "root",
        "dyo-Arab": "root",
        "en-Dsrt": "root",
        "en-Shaw": "root",
        "ff-Adlm": "root",
        "ff-Arab": "root",
        "ha-Arab": "root",
        "iu-Latn": "root",
        "kk-Arab": "root",
        "ku-Arab": "root",
        "ky-Arab": "root",
        "ky-Latn": "root",
        "ml-Arab": "root",
        "mn-Mong": "root",
        "ms-Arab": "root",
        "pa-Arab": "root",
        "sd-Deva": "root",
        "sd-Khoj": "root",
        "sd-Sind": "root",
        "shi-Latn": "root",
        "so-Arab": "root",
        "sr-Latn": "root",
        "sw-Arab": "root",
        "tg-Arab": "root",
        "ug-Cyrl": "root",
        "uz-Arab": "root",
        "uz-Cyrl": "root",
        "vai-Latn": "root",
        "wo-Arab": "root",
        "yo-Arab": "root",
        "yue-Hans": "root",
        "zh-Hant": "root",
        "zh-Hant-MO": "zh-Hant-HK"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14885 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "plurals-type-cardinal": {
      "af": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ak": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "am": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ar": {
        "pluralRule-count-zero": "n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000",
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-few": "n % 100 = 3..10 @integer 3~10, 103~110, 1003, … @decimal 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 103.0, 1003.0, …",
        "pluralRule-count-many": "n % 100 = 11..99 @integer 11~26, 111, 1011, … @decimal 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 111.0, 1011.0, …",
        "pluralRule-count-other": " @integer 100~102, 200~202, 300~302, 400~402, 500~502, 600, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ars": {
        "pluralRule-count-zero": "n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000",
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-few": "n % 100 = 3..10 @integer 3~10, 103~110, 1003, … @decimal 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 103.0, 1003.0, …",
        "pluralRule-count-many": "n % 100 = 11..99 @integer 11~26, 111, 1011, … @decimal 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 111.0, 1011.0, …",
        "pluralRule-count-other": " @integer 100~102, 200~202, 300~302, 400~402, 500~502, 600, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "as": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "asa": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ast": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "az": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "be": {
        "pluralRule-count-one": "n % 10 = 1 and n % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 1.0, 21.0, 31.0, 41.0, 51.0, 61.0, 71.0, 81.0, 101.0, 1001.0, …",
        "pluralRule-count-few": "n % 10 = 2..4 and n % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 2.0, 3.0, 4.0, 22.0, 23.0, 24.0, 32.0, 33.0, 102.0, 1002.0, …",
        "pluralRule-count-many": "n % 10 = 0 or n % 10 = 5..9 or n % 100 = 11..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": "   @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.1, 1000.1, …"
      },
      "bem": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "bez": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "bg": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "bh": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "bm": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "bn": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "bo": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "br": {
        "pluralRule-count-one": "n % 10 = 1 and n % 100 != 11,71,91 @integer 1, 21, 31, 41, 51, 61, 81, 101, 1001, … @decimal 1.0, 21.0, 31.0, 41.0, 51.0, 61.0, 81.0, 101.0, 1001.0, …",
        "pluralRule-count-two": "n % 10 = 2 and n % 100 != 12,72,92 @integer 2, 22, 32, 42, 52, 62, 82, 102, 1002, … @decimal 2.0, 22.0, 32.0, 42.0, 52.0, 62.0, 82.0, 102.0, 1002.0, …",
        "pluralRule-count-few": "n % 10 = 3..4,9 and n % 100 != 10..19,70..79,90..99 @integer 3, 4, 9, 23, 24, 29, 33, 34, 39, 43, 44, 49, 103, 1003, … @decimal 3.0, 4.0, 9.0, 23.0, 24.0, 29.0, 33.0, 34.0, 103.0, 1003.0, …",
        "pluralRule-count-many": "n != 0 and n % 1000000 = 0 @integer 1000000, … @decimal 1000000.0, 1000000.00, 1000000.000, …",
        "pluralRule-count-other": " @integer 0, 5~8, 10~20, 100, 1000, 10000, 100000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, …"
      },
      "brx": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "bs": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-few": "v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ca": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ce": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ceb": {
        "pluralRule-count-one": "v = 0 and i = 1,2,3 or v = 0 and i % 10 != 4,6,9 or v != 0 and f % 10 != 4,6,9 @integer 0~3, 5, 7, 8, 10~13, 15, 17, 18, 20, 21, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.3, 0.5, 0.7, 0.8, 1.0~1.3, 1.5, 1.7, 1.8, 2.0, 2.1, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 4, 6, 9, 14, 16, 19, 24, 26, 104, 1004, … @decimal 0.4, 0.6, 0.9, 1.4, 1.6, 1.9, 2.4, 2.6, 10.4, 100.4, 1000.4, …"
      },
      "cgg": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "chr": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ckb": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "cs": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-few": "i = 2..4 and v = 0 @integer 2~4",
        "pluralRule-count-many": "v != 0   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"
      },
      "cy": {
        "pluralRule-count-zero": "n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000",
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-few": "n = 3 @integer 3 @decimal 3.0, 3.00, 3.000, 3.0000",
        "pluralRule-count-many": "n = 6 @integer 6 @decimal 6.0, 6.00, 6.000, 6.0000",
        "pluralRule-count-other": " @integer 4, 5, 7~20, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "da": {
        "pluralRule-count-one": "n = 1 or t != 0 and i = 0,1 @integer 1 @decimal 0.1~1.6",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 2.0~3.4, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "de": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "dsb": {
        "pluralRule-count-one": "v = 0 and i % 100 = 1 or f % 100 = 1 @integer 1, 101, 201, 301, 401, 501, 601, 701, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-two": "v = 0 and i % 100 = 2 or f % 100 = 2 @integer 2, 102, 202, 302, 402, 502, 602, 702, 1002, … @decimal 0.2, 1.2, 2.2, 3.2, 4.2, 5.2, 6.2, 7.2, 10.2, 100.2, 1000.2, …",
        "pluralRule-count-few": "v = 0 and i % 100 = 3..4 or f % 100 = 3..4 @integer 3, 4, 103, 104, 203, 204, 303, 304, 403, 404, 503, 504, 603, 604, 703, 704, 1003, … @decimal 0.3, 0.4, 1.3, 1.4, 2.3, 2.4, 3.3, 3.4, 4.3, 4.4, 5.3, 5.4, 6.3, 6.4, 7.3, 7.4, 10.3, 100.3, 1000.3, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "dv": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "dz": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ee": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "el": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "en": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "eo": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "es": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "et": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "eu": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "fa": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ff": {
        "pluralRule-count-one": "i = 0,1 @integer 0, 1 @decimal 0.0~1.5",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "fi": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "fil": {
        "pluralRule-count-one": "v = 0 and i = 1,2,3 or v = 0 and i % 10 != 4,6,9 or v != 0 and f % 10 != 4,6,9 @integer 0~3, 5, 7, 8, 10~13, 15, 17, 18, 20, 21, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.3, 0.5, 0.7, 0.8, 1.0~1.3, 1.5, 1.7, 1.8, 2.0, 2.1, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 4, 6, 9, 14, 16, 19, 24, 26, 104, 1004, … @decimal 0.4, 0.6, 0.9, 1.4, 1.6, 1.9, 2.4, 2.6, 10.4, 100.4, 1000.4, …"
      },
      "fo": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "fr": {
        "pluralRule-count-one": "i = 0,1 @integer 0, 1 @decimal 0.0~1.5",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "fur": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "fy": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ga": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-few": "n = 3..6 @integer 3~6 @decimal 3.0, 4.0, 5.0, 6.0, 3.00, 4.00, 5.00, 6.00, 3.000, 4.000, 5.000, 6.000, 3.0000, 4.0000, 5.0000, 6.0000",
        "pluralRule-count-many": "n = 7..10 @integer 7~10 @decimal 7.0, 8.0, 9.0, 10.0, 7.00, 8.00, 9.00, 10.00, 7.000, 8.000, 9.000, 10.000, 7.0000, 8.0000, 9.0000, 10.0000",
        "pluralRule-count-other": " @integer 0, 11~25, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "gd": {
        "pluralRule-count-one": "n = 1,11 @integer 1, 11 @decimal 1.0, 11.0, 1.00, 11.00, 1.000, 11.000, 1.0000",
        "pluralRule-count-two": "n = 2,12 @integer 2, 12 @decimal 2.0, 12.0, 2.00, 12.00, 2.000, 12.000, 2.0000",
        "pluralRule-count-few": "n = 3..10,13..19 @integer 3~10, 13~19 @decimal 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 3.00",
        "pluralRule-count-other": " @integer 0, 20~34, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "gl": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "gsw": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "gu": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "guw": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "gv": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 @integer 1, 11, 21, 31, 41, 51, 61, 71, 101, 1001, …",
        "pluralRule-count-two": "v = 0 and i % 10 = 2 @integer 2, 12, 22, 32, 42, 52, 62, 72, 102, 1002, …",
        "pluralRule-count-few": "v = 0 and i % 100 = 0,20,40,60,80 @integer 0, 20, 40, 60, 80, 100, 120, 140, 1000, 10000, 100000, 1000000, …",
        "pluralRule-count-many": "v != 0   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 3~10, 13~19, 23, 103, 1003, …"
      },
      "ha": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "haw": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "he": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-two": "i = 2 and v = 0 @integer 2",
        "pluralRule-count-many": "v = 0 and n != 0..10 and n % 10 = 0 @integer 20, 30, 40, 50, 60, 70, 80, 90, 100, 1000, 10000, 100000, 1000000, …",
        "pluralRule-count-other": " @integer 0, 3~17, 101, 1001, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "hi": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "hr": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-few": "v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "hsb": {
        "pluralRule-count-one": "v = 0 and i % 100 = 1 or f % 100 = 1 @integer 1, 101, 201, 301, 401, 501, 601, 701, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-two": "v = 0 and i % 100 = 2 or f % 100 = 2 @integer 2, 102, 202, 302, 402, 502, 602, 702, 1002, … @decimal 0.2, 1.2, 2.2, 3.2, 4.2, 5.2, 6.2, 7.2, 10.2, 100.2, 1000.2, …",
        "pluralRule-count-few": "v = 0 and i % 100 = 3..4 or f % 100 = 3..4 @integer 3, 4, 103, 104, 203, 204, 303, 304, 403, 404, 503, 504, 603, 604, 703, 704, 1003, … @decimal 0.3, 0.4, 1.3, 1.4, 2.3, 2.4, 3.3, 3.4, 4.3, 4.4, 5.3, 5.4, 6.3, 6.4, 7.3, 7.4, 10.3, 100.3, 1000.3, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "hu": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "hy": {
        "pluralRule-count-one": "i = 0,1 @integer 0, 1 @decimal 0.0~1.5",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ia": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "id": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ig": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ii": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "in": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "io": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "is": {
        "pluralRule-count-one": "t = 0 and i % 10 = 1 and i % 100 != 11 or t != 0 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1~1.6, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "it": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "iu": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "iw": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-two": "i = 2 and v = 0 @integer 2",
        "pluralRule-count-many": "v = 0 and n != 0..10 and n % 10 = 0 @integer 20, 30, 40, 50, 60, 70, 80, 90, 100, 1000, 10000, 100000, 1000000, …",
        "pluralRule-count-other": " @integer 0, 3~17, 101, 1001, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ja": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "jbo": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "jgo": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ji": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "jmc": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "jv": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "jw": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ka": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kab": {
        "pluralRule-count-one": "i = 0,1 @integer 0, 1 @decimal 0.0~1.5",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kaj": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kcg": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kde": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kea": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kk": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kkj": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kl": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "km": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kn": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ko": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ks": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ksb": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ksh": {
        "pluralRule-count-zero": "n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000",
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ku": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "kw": {
        "pluralRule-count-zero": "n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000",
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n % 100 = 2,22,42,62,82 or n%1000 = 0 and n%100000=1000..20000,40000,60000,80000 or n!=0 and n%1000000=100000@integer 2, 22, 42, 62, 82, 102, 122, 142, 1002, … @decimal 2.0, 22.0, 42.0, 62.0, 82.0, 102.0, 122.0, 142.0, 1002.0, …",
        "pluralRule-count-few": "n % 100 = 3,23,43,63,83 @integer 3, 23, 43, 63, 83, 103, 123, 143, 1003, … @decimal 3.0, 23.0, 43.0, 63.0, 83.0, 103.0, 123.0, 143.0, 1003.0, …",
        "pluralRule-count-many": "n != 1 and n % 100 = 1,21,41,61,81 @integer 21, 41, 61, 81, 101, 121, 141, 161, 1001, … @decimal 21.0, 41.0, 61.0, 81.0, 101.0, 121.0, 141.0, 161.0, 1001.0, …",
        "pluralRule-count-other": " @integer 4~19, 100, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ky": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "lag": {
        "pluralRule-count-zero": "n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000",
        "pluralRule-count-one": "i = 0,1 and n != 0 @integer 1 @decimal 0.1~1.6",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "lb": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "lg": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "lkt": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ln": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "lo": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "lt": {
        "pluralRule-count-one": "n % 10 = 1 and n % 100 != 11..19 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 1.0, 21.0, 31.0, 41.0, 51.0, 61.0, 71.0, 81.0, 101.0, 1001.0, …",
        "pluralRule-count-few": "n % 10 = 2..9 and n % 100 != 11..19 @integer 2~9, 22~29, 102, 1002, … @decimal 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 22.0, 102.0, 1002.0, …",
        "pluralRule-count-many": "f != 0   @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-other": " @integer 0, 10~20, 30, 40, 50, 60, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "lv": {
        "pluralRule-count-zero": "n % 10 = 0 or n % 100 = 11..19 or v = 2 and f % 100 = 11..19 @integer 0, 10~20, 30, 40, 50, 60, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-one": "n % 10 = 1 and n % 100 != 11 or v = 2 and f % 10 = 1 and f % 100 != 11 or v != 2 and f % 10 = 1 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.0, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-other": " @integer 2~9, 22~29, 102, 1002, … @decimal 0.2~0.9, 1.2~1.9, 10.2, 100.2, 1000.2, …"
      },
      "mas": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "mg": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "mgo": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "mk": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.2~1.0, 1.2~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ml": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "mn": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "mo": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-few": "v != 0 or n = 0 or n % 100 = 2..19 @integer 0, 2~16, 102, 1002, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 20~35, 100, 1000, 10000, 100000, 1000000, …"
      },
      "mr": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ms": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "mt": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-few": "n = 0 or n % 100 = 2..10 @integer 0, 2~10, 102~107, 1002, … @decimal 0.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 10.0, 102.0, 1002.0, …",
        "pluralRule-count-many": "n % 100 = 11..19 @integer 11~19, 111~117, 1011, … @decimal 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 111.0, 1011.0, …",
        "pluralRule-count-other": " @integer 20~35, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "my": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nah": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "naq": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nb": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nd": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ne": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nl": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nn": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nnh": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "no": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nqo": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nr": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nso": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ny": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "nyn": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "om": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "or": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "os": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "pa": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "pap": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "pl": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-few": "v = 0 and i % 10 = 2..4 and i % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, …",
        "pluralRule-count-many": "v = 0 and i != 1 and i % 10 = 0..1 or v = 0 and i % 10 = 5..9 or v = 0 and i % 100 = 12..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …",
        "pluralRule-count-other": "   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "prg": {
        "pluralRule-count-zero": "n % 10 = 0 or n % 100 = 11..19 or v = 2 and f % 100 = 11..19 @integer 0, 10~20, 30, 40, 50, 60, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-one": "n % 10 = 1 and n % 100 != 11 or v = 2 and f % 10 = 1 and f % 100 != 11 or v != 2 and f % 10 = 1 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.0, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-other": " @integer 2~9, 22~29, 102, 1002, … @decimal 0.2~0.9, 1.2~1.9, 10.2, 100.2, 1000.2, …"
      },
      "ps": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "pt": {
        "pluralRule-count-one": "i = 0..1 @integer 0, 1 @decimal 0.0~1.5",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "pt-PT": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "rm": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ro": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-few": "v != 0 or n = 0 or n % 100 = 2..19 @integer 0, 2~16, 102, 1002, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 20~35, 100, 1000, 10000, 100000, 1000000, …"
      },
      "rof": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "root": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ru": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 and i % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, …",
        "pluralRule-count-few": "v = 0 and i % 10 = 2..4 and i % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, …",
        "pluralRule-count-many": "v = 0 and i % 10 = 0 or v = 0 and i % 10 = 5..9 or v = 0 and i % 100 = 11..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …",
        "pluralRule-count-other": "   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "rwk": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sah": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "saq": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sc": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "scn": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sd": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sdh": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "se": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "seh": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ses": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sg": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sh": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-few": "v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "shi": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-few": "n = 2..10 @integer 2~10 @decimal 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 2.00, 3.00, 4.00, 5.00, 6.00, 7.00, 8.00",
        "pluralRule-count-other": " @integer 11~26, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~1.9, 2.1~2.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "si": {
        "pluralRule-count-one": "n = 0,1 or i = 0 and f = 1 @integer 0, 1 @decimal 0.0, 0.1, 1.0, 0.00, 0.01, 1.00, 0.000, 0.001, 1.000, 0.0000, 0.0001, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.2~0.9, 1.1~1.8, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sk": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-few": "i = 2..4 and v = 0 @integer 2~4",
        "pluralRule-count-many": "v != 0   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sl": {
        "pluralRule-count-one": "v = 0 and i % 100 = 1 @integer 1, 101, 201, 301, 401, 501, 601, 701, 1001, …",
        "pluralRule-count-two": "v = 0 and i % 100 = 2 @integer 2, 102, 202, 302, 402, 502, 602, 702, 1002, …",
        "pluralRule-count-few": "v = 0 and i % 100 = 3..4 or v != 0 @integer 3, 4, 103, 104, 203, 204, 303, 304, 403, 404, 503, 504, 603, 604, 703, 704, 1003, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"
      },
      "sma": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "smi": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "smj": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "smn": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sms": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-two": "n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000",
        "pluralRule-count-other": " @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sn": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "so": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sq": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sr": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …",
        "pluralRule-count-few": "v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …",
        "pluralRule-count-other": " @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ss": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ssy": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "st": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sv": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "sw": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "syr": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ta": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "te": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "teo": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "th": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ti": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "tig": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "tk": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "tl": {
        "pluralRule-count-one": "v = 0 and i = 1,2,3 or v = 0 and i % 10 != 4,6,9 or v != 0 and f % 10 != 4,6,9 @integer 0~3, 5, 7, 8, 10~13, 15, 17, 18, 20, 21, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.3, 0.5, 0.7, 0.8, 1.0~1.3, 1.5, 1.7, 1.8, 2.0, 2.1, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …",
        "pluralRule-count-other": " @integer 4, 6, 9, 14, 16, 19, 24, 26, 104, 1004, … @decimal 0.4, 0.6, 0.9, 1.4, 1.6, 1.9, 2.4, 2.6, 10.4, 100.4, 1000.4, …"
      },
      "tn": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "to": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "tr": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ts": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "tzm": {
        "pluralRule-count-one": "n = 0..1 or n = 11..99 @integer 0, 1, 11~24 @decimal 0.0, 1.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0, 23.0, 24.0",
        "pluralRule-count-other": " @integer 2~10, 100~106, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ug": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "uk": {
        "pluralRule-count-one": "v = 0 and i % 10 = 1 and i % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, …",
        "pluralRule-count-few": "v = 0 and i % 10 = 2..4 and i % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, …",
        "pluralRule-count-many": "v = 0 and i % 10 = 0 or v = 0 and i % 10 = 5..9 or v = 0 and i % 100 = 11..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …",
        "pluralRule-count-other": "   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ur": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "uz": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "ve": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "vi": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "vo": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "vun": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "wa": {
        "pluralRule-count-one": "n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "wae": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "wo": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "xh": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "xog": {
        "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "yi": {
        "pluralRule-count-one": "i = 1 and v = 0 @integer 1",
        "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "yo": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "yue": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "zh": {
        "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      },
      "zu": {
        "pluralRule-count-one": "i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04",
        "pluralRule-count-other": " @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "primaryZones": {
      "CL": "America/Santiago",
      "CN": "Asia/Shanghai",
      "DE": "Europe/Berlin",
      "EC": "America/Guayaquil",
      "ES": "Europe/Madrid",
      "MH": "Pacific/Majuro",
      "MY": "Asia/Kuala_Lumpur",
      "NZ": "Pacific/Auckland",
      "PT": "Europe/Lisbon",
      "UA": "Europe/Kiev",
      "UZ": "Asia/Tashkent"
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "references": {
      "R1000": {
        "_value": "Dutch official",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/aa.html"
      },
      "R1001": {
        "_value": "At most 6% are not fluent in English",
        "_uri": "http://www.migrationinformation.org/Feature/display.cfm?ID=72"
      },
      "R1002": {
        "_value": "French official, the figure is derived from literacy * population",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/cg.html"
      },
      "R1003": "While Cyrillic is customary, the vast majority of the population can read both.For languages not customarily written, the writing populiation is artificially set to 5% in the absence of better information.",
      "R1004": {
        "_value": "The figure includes 'Vlaams' population from Ethnologue",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=NL"
      },
      "R1005": {
        "_value": "It is estimated that Walloon is used actively by 10-20% of the total population of Wallonia or between 300,000 and 600,000 people. For languages not customarily written, the writing population is artificially set to 5% in the absence of better information.",
        "_uri": "http://www.orbilat.com/Languages/Walloon/Walloon.htm"
      },
      "R1006": {
        "_value": "http://en.wikipedia.org/wiki/Demographics_of_Switzerland Literacy rate for gsw is 5% of reported speaker population; literacy is mostly in standard German. For languages not customarily written, the writing population is artificially set to 5% in the absence of better information.",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=CH"
      },
      "R1007": {
        "_value": "Arabic official, the figure is derived from literacy * lang pop",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=Bahrain"
      },
      "R1008": {
        "_value": "Spanish is the official language, only about 60-70% of the population speaks it at all ;",
        "_uri": "http://lanic.utexas.edu/project/tilan/reports/rtf359/bolivia1.html"
      },
      "R1009": {
        "_value": "English official, 81% literacy; the figure is derived from literacy * lang pop",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/bc.html"
      },
      "R1010": {
        "_value": "[missing]",
        "_uri": "http://www.joshuaproject.net/people-profile.php?peo3=13068&rog3=AO"
      },
      "R1011": {
        "_value": "Ethnologue: 350k in CAF + 1.6 million 2nd lang speakers",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=sag"
      },
      "R1012": {
        "_value": "Corsican has been recognized as a language by the French government. Speakers also use French but many are not fluent in it. For languages not customarily written, the writing population is artificially set to 5%",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=cos"
      },
      "R1013": {
        "_value": "English 1/5 of pop, used 1/5 of pop * literacy rate",
        "_uri": "http://en.wikipedia.org/wiki/Cameroon"
      },
      "R1014": {
        "_value": "Spanish official",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/co.html"
      },
      "R1015": {
        "_value": "Languedocien = Occitan 'Everyone speaks French as first or second language.' For languages not customarily written, the writing population is artificially set to 5%",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=lnc"
      },
      "R1016": {
        "_value": "100k+ native, plus 1.5 mil 2nd lang speakers. For languages not customarily written, the writing population is artificially set to 5% in the absence of better information.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=sco"
      },
      "R1017": "For languages not customarily written, the writing population is artificially set to 5% in the absence of better information.",
      "R1018": {
        "_value": "English official; the figure is derived from literacy * lang pop",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/gj.html"
      },
      "R1019": {
        "_value": "French official; the figure is derived from literacy * lang pop",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=GF"
      },
      "R1020": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Ascension_Island"
      },
      "R1021": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Languages_of_Canada#Languages_by_mother_tongue"
      },
      "R1022": {
        "_value": "English official, the figure is derived from literacy * lang pop",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/gi.html"
      },
      "R1023": {
        "_value": "French official; the figure is derived from literacy * lang pop",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=GP"
      },
      "R1024": {
        "_value": "Some 99% of users are literate in French or German. For languages not customarily written, the writing population is artificially set to 5% in the absence of better information.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=ltz"
      },
      "R1025": {
        "_value": "2nd lang literacy 15-25%",
        "_uri": "http://www.ethnologue.com/language/ewo"
      },
      "R1026": {
        "_value": "Nearly all speakers are literate in a 2nd language. For languages not customarily written, the writing population is artificially set to 5%",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=lim"
      },
      "R1027": {
        "_value": "Many minor langs; Portuguese official",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/pu.html"
      },
      "R1028": {
        "_value": "In this and other sources, such as Ethnologue, there is no estimate for number of users. http://en.wikipedia.org/wiki/Filipino_language http://www.ethnologue.com/show_language.asp?code=fil ",
        "_uri": "http://www.seasite.niu.edu/tagalog/essays-on-philippine-languages.htm"
      },
      "R1029": {
        "_value": "Most of the population uses Creole; see also http://www.country-studies.com/haiti/creole,-literacy,-and-education.html http://en.wikipedia.org/wiki/French_language#Haiti",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=hat"
      },
      "R1030": {
        "_value": "400k 2nd language speakers",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=fra"
      },
      "R1031": {
        "_value": "Official language, 37-77% literacy",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=CV"
      },
      "R1032": {
        "_value": "Official language, used in some schools.",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=ER"
      },
      "R1033": {
        "_value": "http://www.censusindia.net/cendat/datatable26.html",
        "_uri": "http://www.ciil.org/Main/Announcement/MBE_Programme/paper/paper2.htm"
      },
      "R1034": {
        "_value": "25% of pop",
        "_uri": "http://www.ethnologue.com/14/show_iso639.asp?code=kmb"
      },
      "R1035": {
        "_value": "- Icelandic official",
        "_uri": "http://en.wikipedia.org/wiki/Iceland"
      },
      "R1036": {
        "_value": "says: All Jordanians, regardless of ethnicity or religion, speak Arabic, the official language of Jordan",
        "_uri": "http://memory.loc.gov/cgi-bin/query/r?frd/cstdy:@field(DOCID+jo0039)"
      },
      "R1037": {
        "_value": "English official; Kiribati widespread",
        "_uri": "http://en.wikipedia.org/wiki/Kiribati"
      },
      "R1038": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/cia/publications/factbook/fields/2098.html"
      },
      "R1039": {
        "_value": "German official",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/ls.html"
      },
      "R1040": "No figures found for use of French. Used literacy 29.5% times population to get the writing pop; French is the only official language.",
      "R1041": {
        "_value": "French official; the figure is derived from literacy * lang pop",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/ng.html"
      },
      "R1042": {
        "_value": "Used CIA literacy figure times population, added 'Vlaams' population",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/nl.html"
      },
      "R1043": {
        "_value": "[missing]",
        "_uri": "http://www.cso.ie/census/documents/Final%20Principal%20Demographic%20Results%202006.pdf"
      },
      "R1044": {
        "_value": "70,000 in 1991, 100,000 who understand it, but do not speak it ; ethnic pop 530,000 in 2002",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=mri"
      },
      "R1045": {
        "_value": "Melanesian pidgin in much of the country is lingua franca; English (official; but spoken by only 1%-2% of the population); 120 indigenous languages",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/bp.html"
      },
      "R1046": {
        "_value": "English 20%",
        "_uri": "https://www.cia.gov/cia/publications/factbook/fields/2098.html"
      },
      "R1047": {
        "_value": "Lesotho English-using pop estimated at 5%, no figs available. Probably too low.",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=LS"
      },
      "R1048": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/18/language/ife/"
      },
      "R1049": {
        "_value": "Official language. Probably 2% of the population from East Timor worldwide can function in it",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=por"
      },
      "R1050": {
        "_value": "Ethnologue says 80k users of French. No other figures found yet, but this seems too low.",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=MA"
      },
      "R1051": {
        "_value": "Russian 5.8%.",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/md.html"
      },
      "R1052": {
        "_value": "The figure is from Wikipedia article on English-speaking populations",
        "_uri": "http://en.wikipedia.org/wiki/List_of_countries_by_English-speaking_population"
      },
      "R1053": {
        "_value": "Albanian 25.1%",
        "_uri": "https://www.cia.gov/cia/publications/factbook/fields/2098.html"
      },
      "R1054": {
        "_value": "English is an official language, not widely spoken",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/rw.html"
      },
      "R1055": {
        "_value": "42.6% of population",
        "_uri": "http://en.wikipedia.org/wiki/Pashto_language"
      },
      "R1056": {
        "_value": "[missing]",
        "_uri": "http://www.joshuaproject.net/peopctry.php?rop3=101703&rog3=MY"
      },
      "R1057": {
        "_value": "4mil 2nd lang speakers, 120k 1st lang, 20k monolinguals. English creole; 40-45% literacy.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=tpi"
      },
      "R1058": {
        "_value": "A pidginizatino of Motu; 120k 2nd lang speakers, very few 1st lang.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=hmo"
      },
      "R1059": {
        "_value": "English official on some islands, total 9.4%",
        "_uri": "https://www.cia.gov/cia/publications/factbook/fields/2098.html"
      },
      "R1060": {
        "_value": "http://astro.uchicago.edu/cara/vtour/mcmurdo/ http://www.usap.gov/videoclipsandmaps/mcmwebcam.cfm Winter population is listed.",
        "_uri": "http://www.nsf.gov/od/opp/support/southp.jsp"
      },
      "R1061": {
        "_value": "1.2mil 1st lang + 240k 2nd lang users, low literacy",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=tem"
      },
      "R1062": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Clipperton_Island"
      },
      "R1063": "Canadian census shows 97,230 total population for all Cree languages",
      "R1064": {
        "_value": "Uninhabited, barren, sub-Antarctic islands",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/hm.html"
      },
      "R1065": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Diego_Garcia"
      },
      "R1066": {
        "_value": "Figure for Hindi includes 2nd language users, India Census data.",
        "_uri": "http://www.censusindia.net/"
      },
      "R1067": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Ceuta"
      },
      "R1068": {
        "_value": "CIA Factbook entry on Kazakhstan",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/kz.html"
      },
      "R1069": {
        "_value": "50k Europeans, mostly French. The figure for writing population is derived from literacy * population, and may be too high.",
        "_uri": "http://en.wikipedia.org/wiki/Senegal"
      },
      "R1070": {
        "_value": "The figure is from Wikipedia article on http://en.wikipedia.org/wiki/List_of_countries_by_English-speaking_population The figure is from Wikipedia article on English-speaking populations",
        "_uri": "http://en.wikipedia.org/wiki/List_of_countries_by_English-speaking_population"
      },
      "R1071": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/wz.html"
      },
      "R1072": {
        "_value": " The figure is from Wikipedia article on English-speaking populations",
        "_uri": "http://en.wikipedia.org/wiki/List_of_countries_by_English-speaking_population"
      },
      "R1073": {
        "_value": "Lang pop est, CIA factbook 15-20% country pop",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/iz.html"
      },
      "R1074": {
        "_value": "CIA Factbook",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/sv.html"
      },
      "R1075": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Canary_islands"
      },
      "R1076": {
        "_value": "CIA Factbook. See also http://www.jsmp.minihub.org/Reports/jsmpreports/Language%20Report/LanguageReport(english).pdf",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/tt.html"
      },
      "R1077": {
        "_value": "CIA Factbook.",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/vt.html"
      },
      "R1078": {
        "_value": "The Tonga Chronicle is a government-owned newspaper... It publishes two editions, one in Tongan with a circulation of 5,000, and one in English with a circulation of 1,500; Writing pop figure shown for English is set to 30% of that for Tonga. ",
        "_uri": "http://www.pressreference.com/Sw-Ur/Tonga.html"
      },
      "R1079": {
        "_value": "96% bilingual in Turkish.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=abk"
      },
      "R1080": {
        "_value": "The Tuvaluan language is spoken by virtually everyone, while Gilbertese is spoken by some people on Nui. English is also an official language, but is not spoken in daily use. Writing pop set to 10% of Tuvalu.",
        "_uri": "http://en.wikipedia.org/wiki/Tuvalu"
      },
      "R1081": {
        "_value": "English (official, primary language of commerce, administration, and higher education)",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/tz.html"
      },
      "R1082": {
        "_value": "Ethnologue lists 1 million 2nd lang users of English; no other good figures found.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=eng"
      },
      "R1083": {
        "_value": " also: http://en.wikipedia.org/wiki/Bosnian_language",
        "_uri": "http://www.bhas.ba/index.php?option=com_content&view=article&id=52&itemid=80&lang=en&Itemid="
      },
      "R1084": {
        "_value": "French is a minority official language. Crude estimate of usage based on import partner data.",
        "_uri": "http://www.nationsonline.org/oneworld/equatorial_guinea.htm"
      },
      "R1085": {
        "_value": "Macao reported 5% native Portuguese speakers.",
        "_uri": "http://en.wikipedia.org/wiki/Geographic_distribution_of_Portuguese"
      },
      "R1086": "5% writing pop estimated in absence of other data",
      "R1087": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=rkt"
      },
      "R1088": {
        "_value": "Crude estimate based on import partner data.",
        "_uri": "http://www.nationsonline.org/oneworld/syria.htm"
      },
      "R1089": {
        "_value": "[missing]",
        "_uri": "http://www.wildmadagascar.org/overview/loc/27-minorities.html"
      },
      "R1090": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Mohawk_language"
      },
      "R1091": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=dyu"
      },
      "R1092": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=lua"
      },
      "R1093": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=lub"
      },
      "R1094": {
        "_value": "(= Tai Lu, Xishuangbanna Dai; New Tai Lue script)",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=khb"
      },
      "R1095": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/frr"
      },
      "R1096": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=ast"
      },
      "R1097": {
        "_value": "Estimates Indian ethnic 44% ; see also http://en.wikipedia.org/wiki/Non-resident_Indian_and_Person_of_Indian_Origin and http://www.vanuatu.usp.ac.fj/paclangunit/English_South_Pacific.htm",
        "_uri": "http://www.uwplatt.edu/news/2005/02/uw-platteville-announces-study-abroad.html"
      },
      "R1098": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=mag"
      },
      "R1099": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=efi"
      },
      "R1100": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=tbw"
      },
      "R1101": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=mhr"
      },
      "R1102": {
        "_value": "- Not widely used; set to 10%.",
        "_uri": "http://www.lmp.ucla.edu/Profile.aspx?menu=004&LangID=201"
      },
      "R1103": {
        "_value": "The lingua franca of 80% of the population",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=srn"
      },
      "R1104": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=bem"
      },
      "R1105": {
        "_value": "and https://en.wikipedia.org/wiki/Mru_language",
        "_uri": "https://www.ethnologue.com/language/mro"
      },
      "R1106": {
        "_value": "- More than 95% of Pakistanis can speak or understand Urdu as their second or third language",
        "_uri": "http://en.wikipedia.org/wiki/Languages_of_Pakistan"
      },
      "R1107": {
        "_value": "15.42% of population",
        "_uri": "http://en.wikipedia.org/wiki/Pashto_language"
      },
      "R1108": {
        "_value": "http://www.stoletie.ru/vzglyad/derusifikacija_nabirajet_oboroty_934.htm",
        "_uri": "http://windowoneurasia2.blogspot.com/2013/12/window-on-eurasia-de-russianization.html"
      },
      "R1109": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=Bahrain"
      },
      "R1110": {
        "_value": "[missing]",
        "_uri": "http://www.vaestorekisterikeskus.fi/vrk/home.nsf/pages/index_eng"
      },
      "R1111": {
        "_value": "[missing]",
        "_uri": "http://www.kotus.fi/index.phtml?l=en&s=512"
      },
      "R1112": {
        "_value": "[missing]",
        "_uri": "http://www.kotus.fi/?l=en&s=207"
      },
      "R1113": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_country.asp?name=United+Kingdom"
      },
      "R1114": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/ybb"
      },
      "R1115": {
        "_value": "[missing]",
        "_uri": "http://www.jewish-languages.org/jewish-malayalam.html"
      },
      "R1116": {
        "_value": "CIA Factbook lists spoken language, the entry for Bokmål only on Svalbard and Jan Mayan is an assumption.",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/sv.html"
      },
      "R1117": {
        "_value": " http://www.bfs.admin.ch/bfs/portal/de/index/infothek/lexikon/bienvenue___login/blank/zugang_lexikon.Document.62669.xls",
        "_uri": "http://en.wikipedia.org/wiki/Romansh_language"
      },
      "R1118": "No literacy figure available for English in Madagascar; newly adopted official language; 5% is an estimate.",
      "R1119": {
        "_value": "- the script is an assumption, needs a reference",
        "_uri": "http://en.wikipedia.org/wiki/Kazakh_language"
      },
      "R1120": {
        "_value": "Latin script official, used 98.8% of pop * 10% for the usage figure",
        "_uri": "http://www.nvtc.gov/lotw/months/march/Azerbaijani.html#writ"
      },
      "R1121": {
        "_value": "Latin script official, used 98.8% of pop * 90% for the usage figure",
        "_uri": "http://www.nvtc.gov/lotw/months/march/Azerbaijani.html#writ"
      },
      "R1122": {
        "_value": "- five eastern provinces of the DRC are Swahili speaking. Nearly half the 66 million Congolese speak it.",
        "_uri": "http://en.wikipedia.org/wiki/Swahili_language"
      },
      "R1123": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Kazakh_language"
      },
      "R1124": {
        "_value": "estimate 20% of Algerians can use French",
        "_uri": "http://en.wikipedia.org/wiki/Algerian_language"
      },
      "R1125": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Alsatian_language"
      },
      "R1126": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=rwr"
      },
      "R1127": {
        "_value": "- Most educated Kenyans are able to communicate fluently in Swahili, since it is a compulsory subject in school",
        "_uri": "http://en.wikipedia.org/wiki/Swahili_language"
      },
      "R1128": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Gagauz_language"
      },
      "R1129": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=skr"
      },
      "R1130": {
        "_value": "- Education is in French; using literacy rate * pop for French-using population",
        "_uri": "http://en.wikipedia.org/wiki/R%C3%A9union"
      },
      "R1131": {
        "_value": "  English is the first language learned by half the children by the time they reach preschool age; using 92.6% of pop for the English figure",
        "_uri": "http://en.wikipedia.org/wiki/Singapore"
      },
      "R1132": {
        "_value": "- using pop * literacy rate",
        "_uri": "http://en.wikipedia.org/wiki/Tunisia#Language"
      },
      "R1133": {
        "_value": "- 90 percent of approximately 39 million Tanzanians speak Swahili",
        "_uri": "http://en.wikipedia.org/wiki/Swahili_language"
      },
      "R1134": {
        "_value": "- Baganda generally don't speak Swahili, but it is in common use among the 25 million people elsewhere in the country, and is currently being implemented in schools nationwide (use 75% of Cpop for this figure)",
        "_uri": "http://en.wikipedia.org/wiki/Swahili_language"
      },
      "R1135": {
        "_value": "Crude estimate based on import partner data. http://www.answers.com/topic/mauritania ",
        "_uri": "http://www.nationsonline.org/oneworld/mauritania.htm"
      },
      "R1136": {
        "_value": "also called Dogrib",
        "_uri": "http://en.wikipedia.org/wiki/Tlicho_Yatii_language"
      },
      "R1137": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/French_language"
      },
      "R1138": {
        "_value": "http://www.ofis-bzh.org/fr/langue_bretonne/chiffres_cles/index.php France blocks other languages in state schools; 1.4% attended Breton schools and 3% is estimated as family transmission rate",
        "_uri": "http://en.wikipedia.org/wiki/Breton_language"
      },
      "R1139": "As with IE, we have to adjust the figures for real usage  ",
      "R1140": {
        "_value": "The 2008 estimate is ~2000 speakers due to revival efforts",
        "_uri": "http://en.wikipedia.org/wiki/Cornish_language"
      },
      "R1141": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Hausa_people"
      },
      "R1142": {
        "_value": "The great majority of Equatorial Guineans speak Spanish, especially those living in the capital, Malabo. Spanish has been an official language since 1844.",
        "_uri": "http://en.wikipedia.org/wiki/Equatorial-guinea#Official-languages"
      },
      "R1143": "Hans literacy is unknown; set to 5% artificially pending better or official figures.",
      "R1144": {
        "_value": "http://www.statemaster.com/encyclopedia/Balinese-language widely used; taught in school as a main lang",
        "_uri": "http://yamiproject.cs.pu.edu.tw/yami/conference/paper/015.pdf"
      },
      "R1145": {
        "_value": "widely used in its cultural areas, often in Latin script",
        "_uri": "http://en.wikipedia.org/wiki/Buginese_language"
      },
      "R1146": {
        "_value": "http://www.indianetzone.com/7/haryanvi.htm little literature mostly folksongs; writers use std Hindi; claim of 55% literacy",
        "_uri": "http://en.wikipedia.org/wiki/Haryanvi"
      },
      "R1147": {
        "_value": "2nd lang literacy 25-50%, taught formally",
        "_uri": "http://www.ethnologue.com/language/bbj"
      },
      "R1148": "5% writing pop estimated in absence of other data; literacy rate reported at 12%",
      "R1149": "5% writing pop estimated in absence of other data; literacy rate reported at ~8%",
      "R1150": "No estimate available.",
      "R1151": "5% writing pop estimated in absence of other data; Japanese is lingua franca here",
      "R1152": {
        "_value": "[missing]",
        "_uri": "http://www.chass.utoronto.ca/~cpercy/courses/6362-chiba.htm"
      },
      "R1153": "Data completely unknown for Hausa in Arabic in Nigeria",
      "R1154": {
        "_value": "almost all speakers bilingual in English",
        "_uri": "http://en.wikipedia.org/wiki/Nauru_language"
      },
      "R1155": {
        "_value": "Pop decline to ~1398 in 2009",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/NE.html"
      },
      "R1156": {
        "_value": "Low literacy, high linguistic diversity; English official (govt) but not widely spoken",
        "_uri": "http://en.wikipedia.org/wiki/Papua_New_Guinea"
      },
      "R1157": {
        "_value": "[missing]",
        "_uri": "http://www.census.gov.ph/data/sectordata/sr05153tx.html"
      },
      "R1158": {
        "_value": "Spoken by 70% of population, assumed to use Arabic script in Pakistan",
        "_uri": "http://en.wikipedia.org/wiki/Languages_of_Pakistan#Punjabi"
      },
      "R1159": {
        "_value": "Reported to be (regional) official in Chuvashia, central Russia: taught at schools. However: http://cv.wikipedia.org/ Chuvash Wikipedia on-line.",
        "_uri": "http://en.wikipedia.org/wiki/Chuvash_language#Language_use"
      },
      "R1160": {
        "_value": "http://www.mavicanet.com/directory/eng/2436.html ",
        "_uri": "http://www.flw.com/languages/creoleseychelles.htm"
      },
      "R1161": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/African_French"
      },
      "R1162": {
        "_value": "'A lingua franca and a first language for 10% of the population but understood by 95%' http://en.wikipedia.org/wiki/Krio_language",
        "_uri": "https://www.cia.gov/cia/publications/factbook/fields/2098.html"
      },
      "R1163": {
        "_value": "Dutch is spoken as a mother tongue by about 60% of the Surinamese, while most others speak it as a second or third language.",
        "_uri": "http://en.wikipedia.org/wiki/Suriname#Languages"
      },
      "R1164": {
        "_value": "main language of trade and comm. in Isan region, except ... media where it gives way to Thai; now largely an unwritten language. 10% writing pop estimated in absence of other data",
        "_uri": "http://en.wikipedia.org/wiki/Isan_language"
      },
      "R1165": {
        "_value": "- primarily written using an Arabic-derived alphabet",
        "_uri": "http://en.wikipedia.org/wiki/Uyghur_language"
      },
      "R1166": "US 2005 census ",
      "R1167": {
        "_value": "understood by 10 million, perhaps. Figure is questionable writing pop artificially set to 5% see also: http://en.wikipedia.org/wiki/Low_German (understood by 10 million people, and native to about 3 million people all around northern Germany)",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=nds"
      },
      "R1168": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Wallis_and_futuna#Languages"
      },
      "R1169": {
        "_value": "See the 2006 language survey data for 2nd langs = Shimaore",
        "_uri": "http://en.wikipedia.org/wiki/Mayotte#Languages"
      },
      "R1170": {
        "_value": "See the 2006 language survey data for 2nd langs",
        "_uri": "http://en.wikipedia.org/wiki/Mayotte#Languages"
      },
      "R1171": "Common lingua franca, widely used. High literacy.",
      "R1172": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/North_Slavey"
      },
      "R1173": {
        "_value": "300 speakers out of 1100 pop; 1998 census shows 770",
        "_uri": "http://en.wikipedia.org/wiki/Gwichin_language"
      },
      "R1174": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=ksh"
      },
      "R1175": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Saho_language"
      },
      "R1176": {
        "_value": "98.8% speak Spanish. Also, https://www.cia.gov/library/publications/the-world-factbook/geos/sp.html",
        "_uri": "http://en.wikipedia.org/wiki/Spanish_language#Spain"
      },
      "R1177": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/sp.html"
      },
      "R1178": {
        "_value": "No indigenous inhabitants. http://en.wikipedia.org/wiki/Heard_Island_and_McDonald_Islands",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/sx.html"
      },
      "R1179": {
        "_value": "No indigenous inhabitants. http://en.wikipedia.org/wiki/British_Indian_Ocean_Territory",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/io.html"
      },
      "R1180": {
        "_value": "Many also use Swahili",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=saq"
      },
      "R1181": {
        "_value": "Latin is not shown as being used, rather Arabic",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=shi"
      },
      "R1182": {
        "_value": "Used in schools up to University.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=naq"
      },
      "R1183": {
        "_value": "Also called Sakha.",
        "_uri": "http://en.wikipedia.org/wiki/Sakha_language"
      },
      "R1184": {
        "_value": "No indigenous inhabitants. http://en.wikipedia.org/wiki/French_Southern_Territories",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/fs.html"
      },
      "R1185": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/tl.html"
      },
      "R1186": {
        "_value": "Shows 50% literacy",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=mas"
      },
      "R1187": {
        "_value": "Most also use Swahili with 50% literacy. Only 5% monolingual.",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=asa"
      },
      "R1188": {
        "_value": "Most also use Swahili",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=lag"
      },
      "R1189": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Rombo_language"
      },
      "R1190": {
        "_value": "basically unihabited, officially ; http://www.census.gov/prod/cen2000/phc3-us-pt1.pdf",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/UM.html"
      },
      "R1191": {
        "_value": "http://lanic.utexas.edu/project/tilan/reports/rtf359/bolivia1.html Spanish is the official language, only about 60-70% of the population speaks it at all ;",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/bl.html"
      },
      "R1192": {
        "_value": "Spanish \\\"\\\"universal\\\"\\\", set to 98%",
        "_uri": "http://en.wikipedia.org/wiki/Demographics_of_Chile#Languages"
      },
      "R1193": {
        "_value": "https://www.cia.gov/library/publications/the-world-factbook/geos/cs.html",
        "_uri": "http://en.wikipedia.org/wiki/Costa_Rica"
      },
      "R1194": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Languages_of_Canada"
      },
      "R1195": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/in.html"
      },
      "R1196": {
        "_value": "Sirmauri (srx) Mahasui = Himachali, Pahari, Sirmouri, Sirmuri",
        "_uri": "http://www.himachalonline.com/temp/languages.htm"
      },
      "R1197": {
        "_value": "- 14k reported as native. Taught as elective subject in grades 5-8; not widely spoken as primary communication.",
        "_uri": "http://en.wikipedia.org/wiki/Sanskrit"
      },
      "R1198": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=zdj"
      },
      "R1199": {
        "_value": "More than 80 % of the total Thai population speaks the native Thai language. ",
        "_uri": "http://www.mapsofworld.com/thailand/geography/demographics.html"
      },
      "R1200": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Russian_language_in_Ukraine"
      },
      "R1201": "native speaker pop is low, ~6200; but is most widely spoken 2nd language",
      "R1202": {
        "_value": "[missing]",
        "_uri": "http://ec.europa.eu/public_opinion/archives/ebs/ebs_243_en.pdf"
      },
      "R1203": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/nz.html"
      },
      "R1204": {
        "_value": "(94% of studends in Russia receive primarily Russian-language ed)",
        "_uri": "http://en.wikipedia.org/wiki/Russian_language"
      },
      "R1205": {
        "_value": "Europeans and their languages survey, page 7",
        "_uri": "http://ec.europa.eu/public_opinion/archives/ebs/ebs_243_en.pdf"
      },
      "R1206": {
        "_value": "http://ec.europa.eu/public_opinion/archives/ebs/ebs_243_en.pdf Europeans and their languages survey, page 7",
        "_uri": "http://en.wikipedia.org/wiki/Turkish_language#Geographic_distribution"
      },
      "R1207": {
        "_value": "[missing]",
        "_uri": "http://www12.statcan.ca/census-recensement/2006/dp-pd/tbt/Rp-eng.cfm?LANG=E&APATH=3&DETAIL=0&DIM=0&FL=A&FREE=0&GC=0&GID=837928&GK=0&GRP=1&PID=89189&PRID=0&PTYPE=88971,97154&S=0&SHOWALL=0&SUB=0&Temporal=2006&THEME=70&VID=0&VNAMEE=&VNAMEF="
      },
      "R1208": {
        "_value": "1st lang literacy 8%",
        "_uri": "http://www.ethnologue.com/language/nnh"
      },
      "R1209": {
        "_value": "low literacy",
        "_uri": "http://www.ethnologue.com/language/bgn"
      },
      "R1210": "percentage calculated from http://www.spanishcourses.info/Mains/SpanishSpoken_EN.htm , see also http://www.spanishseo.org/resources/worldwide-spanish-speaking-population",
      "R1211": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/gr.html"
      },
      "R1212": "www.amar.org.ir",
      "R1213": {
        "_value": "- regional lang community status, taught in some schools",
        "_uri": "http://ec.europa.eu/education/languages/archive/languages/langmin/euromosaic/pol3-en.html"
      },
      "R1214": {
        "_value": "- 52.9% of Tatarstan is ethnic Tatar, the pop figure is an upper bound",
        "_uri": "http://www.tatar.ru/"
      },
      "R1215": " http://en.wikipedia.org/wiki/Interlingua#Community Has a regular conf in Sweden, also Brazil; an auxiliary language with tiny population worldwide",
      "R1217": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/bkm"
      },
      "R1218": {
        "_value": "(could be higher if 2nd lang included; no data yet)",
        "_uri": "http://en.wikipedia.org/wiki/Vietnamese_language"
      },
      "R1219": "Mainly in Guangdong Prov, ~70-80 million",
      "R1220": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/18/language/knf/"
      },
      "R1221": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/cc.html"
      },
      "R1222": {
        "_value": "pop 7k. Figure is questionable writing pop artificially set to 5% see also http://en.wikipedia.org/wiki/Lower_Sorbian",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=dsb"
      },
      "R1223": {
        "_value": "Tigrinya ethnic pop is about 60%",
        "_uri": "http://en.wikipedia.org/wiki/Eritrea#Languages"
      },
      "R1224": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Blin_language"
      },
      "R1225": {
        "_value": "English official in education, 36.1% 2000 census",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/gh.html"
      },
      "R1226": {
        "_value": "no other info available for now",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=saf"
      },
      "R1227": {
        "_value": "https://www.cia.gov/cia/publications/factbook/geos/gt.html Spanish official",
        "_uri": "http://en.wikipedia.org/wiki/Guatemala#Language"
      },
      "R1228": {
        "_value": "language also called Kamta in India",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=rkt"
      },
      "R1229": {
        "_value": "Modern use of Arabic (Jawi) seems to be minimal, but is co-official with ms; set to 5% for now.",
        "_uri": "http://en.wikipedia.org/wiki/Languages_of_Brunei"
      },
      "R1230": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Khmu_language"
      },
      "R1231": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Kuy_language"
      },
      "R1232": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=rjs"
      },
      "R1233": {
        "_value": "census data",
        "_uri": "http://www.gks.ru/free_doc/new_site/population/demo/per-itog/tab6.xls"
      },
      "R1234": {
        "_value": "- source for GDP",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/su.html"
      },
      "R1235": {
        "_value": "- source for GDP Level of English usage unclear, but official for govt and education",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/su.html"
      },
      "R1236": {
        "_value": "- estimate 90%of literate pop can use Arabic; Lpop = 99%",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/so.html"
      },
      "R1237": {
        "_value": "http://en.wikipedia.org/wiki/South_Sudan",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/od.html"
      },
      "R1238": {
        "_value": "[missing]",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/sk.html"
      },
      "R1239": {
        "_value": "low literacy and >120 langs in country",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/cd.html"
      },
      "R1240": {
        "_value": "(used lower figure)",
        "_uri": "http://www.lakhota.org/html/status2.html"
      },
      "R1241": {
        "_value": "25-50% literacy",
        "_uri": "http://www.ethnologue.com/language/bas"
      },
      "R1242": {
        "_value": "literacy 15-25%",
        "_uri": "http://www.ethnologue.com/language/byv"
      },
      "R1243": {
        "_value": "30% literacy",
        "_uri": "http://www.ethnologue.com/language/bfd"
      },
      "R1244": {
        "_value": "2nd lang literacy 30%",
        "_uri": "http://www.ethnologue.com/language/bss"
      },
      "R1245": {
        "_value": "2nd lang literacy 25-50%",
        "_uri": "http://www.ethnologue.com/language/dua"
      },
      "R1246": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/nmg"
      },
      "R1247": "protected minority, southern Jutland",
      "R1248": "etimate only based on literacy; no population data currently available",
      "R1249": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Yiddish_language#Numbers_of_speakers"
      },
      "R1250": "No Data Available at present.",
      "R1251": "co-official in South Tyrol",
      "R1252": "Aosta Valley",
      "R1253": "in Trieste and  Gorizia",
      "R1254": {
        "_value": "[missing]",
        "_uri": "http://unicode.org/cldr/trac/attachment/ticket/5887/zgh-ISO639-2-certif.pdf"
      },
      "R1255": "Information on the Latin/Cyrillic script percentages for Montenegro not currently found.",
      "R1256": {
        "_value": "most of population use Afrikaans commonly, about 89% literacy",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/wa.html"
      },
      "R1257": {
        "_value": "CIA Factbook entry on Kazakhstan http://windowoneurasia2.blogspot.com/2013/12/window-on-eurasia-de-russianization.html http://www.stoletie.ru/vzglyad/derusifikacija_nabirajet_oboroty_934.htm http://www.stoletie.ru/vzglyad/derusifikacija_nabirajet_oboroty_934.htm",
        "_uri": "https://www.cia.gov/cia/publications/factbook/geos/kz.html"
      },
      "R1258": {
        "_value": ", Podlaskie Voivodeship ",
        "_uri": "http://en.wikipedia.org/wiki/Lithuanian_minority_in_Poland"
      },
      "R1259": "official in Vojvodina only",
      "R1260": "official in Vojvodina only; no pop data yet found",
      "R1261": {
        "_value": "regional in Dagestan, population estimate",
        "_uri": "http://en.wikipedia.org/wiki/Azerbaijanis_in_Russia"
      },
      "R1262": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Languages_of_the_United_States#Yiddish"
      },
      "R1263": {
        "_value": "https://www.cia.gov/library/publications/the-world-factbook/geos/uz.html Latin/Cyrillic balance is estimated, based on literacy; younger education now in Latin",
        "_uri": "http://en.wikipedia.org/wiki/Uzbek_language#Writing_systems"
      },
      "R1264": "Information on the Latin/Cyrillic script percentages for Kosovo not currently found.",
      "R1265": "Estimate based on 90% of literate pop > 15 years (71% of Cpop) can use English, for lack of official number of users",
      "R1266": {
        "_value": "low litreracy ~5%",
        "_uri": "http://www.ethnologue.com/language/mgh"
      },
      "R1267": {
        "_value": "2nd lang literacy 30%",
        "_uri": "http://www.ethnologue.com/language/jgo"
      },
      "R1269": {
        "_value": "recognized in West Java",
        "_uri": "https://en.wikipedia.org/wiki/Sundanese_language"
      },
      "R1270": "Mainly unwritten",
      "R1271": "Vai script is the main script for this language.",
      "R1272": "Latin listed as being used (Scriptsource) but no pop figures available.",
      "R1273": {
        "_value": "and https://en.wikipedia.org/wiki/Macau",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/mc.html"
      },
      "R1274": {
        "_value": "but no literacy data",
        "_uri": "http://www.ethnologue.com/language/mgh"
      },
      "R1275": {
        "_value": "Including 1st and 2nd lang speakers",
        "_uri": "http://www.ethnologue.com/language/pcm"
      },
      "R1276": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=bin"
      },
      "R1277": {
        "_value": "regional-official in part of Opole Voivodeship; in Poland 325 schools with primary instr in German, estimate 37000 students. Real figure probably higher.",
        "_uri": "http://en.wikipedia.org/wiki/German_minority_in_Poland"
      },
      "R1278": {
        "_value": "Census figures cited there seem to put Armenian using pop between 50-75%. Using 50%.",
        "_uri": "https://en.wikipedia.org/wiki/Armenians_in_Russia"
      },
      "R1279": {
        "_value": "[missing]",
        "_uri": "https://en.wikipedia.org/wiki/Religion_in_russia#Russian_Orthodoxy"
      },
      "R1280": {
        "_value": "unknown literacy",
        "_uri": "http://www.ethnologue.com/language/nus"
      },
      "R1281": {
        "_value": "only 10% monolingual",
        "_uri": "http://www.ethnologue.com/language/dyo"
      },
      "R1282": {
        "_value": "near zero literacy; pop ~80000 (2009) see David Lawrence, Tanzania and its People, page 121, Google books",
        "_uri": "http://www.ethnologue.com/language/sbp"
      },
      "R1283": {
        "_value": "(baseline)",
        "_uri": "http://www.ethnologue.com/language/ACH/"
      },
      "R1284": {
        "_value": "No population figure yet on use of Latin in Vatican. Estimate 100% of Vatican residents can use Latin.",
        "_uri": "http://news.bbc.co.uk/2/hi/europe/4475099.stm"
      },
      "R1285": {
        "_value": "[missing]",
        "_uri": "https://en.wikipedia.org/wiki/Lozi_language"
      },
      "R1286": "No figures available for this language.  Estimating at 5%.",
      "R1287": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Mapuche_language"
      },
      "R1288": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Quechua_language"
      },
      "R1289": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/K'iche'_language"
      },
      "R1290": {
        "_value": "- near-zero Azeri population in last census http://en.wikipedia.org/wiki/Azerbaijanis_in_Armenia#Current_situation",
        "_uri": "http://en.wikipedia.org/wiki/Census_in_Armenia"
      },
      "R1291": "No figures available for breakdown of Latin vs. N'Ko for Bambara.  The 2% figure is an estimate.",
      "R1292": {
        "_value": "pop 13k. Figure is questionable writing pop artificially set to 5% see also http://en.wikipedia.org/wiki/Upper_Sorbian",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=hsb"
      },
      "R1293": {
        "_value": "French mostly used in commerce",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=kab"
      },
      "R1294": "Indonesia high literacy; low written use of local languages",
      "R1295": {
        "_value": "- est 50% pop of Veneto area",
        "_uri": "http://www.orbilat.com/Languages/Venetan/Venetan.html"
      },
      "R1296": "5% mainly spoken",
      "R1297": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Wolof_language"
      },
      "R1298": "​http://www.interlingua.com/statutos leading Interlingua assoc (Union Mundial pro Interlingua) registered French non-profit - real user pop figure is unknown but low",
      "R1299": {
        "_value": "[missing]",
        "_uri": "http://en.wikipedia.org/wiki/Fiji_Hindi"
      },
      "R1300": {
        "_value": "Moribund language",
        "_uri": "http://www.ethnologue.com/language/frs"
      },
      "R1301": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/lad"
      },
      "R1302": "Estimated. See http://en.wikipedia.org/wiki/Emilian_language",
      "R1303": "Estimate not available.",
      "R1304": {
        "_value": "[missing]",
        "_uri": "http://de.statista.com/statistik/daten/studie/1138/umfrage/fremdsprachenkenntnisse/"
      },
      "R1305": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/aln"
      },
      "R1306": {
        "_value": "[missing]",
        "_uri": "http://www.bevoelkerungsschutz-portal.de/SharedDocs/Downloads/DE/Broschueren/2008/Regional_und_Minderheitensprachen.pdf"
      },
      "R1307": {
        "_value": "Also called Moré",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=mos"
      },
      "R1308": {
        "_value": "Newly designated official, not so widely used",
        "_uri": "http://www.iwacu-burundi.org/blogs/english/english-is-now-official-language-of-burundi/"
      },
      "R1309": {
        "_value": "[missing]",
        "_uri": "https://en.wikipedia.org/wiki/Faroese_language"
      },
      "R1310": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/lrc"
      },
      "R1311": {
        "_value": "syr is a macrolang containing cld and aii)",
        "_uri": "http://www.ethnologue.com/show_language.asp?code=cld"
      },
      "R1312": {
        "_value": "[missing]",
        "_uri": "http://www.ethnologue.com/language/sdh"
      },
      "R1313": {
        "_value": "[missing]",
        "_uri": "https://www.ethnologue.com/language/wni"
      },
      "R1314": {
        "_value": "[missing]",
        "_uri": "http://www.axl.cefan.ulaval.ca/afrique/soudan.htm"
      },
      "R1315": {
        "_value": "[missing]",
        "_uri": "https://en.wikipedia.org/wiki/Languages_of_Brazil"
      },
      "R1316": {
        "_value": "[missing]",
        "_uri": "http://www.bfs.admin.ch/bfs/portal/en/index/themen/01/05/blank/key/sprachen.html"
      },
      "R1317": "This is base pop for \\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"fub\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\" lang code; ff shows as a macrolanguage",
      "R1318": {
        "_value": "Widely spoken less written, and most speakers know standard German as well",
        "_uri": "https://en.wikipedia.org/wiki/Bavarian_language"
      },
      "R1319": {
        "_value": "[missing]",
        "_uri": "http://nso.gov.mt/en/publicatons/Publications_by_Unit/Documents/C1_Living_Conditions_and_Culture_Statistics/Culture_Participation_Survey_2011.pdf"
      },
      "R1320": {
        "_value": "and https://www.ethnologue.com/language/yue",
        "_uri": "https://www.cia.gov/library/publications/the-world-factbook/geos/hk.html"
      },
      "R1321": {
        "_value": "[missing]",
        "_uri": "https://en.wikipedia.org/wiki/Portuguese_Luxembourger"
      },
      "R1322": {
        "_value": "[missing]",
        "_uri": "https://en.wikipedia.org/wiki/Doteli_language"
      },
      "R1323": {
        "_value": "[missing]",
        "_uri": "https://en.wikipedia.org/wiki/Immigration_to_Portugal#Immigration"
      },
      "R1324": {
        "_value": "[missing]",
        "_uri": "http://2001.ukrcensus.gov.ua/eng/results/general/nationality/"
      },
      "R1325": {
        "_value": "http://en.wikipedia.org/wiki/Akademio_Internacia_de_la_Sciencoj_San_Marino - estimate 100% of the academy can use Esperanto; the language is used as 1st language of instruction; academy has 300 \\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"members\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\"\\\".",
        "_uri": "http://en.wikipedia.org/wiki/Esperanto"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "territoryContainment": {
      "142": {
        "_contains": ["145", "143", "030", "034", "035"]
      },
      "143": {
        "_contains": ["TM", "TJ", "KG", "KZ", "UZ"]
      },
      "145": {
        "_contains": ["AE", "AM", "AZ", "BH", "CY", "GE", "IL", "IQ", "JO", "KW", "LB", "OM", "PS", "QA", "SA", "SY", "TR", "YE"]
      },
      "150": {
        "_contains": ["154", "155", "151", "039"]
      },
      "151": {
        "_contains": ["BG", "BY", "CZ", "HU", "MD", "PL", "RO", "RU", "SK", "UA"]
      },
      "154": {
        "_contains": ["GG", "IM", "JE", "AX", "DK", "EE", "FI", "FO", "GB", "IE", "IS", "LT", "LV", "NO", "SE", "SJ"]
      },
      "155": {
        "_contains": ["AT", "BE", "CH", "DE", "FR", "LI", "LU", "MC", "NL"]
      },
      "202": {
        "_contains": ["011", "017", "014", "018"],
        "_grouping": "true"
      },
      "419": {
        "_contains": ["013", "029", "005"],
        "_grouping": "true"
      },
      "001": {
        "_contains": ["019", "002", "150", "142", "009"]
      },
      "001-status-deprecated": {
        "_contains": ["QU"]
      },
      "001-status-grouping": {
        "_contains": ["EU", "EZ", "UN"]
      },
      "002": {
        "_contains": ["015", "011", "017", "014", "018"]
      },
      "002-status-grouping": {
        "_contains": ["202"]
      },
      "003": {
        "_contains": ["021", "013", "029"],
        "_grouping": "true"
      },
      "005": {
        "_contains": ["AR", "BO", "BR", "BV", "CL", "CO", "EC", "FK", "GF", "GS", "GY", "PE", "PY", "SR", "UY", "VE"]
      },
      "009": {
        "_contains": ["053", "054", "057", "061", "QO"]
      },
      "011": {
        "_contains": ["BF", "BJ", "CI", "CV", "GH", "GM", "GN", "GW", "LR", "ML", "MR", "NE", "NG", "SH", "SL", "SN", "TG"]
      },
      "013": {
        "_contains": ["BZ", "CR", "GT", "HN", "MX", "NI", "PA", "SV"]
      },
      "014": {
        "_contains": ["BI", "DJ", "ER", "ET", "IO", "KE", "KM", "MG", "MU", "MW", "MZ", "RE", "RW", "SC", "SO", "SS", "TF", "TZ", "UG", "YT", "ZM", "ZW"]
      },
      "015": {
        "_contains": ["DZ", "EG", "EH", "LY", "MA", "SD", "TN", "EA", "IC"]
      },
      "017": {
        "_contains": ["AO", "CD", "CF", "CG", "CM", "GA", "GQ", "ST", "TD"]
      },
      "017-status-deprecated": {
        "_contains": ["ZR"]
      },
      "018": {
        "_contains": ["BW", "LS", "NA", "SZ", "ZA"]
      },
      "019": {
        "_contains": ["021", "013", "029", "005"]
      },
      "019-status-grouping": {
        "_contains": ["003", "419"]
      },
      "021": {
        "_contains": ["BM", "CA", "GL", "PM", "US"]
      },
      "029": {
        "_contains": ["AG", "AI", "AW", "BB", "BL", "BQ", "BS", "CU", "CW", "DM", "DO", "GD", "GP", "HT", "JM", "KN", "KY", "LC", "MF", "MQ", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"]
      },
      "029-status-deprecated": {
        "_contains": ["AN"]
      },
      "030": {
        "_contains": ["CN", "HK", "JP", "KP", "KR", "MN", "MO", "TW"]
      },
      "034": {
        "_contains": ["AF", "BD", "BT", "IN", "IR", "LK", "MV", "NP", "PK"]
      },
      "035": {
        "_contains": ["BN", "ID", "KH", "LA", "MM", "MY", "PH", "SG", "TH", "TL", "VN"]
      },
      "035-status-deprecated": {
        "_contains": ["BU", "TP"]
      },
      "039": {
        "_contains": ["AD", "AL", "BA", "ES", "GI", "GR", "HR", "IT", "ME", "MK", "MT", "RS", "PT", "SI", "SM", "VA", "XK"]
      },
      "039-status-deprecated": {
        "_contains": ["CS", "YU"]
      },
      "053": {
        "_contains": ["AU", "CC", "CX", "HM", "NF", "NZ"]
      },
      "054": {
        "_contains": ["FJ", "NC", "PG", "SB", "VU"]
      },
      "057": {
        "_contains": ["FM", "GU", "KI", "MH", "MP", "NR", "PW", "UM"]
      },
      "061": {
        "_contains": ["AS", "CK", "NU", "PF", "PN", "TK", "TO", "TV", "WF", "WS"]
      },
      "145-status-deprecated": {
        "_contains": ["NT", "YD"]
      },
      "151-status-deprecated": {
        "_contains": ["SU"]
      },
      "155-status-deprecated": {
        "_contains": ["DD", "FX"]
      },
      "EU": {
        "_contains": ["AT", "BE", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "SE", "SI", "SK", "BG", "RO"],
        "_grouping": "true"
      },
      "EZ": {
        "_contains": ["AT", "BE", "CY", "DE", "EE", "ES", "FI", "FR", "GR", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PT", "SI", "SK"],
        "_grouping": "true"
      },
      "QO": {
        "_contains": ["AQ", "AC", "CP", "DG", "TA"]
      },
      "UN": {
        "_contains": ["AD", "AE", "AF", "AG", "AL", "AM", "AO", "AR", "AT", "AU", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BN", "BO", "BR", "BS", "BT", "BW", "BY", "BZ", "CA", "CD", "CF", "CG", "CH", "CI", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "ER", "ES", "ET", "FI", "FJ", "FM", "FR", "GA", "GB", "GD", "GE", "GH", "GM", "GN", "GQ", "GR", "GT", "GW", "GY", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IN", "IQ", "IR", "IS", "IT", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MG", "MH", "MK", "ML", "MM", "MN", "MR", "MT", "MU", "MV", "MX", "MW", "MY", "MZ", "NA", "NE", "NG", "NI", "NL", "NO", "NR", "NP", "NZ", "OM", "PA", "PE", "PG", "PH", "PK", "PL", "PT", "PW", "PY", "QA", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SI", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SY", "SZ", "TD", "TG", "TH", "TJ", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TZ", "UA", "UG", "US", "UY", "UZ", "VC", "VE", "VN", "VU", "WS", "YE", "ZA", "ZM", "ZW"],
        "_grouping": "true"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "territoryInfo": {
      "AC": {
        "_gdp": "42230000",
        "_literacyPercent": "99",
        "_population": "940",
        "languagePopulation": {
          "en": {
            "_populationPercent": "99"
          }
        }
      },
      "AD": {
        "_gdp": "3327000000",
        "_literacyPercent": "100",
        "_population": "85708",
        "languagePopulation": {
          "ca": {
            "_populationPercent": "51",
            "_officialStatus": "official"
          },
          "es": {
            "_populationPercent": "43"
          },
          "fr": {
            "_populationPercent": "6.7"
          }
        }
      },
      "AE": {
        "_gdp": "696000000000",
        "_literacyPercent": "90",
        "_population": "9701320",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "78",
            "_officialStatus": "official"
          },
          "bal": {
            "_populationPercent": "2.3"
          },
          "en": {
            "_populationPercent": "50"
          },
          "fa": {
            "_populationPercent": "1.9"
          },
          "ml": {
            "_populationPercent": "7"
          },
          "ps": {
            "_populationPercent": "2.9"
          }
        }
      },
      "AF": {
        "_gdp": "69450000000",
        "_literacyPercent": "28.1",
        "_population": "34940800",
        "languagePopulation": {
          "bal": {
            "_populationPercent": "0.67",
            "_officialStatus": "official_regional"
          },
          "bgn": {
            "_writingPercent": "5",
            "_populationPercent": "0.63"
          },
          "fa": {
            "_populationPercent": "50",
            "_officialStatus": "official"
          },
          "haz": {
            "_populationPercent": "5.9"
          },
          "kk_Arab": {
            "_populationPercent": "0.0057"
          },
          "prd": {
            "_populationPercent": "1.2"
          },
          "ps": {
            "_populationPercent": "43",
            "_officialStatus": "official"
          },
          "tk": {
            "_populationPercent": "1.7",
            "_officialStatus": "official_regional"
          },
          "ug": {
            "_populationPercent": "0.0086"
          },
          "uz_Arab": {
            "_populationPercent": "4.7",
            "_officialStatus": "official_regional"
          }
        }
      },
      "AG": {
        "_gdp": "2398000000",
        "_literacyPercent": "99",
        "_population": "95882",
        "languagePopulation": {
          "en": {
            "_populationPercent": "86",
            "_officialStatus": "official"
          },
          "pt": {
            "_populationPercent": "1.7"
          }
        }
      },
      "AI": {
        "_gdp": "175400000",
        "_literacyPercent": "95",
        "_population": "17422",
        "languagePopulation": {
          "en": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "AL": {
        "_gdp": "36010000000",
        "_literacyPercent": "96.8",
        "_population": "3057220",
        "languagePopulation": {
          "el": {
            "_populationPercent": "1.9"
          },
          "mk": {
            "_populationPercent": "0.47"
          },
          "sq": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "AM": {
        "_gdp": "28340000000",
        "_literacyPercent": "99.6",
        "_population": "3038220",
        "languagePopulation": {
          "az": {
            "_populationPercent": "0"
          },
          "hy": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          },
          "ku": {
            "_populationPercent": "3.3"
          }
        }
      },
      "AO": {
        "_gdp": "193600000000",
        "_literacyPercent": "70.4",
        "_population": "30355900",
        "languagePopulation": {
          "kmb": {
            "_populationPercent": "25",
            "_literacyPercent": "10"
          },
          "ln": {
            "_populationPercent": "0.67"
          },
          "pt": {
            "_populationPercent": "67",
            "_officialStatus": "official"
          },
          "umb": {
            "_populationPercent": "29"
          }
        }
      },
      "AQ": {
        "_gdp": "17760000",
        "_literacyPercent": "99",
        "_population": "300",
        "languagePopulation": {
          "und": {
            "_populationPercent": "100"
          }
        }
      },
      "AR": {
        "_gdp": "922100000000",
        "_literacyPercent": "97.9",
        "_population": "44694200",
        "languagePopulation": {
          "cy": {
            "_populationPercent": "0.065"
          },
          "en": {
            "_populationPercent": "7"
          },
          "es": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "gn": {
            "_populationPercent": "0.047"
          }
        }
      },
      "AS": {
        "_gdp": "658000000",
        "_literacyPercent": "97",
        "_population": "50826",
        "languagePopulation": {
          "en": {
            "_populationPercent": "97",
            "_officialStatus": "de_facto_official"
          },
          "sm": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          }
        }
      },
      "AT": {
        "_gdp": "441000000000",
        "_literacyPercent": "98",
        "_population": "8793370",
        "languagePopulation": {
          "bar": {
            "_populationPercent": "95"
          },
          "de": {
            "_populationPercent": "97",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "73"
          },
          "fr": {
            "_populationPercent": "11"
          },
          "hr": {
            "_populationPercent": "1.2",
            "_officialStatus": "official_regional"
          },
          "hu": {
            "_populationPercent": "0.27",
            "_officialStatus": "official_regional"
          },
          "it": {
            "_populationPercent": "9"
          },
          "sl": {
            "_populationPercent": "0.37",
            "_officialStatus": "official_regional"
          }
        }
      },
      "AU": {
        "_gdp": "1248000000000",
        "_literacyPercent": "99",
        "_population": "23470100",
        "languagePopulation": {
          "en": {
            "_populationPercent": "96",
            "_officialStatus": "de_facto_official"
          },
          "it": {
            "_populationPercent": "1.9"
          },
          "wbp": {
            "_populationPercent": "0.011"
          },
          "zh_Hant": {
            "_populationPercent": "2.1"
          }
        }
      },
      "AW": {
        "_gdp": "4158000000",
        "_literacyPercent": "96.8",
        "_population": "116576",
        "languagePopulation": {
          "en": {
            "_populationPercent": "2.6"
          },
          "nl": {
            "_populationPercent": "97",
            "_officialStatus": "official"
          },
          "pap": {
            "_populationPercent": "61",
            "_officialStatus": "official"
          }
        }
      },
      "AX": {
        "_gdp": "929800000",
        "_literacyPercent": "100",
        "_population": "26200",
        "languagePopulation": {
          "sv": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          }
        }
      },
      "AZ": {
        "_gdp": "172200000000",
        "_literacyPercent": "99.8",
        "_population": "10046500",
        "languagePopulation": {
          "az": {
            "_populationPercent": "89",
            "_officialStatus": "official"
          },
          "az_Cyrl": {
            "_populationPercent": "9.9",
            "_officialStatus": "official"
          },
          "ku": {
            "_populationPercent": "0.24"
          },
          "tkr": {
            "_populationPercent": "0.16"
          },
          "tly": {
            "_populationPercent": "9.8"
          },
          "ttt": {
            "_populationPercent": "0.22"
          }
        }
      },
      "BA": {
        "_gdp": "44830000000",
        "_literacyPercent": "98",
        "_population": "3849890",
        "languagePopulation": {
          "bs": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "bs_Cyrl": {
            "_writingPercent": "5",
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "45"
          },
          "hr": {
            "_populationPercent": "12",
            "_officialStatus": "official"
          },
          "sr": {
            "_populationPercent": "10",
            "_officialStatus": "official"
          },
          "sr_Latn": {
            "_writingPercent": "5",
            "_populationPercent": "10",
            "_officialStatus": "official"
          }
        }
      },
      "BB": {
        "_gdp": "5218000000",
        "_literacyPercent": "99.7",
        "_population": "293131",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "BD": {
        "_gdp": "690300000000",
        "_literacyPercent": "57.7",
        "_population": "159453000",
        "languagePopulation": {
          "bn": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          },
          "ccp": {
            "_populationPercent": "0.22"
          },
          "en": {
            "_populationPercent": "18"
          },
          "grt": {
            "_populationPercent": "0.073"
          },
          "mni": {
            "_populationPercent": "0.011"
          },
          "mro": {
            "_populationPercent": "0.018"
          },
          "my": {
            "_populationPercent": "0.21"
          },
          "rkt": {
            "_populationPercent": "6.5",
            "_literacyPercent": "20"
          },
          "syl": {
            "_populationPercent": "5",
            "_literacyPercent": "35"
          }
        }
      },
      "BE": {
        "_gdp": "529200000000",
        "_literacyPercent": "99",
        "_population": "11570800",
        "languagePopulation": {
          "de": {
            "_populationPercent": "22",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "59"
          },
          "fr": {
            "_populationPercent": "38",
            "_officialStatus": "official"
          },
          "nl": {
            "_populationPercent": "55",
            "_officialStatus": "official"
          },
          "vls": {
            "_populationPercent": "10"
          },
          "wa": {
            "_writingPercent": "5",
            "_populationPercent": "5.8"
          }
        }
      },
      "BF": {
        "_gdp": "35850000000",
        "_literacyPercent": "28.7",
        "_population": "19742700",
        "languagePopulation": {
          "dyu": {
            "_populationPercent": "32"
          },
          "ff": {
            "_populationPercent": "0"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "fr": {
            "_populationPercent": "22",
            "_officialStatus": "official"
          },
          "mos": {
            "_populationPercent": "40"
          }
        }
      },
      "BG": {
        "_gdp": "153500000000",
        "_literacyPercent": "98.4",
        "_population": "7057500",
        "languagePopulation": {
          "bg": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "de": {
            "_populationPercent": "8"
          },
          "en": {
            "_populationPercent": "25"
          },
          "ru": {
            "_populationPercent": "23"
          },
          "tr": {
            "_populationPercent": "11"
          }
        }
      },
      "BH": {
        "_gdp": "71170000000",
        "_literacyPercent": "94.6",
        "_population": "1442660",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "87",
            "_officialStatus": "official"
          },
          "ml": {
            "_populationPercent": "3.3"
          }
        }
      },
      "BI": {
        "_gdp": "8007000000",
        "_literacyPercent": "67.2",
        "_population": "11844500",
        "languagePopulation": {
          "en": {
            "_populationPercent": "0.053",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "59",
            "_officialStatus": "official"
          },
          "rn": {
            "_populationPercent": "63",
            "_officialStatus": "official"
          },
          "sw": {
            "_populationPercent": "0.054"
          }
        }
      },
      "BJ": {
        "_gdp": "25390000000",
        "_literacyPercent": "42.4",
        "_population": "11340500",
        "languagePopulation": {
          "fon": {
            "_populationPercent": "25"
          },
          "fr": {
            "_populationPercent": "35",
            "_officialStatus": "official"
          },
          "yo": {
            "_populationPercent": "6.7"
          }
        }
      },
      "BL": {
        "_gdp": "255000000",
        "_literacyPercent": "99",
        "_population": "7160",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          }
        }
      },
      "BM": {
        "_gdp": "6127000000",
        "_literacyPercent": "98",
        "_population": "71176",
        "languagePopulation": {
          "en": {
            "_populationPercent": "92",
            "_officialStatus": "official"
          }
        }
      },
      "BN": {
        "_gdp": "33870000000",
        "_literacyPercent": "95.4",
        "_population": "450565",
        "languagePopulation": {
          "en": {
            "_populationPercent": "1.8"
          },
          "ms": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "ms_Arab": {
            "_populationPercent": "5",
            "_officialStatus": "official"
          },
          "zh_Hant": {
            "_populationPercent": "11"
          }
        }
      },
      "BO": {
        "_gdp": "83720000000",
        "_literacyPercent": "91.2",
        "_population": "11306300",
        "languagePopulation": {
          "aro": {
            "_populationPercent": "0.001"
          },
          "ay": {
            "_populationPercent": "20",
            "_officialStatus": "official"
          },
          "es": {
            "_populationPercent": "61",
            "_officialStatus": "official"
          },
          "gn": {
            "_populationPercent": "0.45"
          },
          "qu": {
            "_populationPercent": "32",
            "_officialStatus": "official"
          }
        }
      },
      "BQ": {
        "_gdp": "416400000",
        "_literacyPercent": "96",
        "_population": "20000",
        "languagePopulation": {
          "nl": {
            "_populationPercent": "8",
            "_officialStatus": "official"
          },
          "pap": {
            "_populationPercent": "81"
          }
        }
      },
      "BR": {
        "_gdp": "3248000000000",
        "_literacyPercent": "90.4",
        "_population": "208847000",
        "languagePopulation": {
          "de": {
            "_populationPercent": "0.84"
          },
          "en": {
            "_populationPercent": "8"
          },
          "es": {
            "_populationPercent": "0.037"
          },
          "gub": {
            "_populationPercent": "0.0084"
          },
          "it": {
            "_populationPercent": "0.28"
          },
          "ja": {
            "_populationPercent": "0.21"
          },
          "kgp": {
            "_populationPercent": "0.01"
          },
          "ko": {
            "_populationPercent": "0.021"
          },
          "pt": {
            "_populationPercent": "91",
            "_officialStatus": "official"
          },
          "xav": {
            "_populationPercent": "0.0048"
          },
          "yrl": {
            "_populationPercent": "0.0052"
          }
        }
      },
      "BS": {
        "_gdp": "12060000000",
        "_literacyPercent": "95.6",
        "_population": "332634",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "BT": {
        "_gdp": "7205000000",
        "_literacyPercent": "52.8",
        "_population": "766397",
        "languagePopulation": {
          "dz": {
            "_populationPercent": "47",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "11"
          },
          "lep": {
            "_populationPercent": "3.9"
          },
          "ne": {
            "_populationPercent": "17"
          },
          "tsj": {
            "_populationPercent": "15"
          }
        }
      },
      "BV": {
        "_gdp": "44930",
        "_literacyPercent": "99",
        "_population": "1",
        "languagePopulation": {
          "und": {
            "_populationPercent": "100"
          }
        }
      },
      "BW": {
        "_gdp": "39010000000",
        "_literacyPercent": "85.1",
        "_population": "2249100",
        "languagePopulation": {
          "af": {
            "_populationPercent": "0.27"
          },
          "en": {
            "_populationPercent": "81",
            "_officialStatus": "official"
          },
          "tn": {
            "_populationPercent": "62",
            "_officialStatus": "official"
          }
        }
      },
      "BY": {
        "_gdp": "179400000000",
        "_literacyPercent": "99.6",
        "_population": "9527540",
        "languagePopulation": {
          "be": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "12",
            "_officialStatus": "official"
          }
        }
      },
      "BZ": {
        "_gdp": "3218000000",
        "_literacyPercent": "76.9",
        "_population": "385854",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "es": {
            "_populationPercent": "28"
          }
        }
      },
      "CA": {
        "_gdp": "1774000000000",
        "_literacyPercent": "99",
        "_population": "35881700",
        "languagePopulation": {
          "atj": {
            "_populationPercent": "0.016"
          },
          "chp": {
            "_populationPercent": "0.0021"
          },
          "cr": {
            "_populationPercent": "0.11"
          },
          "crj": {
            "_populationPercent": "0.02"
          },
          "crk": {
            "_populationPercent": "0.11"
          },
          "crl": {
            "_populationPercent": "0.015"
          },
          "crm": {
            "_populationPercent": "0.013"
          },
          "csw": {
            "_populationPercent": "0.014"
          },
          "de": {
            "_populationPercent": "1.9"
          },
          "den": {
            "_populationPercent": "0.0064"
          },
          "dgr": {
            "_populationPercent": "0.0074"
          },
          "en": {
            "_populationPercent": "86",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "22",
            "_officialStatus": "official"
          },
          "gwi": {
            "_populationPercent": "0.0016"
          },
          "ikt": {
            "_populationPercent": "0.011",
            "_literacyPercent": "30",
            "_officialStatus": "official_regional"
          },
          "it": {
            "_populationPercent": "2"
          },
          "iu": {
            "_populationPercent": "0.042",
            "_literacyPercent": "30",
            "_officialStatus": "official_regional"
          },
          "iu_Latn": {
            "_populationPercent": "0.042",
            "_literacyPercent": "30",
            "_officialStatus": "official_regional"
          },
          "moe": {
            "_populationPercent": "0.033"
          },
          "moh": {
            "_populationPercent": "0.0098"
          },
          "nsk": {
            "_populationPercent": "0.0033"
          },
          "pdt": {
            "_populationPercent": "0.24"
          },
          "scs": {
            "_populationPercent": "0.0035"
          },
          "yi": {
            "_populationPercent": "0.045"
          }
        }
      },
      "CC": {
        "_gdp": "31690000",
        "_literacyPercent": "99",
        "_population": "596",
        "languagePopulation": {
          "en": {
            "_populationPercent": "17",
            "_officialStatus": "de_facto_official"
          },
          "ms_Arab": {
            "_populationPercent": "83"
          }
        }
      },
      "CD": {
        "_gdp": "68600000000",
        "_literacyPercent": "66.8",
        "_population": "85281000",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "3.8",
            "_officialStatus": "official"
          },
          "kg": {
            "_populationPercent": "1.5",
            "_officialStatus": "official_regional"
          },
          "ln": {
            "_populationPercent": "3.1",
            "_officialStatus": "official_regional"
          },
          "lol": {
            "_populationPercent": "0.61"
          },
          "lu": {
            "_populationPercent": "2.3"
          },
          "lua": {
            "_populationPercent": "9.6",
            "_officialStatus": "official_regional"
          },
          "rw": {
            "_populationPercent": "0.38"
          },
          "sw": {
            "_populationPercent": "50",
            "_officialStatus": "official_regional"
          }
        }
      },
      "CF": {
        "_gdp": "3390000000",
        "_literacyPercent": "56.6",
        "_population": "5745060",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "49",
            "_officialStatus": "official"
          },
          "ln": {
            "_populationPercent": "0.24"
          },
          "sg": {
            "_populationPercent": "49",
            "_officialStatus": "official"
          }
        }
      },
      "CG": {
        "_gdp": "29390000000",
        "_literacyPercent": "83.8",
        "_population": "5062020",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "84",
            "_officialStatus": "official"
          },
          "ln": {
            "_populationPercent": "2.4"
          }
        }
      },
      "CH": {
        "_gdp": "523100000000",
        "_literacyPercent": "99",
        "_population": "8292810",
        "languagePopulation": {
          "de": {
            "_populationPercent": "73",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "61"
          },
          "fr": {
            "_populationPercent": "21",
            "_officialStatus": "official"
          },
          "gsw": {
            "_writingPercent": "5",
            "_populationPercent": "65",
            "_officialStatus": "de_facto_official"
          },
          "it": {
            "_populationPercent": "4.3",
            "_officialStatus": "official"
          },
          "lmo": {
            "_writingPercent": "5",
            "_populationPercent": "4.1"
          },
          "pt": {
            "_populationPercent": "3.4"
          },
          "rm": {
            "_populationPercent": "0.5",
            "_officialStatus": "official_regional"
          },
          "rmo": {
            "_populationPercent": "0.29"
          },
          "wae": {
            "_populationPercent": "0.12"
          }
        }
      },
      "CI": {
        "_gdp": "97160000000",
        "_literacyPercent": "56.9",
        "_population": "26260600",
        "languagePopulation": {
          "bci": {
            "_populationPercent": "11",
            "_literacyPercent": "10"
          },
          "bqv": {
            "_populationPercent": "0.17",
            "_literacyPercent": "10"
          },
          "dnj": {
            "_populationPercent": "4",
            "_literacyPercent": "1"
          },
          "fr": {
            "_populationPercent": "49",
            "_officialStatus": "official"
          },
          "kfo": {
            "_populationPercent": "0.23"
          },
          "sef": {
            "_writingPercent": "5",
            "_populationPercent": "4.3"
          }
        }
      },
      "CK": {
        "_gdp": "299900000",
        "_literacyPercent": "95",
        "_population": "9038",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "CL": {
        "_gdp": "452100000000",
        "_literacyPercent": "98.6",
        "_population": "17925300",
        "languagePopulation": {
          "arn": {
            "_populationPercent": "1.5"
          },
          "en": {
            "_populationPercent": "9.5"
          },
          "es": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "CM": {
        "_gdp": "89540000000",
        "_literacyPercent": "71.3",
        "_population": "25641000",
        "languagePopulation": {
          "agq": {
            "_populationPercent": "0.14",
            "_literacyPercent": "20"
          },
          "ar": {
            "_populationPercent": "0.39"
          },
          "bas": {
            "_populationPercent": "1.2",
            "_literacyPercent": "25"
          },
          "bax": {
            "_populationPercent": "1.2"
          },
          "bbj": {
            "_populationPercent": "1.4",
            "_literacyPercent": "25"
          },
          "bfd": {
            "_populationPercent": "0.57",
            "_literacyPercent": "30"
          },
          "bkm": {
            "_writingPercent": "5",
            "_populationPercent": "1.3"
          },
          "bss": {
            "_populationPercent": "0.54",
            "_literacyPercent": "30"
          },
          "bum": {
            "_populationPercent": "4.6"
          },
          "byv": {
            "_populationPercent": "1.1",
            "_literacyPercent": "15"
          },
          "dua": {
            "_populationPercent": "0.48",
            "_literacyPercent": "25"
          },
          "en": {
            "_populationPercent": "38",
            "_officialStatus": "official"
          },
          "ewo": {
            "_populationPercent": "3.1",
            "_literacyPercent": "15"
          },
          "ff": {
            "_populationPercent": "3.6"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "fr": {
            "_populationPercent": "68",
            "_officialStatus": "official"
          },
          "ha_Arab": {
            "_populationPercent": "0.14"
          },
          "jgo": {
            "_populationPercent": "0.34",
            "_literacyPercent": "30"
          },
          "kkj": {
            "_populationPercent": "0.54"
          },
          "ksf": {
            "_populationPercent": "0.32"
          },
          "maf": {
            "_populationPercent": "0.74"
          },
          "mgo": {
            "_writingPercent": "5",
            "_populationPercent": "0.47"
          },
          "mua": {
            "_populationPercent": "1"
          },
          "nmg": {
            "_populationPercent": "0.035",
            "_literacyPercent": "10"
          },
          "nnh": {
            "_populationPercent": "1.4",
            "_literacyPercent": "8"
          },
          "yav": {
            "_populationPercent": "0.009"
          },
          "ybb": {
            "_populationPercent": "1.6",
            "_literacyPercent": "2"
          }
        }
      },
      "CN": {
        "_gdp": "23210000000000",
        "_literacyPercent": "95.1",
        "_population": "1384690000",
        "languagePopulation": {
          "bo": {
            "_populationPercent": "0.2",
            "_officialStatus": "official_regional"
          },
          "en": {
            "_populationPercent": "0.0045"
          },
          "gan": {
            "_populationPercent": "1.7"
          },
          "hak": {
            "_populationPercent": "2.3"
          },
          "hsn": {
            "_populationPercent": "2.9"
          },
          "ii": {
            "_populationPercent": "0.6",
            "_literacyPercent": "60"
          },
          "khb": {
            "_populationPercent": "0.019"
          },
          "kk_Arab": {
            "_populationPercent": "0.086"
          },
          "ko": {
            "_populationPercent": "0.15",
            "_officialStatus": "official_regional"
          },
          "ky_Arab": {
            "_populationPercent": "0.034"
          },
          "lcp": {
            "_populationPercent": "0.0058"
          },
          "lis": {
            "_populationPercent": "0.045"
          },
          "lzh": {
            "_populationPercent": "0"
          },
          "mn_Mong": {
            "_populationPercent": "0.26",
            "_officialStatus": "official_regional"
          },
          "nan": {
            "_populationPercent": "1.9"
          },
          "nxq": {
            "_populationPercent": "0.024"
          },
          "ru": {
            "_populationPercent": "0.001"
          },
          "tdd": {
            "_populationPercent": "0.019"
          },
          "ug": {
            "_populationPercent": "0.55",
            "_officialStatus": "official_regional"
          },
          "uz_Cyrl": {
            "_populationPercent": "0.0004"
          },
          "vi": {
            "_populationPercent": "0.0005"
          },
          "wuu": {
            "_populationPercent": "6"
          },
          "yue_Hans": {
            "_populationPercent": "5.2"
          },
          "za": {
            "_populationPercent": "0.31",
            "_officialStatus": "official_regional"
          },
          "zh": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          }
        }
      },
      "CO": {
        "_gdp": "711600000000",
        "_literacyPercent": "93.6",
        "_population": "48169000",
        "languagePopulation": {
          "es": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "guc": {
            "_populationPercent": "0.27"
          }
        }
      },
      "CP": {
        "_gdp": "42400",
        "_literacyPercent": "99",
        "_population": "1",
        "languagePopulation": {
          "und": {
            "_populationPercent": "100"
          }
        }
      },
      "CR": {
        "_gdp": "83940000000",
        "_literacyPercent": "96.3",
        "_population": "4987140",
        "languagePopulation": {
          "es": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "CU": {
        "_gdp": "137000000000",
        "_literacyPercent": "99.8",
        "_population": "11116400",
        "languagePopulation": {
          "es": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "CV": {
        "_gdp": "3777000000",
        "_literacyPercent": "84.9",
        "_population": "568373",
        "languagePopulation": {
          "kea": {
            "_populationPercent": "91"
          },
          "pt": {
            "_populationPercent": "76",
            "_officialStatus": "official"
          }
        }
      },
      "CW": {
        "_gdp": "3128000000",
        "_literacyPercent": "96",
        "_population": "150241",
        "languagePopulation": {
          "es": {
            "_populationPercent": "3.8"
          },
          "nl": {
            "_populationPercent": "8",
            "_officialStatus": "official"
          },
          "pap": {
            "_populationPercent": "81",
            "_officialStatus": "de_facto_official"
          }
        }
      },
      "CX": {
        "_gdp": "117200000",
        "_literacyPercent": "99",
        "_population": "2205",
        "languagePopulation": {
          "en": {
            "_populationPercent": "63",
            "_officialStatus": "official"
          }
        }
      },
      "CY": {
        "_gdp": "31780000000",
        "_literacyPercent": "98.7",
        "_population": "1237090",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "0.11"
          },
          "el": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "73"
          },
          "fr": {
            "_populationPercent": "7"
          },
          "hy": {
            "_populationPercent": "0.22"
          },
          "tr": {
            "_populationPercent": "23",
            "_officialStatus": "official"
          }
        }
      },
      "CZ": {
        "_gdp": "375900000000",
        "_literacyPercent": "99",
        "_population": "10686300",
        "languagePopulation": {
          "cs": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          },
          "de": {
            "_populationPercent": "15"
          },
          "en": {
            "_populationPercent": "27"
          },
          "pl": {
            "_populationPercent": "0.49"
          },
          "sk": {
            "_populationPercent": "16"
          }
        }
      },
      "DE": {
        "_gdp": "4199000000000",
        "_literacyPercent": "99",
        "_population": "80457700",
        "languagePopulation": {
          "bar": {
            "_writingPercent": "5",
            "_populationPercent": "17"
          },
          "da": {
            "_populationPercent": "2"
          },
          "de": {
            "_populationPercent": "91",
            "_officialStatus": "official"
          },
          "dsb": {
            "_writingPercent": "5",
            "_populationPercent": "0.0087"
          },
          "el": {
            "_populationPercent": "0.38"
          },
          "en": {
            "_populationPercent": "64"
          },
          "es": {
            "_populationPercent": "6"
          },
          "fr": {
            "_populationPercent": "18"
          },
          "frr": {
            "_populationPercent": "0.012"
          },
          "frs": {
            "_populationPercent": "0.0025"
          },
          "gsw": {
            "_writingPercent": "5",
            "_populationPercent": "2.3"
          },
          "hr": {
            "_populationPercent": "0.79"
          },
          "hsb": {
            "_writingPercent": "5",
            "_populationPercent": "0.016"
          },
          "it": {
            "_populationPercent": "7"
          },
          "ksh": {
            "_populationPercent": "0.3"
          },
          "ku": {
            "_populationPercent": "0.66"
          },
          "nds": {
            "_writingPercent": "5",
            "_populationPercent": "12"
          },
          "nl": {
            "_populationPercent": "9"
          },
          "pfl": {
            "_populationPercent": "0"
          },
          "pl": {
            "_populationPercent": "0.29"
          },
          "ru": {
            "_populationPercent": "6"
          },
          "stq": {
            "_populationPercent": "0.0012"
          },
          "swg": {
            "_writingPercent": "5",
            "_populationPercent": "1"
          },
          "tr": {
            "_populationPercent": "2.5"
          },
          "vmf": {
            "_populationPercent": "6"
          }
        }
      },
      "DG": {
        "_gdp": "22460000",
        "_literacyPercent": "99",
        "_population": "500",
        "languagePopulation": {
          "en": {
            "_populationPercent": "99",
            "_officialStatus": "de_facto_official"
          }
        }
      },
      "DJ": {
        "_gdp": "3640000000",
        "_literacyPercent": "67.9",
        "_population": "884017",
        "languagePopulation": {
          "aa": {
            "_populationPercent": "42"
          },
          "ar": {
            "_populationPercent": "7.3",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "2.1",
            "_officialStatus": "official"
          },
          "so": {
            "_populationPercent": "41"
          }
        }
      },
      "DK": {
        "_gdp": "287800000000",
        "_literacyPercent": "99",
        "_population": "5809500",
        "languagePopulation": {
          "da": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "de": {
            "_populationPercent": "47",
            "_officialStatus": "official_regional"
          },
          "en": {
            "_populationPercent": "86"
          },
          "fo": {
            "_populationPercent": "0.38"
          },
          "jut": {
            "_populationPercent": "0"
          },
          "kl": {
            "_populationPercent": "0.12",
            "_officialStatus": "official_regional"
          },
          "sv": {
            "_populationPercent": "13"
          }
        }
      },
      "DM": {
        "_gdp": "783000000",
        "_literacyPercent": "94",
        "_population": "74027",
        "languagePopulation": {
          "en": {
            "_populationPercent": "94",
            "_officialStatus": "official"
          }
        }
      },
      "DO": {
        "_gdp": "173000000000",
        "_literacyPercent": "90.1",
        "_population": "10298800",
        "languagePopulation": {
          "en": {
            "_populationPercent": "0.078"
          },
          "es": {
            "_populationPercent": "78",
            "_officialStatus": "official"
          }
        }
      },
      "DZ": {
        "_gdp": "630000000000",
        "_literacyPercent": "72.6",
        "_population": "41657500",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "74",
            "_officialStatus": "official"
          },
          "arq": {
            "_populationPercent": "83"
          },
          "en": {
            "_populationPercent": "7"
          },
          "fr": {
            "_populationPercent": "20",
            "_officialStatus": "official"
          },
          "kab": {
            "_populationPercent": "7.8",
            "_literacyPercent": "10"
          }
        }
      },
      "EA": {
        "_gdp": "5406000000",
        "_literacyPercent": "97.7",
        "_population": "150000",
        "languagePopulation": {
          "es": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "EC": {
        "_gdp": "193000000000",
        "_literacyPercent": "91.6",
        "_population": "16498500",
        "languagePopulation": {
          "es": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          },
          "qu": {
            "_populationPercent": "17",
            "_officialStatus": "official"
          },
          "qug": {
            "_populationPercent": "5.7"
          }
        }
      },
      "EE": {
        "_gdp": "41650000000",
        "_literacyPercent": "99.8",
        "_population": "1244290",
        "languagePopulation": {
          "en": {
            "_populationPercent": "50"
          },
          "et": {
            "_populationPercent": "71",
            "_officialStatus": "official"
          },
          "fi": {
            "_populationPercent": "21"
          },
          "ru": {
            "_populationPercent": "56"
          },
          "vro": {
            "_populationPercent": "5.7"
          }
        }
      },
      "EG": {
        "_gdp": "1204000000000",
        "_literacyPercent": "73.9",
        "_population": "99413300",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "94",
            "_officialStatus": "official"
          },
          "arz": {
            "_populationPercent": "64"
          },
          "el": {
            "_populationPercent": "0.061"
          },
          "en": {
            "_populationPercent": "35"
          }
        }
      },
      "EH": {
        "_gdp": "906500000",
        "_literacyPercent": "50",
        "_population": "619551",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "ER": {
        "_gdp": "9402000000",
        "_literacyPercent": "68.9",
        "_population": "5970650",
        "languagePopulation": {
          "aa": {
            "_populationPercent": "3.6"
          },
          "ar": {
            "_writingPercent": "5",
            "_populationPercent": "4.9",
            "_officialStatus": "official"
          },
          "byn": {
            "_populationPercent": "1.3"
          },
          "en": {
            "_populationPercent": "59",
            "_officialStatus": "official"
          },
          "ssy": {
            "_populationPercent": "3.6"
          },
          "ti": {
            "_populationPercent": "60",
            "_officialStatus": "de_facto_official"
          },
          "tig": {
            "_populationPercent": "18"
          }
        }
      },
      "ES": {
        "_gdp": "1778000000000",
        "_literacyPercent": "97.7",
        "_population": "49331100",
        "languagePopulation": {
          "ast": {
            "_populationPercent": "1.3",
            "_officialStatus": "official_regional"
          },
          "ca": {
            "_populationPercent": "17",
            "_officialStatus": "official_regional"
          },
          "en": {
            "_populationPercent": "24"
          },
          "es": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "eu": {
            "_populationPercent": "2",
            "_officialStatus": "official_regional"
          },
          "ext": {
            "_populationPercent": "0.49"
          },
          "gl": {
            "_populationPercent": "7",
            "_officialStatus": "official_regional"
          }
        }
      },
      "ET": {
        "_gdp": "200600000000",
        "_literacyPercent": "39",
        "_population": "108386000",
        "languagePopulation": {
          "aa": {
            "_populationPercent": "1.4"
          },
          "am": {
            "_populationPercent": "33",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "43"
          },
          "om": {
            "_populationPercent": "32"
          },
          "sid": {
            "_populationPercent": "3.5"
          },
          "so": {
            "_populationPercent": "6"
          },
          "ti": {
            "_populationPercent": "6"
          },
          "wal": {
            "_populationPercent": "1.8"
          }
        }
      },
      "FI": {
        "_gdp": "244900000000",
        "_literacyPercent": "100",
        "_population": "5537360",
        "languagePopulation": {
          "de": {
            "_populationPercent": "18"
          },
          "en": {
            "_populationPercent": "70"
          },
          "et": {
            "_populationPercent": "0.11"
          },
          "fi": {
            "_populationPercent": "94",
            "_officialStatus": "official"
          },
          "rmf": {
            "_populationPercent": "0.09"
          },
          "ru": {
            "_populationPercent": "0.81"
          },
          "se": {
            "_populationPercent": "0.036"
          },
          "smn": {
            "_populationPercent": "0.011"
          },
          "sms": {
            "_populationPercent": "0.011"
          },
          "sv": {
            "_populationPercent": "44",
            "_officialStatus": "official"
          }
        }
      },
      "FJ": {
        "_gdp": "8629000000",
        "_literacyPercent": "93.7",
        "_population": "926276",
        "languagePopulation": {
          "en": {
            "_populationPercent": "94",
            "_officialStatus": "official"
          },
          "fj": {
            "_populationPercent": "39",
            "_officialStatus": "official"
          },
          "hi": {
            "_populationPercent": "44"
          },
          "hif": {
            "_populationPercent": "41",
            "_officialStatus": "official"
          },
          "rtm": {
            "_populationPercent": "0.27"
          }
        }
      },
      "FK": {
        "_gdp": "206400000",
        "_literacyPercent": "99",
        "_population": "3198",
        "languagePopulation": {
          "en": {
            "_populationPercent": "88",
            "_officialStatus": "official"
          }
        }
      },
      "FM": {
        "_gdp": "348000000",
        "_literacyPercent": "89",
        "_population": "103643",
        "languagePopulation": {
          "chk": {
            "_populationPercent": "30"
          },
          "en": {
            "_populationPercent": "57",
            "_officialStatus": "official"
          },
          "kos": {
            "_populationPercent": "7.7"
          },
          "pon": {
            "_populationPercent": "23"
          },
          "uli": {
            "_populationPercent": "2.9"
          },
          "yap": {
            "_populationPercent": "6.4"
          }
        }
      },
      "FO": {
        "_gdp": "2001000000",
        "_literacyPercent": "99",
        "_population": "51018",
        "languagePopulation": {
          "fo": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "FR": {
        "_gdp": "2856000000000",
        "_literacyPercent": "99",
        "_population": "67364400",
        "languagePopulation": {
          "br": {
            "_populationPercent": "0.83",
            "_literacyPercent": "3"
          },
          "ca": {
            "_populationPercent": "0.17"
          },
          "co": {
            "_writingPercent": "5",
            "_populationPercent": "0.24"
          },
          "de": {
            "_populationPercent": "5"
          },
          "en": {
            "_populationPercent": "39"
          },
          "es": {
            "_populationPercent": "13"
          },
          "eu": {
            "_populationPercent": "0.13"
          },
          "fr": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "frp": {
            "_populationPercent": "0.094"
          },
          "gsw": {
            "_writingPercent": "5",
            "_populationPercent": "0.91"
          },
          "ia": {
            "_populationPercent": "0.0002"
          },
          "it": {
            "_populationPercent": "1.7"
          },
          "nl": {
            "_populationPercent": "0.13"
          },
          "oc": {
            "_writingPercent": "5",
            "_populationPercent": "3"
          },
          "pcd": {
            "_populationPercent": "1.1"
          },
          "pt": {
            "_populationPercent": "1.3"
          }
        }
      },
      "GA": {
        "_gdp": "36660000000",
        "_literacyPercent": "89",
        "_population": "2119040",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "63",
            "_officialStatus": "official"
          },
          "puu": {
            "_populationPercent": "9"
          }
        }
      },
      "GB": {
        "_gdp": "2925000000000",
        "_literacyPercent": "99",
        "_population": "65105200",
        "languagePopulation": {
          "bn": {
            "_populationPercent": "0.67"
          },
          "cy": {
            "_populationPercent": "0.77",
            "_officialStatus": "official_regional"
          },
          "de": {
            "_populationPercent": "6"
          },
          "el": {
            "_populationPercent": "0.34"
          },
          "en": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "19"
          },
          "ga": {
            "_populationPercent": "0.026",
            "_officialStatus": "official_regional"
          },
          "gd": {
            "_writingPercent": "5",
            "_populationPercent": "0.099",
            "_officialStatus": "official_regional"
          },
          "it": {
            "_populationPercent": "0.34"
          },
          "ks": {
            "_populationPercent": "0.19"
          },
          "kw": {
            "_populationPercent": "0.0031"
          },
          "ml": {
            "_populationPercent": "0.035"
          },
          "pa": {
            "_populationPercent": "0.79"
          },
          "sco": {
            "_writingPercent": "5",
            "_populationPercent": "2.7"
          },
          "syl": {
            "_populationPercent": "0.5"
          },
          "yi": {
            "_populationPercent": "0.049"
          },
          "zh_Hant": {
            "_populationPercent": "0.54"
          }
        }
      },
      "GD": {
        "_gdp": "1634000000",
        "_literacyPercent": "96",
        "_population": "112207",
        "languagePopulation": {
          "en": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          }
        }
      },
      "GE": {
        "_gdp": "39850000000",
        "_literacyPercent": "99.7",
        "_population": "4926090",
        "languagePopulation": {
          "ab": {
            "_populationPercent": "2.2",
            "_officialStatus": "official_regional"
          },
          "hy": {
            "_populationPercent": "7"
          },
          "ka": {
            "_populationPercent": "86",
            "_officialStatus": "official"
          },
          "ku": {
            "_populationPercent": "0.89"
          },
          "os": {
            "_populationPercent": "2.2",
            "_officialStatus": "official_regional"
          },
          "ru": {
            "_populationPercent": "9"
          },
          "xmf": {
            "_populationPercent": "11"
          }
        }
      },
      "GF": {
        "_gdp": "1551000000",
        "_literacyPercent": "83",
        "_population": "199509",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "77",
            "_officialStatus": "official"
          },
          "gcr": {
            "_populationPercent": "26"
          },
          "zh_Hant": {
            "_populationPercent": "2.5"
          }
        }
      },
      "GG": {
        "_gdp": "3465000000",
        "_literacyPercent": "100",
        "_population": "66697",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "GH": {
        "_gdp": "134000000000",
        "_literacyPercent": "71.5",
        "_population": "28102500",
        "languagePopulation": {
          "abr": {
            "_populationPercent": "5"
          },
          "ada": {
            "_populationPercent": "3"
          },
          "ak": {
            "_populationPercent": "39",
            "_officialStatus": "official_regional"
          },
          "ee": {
            "_populationPercent": "11",
            "_officialStatus": "official_regional"
          },
          "en": {
            "_populationPercent": "21",
            "_officialStatus": "official"
          },
          "ff": {
            "_populationPercent": "0"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "gaa": {
            "_populationPercent": "2.8",
            "_officialStatus": "official_regional"
          },
          "gur": {
            "_populationPercent": "3.5"
          },
          "ha": {
            "_populationPercent": "0.87"
          },
          "nzi": {
            "_populationPercent": "1"
          },
          "saf": {
            "_populationPercent": "0.014"
          }
        }
      },
      "GI": {
        "_gdp": "2044000000",
        "_literacyPercent": "80",
        "_population": "29461",
        "languagePopulation": {
          "en": {
            "_populationPercent": "80",
            "_officialStatus": "official"
          },
          "es": {
            "_populationPercent": "50"
          }
        }
      },
      "GL": {
        "_gdp": "2413000000",
        "_literacyPercent": "100",
        "_population": "57691",
        "languagePopulation": {
          "da": {
            "_populationPercent": "14"
          },
          "kl": {
            "_populationPercent": "84",
            "_officialStatus": "official"
          }
        }
      },
      "GM": {
        "_gdp": "5556000000",
        "_literacyPercent": "51.1",
        "_population": "2092730",
        "languagePopulation": {
          "en": {
            "_populationPercent": "40",
            "_officialStatus": "official"
          },
          "ff": {
            "_populationPercent": "0"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "man": {
            "_populationPercent": "29"
          }
        }
      },
      "GN": {
        "_gdp": "27970000000",
        "_literacyPercent": "41",
        "_population": "11855400",
        "languagePopulation": {
          "ff": {
            "_populationPercent": "26"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "fr": {
            "_populationPercent": "29",
            "_officialStatus": "official"
          },
          "kpe": {
            "_populationPercent": "3.8"
          },
          "man_Nkoo": {
            "_populationPercent": "23"
          },
          "nqo": {
            "_populationPercent": "5"
          },
          "sus": {
            "_populationPercent": "11"
          }
        }
      },
      "GP": {
        "_gdp": "3513000000",
        "_literacyPercent": "90",
        "_population": "452776",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          }
        }
      },
      "GQ": {
        "_gdp": "31520000000",
        "_literacyPercent": "94.2",
        "_population": "797457",
        "languagePopulation": {
          "bvb": {
            "_populationPercent": "7.9"
          },
          "es": {
            "_populationPercent": "87",
            "_officialStatus": "official"
          },
          "fan": {
            "_populationPercent": "51"
          },
          "fr": {
            "_populationPercent": "8.8",
            "_officialStatus": "official"
          },
          "pt": {
            "_populationPercent": "0.0001",
            "_officialStatus": "official"
          }
        }
      },
      "GR": {
        "_gdp": "299300000000",
        "_literacyPercent": "97.3",
        "_population": "10761500",
        "languagePopulation": {
          "bg": {
            "_populationPercent": "0.27"
          },
          "de": {
            "_populationPercent": "5"
          },
          "el": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "51"
          },
          "fr": {
            "_populationPercent": "9"
          },
          "mk": {
            "_populationPercent": "1.6"
          },
          "pnt": {
            "_populationPercent": "3.7"
          },
          "sq": {
            "_populationPercent": "0.093"
          },
          "tr": {
            "_populationPercent": "1.2"
          },
          "tsd": {
            "_populationPercent": "0.0019"
          }
        }
      },
      "GS": {
        "_gdp": "898500",
        "_literacyPercent": "99",
        "_population": "20",
        "languagePopulation": {
          "und": {
            "_populationPercent": "100",
            "_literacyPercent": "100"
          }
        }
      },
      "GT": {
        "_gdp": "138100000000",
        "_literacyPercent": "75.9",
        "_population": "16581300",
        "languagePopulation": {
          "es": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "quc": {
            "_populationPercent": "7",
            "_officialStatus": "official_regional"
          }
        }
      },
      "GU": {
        "_gdp": "5793000000",
        "_literacyPercent": "99",
        "_population": "167772",
        "languagePopulation": {
          "ch": {
            "_populationPercent": "22",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "91",
            "_officialStatus": "de_facto_official"
          }
        }
      },
      "GW": {
        "_gdp": "3171000000",
        "_literacyPercent": "55.3",
        "_population": "1833250",
        "languagePopulation": {
          "ff": {
            "_populationPercent": "0.0001"
          },
          "ff_Adlm": {
            "_populationPercent": "0.0001"
          },
          "knf": {
            "_populationPercent": "2.6"
          },
          "pt": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "GY": {
        "_gdp": "6301000000",
        "_literacyPercent": "91.8",
        "_population": "740685",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "HK": {
        "_gdp": "455900000000",
        "_literacyPercent": "93.5",
        "_population": "7213340",
        "languagePopulation": {
          "en": {
            "_populationPercent": "51",
            "_officialStatus": "official"
          },
          "yue": {
            "_populationPercent": "90"
          },
          "zh": {
            "_populationPercent": "5"
          },
          "zh_Hant": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "HM": {
        "_gdp": "53170",
        "_literacyPercent": "99",
        "_population": "1",
        "languagePopulation": {
          "und": {
            "_populationPercent": "100",
            "_literacyPercent": "100"
          }
        }
      },
      "HN": {
        "_gdp": "46300000000",
        "_literacyPercent": "85.1",
        "_population": "9182770",
        "languagePopulation": {
          "en": {
            "_populationPercent": "0.44"
          },
          "es": {
            "_populationPercent": "78",
            "_officialStatus": "official"
          }
        }
      },
      "HR": {
        "_gdp": "102100000000",
        "_literacyPercent": "98.9",
        "_population": "4270480",
        "languagePopulation": {
          "en": {
            "_populationPercent": "49"
          },
          "hr": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "it": {
            "_populationPercent": "1.6",
            "_officialStatus": "official_regional"
          }
        }
      },
      "HT": {
        "_gdp": "19970000000",
        "_literacyPercent": "48.7",
        "_population": "10788400",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "4.7",
            "_literacyPercent": "100",
            "_officialStatus": "official"
          },
          "ht": {
            "_populationPercent": "81",
            "_officialStatus": "official"
          }
        }
      },
      "HU": {
        "_gdp": "289600000000",
        "_literacyPercent": "99",
        "_population": "9825700",
        "languagePopulation": {
          "de": {
            "_populationPercent": "18"
          },
          "en": {
            "_populationPercent": "20"
          },
          "fr": {
            "_populationPercent": "3"
          },
          "hr": {
            "_populationPercent": "0.32"
          },
          "hu": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "ro": {
            "_populationPercent": "0.99"
          },
          "sk": {
            "_populationPercent": "0.11"
          },
          "sl": {
            "_populationPercent": "0.051"
          }
        }
      },
      "IC": {
        "_gdp": "75640000000",
        "_literacyPercent": "97.7",
        "_population": "2098590",
        "languagePopulation": {
          "es": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "ID": {
        "_gdp": "3250000000000",
        "_literacyPercent": "92.8",
        "_population": "262787000",
        "languagePopulation": {
          "ace": {
            "_populationPercent": "1.4"
          },
          "aoz": {
            "_populationPercent": "0.27"
          },
          "ban": {
            "_populationPercent": "1.8",
            "_literacyPercent": "10"
          },
          "bbc": {
            "_populationPercent": "0.92"
          },
          "bew": {
            "_populationPercent": "2.1"
          },
          "bjn": {
            "_populationPercent": "1.5",
            "_literacyPercent": "10"
          },
          "bug": {
            "_populationPercent": "1.6",
            "_literacyPercent": "10"
          },
          "gay": {
            "_populationPercent": "0.12"
          },
          "gor": {
            "_populationPercent": "0.41"
          },
          "id": {
            "_populationPercent": "64",
            "_officialStatus": "official"
          },
          "jv": {
            "_populationPercent": "34",
            "_literacyPercent": "10"
          },
          "kge": {
            "_populationPercent": "0.32"
          },
          "kvr": {
            "_populationPercent": "0.14"
          },
          "lbw": {
            "_populationPercent": "0.13"
          },
          "ljp": {
            "_populationPercent": "0.69"
          },
          "mad": {
            "_populationPercent": "6.3",
            "_literacyPercent": "40"
          },
          "mak": {
            "_populationPercent": "0.73"
          },
          "mdr": {
            "_populationPercent": "0.092"
          },
          "min": {
            "_populationPercent": "3",
            "_literacyPercent": "10"
          },
          "ms_Arab": {
            "_populationPercent": "4.6"
          },
          "mwv": {
            "_populationPercent": "0.024"
          },
          "nij": {
            "_populationPercent": "0.37"
          },
          "rej": {
            "_populationPercent": "0.46"
          },
          "rob": {
            "_populationPercent": "0.11"
          },
          "sas": {
            "_populationPercent": "0.97"
          },
          "sly": {
            "_populationPercent": "0.054"
          },
          "su": {
            "_populationPercent": "12"
          },
          "sxn": {
            "_populationPercent": "0.092"
          },
          "zh_Hant": {
            "_populationPercent": "0.92"
          }
        }
      },
      "IE": {
        "_gdp": "353300000000",
        "_literacyPercent": "99",
        "_population": "5068050",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "17"
          },
          "ga": {
            "_populationPercent": "22",
            "_officialStatus": "official"
          }
        }
      },
      "IL": {
        "_gdp": "317100000000",
        "_literacyPercent": "97.1",
        "_population": "8424900",
        "languagePopulation": {
          "am": {
            "_populationPercent": "0.59"
          },
          "ar": {
            "_populationPercent": "20",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "85"
          },
          "he": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "hu": {
            "_populationPercent": "1"
          },
          "lad": {
            "_populationPercent": "1.3"
          },
          "ml": {
            "_populationPercent": "0.095"
          },
          "pl": {
            "_populationPercent": "1.5"
          },
          "ro": {
            "_populationPercent": "3.7"
          },
          "ru": {
            "_populationPercent": "11"
          },
          "ti": {
            "_populationPercent": "0.12"
          },
          "yi": {
            "_populationPercent": "3"
          }
        }
      },
      "IM": {
        "_gdp": "6792000000",
        "_literacyPercent": "99",
        "_population": "89407",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "gv": {
            "_populationPercent": "1.9",
            "_officialStatus": "official"
          }
        }
      },
      "IN": {
        "_gdp": "9474000000000",
        "_literacyPercent": "62.8",
        "_population": "1296830000",
        "languagePopulation": {
          "as": {
            "_populationPercent": "1.3",
            "_officialStatus": "official_regional"
          },
          "awa": {
            "_writingPercent": "5",
            "_populationPercent": "1.8"
          },
          "bfq": {
            "_populationPercent": "0.023"
          },
          "bft": {
            "_populationPercent": "0.0062"
          },
          "bfy": {
            "_populationPercent": "0.037"
          },
          "bgc": {
            "_populationPercent": "1.2",
            "_literacyPercent": "55"
          },
          "bhb": {
            "_populationPercent": "0.12"
          },
          "bhi": {
            "_populationPercent": "0.092"
          },
          "bho": {
            "_populationPercent": "2.3",
            "_literacyPercent": "30"
          },
          "bjj": {
            "_populationPercent": "0.56",
            "_literacyPercent": "60"
          },
          "bn": {
            "_populationPercent": "8.1",
            "_officialStatus": "official_regional"
          },
          "bo": {
            "_populationPercent": "0.011"
          },
          "bpy": {
            "_populationPercent": "0.0068"
          },
          "bra": {
            "_populationPercent": "0.0041"
          },
          "brx": {
            "_populationPercent": "0.14"
          },
          "btv": {
            "_populationPercent": "0.0026"
          },
          "ccp": {
            "_populationPercent": "0.028"
          },
          "dcc": {
            "_populationPercent": "1"
          },
          "doi": {
            "_populationPercent": "0.2"
          },
          "dv": {
            "_populationPercent": "0.0004"
          },
          "dz": {
            "_populationPercent": "0.0002"
          },
          "en": {
            "_populationPercent": "19",
            "_officialStatus": "official"
          },
          "gbm": {
            "_populationPercent": "0.27"
          },
          "gom": {
            "_populationPercent": "0.32"
          },
          "gon": {
            "_populationPercent": "0.24"
          },
          "grt": {
            "_populationPercent": "0.053"
          },
          "gu": {
            "_populationPercent": "4.5",
            "_officialStatus": "official_regional"
          },
          "hi": {
            "_populationPercent": "41",
            "_officialStatus": "official"
          },
          "hne": {
            "_populationPercent": "1.1"
          },
          "hoc": {
            "_populationPercent": "0.1"
          },
          "hoj": {
            "_populationPercent": "0.082"
          },
          "kfr": {
            "_populationPercent": "0.075"
          },
          "kfy": {
            "_populationPercent": "0.22"
          },
          "kha": {
            "_populationPercent": "0.08",
            "_literacyPercent": "29",
            "_officialStatus": "official_regional"
          },
          "khn": {
            "_populationPercent": "0.15"
          },
          "kht": {
            "_populationPercent": "0.0007"
          },
          "kn": {
            "_populationPercent": "3.7",
            "_officialStatus": "official_regional"
          },
          "kok": {
            "_populationPercent": "0.37",
            "_officialStatus": "official_regional"
          },
          "kru": {
            "_populationPercent": "0.19"
          },
          "ks": {
            "_populationPercent": "0.41",
            "_officialStatus": "official_regional"
          },
          "lah": {
            "_populationPercent": "0.0025"
          },
          "lep": {
            "_populationPercent": "0.0035"
          },
          "lif": {
            "_populationPercent": "0.0026"
          },
          "lmn": {
            "_populationPercent": "0.27"
          },
          "mag": {
            "_populationPercent": "1.2",
            "_literacyPercent": "30"
          },
          "mai": {
            "_populationPercent": "1.2",
            "_officialStatus": "official_regional"
          },
          "ml": {
            "_populationPercent": "3.2",
            "_officialStatus": "official_regional"
          },
          "mni": {
            "_populationPercent": "0.11"
          },
          "mr": {
            "_populationPercent": "7",
            "_officialStatus": "official_regional"
          },
          "mtr": {
            "_populationPercent": "0.098"
          },
          "mwr": {
            "_populationPercent": "1.2"
          },
          "ne": {
            "_populationPercent": "0.56",
            "_officialStatus": "official_regional"
          },
          "njo": {
            "_populationPercent": "0.023"
          },
          "noe": {
            "_populationPercent": "0.13"
          },
          "or": {
            "_populationPercent": "3.2",
            "_officialStatus": "official_regional"
          },
          "pa": {
            "_populationPercent": "2.8",
            "_officialStatus": "official_regional"
          },
          "raj": {
            "_populationPercent": "0.1"
          },
          "ria": {
            "_populationPercent": "0.013"
          },
          "rkt": {
            "_populationPercent": "0.44",
            "_literacyPercent": "20"
          },
          "sa": {
            "_populationPercent": "0.0012",
            "_officialStatus": "official_regional"
          },
          "sat": {
            "_populationPercent": "0.55",
            "_officialStatus": "official_regional"
          },
          "saz": {
            "_populationPercent": "0.029"
          },
          "sck": {
            "_populationPercent": "0.18"
          },
          "sd": {
            "_populationPercent": "0.26",
            "_officialStatus": "official_regional"
          },
          "sd_Deva": {
            "_populationPercent": "0.026",
            "_officialStatus": "official_regional"
          },
          "srx": {
            "_populationPercent": "0.035"
          },
          "swv": {
            "_populationPercent": "0.28"
          },
          "ta": {
            "_populationPercent": "5.9",
            "_officialStatus": "official_regional"
          },
          "tcy": {
            "_populationPercent": "0.15"
          },
          "te": {
            "_populationPercent": "7.2",
            "_officialStatus": "official_regional"
          },
          "unr": {
            "_populationPercent": "0.094"
          },
          "unx": {
            "_populationPercent": "0.048"
          },
          "ur": {
            "_populationPercent": "5",
            "_officialStatus": "official_regional"
          },
          "wbq": {
            "_populationPercent": "0.18"
          },
          "wbr": {
            "_populationPercent": "0.15"
          },
          "wtm": {
            "_populationPercent": "0.46",
            "_literacyPercent": "25"
          },
          "xnr": {
            "_populationPercent": "0.16"
          }
        }
      },
      "IO": {
        "_gdp": "157200000",
        "_literacyPercent": "99",
        "_population": "3500",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_literacyPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "IQ": {
        "_gdp": "649300000000",
        "_literacyPercent": "78.5",
        "_population": "40194200",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "68",
            "_officialStatus": "official"
          },
          "az_Arab": {
            "_populationPercent": "1.8",
            "_officialStatus": "official_regional"
          },
          "ckb": {
            "_populationPercent": "20",
            "_officialStatus": "official_regional"
          },
          "en": {
            "_populationPercent": "35"
          },
          "fa": {
            "_populationPercent": "0.87"
          },
          "lrc": {
            "_populationPercent": "0.61"
          },
          "syr": {
            "_populationPercent": "0.5"
          }
        }
      },
      "IR": {
        "_gdp": "1640000000000",
        "_literacyPercent": "85",
        "_population": "83024700",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "2"
          },
          "az_Arab": {
            "_populationPercent": "24"
          },
          "bal": {
            "_populationPercent": "2"
          },
          "bgn": {
            "_writingPercent": "5",
            "_populationPercent": "0.56"
          },
          "bqi": {
            "_populationPercent": "1.4"
          },
          "ckb": {
            "_populationPercent": "3.9"
          },
          "fa": {
            "_populationPercent": "75",
            "_officialStatus": "official"
          },
          "gbz": {
            "_populationPercent": "0.0096"
          },
          "glk": {
            "_populationPercent": "4.6"
          },
          "hy": {
            "_populationPercent": "0.24"
          },
          "ka": {
            "_populationPercent": "0.071"
          },
          "kk_Arab": {
            "_populationPercent": "0.0036"
          },
          "lki": {
            "_populationPercent": "0.76"
          },
          "lrc": {
            "_populationPercent": "2.1",
            "_literacyPercent": "10"
          },
          "luz": {
            "_populationPercent": "1.2"
          },
          "mzn": {
            "_populationPercent": "5"
          },
          "prd": {
            "_populationPercent": "0.5"
          },
          "ps": {
            "_populationPercent": "0.16"
          },
          "rmt": {
            "_populationPercent": "1.9",
            "_literacyPercent": "1"
          },
          "sdh": {
            "_populationPercent": "3.7"
          },
          "tk": {
            "_populationPercent": "2.8"
          }
        }
      },
      "IS": {
        "_gdp": "18180000000",
        "_literacyPercent": "99",
        "_population": "343518",
        "languagePopulation": {
          "da": {
            "_populationPercent": "0.65"
          },
          "is": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "IT": {
        "_gdp": "2317000000000",
        "_literacyPercent": "99",
        "_population": "62246700",
        "languagePopulation": {
          "ca": {
            "_populationPercent": "0.035"
          },
          "de": {
            "_populationPercent": "1.6"
          },
          "egl": {
            "_populationPercent": "0.05"
          },
          "el": {
            "_populationPercent": "0.035"
          },
          "en": {
            "_populationPercent": "34"
          },
          "fr": {
            "_populationPercent": "6.3",
            "_officialStatus": "official_regional"
          },
          "fur": {
            "_writingPercent": "5",
            "_populationPercent": "0.06"
          },
          "hr": {
            "_populationPercent": "0.0056"
          },
          "it": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          },
          "lij": {
            "_populationPercent": "0.86"
          },
          "lmo": {
            "_populationPercent": "0.03"
          },
          "nap": {
            "_writingPercent": "5",
            "_populationPercent": "0.97"
          },
          "pms": {
            "_populationPercent": "0.0099"
          },
          "rgn": {
            "_populationPercent": "0"
          },
          "sc": {
            "_populationPercent": "1.7"
          },
          "scn": {
            "_writingPercent": "5",
            "_populationPercent": "0.82"
          },
          "sdc": {
            "_populationPercent": "0.17"
          },
          "sl": {
            "_populationPercent": "0.17"
          },
          "vec": {
            "_populationPercent": "1.3"
          }
        }
      },
      "JE": {
        "_gdp": "5569000000",
        "_literacyPercent": "99",
        "_population": "99602",
        "languagePopulation": {
          "en": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "JM": {
        "_gdp": "26060000000",
        "_literacyPercent": "87",
        "_population": "2812090",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          },
          "jam": {
            "_populationPercent": "95"
          }
        }
      },
      "JO": {
        "_gdp": "89000000000",
        "_literacyPercent": "95.9",
        "_population": "10458400",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "45"
          }
        }
      },
      "JP": {
        "_gdp": "5443000000000",
        "_literacyPercent": "99",
        "_population": "126168000",
        "languagePopulation": {
          "ja": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          },
          "ko": {
            "_populationPercent": "0.52"
          },
          "ryu": {
            "_writingPercent": "5",
            "_populationPercent": "0.77"
          }
        }
      },
      "KE": {
        "_gdp": "163700000000",
        "_literacyPercent": "87.4",
        "_population": "48397500",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "0.046"
          },
          "dav": {
            "_writingPercent": "5",
            "_populationPercent": "0.82"
          },
          "ebu": {
            "_populationPercent": "1.5",
            "_literacyPercent": "1"
          },
          "en": {
            "_populationPercent": "19",
            "_officialStatus": "official"
          },
          "gu": {
            "_populationPercent": "0.01"
          },
          "guz": {
            "_populationPercent": "4.9"
          },
          "kam": {
            "_populationPercent": "7.6"
          },
          "ki": {
            "_populationPercent": "17"
          },
          "kln": {
            "_populationPercent": "7.6"
          },
          "luo": {
            "_populationPercent": "9.8"
          },
          "luy": {
            "_populationPercent": "11"
          },
          "mas": {
            "_populationPercent": "1.6",
            "_literacyPercent": "50"
          },
          "mer": {
            "_populationPercent": "4"
          },
          "om": {
            "_populationPercent": "0.47"
          },
          "pa": {
            "_populationPercent": "0.021"
          },
          "pko": {
            "_populationPercent": "0.7",
            "_literacyPercent": "1"
          },
          "saq": {
            "_populationPercent": "0.46",
            "_literacyPercent": "1"
          },
          "so": {
            "_populationPercent": "1.3"
          },
          "sw": {
            "_populationPercent": "66",
            "_officialStatus": "official"
          },
          "teo": {
            "_populationPercent": "0.74"
          }
        }
      },
      "KG": {
        "_gdp": "23150000000",
        "_literacyPercent": "99.2",
        "_population": "5849300",
        "languagePopulation": {
          "ky": {
            "_populationPercent": "48",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "36",
            "_officialStatus": "official"
          }
        }
      },
      "KH": {
        "_gdp": "64210000000",
        "_literacyPercent": "73.9",
        "_population": "16449500",
        "languagePopulation": {
          "cja": {
            "_populationPercent": "1.6"
          },
          "kdt": {
            "_populationPercent": "0.11"
          },
          "km": {
            "_populationPercent": "89",
            "_officialStatus": "official"
          }
        }
      },
      "KI": {
        "_gdp": "227000000",
        "_literacyPercent": "90",
        "_population": "109367",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "gil": {
            "_populationPercent": "60",
            "_officialStatus": "official"
          }
        }
      },
      "KM": {
        "_gdp": "1319000000",
        "_literacyPercent": "75.5",
        "_population": "821164",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "66",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "56",
            "_officialStatus": "official"
          },
          "wni": {
            "_populationPercent": "34",
            "_officialStatus": "official"
          },
          "zdj": {
            "_populationPercent": "37",
            "_officialStatus": "official"
          }
        }
      },
      "KN": {
        "_gdp": "1550000000",
        "_literacyPercent": "97.8",
        "_population": "53094",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "KP": {
        "_gdp": "40000000000",
        "_literacyPercent": "100",
        "_population": "25381100",
        "languagePopulation": {
          "ko": {
            "_populationPercent": "88",
            "_officialStatus": "official"
          }
        }
      },
      "KR": {
        "_gdp": "2035000000000",
        "_literacyPercent": "97.9",
        "_population": "51418100",
        "languagePopulation": {
          "ko": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "KW": {
        "_gdp": "289700000000",
        "_literacyPercent": "93.9",
        "_population": "2916470",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "KY": {
        "_gdp": "2507000000",
        "_literacyPercent": "98.9",
        "_population": "59613",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "KZ": {
        "_gdp": "478600000000",
        "_literacyPercent": "99.7",
        "_population": "18744500",
        "languagePopulation": {
          "de": {
            "_populationPercent": "6.4"
          },
          "en": {
            "_populationPercent": "15"
          },
          "kk": {
            "_populationPercent": "64",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "72",
            "_officialStatus": "official"
          },
          "ug_Cyrl": {
            "_populationPercent": "2"
          }
        }
      },
      "LA": {
        "_gdp": "49340000000",
        "_literacyPercent": "72.7",
        "_population": "7234170",
        "languagePopulation": {
          "kdt": {
            "_populationPercent": "0.96"
          },
          "kjg": {
            "_populationPercent": "5.8"
          },
          "lo": {
            "_populationPercent": "69",
            "_officialStatus": "official"
          }
        }
      },
      "LB": {
        "_gdp": "88250000000",
        "_literacyPercent": "89.6",
        "_population": "6100080",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "86",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "40"
          },
          "fr": {
            "_populationPercent": "0.37"
          },
          "hy": {
            "_populationPercent": "5.2"
          },
          "ku_Arab": {
            "_populationPercent": "1.7"
          }
        }
      },
      "LC": {
        "_gdp": "2542000000",
        "_literacyPercent": "90.1",
        "_population": "165510",
        "languagePopulation": {
          "en": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          }
        }
      },
      "LI": {
        "_gdp": "4978000000",
        "_literacyPercent": "100",
        "_population": "38547",
        "languagePopulation": {
          "de": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "gsw": {
            "_writingPercent": "5",
            "_populationPercent": "85",
            "_officialStatus": "de_facto_official"
          },
          "wae": {
            "_populationPercent": "3.4"
          }
        }
      },
      "LK": {
        "_gdp": "275800000000",
        "_literacyPercent": "91.2",
        "_population": "22576600",
        "languagePopulation": {
          "en": {
            "_populationPercent": "10"
          },
          "si": {
            "_populationPercent": "68",
            "_officialStatus": "official"
          },
          "ta": {
            "_populationPercent": "15",
            "_officialStatus": "official"
          }
        }
      },
      "LR": {
        "_gdp": "6112000000",
        "_literacyPercent": "60.8",
        "_population": "4809770",
        "languagePopulation": {
          "en": {
            "_populationPercent": "83",
            "_officialStatus": "official"
          },
          "ff": {
            "_populationPercent": "0"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "kpe": {
            "_populationPercent": "14"
          },
          "men": {
            "_populationPercent": "0.48"
          },
          "vai": {
            "_populationPercent": "2.6"
          },
          "vai_Latn": {
            "_populationPercent": "0"
          }
        }
      },
      "LS": {
        "_gdp": "6656000000",
        "_literacyPercent": "89.6",
        "_population": "1962460",
        "languagePopulation": {
          "en": {
            "_populationPercent": "27",
            "_officialStatus": "official"
          },
          "ss": {
            "_populationPercent": "2.4"
          },
          "st": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          },
          "xh": {
            "_populationPercent": "1"
          },
          "zu": {
            "_populationPercent": "14"
          }
        }
      },
      "LT": {
        "_gdp": "91470000000",
        "_literacyPercent": "99.7",
        "_population": "2793280",
        "languagePopulation": {
          "de": {
            "_populationPercent": "14"
          },
          "en": {
            "_populationPercent": "38"
          },
          "lt": {
            "_populationPercent": "86",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "80"
          },
          "sgs": {
            "_populationPercent": "0"
          }
        }
      },
      "LU": {
        "_gdp": "62110000000",
        "_literacyPercent": "100",
        "_population": "605764",
        "languagePopulation": {
          "de": {
            "_populationPercent": "63",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "56"
          },
          "fr": {
            "_populationPercent": "87",
            "_officialStatus": "official"
          },
          "lb": {
            "_writingPercent": "5",
            "_populationPercent": "67",
            "_officialStatus": "official"
          },
          "pt": {
            "_populationPercent": "16"
          }
        }
      },
      "LV": {
        "_gdp": "54020000000",
        "_literacyPercent": "99.8",
        "_population": "1923560",
        "languagePopulation": {
          "en": {
            "_populationPercent": "46"
          },
          "ltg": {
            "_populationPercent": "8.9"
          },
          "lv": {
            "_populationPercent": "61",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "38"
          }
        }
      },
      "LY": {
        "_gdp": "61970000000",
        "_literacyPercent": "89.5",
        "_population": "6754510",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "74",
            "_officialStatus": "official"
          }
        }
      },
      "MA": {
        "_gdp": "298600000000",
        "_literacyPercent": "67.1",
        "_population": "34314100",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "62",
            "_officialStatus": "official"
          },
          "ary": {
            "_populationPercent": "87"
          },
          "en": {
            "_populationPercent": "14"
          },
          "es": {
            "_populationPercent": "0.065"
          },
          "fr": {
            "_populationPercent": "20",
            "_officialStatus": "de_facto_official"
          },
          "rif": {
            "_writingPercent": "5",
            "_populationPercent": "4.9"
          },
          "rif_Latn": {
            "_writingPercent": "5",
            "_populationPercent": "4.9"
          },
          "shi": {
            "_populationPercent": "8.7"
          },
          "shi_Latn": {
            "_populationPercent": "8.7"
          },
          "tzm": {
            "_populationPercent": "9.8",
            "_literacyPercent": "25",
            "_officialStatus": "official"
          },
          "zgh": {
            "_populationPercent": "22"
          }
        }
      },
      "MC": {
        "_gdp": "7672000000",
        "_literacyPercent": "99",
        "_population": "30727",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          }
        }
      },
      "MD": {
        "_gdp": "23720000000",
        "_literacyPercent": "99",
        "_population": "3437720",
        "languagePopulation": {
          "bg": {
            "_populationPercent": "9.4"
          },
          "gag": {
            "_populationPercent": "3.3"
          },
          "ro": {
            "_populationPercent": "63",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "3"
          },
          "uk": {
            "_populationPercent": "14"
          }
        }
      },
      "ME": {
        "_gdp": "11080000000",
        "_literacyPercent": "98.5",
        "_population": "614249",
        "languagePopulation": {
          "sq": {
            "_populationPercent": "7.9"
          },
          "sr": {
            "_populationPercent": "5"
          },
          "sr_Latn": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "MF": {
        "_gdp": "561500000",
        "_literacyPercent": "99",
        "_population": "32284",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "MG": {
        "_gdp": "39850000000",
        "_literacyPercent": "64.5",
        "_population": "25683600",
        "languagePopulation": {
          "en": {
            "_populationPercent": "18",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "69",
            "_officialStatus": "official"
          },
          "mg": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          }
        }
      },
      "MH": {
        "_gdp": "196000000",
        "_literacyPercent": "93.7",
        "_population": "75684",
        "languagePopulation": {
          "en": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "mh": {
            "_populationPercent": "73",
            "_officialStatus": "official"
          }
        }
      },
      "MK": {
        "_gdp": "31030000000",
        "_literacyPercent": "97.4",
        "_population": "2118950",
        "languagePopulation": {
          "mk": {
            "_populationPercent": "67",
            "_officialStatus": "official"
          },
          "sq": {
            "_populationPercent": "25",
            "_officialStatus": "official_regional"
          },
          "tr": {
            "_populationPercent": "3.5"
          }
        }
      },
      "ML": {
        "_gdp": "41220000000",
        "_literacyPercent": "33.4",
        "_population": "18429900",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "0.89"
          },
          "bm": {
            "_populationPercent": "46"
          },
          "bm_Nkoo": {
            "_populationPercent": "2"
          },
          "bmq": {
            "_populationPercent": "0.86"
          },
          "bze": {
            "_populationPercent": "0.84"
          },
          "dtm": {
            "_populationPercent": "1.1"
          },
          "ffm": {
            "_populationPercent": "7.7"
          },
          "fr": {
            "_populationPercent": "46",
            "_officialStatus": "official"
          },
          "kao": {
            "_populationPercent": "1"
          },
          "khq": {
            "_populationPercent": "1.7"
          },
          "mwk": {
            "_populationPercent": "5"
          },
          "ses": {
            "_populationPercent": "3.4"
          },
          "snk": {
            "_populationPercent": "5.9"
          },
          "tmh": {
            "_populationPercent": "2.1"
          }
        }
      },
      "MM": {
        "_gdp": "329800000000",
        "_literacyPercent": "92.7",
        "_population": "55622500",
        "languagePopulation": {
          "kac": {
            "_populationPercent": "1.7"
          },
          "kht": {
            "_populationPercent": "0.0076"
          },
          "mnw": {
            "_populationPercent": "1.5"
          },
          "my": {
            "_populationPercent": "64",
            "_officialStatus": "official"
          },
          "shn": {
            "_populationPercent": "6.4"
          }
        }
      },
      "MN": {
        "_gdp": "39730000000",
        "_literacyPercent": "97.4",
        "_population": "3103430",
        "languagePopulation": {
          "kk_Arab": {
            "_populationPercent": "7.2"
          },
          "mn": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "0.13"
          },
          "ug_Cyrl": {
            "_populationPercent": "0.032"
          },
          "zh": {
            "_populationPercent": "1.4"
          }
        }
      },
      "MO": {
        "_gdp": "71820000000",
        "_literacyPercent": "95.6",
        "_population": "606340",
        "languagePopulation": {
          "en": {
            "_populationPercent": "2.3"
          },
          "pt": {
            "_populationPercent": "5",
            "_officialStatus": "official"
          },
          "zh": {
            "_populationPercent": "5"
          },
          "zh_Hant": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "MP": {
        "_gdp": "1242000000",
        "_literacyPercent": "97",
        "_population": "51994",
        "languagePopulation": {
          "ch": {
            "_populationPercent": "18"
          },
          "en": {
            "_populationPercent": "97",
            "_officialStatus": "de_facto_official"
          }
        }
      },
      "MQ": {
        "_gdp": "6117000000",
        "_literacyPercent": "98",
        "_population": "436131",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "MR": {
        "_gdp": "17280000000",
        "_literacyPercent": "58.6",
        "_population": "3840430",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "85",
            "_officialStatus": "official"
          },
          "ff": {
            "_populationPercent": "5.7"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "fr": {
            "_populationPercent": "17"
          },
          "wo": {
            "_populationPercent": "0.26"
          }
        }
      },
      "MS": {
        "_gdp": "167400000",
        "_literacyPercent": "97",
        "_population": "5315",
        "languagePopulation": {
          "en": {
            "_populationPercent": "66",
            "_officialStatus": "official"
          }
        }
      },
      "MT": {
        "_gdp": "19260000000",
        "_literacyPercent": "92.4",
        "_population": "449043",
        "languagePopulation": {
          "en": {
            "_populationPercent": "88",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "11"
          },
          "it": {
            "_populationPercent": "56"
          },
          "mt": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "MU": {
        "_gdp": "28270000000",
        "_literacyPercent": "88.8",
        "_population": "1364280",
        "languagePopulation": {
          "bho": {
            "_populationPercent": "27"
          },
          "en": {
            "_populationPercent": "72",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "3",
            "_officialStatus": "official"
          },
          "mfe": {
            "_populationPercent": "90"
          },
          "ta": {
            "_populationPercent": "2.5"
          },
          "ur": {
            "_populationPercent": "5.2"
          }
        }
      },
      "MV": {
        "_gdp": "6901000000",
        "_literacyPercent": "98.4",
        "_population": "392473",
        "languagePopulation": {
          "dv": {
            "_populationPercent": "94",
            "_officialStatus": "official"
          }
        }
      },
      "MW": {
        "_gdp": "22420000000",
        "_literacyPercent": "74.8",
        "_population": "19842600",
        "languagePopulation": {
          "en": {
            "_populationPercent": "63",
            "_officialStatus": "official"
          },
          "ny": {
            "_populationPercent": "63",
            "_officialStatus": "official"
          },
          "tog": {
            "_populationPercent": "0.98"
          },
          "tum": {
            "_populationPercent": "8.4"
          },
          "zu": {
            "_populationPercent": "0.33"
          }
        }
      },
      "MX": {
        "_gdp": "2463000000000",
        "_literacyPercent": "93.5",
        "_population": "125959000",
        "languagePopulation": {
          "en": {
            "_populationPercent": "13"
          },
          "es": {
            "_populationPercent": "83",
            "_officialStatus": "de_facto_official"
          },
          "maz": {
            "_populationPercent": "0.34"
          },
          "nch": {
            "_populationPercent": "0.19"
          },
          "nhe": {
            "_populationPercent": "0.39"
          },
          "nhw": {
            "_populationPercent": "0.39"
          },
          "sei": {
            "_populationPercent": "0.0007"
          },
          "yua": {
            "_populationPercent": "0.67"
          }
        }
      },
      "MY": {
        "_gdp": "933300000000",
        "_literacyPercent": "93.1",
        "_population": "31809700",
        "languagePopulation": {
          "bjn": {
            "_populationPercent": "0.016"
          },
          "bug": {
            "_populationPercent": "0.079"
          },
          "dtp": {
            "_populationPercent": "0.56"
          },
          "en": {
            "_populationPercent": "21"
          },
          "iba": {
            "_populationPercent": "2.5"
          },
          "jv": {
            "_populationPercent": "1.2"
          },
          "ml": {
            "_populationPercent": "0.15"
          },
          "ms": {
            "_populationPercent": "75",
            "_officialStatus": "official"
          },
          "ta": {
            "_populationPercent": "4.2"
          },
          "zh_Hant": {
            "_populationPercent": "17"
          },
          "zmi": {
            "_populationPercent": "1.2"
          }
        }
      },
      "MZ": {
        "_gdp": "37090000000",
        "_literacyPercent": "56.1",
        "_population": "27233800",
        "languagePopulation": {
          "mgh": {
            "_populationPercent": "4.5"
          },
          "ndc": {
            "_populationPercent": "9.9"
          },
          "ngl": {
            "_populationPercent": "6.8"
          },
          "ny": {
            "_populationPercent": "2.6"
          },
          "pt": {
            "_populationPercent": "27",
            "_officialStatus": "official"
          },
          "rng": {
            "_populationPercent": "3.4"
          },
          "seh": {
            "_populationPercent": "4.6"
          },
          "sw": {
            "_populationPercent": "0.034"
          },
          "ts": {
            "_populationPercent": "7.9"
          },
          "vmw": {
            "_populationPercent": "13"
          },
          "yao": {
            "_populationPercent": "2.4"
          },
          "zu": {
            "_populationPercent": "0.0066"
          }
        }
      },
      "NA": {
        "_gdp": "26600000000",
        "_literacyPercent": "88.8",
        "_population": "2533220",
        "languagePopulation": {
          "af": {
            "_populationPercent": "75"
          },
          "de": {
            "_populationPercent": "0.9"
          },
          "en": {
            "_populationPercent": "7",
            "_officialStatus": "official"
          },
          "hz": {
            "_populationPercent": "9.1"
          },
          "kj": {
            "_populationPercent": "35"
          },
          "naq": {
            "_populationPercent": "11"
          },
          "ng": {
            "_populationPercent": "21"
          },
          "tn": {
            "_populationPercent": "0.56"
          }
        }
      },
      "NC": {
        "_gdp": "11110000000",
        "_literacyPercent": "96.2",
        "_population": "282754",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          }
        }
      },
      "NE": {
        "_gdp": "21860000000",
        "_literacyPercent": "28.7",
        "_population": "19866200",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "0.21"
          },
          "dje": {
            "_populationPercent": "17"
          },
          "ff": {
            "_populationPercent": "0"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "fr": {
            "_populationPercent": "29",
            "_officialStatus": "official"
          },
          "fuq": {
            "_populationPercent": "7"
          },
          "ha": {
            "_populationPercent": "41"
          },
          "tmh": {
            "_populationPercent": "6"
          },
          "twq": {
            "_populationPercent": "0.04"
          }
        }
      },
      "NF": {
        "_gdp": "92950000",
        "_literacyPercent": "99",
        "_population": "1748",
        "languagePopulation": {
          "en": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          }
        }
      },
      "NG": {
        "_gdp": "1121000000000",
        "_literacyPercent": "61.3",
        "_population": "203453000",
        "languagePopulation": {
          "amo": {
            "_populationPercent": "0.0088"
          },
          "ar": {
            "_populationPercent": "0.071"
          },
          "bin": {
            "_populationPercent": "0.71"
          },
          "cch": {
            "_populationPercent": "0.021"
          },
          "efi": {
            "_populationPercent": "1.4"
          },
          "en": {
            "_populationPercent": "53",
            "_officialStatus": "official"
          },
          "ff": {
            "_populationPercent": "0"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "fuv": {
            "_populationPercent": "6.7",
            "_literacyPercent": "20"
          },
          "ha": {
            "_populationPercent": "13"
          },
          "ha_Arab": {
            "_populationPercent": "1"
          },
          "ibb": {
            "_populationPercent": "1.4"
          },
          "ig": {
            "_populationPercent": "13"
          },
          "kaj": {
            "_populationPercent": "0.21"
          },
          "kcg": {
            "_populationPercent": "0.093"
          },
          "pcm": {
            "_populationPercent": "21"
          },
          "tiv": {
            "_populationPercent": "1.6",
            "_literacyPercent": "25"
          },
          "yo": {
            "_populationPercent": "13",
            "_officialStatus": "official"
          }
        }
      },
      "NI": {
        "_gdp": "36400000000",
        "_literacyPercent": "78",
        "_population": "6085210",
        "languagePopulation": {
          "es": {
            "_populationPercent": "78",
            "_officialStatus": "official"
          }
        }
      },
      "NL": {
        "_gdp": "924400000000",
        "_literacyPercent": "99",
        "_population": "17151200",
        "languagePopulation": {
          "de": {
            "_writingPercent": "5",
            "_populationPercent": "71"
          },
          "en": {
            "_populationPercent": "90"
          },
          "fr": {
            "_populationPercent": "29"
          },
          "fy": {
            "_populationPercent": "4.3",
            "_officialStatus": "official_regional"
          },
          "gos": {
            "_writingPercent": "5",
            "_populationPercent": "3.6"
          },
          "id": {
            "_populationPercent": "1.8"
          },
          "li": {
            "_writingPercent": "5",
            "_populationPercent": "5.5"
          },
          "nds": {
            "_writingPercent": "5",
            "_populationPercent": "11"
          },
          "nl": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "rif_Latn": {
            "_populationPercent": "1.2"
          },
          "tr": {
            "_populationPercent": "1.2"
          },
          "zea": {
            "_populationPercent": "1.4"
          }
        }
      },
      "NO": {
        "_gdp": "381200000000",
        "_literacyPercent": "100",
        "_population": "5372190",
        "languagePopulation": {
          "nb": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "nn": {
            "_populationPercent": "25",
            "_officialStatus": "official"
          },
          "se": {
            "_populationPercent": "0.29",
            "_officialStatus": "official_regional"
          }
        }
      },
      "NP": {
        "_gdp": "79190000000",
        "_literacyPercent": "57.4",
        "_population": "29717600",
        "languagePopulation": {
          "awa": {
            "_populationPercent": "2.2"
          },
          "bap": {
            "_populationPercent": "1.5"
          },
          "bfy": {
            "_populationPercent": "0.54"
          },
          "bho": {
            "_populationPercent": "6.8"
          },
          "bn": {
            "_populationPercent": "0.094"
          },
          "bo": {
            "_populationPercent": "0.24"
          },
          "dty": {
            "_populationPercent": "2.5"
          },
          "en": {
            "_populationPercent": "3"
          },
          "gvr": {
            "_populationPercent": "0.71"
          },
          "hi": {
            "_populationPercent": "0.42"
          },
          "jml": {
            "_populationPercent": "3.2"
          },
          "lep": {
            "_populationPercent": "0.0095"
          },
          "lif": {
            "_populationPercent": "1.1"
          },
          "mai": {
            "_populationPercent": "11"
          },
          "mgp": {
            "_populationPercent": "1.1"
          },
          "mrd": {
            "_populationPercent": "0.83"
          },
          "ne": {
            "_populationPercent": "44",
            "_officialStatus": "official"
          },
          "new": {
            "_populationPercent": "3.3"
          },
          "rjs": {
            "_populationPercent": "0.44",
            "_literacyPercent": "67"
          },
          "taj": {
            "_populationPercent": "3.43"
          },
          "tdg": {
            "_populationPercent": "1.3"
          },
          "tdh": {
            "_populationPercent": "0.12"
          },
          "thl": {
            "_populationPercent": "2"
          },
          "thq": {
            "_populationPercent": "1"
          },
          "thr": {
            "_populationPercent": "1.2"
          },
          "tkt": {
            "_populationPercent": "0.24"
          },
          "unr_Deva": {
            "_populationPercent": "0.019"
          },
          "xsr": {
            "_populationPercent": "0.52"
          }
        }
      },
      "NR": {
        "_gdp": "160000000",
        "_literacyPercent": "99",
        "_population": "9692",
        "languagePopulation": {
          "en": {
            "_populationPercent": "97",
            "_officialStatus": "official"
          },
          "na": {
            "_populationPercent": "71",
            "_officialStatus": "official"
          }
        }
      },
      "NU": {
        "_gdp": "10010000",
        "_literacyPercent": "95",
        "_population": "1618",
        "languagePopulation": {
          "en": {
            "_populationPercent": "70",
            "_officialStatus": "official"
          },
          "niu": {
            "_populationPercent": "70",
            "_officialStatus": "official"
          }
        }
      },
      "NZ": {
        "_gdp": "189000000000",
        "_literacyPercent": "99",
        "_population": "4545630",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "de_facto_official"
          },
          "mi": {
            "_populationPercent": "2.8",
            "_officialStatus": "official"
          }
        }
      },
      "OM": {
        "_gdp": "190100000000",
        "_literacyPercent": "86.9",
        "_population": "3494120",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "81",
            "_officialStatus": "official"
          },
          "bal": {
            "_populationPercent": "4.9"
          },
          "fa": {
            "_populationPercent": "0.94"
          }
        }
      },
      "PA": {
        "_gdp": "104100000000",
        "_literacyPercent": "94.1",
        "_population": "3800640",
        "languagePopulation": {
          "en": {
            "_populationPercent": "14"
          },
          "es": {
            "_populationPercent": "69",
            "_officialStatus": "official"
          },
          "zh_Hant": {
            "_populationPercent": "0.16"
          }
        }
      },
      "PE": {
        "_gdp": "430300000000",
        "_literacyPercent": "89.6",
        "_population": "31331200",
        "languagePopulation": {
          "ay": {
            "_populationPercent": "1.6"
          },
          "es": {
            "_populationPercent": "73",
            "_officialStatus": "official"
          },
          "qu": {
            "_populationPercent": "15",
            "_officialStatus": "official"
          }
        }
      },
      "PF": {
        "_gdp": "5490000000",
        "_literacyPercent": "98",
        "_population": "290373",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "61",
            "_officialStatus": "official"
          },
          "ty": {
            "_populationPercent": "31",
            "_officialStatus": "official"
          },
          "zh_Hant": {
            "_populationPercent": "7.8"
          }
        }
      },
      "PG": {
        "_gdp": "30190000000",
        "_literacyPercent": "62.4",
        "_population": "7027330",
        "languagePopulation": {
          "en": {
            "_populationPercent": "50",
            "_officialStatus": "official"
          },
          "ho": {
            "_writingPercent": "5",
            "_populationPercent": "2.1",
            "_officialStatus": "official"
          },
          "tpi": {
            "_populationPercent": "71",
            "_literacyPercent": "45",
            "_officialStatus": "official"
          }
        }
      },
      "PH": {
        "_gdp": "877200000000",
        "_literacyPercent": "95.4",
        "_population": "105893000",
        "languagePopulation": {
          "bhk": {
            "_populationPercent": "2.3"
          },
          "bik": {
            "_populationPercent": "3"
          },
          "bku": {
            "_populationPercent": "0.0076"
          },
          "bto": {
            "_populationPercent": "0.28"
          },
          "ceb": {
            "_populationPercent": "24",
            "_literacyPercent": "13",
            "_officialStatus": "official_regional"
          },
          "cps": {
            "_populationPercent": "0.66"
          },
          "en": {
            "_populationPercent": "64",
            "_officialStatus": "official"
          },
          "es": {
            "_populationPercent": "31"
          },
          "fil": {
            "_populationPercent": "60",
            "_officialStatus": "official"
          },
          "hil": {
            "_populationPercent": "8.4",
            "_literacyPercent": "8",
            "_officialStatus": "official_regional"
          },
          "hnn": {
            "_populationPercent": "0.016"
          },
          "ilo": {
            "_populationPercent": "9.6",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "krj": {
            "_populationPercent": "0.39"
          },
          "mdh": {
            "_populationPercent": "1.2",
            "_officialStatus": "official_regional"
          },
          "pag": {
            "_populationPercent": "1.4",
            "_officialStatus": "official_regional"
          },
          "pam": {
            "_populationPercent": "2.3"
          },
          "tbw": {
            "_populationPercent": "0.0094",
            "_literacyPercent": "36"
          },
          "tsg": {
            "_populationPercent": "1.1",
            "_officialStatus": "official_regional"
          },
          "war": {
            "_populationPercent": "2.9",
            "_officialStatus": "official_regional"
          },
          "zh_Hant": {
            "_populationPercent": "0.73"
          }
        }
      },
      "PK": {
        "_gdp": "1061000000000",
        "_literacyPercent": "54.9",
        "_population": "207863000",
        "languagePopulation": {
          "bal": {
            "_populationPercent": "3.7"
          },
          "bft": {
            "_populationPercent": "0.18"
          },
          "bgn": {
            "_writingPercent": "5",
            "_populationPercent": "0.57"
          },
          "brh": {
            "_populationPercent": "1.3"
          },
          "btv": {
            "_populationPercent": "0.019"
          },
          "en": {
            "_populationPercent": "50",
            "_officialStatus": "official"
          },
          "fa": {
            "_populationPercent": "0.66"
          },
          "gjk": {
            "_populationPercent": "0.11"
          },
          "gju": {
            "_populationPercent": "0.2"
          },
          "hnd": {
            "_populationPercent": "0.41"
          },
          "hno": {
            "_populationPercent": "1.2"
          },
          "khw": {
            "_populationPercent": "0.15"
          },
          "ks": {
            "_populationPercent": "0.069"
          },
          "kvx": {
            "_populationPercent": "0.16"
          },
          "kxp": {
            "_populationPercent": "0.12"
          },
          "lah": {
            "_populationPercent": "40"
          },
          "mvy": {
            "_populationPercent": "0.14"
          },
          "pa_Arab": {
            "_populationPercent": "70"
          },
          "ps": {
            "_populationPercent": "15"
          },
          "sd": {
            "_populationPercent": "12"
          },
          "skr": {
            "_populationPercent": "9.1",
            "_literacyPercent": "1"
          },
          "tg_Arab": {
            "_populationPercent": "0.33"
          },
          "ur": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "PL": {
        "_gdp": "1126000000000",
        "_literacyPercent": "99.7",
        "_population": "38420700",
        "languagePopulation": {
          "be": {
            "_populationPercent": "0.58"
          },
          "csb": {
            "_populationPercent": "0.13",
            "_officialStatus": "official_regional"
          },
          "de": {
            "_populationPercent": "19",
            "_officialStatus": "official_regional"
          },
          "en": {
            "_populationPercent": "33"
          },
          "lt": {
            "_populationPercent": "0.021",
            "_officialStatus": "official_regional"
          },
          "pl": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "18"
          },
          "sli": {
            "_populationPercent": "0.031"
          },
          "szl": {
            "_populationPercent": "1.3"
          },
          "uk": {
            "_populationPercent": "0.39"
          }
        }
      },
      "PM": {
        "_gdp": "261300000",
        "_literacyPercent": "99",
        "_population": "5471",
        "languagePopulation": {
          "en": {
            "_populationPercent": "3.4"
          },
          "fr": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          }
        }
      },
      "PN": {
        "_gdp": "2426000",
        "_literacyPercent": "99",
        "_population": "54",
        "languagePopulation": {
          "en": {
            "_populationPercent": "85",
            "_officialStatus": "official"
          }
        }
      },
      "PR": {
        "_gdp": "130000000000",
        "_literacyPercent": "90.3",
        "_population": "3294630",
        "languagePopulation": {
          "en": {
            "_populationPercent": "49",
            "_officialStatus": "de_facto_official"
          },
          "es": {
            "_populationPercent": "87",
            "_officialStatus": "official"
          }
        }
      },
      "PS": {
        "_gdp": "21220000000",
        "_literacyPercent": "95.3",
        "_population": "4635210",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "PT": {
        "_gdp": "314100000000",
        "_literacyPercent": "95.4",
        "_population": "10355500",
        "languagePopulation": {
          "en": {
            "_populationPercent": "27"
          },
          "es": {
            "_populationPercent": "10"
          },
          "fr": {
            "_populationPercent": "15"
          },
          "gl": {
            "_populationPercent": "0.14"
          },
          "pt": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          }
        }
      },
      "PW": {
        "_gdp": "264000000",
        "_literacyPercent": "92",
        "_population": "21516",
        "languagePopulation": {
          "en": {
            "_populationPercent": "8.7",
            "_officialStatus": "official"
          },
          "pau": {
            "_populationPercent": "74",
            "_officialStatus": "official"
          }
        }
      },
      "PY": {
        "_gdp": "88910000000",
        "_literacyPercent": "93.9",
        "_population": "7025760",
        "languagePopulation": {
          "de": {
            "_populationPercent": "2.9"
          },
          "es": {
            "_populationPercent": "3.2",
            "_officialStatus": "official"
          },
          "gn": {
            "_populationPercent": "80",
            "_officialStatus": "official"
          }
        }
      },
      "QA": {
        "_gdp": "339500000000",
        "_literacyPercent": "96.3",
        "_population": "2363570",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "89",
            "_officialStatus": "official"
          },
          "fa": {
            "_populationPercent": "11"
          },
          "ml": {
            "_populationPercent": "0.28"
          }
        }
      },
      "RE": {
        "_gdp": "4791000000",
        "_literacyPercent": "88",
        "_population": "787584",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "89",
            "_officialStatus": "official"
          },
          "rcf": {
            "_populationPercent": "71"
          },
          "ta": {
            "_populationPercent": "15"
          }
        }
      },
      "RO": {
        "_gdp": "483400000000",
        "_literacyPercent": "97.7",
        "_population": "21457100",
        "languagePopulation": {
          "bg": {
            "_populationPercent": "0.031"
          },
          "de": {
            "_populationPercent": "0.21"
          },
          "el": {
            "_populationPercent": "0.019"
          },
          "en": {
            "_populationPercent": "31"
          },
          "es": {
            "_populationPercent": "10"
          },
          "fr": {
            "_populationPercent": "17"
          },
          "hu": {
            "_populationPercent": "6.6"
          },
          "pl": {
            "_populationPercent": "0.013"
          },
          "ro": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          },
          "sr_Latn": {
            "_populationPercent": "0.12"
          },
          "tr": {
            "_populationPercent": "0.13"
          }
        }
      },
      "RS": {
        "_gdp": "105700000000",
        "_literacyPercent": "98",
        "_population": "7078110",
        "languagePopulation": {
          "hr": {
            "_populationPercent": "0.93",
            "_officialStatus": "official_regional"
          },
          "hu": {
            "_populationPercent": "4.8",
            "_officialStatus": "official_regional"
          },
          "ro": {
            "_populationPercent": "2.1",
            "_officialStatus": "official_regional"
          },
          "sk": {
            "_populationPercent": "0.86",
            "_officialStatus": "official_regional"
          },
          "sq": {
            "_populationPercent": "19"
          },
          "sr": {
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "sr_Latn": {
            "_writingPercent": "5",
            "_populationPercent": "99",
            "_officialStatus": "official"
          },
          "uk": {
            "_populationPercent": "0",
            "_officialStatus": "official_regional"
          }
        }
      },
      "RU": {
        "_gdp": "4016000000000",
        "_literacyPercent": "99.7",
        "_population": "142123000",
        "languagePopulation": {
          "ady": {
            "_populationPercent": "0.088",
            "_officialStatus": "official_regional"
          },
          "alt": {
            "_populationPercent": "0.014"
          },
          "av": {
            "_populationPercent": "0.39",
            "_officialStatus": "official_regional"
          },
          "az_Cyrl": {
            "_populationPercent": "0.093",
            "_officialStatus": "official_regional"
          },
          "ba": {
            "_populationPercent": "1.3",
            "_officialStatus": "official_regional"
          },
          "bua": {
            "_populationPercent": "0.22"
          },
          "ce": {
            "_populationPercent": "0.66",
            "_officialStatus": "official_regional"
          },
          "chm": {
            "_populationPercent": "0.37"
          },
          "cu": {
            "_populationPercent": "0"
          },
          "cv": {
            "_populationPercent": "1.3"
          },
          "dar": {
            "_populationPercent": "0.26"
          },
          "fi": {
            "_populationPercent": "0.012"
          },
          "hy": {
            "_populationPercent": "0.84",
            "_literacyPercent": "50"
          },
          "inh": {
            "_populationPercent": "0.16",
            "_officialStatus": "official_regional"
          },
          "izh": {
            "_populationPercent": "0.0001"
          },
          "kbd": {
            "_populationPercent": "0.31",
            "_officialStatus": "official_regional"
          },
          "koi": {
            "_populationPercent": "0.045",
            "_officialStatus": "official_regional"
          },
          "krc": {
            "_populationPercent": "0.17",
            "_officialStatus": "official_regional"
          },
          "krl": {
            "_populationPercent": "0.082"
          },
          "kum": {
            "_populationPercent": "0.2",
            "_officialStatus": "official_regional"
          },
          "kv": {
            "_populationPercent": "0.18",
            "_officialStatus": "official_regional"
          },
          "lbe": {
            "_populationPercent": "0.078",
            "_officialStatus": "official_regional"
          },
          "lez": {
            "_populationPercent": "0.18",
            "_officialStatus": "official_regional"
          },
          "mdf": {
            "_populationPercent": "0.21",
            "_officialStatus": "official_regional"
          },
          "mn": {
            "_populationPercent": "0.0015"
          },
          "mrj": {
            "_populationPercent": "0.021"
          },
          "myv": {
            "_populationPercent": "0.31",
            "_officialStatus": "official_regional"
          },
          "os": {
            "_populationPercent": "0.32"
          },
          "ru": {
            "_populationPercent": "94",
            "_officialStatus": "official"
          },
          "sah": {
            "_populationPercent": "0.32",
            "_officialStatus": "official_regional"
          },
          "sr_Latn": {
            "_populationPercent": "0.0035"
          },
          "tt": {
            "_populationPercent": "1.4",
            "_officialStatus": "official_regional"
          },
          "tyv": {
            "_populationPercent": "0.13",
            "_officialStatus": "official_regional"
          },
          "udm": {
            "_populationPercent": "0.38",
            "_officialStatus": "official_regional"
          },
          "vep": {
            "_populationPercent": "0.0025"
          },
          "vot": {
            "_populationPercent": "0"
          }
        }
      },
      "RW": {
        "_gdp": "24680000000",
        "_literacyPercent": "71.1",
        "_population": "12187400",
        "languagePopulation": {
          "en": {
            "_populationPercent": "15",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "0.019",
            "_officialStatus": "official"
          },
          "rw": {
            "_populationPercent": "77",
            "_officialStatus": "official"
          }
        }
      },
      "SA": {
        "_gdp": "1775000000000",
        "_literacyPercent": "87.2",
        "_population": "33091100",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "SB": {
        "_gdp": "1330000000",
        "_literacyPercent": "84.1",
        "_population": "660121",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "rug": {
            "_populationPercent": "1.5"
          }
        }
      },
      "SC": {
        "_gdp": "2750000000",
        "_literacyPercent": "91.8",
        "_population": "94633",
        "languagePopulation": {
          "crs": {
            "_populationPercent": "98"
          },
          "en": {
            "_populationPercent": "38",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "60",
            "_officialStatus": "official"
          }
        }
      },
      "SD": {
        "_gdp": "177400000000",
        "_literacyPercent": "71.9",
        "_population": "43120800",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "61",
            "_officialStatus": "official"
          },
          "bej": {
            "_populationPercent": "5.4"
          },
          "en": {
            "_populationPercent": "61",
            "_officialStatus": "official"
          },
          "fia": {
            "_populationPercent": "0.83"
          },
          "fvr": {
            "_populationPercent": "2.7"
          },
          "ha_Arab": {
            "_populationPercent": "1.8"
          },
          "mls": {
            "_populationPercent": "0.99"
          },
          "zag": {
            "_populationPercent": "0.51"
          }
        }
      },
      "SE": {
        "_gdp": "518000000000",
        "_literacyPercent": "99",
        "_population": "10041000",
        "languagePopulation": {
          "en": {
            "_populationPercent": "86"
          },
          "fi": {
            "_populationPercent": "2.2",
            "_officialStatus": "official_regional"
          },
          "fit": {
            "_populationPercent": "0.55"
          },
          "ia": {
            "_populationPercent": "0"
          },
          "rmu": {
            "_populationPercent": "0.095"
          },
          "se": {
            "_populationPercent": "0.33"
          },
          "sma": {
            "_populationPercent": "0.003",
            "_literacyPercent": "75"
          },
          "smj": {
            "_populationPercent": "0.015"
          },
          "sv": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          },
          "yi": {
            "_populationPercent": "0.03"
          }
        }
      },
      "SG": {
        "_gdp": "528100000000",
        "_literacyPercent": "95.9",
        "_population": "5995990",
        "languagePopulation": {
          "en": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "ml": {
            "_populationPercent": "0.17"
          },
          "ms": {
            "_populationPercent": "14",
            "_officialStatus": "official"
          },
          "pa": {
            "_populationPercent": "0.16"
          },
          "ta": {
            "_populationPercent": "2.1",
            "_officialStatus": "official"
          },
          "zh": {
            "_populationPercent": "77",
            "_officialStatus": "official"
          }
        }
      },
      "SH": {
        "_gdp": "31100000",
        "_literacyPercent": "97",
        "_population": "7841",
        "languagePopulation": {
          "en": {
            "_populationPercent": "69",
            "_officialStatus": "official"
          }
        }
      },
      "SI": {
        "_gdp": "71230000000",
        "_literacyPercent": "99.7",
        "_population": "2102130",
        "languagePopulation": {
          "de": {
            "_populationPercent": "42"
          },
          "en": {
            "_populationPercent": "59"
          },
          "hr": {
            "_populationPercent": "61"
          },
          "hu": {
            "_populationPercent": "0.44"
          },
          "it": {
            "_populationPercent": "0.19"
          },
          "sl": {
            "_populationPercent": "87",
            "_officialStatus": "official"
          }
        }
      },
      "SJ": {
        "_gdp": "183300000",
        "_literacyPercent": "100",
        "_population": "2583",
        "languagePopulation": {
          "nb": {
            "_populationPercent": "58",
            "_officialStatus": "official"
          },
          "ru": {
            "_populationPercent": "46"
          }
        }
      },
      "SK": {
        "_gdp": "179700000000",
        "_literacyPercent": "99.6",
        "_population": "5445040",
        "languagePopulation": {
          "cs": {
            "_populationPercent": "47"
          },
          "de": {
            "_populationPercent": "22"
          },
          "en": {
            "_populationPercent": "26"
          },
          "hu": {
            "_populationPercent": "11"
          },
          "pl": {
            "_populationPercent": "0.93"
          },
          "sk": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          },
          "uk": {
            "_populationPercent": "1.9"
          }
        }
      },
      "SL": {
        "_gdp": "11550000000",
        "_literacyPercent": "43.3",
        "_population": "6312210",
        "languagePopulation": {
          "en": {
            "_populationPercent": "35",
            "_officialStatus": "official"
          },
          "ff": {
            "_populationPercent": "0"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "kri": {
            "_populationPercent": "95"
          },
          "men": {
            "_populationPercent": "27"
          },
          "tem": {
            "_populationPercent": "26",
            "_literacyPercent": "6"
          }
        }
      },
      "SM": {
        "_gdp": "2064000000",
        "_literacyPercent": "96",
        "_population": "33779",
        "languagePopulation": {
          "eo": {
            "_populationPercent": "0.89"
          },
          "it": {
            "_populationPercent": "89",
            "_officialStatus": "official"
          }
        }
      },
      "SN": {
        "_gdp": "54800000000",
        "_literacyPercent": "49.7",
        "_population": "15020900",
        "languagePopulation": {
          "bjt": {
            "_populationPercent": "0.61",
            "_literacyPercent": "100",
            "_officialStatus": "official_regional"
          },
          "bsc": {
            "_populationPercent": "0.097",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "dyo": {
            "_populationPercent": "2.6",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "ff": {
            "_populationPercent": "21",
            "_officialStatus": "official_regional"
          },
          "ff_Adlm": {
            "_populationPercent": "0"
          },
          "fr": {
            "_populationPercent": "39",
            "_literacyPercent": "100",
            "_officialStatus": "official"
          },
          "knf": {
            "_populationPercent": "0.21",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "mey": {
            "_populationPercent": "0.048",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "mfv": {
            "_populationPercent": "0.77",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "sav": {
            "_populationPercent": "1.5",
            "_officialStatus": "official_regional"
          },
          "snf": {
            "_populationPercent": "0.24",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "srr": {
            "_populationPercent": "11",
            "_officialStatus": "official_regional"
          },
          "tnr": {
            "_populationPercent": "0.023",
            "_literacyPercent": "10",
            "_officialStatus": "official_regional"
          },
          "wo": {
            "_populationPercent": "70",
            "_officialStatus": "de_facto_official"
          }
        }
      },
      "SO": {
        "_gdp": "20440000000",
        "_literacyPercent": "37.8",
        "_population": "11259000",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "34",
            "_literacyPercent": "99",
            "_officialStatus": "official"
          },
          "om": {
            "_populationPercent": "0.42"
          },
          "so": {
            "_populationPercent": "78",
            "_officialStatus": "official"
          },
          "sw": {
            "_populationPercent": "2"
          }
        }
      },
      "SR": {
        "_gdp": "8688000000",
        "_literacyPercent": "94.7",
        "_population": "597927",
        "languagePopulation": {
          "nl": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          },
          "srn": {
            "_populationPercent": "68",
            "_literacyPercent": "75"
          },
          "zh_Hant": {
            "_populationPercent": "1.2"
          }
        }
      },
      "SS": {
        "_gdp": "20010000000",
        "_literacyPercent": "27",
        "_population": "10204600",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "27"
          },
          "en": {
            "_populationPercent": "27",
            "_officialStatus": "official"
          },
          "nus": {
            "_populationPercent": "5.6"
          }
        }
      },
      "ST": {
        "_gdp": "686000000",
        "_literacyPercent": "69.5",
        "_population": "204454",
        "languagePopulation": {
          "pt": {
            "_populationPercent": "85",
            "_officialStatus": "official"
          }
        }
      },
      "SV": {
        "_gdp": "51170000000",
        "_literacyPercent": "84.5",
        "_population": "6187270",
        "languagePopulation": {
          "es": {
            "_populationPercent": "89",
            "_officialStatus": "official"
          }
        }
      },
      "SX": {
        "_gdp": "365800000",
        "_literacyPercent": "99",
        "_population": "42677",
        "languagePopulation": {
          "en": {
            "_populationPercent": "68",
            "_officialStatus": "official"
          },
          "es": {
            "_populationPercent": "11"
          },
          "nl": {
            "_populationPercent": "3.7",
            "_officialStatus": "official"
          },
          "vic": {
            "_populationPercent": "7.3"
          }
        }
      },
      "SY": {
        "_gdp": "50280000000",
        "_literacyPercent": "84.1",
        "_population": "19454300",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "80",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "5.9",
            "_officialStatus": "official"
          },
          "hy": {
            "_populationPercent": "1.8"
          },
          "ku": {
            "_populationPercent": "8"
          },
          "syr": {
            "_writingPercent": "5",
            "_populationPercent": "0.084"
          }
        }
      },
      "SZ": {
        "_gdp": "11600000000",
        "_literacyPercent": "87.8",
        "_population": "1087200",
        "languagePopulation": {
          "en": {
            "_populationPercent": "80",
            "_officialStatus": "official"
          },
          "ss": {
            "_populationPercent": "58",
            "_officialStatus": "official"
          },
          "ts": {
            "_populationPercent": "1.7"
          },
          "zu": {
            "_populationPercent": "6.8"
          }
        }
      },
      "TA": {
        "_gdp": "12350000",
        "_literacyPercent": "99",
        "_population": "275",
        "languagePopulation": {
          "en": {
            "_populationPercent": "99"
          }
        }
      },
      "TC": {
        "_gdp": "632000000",
        "_literacyPercent": "98",
        "_population": "53701",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "TD": {
        "_gdp": "28620000000",
        "_literacyPercent": "35.4",
        "_population": "15833100",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "17",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "26",
            "_officialStatus": "official"
          }
        }
      },
      "TF": {
        "_gdp": "5935000",
        "_literacyPercent": "99",
        "_population": "140",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "100",
            "_literacyPercent": "100"
          }
        }
      },
      "TG": {
        "_gdp": "12970000000",
        "_literacyPercent": "60.4",
        "_population": "8176450",
        "languagePopulation": {
          "ee": {
            "_populationPercent": "17"
          },
          "fr": {
            "_populationPercent": "61",
            "_officialStatus": "official"
          },
          "ife": {
            "_populationPercent": "1.3",
            "_literacyPercent": "15"
          }
        }
      },
      "TH": {
        "_gdp": "1236000000000",
        "_literacyPercent": "93.5",
        "_population": "68615900",
        "languagePopulation": {
          "en": {
            "_populationPercent": "27"
          },
          "kdt": {
            "_populationPercent": "0.48",
            "_literacyPercent": "50"
          },
          "kxm": {
            "_populationPercent": "1.7"
          },
          "lcp": {
            "_populationPercent": "0.01",
            "_literacyPercent": "25"
          },
          "lwl": {
            "_populationPercent": "0.01"
          },
          "mfa": {
            "_populationPercent": "5"
          },
          "mnw": {
            "_populationPercent": "0.17"
          },
          "nod": {
            "_writingPercent": "5",
            "_populationPercent": "9.6"
          },
          "shn": {
            "_populationPercent": "0.096"
          },
          "sou": {
            "_writingPercent": "5",
            "_populationPercent": "8"
          },
          "th": {
            "_populationPercent": "80",
            "_literacyPercent": "93",
            "_officialStatus": "official"
          },
          "tts": {
            "_writingPercent": "5",
            "_populationPercent": "24"
          },
          "zh_Hant": {
            "_populationPercent": "1.8"
          }
        }
      },
      "TJ": {
        "_gdp": "28430000000",
        "_literacyPercent": "99.7",
        "_population": "8604880",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "0.012"
          },
          "fa": {
            "_populationPercent": "0.78"
          },
          "ru": {
            "_populationPercent": "12"
          },
          "tg": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "TK": {
        "_gdp": "1500000",
        "_literacyPercent": "94",
        "_population": "1285",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          },
          "tkl": {
            "_writingPercent": "5",
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "TL": {
        "_gdp": "7426000000",
        "_literacyPercent": "58.3",
        "_population": "1321930",
        "languagePopulation": {
          "pt": {
            "_populationPercent": "59",
            "_literacyPercent": "100",
            "_officialStatus": "official"
          },
          "tet": {
            "_populationPercent": "59",
            "_officialStatus": "official"
          }
        }
      },
      "TM": {
        "_gdp": "103700000000",
        "_literacyPercent": "99.6",
        "_population": "5411010",
        "languagePopulation": {
          "ku": {
            "_populationPercent": "0.41"
          },
          "ru": {
            "_populationPercent": "12"
          },
          "tk": {
            "_populationPercent": "70",
            "_officialStatus": "official"
          },
          "uz": {
            "_populationPercent": "9"
          }
        }
      },
      "TN": {
        "_gdp": "137700000000",
        "_literacyPercent": "79.1",
        "_population": "11516200",
        "languagePopulation": {
          "aeb": {
            "_populationPercent": "90"
          },
          "ar": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "74",
            "_officialStatus": "official"
          }
        }
      },
      "TO": {
        "_gdp": "591000000",
        "_literacyPercent": "99",
        "_population": "106398",
        "languagePopulation": {
          "en": {
            "_populationPercent": "28",
            "_officialStatus": "official"
          },
          "to": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "TR": {
        "_gdp": "2186000000000",
        "_literacyPercent": "94.1",
        "_population": "81257200",
        "languagePopulation": {
          "ab": {
            "_populationPercent": "0.0049"
          },
          "ady": {
            "_populationPercent": "0.39"
          },
          "ar": {
            "_populationPercent": "0.56"
          },
          "az": {
            "_populationPercent": "0.74"
          },
          "az_Arab": {
            "_populationPercent": "0.65"
          },
          "bg": {
            "_populationPercent": "0.42"
          },
          "bgx": {
            "_populationPercent": "0.46"
          },
          "el": {
            "_populationPercent": "0.0049"
          },
          "en": {
            "_populationPercent": "17"
          },
          "hy": {
            "_populationPercent": "0.056"
          },
          "ka": {
            "_populationPercent": "0.056"
          },
          "kbd": {
            "_populationPercent": "0.77"
          },
          "kiu": {
            "_populationPercent": "0.19"
          },
          "kk": {
            "_populationPercent": "0.0007"
          },
          "ku": {
            "_populationPercent": "5.5"
          },
          "ky_Latn": {
            "_populationPercent": "0.0014"
          },
          "lzz": {
            "_populationPercent": "0.028"
          },
          "sq": {
            "_populationPercent": "0.021"
          },
          "sr_Latn": {
            "_writingPercent": "5",
            "_populationPercent": "0.028"
          },
          "tr": {
            "_populationPercent": "93",
            "_officialStatus": "official"
          },
          "tru": {
            "_populationPercent": "0.0037"
          },
          "uz": {
            "_populationPercent": "0.0024"
          },
          "zza": {
            "_populationPercent": "1.4"
          }
        }
      },
      "TT": {
        "_gdp": "42850000000",
        "_literacyPercent": "98.8",
        "_population": "1215530",
        "languagePopulation": {
          "en": {
            "_populationPercent": "88",
            "_officialStatus": "official"
          },
          "es": {
            "_populationPercent": "0.34"
          }
        }
      },
      "TV": {
        "_gdp": "42000000",
        "_literacyPercent": "95",
        "_population": "11147",
        "languagePopulation": {
          "en": {
            "_populationPercent": "9.6",
            "_officialStatus": "official"
          },
          "tvl": {
            "_populationPercent": "89",
            "_officialStatus": "official"
          }
        }
      },
      "TW": {
        "_gdp": "1189000000000",
        "_literacyPercent": "96.1",
        "_population": "23546000",
        "languagePopulation": {
          "trv": {
            "_populationPercent": "0.02"
          },
          "zh_Hant": {
            "_populationPercent": "95",
            "_officialStatus": "official"
          }
        }
      },
      "TZ": {
        "_gdp": "162500000000",
        "_literacyPercent": "67.8",
        "_population": "55451300",
        "languagePopulation": {
          "asa": {
            "_populationPercent": "1.2"
          },
          "bez": {
            "_populationPercent": "1.7"
          },
          "en": {
            "_populationPercent": "69",
            "_officialStatus": "official"
          },
          "jmc": {
            "_populationPercent": "0.75"
          },
          "kde": {
            "_populationPercent": "2.4"
          },
          "ksb": {
            "_populationPercent": "1.7"
          },
          "lag": {
            "_populationPercent": "0.87"
          },
          "mas": {
            "_populationPercent": "1.5",
            "_literacyPercent": "50"
          },
          "mgy": {
            "_populationPercent": "1.4"
          },
          "nym": {
            "_populationPercent": "3.3"
          },
          "rof": {
            "_populationPercent": "0.75"
          },
          "rwk": {
            "_populationPercent": "0.22"
          },
          "sbp": {
            "_populationPercent": "0.2",
            "_literacyPercent": "1"
          },
          "suk": {
            "_populationPercent": "8.7"
          },
          "sw": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          },
          "vun": {
            "_populationPercent": "0.75"
          }
        }
      },
      "UA": {
        "_gdp": "369600000000",
        "_literacyPercent": "99.7",
        "_population": "43952300",
        "languagePopulation": {
          "be": {
            "_populationPercent": "0.83"
          },
          "bg": {
            "_populationPercent": "0.49"
          },
          "crh": {
            "_populationPercent": "0.56"
          },
          "el": {
            "_populationPercent": "0.016"
          },
          "hu": {
            "_populationPercent": "0.37"
          },
          "pl": {
            "_populationPercent": "2.4"
          },
          "ro": {
            "_populationPercent": "0.52"
          },
          "ru": {
            "_populationPercent": "46",
            "_officialStatus": "de_facto_official"
          },
          "rue": {
            "_populationPercent": "1.2"
          },
          "tr": {
            "_populationPercent": "0.42"
          },
          "uk": {
            "_populationPercent": "65",
            "_officialStatus": "official"
          },
          "yi": {
            "_populationPercent": "1.3"
          }
        }
      },
      "UG": {
        "_gdp": "89190000000",
        "_literacyPercent": "73.2",
        "_population": "40853700",
        "languagePopulation": {
          "ach": {
            "_populationPercent": "3.7"
          },
          "cgg": {
            "_populationPercent": "5.4"
          },
          "en": {
            "_populationPercent": "3.9",
            "_officialStatus": "official"
          },
          "hi": {
            "_populationPercent": "0.0054"
          },
          "laj": {
            "_populationPercent": "3.8"
          },
          "lg": {
            "_populationPercent": "13"
          },
          "myx": {
            "_populationPercent": "2.9"
          },
          "nyn": {
            "_populationPercent": "6.3"
          },
          "rw": {
            "_populationPercent": "2.1"
          },
          "sw": {
            "_populationPercent": "75",
            "_officialStatus": "official"
          },
          "teo": {
            "_populationPercent": "3.9"
          },
          "ttj": {
            "_populationPercent": "1.9"
          },
          "xog": {
            "_populationPercent": "5.3"
          }
        }
      },
      "UM": {
        "_gdp": "18710000",
        "_literacyPercent": "99",
        "_population": "316",
        "languagePopulation": {
          "en": {
            "_populationPercent": "100",
            "_officialStatus": "de_facto_official"
          }
        }
      },
      "US": {
        "_gdp": "19490000000000",
        "_literacyPercent": "99",
        "_population": "329256000",
        "languagePopulation": {
          "cho": {
            "_populationPercent": "0.0033"
          },
          "chr": {
            "_writingPercent": "5",
            "_populationPercent": "0.0077"
          },
          "dak": {
            "_populationPercent": "0.0059"
          },
          "de": {
            "_populationPercent": "0.47"
          },
          "en": {
            "_populationPercent": "96",
            "_officialStatus": "de_facto_official"
          },
          "es": {
            "_populationPercent": "9.6",
            "_officialStatus": "official_regional"
          },
          "esu": {
            "_populationPercent": "0.0062"
          },
          "fil": {
            "_populationPercent": "0.42"
          },
          "fr": {
            "_populationPercent": "0.56"
          },
          "frc": {
            "_populationPercent": "0.0085"
          },
          "haw": {
            "_populationPercent": "0.0089",
            "_officialStatus": "official_regional"
          },
          "ik": {
            "_writingPercent": "5",
            "_populationPercent": "0.0024"
          },
          "it": {
            "_populationPercent": "0.34"
          },
          "ko": {
            "_populationPercent": "0.3"
          },
          "lkt": {
            "_populationPercent": "0.0025"
          },
          "mus": {
            "_populationPercent": "0.0012"
          },
          "nv": {
            "_populationPercent": "0.051"
          },
          "pdc": {
            "_populationPercent": "0.039"
          },
          "ru": {
            "_populationPercent": "0.24"
          },
          "vi": {
            "_populationPercent": "0.34"
          },
          "yi": {
            "_populationPercent": "0.049"
          },
          "zh_Hant": {
            "_populationPercent": "0.69"
          }
        }
      },
      "UY": {
        "_gdp": "78160000000",
        "_literacyPercent": "98.1",
        "_population": "3369300",
        "languagePopulation": {
          "es": {
            "_populationPercent": "88",
            "_officialStatus": "official"
          }
        }
      },
      "UZ": {
        "_gdp": "223000000000",
        "_literacyPercent": "99.4",
        "_population": "30023700",
        "languagePopulation": {
          "kaa": {
            "_populationPercent": "1.6"
          },
          "ru": {
            "_populationPercent": "14"
          },
          "tr": {
            "_populationPercent": "0.76"
          },
          "uz": {
            "_populationPercent": "85",
            "_officialStatus": "official"
          },
          "uz_Cyrl": {
            "_populationPercent": "15",
            "_officialStatus": "official"
          }
        }
      },
      "VA": {
        "_gdp": "37220000",
        "_literacyPercent": "100",
        "_population": "1000",
        "languagePopulation": {
          "it": {
            "_populationPercent": "82",
            "_officialStatus": "de_facto_official"
          },
          "la": {
            "_populationPercent": "82"
          }
        }
      },
      "VC": {
        "_gdp": "1265000000",
        "_literacyPercent": "96",
        "_population": "101844",
        "languagePopulation": {
          "en": {
            "_populationPercent": "96",
            "_officialStatus": "official"
          }
        }
      },
      "VE": {
        "_gdp": "381600000000",
        "_literacyPercent": "95.5",
        "_population": "31689200",
        "languagePopulation": {
          "es": {
            "_populationPercent": "82",
            "_officialStatus": "official"
          }
        }
      },
      "VG": {
        "_gdp": "500000000",
        "_literacyPercent": "97.8",
        "_population": "35802",
        "languagePopulation": {
          "en": {
            "_populationPercent": "98",
            "_officialStatus": "official"
          }
        }
      },
      "VI": {
        "_gdp": "3872000000",
        "_literacyPercent": "99",
        "_population": "106977",
        "languagePopulation": {
          "en": {
            "_populationPercent": "75",
            "_officialStatus": "de_facto_official"
          }
        }
      },
      "VN": {
        "_gdp": "648700000000",
        "_literacyPercent": "93.4",
        "_population": "97040300",
        "languagePopulation": {
          "cjm": {
            "_populationPercent": "0.089",
            "_literacyPercent": "60"
          },
          "vi": {
            "_populationPercent": "86",
            "_officialStatus": "official"
          },
          "zh_Hant": {
            "_populationPercent": "1.1"
          }
        }
      },
      "VU": {
        "_gdp": "772000000",
        "_literacyPercent": "83.2",
        "_population": "288037",
        "languagePopulation": {
          "bi": {
            "_populationPercent": "90",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "83",
            "_officialStatus": "official"
          },
          "fr": {
            "_populationPercent": "50",
            "_officialStatus": "official"
          }
        }
      },
      "WF": {
        "_gdp": "60000000",
        "_literacyPercent": "50",
        "_population": "15763",
        "languagePopulation": {
          "fr": {
            "_populationPercent": "48",
            "_officialStatus": "official"
          },
          "fud": {
            "_populationPercent": "31"
          },
          "wls": {
            "_populationPercent": "60"
          }
        }
      },
      "WS": {
        "_gdp": "1137000000",
        "_literacyPercent": "98.8",
        "_population": "201316",
        "languagePopulation": {
          "en": {
            "_populationPercent": "2.2",
            "_officialStatus": "official"
          },
          "sm": {
            "_populationPercent": "100",
            "_officialStatus": "official"
          }
        }
      },
      "XK": {
        "_gdp": "19600000000",
        "_literacyPercent": "91.9",
        "_population": "1907590",
        "languagePopulation": {
          "aln": {
            "_populationPercent": "74"
          },
          "sq": {
            "_populationPercent": "92",
            "_officialStatus": "official"
          },
          "sr": {
            "_populationPercent": "5",
            "_officialStatus": "official"
          },
          "sr_Latn": {
            "_populationPercent": "5",
            "_officialStatus": "official"
          }
        }
      },
      "YE": {
        "_gdp": "73630000000",
        "_literacyPercent": "65.3",
        "_population": "28667200",
        "languagePopulation": {
          "ar": {
            "_populationPercent": "74",
            "_officialStatus": "official"
          },
          "en": {
            "_populationPercent": "9"
          }
        }
      },
      "YT": {
        "_gdp": "953600000",
        "_literacyPercent": "92",
        "_population": "194000",
        "languagePopulation": {
          "buc": {
            "_populationPercent": "23"
          },
          "fr": {
            "_populationPercent": "57",
            "_officialStatus": "official"
          },
          "sw": {
            "_populationPercent": "1.4"
          },
          "swb": {
            "_populationPercent": "88"
          }
        }
      },
      "ZA": {
        "_gdp": "767200000000",
        "_literacyPercent": "93",
        "_population": "55380200",
        "languagePopulation": {
          "af": {
            "_populationPercent": "13",
            "_literacyPercent": "99",
            "_officialStatus": "official_regional"
          },
          "en": {
            "_populationPercent": "31",
            "_literacyPercent": "99",
            "_officialStatus": "official"
          },
          "hi": {
            "_populationPercent": "2",
            "_literacyPercent": "69"
          },
          "nr": {
            "_populationPercent": "1.6",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "nso": {
            "_populationPercent": "9.4",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "ss": {
            "_populationPercent": "2.7",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "st": {
            "_populationPercent": "7.9",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "sw": {
            "_populationPercent": "0.0018",
            "_literacyPercent": "50"
          },
          "tn": {
            "_populationPercent": "8.2",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "ts": {
            "_populationPercent": "4.4",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "ve": {
            "_populationPercent": "2.3",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "xh": {
            "_populationPercent": "18",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          },
          "zu": {
            "_populationPercent": "24",
            "_literacyPercent": "50",
            "_officialStatus": "official_regional"
          }
        }
      },
      "ZM": {
        "_gdp": "68930000000",
        "_literacyPercent": "61.4",
        "_population": "16445100",
        "languagePopulation": {
          "bem": {
            "_populationPercent": "31"
          },
          "en": {
            "_populationPercent": "16",
            "_officialStatus": "official"
          },
          "loz": {
            "_populationPercent": "6"
          },
          "ny": {
            "_populationPercent": "15"
          }
        }
      },
      "ZW": {
        "_gdp": "34270000000",
        "_literacyPercent": "83.6",
        "_population": "14030400",
        "languagePopulation": {
          "en": {
            "_populationPercent": "42",
            "_officialStatus": "official"
          },
          "kck": {
            "_populationPercent": "5.3"
          },
          "mxc": {
            "_populationPercent": "6.5"
          },
          "nd": {
            "_populationPercent": "12",
            "_officialStatus": "official"
          },
          "ndc": {
            "_populationPercent": "6.1"
          },
          "ny": {
            "_populationPercent": "1.9"
          },
          "sn": {
            "_populationPercent": "81",
            "_officialStatus": "official"
          },
          "tn": {
            "_populationPercent": "0.22"
          },
          "ve": {
            "_populationPercent": "0.64"
          }
        }
      },
      "ZZ": {
        "_gdp": "0",
        "_literacyPercent": "0",
        "_population": "0"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "timeData": {
      "AX": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "BQ": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "CP": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "CZ": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "DK": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "FI": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "ID": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "IS": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "ML": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "NE": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "RU": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "SE": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "SJ": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "SK": {
        "_allowed": "H",
        "_preferred": "H"
      },
      "AS": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "BT": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "DJ": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "ER": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "GH": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "IN": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "LS": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "PG": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "PW": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "SO": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "TO": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "VU": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "WS": {
        "_allowed": "h H",
        "_preferred": "h"
      },
      "001": {
        "_allowed": "H h",
        "_preferred": "H"
      },
      "AL": {
        "_allowed": "h H hB",
        "_preferred": "h"
      },
      "TD": {
        "_allowed": "h H hB",
        "_preferred": "h"
      },
      "ca_ES": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "CF": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "CM": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "fr_CA": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "gl_ES": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "it_CH": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "it_IT": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "LU": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "NP": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "PF": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "SC": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "SM": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "SN": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "TF": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "VA": {
        "_allowed": "H h hB",
        "_preferred": "H"
      },
      "CY": {
        "_allowed": "h H hb hB",
        "_preferred": "h"
      },
      "GR": {
        "_allowed": "h H hb hB",
        "_preferred": "h"
      },
      "CO": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "DO": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "KP": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "KR": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "NA": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "PA": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "PR": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "VE": {
        "_allowed": "h H hB hb",
        "_preferred": "h"
      },
      "AC": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "AI": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "BW": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "BZ": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "CC": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "CK": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "CX": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "DG": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "FK": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "GB": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "GG": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "GI": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "IE": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "IM": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "IO": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "JE": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "LT": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "MK": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "MN": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "MS": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "NF": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "NG": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "NR": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "NU": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "PN": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "SH": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "SX": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "TA": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "ZA": {
        "_allowed": "H h hb hB",
        "_preferred": "H"
      },
      "af_ZA": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "AR": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "CL": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "CR": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "CU": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "EA": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "es_BO": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "es_BR": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "es_EC": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "es_ES": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "es_GQ": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "es_PE": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "GT": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "HN": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "IC": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "KG": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "KM": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "LK": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "MA": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "MX": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "NI": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "PY": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "SV": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "UY": {
        "_allowed": "H h hB hb",
        "_preferred": "H"
      },
      "JP": {
        "_allowed": "H h K",
        "_preferred": "H"
      },
      "AD": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "AM": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "AO": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "AT": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "AW": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "BE": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "BF": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "BJ": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "BL": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "BR": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "CG": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "CI": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "CV": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "DE": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "EE": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "FR": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "GA": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "GF": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "GN": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "GP": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "GW": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "HR": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "IL": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "IT": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "KZ": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "MC": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "MD": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "MF": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "MQ": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "MZ": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "NC": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "NL": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "PM": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "PT": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "RE": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "RO": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "SI": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "SR": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "ST": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "TG": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "TR": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "WF": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "YT": {
        "_allowed": "H hB",
        "_preferred": "H"
      },
      "BD": {
        "_allowed": "h hB H",
        "_preferred": "h"
      },
      "PK": {
        "_allowed": "h hB H",
        "_preferred": "h"
      },
      "AZ": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "BA": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "BG": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "CH": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "GE": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "LI": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "ME": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "RS": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "UA": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "UZ": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "XK": {
        "_allowed": "H hB h",
        "_preferred": "H"
      },
      "AG": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "AU": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "BB": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "BM": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "BS": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "CA": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "DM": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "en_001": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "FJ": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "FM": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "GD": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "GM": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "GU": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "GY": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "JM": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "KI": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "KN": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "KY": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "LC": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "LR": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "MH": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "MP": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "MW": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "NZ": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "SB": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "SG": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "SL": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "SS": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "SZ": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "TC": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "TT": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "UM": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "US": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "VC": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "VG": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "VI": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "ZM": {
        "_allowed": "h hb H hB",
        "_preferred": "h"
      },
      "BO": {
        "_allowed": "H hB h hb",
        "_preferred": "H"
      },
      "EC": {
        "_allowed": "H hB h hb",
        "_preferred": "H"
      },
      "ES": {
        "_allowed": "H hB h hb",
        "_preferred": "H"
      },
      "GQ": {
        "_allowed": "H hB h hb",
        "_preferred": "H"
      },
      "PE": {
        "_allowed": "H hB h hb",
        "_preferred": "H"
      },
      "AE": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "ar_001": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "BH": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "DZ": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "EG": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "EH": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "IQ": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "JO": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "KW": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "LB": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "LY": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "MR": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "OM": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "PH": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "PS": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "QA": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "SA": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "SD": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "SY": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "TN": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "YE": {
        "_allowed": "h hB hb H",
        "_preferred": "h"
      },
      "AF": {
        "_allowed": "H hb hB h",
        "_preferred": "H"
      },
      "LA": {
        "_allowed": "H hb hB h",
        "_preferred": "H"
      },
      "LV": {
        "_allowed": "H hB hb h",
        "_preferred": "H"
      },
      "TL": {
        "_allowed": "H hB hb h",
        "_preferred": "H"
      },
      "zu_ZA": {
        "_allowed": "H hB hb h",
        "_preferred": "H"
      },
      "CD": {
        "_allowed": "hB H",
        "_preferred": "H"
      },
      "IR": {
        "_allowed": "hB H",
        "_preferred": "H"
      },
      "hi_IN": {
        "_allowed": "hB h H",
        "_preferred": "h"
      },
      "kn_IN": {
        "_allowed": "hB h H",
        "_preferred": "h"
      },
      "ml_IN": {
        "_allowed": "hB h H",
        "_preferred": "h"
      },
      "te_IN": {
        "_allowed": "hB h H",
        "_preferred": "h"
      },
      "KH": {
        "_allowed": "hB h H hb",
        "_preferred": "h"
      },
      "ta_IN": {
        "_allowed": "hB h hb H",
        "_preferred": "h"
      },
      "BN": {
        "_allowed": "hb hB h H",
        "_preferred": "h"
      },
      "MY": {
        "_allowed": "hb hB h H",
        "_preferred": "h"
      },
      "CN": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "ET": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "gu_IN": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "HK": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "MO": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "mr_IN": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "pa_IN": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "TW": {
        "_allowed": "hB hb h H",
        "_preferred": "h"
      },
      "KE": {
        "_allowed": "hB hb H h",
        "_preferred": "H"
      },
      "MM": {
        "_allowed": "hB hb H h",
        "_preferred": "H"
      },
      "TZ": {
        "_allowed": "hB hb H h",
        "_preferred": "H"
      },
      "UG": {
        "_allowed": "hB hb H h",
        "_preferred": "H"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "unitPreferenceData": {
      "unitPreferences": {
        "area": {
          "land-agricult": {
            "001": "hectare",
            "GB": "acre",
            "US": "acre"
          },
          "land-commercl": {
            "001": "hectare",
            "GB": "acre",
            "US": "acre"
          },
          "land-residntl": {
            "001": "hectare",
            "GB": "acre",
            "US": "acre"
          }
        },
        "concentr": {
          "blood-glucose": {
            "001": "milligram-per-deciliter",
            "AG": "millimole-per-liter",
            "AI": "millimole-per-liter",
            "AO": "millimole-per-liter",
            "AU": "millimole-per-liter",
            "BA": "millimole-per-liter",
            "BG": "millimole-per-liter",
            "BH": "millimole-per-liter",
            "BM": "millimole-per-liter",
            "BN": "millimole-per-liter",
            "BW": "millimole-per-liter",
            "BY": "millimole-per-liter",
            "CA": "millimole-per-liter",
            "CH": "millimole-per-liter",
            "CM": "millimole-per-liter",
            "CN": "millimole-per-liter",
            "CZ": "millimole-per-liter",
            "DK": "millimole-per-liter",
            "DM": "millimole-per-liter",
            "EE": "millimole-per-liter",
            "FI": "millimole-per-liter",
            "FJ": "millimole-per-liter",
            "GB": "millimole-per-liter",
            "GD": "millimole-per-liter",
            "HK": "millimole-per-liter",
            "HR": "millimole-per-liter",
            "HU": "millimole-per-liter",
            "IE": "millimole-per-liter",
            "IM": "millimole-per-liter",
            "IS": "millimole-per-liter",
            "KE": "millimole-per-liter",
            "KN": "millimole-per-liter",
            "KW": "millimole-per-liter",
            "KZ": "millimole-per-liter",
            "LC": "millimole-per-liter",
            "LI": "millimole-per-liter",
            "LT": "millimole-per-liter",
            "LU": "millimole-per-liter",
            "LV": "millimole-per-liter",
            "ME": "millimole-per-liter",
            "MG": "millimole-per-liter",
            "MK": "millimole-per-liter",
            "MO": "millimole-per-liter",
            "MS": "millimole-per-liter",
            "MT": "millimole-per-liter",
            "MU": "millimole-per-liter",
            "MY": "millimole-per-liter",
            "MZ": "millimole-per-liter",
            "NA": "millimole-per-liter",
            "NL": "millimole-per-liter",
            "NO": "millimole-per-liter",
            "NZ": "millimole-per-liter",
            "OM": "millimole-per-liter",
            "PG": "millimole-per-liter",
            "RS": "millimole-per-liter",
            "RU": "millimole-per-liter",
            "SE": "millimole-per-liter",
            "SG": "millimole-per-liter",
            "SI": "millimole-per-liter",
            "SK": "millimole-per-liter",
            "TC": "millimole-per-liter",
            "TO": "millimole-per-liter",
            "UA": "millimole-per-liter",
            "UG": "millimole-per-liter",
            "VC": "millimole-per-liter",
            "VG": "millimole-per-liter",
            "VN": "millimole-per-liter",
            "VU": "millimole-per-liter",
            "ZA": "millimole-per-liter"
          }
        },
        "consumption": {
          "vehicle-fuel": {
            "001": "liter-per-100kilometers",
            "BR": "liter-per-kilometer",
            "IT": "liter-per-kilometer",
            "JP": "liter-per-kilometer",
            "KR": "liter-per-kilometer",
            "MX": "liter-per-kilometer",
            "MY": "liter-per-kilometer",
            "TH": "liter-per-kilometer",
            "TR": "liter-per-kilometer",
            "CA-alt-informal": "mile-per-gallon-imperial",
            "GB-alt-informal": "mile-per-gallon-imperial",
            "NL-alt-informal": "liter-per-kilometer",
            "US": "mile-per-gallon"
          }
        },
        "duration": {
          "music-track": {
            "001": "minute second"
          },
          "person-age": {
            "001": "year-person month-person"
          },
          "tv-program": {
            "001": "minute second"
          }
        },
        "energy": {
          "food": {
            "001": "foodcalorie"
          },
          "person-usage": {
            "001": "kilocalorie"
          }
        },
        "length": {
          "person": {
            "001": "centimeter",
            "AT": "meter centimeter",
            "BE": "meter centimeter",
            "DZ": "meter centimeter",
            "EG": "meter centimeter",
            "ES": "meter centimeter",
            "FR": "meter centimeter",
            "HK": "meter centimeter",
            "ID": "meter centimeter",
            "IL": "meter centimeter",
            "IT": "meter centimeter",
            "JO": "meter centimeter",
            "MY": "meter centimeter",
            "SA": "meter centimeter",
            "SE": "meter centimeter",
            "TR": "meter centimeter",
            "VN": "meter centimeter",
            "BR-alt-informal": "meter centimeter",
            "CN-alt-informal": "meter centimeter",
            "DE-alt-informal": "meter centimeter",
            "DK-alt-informal": "meter centimeter",
            "MX-alt-informal": "meter centimeter",
            "NL-alt-informal": "meter centimeter",
            "NO-alt-informal": "meter centimeter",
            "PL-alt-informal": "meter centimeter",
            "PT-alt-informal": "meter centimeter",
            "RU-alt-informal": "meter centimeter",
            "CA-alt-informal": "foot inch",
            "GB-alt-informal": "foot inch",
            "IN-alt-informal": "foot inch",
            "US-alt-informal": "foot inch",
            "US": "inch"
          },
          "small": {
            "001": "meter",
            "GB": "foot",
            "US": "foot"
          },
          "rainfall": {
            "001": "millimeter",
            "BR": "centimeter",
            "US": "inch"
          },
          "road": {
            "001": "kilometer",
            "GB": "mile",
            "US": "mile",
            "SE-alt-informal": "mile-scandinavian"
          },
          "snowfall": {
            "001": "centimeter",
            "US": "inch"
          },
          "vehicle": {
            "001": "meter",
            "GB": "foot inch",
            "US": "foot inch",
            "MX": "meter centimeter"
          },
          "visiblty": {
            "001": "kilometer",
            "DE": "meter",
            "NL": "meter",
            "GB": "mile",
            "US": "mile"
          }
        },
        "mass": {
          "person": {
            "001": "kilogram",
            "GB": "stone pound",
            "US": "pound"
          },
          "small": {
            "001": "gram",
            "DZ": "kilogram gram",
            "EG": "kilogram gram",
            "ES": "kilogram gram",
            "JO": "kilogram gram",
            "SA": "kilogram gram",
            "GB": "pound ounce",
            "HK": "pound ounce",
            "US": "pound ounce"
          }
        },
        "pressure": {
          "baromtrc": {
            "001": "hectopascal",
            "BR": "millibar",
            "EG": "millibar",
            "GB": "millibar",
            "IL": "millibar",
            "TH": "millibar",
            "IN": "inch-hg",
            "US": "inch-hg",
            "MX": "millimeter-of-mercury",
            "RU": "millimeter-of-mercury"
          }
        },
        "speed": {
          "road-travel": {
            "001": "kilometer-per-hour",
            "GB": "mile-per-hour",
            "US": "mile-per-hour"
          },
          "wind": {
            "001": "kilometer-per-hour",
            "FI": "meter-per-second",
            "KR": "meter-per-second",
            "NO": "meter-per-second",
            "PL": "meter-per-second",
            "RU": "meter-per-second",
            "SE": "meter-per-second",
            "US": "mile-per-hour"
          }
        },
        "temperature": {
          "person": {
            "001": "celsius",
            "US": "fahrenheit"
          },
          "weather": {
            "001": "celsius",
            "BS": "fahrenheit",
            "BZ": "fahrenheit",
            "KY": "fahrenheit",
            "PR": "fahrenheit",
            "PW": "fahrenheit",
            "US": "fahrenheit"
          }
        },
        "volume": {
          "vehicle-fuel": {
            "001": "liter",
            "US": "gallon"
          }
        }
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14982 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "weekData": {
      "minDays": {
        "001": "1",
        "AD": "4",
        "AN": "4",
        "AT": "4",
        "AX": "4",
        "BE": "4",
        "BG": "4",
        "CH": "4",
        "CZ": "4",
        "DE": "4",
        "DK": "4",
        "EE": "4",
        "ES": "4",
        "FI": "4",
        "FJ": "4",
        "FO": "4",
        "FR": "4",
        "GB": "4",
        "GF": "4",
        "GG": "4",
        "GI": "4",
        "GP": "4",
        "GR": "4",
        "GU": "1",
        "HU": "4",
        "IE": "4",
        "IM": "4",
        "IS": "4",
        "IT": "4",
        "JE": "4",
        "LI": "4",
        "LT": "4",
        "LU": "4",
        "MC": "4",
        "MQ": "4",
        "NL": "4",
        "NO": "4",
        "PL": "4",
        "PT": "4",
        "RE": "4",
        "RU": "4",
        "SE": "4",
        "SJ": "4",
        "SK": "4",
        "SM": "4",
        "UM": "1",
        "US": "1",
        "VA": "4",
        "VI": "1"
      },
      "firstDay": {
        "001": "mon",
        "AD": "mon",
        "AE": "sat",
        "AF": "sat",
        "AG": "sun",
        "AI": "mon",
        "AL": "mon",
        "AM": "mon",
        "AN": "mon",
        "AR": "sun",
        "AS": "sun",
        "AT": "mon",
        "AU": "sun",
        "AX": "mon",
        "AZ": "mon",
        "BA": "mon",
        "BD": "sun",
        "BE": "mon",
        "BG": "mon",
        "BH": "sat",
        "BM": "mon",
        "BN": "mon",
        "BR": "sun",
        "BS": "sun",
        "BT": "sun",
        "BW": "sun",
        "BY": "mon",
        "BZ": "sun",
        "CA": "sun",
        "CH": "mon",
        "CL": "mon",
        "CM": "mon",
        "CN": "sun",
        "CO": "sun",
        "CR": "mon",
        "CY": "mon",
        "CZ": "mon",
        "DE": "mon",
        "DJ": "sat",
        "DK": "mon",
        "DM": "sun",
        "DO": "sun",
        "DZ": "sat",
        "EC": "mon",
        "EE": "mon",
        "EG": "sat",
        "ES": "mon",
        "ET": "sun",
        "FI": "mon",
        "FJ": "mon",
        "FO": "mon",
        "FR": "mon",
        "GB": "mon",
        "GB-alt-variant": "sun",
        "GE": "mon",
        "GF": "mon",
        "GP": "mon",
        "GR": "mon",
        "GT": "sun",
        "GU": "sun",
        "HK": "sun",
        "HN": "sun",
        "HR": "mon",
        "HU": "mon",
        "ID": "sun",
        "IE": "mon",
        "IL": "sun",
        "IN": "sun",
        "IQ": "sat",
        "IR": "sat",
        "IS": "mon",
        "IT": "mon",
        "JM": "sun",
        "JO": "sat",
        "JP": "sun",
        "KE": "sun",
        "KG": "mon",
        "KH": "sun",
        "KR": "sun",
        "KW": "sat",
        "KZ": "mon",
        "LA": "sun",
        "LB": "mon",
        "LI": "mon",
        "LK": "mon",
        "LT": "mon",
        "LU": "mon",
        "LV": "mon",
        "LY": "sat",
        "MC": "mon",
        "MD": "mon",
        "ME": "mon",
        "MH": "sun",
        "MK": "mon",
        "MM": "sun",
        "MN": "mon",
        "MO": "sun",
        "MQ": "mon",
        "MT": "sun",
        "MV": "fri",
        "MX": "sun",
        "MY": "mon",
        "MZ": "sun",
        "NI": "sun",
        "NL": "mon",
        "NO": "mon",
        "NP": "sun",
        "NZ": "mon",
        "OM": "sat",
        "PA": "sun",
        "PE": "sun",
        "PH": "sun",
        "PK": "sun",
        "PL": "mon",
        "PR": "sun",
        "PT": "sun",
        "PY": "sun",
        "QA": "sat",
        "RE": "mon",
        "RO": "mon",
        "RS": "mon",
        "RU": "mon",
        "SA": "sun",
        "SD": "sat",
        "SE": "mon",
        "SG": "sun",
        "SI": "mon",
        "SK": "mon",
        "SM": "mon",
        "SV": "sun",
        "SY": "sat",
        "TH": "sun",
        "TJ": "mon",
        "TM": "mon",
        "TR": "mon",
        "TT": "sun",
        "TW": "sun",
        "UA": "mon",
        "UM": "sun",
        "US": "sun",
        "UY": "mon",
        "UZ": "mon",
        "VA": "mon",
        "VE": "sun",
        "VI": "sun",
        "VN": "mon",
        "WS": "sun",
        "XK": "mon",
        "YE": "sun",
        "ZA": "sun",
        "ZW": "sun"
      },
      "weekendStart": {
        "001": "sat",
        "AE": "fri",
        "AF": "thu",
        "BH": "fri",
        "DZ": "fri",
        "EG": "fri",
        "IL": "fri",
        "IN": "sun",
        "IQ": "fri",
        "IR": "fri",
        "JO": "fri",
        "KW": "fri",
        "LY": "fri",
        "OM": "fri",
        "QA": "fri",
        "SA": "fri",
        "SD": "fri",
        "SY": "fri",
        "YE": "fri"
      },
      "weekendEnd": {
        "001": "sun",
        "AE": "sat",
        "AF": "fri",
        "BH": "sat",
        "DZ": "sat",
        "EG": "sat",
        "IL": "sat",
        "IQ": "sat",
        "IR": "fri",
        "JO": "sat",
        "KW": "sat",
        "LY": "sat",
        "OM": "sat",
        "QA": "sat",
        "SA": "sat",
        "SD": "sat",
        "SY": "sat",
        "YE": "sat"
      },
      "af": {
        "_ordering": "weekOfDate weekOfInterval weekOfMonth"
      },
      "am az bs cs cy da el et hi ky lt mk sk ta th": {
        "_ordering": "weekOfYear weekOfMonth"
      },
      "ar fil gu hu hy id kk ko": {
        "_ordering": "weekOfMonth"
      },
      "be ro ru": {
        "_ordering": "weekOfInterval weekOfMonth"
      },
      "bg de iw pt ur zh": {
        "_ordering": "weekOfDate weekOfMonth weekOfInterval"
      },
      "ca es fr gl": {
        "_ordering": "weekOfDate"
      },
      "en bn ja ka": {
        "_ordering": "weekOfDate weekOfMonth"
      },
      "eu": {
        "_ordering": "weekOfMonth weekOfDate"
      },
      "fa hr it lv pl si sr uk uz": {
        "_ordering": "weekOfMonth weekOfInterval"
      },
      "fi zh-TW": {
        "_ordering": "weekOfYear weekOfDate weekOfMonth"
      },
      "is mn no sv vi": {
        "_ordering": "weekOfYear weekOfMonth weekOfInterval"
      },
      "km mr": {
        "_ordering": "weekOfMonth weekOfYear"
      },
      "kn ml pa": {
        "_ordering": "weekOfMonth weekOfDate weekOfYear"
      },
      "lo sq": {
        "_ordering": "weekOfMonth weekOfInterval weekOfDate weekOfYear"
      },
      "ms tr": {
        "_ordering": "weekOfMonth weekOfYear weekOfInterval weekOfDate"
      },
      "nl": {
        "_ordering": "weekOfDate weekOfYear weekOfMonth"
      },
      "sl": {
        "_ordering": "weekOfInterval"
      },
      "sw te": {
        "_ordering": "weekOfMonth weekOfInterval weekOfYear"
      },
      "und": {
        "_ordering": "weekOfYear"
      },
      "zu": {
        "_ordering": "weekOfYear weekOfInterval"
      }
    }
  }
}, {
  "supplemental": {
    "version": {
      "_number": "$Revision: 14742 $",
      "_unicodeVersion": "12.1.0",
      "_cldrVersion": "35.1"
    },
    "windowsZones": {
      "mapTimezones": [{
        "mapZone": {
          "_other": "Afghanistan Standard Time",
          "_type": "Asia/Kabul",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Afghanistan Standard Time",
          "_type": "Asia/Kabul",
          "_territory": "AF"
        }
      }, {
        "mapZone": {
          "_other": "Alaskan Standard Time",
          "_type": "America/Anchorage",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Alaskan Standard Time",
          "_type": "America/Anchorage America/Juneau America/Nome America/Sitka America/Yakutat",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "Aleutian Standard Time",
          "_type": "America/Adak",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Aleutian Standard Time",
          "_type": "America/Adak",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "Altai Standard Time",
          "_type": "Asia/Barnaul",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Altai Standard Time",
          "_type": "Asia/Barnaul",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Arab Standard Time",
          "_type": "Asia/Riyadh",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Arab Standard Time",
          "_type": "Asia/Bahrain",
          "_territory": "BH"
        }
      }, {
        "mapZone": {
          "_other": "Arab Standard Time",
          "_type": "Asia/Kuwait",
          "_territory": "KW"
        }
      }, {
        "mapZone": {
          "_other": "Arab Standard Time",
          "_type": "Asia/Qatar",
          "_territory": "QA"
        }
      }, {
        "mapZone": {
          "_other": "Arab Standard Time",
          "_type": "Asia/Riyadh",
          "_territory": "SA"
        }
      }, {
        "mapZone": {
          "_other": "Arab Standard Time",
          "_type": "Asia/Aden",
          "_territory": "YE"
        }
      }, {
        "mapZone": {
          "_other": "Arabian Standard Time",
          "_type": "Asia/Dubai",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Arabian Standard Time",
          "_type": "Asia/Dubai",
          "_territory": "AE"
        }
      }, {
        "mapZone": {
          "_other": "Arabian Standard Time",
          "_type": "Asia/Muscat",
          "_territory": "OM"
        }
      }, {
        "mapZone": {
          "_other": "Arabian Standard Time",
          "_type": "Etc/GMT-4",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Arabic Standard Time",
          "_type": "Asia/Baghdad",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Arabic Standard Time",
          "_type": "Asia/Baghdad",
          "_territory": "IQ"
        }
      }, {
        "mapZone": {
          "_other": "Argentina Standard Time",
          "_type": "America/Buenos_Aires",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Argentina Standard Time",
          "_type": "America/Buenos_Aires America/Argentina/La_Rioja America/Argentina/Rio_Gallegos America/Argentina/Salta America/Argentina/San_Juan America/Argentina/San_Luis America/Argentina/Tucuman America/Argentina/Ushuaia America/Catamarca America/Cordoba America/Jujuy America/Mendoza",
          "_territory": "AR"
        }
      }, {
        "mapZone": {
          "_other": "Astrakhan Standard Time",
          "_type": "Europe/Astrakhan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Astrakhan Standard Time",
          "_type": "Europe/Astrakhan Europe/Ulyanovsk",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic Standard Time",
          "_type": "America/Halifax",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic Standard Time",
          "_type": "Atlantic/Bermuda",
          "_territory": "BM"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic Standard Time",
          "_type": "America/Halifax America/Glace_Bay America/Goose_Bay America/Moncton",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "Atlantic Standard Time",
          "_type": "America/Thule",
          "_territory": "GL"
        }
      }, {
        "mapZone": {
          "_other": "AUS Central Standard Time",
          "_type": "Australia/Darwin",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "AUS Central Standard Time",
          "_type": "Australia/Darwin",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "Aus Central W. Standard Time",
          "_type": "Australia/Eucla",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Aus Central W. Standard Time",
          "_type": "Australia/Eucla",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "AUS Eastern Standard Time",
          "_type": "Australia/Sydney",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "AUS Eastern Standard Time",
          "_type": "Australia/Sydney Australia/Melbourne",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "Azerbaijan Standard Time",
          "_type": "Asia/Baku",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Azerbaijan Standard Time",
          "_type": "Asia/Baku",
          "_territory": "AZ"
        }
      }, {
        "mapZone": {
          "_other": "Azores Standard Time",
          "_type": "Atlantic/Azores",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Azores Standard Time",
          "_type": "America/Scoresbysund",
          "_territory": "GL"
        }
      }, {
        "mapZone": {
          "_other": "Azores Standard Time",
          "_type": "Atlantic/Azores",
          "_territory": "PT"
        }
      }, {
        "mapZone": {
          "_other": "Bahia Standard Time",
          "_type": "America/Bahia",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Bahia Standard Time",
          "_type": "America/Bahia",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "Bangladesh Standard Time",
          "_type": "Asia/Dhaka",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Bangladesh Standard Time",
          "_type": "Asia/Dhaka",
          "_territory": "BD"
        }
      }, {
        "mapZone": {
          "_other": "Bangladesh Standard Time",
          "_type": "Asia/Thimphu",
          "_territory": "BT"
        }
      }, {
        "mapZone": {
          "_other": "Belarus Standard Time",
          "_type": "Europe/Minsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Belarus Standard Time",
          "_type": "Europe/Minsk",
          "_territory": "BY"
        }
      }, {
        "mapZone": {
          "_other": "Bougainville Standard Time",
          "_type": "Pacific/Bougainville",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Bougainville Standard Time",
          "_type": "Pacific/Bougainville",
          "_territory": "PG"
        }
      }, {
        "mapZone": {
          "_other": "Canada Central Standard Time",
          "_type": "America/Regina",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Canada Central Standard Time",
          "_type": "America/Regina America/Swift_Current",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "Cape Verde Standard Time",
          "_type": "Atlantic/Cape_Verde",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Cape Verde Standard Time",
          "_type": "Atlantic/Cape_Verde",
          "_territory": "CV"
        }
      }, {
        "mapZone": {
          "_other": "Cape Verde Standard Time",
          "_type": "Etc/GMT+1",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Caucasus Standard Time",
          "_type": "Asia/Yerevan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Caucasus Standard Time",
          "_type": "Asia/Yerevan",
          "_territory": "AM"
        }
      }, {
        "mapZone": {
          "_other": "Cen. Australia Standard Time",
          "_type": "Australia/Adelaide",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Cen. Australia Standard Time",
          "_type": "Australia/Adelaide Australia/Broken_Hill",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "America/Guatemala",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "America/Belize",
          "_territory": "BZ"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "America/Costa_Rica",
          "_territory": "CR"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "Pacific/Galapagos",
          "_territory": "EC"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "America/Guatemala",
          "_territory": "GT"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "America/Tegucigalpa",
          "_territory": "HN"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "America/Managua",
          "_territory": "NI"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "America/El_Salvador",
          "_territory": "SV"
        }
      }, {
        "mapZone": {
          "_other": "Central America Standard Time",
          "_type": "Etc/GMT+6",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Central Asia Standard Time",
          "_type": "Asia/Almaty",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central Asia Standard Time",
          "_type": "Antarctica/Vostok",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "Central Asia Standard Time",
          "_type": "Asia/Urumqi",
          "_territory": "CN"
        }
      }, {
        "mapZone": {
          "_other": "Central Asia Standard Time",
          "_type": "Indian/Chagos",
          "_territory": "IO"
        }
      }, {
        "mapZone": {
          "_other": "Central Asia Standard Time",
          "_type": "Asia/Bishkek",
          "_territory": "KG"
        }
      }, {
        "mapZone": {
          "_other": "Central Asia Standard Time",
          "_type": "Asia/Almaty Asia/Qostanay",
          "_territory": "KZ"
        }
      }, {
        "mapZone": {
          "_other": "Central Asia Standard Time",
          "_type": "Etc/GMT-6",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Central Brazilian Standard Time",
          "_type": "America/Cuiaba",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central Brazilian Standard Time",
          "_type": "America/Cuiaba America/Campo_Grande",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Budapest",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Tirane",
          "_territory": "AL"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Prague",
          "_territory": "CZ"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Budapest",
          "_territory": "HU"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Podgorica",
          "_territory": "ME"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Belgrade",
          "_territory": "RS"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Ljubljana",
          "_territory": "SI"
        }
      }, {
        "mapZone": {
          "_other": "Central Europe Standard Time",
          "_type": "Europe/Bratislava",
          "_territory": "SK"
        }
      }, {
        "mapZone": {
          "_other": "Central European Standard Time",
          "_type": "Europe/Warsaw",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central European Standard Time",
          "_type": "Europe/Sarajevo",
          "_territory": "BA"
        }
      }, {
        "mapZone": {
          "_other": "Central European Standard Time",
          "_type": "Europe/Zagreb",
          "_territory": "HR"
        }
      }, {
        "mapZone": {
          "_other": "Central European Standard Time",
          "_type": "Europe/Skopje",
          "_territory": "MK"
        }
      }, {
        "mapZone": {
          "_other": "Central European Standard Time",
          "_type": "Europe/Warsaw",
          "_territory": "PL"
        }
      }, {
        "mapZone": {
          "_other": "Central Pacific Standard Time",
          "_type": "Pacific/Guadalcanal",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central Pacific Standard Time",
          "_type": "Antarctica/Macquarie",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "Central Pacific Standard Time",
          "_type": "Pacific/Ponape Pacific/Kosrae",
          "_territory": "FM"
        }
      }, {
        "mapZone": {
          "_other": "Central Pacific Standard Time",
          "_type": "Pacific/Noumea",
          "_territory": "NC"
        }
      }, {
        "mapZone": {
          "_other": "Central Pacific Standard Time",
          "_type": "Pacific/Guadalcanal",
          "_territory": "SB"
        }
      }, {
        "mapZone": {
          "_other": "Central Pacific Standard Time",
          "_type": "Pacific/Efate",
          "_territory": "VU"
        }
      }, {
        "mapZone": {
          "_other": "Central Pacific Standard Time",
          "_type": "Etc/GMT-11",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Central Standard Time",
          "_type": "America/Chicago",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central Standard Time",
          "_type": "America/Winnipeg America/Rainy_River America/Rankin_Inlet America/Resolute",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "Central Standard Time",
          "_type": "America/Matamoros",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "Central Standard Time",
          "_type": "America/Chicago America/Indiana/Knox America/Indiana/Tell_City America/Menominee America/North_Dakota/Beulah America/North_Dakota/Center America/North_Dakota/New_Salem",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "Central Standard Time",
          "_type": "CST6CDT",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Central Standard Time (Mexico)",
          "_type": "America/Mexico_City",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Central Standard Time (Mexico)",
          "_type": "America/Mexico_City America/Bahia_Banderas America/Merida America/Monterrey",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "Chatham Islands Standard Time",
          "_type": "Pacific/Chatham",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Chatham Islands Standard Time",
          "_type": "Pacific/Chatham",
          "_territory": "NZ"
        }
      }, {
        "mapZone": {
          "_other": "China Standard Time",
          "_type": "Asia/Shanghai",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "China Standard Time",
          "_type": "Asia/Shanghai",
          "_territory": "CN"
        }
      }, {
        "mapZone": {
          "_other": "China Standard Time",
          "_type": "Asia/Hong_Kong",
          "_territory": "HK"
        }
      }, {
        "mapZone": {
          "_other": "China Standard Time",
          "_type": "Asia/Macau",
          "_territory": "MO"
        }
      }, {
        "mapZone": {
          "_other": "Cuba Standard Time",
          "_type": "America/Havana",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Cuba Standard Time",
          "_type": "America/Havana",
          "_territory": "CU"
        }
      }, {
        "mapZone": {
          "_other": "Dateline Standard Time",
          "_type": "Etc/GMT+12",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Dateline Standard Time",
          "_type": "Etc/GMT+12",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Nairobi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Antarctica/Syowa",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Djibouti",
          "_territory": "DJ"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Asmera",
          "_territory": "ER"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Addis_Ababa",
          "_territory": "ET"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Nairobi",
          "_territory": "KE"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Indian/Comoro",
          "_territory": "KM"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Indian/Antananarivo",
          "_territory": "MG"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Mogadishu",
          "_territory": "SO"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Juba",
          "_territory": "SS"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Dar_es_Salaam",
          "_territory": "TZ"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Africa/Kampala",
          "_territory": "UG"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Indian/Mayotte",
          "_territory": "YT"
        }
      }, {
        "mapZone": {
          "_other": "E. Africa Standard Time",
          "_type": "Etc/GMT-3",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "E. Australia Standard Time",
          "_type": "Australia/Brisbane",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "E. Australia Standard Time",
          "_type": "Australia/Brisbane Australia/Lindeman",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "E. Europe Standard Time",
          "_type": "Europe/Chisinau",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "E. Europe Standard Time",
          "_type": "Europe/Chisinau",
          "_territory": "MD"
        }
      }, {
        "mapZone": {
          "_other": "E. South America Standard Time",
          "_type": "America/Sao_Paulo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "E. South America Standard Time",
          "_type": "America/Sao_Paulo",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "Easter Island Standard Time",
          "_type": "Pacific/Easter",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Easter Island Standard Time",
          "_type": "Pacific/Easter",
          "_territory": "CL"
        }
      }, {
        "mapZone": {
          "_other": "Eastern Standard Time",
          "_type": "America/New_York",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Eastern Standard Time",
          "_type": "America/Nassau",
          "_territory": "BS"
        }
      }, {
        "mapZone": {
          "_other": "Eastern Standard Time",
          "_type": "America/Toronto America/Iqaluit America/Montreal America/Nipigon America/Pangnirtung America/Thunder_Bay",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "Eastern Standard Time",
          "_type": "America/New_York America/Detroit America/Indiana/Petersburg America/Indiana/Vincennes America/Indiana/Winamac America/Kentucky/Monticello America/Louisville",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "Eastern Standard Time",
          "_type": "EST5EDT",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Eastern Standard Time (Mexico)",
          "_type": "America/Cancun",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Eastern Standard Time (Mexico)",
          "_type": "America/Cancun",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "Egypt Standard Time",
          "_type": "Africa/Cairo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Egypt Standard Time",
          "_type": "Africa/Cairo",
          "_territory": "EG"
        }
      }, {
        "mapZone": {
          "_other": "Ekaterinburg Standard Time",
          "_type": "Asia/Yekaterinburg",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Ekaterinburg Standard Time",
          "_type": "Asia/Yekaterinburg",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Fiji Standard Time",
          "_type": "Pacific/Fiji",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Fiji Standard Time",
          "_type": "Pacific/Fiji",
          "_territory": "FJ"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Kiev",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Mariehamn",
          "_territory": "AX"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Sofia",
          "_territory": "BG"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Tallinn",
          "_territory": "EE"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Helsinki",
          "_territory": "FI"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Vilnius",
          "_territory": "LT"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Riga",
          "_territory": "LV"
        }
      }, {
        "mapZone": {
          "_other": "FLE Standard Time",
          "_type": "Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
          "_territory": "UA"
        }
      }, {
        "mapZone": {
          "_other": "Georgian Standard Time",
          "_type": "Asia/Tbilisi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Georgian Standard Time",
          "_type": "Asia/Tbilisi",
          "_territory": "GE"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Europe/London",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Atlantic/Canary",
          "_territory": "ES"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Atlantic/Faeroe",
          "_territory": "FO"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Europe/London",
          "_territory": "GB"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Europe/Guernsey",
          "_territory": "GG"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Europe/Dublin",
          "_territory": "IE"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Europe/Isle_of_Man",
          "_territory": "IM"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Europe/Jersey",
          "_territory": "JE"
        }
      }, {
        "mapZone": {
          "_other": "GMT Standard Time",
          "_type": "Europe/Lisbon Atlantic/Madeira",
          "_territory": "PT"
        }
      }, {
        "mapZone": {
          "_other": "Greenland Standard Time",
          "_type": "America/Godthab",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Greenland Standard Time",
          "_type": "America/Godthab",
          "_territory": "GL"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Atlantic/Reykjavik",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Ouagadougou",
          "_territory": "BF"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Abidjan",
          "_territory": "CI"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Accra",
          "_territory": "GH"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Banjul",
          "_territory": "GM"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Conakry",
          "_territory": "GN"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Bissau",
          "_territory": "GW"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Atlantic/Reykjavik",
          "_territory": "IS"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Monrovia",
          "_territory": "LR"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Bamako",
          "_territory": "ML"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Nouakchott",
          "_territory": "MR"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Atlantic/St_Helena",
          "_territory": "SH"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Freetown",
          "_territory": "SL"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Dakar",
          "_territory": "SN"
        }
      }, {
        "mapZone": {
          "_other": "Greenwich Standard Time",
          "_type": "Africa/Lome",
          "_territory": "TG"
        }
      }, {
        "mapZone": {
          "_other": "GTB Standard Time",
          "_type": "Europe/Bucharest",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "GTB Standard Time",
          "_type": "Asia/Famagusta Asia/Nicosia",
          "_territory": "CY"
        }
      }, {
        "mapZone": {
          "_other": "GTB Standard Time",
          "_type": "Europe/Athens",
          "_territory": "GR"
        }
      }, {
        "mapZone": {
          "_other": "GTB Standard Time",
          "_type": "Europe/Bucharest",
          "_territory": "RO"
        }
      }, {
        "mapZone": {
          "_other": "Haiti Standard Time",
          "_type": "America/Port-au-Prince",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Haiti Standard Time",
          "_type": "America/Port-au-Prince",
          "_territory": "HT"
        }
      }, {
        "mapZone": {
          "_other": "Hawaiian Standard Time",
          "_type": "Pacific/Honolulu",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Hawaiian Standard Time",
          "_type": "Pacific/Rarotonga",
          "_territory": "CK"
        }
      }, {
        "mapZone": {
          "_other": "Hawaiian Standard Time",
          "_type": "Pacific/Tahiti",
          "_territory": "PF"
        }
      }, {
        "mapZone": {
          "_other": "Hawaiian Standard Time",
          "_type": "Pacific/Johnston",
          "_territory": "UM"
        }
      }, {
        "mapZone": {
          "_other": "Hawaiian Standard Time",
          "_type": "Pacific/Honolulu",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "Hawaiian Standard Time",
          "_type": "Etc/GMT+10",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "India Standard Time",
          "_type": "Asia/Calcutta",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "India Standard Time",
          "_type": "Asia/Calcutta",
          "_territory": "IN"
        }
      }, {
        "mapZone": {
          "_other": "Iran Standard Time",
          "_type": "Asia/Tehran",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Iran Standard Time",
          "_type": "Asia/Tehran",
          "_territory": "IR"
        }
      }, {
        "mapZone": {
          "_other": "Israel Standard Time",
          "_type": "Asia/Jerusalem",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Israel Standard Time",
          "_type": "Asia/Jerusalem",
          "_territory": "IL"
        }
      }, {
        "mapZone": {
          "_other": "Jordan Standard Time",
          "_type": "Asia/Amman",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Jordan Standard Time",
          "_type": "Asia/Amman",
          "_territory": "JO"
        }
      }, {
        "mapZone": {
          "_other": "Kaliningrad Standard Time",
          "_type": "Europe/Kaliningrad",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Kaliningrad Standard Time",
          "_type": "Europe/Kaliningrad",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Korea Standard Time",
          "_type": "Asia/Seoul",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Korea Standard Time",
          "_type": "Asia/Seoul",
          "_territory": "KR"
        }
      }, {
        "mapZone": {
          "_other": "Libya Standard Time",
          "_type": "Africa/Tripoli",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Libya Standard Time",
          "_type": "Africa/Tripoli",
          "_territory": "LY"
        }
      }, {
        "mapZone": {
          "_other": "Line Islands Standard Time",
          "_type": "Pacific/Kiritimati",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Line Islands Standard Time",
          "_type": "Pacific/Kiritimati",
          "_territory": "KI"
        }
      }, {
        "mapZone": {
          "_other": "Line Islands Standard Time",
          "_type": "Etc/GMT-14",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Lord Howe Standard Time",
          "_type": "Australia/Lord_Howe",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Lord Howe Standard Time",
          "_type": "Australia/Lord_Howe",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "Magadan Standard Time",
          "_type": "Asia/Magadan",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Magadan Standard Time",
          "_type": "Asia/Magadan",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Magallanes Standard Time",
          "_type": "America/Punta_Arenas",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Magallanes Standard Time",
          "_type": "Antarctica/Palmer",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "Magallanes Standard Time",
          "_type": "America/Punta_Arenas",
          "_territory": "CL"
        }
      }, {
        "mapZone": {
          "_other": "Marquesas Standard Time",
          "_type": "Pacific/Marquesas",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Marquesas Standard Time",
          "_type": "Pacific/Marquesas",
          "_territory": "PF"
        }
      }, {
        "mapZone": {
          "_other": "Mauritius Standard Time",
          "_type": "Indian/Mauritius",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mauritius Standard Time",
          "_type": "Indian/Mauritius",
          "_territory": "MU"
        }
      }, {
        "mapZone": {
          "_other": "Mauritius Standard Time",
          "_type": "Indian/Reunion",
          "_territory": "RE"
        }
      }, {
        "mapZone": {
          "_other": "Mauritius Standard Time",
          "_type": "Indian/Mahe",
          "_territory": "SC"
        }
      }, {
        "mapZone": {
          "_other": "Middle East Standard Time",
          "_type": "Asia/Beirut",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Middle East Standard Time",
          "_type": "Asia/Beirut",
          "_territory": "LB"
        }
      }, {
        "mapZone": {
          "_other": "Montevideo Standard Time",
          "_type": "America/Montevideo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Montevideo Standard Time",
          "_type": "America/Montevideo",
          "_territory": "UY"
        }
      }, {
        "mapZone": {
          "_other": "Morocco Standard Time",
          "_type": "Africa/Casablanca",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Morocco Standard Time",
          "_type": "Africa/El_Aaiun",
          "_territory": "EH"
        }
      }, {
        "mapZone": {
          "_other": "Morocco Standard Time",
          "_type": "Africa/Casablanca",
          "_territory": "MA"
        }
      }, {
        "mapZone": {
          "_other": "Mountain Standard Time",
          "_type": "America/Denver",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mountain Standard Time",
          "_type": "America/Edmonton America/Cambridge_Bay America/Inuvik America/Yellowknife",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "Mountain Standard Time",
          "_type": "America/Ojinaga",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "Mountain Standard Time",
          "_type": "America/Denver America/Boise",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "Mountain Standard Time",
          "_type": "MST7MDT",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Mountain Standard Time (Mexico)",
          "_type": "America/Chihuahua",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Mountain Standard Time (Mexico)",
          "_type": "America/Chihuahua America/Mazatlan",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "Myanmar Standard Time",
          "_type": "Asia/Rangoon",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Myanmar Standard Time",
          "_type": "Indian/Cocos",
          "_territory": "CC"
        }
      }, {
        "mapZone": {
          "_other": "Myanmar Standard Time",
          "_type": "Asia/Rangoon",
          "_territory": "MM"
        }
      }, {
        "mapZone": {
          "_other": "N. Central Asia Standard Time",
          "_type": "Asia/Novosibirsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "N. Central Asia Standard Time",
          "_type": "Asia/Novosibirsk",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Namibia Standard Time",
          "_type": "Africa/Windhoek",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Namibia Standard Time",
          "_type": "Africa/Windhoek",
          "_territory": "NA"
        }
      }, {
        "mapZone": {
          "_other": "Nepal Standard Time",
          "_type": "Asia/Katmandu",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Nepal Standard Time",
          "_type": "Asia/Katmandu",
          "_territory": "NP"
        }
      }, {
        "mapZone": {
          "_other": "New Zealand Standard Time",
          "_type": "Pacific/Auckland",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "New Zealand Standard Time",
          "_type": "Antarctica/McMurdo",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "New Zealand Standard Time",
          "_type": "Pacific/Auckland",
          "_territory": "NZ"
        }
      }, {
        "mapZone": {
          "_other": "Newfoundland Standard Time",
          "_type": "America/St_Johns",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Newfoundland Standard Time",
          "_type": "America/St_Johns",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "Norfolk Standard Time",
          "_type": "Pacific/Norfolk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Norfolk Standard Time",
          "_type": "Pacific/Norfolk",
          "_territory": "NF"
        }
      }, {
        "mapZone": {
          "_other": "North Asia East Standard Time",
          "_type": "Asia/Irkutsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "North Asia East Standard Time",
          "_type": "Asia/Irkutsk",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "North Asia Standard Time",
          "_type": "Asia/Krasnoyarsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "North Asia Standard Time",
          "_type": "Asia/Krasnoyarsk Asia/Novokuznetsk",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "North Korea Standard Time",
          "_type": "Asia/Pyongyang",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "North Korea Standard Time",
          "_type": "Asia/Pyongyang",
          "_territory": "KP"
        }
      }, {
        "mapZone": {
          "_other": "Omsk Standard Time",
          "_type": "Asia/Omsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Omsk Standard Time",
          "_type": "Asia/Omsk",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Pacific SA Standard Time",
          "_type": "America/Santiago",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pacific SA Standard Time",
          "_type": "America/Santiago",
          "_territory": "CL"
        }
      }, {
        "mapZone": {
          "_other": "Pacific Standard Time",
          "_type": "America/Los_Angeles",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pacific Standard Time",
          "_type": "America/Vancouver America/Dawson America/Whitehorse",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "Pacific Standard Time",
          "_type": "America/Los_Angeles America/Metlakatla",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "Pacific Standard Time",
          "_type": "PST8PDT",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Pacific Standard Time (Mexico)",
          "_type": "America/Tijuana",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pacific Standard Time (Mexico)",
          "_type": "America/Tijuana America/Santa_Isabel",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "Pakistan Standard Time",
          "_type": "Asia/Karachi",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Pakistan Standard Time",
          "_type": "Asia/Karachi",
          "_territory": "PK"
        }
      }, {
        "mapZone": {
          "_other": "Paraguay Standard Time",
          "_type": "America/Asuncion",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Paraguay Standard Time",
          "_type": "America/Asuncion",
          "_territory": "PY"
        }
      }, {
        "mapZone": {
          "_other": "Romance Standard Time",
          "_type": "Europe/Paris",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Romance Standard Time",
          "_type": "Europe/Brussels",
          "_territory": "BE"
        }
      }, {
        "mapZone": {
          "_other": "Romance Standard Time",
          "_type": "Europe/Copenhagen",
          "_territory": "DK"
        }
      }, {
        "mapZone": {
          "_other": "Romance Standard Time",
          "_type": "Europe/Madrid Africa/Ceuta",
          "_territory": "ES"
        }
      }, {
        "mapZone": {
          "_other": "Romance Standard Time",
          "_type": "Europe/Paris",
          "_territory": "FR"
        }
      }, {
        "mapZone": {
          "_other": "Russia Time Zone 3",
          "_type": "Europe/Samara",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Russia Time Zone 3",
          "_type": "Europe/Samara",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Russia Time Zone 10",
          "_type": "Asia/Srednekolymsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Russia Time Zone 10",
          "_type": "Asia/Srednekolymsk",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Russia Time Zone 11",
          "_type": "Asia/Kamchatka",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Russia Time Zone 11",
          "_type": "Asia/Kamchatka Asia/Anadyr",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Russian Standard Time",
          "_type": "Europe/Moscow",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Russian Standard Time",
          "_type": "Europe/Moscow Europe/Kirov Europe/Volgograd",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Russian Standard Time",
          "_type": "Europe/Simferopol",
          "_territory": "UA"
        }
      }, {
        "mapZone": {
          "_other": "SA Eastern Standard Time",
          "_type": "America/Cayenne",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "SA Eastern Standard Time",
          "_type": "Antarctica/Rothera",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "SA Eastern Standard Time",
          "_type": "America/Fortaleza America/Belem America/Maceio America/Recife America/Santarem",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "SA Eastern Standard Time",
          "_type": "Atlantic/Stanley",
          "_territory": "FK"
        }
      }, {
        "mapZone": {
          "_other": "SA Eastern Standard Time",
          "_type": "America/Cayenne",
          "_territory": "GF"
        }
      }, {
        "mapZone": {
          "_other": "SA Eastern Standard Time",
          "_type": "America/Paramaribo",
          "_territory": "SR"
        }
      }, {
        "mapZone": {
          "_other": "SA Eastern Standard Time",
          "_type": "Etc/GMT+3",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Bogota",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Rio_Branco America/Eirunepe",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Coral_Harbour",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Bogota",
          "_territory": "CO"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Guayaquil",
          "_territory": "EC"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Jamaica",
          "_territory": "JM"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Cayman",
          "_territory": "KY"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Panama",
          "_territory": "PA"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "America/Lima",
          "_territory": "PE"
        }
      }, {
        "mapZone": {
          "_other": "SA Pacific Standard Time",
          "_type": "Etc/GMT+5",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/La_Paz",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Antigua",
          "_territory": "AG"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Anguilla",
          "_territory": "AI"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Aruba",
          "_territory": "AW"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Barbados",
          "_territory": "BB"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/St_Barthelemy",
          "_territory": "BL"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/La_Paz",
          "_territory": "BO"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Kralendijk",
          "_territory": "BQ"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Manaus America/Boa_Vista America/Porto_Velho",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Blanc-Sablon",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Curacao",
          "_territory": "CW"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Dominica",
          "_territory": "DM"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Santo_Domingo",
          "_territory": "DO"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Grenada",
          "_territory": "GD"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Guadeloupe",
          "_territory": "GP"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Guyana",
          "_territory": "GY"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/St_Kitts",
          "_territory": "KN"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/St_Lucia",
          "_territory": "LC"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Marigot",
          "_territory": "MF"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Martinique",
          "_territory": "MQ"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Montserrat",
          "_territory": "MS"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Puerto_Rico",
          "_territory": "PR"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Lower_Princes",
          "_territory": "SX"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Port_of_Spain",
          "_territory": "TT"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/St_Vincent",
          "_territory": "VC"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/Tortola",
          "_territory": "VG"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "America/St_Thomas",
          "_territory": "VI"
        }
      }, {
        "mapZone": {
          "_other": "SA Western Standard Time",
          "_type": "Etc/GMT+4",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Saint Pierre Standard Time",
          "_type": "America/Miquelon",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Saint Pierre Standard Time",
          "_type": "America/Miquelon",
          "_territory": "PM"
        }
      }, {
        "mapZone": {
          "_other": "Sakhalin Standard Time",
          "_type": "Asia/Sakhalin",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Sakhalin Standard Time",
          "_type": "Asia/Sakhalin",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Samoa Standard Time",
          "_type": "Pacific/Apia",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Samoa Standard Time",
          "_type": "Pacific/Apia",
          "_territory": "WS"
        }
      }, {
        "mapZone": {
          "_other": "Sao Tome Standard Time",
          "_type": "Africa/Sao_Tome",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Sao Tome Standard Time",
          "_type": "Africa/Sao_Tome",
          "_territory": "ST"
        }
      }, {
        "mapZone": {
          "_other": "Saratov Standard Time",
          "_type": "Europe/Saratov",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Saratov Standard Time",
          "_type": "Europe/Saratov",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Asia/Bangkok",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Antarctica/Davis",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Indian/Christmas",
          "_territory": "CX"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Asia/Jakarta Asia/Pontianak",
          "_territory": "ID"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Asia/Phnom_Penh",
          "_territory": "KH"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Asia/Vientiane",
          "_territory": "LA"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Asia/Bangkok",
          "_territory": "TH"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Asia/Saigon",
          "_territory": "VN"
        }
      }, {
        "mapZone": {
          "_other": "SE Asia Standard Time",
          "_type": "Etc/GMT-7",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Singapore Standard Time",
          "_type": "Asia/Singapore",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Singapore Standard Time",
          "_type": "Asia/Brunei",
          "_territory": "BN"
        }
      }, {
        "mapZone": {
          "_other": "Singapore Standard Time",
          "_type": "Asia/Makassar",
          "_territory": "ID"
        }
      }, {
        "mapZone": {
          "_other": "Singapore Standard Time",
          "_type": "Asia/Kuala_Lumpur Asia/Kuching",
          "_territory": "MY"
        }
      }, {
        "mapZone": {
          "_other": "Singapore Standard Time",
          "_type": "Asia/Manila",
          "_territory": "PH"
        }
      }, {
        "mapZone": {
          "_other": "Singapore Standard Time",
          "_type": "Asia/Singapore",
          "_territory": "SG"
        }
      }, {
        "mapZone": {
          "_other": "Singapore Standard Time",
          "_type": "Etc/GMT-8",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Johannesburg",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Bujumbura",
          "_territory": "BI"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Gaborone",
          "_territory": "BW"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Lubumbashi",
          "_territory": "CD"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Maseru",
          "_territory": "LS"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Blantyre",
          "_territory": "MW"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Maputo",
          "_territory": "MZ"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Kigali",
          "_territory": "RW"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Mbabane",
          "_territory": "SZ"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Johannesburg",
          "_territory": "ZA"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Lusaka",
          "_territory": "ZM"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Africa/Harare",
          "_territory": "ZW"
        }
      }, {
        "mapZone": {
          "_other": "South Africa Standard Time",
          "_type": "Etc/GMT-2",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Sri Lanka Standard Time",
          "_type": "Asia/Colombo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Sri Lanka Standard Time",
          "_type": "Asia/Colombo",
          "_territory": "LK"
        }
      }, {
        "mapZone": {
          "_other": "Sudan Standard Time",
          "_type": "Africa/Khartoum",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Sudan Standard Time",
          "_type": "Africa/Khartoum",
          "_territory": "SD"
        }
      }, {
        "mapZone": {
          "_other": "Syria Standard Time",
          "_type": "Asia/Damascus",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Syria Standard Time",
          "_type": "Asia/Damascus",
          "_territory": "SY"
        }
      }, {
        "mapZone": {
          "_other": "Taipei Standard Time",
          "_type": "Asia/Taipei",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Taipei Standard Time",
          "_type": "Asia/Taipei",
          "_territory": "TW"
        }
      }, {
        "mapZone": {
          "_other": "Tasmania Standard Time",
          "_type": "Australia/Hobart",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tasmania Standard Time",
          "_type": "Australia/Hobart Australia/Currie",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "Tocantins Standard Time",
          "_type": "America/Araguaina",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tocantins Standard Time",
          "_type": "America/Araguaina",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "Tokyo Standard Time",
          "_type": "Asia/Tokyo",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tokyo Standard Time",
          "_type": "Asia/Jayapura",
          "_territory": "ID"
        }
      }, {
        "mapZone": {
          "_other": "Tokyo Standard Time",
          "_type": "Asia/Tokyo",
          "_territory": "JP"
        }
      }, {
        "mapZone": {
          "_other": "Tokyo Standard Time",
          "_type": "Pacific/Palau",
          "_territory": "PW"
        }
      }, {
        "mapZone": {
          "_other": "Tokyo Standard Time",
          "_type": "Asia/Dili",
          "_territory": "TL"
        }
      }, {
        "mapZone": {
          "_other": "Tokyo Standard Time",
          "_type": "Etc/GMT-9",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Tomsk Standard Time",
          "_type": "Asia/Tomsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tomsk Standard Time",
          "_type": "Asia/Tomsk",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Tonga Standard Time",
          "_type": "Pacific/Tongatapu",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Tonga Standard Time",
          "_type": "Pacific/Tongatapu",
          "_territory": "TO"
        }
      }, {
        "mapZone": {
          "_other": "Transbaikal Standard Time",
          "_type": "Asia/Chita",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Transbaikal Standard Time",
          "_type": "Asia/Chita",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "Turkey Standard Time",
          "_type": "Europe/Istanbul",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Turkey Standard Time",
          "_type": "Europe/Istanbul",
          "_territory": "TR"
        }
      }, {
        "mapZone": {
          "_other": "Turks And Caicos Standard Time",
          "_type": "America/Grand_Turk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Turks And Caicos Standard Time",
          "_type": "America/Grand_Turk",
          "_territory": "TC"
        }
      }, {
        "mapZone": {
          "_other": "Ulaanbaatar Standard Time",
          "_type": "Asia/Ulaanbaatar",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Ulaanbaatar Standard Time",
          "_type": "Asia/Ulaanbaatar Asia/Choibalsan",
          "_territory": "MN"
        }
      }, {
        "mapZone": {
          "_other": "US Eastern Standard Time",
          "_type": "America/Indianapolis",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "US Eastern Standard Time",
          "_type": "America/Indianapolis America/Indiana/Marengo America/Indiana/Vevay",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "US Mountain Standard Time",
          "_type": "America/Phoenix",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "US Mountain Standard Time",
          "_type": "America/Dawson_Creek America/Creston America/Fort_Nelson",
          "_territory": "CA"
        }
      }, {
        "mapZone": {
          "_other": "US Mountain Standard Time",
          "_type": "America/Hermosillo",
          "_territory": "MX"
        }
      }, {
        "mapZone": {
          "_other": "US Mountain Standard Time",
          "_type": "America/Phoenix",
          "_territory": "US"
        }
      }, {
        "mapZone": {
          "_other": "US Mountain Standard Time",
          "_type": "Etc/GMT+7",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "UTC",
          "_type": "Etc/GMT",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "UTC",
          "_type": "America/Danmarkshavn",
          "_territory": "GL"
        }
      }, {
        "mapZone": {
          "_other": "UTC",
          "_type": "Etc/GMT Etc/UTC",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "UTC-02",
          "_type": "Etc/GMT+2",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "UTC-02",
          "_type": "America/Noronha",
          "_territory": "BR"
        }
      }, {
        "mapZone": {
          "_other": "UTC-02",
          "_type": "Atlantic/South_Georgia",
          "_territory": "GS"
        }
      }, {
        "mapZone": {
          "_other": "UTC-02",
          "_type": "Etc/GMT+2",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "UTC-08",
          "_type": "Etc/GMT+8",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "UTC-08",
          "_type": "Pacific/Pitcairn",
          "_territory": "PN"
        }
      }, {
        "mapZone": {
          "_other": "UTC-08",
          "_type": "Etc/GMT+8",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "UTC-09",
          "_type": "Etc/GMT+9",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "UTC-09",
          "_type": "Pacific/Gambier",
          "_territory": "PF"
        }
      }, {
        "mapZone": {
          "_other": "UTC-09",
          "_type": "Etc/GMT+9",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "UTC-11",
          "_type": "Etc/GMT+11",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "UTC-11",
          "_type": "Pacific/Pago_Pago",
          "_territory": "AS"
        }
      }, {
        "mapZone": {
          "_other": "UTC-11",
          "_type": "Pacific/Niue",
          "_territory": "NU"
        }
      }, {
        "mapZone": {
          "_other": "UTC-11",
          "_type": "Pacific/Midway",
          "_territory": "UM"
        }
      }, {
        "mapZone": {
          "_other": "UTC-11",
          "_type": "Etc/GMT+11",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Etc/GMT-12",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Pacific/Tarawa",
          "_territory": "KI"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Pacific/Majuro Pacific/Kwajalein",
          "_territory": "MH"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Pacific/Nauru",
          "_territory": "NR"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Pacific/Funafuti",
          "_territory": "TV"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Pacific/Wake",
          "_territory": "UM"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Pacific/Wallis",
          "_territory": "WF"
        }
      }, {
        "mapZone": {
          "_other": "UTC+12",
          "_type": "Etc/GMT-12",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "UTC+13",
          "_type": "Etc/GMT-13",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "UTC+13",
          "_type": "Pacific/Enderbury",
          "_territory": "KI"
        }
      }, {
        "mapZone": {
          "_other": "UTC+13",
          "_type": "Pacific/Fakaofo",
          "_territory": "TK"
        }
      }, {
        "mapZone": {
          "_other": "UTC+13",
          "_type": "Etc/GMT-13",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Venezuela Standard Time",
          "_type": "America/Caracas",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Venezuela Standard Time",
          "_type": "America/Caracas",
          "_territory": "VE"
        }
      }, {
        "mapZone": {
          "_other": "Vladivostok Standard Time",
          "_type": "Asia/Vladivostok",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Vladivostok Standard Time",
          "_type": "Asia/Vladivostok Asia/Ust-Nera",
          "_territory": "RU"
        }
      }, {
        "mapZone": {
          "_other": "W. Australia Standard Time",
          "_type": "Australia/Perth",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "W. Australia Standard Time",
          "_type": "Antarctica/Casey",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "W. Australia Standard Time",
          "_type": "Australia/Perth",
          "_territory": "AU"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Lagos",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Luanda",
          "_territory": "AO"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Porto-Novo",
          "_territory": "BJ"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Kinshasa",
          "_territory": "CD"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Bangui",
          "_territory": "CF"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Brazzaville",
          "_territory": "CG"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Douala",
          "_territory": "CM"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Algiers",
          "_territory": "DZ"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Libreville",
          "_territory": "GA"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Malabo",
          "_territory": "GQ"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Niamey",
          "_territory": "NE"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Lagos",
          "_territory": "NG"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Ndjamena",
          "_territory": "TD"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Africa/Tunis",
          "_territory": "TN"
        }
      }, {
        "mapZone": {
          "_other": "W. Central Africa Standard Time",
          "_type": "Etc/GMT-1",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Berlin",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Andorra",
          "_territory": "AD"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Vienna",
          "_territory": "AT"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Zurich",
          "_territory": "CH"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Berlin Europe/Busingen",
          "_territory": "DE"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Gibraltar",
          "_territory": "GI"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Rome",
          "_territory": "IT"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Vaduz",
          "_territory": "LI"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Luxembourg",
          "_territory": "LU"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Monaco",
          "_territory": "MC"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Malta",
          "_territory": "MT"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Amsterdam",
          "_territory": "NL"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Oslo",
          "_territory": "NO"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Stockholm",
          "_territory": "SE"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Arctic/Longyearbyen",
          "_territory": "SJ"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/San_Marino",
          "_territory": "SM"
        }
      }, {
        "mapZone": {
          "_other": "W. Europe Standard Time",
          "_type": "Europe/Vatican",
          "_territory": "VA"
        }
      }, {
        "mapZone": {
          "_other": "W. Mongolia Standard Time",
          "_type": "Asia/Hovd",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "W. Mongolia Standard Time",
          "_type": "Asia/Hovd",
          "_territory": "MN"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Asia/Tashkent",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Antarctica/Mawson",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Asia/Oral Asia/Aqtau Asia/Aqtobe Asia/Atyrau Asia/Qyzylorda",
          "_territory": "KZ"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Indian/Maldives",
          "_territory": "MV"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Indian/Kerguelen",
          "_territory": "TF"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Asia/Dushanbe",
          "_territory": "TJ"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Asia/Ashgabat",
          "_territory": "TM"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Asia/Tashkent Asia/Samarkand",
          "_territory": "UZ"
        }
      }, {
        "mapZone": {
          "_other": "West Asia Standard Time",
          "_type": "Etc/GMT-5",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "West Bank Standard Time",
          "_type": "Asia/Hebron",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "West Bank Standard Time",
          "_type": "Asia/Hebron Asia/Gaza",
          "_territory": "PS"
        }
      }, {
        "mapZone": {
          "_other": "West Pacific Standard Time",
          "_type": "Pacific/Port_Moresby",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "West Pacific Standard Time",
          "_type": "Antarctica/DumontDUrville",
          "_territory": "AQ"
        }
      }, {
        "mapZone": {
          "_other": "West Pacific Standard Time",
          "_type": "Pacific/Truk",
          "_territory": "FM"
        }
      }, {
        "mapZone": {
          "_other": "West Pacific Standard Time",
          "_type": "Pacific/Guam",
          "_territory": "GU"
        }
      }, {
        "mapZone": {
          "_other": "West Pacific Standard Time",
          "_type": "Pacific/Saipan",
          "_territory": "MP"
        }
      }, {
        "mapZone": {
          "_other": "West Pacific Standard Time",
          "_type": "Pacific/Port_Moresby",
          "_territory": "PG"
        }
      }, {
        "mapZone": {
          "_other": "West Pacific Standard Time",
          "_type": "Etc/GMT-10",
          "_territory": "ZZ"
        }
      }, {
        "mapZone": {
          "_other": "Yakutsk Standard Time",
          "_type": "Asia/Yakutsk",
          "_territory": "001"
        }
      }, {
        "mapZone": {
          "_other": "Yakutsk Standard Time",
          "_type": "Asia/Yakutsk Asia/Khandyga",
          "_territory": "RU"
        }
      }]
    }
  }
}, {
  "main": {
    "cs": {
      "identity": {
        "version": {
          "_number": "$Revision: 14844 $",
          "_cldrVersion": "35.1"
        },
        "language": "cs"
      },
      "dates": {
        "calendars": {
          "gregorian": {
            "months": {
              "format": {
                "abbreviated": {
                  "1": "led",
                  "2": "úno",
                  "3": "bře",
                  "4": "dub",
                  "5": "kvě",
                  "6": "čvn",
                  "7": "čvc",
                  "8": "srp",
                  "9": "zář",
                  "10": "říj",
                  "11": "lis",
                  "12": "pro"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4",
                  "5": "5",
                  "6": "6",
                  "7": "7",
                  "8": "8",
                  "9": "9",
                  "10": "10",
                  "11": "11",
                  "12": "12"
                },
                "wide": {
                  "1": "ledna",
                  "2": "února",
                  "3": "března",
                  "4": "dubna",
                  "5": "května",
                  "6": "června",
                  "7": "července",
                  "8": "srpna",
                  "9": "září",
                  "10": "října",
                  "11": "listopadu",
                  "12": "prosince"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "led",
                  "2": "úno",
                  "3": "bře",
                  "4": "dub",
                  "5": "kvě",
                  "6": "čvn",
                  "7": "čvc",
                  "8": "srp",
                  "9": "zář",
                  "10": "říj",
                  "11": "lis",
                  "12": "pro"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4",
                  "5": "5",
                  "6": "6",
                  "7": "7",
                  "8": "8",
                  "9": "9",
                  "10": "10",
                  "11": "11",
                  "12": "12"
                },
                "wide": {
                  "1": "leden",
                  "2": "únor",
                  "3": "březen",
                  "4": "duben",
                  "5": "květen",
                  "6": "červen",
                  "7": "červenec",
                  "8": "srpen",
                  "9": "září",
                  "10": "říjen",
                  "11": "listopad",
                  "12": "prosinec"
                }
              }
            },
            "days": {
              "format": {
                "abbreviated": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "út",
                  "wed": "st",
                  "thu": "čt",
                  "fri": "pá",
                  "sat": "so"
                },
                "narrow": {
                  "sun": "N",
                  "mon": "P",
                  "tue": "Ú",
                  "wed": "S",
                  "thu": "Č",
                  "fri": "P",
                  "sat": "S"
                },
                "short": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "út",
                  "wed": "st",
                  "thu": "čt",
                  "fri": "pá",
                  "sat": "so"
                },
                "wide": {
                  "sun": "neděle",
                  "mon": "pondělí",
                  "tue": "úterý",
                  "wed": "středa",
                  "thu": "čtvrtek",
                  "fri": "pátek",
                  "sat": "sobota"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "út",
                  "wed": "st",
                  "thu": "čt",
                  "fri": "pá",
                  "sat": "so"
                },
                "narrow": {
                  "sun": "N",
                  "mon": "P",
                  "tue": "Ú",
                  "wed": "S",
                  "thu": "Č",
                  "fri": "P",
                  "sat": "S"
                },
                "short": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "út",
                  "wed": "st",
                  "thu": "čt",
                  "fri": "pá",
                  "sat": "so"
                },
                "wide": {
                  "sun": "neděle",
                  "mon": "pondělí",
                  "tue": "úterý",
                  "wed": "středa",
                  "thu": "čtvrtek",
                  "fri": "pátek",
                  "sat": "sobota"
                }
              }
            },
            "quarters": {
              "format": {
                "abbreviated": {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1. čtvrtletí",
                  "2": "2. čtvrtletí",
                  "3": "3. čtvrtletí",
                  "4": "4. čtvrtletí"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1. čtvrtletí",
                  "2": "2. čtvrtletí",
                  "3": "3. čtvrtletí",
                  "4": "4. čtvrtletí"
                }
              }
            },
            "dayPeriods": {
              "format": {
                "abbreviated": {
                  "midnight": "půln.",
                  "am": "dop.",
                  "noon": "pol.",
                  "pm": "odp.",
                  "morning1": "r.",
                  "morning2": "dop.",
                  "afternoon1": "odp.",
                  "evening1": "več.",
                  "night1": "v n."
                },
                "narrow": {
                  "midnight": "půl.",
                  "am": "dop.",
                  "noon": "pol.",
                  "pm": "odp.",
                  "morning1": "r.",
                  "morning2": "d.",
                  "afternoon1": "o.",
                  "evening1": "v.",
                  "night1": "n."
                },
                "wide": {
                  "midnight": "půlnoc",
                  "am": "dop.",
                  "noon": "poledne",
                  "pm": "odp.",
                  "morning1": "ráno",
                  "morning2": "dopoledne",
                  "afternoon1": "odpoledne",
                  "evening1": "večer",
                  "night1": "v noci"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "midnight": "půlnoc",
                  "am": "dop.",
                  "noon": "poledne",
                  "pm": "odp.",
                  "morning1": "ráno",
                  "morning2": "dopoledne",
                  "afternoon1": "odpoledne",
                  "evening1": "večer",
                  "night1": "noc"
                },
                "narrow": {
                  "midnight": "půl.",
                  "am": "dop.",
                  "noon": "pol.",
                  "pm": "odp.",
                  "morning1": "ráno",
                  "morning2": "dop.",
                  "afternoon1": "odp.",
                  "evening1": "več.",
                  "night1": "noc"
                },
                "wide": {
                  "midnight": "půlnoc",
                  "am": "dop.",
                  "noon": "poledne",
                  "pm": "odp.",
                  "morning1": "ráno",
                  "morning2": "dopoledne",
                  "afternoon1": "odpoledne",
                  "evening1": "večer",
                  "night1": "noc"
                }
              }
            },
            "eras": {
              "eraNames": {
                "0": "před naším letopočtem",
                "1": "našeho letopočtu",
                "0-alt-variant": "BCE",
                "1-alt-variant": "CE"
              },
              "eraAbbr": {
                "0": "př. n. l.",
                "1": "n. l.",
                "0-alt-variant": "BCE",
                "1-alt-variant": "CE"
              },
              "eraNarrow": {
                "0": "př.n.l.",
                "1": "n.l.",
                "0-alt-variant": "BCE",
                "1-alt-variant": "CE"
              }
            },
            "dateFormats": {
              "full": "EEEE d. MMMM y",
              "long": "d. MMMM y",
              "medium": "d. M. y",
              "short": "dd.MM.yy"
            },
            "timeFormats": {
              "full": "H:mm:ss zzzz",
              "long": "H:mm:ss z",
              "medium": "H:mm:ss",
              "short": "H:mm"
            },
            "dateTimeFormats": {
              "full": "{1} {0}",
              "long": "{1} {0}",
              "medium": "{1} {0}",
              "short": "{1} {0}",
              "availableFormats": {
                "Bh": "h B",
                "Bhm": "h:mm B",
                "Bhms": "h:mm:ss B",
                "d": "d.",
                "E": "ccc",
                "EBhm": "E h:mm B",
                "EBhms": "E h:mm:ss B",
                "Ed": "E d.",
                "Ehm": "E h:mm a",
                "EHm": "E H:mm",
                "Ehms": "E h:mm:ss a",
                "EHms": "E H:mm:ss",
                "Gy": "y G",
                "GyMMM": "LLLL y G",
                "GyMMMd": "d. M. y G",
                "GyMMMEd": "E d. M. y G",
                "GyMMMMd": "d. MMMM y G",
                "GyMMMMEd": "E d. MMMM y G",
                "h": "h a",
                "H": "H",
                "hm": "h:mm a",
                "Hm": "H:mm",
                "hms": "h:mm:ss a",
                "Hms": "H:mm:ss",
                "hmsv": "h:mm:ss a v",
                "Hmsv": "H:mm:ss v",
                "hmv": "h:mm a v",
                "Hmv": "H:mm v",
                "M": "L",
                "Md": "d. M.",
                "MEd": "E d. M.",
                "MMM": "LLL",
                "MMMd": "d. M.",
                "MMMEd": "E d. M.",
                "MMMMd": "d. MMMM",
                "MMMMEd": "E d. MMMM",
                "MMMMW-count-one": "W. 'týden' MMMM",
                "MMMMW-count-few": "W. 'týden' MMMM",
                "MMMMW-count-many": "W. 'týden' MMMM",
                "MMMMW-count-other": "W. 'týden' MMMM",
                "ms": "mm:ss",
                "y": "y",
                "yM": "M/y",
                "yMd": "d. M. y",
                "yMEd": "E d. M. y",
                "yMMM": "LLLL y",
                "yMMMd": "d. M. y",
                "yMMMEd": "E d. M. y",
                "yMMMM": "LLLL y",
                "yMMMMd": "d. MMMM y",
                "yMMMMEd": "E d. MMMM y",
                "yQQQ": "QQQ y",
                "yQQQQ": "QQQQ y",
                "yw-count-one": "w. 'týden' 'roku' Y",
                "yw-count-few": "w. 'týden' 'roku' Y",
                "yw-count-many": "w. 'týden' 'roku' Y",
                "yw-count-other": "w. 'týden' 'roku' Y"
              },
              "appendItems": {
                "Day": "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                "Era": "{1} {0}",
                "Hour": "{0} ({2}: {1})",
                "Minute": "{0} ({2}: {1})",
                "Month": "{0} ({2}: {1})",
                "Quarter": "{0} ({2}: {1})",
                "Second": "{0} ({2}: {1})",
                "Timezone": "{0} {1}",
                "Week": "{0} ({2}: {1})",
                "Year": "{1} {0}"
              },
              "intervalFormats": {
                "intervalFormatFallback": "{0} – {1}",
                "Bh": {
                  "B": "h B – h B",
                  "h": "h–h B"
                },
                "Bhm": {
                  "B": "h:mm B – h:mm B",
                  "h": "h:mm–h:mm B",
                  "m": "h:mm–h:mm B"
                },
                "d": {
                  "d": "d.–d."
                },
                "Gy": {
                  "G": "y G – y G",
                  "y": "y–y G"
                },
                "GyM": {
                  "G": "M/y GGGGG – M/y GGGGG",
                  "M": "M/y – M/y GGGGG",
                  "y": "M/y – M/y GGGGG"
                },
                "GyMd": {
                  "d": "d. M. y – d. M. y GGGGG",
                  "G": "d. M. y GGGGG – d. M. y GGGGG",
                  "M": "d. M. y – d. M. y GGGGG",
                  "y": "d. M. y – d. M. y GGGGG"
                },
                "GyMEd": {
                  "d": "E d. M. y – E d. M. y GGGGG",
                  "G": "E d. M. y GGGGG – E d. M. y GGGGG",
                  "M": "E d. M. y – E d. M. y GGGGG",
                  "y": "E d. M. y – E d. M. y GGGGG"
                },
                "GyMMM": {
                  "G": "LLLL y G – LLLL y G",
                  "M": "LLLL–LLLL y G",
                  "y": "LLLL y – LLLL y G"
                },
                "GyMMMd": {
                  "d": "d.–d. M. y G",
                  "G": "d. M. y G – d. M. y G",
                  "M": "d. M. – d. M. y G",
                  "y": "d. M. y – d. M. y G"
                },
                "GyMMMEd": {
                  "d": "E d. M. – E d. M. y G",
                  "G": "E d. M. y G – E d. M. y G",
                  "M": "E d. M. – E d. M. y G",
                  "y": "E d. M. y – E d. M. y G"
                },
                "h": {
                  "a": "h a – h a",
                  "h": "h–h a"
                },
                "H": {
                  "H": "H–H"
                },
                "hm": {
                  "a": "h:mm a – h:mm a",
                  "h": "h:mm–h:mm a",
                  "m": "h:mm–h:mm a"
                },
                "Hm": {
                  "H": "H:mm–H:mm",
                  "m": "H:mm–H:mm"
                },
                "hmv": {
                  "a": "h:mm a – h:mm a v",
                  "h": "h:mm–h:mm a v",
                  "m": "h:mm–h:mm a v"
                },
                "Hmv": {
                  "H": "H:mm–H:mm v",
                  "m": "H:mm–H:mm v"
                },
                "hv": {
                  "a": "h a – h a v",
                  "h": "h–h a v"
                },
                "Hv": {
                  "H": "H–H v"
                },
                "M": {
                  "M": "M–M"
                },
                "Md": {
                  "d": "d. M. – d. M.",
                  "M": "d. M. – d. M."
                },
                "MEd": {
                  "d": "E d. M. – E d. M.",
                  "M": "E d. M. – E d. M."
                },
                "MMM": {
                  "M": "MMM–MMM"
                },
                "MMMd": {
                  "d": "d.–d. M.",
                  "M": "d. M. – d. M."
                },
                "MMMEd": {
                  "d": "E d. M. – E d. M.",
                  "M": "E d. M. – E d. M."
                },
                "y": {
                  "y": "y–y"
                },
                "yM": {
                  "M": "M/y – M/y",
                  "y": "M/y – M/y"
                },
                "yMd": {
                  "d": "dd.MM.y – dd.MM.y",
                  "M": "dd.MM.y – dd.MM.y",
                  "y": "dd.MM.y – dd.MM.y"
                },
                "yMEd": {
                  "d": "E dd.MM.y – E dd.MM.y",
                  "M": "E dd.MM.y – E dd.MM.y",
                  "y": "E dd.MM.y – E dd.MM.y"
                },
                "yMMM": {
                  "M": "MMM–MMM y",
                  "y": "MMM y – MMM y"
                },
                "yMMMd": {
                  "d": "d.–d. M. y",
                  "M": "d. M. – d. M. y",
                  "y": "d. M. y – d. M. y"
                },
                "yMMMEd": {
                  "d": "E d. M. – E d. M. y",
                  "M": "E d. M. – E d. M. y",
                  "y": "E d. M. y – E d. M. y"
                },
                "yMMMM": {
                  "M": "LLLL–LLLL y",
                  "y": "LLLL y – LLLL y"
                }
              }
            }
          }
        }
      }
    }
  }
}, {
  "main": {
    "cs": {
      "identity": {
        "version": {
          "_number": "$Revision: 14844 $",
          "_cldrVersion": "35.1"
        },
        "language": "cs"
      },
      "numbers": {
        "currencies": {
          "ADP": {
            "displayName": "andorrská peseta",
            "displayName-count-one": "andorrská peseta",
            "displayName-count-few": "andorrské pesety",
            "displayName-count-many": "andorrské pesety",
            "displayName-count-other": "andorrských peset",
            "symbol": "ADP"
          },
          "AED": {
            "displayName": "SAE dirham",
            "displayName-count-one": "SAE dirham",
            "displayName-count-few": "SAE dirhamy",
            "displayName-count-many": "SAE dirhamu",
            "displayName-count-other": "SAE dirhamů",
            "symbol": "AED"
          },
          "AFA": {
            "displayName": "afghánský afghán (1927–2002)",
            "displayName-count-one": "afghánský afghán (1927–2002)",
            "displayName-count-few": "afghánské afghány (1927–2002)",
            "displayName-count-many": "afghánského afghánu (1927–2002)",
            "displayName-count-other": "afghánských afghánů (1927–2002)",
            "symbol": "AFA"
          },
          "AFN": {
            "displayName": "afghánský afghán",
            "displayName-count-one": "afghánský afghán",
            "displayName-count-few": "afghánské afghány",
            "displayName-count-many": "afghánského afghánu",
            "displayName-count-other": "afghánských afghánů",
            "symbol": "AFN"
          },
          "ALK": {
            "displayName": "albánský lek (1946–1965)",
            "displayName-count-one": "albánský lek (1946–1965)",
            "displayName-count-few": "albánské leky (1946–1965)",
            "displayName-count-many": "albánského leku (1946–1965)",
            "displayName-count-other": "albánských leků (1946–1965)",
            "symbol": "ALK"
          },
          "ALL": {
            "displayName": "albánský lek",
            "displayName-count-one": "albánský lek",
            "displayName-count-few": "albánské leky",
            "displayName-count-many": "albánského leku",
            "displayName-count-other": "albánských leků",
            "symbol": "ALL"
          },
          "AMD": {
            "displayName": "arménský dram",
            "displayName-count-one": "arménský dram",
            "displayName-count-few": "arménské dramy",
            "displayName-count-many": "arménského dramu",
            "displayName-count-other": "arménských dramů",
            "symbol": "AMD"
          },
          "ANG": {
            "displayName": "nizozemskoantilský gulden",
            "displayName-count-one": "nizozemskoantilský gulden",
            "displayName-count-few": "nizozemskoantilské guldeny",
            "displayName-count-many": "nizozemskoantilského guldenu",
            "displayName-count-other": "nizozemskoantilských guldenů",
            "symbol": "ANG"
          },
          "AOA": {
            "displayName": "angolská kwanza",
            "displayName-count-one": "angolská kwanza",
            "displayName-count-few": "angolské kwanzy",
            "displayName-count-many": "angolské kwanzy",
            "displayName-count-other": "angolských kwanz",
            "symbol": "AOA",
            "symbol-alt-narrow": "Kz"
          },
          "AOK": {
            "displayName": "angolská kwanza (1977–1991)",
            "displayName-count-one": "angolská kwanza (1977–1991)",
            "displayName-count-few": "angolské kwanzy (1977–1991)",
            "displayName-count-many": "angolské kwanzy (1977–1991)",
            "displayName-count-other": "angolských kwanz (1977–1991)",
            "symbol": "AOK"
          },
          "AON": {
            "displayName": "angolská kwanza (1990–2000)",
            "displayName-count-one": "angolská kwanza (1990–2000)",
            "displayName-count-few": "angolské kwanzy (1990–2000)",
            "displayName-count-many": "angolské kwanzy (1990–2000)",
            "displayName-count-other": "angolských kwanz (1990–2000)",
            "symbol": "AON"
          },
          "AOR": {
            "displayName": "angolská kwanza (1995–1999)",
            "displayName-count-one": "angolská nový kwanza (1995–1999)",
            "displayName-count-few": "angolská kwanza (1995–1999)",
            "displayName-count-many": "angolské kwanzy (1995–1999)",
            "displayName-count-other": "angolských kwanz (1995–1999)",
            "symbol": "AOR"
          },
          "ARA": {
            "displayName": "argentinský austral",
            "displayName-count-one": "argentinský austral",
            "displayName-count-few": "argentinské australy",
            "displayName-count-many": "argentinského australu",
            "displayName-count-other": "argentinských australů",
            "symbol": "ARA"
          },
          "ARL": {
            "displayName": "argentinské peso ley (1970–1983)",
            "displayName-count-one": "argentinské peso ley (1970–1983)",
            "displayName-count-few": "argentinská pesa ley (1970–1983)",
            "displayName-count-many": "argentinského pesa ley (1970–1983)",
            "displayName-count-other": "argentinských pes ley (1970–1983)",
            "symbol": "ARL"
          },
          "ARM": {
            "displayName": "argentinské peso (1881–1970)",
            "displayName-count-one": "argentinské peso (1881–1970)",
            "displayName-count-few": "argentinská pesa (1881–1970)",
            "displayName-count-many": "argentinského pesa (1881–1970)",
            "displayName-count-other": "argentinských pes (1881–1970)",
            "symbol": "ARM"
          },
          "ARP": {
            "displayName": "argentinské peso (1983–1985)",
            "displayName-count-one": "argentinské peso (1983–1985)",
            "displayName-count-few": "argentinská pesa (1983–1985)",
            "displayName-count-many": "argentinského pesa (1983–1985)",
            "displayName-count-other": "argentinských pes (1983–1985)",
            "symbol": "ARP"
          },
          "ARS": {
            "displayName": "argentinské peso",
            "displayName-count-one": "argentinské peso",
            "displayName-count-few": "argentinská pesa",
            "displayName-count-many": "argentinského pesa",
            "displayName-count-other": "argentinských pes",
            "symbol": "ARS",
            "symbol-alt-narrow": "$"
          },
          "ATS": {
            "displayName": "rakouský šilink",
            "displayName-count-one": "rakouský šilink",
            "displayName-count-few": "rakouské šilinky",
            "displayName-count-many": "rakouského šilinku",
            "displayName-count-other": "rakouských šilinků",
            "symbol": "ATS"
          },
          "AUD": {
            "displayName": "australský dolar",
            "displayName-count-one": "australský dolar",
            "displayName-count-few": "australské dolary",
            "displayName-count-many": "australského dolaru",
            "displayName-count-other": "australských dolarů",
            "symbol": "AU$",
            "symbol-alt-narrow": "$"
          },
          "AWG": {
            "displayName": "arubský zlatý",
            "displayName-count-one": "arubský zlatý",
            "displayName-count-few": "arubské zlaté",
            "displayName-count-many": "arubského zlatého",
            "displayName-count-other": "arubských zlatých",
            "symbol": "AWG"
          },
          "AZM": {
            "displayName": "ázerbájdžánský manat (1993–2006)",
            "displayName-count-one": "ázerbájdžánský manat (1993–2006)",
            "displayName-count-few": "ázerbájdžánské manaty (1993–2006)",
            "displayName-count-many": "ázerbájdžánského manatu (1993–2006)",
            "displayName-count-other": "ázerbájdžánských manatů (1993–2006)",
            "symbol": "AZM"
          },
          "AZN": {
            "displayName": "ázerbájdžánský manat",
            "displayName-count-one": "ázerbájdžánský manat",
            "displayName-count-few": "ázerbájdžánské manaty",
            "displayName-count-many": "ázerbájdžánského manatu",
            "displayName-count-other": "ázerbájdžánských manatů",
            "symbol": "AZN"
          },
          "BAD": {
            "displayName": "bosenský dinár (1992–1994)",
            "displayName-count-one": "bosenský dinár (1992–1994)",
            "displayName-count-few": "bosenské dináry (1992–1994)",
            "displayName-count-many": "bosenského dináru (1992–1994)",
            "displayName-count-other": "bosenských dinárů (1992–1994)",
            "symbol": "BAD"
          },
          "BAM": {
            "displayName": "bosenská konvertibilní marka",
            "displayName-count-one": "bosenská konvertibilní marka",
            "displayName-count-few": "bosenské konvertibilní marky",
            "displayName-count-many": "bosenské konvertibilní marky",
            "displayName-count-other": "bosenských konvertibilních marek",
            "symbol": "BAM",
            "symbol-alt-narrow": "KM"
          },
          "BAN": {
            "displayName": "bosenský nový dinár (1994–1997)",
            "displayName-count-one": "bosenský nový dinár (1994–1997)",
            "displayName-count-few": "bosenské nové dináry (1994–1997)",
            "displayName-count-many": "bosenského nového dináru (1994–1997)",
            "displayName-count-other": "bosenských nových dinárů (1994–1997)",
            "symbol": "BAN"
          },
          "BBD": {
            "displayName": "barbadoský dolar",
            "displayName-count-one": "barbadoský dolar",
            "displayName-count-few": "barbadoské dolary",
            "displayName-count-many": "barbadoského dolaru",
            "displayName-count-other": "barbadoských dolarů",
            "symbol": "BBD",
            "symbol-alt-narrow": "$"
          },
          "BDT": {
            "displayName": "bangladéšská taka",
            "displayName-count-one": "bangladéšská taka",
            "displayName-count-few": "bangladéšské taky",
            "displayName-count-many": "bangladéšské taky",
            "displayName-count-other": "bangladéšských tak",
            "symbol": "BDT",
            "symbol-alt-narrow": "৳"
          },
          "BEC": {
            "displayName": "belgický konvertibilní frank",
            "displayName-count-one": "belgický konvertibilní frank",
            "displayName-count-few": "belgické konvertibilní franky",
            "displayName-count-many": "belgického konvertibilního franku",
            "displayName-count-other": "belgických konvertibilních franků",
            "symbol": "BEC"
          },
          "BEF": {
            "displayName": "belgický frank",
            "displayName-count-one": "belgický frank",
            "displayName-count-few": "belgické franky",
            "displayName-count-many": "belgického franku",
            "displayName-count-other": "belgických franků",
            "symbol": "BEF"
          },
          "BEL": {
            "displayName": "belgický finanční frank",
            "displayName-count-one": "belgický finanční frank",
            "displayName-count-few": "belgické finanční franky",
            "displayName-count-many": "belgického finančního franku",
            "displayName-count-other": "belgických finančních franků",
            "symbol": "BEL"
          },
          "BGL": {
            "displayName": "bulharský tvrdý leva",
            "displayName-count-one": "bulharský tvrdý leva",
            "displayName-count-few": "bulharské tvrdé leva",
            "displayName-count-many": "bulharského tvrdého leva",
            "displayName-count-other": "bulharských tvrdých leva",
            "symbol": "BGL"
          },
          "BGM": {
            "displayName": "bulharský socialistický leva",
            "displayName-count-one": "bulharský socialistický leva",
            "displayName-count-few": "bulharské socialistické leva",
            "displayName-count-many": "bulharského socialistického leva",
            "displayName-count-other": "bulharských socialistických leva",
            "symbol": "BGM"
          },
          "BGN": {
            "displayName": "bulharský leva",
            "displayName-count-one": "bulharský leva",
            "displayName-count-few": "bulharské leva",
            "displayName-count-many": "bulharského leva",
            "displayName-count-other": "bulharských leva",
            "symbol": "BGN"
          },
          "BGO": {
            "displayName": "bulharský lev (1879–1952)",
            "displayName-count-one": "bulharský lev (1879–1952)",
            "displayName-count-few": "bulharské leva (1879–1952)",
            "displayName-count-many": "bulharského leva (1879–1952)",
            "displayName-count-other": "bulharských leva (1879–1952)",
            "symbol": "BGO"
          },
          "BHD": {
            "displayName": "bahrajnský dinár",
            "displayName-count-one": "bahrajnský dinár",
            "displayName-count-few": "bahrajnské dináry",
            "displayName-count-many": "bahrajnského dináru",
            "displayName-count-other": "bahrajnských dinárů",
            "symbol": "BHD"
          },
          "BIF": {
            "displayName": "burundský frank",
            "displayName-count-one": "burundský frank",
            "displayName-count-few": "burundské franky",
            "displayName-count-many": "burundského franku",
            "displayName-count-other": "burundských franků",
            "symbol": "BIF"
          },
          "BMD": {
            "displayName": "bermudský dolar",
            "displayName-count-one": "bermudský dolar",
            "displayName-count-few": "bermudské dolary",
            "displayName-count-many": "bermudského dolaru",
            "displayName-count-other": "bermudských dolarů",
            "symbol": "BMD",
            "symbol-alt-narrow": "$"
          },
          "BND": {
            "displayName": "brunejský dolar",
            "displayName-count-one": "brunejský dolar",
            "displayName-count-few": "brunejské dolary",
            "displayName-count-many": "brunejského dolaru",
            "displayName-count-other": "brunejských dolarů",
            "symbol": "BND",
            "symbol-alt-narrow": "$"
          },
          "BOB": {
            "displayName": "bolivijský boliviano",
            "displayName-count-one": "bolivijský boliviano",
            "displayName-count-few": "bolivijské bolivianos",
            "displayName-count-many": "bolivijského boliviana",
            "displayName-count-other": "bolivijských bolivianos",
            "symbol": "BOB",
            "symbol-alt-narrow": "Bs"
          },
          "BOL": {
            "displayName": "bolivijský boliviano (1863–1963)",
            "displayName-count-one": "bolivijský boliviano (1863–1963)",
            "displayName-count-few": "bolivijské bolivianos (1863–1963)",
            "displayName-count-many": "bolivijského boliviana (1863–1963)",
            "displayName-count-other": "bolivijských bolivianos (1863–1963)",
            "symbol": "BOL"
          },
          "BOP": {
            "displayName": "bolivijské peso",
            "displayName-count-one": "bolivijské peso",
            "displayName-count-few": "bolivijská pesa",
            "displayName-count-many": "bolivijského pesa",
            "displayName-count-other": "bolivijských pes",
            "symbol": "BOP"
          },
          "BOV": {
            "displayName": "bolivijský mvdol",
            "displayName-count-one": "bolivijský mvdol",
            "displayName-count-few": "bolivijské mvdoly",
            "displayName-count-many": "bolivijského mvdolu",
            "displayName-count-other": "bolivijských mvdolů",
            "symbol": "BOV"
          },
          "BRB": {
            "displayName": "brazilské nové cruzeiro (1967–1986)",
            "displayName-count-one": "brazilské nové cruzeiro (1967–1986)",
            "displayName-count-few": "brazilská nová cruzeira (1967–1986)",
            "displayName-count-many": "brazilského nového cruzeira (1967–1986)",
            "displayName-count-other": "brazilských nových cruzeir (1967–1986)",
            "symbol": "BRB"
          },
          "BRC": {
            "displayName": "brazilské cruzado (1986–1989)",
            "displayName-count-one": "brazilské cruzado (1986–1989)",
            "displayName-count-few": "brazilská cruzada (1986–1989)",
            "displayName-count-many": "brazilského cruzada (1986–1989)",
            "displayName-count-other": "brazilských cruzad (1986–1989)",
            "symbol": "BRC"
          },
          "BRE": {
            "displayName": "brazilské cruzeiro (1990–1993)",
            "displayName-count-one": "brazilské cruzeiro (1990–1993)",
            "displayName-count-few": "brazilská cruzeira (1990–1993)",
            "displayName-count-many": "brazilského cruzeira (1990–1993)",
            "displayName-count-other": "brazilských cruzeir (1990–1993)",
            "symbol": "BRE"
          },
          "BRL": {
            "displayName": "brazilský real",
            "displayName-count-one": "brazilský real",
            "displayName-count-few": "brazilské realy",
            "displayName-count-many": "brazilského realu",
            "displayName-count-other": "brazilských realů",
            "symbol": "R$",
            "symbol-alt-narrow": "R$"
          },
          "BRN": {
            "displayName": "brazilské nové cruzado (1989–1990)",
            "displayName-count-one": "brazilské nové cruzado (1989–1990)",
            "displayName-count-few": "brazilská nová cruzada (1989–1990)",
            "displayName-count-many": "brazilského nového cruzada (1989–1990)",
            "displayName-count-other": "brazilských nových cruzad (1989–1990)",
            "symbol": "BRN"
          },
          "BRR": {
            "displayName": "brazilské cruzeiro (1993–1994)",
            "displayName-count-one": "brazilské cruzeiro (1993–1994)",
            "displayName-count-few": "brazilská cruzeira (1993–1994)",
            "displayName-count-many": "brazilského cruzeira (1993–1994)",
            "displayName-count-other": "brazilských cruzeir (1993–1994)",
            "symbol": "BRR"
          },
          "BRZ": {
            "displayName": "brazilské cruzeiro (1942–1967)",
            "displayName-count-one": "brazilské cruzeiro (1942–1967)",
            "displayName-count-few": "brazilská cruzeira (1942–1967)",
            "displayName-count-many": "brazilského cruzeira (1942–1967)",
            "displayName-count-other": "brazilských cruzeir (1942–1967)",
            "symbol": "BRZ"
          },
          "BSD": {
            "displayName": "bahamský dolar",
            "displayName-count-one": "bahamský dolar",
            "displayName-count-few": "bahamské dolary",
            "displayName-count-many": "bahamského dolaru",
            "displayName-count-other": "bahamských dolarů",
            "symbol": "BSD",
            "symbol-alt-narrow": "$"
          },
          "BTN": {
            "displayName": "bhútánský ngultrum",
            "displayName-count-one": "bhútánský ngultrum",
            "displayName-count-few": "bhútánské ngultrumy",
            "displayName-count-many": "bhútánského ngultrumu",
            "displayName-count-other": "bhútánských ngultrumů",
            "symbol": "BTN"
          },
          "BUK": {
            "displayName": "barmský kyat",
            "displayName-count-one": "barmský kyat",
            "displayName-count-few": "barmské kyaty",
            "displayName-count-many": "barmského kyatu",
            "displayName-count-other": "barmských kyatů",
            "symbol": "BUK"
          },
          "BWP": {
            "displayName": "botswanská pula",
            "displayName-count-one": "botswanská pula",
            "displayName-count-few": "botswanské puly",
            "displayName-count-many": "botswanské puly",
            "displayName-count-other": "botswanských pul",
            "symbol": "BWP",
            "symbol-alt-narrow": "P"
          },
          "BYB": {
            "displayName": "běloruský rubl (1994–1999)",
            "displayName-count-one": "běloruský rubl (1994–1999)",
            "displayName-count-few": "běloruské rubly (1994–1999)",
            "displayName-count-many": "běloruského rublu (1994–1999)",
            "displayName-count-other": "běloruských rublů (1994–1999)",
            "symbol": "BYB"
          },
          "BYN": {
            "displayName": "běloruský rubl",
            "displayName-count-one": "běloruský rubl",
            "displayName-count-few": "běloruské rubly",
            "displayName-count-many": "běloruského rublu",
            "displayName-count-other": "běloruských rublů",
            "symbol": "BYN",
            "symbol-alt-narrow": "р."
          },
          "BYR": {
            "displayName": "běloruský rubl (2000–2016)",
            "displayName-count-one": "běloruský rubl (2000–2016)",
            "displayName-count-few": "běloruské rubly (2000–2016)",
            "displayName-count-many": "běloruského rublu (2000–2016)",
            "displayName-count-other": "běloruských rublů (2000–2016)",
            "symbol": "BYR"
          },
          "BZD": {
            "displayName": "belizský dolar",
            "displayName-count-one": "belizský dolar",
            "displayName-count-few": "belizské dolary",
            "displayName-count-many": "belizského dolaru",
            "displayName-count-other": "belizských dolarů",
            "symbol": "BZD",
            "symbol-alt-narrow": "$"
          },
          "CAD": {
            "displayName": "kanadský dolar",
            "displayName-count-one": "kanadský dolar",
            "displayName-count-few": "kanadské dolary",
            "displayName-count-many": "kanadského dolaru",
            "displayName-count-other": "kanadských dolarů",
            "symbol": "CA$",
            "symbol-alt-narrow": "$"
          },
          "CDF": {
            "displayName": "konžský frank",
            "displayName-count-one": "konžský frank",
            "displayName-count-few": "konžské franky",
            "displayName-count-many": "konžského franku",
            "displayName-count-other": "konžských franků",
            "symbol": "CDF"
          },
          "CHE": {
            "displayName": "švýcarské WIR-euro",
            "displayName-count-one": "švýcarské WIR-euro",
            "displayName-count-few": "švýcarská WIR-eura",
            "displayName-count-many": "švýcarského WIR-eura",
            "displayName-count-other": "švýcarských WIR-eur",
            "symbol": "CHE"
          },
          "CHF": {
            "displayName": "švýcarský frank",
            "displayName-count-one": "švýcarský frank",
            "displayName-count-few": "švýcarské franky",
            "displayName-count-many": "švýcarského franku",
            "displayName-count-other": "švýcarských franků",
            "symbol": "CHF"
          },
          "CHW": {
            "displayName": "švýcarský WIR-frank",
            "displayName-count-one": "švýcarský WIR-frank",
            "displayName-count-few": "švýcarské WIR-franky",
            "displayName-count-many": "švýcarského WIR-franku",
            "displayName-count-other": "švýcarských WIR-franků",
            "symbol": "CHW"
          },
          "CLE": {
            "displayName": "chilské escudo",
            "displayName-count-one": "chilské escudo",
            "displayName-count-few": "chilská escuda",
            "displayName-count-many": "chilského escuda",
            "displayName-count-other": "chilských escud",
            "symbol": "CLE"
          },
          "CLF": {
            "displayName": "chilská účetní jednotka (UF)",
            "displayName-count-one": "chilská účetní jednotka (UF)",
            "displayName-count-few": "chilské účetní jednotky (UF)",
            "displayName-count-many": "chilské účetní jednotky (UF)",
            "displayName-count-other": "chilských účetních jednotek (UF)",
            "symbol": "CLF"
          },
          "CLP": {
            "displayName": "chilské peso",
            "displayName-count-one": "chilské peso",
            "displayName-count-few": "chilská pesa",
            "displayName-count-many": "chilského pesa",
            "displayName-count-other": "chilských pes",
            "symbol": "CLP",
            "symbol-alt-narrow": "$"
          },
          "CNH": {
            "displayName": "čínský jüan (offshore)",
            "displayName-count-one": "čínský jüan (offshore)",
            "displayName-count-few": "čínské jüany (offshore)",
            "displayName-count-many": "čínského jüanu (offshore)",
            "displayName-count-other": "čínských jüanů (offshore)",
            "symbol": "CNH"
          },
          "CNX": {
            "displayName": "čínský dolar ČLB",
            "displayName-count-one": "čínský dolar ČLB",
            "displayName-count-few": "čínské dolary ČLB",
            "displayName-count-many": "čínského dolaru ČLB",
            "displayName-count-other": "čínských dolarů ČLB",
            "symbol": "CNX"
          },
          "CNY": {
            "displayName": "čínský jüan",
            "displayName-count-one": "čínský jüan",
            "displayName-count-few": "čínské jüany",
            "displayName-count-many": "čínského jüanu",
            "displayName-count-other": "čínských jüanů",
            "symbol": "CN¥",
            "symbol-alt-narrow": "¥"
          },
          "COP": {
            "displayName": "kolumbijské peso",
            "displayName-count-one": "kolumbijské peso",
            "displayName-count-few": "kolumbijská pesa",
            "displayName-count-many": "kolumbijského pesa",
            "displayName-count-other": "kolumbijských pes",
            "symbol": "COP",
            "symbol-alt-narrow": "$"
          },
          "COU": {
            "displayName": "kolumbijská jednotka reálné hodnoty",
            "displayName-count-one": "kolumbijská jednotka reálné hodnoty",
            "displayName-count-few": "kolumbijské jednotky reálné hodnoty",
            "displayName-count-many": "kolumbijské jednotky reálné hodnoty",
            "displayName-count-other": "kolumbijských jednotek reálné hodnoty",
            "symbol": "COU"
          },
          "CRC": {
            "displayName": "kostarický colón",
            "displayName-count-one": "kostarický colón",
            "displayName-count-few": "kostarické colóny",
            "displayName-count-many": "kostarického colónu",
            "displayName-count-other": "kostarických colónů",
            "symbol": "CRC",
            "symbol-alt-narrow": "₡"
          },
          "CSD": {
            "displayName": "srbský dinár (2002–2006)",
            "displayName-count-one": "srbský dinár (2002–2006)",
            "displayName-count-few": "srbské dináry (2002–2006)",
            "displayName-count-many": "srbského dináru (2002–2006)",
            "displayName-count-other": "srbských dinárů (2002–2006)",
            "symbol": "CSD"
          },
          "CSK": {
            "displayName": "československá koruna",
            "displayName-count-one": "československá koruna",
            "displayName-count-few": "československé koruny",
            "displayName-count-many": "československé koruny",
            "displayName-count-other": "československých korun",
            "symbol": "Kčs"
          },
          "CUC": {
            "displayName": "kubánské konvertibilní peso",
            "displayName-count-one": "kubánské konvertibilní peso",
            "displayName-count-few": "kubánská konvertibilní pesa",
            "displayName-count-many": "kubánského konvertibilního pesa",
            "displayName-count-other": "kubánských konvertibilních pes",
            "symbol": "CUC",
            "symbol-alt-narrow": "$"
          },
          "CUP": {
            "displayName": "kubánské peso",
            "displayName-count-one": "kubánské peso",
            "displayName-count-few": "kubánská pesa",
            "displayName-count-many": "kubánského pesa",
            "displayName-count-other": "kubánských pes",
            "symbol": "CUP",
            "symbol-alt-narrow": "$"
          },
          "CVE": {
            "displayName": "kapverdské escudo",
            "displayName-count-one": "kapverdské escudo",
            "displayName-count-few": "kapverdská escuda",
            "displayName-count-many": "kapverdského escuda",
            "displayName-count-other": "kapverdských escud",
            "symbol": "CVE"
          },
          "CYP": {
            "displayName": "kyperská libra",
            "displayName-count-one": "kyperská libra",
            "displayName-count-few": "kyperské libry",
            "displayName-count-many": "kyperské libry",
            "displayName-count-other": "kyperských liber",
            "symbol": "CYP"
          },
          "CZK": {
            "displayName": "česká koruna",
            "displayName-count-one": "česká koruna",
            "displayName-count-few": "české koruny",
            "displayName-count-many": "české koruny",
            "displayName-count-other": "českých korun",
            "symbol": "Kč",
            "symbol-alt-narrow": "Kč"
          },
          "DDM": {
            "displayName": "východoněmecká marka",
            "displayName-count-one": "východoněmecká marka",
            "displayName-count-few": "východoněmecké marky",
            "displayName-count-many": "východoněmecké marky",
            "displayName-count-other": "východoněmeckých marek",
            "symbol": "DDM"
          },
          "DEM": {
            "displayName": "německá marka",
            "displayName-count-one": "německá marka",
            "displayName-count-few": "německé marky",
            "displayName-count-many": "německé marky",
            "displayName-count-other": "německých marek",
            "symbol": "DEM"
          },
          "DJF": {
            "displayName": "džibutský frank",
            "displayName-count-one": "džibutský frank",
            "displayName-count-few": "džibutské franky",
            "displayName-count-many": "džibutského franku",
            "displayName-count-other": "džibutských franků",
            "symbol": "DJF"
          },
          "DKK": {
            "displayName": "dánská koruna",
            "displayName-count-one": "dánská koruna",
            "displayName-count-few": "dánské koruny",
            "displayName-count-many": "dánské koruny",
            "displayName-count-other": "dánských korun",
            "symbol": "DKK",
            "symbol-alt-narrow": "kr"
          },
          "DOP": {
            "displayName": "dominikánské peso",
            "displayName-count-one": "dominikánské peso",
            "displayName-count-few": "dominikánská pesa",
            "displayName-count-many": "dominikánského pesa",
            "displayName-count-other": "dominikánských pes",
            "symbol": "DOP",
            "symbol-alt-narrow": "$"
          },
          "DZD": {
            "displayName": "alžírský dinár",
            "displayName-count-one": "alžírský dinár",
            "displayName-count-few": "alžírské dináry",
            "displayName-count-many": "alžírského dináru",
            "displayName-count-other": "alžírských dinárů",
            "symbol": "DZD"
          },
          "ECS": {
            "displayName": "ekvádorský sucre",
            "displayName-count-one": "ekvádorský sucre",
            "displayName-count-few": "ekvádorské sucre",
            "displayName-count-many": "ekvádorského sucre",
            "displayName-count-other": "ekvádorských sucre",
            "symbol": "ECS"
          },
          "ECV": {
            "displayName": "ekvádorská jednotka konstantní hodnoty",
            "displayName-count-one": "ekvádorská jednotka konstantní hodnoty",
            "displayName-count-few": "ekvádorské jednotky konstantní hodnoty",
            "displayName-count-many": "ekvádorské jednotky konstantní hodnoty",
            "displayName-count-other": "ekvádorských jednotek konstantní hodnoty",
            "symbol": "ECV"
          },
          "EEK": {
            "displayName": "estonská koruna",
            "displayName-count-one": "estonská koruna",
            "displayName-count-few": "estonské koruny",
            "displayName-count-many": "estonské koruny",
            "displayName-count-other": "estonských korun",
            "symbol": "EEK"
          },
          "EGP": {
            "displayName": "egyptská libra",
            "displayName-count-one": "egyptská libra",
            "displayName-count-few": "egyptské libry",
            "displayName-count-many": "egyptské libry",
            "displayName-count-other": "egyptských liber",
            "symbol": "EGP",
            "symbol-alt-narrow": "E£"
          },
          "ERN": {
            "displayName": "eritrejská nakfa",
            "displayName-count-one": "eritrejská nakfa",
            "displayName-count-few": "eritrejské nakfy",
            "displayName-count-many": "eritrejské nakfy",
            "displayName-count-other": "eritrejských nakf",
            "symbol": "ERN"
          },
          "ESA": {
            "displayName": "španělská peseta („A“ účet)",
            "displayName-count-one": "španělská peseta („A“ účet)",
            "displayName-count-few": "španělské pesety („A“ účet)",
            "displayName-count-many": "španělské pesety („A“ účet)",
            "displayName-count-other": "španělských peset („A“ účet)",
            "symbol": "ESA"
          },
          "ESB": {
            "displayName": "španělská peseta (konvertibilní účet)",
            "displayName-count-one": "španělská peseta (konvertibilní účet)",
            "displayName-count-few": "španělské pesety (konvertibilní účet)",
            "displayName-count-many": "španělské pesety (konvertibilní účet)",
            "displayName-count-other": "španělských peset (konvertibilní účet)",
            "symbol": "ESB"
          },
          "ESP": {
            "displayName": "španělská peseta",
            "displayName-count-one": "španělská peseta",
            "displayName-count-few": "španělské pesety",
            "displayName-count-many": "španělské pesety",
            "displayName-count-other": "španělských peset",
            "symbol": "ESP",
            "symbol-alt-narrow": "₧"
          },
          "ETB": {
            "displayName": "etiopský birr",
            "displayName-count-one": "etiopský birr",
            "displayName-count-few": "etiopské birry",
            "displayName-count-many": "etiopského birru",
            "displayName-count-other": "etiopských birrů",
            "symbol": "ETB"
          },
          "EUR": {
            "displayName": "euro",
            "displayName-count-one": "euro",
            "displayName-count-few": "eura",
            "displayName-count-many": "eura",
            "displayName-count-other": "eur",
            "symbol": "€",
            "symbol-alt-narrow": "€"
          },
          "FIM": {
            "displayName": "finská marka",
            "displayName-count-one": "finská marka",
            "displayName-count-few": "finské marky",
            "displayName-count-many": "finské marky",
            "displayName-count-other": "finských marek",
            "symbol": "FIM"
          },
          "FJD": {
            "displayName": "fidžijský dolar",
            "displayName-count-one": "fidžijský dolar",
            "displayName-count-few": "fidžijské dolary",
            "displayName-count-many": "fidžijského dolaru",
            "displayName-count-other": "fidžijských dolarů",
            "symbol": "FJD",
            "symbol-alt-narrow": "$"
          },
          "FKP": {
            "displayName": "falklandská libra",
            "displayName-count-one": "falklandská libra",
            "displayName-count-few": "falklandské libry",
            "displayName-count-many": "falklandské libry",
            "displayName-count-other": "falklandských liber",
            "symbol": "FKP",
            "symbol-alt-narrow": "£"
          },
          "FRF": {
            "displayName": "francouzský frank",
            "displayName-count-one": "francouzský frank",
            "displayName-count-few": "francouzské franky",
            "displayName-count-many": "francouzského franku",
            "displayName-count-other": "francouzských franků",
            "symbol": "FRF"
          },
          "GBP": {
            "displayName": "britská libra",
            "displayName-count-one": "britská libra",
            "displayName-count-few": "britské libry",
            "displayName-count-many": "britské libry",
            "displayName-count-other": "britských liber",
            "symbol": "£",
            "symbol-alt-narrow": "£"
          },
          "GEK": {
            "displayName": "gruzínské kuponové lari",
            "displayName-count-one": "gruzínské kuponové lari",
            "displayName-count-few": "gruzínské kuponové lari",
            "displayName-count-many": "gruzínského kuponového lari",
            "displayName-count-other": "gruzínských kuponových lari",
            "symbol": "GEK"
          },
          "GEL": {
            "displayName": "gruzínské lari",
            "displayName-count-one": "gruzínské lari",
            "displayName-count-few": "gruzínské lari",
            "displayName-count-many": "gruzínského lari",
            "displayName-count-other": "gruzínských lari",
            "symbol": "GEL",
            "symbol-alt-narrow": "₾",
            "symbol-alt-variant": "₾"
          },
          "GHC": {
            "displayName": "ghanský cedi (1979–2007)",
            "displayName-count-one": "ghanský cedi (1979–2007)",
            "displayName-count-few": "ghanské cedi (1979–2007)",
            "displayName-count-many": "ghanského cedi (1979–2007)",
            "displayName-count-other": "ghanských cedi (1979–2007)",
            "symbol": "GHC"
          },
          "GHS": {
            "displayName": "ghanský cedi",
            "displayName-count-one": "ghanský cedi",
            "displayName-count-few": "ghanské cedi",
            "displayName-count-many": "ghanského cedi",
            "displayName-count-other": "ghanských cedi",
            "symbol": "GHS"
          },
          "GIP": {
            "displayName": "gibraltarská libra",
            "displayName-count-one": "gibraltarská libra",
            "displayName-count-few": "gibraltarské libry",
            "displayName-count-many": "gibraltarské libry",
            "displayName-count-other": "gibraltarských liber",
            "symbol": "GIP",
            "symbol-alt-narrow": "£"
          },
          "GMD": {
            "displayName": "gambijský dalasi",
            "displayName-count-one": "gambijský dalasi",
            "displayName-count-few": "gambijské dalasi",
            "displayName-count-many": "gambijského dalasi",
            "displayName-count-other": "gambijských dalasi",
            "symbol": "GMD"
          },
          "GNF": {
            "displayName": "guinejský frank",
            "displayName-count-one": "guinejský frank",
            "displayName-count-few": "guinejské franky",
            "displayName-count-many": "guinejského franku",
            "displayName-count-other": "guinejských franků",
            "symbol": "GNF",
            "symbol-alt-narrow": "FG"
          },
          "GNS": {
            "displayName": "guinejský syli",
            "displayName-count-one": "guinejský syli",
            "displayName-count-few": "guinejské syli",
            "displayName-count-many": "guinejského syli",
            "displayName-count-other": "guinejských syli",
            "symbol": "GNS"
          },
          "GQE": {
            "displayName": "rovníkovoguinejský ekwele",
            "displayName-count-one": "rovníkovoguinejský ekwele",
            "displayName-count-few": "rovníkovoguinejské ekwele",
            "displayName-count-many": "rovníkovoguinejského ekwele",
            "displayName-count-other": "rovníkovoguinejských ekwele",
            "symbol": "GQE"
          },
          "GRD": {
            "displayName": "řecká drachma",
            "displayName-count-one": "řecká drachma",
            "displayName-count-few": "řecké drachmy",
            "displayName-count-many": "řecké drachmy",
            "displayName-count-other": "řeckých drachem",
            "symbol": "GRD"
          },
          "GTQ": {
            "displayName": "guatemalský quetzal",
            "displayName-count-one": "guatemalský quetzal",
            "displayName-count-few": "guatemalské quetzaly",
            "displayName-count-many": "guatemalského quetzalu",
            "displayName-count-other": "guatemalských quetzalů",
            "symbol": "GTQ",
            "symbol-alt-narrow": "Q"
          },
          "GWE": {
            "displayName": "portugalskoguinejské escudo",
            "displayName-count-one": "portugalskoguinejské escudo",
            "displayName-count-few": "portugalskoguinejská escuda",
            "displayName-count-many": "portugalskoguinejského escuda",
            "displayName-count-other": "portugalskoguinejských escud",
            "symbol": "GWE"
          },
          "GWP": {
            "displayName": "guinejsko-bissauské peso",
            "displayName-count-one": "guinejsko-bissauské peso",
            "displayName-count-few": "guinejsko-bissauská pesa",
            "displayName-count-many": "guinejsko-bissauského pesa",
            "displayName-count-other": "guinejsko-bissauských pes",
            "symbol": "GWP"
          },
          "GYD": {
            "displayName": "guyanský dolar",
            "displayName-count-one": "guyanský dolar",
            "displayName-count-few": "guyanské dolary",
            "displayName-count-many": "guyanského dolaru",
            "displayName-count-other": "guyanských dolarů",
            "symbol": "GYD",
            "symbol-alt-narrow": "$"
          },
          "HKD": {
            "displayName": "hongkongský dolar",
            "displayName-count-one": "hongkongský dolar",
            "displayName-count-few": "hongkongské dolary",
            "displayName-count-many": "hongkongského dolaru",
            "displayName-count-other": "hongkongských dolarů",
            "symbol": "HK$",
            "symbol-alt-narrow": "$"
          },
          "HNL": {
            "displayName": "honduraská lempira",
            "displayName-count-one": "honduraská lempira",
            "displayName-count-few": "honduraské lempiry",
            "displayName-count-many": "honduraské lempiry",
            "displayName-count-other": "honduraských lempir",
            "symbol": "HNL",
            "symbol-alt-narrow": "L"
          },
          "HRD": {
            "displayName": "chorvatský dinár",
            "displayName-count-one": "chorvatský dinár",
            "displayName-count-few": "chorvatské dináry",
            "displayName-count-many": "chorvatského dináru",
            "displayName-count-other": "chorvatských dinárů",
            "symbol": "HRD"
          },
          "HRK": {
            "displayName": "chorvatská kuna",
            "displayName-count-one": "chorvatská kuna",
            "displayName-count-few": "chorvatské kuny",
            "displayName-count-many": "chorvatské kuny",
            "displayName-count-other": "chorvatských kun",
            "symbol": "HRK",
            "symbol-alt-narrow": "kn"
          },
          "HTG": {
            "displayName": "haitský gourde",
            "displayName-count-one": "haitský gourde",
            "displayName-count-few": "haitské gourde",
            "displayName-count-many": "haitského gourde",
            "displayName-count-other": "haitských gourde",
            "symbol": "HTG"
          },
          "HUF": {
            "displayName": "maďarský forint",
            "displayName-count-one": "maďarský forint",
            "displayName-count-few": "maďarské forinty",
            "displayName-count-many": "maďarského forintu",
            "displayName-count-other": "maďarských forintů",
            "symbol": "HUF",
            "symbol-alt-narrow": "Ft"
          },
          "IDR": {
            "displayName": "indonéská rupie",
            "displayName-count-one": "indonéská rupie",
            "displayName-count-few": "indonéské rupie",
            "displayName-count-many": "indonéské rupie",
            "displayName-count-other": "indonéských rupií",
            "symbol": "IDR",
            "symbol-alt-narrow": "Rp"
          },
          "IEP": {
            "displayName": "irská libra",
            "displayName-count-one": "irská libra",
            "displayName-count-few": "irské libry",
            "displayName-count-many": "irské libry",
            "displayName-count-other": "irských liber",
            "symbol": "IEP"
          },
          "ILP": {
            "displayName": "izraelská libra",
            "displayName-count-one": "izraelská libra",
            "displayName-count-few": "izraelské libry",
            "displayName-count-many": "izraelské libry",
            "displayName-count-other": "izraelských liber",
            "symbol": "ILP"
          },
          "ILR": {
            "displayName": "izraelský šekel (1980–1985)",
            "displayName-count-one": "izraelský šekel (1980–1985)",
            "displayName-count-few": "izraelské šekely (1980–1985)",
            "displayName-count-many": "izraelského šekelu (1980–1985)",
            "displayName-count-other": "izraelských šekelů (1980–1985)",
            "symbol": "ILR"
          },
          "ILS": {
            "displayName": "izraelský nový šekel",
            "displayName-count-one": "izraelský nový šekel",
            "displayName-count-few": "izraelské nové šekely",
            "displayName-count-many": "izraelského nového šekelu",
            "displayName-count-other": "izraelských nový šekelů",
            "symbol": "ILS",
            "symbol-alt-narrow": "₪"
          },
          "INR": {
            "displayName": "indická rupie",
            "displayName-count-one": "indická rupie",
            "displayName-count-few": "indické rupie",
            "displayName-count-many": "indické rupie",
            "displayName-count-other": "indických rupií",
            "symbol": "INR",
            "symbol-alt-narrow": "₹"
          },
          "IQD": {
            "displayName": "irácký dinár",
            "displayName-count-one": "irácký dinár",
            "displayName-count-few": "irácké dináry",
            "displayName-count-many": "iráckého dináru",
            "displayName-count-other": "iráckých dinárů",
            "symbol": "IQD"
          },
          "IRR": {
            "displayName": "íránský rijál",
            "displayName-count-one": "íránský rijál",
            "displayName-count-few": "íránské rijály",
            "displayName-count-many": "íránského rijálu",
            "displayName-count-other": "íránských rijálů",
            "symbol": "IRR"
          },
          "ISJ": {
            "displayName": "islandská koruna (1918–1981)",
            "displayName-count-one": "islandská koruna (1918–1981)",
            "displayName-count-few": "islandské koruny (1918–1981)",
            "displayName-count-many": "islandské koruny (1918–1981)",
            "displayName-count-other": "islandských korun (1918–1981)",
            "symbol": "ISJ"
          },
          "ISK": {
            "displayName": "islandská koruna",
            "displayName-count-one": "islandská koruna",
            "displayName-count-few": "islandské koruny",
            "displayName-count-many": "islandské koruny",
            "displayName-count-other": "islandských korun",
            "symbol": "ISK",
            "symbol-alt-narrow": "kr"
          },
          "ITL": {
            "displayName": "italská lira",
            "displayName-count-one": "italská lira",
            "displayName-count-few": "italské liry",
            "displayName-count-many": "italské liry",
            "displayName-count-other": "italských lir",
            "symbol": "ITL"
          },
          "JMD": {
            "displayName": "jamajský dolar",
            "displayName-count-one": "jamajský dolar",
            "displayName-count-few": "jamajské dolary",
            "displayName-count-many": "jamajského dolaru",
            "displayName-count-other": "jamajských dolarů",
            "symbol": "JMD",
            "symbol-alt-narrow": "$"
          },
          "JOD": {
            "displayName": "jordánský dinár",
            "displayName-count-one": "jordánský dinár",
            "displayName-count-few": "jordánské dináry",
            "displayName-count-many": "jordánského dináru",
            "displayName-count-other": "jordánských dinárů",
            "symbol": "JOD"
          },
          "JPY": {
            "displayName": "japonský jen",
            "displayName-count-one": "japonský jen",
            "displayName-count-few": "japonské jeny",
            "displayName-count-many": "japonského jenu",
            "displayName-count-other": "japonských jenů",
            "symbol": "JP¥",
            "symbol-alt-narrow": "¥"
          },
          "KES": {
            "displayName": "keňský šilink",
            "displayName-count-one": "keňský šilink",
            "displayName-count-few": "keňské šilinky",
            "displayName-count-many": "keňského šilinku",
            "displayName-count-other": "keňských šilinků",
            "symbol": "KES"
          },
          "KGS": {
            "displayName": "kyrgyzský som",
            "displayName-count-one": "kyrgyzský som",
            "displayName-count-few": "kyrgyzské somy",
            "displayName-count-many": "kyrgyzského somu",
            "displayName-count-other": "kyrgyzských somů",
            "symbol": "KGS"
          },
          "KHR": {
            "displayName": "kambodžský riel",
            "displayName-count-one": "kambodžský riel",
            "displayName-count-few": "kambodžské riely",
            "displayName-count-many": "kambodžského rielu",
            "displayName-count-other": "kambodžských rielů",
            "symbol": "KHR",
            "symbol-alt-narrow": "៛"
          },
          "KMF": {
            "displayName": "komorský frank",
            "displayName-count-one": "komorský frank",
            "displayName-count-few": "komorské franky",
            "displayName-count-many": "komorského franku",
            "displayName-count-other": "komorských franků",
            "symbol": "KMF",
            "symbol-alt-narrow": "CF"
          },
          "KPW": {
            "displayName": "severokorejský won",
            "displayName-count-one": "severokorejský won",
            "displayName-count-few": "severokorejské wony",
            "displayName-count-many": "severokorejského wonu",
            "displayName-count-other": "severokorejských wonů",
            "symbol": "KPW",
            "symbol-alt-narrow": "₩"
          },
          "KRH": {
            "displayName": "jihokorejský hwan (1953–1962)",
            "displayName-count-one": "jihokorejský hwan (1953–1962)",
            "displayName-count-few": "jihokorejské hwany (1953–1962)",
            "displayName-count-many": "jihokorejského hwanu (1953–1962)",
            "displayName-count-other": "jihokorejských hwanů (1953–1962)",
            "symbol": "KRH"
          },
          "KRO": {
            "displayName": "jihokorejský won (1945–1953)",
            "displayName-count-one": "jihokorejský won (1945–1953)",
            "displayName-count-few": "jihokorejské wony (1945–1953)",
            "displayName-count-many": "jihokorejského wonu (1945–1953)",
            "displayName-count-other": "jihokorejských wonů (1945–1953)",
            "symbol": "KRO"
          },
          "KRW": {
            "displayName": "jihokorejský won",
            "displayName-count-one": "jihokorejský won",
            "displayName-count-few": "jihokorejské wony",
            "displayName-count-many": "jihokorejského wonu",
            "displayName-count-other": "jihokorejských wonů",
            "symbol": "₩",
            "symbol-alt-narrow": "₩"
          },
          "KWD": {
            "displayName": "kuvajtský dinár",
            "displayName-count-one": "kuvajtský dinár",
            "displayName-count-few": "kuvajtské dináry",
            "displayName-count-many": "kuvajtského dináru",
            "displayName-count-other": "kuvajtských dinárů",
            "symbol": "KWD"
          },
          "KYD": {
            "displayName": "kajmanský dolar",
            "displayName-count-one": "kajmanský dolar",
            "displayName-count-few": "kajmanské dolary",
            "displayName-count-many": "kajmanského dolaru",
            "displayName-count-other": "kajmanských dolarů",
            "symbol": "KYD",
            "symbol-alt-narrow": "$"
          },
          "KZT": {
            "displayName": "kazašské tenge",
            "displayName-count-one": "kazašské tenge",
            "displayName-count-few": "kazašské tenge",
            "displayName-count-many": "kazašského tenge",
            "displayName-count-other": "kazašských tenge",
            "symbol": "KZT",
            "symbol-alt-narrow": "₸"
          },
          "LAK": {
            "displayName": "laoský kip",
            "displayName-count-one": "laoský kip",
            "displayName-count-few": "laoské kipy",
            "displayName-count-many": "laoského kipu",
            "displayName-count-other": "laoských kipů",
            "symbol": "LAK",
            "symbol-alt-narrow": "₭"
          },
          "LBP": {
            "displayName": "libanonská libra",
            "displayName-count-one": "libanonská libra",
            "displayName-count-few": "libanonské libry",
            "displayName-count-many": "libanonské libry",
            "displayName-count-other": "libanonských liber",
            "symbol": "LBP",
            "symbol-alt-narrow": "L£"
          },
          "LKR": {
            "displayName": "srílanská rupie",
            "displayName-count-one": "srílanská rupie",
            "displayName-count-few": "srílanské rupie",
            "displayName-count-many": "srílanské rupie",
            "displayName-count-other": "srílanských rupií",
            "symbol": "LKR",
            "symbol-alt-narrow": "Rs"
          },
          "LRD": {
            "displayName": "liberijský dolar",
            "displayName-count-one": "liberijský dolar",
            "displayName-count-few": "liberijské dolary",
            "displayName-count-many": "liberijského dolaru",
            "displayName-count-other": "liberijských dolarů",
            "symbol": "LRD",
            "symbol-alt-narrow": "$"
          },
          "LSL": {
            "displayName": "lesothský loti",
            "displayName-count-one": "lesothský loti",
            "displayName-count-few": "lesothské maloti",
            "displayName-count-many": "lesothského loti",
            "displayName-count-other": "lesothských maloti",
            "symbol": "LSL"
          },
          "LTL": {
            "displayName": "litevský litas",
            "displayName-count-one": "litevský litas",
            "displayName-count-few": "litevské lity",
            "displayName-count-many": "litevského litu",
            "displayName-count-other": "litevských litů",
            "symbol": "LTL",
            "symbol-alt-narrow": "Lt"
          },
          "LTT": {
            "displayName": "litevský talonas",
            "displayName-count-one": "litevský talonas",
            "displayName-count-few": "litevské talony",
            "displayName-count-many": "litevského talonu",
            "displayName-count-other": "litevských talonů",
            "symbol": "LTT"
          },
          "LUC": {
            "displayName": "lucemburský konvertibilní frank",
            "displayName-count-one": "lucemburský konvertibilní frank",
            "displayName-count-few": "lucemburské konvertibilní franky",
            "displayName-count-many": "lucemburského konvertibilního franku",
            "displayName-count-other": "lucemburských konvertibilních franků",
            "symbol": "LUC"
          },
          "LUF": {
            "displayName": "lucemburský frank",
            "displayName-count-one": "lucemburský frank",
            "displayName-count-few": "lucemburské franky",
            "displayName-count-many": "lucemburského franku",
            "displayName-count-other": "lucemburských franků",
            "symbol": "LUF"
          },
          "LUL": {
            "displayName": "lucemburský finanční frank",
            "displayName-count-one": "lucemburský finanční frank",
            "displayName-count-few": "lucemburské finanční franky",
            "displayName-count-many": "lucemburského finančního franku",
            "displayName-count-other": "lucemburských finančních franků",
            "symbol": "LUL"
          },
          "LVL": {
            "displayName": "lotyšský lat",
            "displayName-count-one": "lotyšský lat",
            "displayName-count-few": "lotyšské laty",
            "displayName-count-many": "lotyšského latu",
            "displayName-count-other": "lotyšských latů",
            "symbol": "LVL",
            "symbol-alt-narrow": "Ls"
          },
          "LVR": {
            "displayName": "lotyšský rubl",
            "displayName-count-one": "lotyšský rubl",
            "displayName-count-few": "lotyšské rubly",
            "displayName-count-many": "lotyšského rublu",
            "displayName-count-other": "lotyšských rublů",
            "symbol": "LVR"
          },
          "LYD": {
            "displayName": "libyjský dinár",
            "displayName-count-one": "libyjský dinár",
            "displayName-count-few": "libyjské dináry",
            "displayName-count-many": "libyjského dináru",
            "displayName-count-other": "libyjských dinárů",
            "symbol": "LYD"
          },
          "MAD": {
            "displayName": "marocký dinár",
            "displayName-count-one": "marocký dinár",
            "displayName-count-few": "marocké dináry",
            "displayName-count-many": "marockého dináru",
            "displayName-count-other": "marockých dinárů",
            "symbol": "MAD"
          },
          "MAF": {
            "displayName": "marocký frank",
            "displayName-count-one": "marocký frank",
            "displayName-count-few": "marocké franky",
            "displayName-count-many": "marockého franku",
            "displayName-count-other": "marockých franků",
            "symbol": "MAF"
          },
          "MCF": {
            "displayName": "monacký frank",
            "displayName-count-one": "monacký frank",
            "displayName-count-few": "monacké franky",
            "displayName-count-many": "monackého franku",
            "displayName-count-other": "monackých franků",
            "symbol": "MCF"
          },
          "MDC": {
            "displayName": "moldavský kupon",
            "displayName-count-one": "moldavský kupon",
            "displayName-count-few": "moldavské kupony",
            "displayName-count-many": "moldavského kuponu",
            "displayName-count-other": "moldavských kuponů",
            "symbol": "MDC"
          },
          "MDL": {
            "displayName": "moldavský leu",
            "displayName-count-one": "moldavský leu",
            "displayName-count-few": "moldavské lei",
            "displayName-count-many": "moldavského leu",
            "displayName-count-other": "moldavských lei",
            "symbol": "MDL"
          },
          "MGA": {
            "displayName": "madagaskarský ariary",
            "displayName-count-one": "madagaskarský ariary",
            "displayName-count-few": "madagaskarské ariary",
            "displayName-count-many": "madagaskarského ariary",
            "displayName-count-other": "madagaskarských ariary",
            "symbol": "MGA",
            "symbol-alt-narrow": "Ar"
          },
          "MGF": {
            "displayName": "madagaskarský frank",
            "displayName-count-one": "madagaskarský frank",
            "displayName-count-few": "madagaskarské franky",
            "displayName-count-many": "madagaskarského franku",
            "displayName-count-other": "madagaskarských franků",
            "symbol": "MGF"
          },
          "MKD": {
            "displayName": "makedonský denár",
            "displayName-count-one": "makedonský denár",
            "displayName-count-few": "makedonské denáry",
            "displayName-count-many": "makedonského denáru",
            "displayName-count-other": "makedonských denárů",
            "symbol": "MKD"
          },
          "MKN": {
            "displayName": "makedonský denár (1992–1993)",
            "displayName-count-one": "makedonský denár (1992–1993)",
            "displayName-count-few": "makedonské denáry (1992–1993)",
            "displayName-count-many": "makedonského denáru (1992–1993)",
            "displayName-count-other": "makedonských denárů (1992–1993)",
            "symbol": "MKN"
          },
          "MLF": {
            "displayName": "malijský frank",
            "displayName-count-one": "malijský frank",
            "displayName-count-few": "malijské franky",
            "displayName-count-many": "malijského franku",
            "displayName-count-other": "malijských franků",
            "symbol": "MLF"
          },
          "MMK": {
            "displayName": "myanmarský kyat",
            "displayName-count-one": "myanmarský kyat",
            "displayName-count-few": "myanmarské kyaty",
            "displayName-count-many": "myanmarského kyatu",
            "displayName-count-other": "myanmarských kyatů",
            "symbol": "MMK",
            "symbol-alt-narrow": "K"
          },
          "MNT": {
            "displayName": "mongolský tugrik",
            "displayName-count-one": "mongolský tugrik",
            "displayName-count-few": "mongolské tugriky",
            "displayName-count-many": "mongolského tugriku",
            "displayName-count-other": "mongolských tugriků",
            "symbol": "MNT",
            "symbol-alt-narrow": "₮"
          },
          "MOP": {
            "displayName": "macajská pataca",
            "displayName-count-one": "macajská pataca",
            "displayName-count-few": "macajské patacy",
            "displayName-count-many": "macajské patacy",
            "displayName-count-other": "macajských patac",
            "symbol": "MOP"
          },
          "MRO": {
            "displayName": "mauritánská ouguiya (1973–2017)",
            "displayName-count-one": "mauritánská ouguiya (1973–2017)",
            "displayName-count-few": "mauritánské ouguiye (1973–2017)",
            "displayName-count-many": "mauritánské ouguiye (1973–2017)",
            "displayName-count-other": "mauritánských ouguiyí (1973–2017)",
            "symbol": "MRO"
          },
          "MRU": {
            "displayName": "mauritánská ouguiya",
            "displayName-count-one": "mauritánská ouguiya",
            "displayName-count-few": "mauritánské ouguiye",
            "displayName-count-many": "mauritánské ouguiye",
            "displayName-count-other": "mauritánských ouguiyí",
            "symbol": "MRU"
          },
          "MTL": {
            "displayName": "maltská lira",
            "displayName-count-one": "maltská lira",
            "displayName-count-few": "maltské liry",
            "displayName-count-many": "maltské liry",
            "displayName-count-other": "maltských lir",
            "symbol": "MTL"
          },
          "MTP": {
            "displayName": "maltská libra",
            "displayName-count-one": "maltská libra",
            "displayName-count-few": "maltské libry",
            "displayName-count-many": "maltské libry",
            "displayName-count-other": "maltských liber",
            "symbol": "MTP"
          },
          "MUR": {
            "displayName": "mauricijská rupie",
            "displayName-count-one": "mauricijská rupie",
            "displayName-count-few": "mauricijské rupie",
            "displayName-count-many": "mauricijské rupie",
            "displayName-count-other": "mauricijských rupií",
            "symbol": "MUR",
            "symbol-alt-narrow": "Rs"
          },
          "MVP": {
            "displayName": "maledivská rupie (1947–1981)",
            "displayName-count-one": "maledivská rupie (1947–1981)",
            "displayName-count-few": "maledivské rupie (1947–1981)",
            "displayName-count-many": "maledivské rupie (1947–1981)",
            "displayName-count-other": "maledivských rupií (1947–1981)",
            "symbol": "MVP"
          },
          "MVR": {
            "displayName": "maledivská rupie",
            "displayName-count-one": "maledivská rupie",
            "displayName-count-few": "maledivské rupie",
            "displayName-count-many": "maledivské rupie",
            "displayName-count-other": "maledivských rupií",
            "symbol": "MVR"
          },
          "MWK": {
            "displayName": "malawijská kwacha",
            "displayName-count-one": "malawijská kwacha",
            "displayName-count-few": "malawijské kwachy",
            "displayName-count-many": "malawijské kwachy",
            "displayName-count-other": "malawijských kwach",
            "symbol": "MWK"
          },
          "MXN": {
            "displayName": "mexické peso",
            "displayName-count-one": "mexické peso",
            "displayName-count-few": "mexická pesa",
            "displayName-count-many": "mexického pesa",
            "displayName-count-other": "mexických pes",
            "symbol": "MX$",
            "symbol-alt-narrow": "$"
          },
          "MXP": {
            "displayName": "mexické stříbrné peso (1861–1992)",
            "displayName-count-one": "mexické stříbrné peso (1861–1992)",
            "displayName-count-few": "mexická stříbrná pesa (1861–1992)",
            "displayName-count-many": "mexického stříbrného pesa (1861–1992)",
            "displayName-count-other": "mexických stříbrných pes (1861–1992)",
            "symbol": "MXP"
          },
          "MXV": {
            "displayName": "mexická investiční jednotka",
            "displayName-count-one": "mexická investiční jednotka",
            "displayName-count-few": "mexické investiční jednotky",
            "displayName-count-many": "mexické investiční jednotky",
            "displayName-count-other": "mexických investičních jednotek",
            "symbol": "MXV"
          },
          "MYR": {
            "displayName": "malajsijský ringgit",
            "displayName-count-one": "malajsijský ringgit",
            "displayName-count-few": "malajsijské ringgity",
            "displayName-count-many": "malajsijského ringgitu",
            "displayName-count-other": "malajsijských ringgitů",
            "symbol": "MYR",
            "symbol-alt-narrow": "RM"
          },
          "MZE": {
            "displayName": "mosambický escudo",
            "displayName-count-one": "mosambický escudo",
            "displayName-count-few": "mosambická escuda",
            "displayName-count-many": "mosambického escuda",
            "displayName-count-other": "mosambických escud",
            "symbol": "MZE"
          },
          "MZM": {
            "displayName": "mosambický metical (1980–2006)",
            "displayName-count-one": "mosambický metical (1980–2006)",
            "displayName-count-few": "mosambické meticaly (1980–2006)",
            "displayName-count-many": "mosambického meticalu (1980–2006)",
            "displayName-count-other": "mosambických meticalů (1980–2006)",
            "symbol": "MZM"
          },
          "MZN": {
            "displayName": "mozambický metical",
            "displayName-count-one": "mozambický metical",
            "displayName-count-few": "mozambické meticaly",
            "displayName-count-many": "mozambického meticalu",
            "displayName-count-other": "mozambických meticalů",
            "symbol": "MZN"
          },
          "NAD": {
            "displayName": "namibijský dolar",
            "displayName-count-one": "namibijský dolar",
            "displayName-count-few": "namibijské dolary",
            "displayName-count-many": "namibijského dolaru",
            "displayName-count-other": "namibijských dolarů",
            "symbol": "NAD",
            "symbol-alt-narrow": "$"
          },
          "NGN": {
            "displayName": "nigerijská naira",
            "displayName-count-one": "nigerijská naira",
            "displayName-count-few": "nigerijské nairy",
            "displayName-count-many": "nigerijské nairy",
            "displayName-count-other": "nigerijských nair",
            "symbol": "NGN",
            "symbol-alt-narrow": "₦"
          },
          "NIC": {
            "displayName": "nikaragujská córdoba (1988–1991)",
            "displayName-count-one": "nikaragujská córdoba (1988–1991)",
            "displayName-count-few": "nikaragujské córdoby (1988–1991)",
            "displayName-count-many": "nikaragujské córdoby (1988–1991)",
            "displayName-count-other": "nikaragujských córdob (1988–1991)",
            "symbol": "NIC"
          },
          "NIO": {
            "displayName": "nikaragujská córdoba",
            "displayName-count-one": "nikaragujská córdoba",
            "displayName-count-few": "nikaragujské córdoby",
            "displayName-count-many": "nikaragujské córdoby",
            "displayName-count-other": "nikaragujských córdob",
            "symbol": "NIO",
            "symbol-alt-narrow": "C$"
          },
          "NLG": {
            "displayName": "nizozemský gulden",
            "displayName-count-one": "nizozemský gulden",
            "displayName-count-few": "nizozemské guldeny",
            "displayName-count-many": "nizozemského guldenu",
            "displayName-count-other": "nizozemských guldenů",
            "symbol": "NLG"
          },
          "NOK": {
            "displayName": "norská koruna",
            "displayName-count-one": "norská koruna",
            "displayName-count-few": "norské koruny",
            "displayName-count-many": "norské koruny",
            "displayName-count-other": "norských korun",
            "symbol": "NOK",
            "symbol-alt-narrow": "kr"
          },
          "NPR": {
            "displayName": "nepálská rupie",
            "displayName-count-one": "nepálská rupie",
            "displayName-count-few": "nepálské rupie",
            "displayName-count-many": "nepálské rupie",
            "displayName-count-other": "nepálských rupií",
            "symbol": "NPR",
            "symbol-alt-narrow": "Rs"
          },
          "NZD": {
            "displayName": "novozélandský dolar",
            "displayName-count-one": "novozélandský dolar",
            "displayName-count-few": "novozélandské dolary",
            "displayName-count-many": "novozélandského dolaru",
            "displayName-count-other": "novozélandských dolarů",
            "symbol": "NZ$",
            "symbol-alt-narrow": "$"
          },
          "OMR": {
            "displayName": "ománský rijál",
            "displayName-count-one": "ománský rijál",
            "displayName-count-few": "ománské rijály",
            "displayName-count-many": "ománského rijálu",
            "displayName-count-other": "ománských rijálů",
            "symbol": "OMR"
          },
          "PAB": {
            "displayName": "panamská balboa",
            "displayName-count-one": "panamská balboa",
            "displayName-count-few": "panamské balboy",
            "displayName-count-many": "panamské balboy",
            "displayName-count-other": "panamských balboí",
            "symbol": "PAB"
          },
          "PEI": {
            "displayName": "peruánská inti",
            "displayName-count-one": "peruánská inti",
            "displayName-count-few": "peruánské inti",
            "displayName-count-many": "peruánské inti",
            "displayName-count-other": "peruánských inti",
            "symbol": "PEI"
          },
          "PEN": {
            "displayName": "peruánský sol",
            "displayName-count-one": "peruánský sol",
            "displayName-count-few": "peruánské soly",
            "displayName-count-many": "peruánského solu",
            "displayName-count-other": "peruánských solů",
            "symbol": "PEN"
          },
          "PES": {
            "displayName": "peruánský sol (1863–1965)",
            "displayName-count-one": "peruánský sol (1863–1965)",
            "displayName-count-few": "peruánské soly (1863–1965)",
            "displayName-count-many": "peruánského solu (1863–1965)",
            "displayName-count-other": "peruánských solů (1863–1965)",
            "symbol": "PES"
          },
          "PGK": {
            "displayName": "papuánská nová kina",
            "displayName-count-one": "papuánská nová kina",
            "displayName-count-few": "papuánské nové kiny",
            "displayName-count-many": "papuánské nové kiny",
            "displayName-count-other": "papuánských nových kin",
            "symbol": "PGK"
          },
          "PHP": {
            "displayName": "filipínské peso",
            "displayName-count-one": "filipínské peso",
            "displayName-count-few": "filipínská pesa",
            "displayName-count-many": "filipínského pesa",
            "displayName-count-other": "filipínských pes",
            "symbol": "PHP",
            "symbol-alt-narrow": "₱"
          },
          "PKR": {
            "displayName": "pákistánská rupie",
            "displayName-count-one": "pákistánská rupie",
            "displayName-count-few": "pákistánské rupie",
            "displayName-count-many": "pákistánské rupie",
            "displayName-count-other": "pákistánských rupií",
            "symbol": "PKR",
            "symbol-alt-narrow": "Rs"
          },
          "PLN": {
            "displayName": "polský zlotý",
            "displayName-count-one": "polský zlotý",
            "displayName-count-few": "polské zloté",
            "displayName-count-many": "polského zlotého",
            "displayName-count-other": "polských zlotých",
            "symbol": "PLN",
            "symbol-alt-narrow": "zł"
          },
          "PLZ": {
            "displayName": "polský zlotý (1950–1995)",
            "displayName-count-one": "polský zlotý (1950–1995)",
            "displayName-count-few": "polské zloté (1950–1995)",
            "displayName-count-many": "polského zlotého (1950–1995)",
            "displayName-count-other": "polských zlotých (1950–1995)",
            "symbol": "PLZ"
          },
          "PTE": {
            "displayName": "portugalské escudo",
            "displayName-count-one": "portugalské escudo",
            "displayName-count-few": "portugalská escuda",
            "displayName-count-many": "portugalského escuda",
            "displayName-count-other": "portugalských escud",
            "symbol": "PTE"
          },
          "PYG": {
            "displayName": "paraguajské guarani",
            "displayName-count-one": "paraguajské guarani",
            "displayName-count-few": "paraguajská guarani",
            "displayName-count-many": "paraguajského guarani",
            "displayName-count-other": "paraguajských guarani",
            "symbol": "PYG",
            "symbol-alt-narrow": "₲"
          },
          "QAR": {
            "displayName": "katarský rijál",
            "displayName-count-one": "katarský rijál",
            "displayName-count-few": "katarské rijály",
            "displayName-count-many": "katarského rijálu",
            "displayName-count-other": "katarských rijálů",
            "symbol": "QAR"
          },
          "RHD": {
            "displayName": "rhodéský dolar",
            "displayName-count-one": "rhodéský dolar",
            "displayName-count-few": "rhodéské dolary",
            "displayName-count-many": "rhodéského dolaru",
            "displayName-count-other": "rhodéských dolarů",
            "symbol": "RHD"
          },
          "ROL": {
            "displayName": "rumunské leu (1952–2006)",
            "displayName-count-one": "rumunské leu (1952–2006)",
            "displayName-count-few": "rumunské lei (1952–2006)",
            "displayName-count-many": "rumunského leu (1952–2006)",
            "displayName-count-other": "rumunských lei (1952–2006)",
            "symbol": "ROL"
          },
          "RON": {
            "displayName": "rumunský leu",
            "displayName-count-one": "rumunský leu",
            "displayName-count-few": "rumunské lei",
            "displayName-count-many": "rumunského leu",
            "displayName-count-other": "rumunských lei",
            "symbol": "RON",
            "symbol-alt-narrow": "L"
          },
          "RSD": {
            "displayName": "srbský dinár",
            "displayName-count-one": "srbský dinár",
            "displayName-count-few": "srbské dináry",
            "displayName-count-many": "srbského dináru",
            "displayName-count-other": "srbských dinárů",
            "symbol": "RSD"
          },
          "RUB": {
            "displayName": "ruský rubl",
            "displayName-count-one": "ruský rubl",
            "displayName-count-few": "ruské rubly",
            "displayName-count-many": "ruského rublu",
            "displayName-count-other": "ruských rublů",
            "symbol": "RUB",
            "symbol-alt-narrow": "₽"
          },
          "RUR": {
            "displayName": "ruský rubl (1991–1998)",
            "displayName-count-one": "ruský rubl (1991–1998)",
            "displayName-count-few": "ruské rubly (1991–1998)",
            "displayName-count-many": "ruského rublu (1991–1998)",
            "displayName-count-other": "ruských rublů (1991–1998)",
            "symbol": "RUR",
            "symbol-alt-narrow": "р."
          },
          "RWF": {
            "displayName": "rwandský frank",
            "displayName-count-one": "rwandský frank",
            "displayName-count-few": "rwandské franky",
            "displayName-count-many": "rwandského franku",
            "displayName-count-other": "rwandských franků",
            "symbol": "RWF",
            "symbol-alt-narrow": "RF"
          },
          "SAR": {
            "displayName": "saúdský rijál",
            "displayName-count-one": "saúdský rijál",
            "displayName-count-few": "saúdské rijály",
            "displayName-count-many": "saúdského rijálu",
            "displayName-count-other": "saúdských rijálů",
            "symbol": "SAR"
          },
          "SBD": {
            "displayName": "šalamounský dolar",
            "displayName-count-one": "šalamounský dolar",
            "displayName-count-few": "šalamounské dolary",
            "displayName-count-many": "šalamounského dolaru",
            "displayName-count-other": "šalamounských dolarů",
            "symbol": "SBD",
            "symbol-alt-narrow": "$"
          },
          "SCR": {
            "displayName": "seychelská rupie",
            "displayName-count-one": "seychelská rupie",
            "displayName-count-few": "seychelské rupie",
            "displayName-count-many": "seychelské rupie",
            "displayName-count-other": "seychelských rupií",
            "symbol": "SCR"
          },
          "SDD": {
            "displayName": "súdánský dinár (1992–2007)",
            "displayName-count-one": "súdánský dinár (1992–2007)",
            "displayName-count-few": "súdánské dináry (1992–2007)",
            "displayName-count-many": "súdánského dináru (1992–2007)",
            "displayName-count-other": "súdánských dinárů (1992–2007)",
            "symbol": "SDD"
          },
          "SDG": {
            "displayName": "súdánská libra",
            "displayName-count-one": "súdánská libra",
            "displayName-count-few": "súdánské libry",
            "displayName-count-many": "súdánské libry",
            "displayName-count-other": "súdánských liber",
            "symbol": "SDG"
          },
          "SDP": {
            "displayName": "súdánská libra (1957–1998)",
            "displayName-count-one": "súdánská libra (1957–1998)",
            "displayName-count-few": "súdánské libry (1957–1998)",
            "displayName-count-many": "súdánské libry (1957–1998)",
            "displayName-count-other": "súdánských liber (1957–1998)",
            "symbol": "SDP"
          },
          "SEK": {
            "displayName": "švédská koruna",
            "displayName-count-one": "švédská koruna",
            "displayName-count-few": "švédské koruny",
            "displayName-count-many": "švédské koruny",
            "displayName-count-other": "švédských korun",
            "symbol": "SEK",
            "symbol-alt-narrow": "kr"
          },
          "SGD": {
            "displayName": "singapurský dolar",
            "displayName-count-one": "singapurský dolar",
            "displayName-count-few": "singapurské dolary",
            "displayName-count-many": "singapurského dolaru",
            "displayName-count-other": "singapurských dolarů",
            "symbol": "SGD",
            "symbol-alt-narrow": "$"
          },
          "SHP": {
            "displayName": "svatohelenská libra",
            "displayName-count-one": "svatohelenská libra",
            "displayName-count-few": "svatohelenské libry",
            "displayName-count-many": "svatohelenské libry",
            "displayName-count-other": "svatohelenských liber",
            "symbol": "SHP",
            "symbol-alt-narrow": "£"
          },
          "SIT": {
            "displayName": "slovinský tolar",
            "displayName-count-one": "slovinský tolar",
            "displayName-count-few": "slovinské tolary",
            "displayName-count-many": "slovinského tolaru",
            "displayName-count-other": "slovinských tolarů",
            "symbol": "SIT"
          },
          "SKK": {
            "displayName": "slovenská koruna",
            "displayName-count-one": "slovenská koruna",
            "displayName-count-few": "slovenské koruny",
            "displayName-count-many": "slovenské koruny",
            "displayName-count-other": "slovenských korun",
            "symbol": "SKK"
          },
          "SLL": {
            "displayName": "sierro-leonský leone",
            "displayName-count-one": "sierro-leonský leone",
            "displayName-count-few": "sierro-leonské leone",
            "displayName-count-many": "sierro-leonského leone",
            "displayName-count-other": "sierro-leonských leone",
            "symbol": "SLL"
          },
          "SOS": {
            "displayName": "somálský šilink",
            "displayName-count-one": "somálský šilink",
            "displayName-count-few": "somálské šilinky",
            "displayName-count-many": "somálského šilinku",
            "displayName-count-other": "somálských šilinků",
            "symbol": "SOS"
          },
          "SRD": {
            "displayName": "surinamský dolar",
            "displayName-count-one": "surinamský dolar",
            "displayName-count-few": "surinamské dolary",
            "displayName-count-many": "surinamského dolaru",
            "displayName-count-other": "surinamských dolarů",
            "symbol": "SRD",
            "symbol-alt-narrow": "$"
          },
          "SRG": {
            "displayName": "surinamský zlatý",
            "displayName-count-one": "surinamský zlatý",
            "displayName-count-few": "surinamské zlaté",
            "displayName-count-many": "surinamského zlatého",
            "displayName-count-other": "surinamských zlatých",
            "symbol": "SRG"
          },
          "SSP": {
            "displayName": "jihosúdánská libra",
            "displayName-count-one": "jihosúdánská libra",
            "displayName-count-few": "jihosúdánské libry",
            "displayName-count-many": "jihosúdánské libry",
            "displayName-count-other": "jihosúdánských liber",
            "symbol": "SSP",
            "symbol-alt-narrow": "£"
          },
          "STD": {
            "displayName": "svatotomášská dobra (1977–2017)",
            "displayName-count-one": "svatotomášská dobra (1977–2017)",
            "displayName-count-few": "svatotomášské dobry (1977–2017)",
            "displayName-count-many": "svatotomášské dobry (1977–2017)",
            "displayName-count-other": "svatotomášských dober (1977–2017)",
            "symbol": "STD"
          },
          "STN": {
            "displayName": "svatotomášská dobra",
            "displayName-count-one": "svatotomášská dobra",
            "displayName-count-few": "svatotomášské dobry",
            "displayName-count-many": "svatotomášské dobry",
            "displayName-count-other": "svatotomášských dober",
            "symbol": "STN",
            "symbol-alt-narrow": "Db"
          },
          "SUR": {
            "displayName": "sovětský rubl",
            "displayName-count-one": "sovětský rubl",
            "displayName-count-few": "sovětské rubly",
            "displayName-count-many": "sovětského rublu",
            "displayName-count-other": "sovětských rublů",
            "symbol": "SUR"
          },
          "SVC": {
            "displayName": "salvadorský colón",
            "displayName-count-one": "salvadorský colón",
            "displayName-count-few": "salvadorské colóny",
            "displayName-count-many": "salvadorského colónu",
            "displayName-count-other": "salvadorských colónů",
            "symbol": "SVC"
          },
          "SYP": {
            "displayName": "syrská libra",
            "displayName-count-one": "syrská libra",
            "displayName-count-few": "syrské libry",
            "displayName-count-many": "syrské libry",
            "displayName-count-other": "syrských liber",
            "symbol": "SYP",
            "symbol-alt-narrow": "£"
          },
          "SZL": {
            "displayName": "svazijský lilangeni",
            "displayName-count-one": "svazijský lilangeni",
            "displayName-count-few": "svazijské emalangeni",
            "displayName-count-many": "svazijského lilangeni",
            "displayName-count-other": "svazijských emalangeni",
            "symbol": "SZL"
          },
          "THB": {
            "displayName": "thajský baht",
            "displayName-count-one": "thajský baht",
            "displayName-count-few": "thajské bahty",
            "displayName-count-many": "thajského bahtu",
            "displayName-count-other": "thajských bahtů",
            "symbol": "THB",
            "symbol-alt-narrow": "฿"
          },
          "TJR": {
            "displayName": "tádžický rubl",
            "displayName-count-one": "tádžický rubl",
            "displayName-count-few": "tádžické rubly",
            "displayName-count-many": "tádžického rublu",
            "displayName-count-other": "tádžických rublů",
            "symbol": "TJR"
          },
          "TJS": {
            "displayName": "tádžické somoni",
            "displayName-count-one": "tádžické somoni",
            "displayName-count-few": "tádžická somoni",
            "displayName-count-many": "tádžického somoni",
            "displayName-count-other": "tádžických somoni",
            "symbol": "TJS"
          },
          "TMM": {
            "displayName": "turkmenský manat (1993–2009)",
            "displayName-count-one": "turkmenský manat (1993–2009)",
            "displayName-count-few": "turkmenské manaty (1993–2009)",
            "displayName-count-many": "turkmenského manatu (1993–2009)",
            "displayName-count-other": "turkmenských manatů (1993–2009)",
            "symbol": "TMM"
          },
          "TMT": {
            "displayName": "turkmenský manat",
            "displayName-count-one": "turkmenský manat",
            "displayName-count-few": "turkmenské manaty",
            "displayName-count-many": "turkmenského manatu",
            "displayName-count-other": "turkmenských manatů",
            "symbol": "TMT"
          },
          "TND": {
            "displayName": "tuniský dinár",
            "displayName-count-one": "tuniský dinár",
            "displayName-count-few": "tuniské dináry",
            "displayName-count-many": "tuniského dináru",
            "displayName-count-other": "tuniských dinárů",
            "symbol": "TND"
          },
          "TOP": {
            "displayName": "tonžská paanga",
            "displayName-count-one": "tonžská paanga",
            "displayName-count-few": "tonžské paangy",
            "displayName-count-many": "tonžské paangy",
            "displayName-count-other": "tonžských paang",
            "symbol": "TOP",
            "symbol-alt-narrow": "T$"
          },
          "TPE": {
            "displayName": "timorské escudo",
            "displayName-count-one": "timorské escudo",
            "displayName-count-few": "timorská escuda",
            "displayName-count-many": "timorského escuda",
            "displayName-count-other": "timorských escud",
            "symbol": "TPE"
          },
          "TRL": {
            "displayName": "turecká lira (1922–2005)",
            "displayName-count-one": "turecká lira (1922–2005)",
            "displayName-count-few": "turecké liry (1922–2005)",
            "displayName-count-many": "turecké liry (1922–2005)",
            "displayName-count-other": "tureckých lir (1922–2005)",
            "symbol": "TRL"
          },
          "TRY": {
            "displayName": "turecká lira",
            "displayName-count-one": "turecká lira",
            "displayName-count-few": "turecké liry",
            "displayName-count-many": "turecké liry",
            "displayName-count-other": "tureckých lir",
            "symbol": "TRY",
            "symbol-alt-narrow": "₺",
            "symbol-alt-variant": "TL"
          },
          "TTD": {
            "displayName": "trinidadský dolar",
            "displayName-count-one": "trinidadský dolar",
            "displayName-count-few": "trinidadské dolary",
            "displayName-count-many": "trinidadského dolaru",
            "displayName-count-other": "trinidadských dolarů",
            "symbol": "TTD",
            "symbol-alt-narrow": "$"
          },
          "TWD": {
            "displayName": "tchajwanský dolar",
            "displayName-count-one": "tchajwanský dolar",
            "displayName-count-few": "tchajwanské dolary",
            "displayName-count-many": "tchajwanského dolaru",
            "displayName-count-other": "tchajwanských dolarů",
            "symbol": "NT$",
            "symbol-alt-narrow": "NT$"
          },
          "TZS": {
            "displayName": "tanzanský šilink",
            "displayName-count-one": "tanzanský šilink",
            "displayName-count-few": "tanzanské šilinky",
            "displayName-count-many": "tanzanského šilinku",
            "displayName-count-other": "tanzanských šilinků",
            "symbol": "TZS"
          },
          "UAH": {
            "displayName": "ukrajinská hřivna",
            "displayName-count-one": "ukrajinská hřivna",
            "displayName-count-few": "ukrajinské hřivny",
            "displayName-count-many": "ukrajinské hřivny",
            "displayName-count-other": "ukrajinských hřiven",
            "symbol": "UAH",
            "symbol-alt-narrow": "₴"
          },
          "UAK": {
            "displayName": "ukrajinský karbovanec",
            "displayName-count-one": "ukrajinský karbovanec",
            "displayName-count-few": "ukrajinské karbovance",
            "displayName-count-many": "ukrajinského karbovance",
            "displayName-count-other": "ukrajinských karbovanců",
            "symbol": "UAK"
          },
          "UGS": {
            "displayName": "ugandský šilink (1966–1987)",
            "displayName-count-one": "ugandský šilink (1966–1987)",
            "displayName-count-few": "ugandské šilinky (1966–1987)",
            "displayName-count-many": "ugandského šilinku (1966–1987)",
            "displayName-count-other": "ugandských šilinků (1966–1987)",
            "symbol": "UGS"
          },
          "UGX": {
            "displayName": "ugandský šilink",
            "displayName-count-one": "ugandský šilink",
            "displayName-count-few": "ugandské šilinky",
            "displayName-count-many": "ugandského šilinku",
            "displayName-count-other": "ugandských šilinků",
            "symbol": "UGX"
          },
          "USD": {
            "displayName": "americký dolar",
            "displayName-count-one": "americký dolar",
            "displayName-count-few": "americké dolary",
            "displayName-count-many": "amerického dolaru",
            "displayName-count-other": "amerických dolarů",
            "symbol": "US$",
            "symbol-alt-narrow": "$"
          },
          "USN": {
            "displayName": "americký dolar (příští den)",
            "displayName-count-one": "americký dolar (příští den)",
            "displayName-count-few": "americké dolary (příští den)",
            "displayName-count-many": "amerického dolaru (příští den)",
            "displayName-count-other": "amerických dolarů (příští den)",
            "symbol": "USN"
          },
          "USS": {
            "displayName": "americký dolar (týž den)",
            "displayName-count-one": "americký dolar (týž den)",
            "displayName-count-few": "americké dolary (týž den)",
            "displayName-count-many": "amerického dolaru (týž den)",
            "displayName-count-other": "amerických dolarů (týž den)",
            "symbol": "USS"
          },
          "UYI": {
            "displayName": "uruguayské peso (v indexovaných jednotkách)",
            "displayName-count-one": "uruguayské peso (v indexovaných jednotkách)",
            "displayName-count-few": "uruguayská pesa (v indexovaných jednotkách)",
            "displayName-count-many": "uruguayského pesa (v indexovaných jednotkách)",
            "displayName-count-other": "uruguayských pes (v indexovaných jednotkách)",
            "symbol": "UYI"
          },
          "UYP": {
            "displayName": "uruguayské peso (1975–1993)",
            "displayName-count-one": "uruguayské peso (1975–1993)",
            "displayName-count-few": "uruguayská pesa (1975–1993)",
            "displayName-count-many": "uruguayského pesa (1975–1993)",
            "displayName-count-other": "uruguayských pes (1975–1993)",
            "symbol": "UYP"
          },
          "UYU": {
            "displayName": "uruguayské peso",
            "displayName-count-one": "uruguayské peso",
            "displayName-count-few": "uruguayská pesa",
            "displayName-count-many": "uruguayského pesa",
            "displayName-count-other": "uruguayských pes",
            "symbol": "UYU",
            "symbol-alt-narrow": "$"
          },
          "UYW": {
            "displayName": "UYW",
            "symbol": "UYW"
          },
          "UZS": {
            "displayName": "uzbecký sum",
            "displayName-count-one": "uzbecký sum",
            "displayName-count-few": "uzbecké sumy",
            "displayName-count-many": "uzbeckého sumu",
            "displayName-count-other": "uzbeckých sumů",
            "symbol": "UZS"
          },
          "VEB": {
            "displayName": "venezuelský bolívar (1871–2008)",
            "displayName-count-one": "venezuelský bolívar (1871–2008)",
            "displayName-count-few": "venezuelské bolívary (1871–2008)",
            "displayName-count-many": "venezuelského bolívaru (1871–2008)",
            "displayName-count-other": "venezuelských bolívarů (1871–2008)",
            "symbol": "VEB"
          },
          "VEF": {
            "displayName": "venezuelský bolívar (2008–2018)",
            "displayName-count-one": "venezuelský bolívar (2008–2018)",
            "displayName-count-few": "venezuelské bolívary (2008–2018)",
            "displayName-count-many": "venezuelského bolívaru (2008–2018)",
            "displayName-count-other": "venezuelských bolívarů (2008–2018)",
            "symbol": "VEF",
            "symbol-alt-narrow": "Bs"
          },
          "VES": {
            "displayName": "venezuelský bolívar",
            "displayName-count-one": "venezuelský bolívar",
            "displayName-count-few": "venezuelské bolívary",
            "displayName-count-many": "venezuelského bolívaru",
            "displayName-count-other": "venezuelských bolívarů",
            "symbol": "VES"
          },
          "VND": {
            "displayName": "vietnamský dong",
            "displayName-count-one": "vietnamský dong",
            "displayName-count-few": "vietnamské dongy",
            "displayName-count-many": "vietnamského dongu",
            "displayName-count-other": "vietnamských dongů",
            "symbol": "VND",
            "symbol-alt-narrow": "₫"
          },
          "VNN": {
            "displayName": "vietnamský dong (1978–1985)",
            "displayName-count-one": "vietnamský dong (1978–1985)",
            "displayName-count-few": "vietnamské dongy (1978–1985)",
            "displayName-count-many": "vietnamského dongu (1978–1985)",
            "displayName-count-other": "vietnamských dongů (1978–1985)",
            "symbol": "VNN"
          },
          "VUV": {
            "displayName": "vanuatský vatu",
            "displayName-count-one": "vanuatský vatu",
            "displayName-count-few": "vanuatské vatu",
            "displayName-count-many": "vanuatského vatu",
            "displayName-count-other": "vanuatských vatu",
            "symbol": "VUV"
          },
          "WST": {
            "displayName": "samojská tala",
            "displayName-count-one": "samojská tala",
            "displayName-count-few": "samojské taly",
            "displayName-count-many": "samojské taly",
            "displayName-count-other": "samojských tal",
            "symbol": "WST"
          },
          "XAF": {
            "displayName": "CFA/BEAC frank",
            "displayName-count-one": "CFA/BEAC frank",
            "displayName-count-few": "CFA/BEAC franky",
            "displayName-count-many": "CFA/BEAC franku",
            "displayName-count-other": "CFA/BEAC franků",
            "symbol": "FCFA"
          },
          "XAG": {
            "displayName": "stříbro",
            "displayName-count-one": "trojská unce stříbra",
            "displayName-count-few": "trojské unce stříbra",
            "displayName-count-many": "trojské unce stříbra",
            "displayName-count-other": "trojských uncí stříbra",
            "symbol": "XAG"
          },
          "XAU": {
            "displayName": "zlato",
            "displayName-count-one": "trojská unce zlata",
            "displayName-count-few": "trojské unce zlata",
            "displayName-count-many": "trojské unce zlata",
            "displayName-count-other": "trojských uncí zlata",
            "symbol": "XAU"
          },
          "XBA": {
            "displayName": "evropská smíšená jednotka",
            "displayName-count-one": "evropská smíšená jednotka",
            "displayName-count-few": "evropské smíšené jednotky",
            "displayName-count-many": "evropské smíšené jednotky",
            "displayName-count-other": "evropských smíšených jednotek",
            "symbol": "XBA"
          },
          "XBB": {
            "displayName": "evropská peněžní jednotka",
            "displayName-count-one": "evropská peněžní jednotka",
            "displayName-count-few": "evropské peněžní jednotky",
            "displayName-count-many": "evropské peněžní jednotky",
            "displayName-count-other": "evropských peněžních jednotek",
            "symbol": "XBB"
          },
          "XBC": {
            "displayName": "evropská jednotka účtu 9 (XBC)",
            "displayName-count-one": "evropská jednotka účtu 9 (XBC)",
            "displayName-count-few": "evropské jednotky účtu 9 (XBC)",
            "displayName-count-many": "evropské jednotky účtu 9 (XBC)",
            "displayName-count-other": "evropských jednotek účtu 9 (XBC)",
            "symbol": "XBC"
          },
          "XBD": {
            "displayName": "evropská jednotka účtu 17 (XBD)",
            "displayName-count-one": "evropská jednotka účtu 17 (XBD)",
            "displayName-count-few": "evropské jednotky účtu 17 (XBD)",
            "displayName-count-many": "evropské jednotky účtu 17 (XBD)",
            "displayName-count-other": "evropských jednotek účtu 17 (XBD)",
            "symbol": "XBD"
          },
          "XCD": {
            "displayName": "východokaribský dolar",
            "displayName-count-one": "východokaribský dolar",
            "displayName-count-few": "východokaribské dolary",
            "displayName-count-many": "východokaribského dolaru",
            "displayName-count-other": "východokaribských dolarů",
            "symbol": "EC$",
            "symbol-alt-narrow": "$"
          },
          "XDR": {
            "displayName": "SDR",
            "symbol": "XDR"
          },
          "XEU": {
            "displayName": "evropská měnová jednotka",
            "displayName-count-one": "ECU",
            "displayName-count-few": "ECU",
            "displayName-count-many": "ECU",
            "displayName-count-other": "ECU",
            "symbol": "ECU"
          },
          "XFO": {
            "displayName": "francouzský zlatý frank",
            "displayName-count-one": "francouzský zlatý frank",
            "displayName-count-few": "francouzské zlaté franky",
            "displayName-count-many": "francouzského zlatého franku",
            "displayName-count-other": "francouzských zlatých franků",
            "symbol": "XFO"
          },
          "XFU": {
            "displayName": "francouzský UIC frank",
            "displayName-count-one": "francouzský UIC frank",
            "displayName-count-few": "francouzské UIC franky",
            "displayName-count-many": "francouzského UIC franku",
            "displayName-count-other": "francouzských UIC franků",
            "symbol": "XFU"
          },
          "XOF": {
            "displayName": "CFA/BCEAO frank",
            "displayName-count-one": "CFA/BCEAO frank",
            "displayName-count-few": "CFA/BCEAO franky",
            "displayName-count-many": "CFA/BCEAO franku",
            "displayName-count-other": "CFA/BCEAO franků",
            "symbol": "CFA"
          },
          "XPD": {
            "displayName": "palladium",
            "displayName-count-one": "trojská unce palladia",
            "displayName-count-few": "trojské unce palladia",
            "displayName-count-many": "trojské unce palladia",
            "displayName-count-other": "trojských uncí palladia",
            "symbol": "XPD"
          },
          "XPF": {
            "displayName": "CFP frank",
            "displayName-count-one": "CFP frank",
            "displayName-count-few": "CFP franky",
            "displayName-count-many": "CFP franku",
            "displayName-count-other": "CFP franků",
            "symbol": "CFPF"
          },
          "XPT": {
            "displayName": "platina",
            "displayName-count-one": "trojská unce platiny",
            "displayName-count-few": "trojské unce platiny",
            "displayName-count-many": "trojské unce platiny",
            "displayName-count-other": "trojských uncí platiny",
            "symbol": "XPT"
          },
          "XRE": {
            "displayName": "kód fondů RINET",
            "displayName-count-one": "kód fondů RINET",
            "displayName-count-few": "kód fondů RINET",
            "displayName-count-many": "kód fondů RINET",
            "displayName-count-other": "kód fondů RINET",
            "symbol": "XRE"
          },
          "XSU": {
            "displayName": "sucre",
            "displayName-count-one": "sucre",
            "displayName-count-few": "sucre",
            "displayName-count-many": "sucre",
            "displayName-count-other": "sucre",
            "symbol": "XSU"
          },
          "XTS": {
            "displayName": "kód zvlášť vyhrazený pro testovací účely",
            "displayName-count-one": "kód zvlášť vyhrazený pro testovací účely",
            "displayName-count-few": "kódy zvlášť vyhrazené pro testovací účely",
            "displayName-count-many": "kódu zvlášť vyhrazeného pro testovací účely",
            "displayName-count-other": "kódů zvlášť vyhrazených pro testovací účely",
            "symbol": "XTS"
          },
          "XUA": {
            "displayName": "XUA",
            "symbol": "XUA"
          },
          "XXX": {
            "displayName": "neznámá měna",
            "displayName-count-one": "neznámá měna",
            "displayName-count-few": "neznámá měna",
            "displayName-count-many": "neznámá měna",
            "displayName-count-other": "neznámá měna",
            "symbol": "XXX"
          },
          "YDD": {
            "displayName": "jemenský dinár",
            "displayName-count-one": "jemenský dinár",
            "displayName-count-few": "jemenské dináry",
            "displayName-count-many": "jemenského dináru",
            "displayName-count-other": "jemenských dinárů",
            "symbol": "YDD"
          },
          "YER": {
            "displayName": "jemenský rijál",
            "displayName-count-one": "jemenský rijál",
            "displayName-count-few": "jemenské rijály",
            "displayName-count-many": "jemenského rijálu",
            "displayName-count-other": "jemenských rijálů",
            "symbol": "YER"
          },
          "YUD": {
            "displayName": "jugoslávský dinár (1966–1990)",
            "displayName-count-one": "jugoslávský dinár (1966–1990)",
            "displayName-count-few": "jugoslávské dináry (1966–1990)",
            "displayName-count-many": "jugoslávského dináru (1966–1990)",
            "displayName-count-other": "jugoslávských dinárů (1966–1990)",
            "symbol": "YUD"
          },
          "YUM": {
            "displayName": "jugoslávský nový dinár (1994–2002)",
            "displayName-count-one": "jugoslávský nový dinár (1994–2002)",
            "displayName-count-few": "jugoslávské nové dináry (1994–2002)",
            "displayName-count-many": "jugoslávského nového dináru (1994–2002)",
            "displayName-count-other": "jugoslávských nových dinárů (1994–2002)",
            "symbol": "YUM"
          },
          "YUN": {
            "displayName": "jugoslávský konvertibilní dinár (1990–1992)",
            "displayName-count-one": "jugoslávský konvertibilní dinár (1990–1992)",
            "displayName-count-few": "jugoslávské konvertibilní dináry (1990–1992)",
            "displayName-count-many": "jugoslávského konvertibilního dináru (1990–1992)",
            "displayName-count-other": "jugoslávských konvertibilních dinárů (1990–1992)",
            "symbol": "YUN"
          },
          "YUR": {
            "displayName": "jugoslávský reformovaný dinár (1992–1993)",
            "displayName-count-one": "jugoslávský reformovaný dinár (1992–1993)",
            "displayName-count-few": "jugoslávské reformované dináry (1992–1993)",
            "displayName-count-many": "jugoslávského reformovaného dináru (1992–1993)",
            "displayName-count-other": "jugoslávských reformovaných dinárů (1992–1993)",
            "symbol": "YUR"
          },
          "ZAL": {
            "displayName": "jihoafrický finanční rand",
            "displayName-count-one": "jihoafrický finanční rand",
            "displayName-count-few": "jihoafrické finanční randy",
            "displayName-count-many": "jihoafrického finančního randu",
            "displayName-count-other": "jihoafrických finančních randů",
            "symbol": "ZAL"
          },
          "ZAR": {
            "displayName": "jihoafrický rand",
            "displayName-count-one": "jihoafrický rand",
            "displayName-count-few": "jihoafrické randy",
            "displayName-count-many": "jihoafrického randu",
            "displayName-count-other": "jihoafrických randů",
            "symbol": "ZAR",
            "symbol-alt-narrow": "R"
          },
          "ZMK": {
            "displayName": "zambijská kwacha (1968–2012)",
            "displayName-count-one": "zambijská kwacha (1968–2012)",
            "displayName-count-few": "zambijské kwachy (1968–2012)",
            "displayName-count-many": "zambijské kwachy (1968–2012)",
            "displayName-count-other": "zambijských kwach (1968–2012)",
            "symbol": "ZMK"
          },
          "ZMW": {
            "displayName": "zambijská kwacha",
            "displayName-count-one": "zambijská kwacha",
            "displayName-count-few": "zambijské kwachy",
            "displayName-count-many": "zambijské kwachy",
            "displayName-count-other": "zambijských kwach",
            "symbol": "ZMW",
            "symbol-alt-narrow": "ZK"
          },
          "ZRN": {
            "displayName": "zairský nový zaire (1993–1998)",
            "displayName-count-one": "zairský nový zaire (1993–1998)",
            "displayName-count-few": "zairské nové zairy (1993–1998)",
            "displayName-count-many": "zairského nového zairu (1993–1998)",
            "displayName-count-other": "zairských nových zairů (1993–1998)",
            "symbol": "ZRN"
          },
          "ZRZ": {
            "displayName": "zairský zaire (1971–1993)",
            "displayName-count-one": "zairský zaire (1971–1993)",
            "displayName-count-few": "zairské zairy (1971–1993)",
            "displayName-count-many": "zairského zairu (1971–1993)",
            "displayName-count-other": "zairských zairů (1971–1993)",
            "symbol": "ZRZ"
          },
          "ZWD": {
            "displayName": "zimbabwský dolar (1980–2008)",
            "displayName-count-one": "zimbabwský dolar (1980–2008)",
            "displayName-count-few": "zimbabwské dolary (1980–2008)",
            "displayName-count-many": "zimbabwského dolaru (1980–2008)",
            "displayName-count-other": "zimbabwských dolarů (1980–2008)",
            "symbol": "ZWD"
          },
          "ZWL": {
            "displayName": "zimbabwský dolar (2009)",
            "displayName-count-one": "zimbabwský dolar (2009)",
            "displayName-count-few": "zimbabwské dolary (2009)",
            "displayName-count-many": "zimbabwského dolaru (2009)",
            "displayName-count-other": "zimbabwských dolarů (2009)",
            "symbol": "ZWL"
          },
          "ZWR": {
            "displayName": "zimbabwský dolar (2008)",
            "displayName-count-one": "zimbabwský dolar (2008)",
            "displayName-count-few": "zimbabwské dolary (2008)",
            "displayName-count-many": "zimbabwského dolaru (2008)",
            "displayName-count-other": "zimbabwských dolarů (2008)",
            "symbol": "ZWR"
          }
        }
      }
    }
  }
}, {
  "main": {
    "cs": {
      "identity": {
        "version": {
          "_number": "$Revision: 14844 $",
          "_cldrVersion": "35.1"
        },
        "language": "cs"
      },
      "dates": {
        "fields": {
          "era": {
            "displayName": "letopočet"
          },
          "era-short": {
            "displayName": "letop."
          },
          "era-narrow": {
            "displayName": "let."
          },
          "year": {
            "displayName": "rok",
            "relative-type--1": "minulý rok",
            "relative-type-0": "tento rok",
            "relative-type-1": "příští rok",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} rok",
              "relativeTimePattern-count-few": "za {0} roky",
              "relativeTimePattern-count-many": "za {0} roku",
              "relativeTimePattern-count-other": "za {0} let"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} rokem",
              "relativeTimePattern-count-few": "před {0} lety",
              "relativeTimePattern-count-many": "před {0} roku",
              "relativeTimePattern-count-other": "před {0} lety"
            }
          },
          "year-short": {
            "displayName": "r.",
            "relative-type--1": "minulý rok",
            "relative-type-0": "tento rok",
            "relative-type-1": "příští rok",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} r.",
              "relativeTimePattern-count-few": "za {0} r.",
              "relativeTimePattern-count-many": "za {0} r.",
              "relativeTimePattern-count-other": "za {0} l."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} r.",
              "relativeTimePattern-count-few": "před {0} r.",
              "relativeTimePattern-count-many": "před {0} r.",
              "relativeTimePattern-count-other": "před {0} l."
            }
          },
          "year-narrow": {
            "displayName": "r.",
            "relative-type--1": "minulý rok",
            "relative-type-0": "tento rok",
            "relative-type-1": "příští rok",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} r.",
              "relativeTimePattern-count-few": "za {0} r.",
              "relativeTimePattern-count-many": "za {0} r.",
              "relativeTimePattern-count-other": "za {0} l."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} r.",
              "relativeTimePattern-count-few": "před {0} r.",
              "relativeTimePattern-count-many": "před {0} r.",
              "relativeTimePattern-count-other": "před {0} l."
            }
          },
          "quarter": {
            "displayName": "čtvrtletí",
            "relative-type--1": "minulé čtvrtletí",
            "relative-type-0": "toto čtvrtletí",
            "relative-type-1": "příští čtvrtletí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtletí",
              "relativeTimePattern-count-few": "za {0} čtvrtletí",
              "relativeTimePattern-count-many": "za {0} čtvrtletí",
              "relativeTimePattern-count-other": "za {0} čtvrtletí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtletím",
              "relativeTimePattern-count-few": "před {0} čtvrtletími",
              "relativeTimePattern-count-many": "před {0} čtvrtletí",
              "relativeTimePattern-count-other": "před {0} čtvrtletími"
            }
          },
          "quarter-short": {
            "displayName": "Q",
            "relative-type--1": "minulé čtvrtletí",
            "relative-type-0": "toto čtvrtletí",
            "relative-type-1": "příští čtvrtletí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "+{0} Q",
              "relativeTimePattern-count-few": "+{0} Q",
              "relativeTimePattern-count-many": "+{0} Q",
              "relativeTimePattern-count-other": "+{0} Q"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "-{0} Q",
              "relativeTimePattern-count-few": "-{0} Q",
              "relativeTimePattern-count-many": "-{0} Q",
              "relativeTimePattern-count-other": "-{0} Q"
            }
          },
          "quarter-narrow": {
            "displayName": "Q",
            "relative-type--1": "minulé čtvrtletí",
            "relative-type-0": "toto čtvrtletí",
            "relative-type-1": "příští čtvrtletí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "+{0} Q",
              "relativeTimePattern-count-few": "+{0} Q",
              "relativeTimePattern-count-many": "+{0} Q",
              "relativeTimePattern-count-other": "+{0} Q"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "-{0} Q",
              "relativeTimePattern-count-few": "-{0} Q",
              "relativeTimePattern-count-many": "-{0} Q",
              "relativeTimePattern-count-other": "-{0} Q"
            }
          },
          "month": {
            "displayName": "měsíc",
            "relative-type--1": "minulý měsíc",
            "relative-type-0": "tento měsíc",
            "relative-type-1": "příští měsíc",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} měsíc",
              "relativeTimePattern-count-few": "za {0} měsíce",
              "relativeTimePattern-count-many": "za {0} měsíce",
              "relativeTimePattern-count-other": "za {0} měsíců"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} měsícem",
              "relativeTimePattern-count-few": "před {0} měsíci",
              "relativeTimePattern-count-many": "před {0} měsíce",
              "relativeTimePattern-count-other": "před {0} měsíci"
            }
          },
          "month-short": {
            "displayName": "měs.",
            "relative-type--1": "minulý měs.",
            "relative-type-0": "tento měs.",
            "relative-type-1": "příští měs.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} měs.",
              "relativeTimePattern-count-few": "za {0} měs.",
              "relativeTimePattern-count-many": "za {0} měs.",
              "relativeTimePattern-count-other": "za {0} měs."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} měs.",
              "relativeTimePattern-count-few": "před {0} měs.",
              "relativeTimePattern-count-many": "před {0} měs.",
              "relativeTimePattern-count-other": "před {0} měs."
            }
          },
          "month-narrow": {
            "displayName": "měs.",
            "relative-type--1": "minulý měs.",
            "relative-type-0": "tento měs.",
            "relative-type-1": "příští měs.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} měs.",
              "relativeTimePattern-count-few": "za {0} měs.",
              "relativeTimePattern-count-many": "za {0} měs.",
              "relativeTimePattern-count-other": "za {0} měs."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} měs.",
              "relativeTimePattern-count-few": "před {0} měs.",
              "relativeTimePattern-count-many": "před {0} měs.",
              "relativeTimePattern-count-other": "před {0} měs."
            }
          },
          "week": {
            "displayName": "týden",
            "relative-type--1": "minulý týden",
            "relative-type-0": "tento týden",
            "relative-type-1": "příští týden",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} týden",
              "relativeTimePattern-count-few": "za {0} týdny",
              "relativeTimePattern-count-many": "za {0} týdne",
              "relativeTimePattern-count-other": "za {0} týdnů"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} týdnem",
              "relativeTimePattern-count-few": "před {0} týdny",
              "relativeTimePattern-count-many": "před {0} týdne",
              "relativeTimePattern-count-other": "před {0} týdny"
            },
            "relativePeriod": "v týdnu {0}"
          },
          "week-short": {
            "displayName": "týd.",
            "relative-type--1": "minulý týd.",
            "relative-type-0": "tento týd.",
            "relative-type-1": "příští týd.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} týd.",
              "relativeTimePattern-count-few": "za {0} týd.",
              "relativeTimePattern-count-many": "za {0} týd.",
              "relativeTimePattern-count-other": "za {0} týd."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} týd.",
              "relativeTimePattern-count-few": "před {0} týd.",
              "relativeTimePattern-count-many": "před {0} týd.",
              "relativeTimePattern-count-other": "před {0} týd."
            },
            "relativePeriod": "v týd. {0}"
          },
          "week-narrow": {
            "displayName": "týd.",
            "relative-type--1": "minulý týd.",
            "relative-type-0": "tento týd.",
            "relative-type-1": "příští týd.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} týd.",
              "relativeTimePattern-count-few": "za {0} týd.",
              "relativeTimePattern-count-many": "za {0} týd.",
              "relativeTimePattern-count-other": "za {0} týd."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} týd.",
              "relativeTimePattern-count-few": "před {0} týd.",
              "relativeTimePattern-count-many": "před {0} týd.",
              "relativeTimePattern-count-other": "před {0} týd."
            },
            "relativePeriod": "v týd. {0}"
          },
          "weekOfMonth": {
            "displayName": "týden v měsíci"
          },
          "weekOfMonth-short": {
            "displayName": "týd. v m."
          },
          "weekOfMonth-narrow": {
            "displayName": "týd. v m."
          },
          "day": {
            "displayName": "den",
            "relative-type--2": "předevčírem",
            "relative-type--1": "včera",
            "relative-type-0": "dnes",
            "relative-type-1": "zítra",
            "relative-type-2": "pozítří",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} den",
              "relativeTimePattern-count-few": "za {0} dny",
              "relativeTimePattern-count-many": "za {0} dne",
              "relativeTimePattern-count-other": "za {0} dní"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} dnem",
              "relativeTimePattern-count-few": "před {0} dny",
              "relativeTimePattern-count-many": "před {0} dne",
              "relativeTimePattern-count-other": "před {0} dny"
            }
          },
          "day-short": {
            "displayName": "den",
            "relative-type--2": "předevčírem",
            "relative-type--1": "včera",
            "relative-type-0": "dnes",
            "relative-type-1": "zítra",
            "relative-type-2": "pozítří",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} den",
              "relativeTimePattern-count-few": "za {0} dny",
              "relativeTimePattern-count-many": "za {0} dne",
              "relativeTimePattern-count-other": "za {0} dní"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} dnem",
              "relativeTimePattern-count-few": "před {0} dny",
              "relativeTimePattern-count-many": "před {0} dne",
              "relativeTimePattern-count-other": "před {0} dny"
            }
          },
          "day-narrow": {
            "displayName": "den",
            "relative-type--2": "předevčírem",
            "relative-type--1": "včera",
            "relative-type-0": "dnes",
            "relative-type-1": "zítra",
            "relative-type-2": "pozítří",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} den",
              "relativeTimePattern-count-few": "za {0} dny",
              "relativeTimePattern-count-many": "za {0} dne",
              "relativeTimePattern-count-other": "za {0} dní"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} dnem",
              "relativeTimePattern-count-few": "před {0} dny",
              "relativeTimePattern-count-many": "před {0} dne",
              "relativeTimePattern-count-other": "před {0} dny"
            }
          },
          "dayOfYear": {
            "displayName": "den v roce"
          },
          "dayOfYear-short": {
            "displayName": "den v r."
          },
          "dayOfYear-narrow": {
            "displayName": "d. v r."
          },
          "weekday": {
            "displayName": "den v týdnu"
          },
          "weekday-short": {
            "displayName": "den v týd."
          },
          "weekday-narrow": {
            "displayName": "d. v týd."
          },
          "weekdayOfMonth": {
            "displayName": "den týdne v měsíci"
          },
          "weekdayOfMonth-short": {
            "displayName": "den týd. v měs."
          },
          "weekdayOfMonth-narrow": {
            "displayName": "d. týd. v měs."
          },
          "sun": {
            "relative-type--1": "minulou neděli",
            "relative-type-0": "tuto neděli",
            "relative-type-1": "příští neděli",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} neděli",
              "relativeTimePattern-count-few": "za {0} neděle",
              "relativeTimePattern-count-many": "za {0} neděle",
              "relativeTimePattern-count-other": "za {0} nedělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} nedělí",
              "relativeTimePattern-count-few": "před {0} nedělemi",
              "relativeTimePattern-count-many": "před {0} neděle",
              "relativeTimePattern-count-other": "před {0} nedělemi"
            }
          },
          "sun-short": {
            "relative-type--1": "minulou neděli",
            "relative-type-0": "tuto neděli",
            "relative-type-1": "příští neděli",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} neděli",
              "relativeTimePattern-count-few": "za {0} neděle",
              "relativeTimePattern-count-many": "za {0} neděle",
              "relativeTimePattern-count-other": "za {0} nedělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} nedělí",
              "relativeTimePattern-count-few": "před {0} nedělemi",
              "relativeTimePattern-count-many": "před {0} neděle",
              "relativeTimePattern-count-other": "před {0} nedělemi"
            }
          },
          "sun-narrow": {
            "relative-type--1": "minulou neděli",
            "relative-type-0": "tuto neděli",
            "relative-type-1": "příští neděli",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} neděli",
              "relativeTimePattern-count-few": "za {0} neděle",
              "relativeTimePattern-count-many": "za {0} neděle",
              "relativeTimePattern-count-other": "za {0} nedělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} nedělí",
              "relativeTimePattern-count-few": "před {0} nedělemi",
              "relativeTimePattern-count-many": "před {0} neděle",
              "relativeTimePattern-count-other": "před {0} nedělemi"
            }
          },
          "mon": {
            "relative-type--1": "minulé pondělí",
            "relative-type-0": "toto pondělí",
            "relative-type-1": "příští pondělí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pondělí",
              "relativeTimePattern-count-few": "za {0} pondělí",
              "relativeTimePattern-count-many": "za {0} pondělí",
              "relativeTimePattern-count-other": "za {0} pondělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pondělím",
              "relativeTimePattern-count-few": "před {0} pondělími",
              "relativeTimePattern-count-many": "před {0} pondělí",
              "relativeTimePattern-count-other": "před {0} pondělími"
            }
          },
          "mon-short": {
            "relative-type--1": "minulé pondělí",
            "relative-type-0": "toto pondělí",
            "relative-type-1": "příští pondělí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pondělí",
              "relativeTimePattern-count-few": "za {0} pondělí",
              "relativeTimePattern-count-many": "za {0} pondělí",
              "relativeTimePattern-count-other": "za {0} pondělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pondělím",
              "relativeTimePattern-count-few": "před {0} pondělími",
              "relativeTimePattern-count-many": "před {0} pondělí",
              "relativeTimePattern-count-other": "před {0} pondělími"
            }
          },
          "mon-narrow": {
            "relative-type--1": "minulé pondělí",
            "relative-type-0": "toto pondělí",
            "relative-type-1": "příští pondělí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pondělí",
              "relativeTimePattern-count-few": "za {0} pondělí",
              "relativeTimePattern-count-many": "za {0} pondělí",
              "relativeTimePattern-count-other": "za {0} pondělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pondělím",
              "relativeTimePattern-count-few": "před {0} pondělími",
              "relativeTimePattern-count-many": "před {0} pondělí",
              "relativeTimePattern-count-other": "před {0} pondělími"
            }
          },
          "tue": {
            "relative-type--1": "minulé úterý",
            "relative-type-0": "toto úterý",
            "relative-type-1": "příští úterý",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} úterý",
              "relativeTimePattern-count-few": "za {0} úterý",
              "relativeTimePattern-count-many": "za {0} úterý",
              "relativeTimePattern-count-other": "za {0} úterý"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} úterým",
              "relativeTimePattern-count-few": "před {0} úterými",
              "relativeTimePattern-count-many": "před {0} úterý",
              "relativeTimePattern-count-other": "před {0} úterými"
            }
          },
          "tue-short": {
            "relative-type--1": "minulé úterý",
            "relative-type-0": "toto úterý",
            "relative-type-1": "příští úterý",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} úterý",
              "relativeTimePattern-count-few": "za {0} úterý",
              "relativeTimePattern-count-many": "za {0} úterý",
              "relativeTimePattern-count-other": "za {0} úterý"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} úterým",
              "relativeTimePattern-count-few": "před {0} úterými",
              "relativeTimePattern-count-many": "před {0} úterý",
              "relativeTimePattern-count-other": "před {0} úterými"
            }
          },
          "tue-narrow": {
            "relative-type--1": "minulé úterý",
            "relative-type-0": "toto úterý",
            "relative-type-1": "příští úterý",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} úterý",
              "relativeTimePattern-count-few": "za {0} úterý",
              "relativeTimePattern-count-many": "za {0} úterý",
              "relativeTimePattern-count-other": "za {0} úterý"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} úterým",
              "relativeTimePattern-count-few": "před {0} úterými",
              "relativeTimePattern-count-many": "před {0} úterý",
              "relativeTimePattern-count-other": "před {0} úterými"
            }
          },
          "wed": {
            "relative-type--1": "minulou středu",
            "relative-type-0": "tuto středu",
            "relative-type-1": "příští středu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} středu",
              "relativeTimePattern-count-few": "za {0} středy",
              "relativeTimePattern-count-many": "za {0} středy",
              "relativeTimePattern-count-other": "za {0} střed"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} středou",
              "relativeTimePattern-count-few": "před {0} středami",
              "relativeTimePattern-count-many": "před {0} středy",
              "relativeTimePattern-count-other": "před {0} středami"
            }
          },
          "wed-short": {
            "relative-type--1": "minulou středu",
            "relative-type-0": "tuto středu",
            "relative-type-1": "příští středu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} středu",
              "relativeTimePattern-count-few": "za {0} středy",
              "relativeTimePattern-count-many": "za {0} středy",
              "relativeTimePattern-count-other": "za {0} střed"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} středou",
              "relativeTimePattern-count-few": "před {0} středami",
              "relativeTimePattern-count-many": "před {0} středy",
              "relativeTimePattern-count-other": "před {0} středami"
            }
          },
          "wed-narrow": {
            "relative-type--1": "minulou středu",
            "relative-type-0": "tuto středu",
            "relative-type-1": "příští středu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} středu",
              "relativeTimePattern-count-few": "za {0} středy",
              "relativeTimePattern-count-many": "za {0} středy",
              "relativeTimePattern-count-other": "za {0} střed"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} středou",
              "relativeTimePattern-count-few": "před {0} středami",
              "relativeTimePattern-count-many": "před {0} středy",
              "relativeTimePattern-count-other": "před {0} středami"
            }
          },
          "thu": {
            "relative-type--1": "minulý čtvrtek",
            "relative-type-0": "tento čtvrtek",
            "relative-type-1": "příští čtvrtek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtek",
              "relativeTimePattern-count-few": "za {0} čtvrtky",
              "relativeTimePattern-count-many": "za {0} čtvrtku",
              "relativeTimePattern-count-other": "za {0} čtvrtků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtkem",
              "relativeTimePattern-count-few": "před {0} čtvrtky",
              "relativeTimePattern-count-many": "před {0} čtvrtku",
              "relativeTimePattern-count-other": "před {0} čtvrtky"
            }
          },
          "thu-short": {
            "relative-type--1": "minulý čtvrtek",
            "relative-type-0": "tento čtvrtek",
            "relative-type-1": "příští čtvrtek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtek",
              "relativeTimePattern-count-few": "za {0} čtvrtky",
              "relativeTimePattern-count-many": "za {0} čtvrtku",
              "relativeTimePattern-count-other": "za {0} čtvrtků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtkem",
              "relativeTimePattern-count-few": "před {0} čtvrtky",
              "relativeTimePattern-count-many": "před {0} čtvrtku",
              "relativeTimePattern-count-other": "před {0} čtvrtky"
            }
          },
          "thu-narrow": {
            "relative-type--1": "minulý čtvrtek",
            "relative-type-0": "tento čtvrtek",
            "relative-type-1": "příští čtvrtek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtek",
              "relativeTimePattern-count-few": "za {0} čtvrtky",
              "relativeTimePattern-count-many": "za {0} čtvrtku",
              "relativeTimePattern-count-other": "za {0} čtvrtků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtkem",
              "relativeTimePattern-count-few": "před {0} čtvrtky",
              "relativeTimePattern-count-many": "před {0} čtvrtku",
              "relativeTimePattern-count-other": "před {0} čtvrtky"
            }
          },
          "fri": {
            "relative-type--1": "minulý pátek",
            "relative-type-0": "tento pátek",
            "relative-type-1": "příští pátek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pátek",
              "relativeTimePattern-count-few": "za {0} pátky",
              "relativeTimePattern-count-many": "za {0} pátku",
              "relativeTimePattern-count-other": "za {0} pátků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pátkem",
              "relativeTimePattern-count-few": "před {0} pátky",
              "relativeTimePattern-count-many": "před {0} pátku",
              "relativeTimePattern-count-other": "před {0} pátky"
            }
          },
          "fri-short": {
            "relative-type--1": "minulý pátek",
            "relative-type-0": "tento pátek",
            "relative-type-1": "příští pátek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pátek",
              "relativeTimePattern-count-few": "za {0} pátky",
              "relativeTimePattern-count-many": "za {0} pátku",
              "relativeTimePattern-count-other": "za {0} pátků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pátkem",
              "relativeTimePattern-count-few": "před {0} pátky",
              "relativeTimePattern-count-many": "před {0} pátku",
              "relativeTimePattern-count-other": "před {0} pátky"
            }
          },
          "fri-narrow": {
            "relative-type--1": "minulý pátek",
            "relative-type-0": "tento pátek",
            "relative-type-1": "příští pátek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pátek",
              "relativeTimePattern-count-few": "za {0} pátky",
              "relativeTimePattern-count-many": "za {0} pátku",
              "relativeTimePattern-count-other": "za {0} pátků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pátkem",
              "relativeTimePattern-count-few": "před {0} pátky",
              "relativeTimePattern-count-many": "před {0} pátku",
              "relativeTimePattern-count-other": "před {0} pátky"
            }
          },
          "sat": {
            "relative-type--1": "minulou sobotu",
            "relative-type-0": "tuto sobotu",
            "relative-type-1": "příští sobotu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sobotu",
              "relativeTimePattern-count-few": "za {0} soboty",
              "relativeTimePattern-count-many": "za {0} soboty",
              "relativeTimePattern-count-other": "za {0} sobot"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sobotou",
              "relativeTimePattern-count-few": "před {0} sobotami",
              "relativeTimePattern-count-many": "před {0} soboty",
              "relativeTimePattern-count-other": "před {0} sobotami"
            }
          },
          "sat-short": {
            "relative-type--1": "minulou sobotu",
            "relative-type-0": "tuto sobotu",
            "relative-type-1": "příští sobotu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sobotu",
              "relativeTimePattern-count-few": "za {0} soboty",
              "relativeTimePattern-count-many": "za {0} soboty",
              "relativeTimePattern-count-other": "za {0} sobot"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sobotou",
              "relativeTimePattern-count-few": "před {0} sobotami",
              "relativeTimePattern-count-many": "před {0} soboty",
              "relativeTimePattern-count-other": "před {0} sobotami"
            }
          },
          "sat-narrow": {
            "relative-type--1": "minulou sobotu",
            "relative-type-0": "tuto sobotu",
            "relative-type-1": "příští sobotu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sobotu",
              "relativeTimePattern-count-few": "za {0} soboty",
              "relativeTimePattern-count-many": "za {0} soboty",
              "relativeTimePattern-count-other": "za {0} sobot"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sobotou",
              "relativeTimePattern-count-few": "před {0} sobotami",
              "relativeTimePattern-count-many": "před {0} soboty",
              "relativeTimePattern-count-other": "před {0} sobotami"
            }
          },
          "dayperiod-short": {
            "displayName": "část dne"
          },
          "dayperiod": {
            "displayName": "část dne"
          },
          "dayperiod-narrow": {
            "displayName": "část d."
          },
          "hour": {
            "displayName": "hodina",
            "relative-type-0": "tuto hodinu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} hodinu",
              "relativeTimePattern-count-few": "za {0} hodiny",
              "relativeTimePattern-count-many": "za {0} hodiny",
              "relativeTimePattern-count-other": "za {0} hodin"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} hodinou",
              "relativeTimePattern-count-few": "před {0} hodinami",
              "relativeTimePattern-count-many": "před {0} hodiny",
              "relativeTimePattern-count-other": "před {0} hodinami"
            }
          },
          "hour-short": {
            "displayName": "h",
            "relative-type-0": "tuto hodinu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} h",
              "relativeTimePattern-count-few": "za {0} h",
              "relativeTimePattern-count-many": "za {0} h",
              "relativeTimePattern-count-other": "za {0} h"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} h",
              "relativeTimePattern-count-few": "před {0} h",
              "relativeTimePattern-count-many": "před {0} h",
              "relativeTimePattern-count-other": "před {0} h"
            }
          },
          "hour-narrow": {
            "displayName": "h",
            "relative-type-0": "tuto hodinu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} h",
              "relativeTimePattern-count-few": "za {0} h",
              "relativeTimePattern-count-many": "za {0} h",
              "relativeTimePattern-count-other": "za {0} h"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} h",
              "relativeTimePattern-count-few": "před {0} h",
              "relativeTimePattern-count-many": "před {0} h",
              "relativeTimePattern-count-other": "před {0} h"
            }
          },
          "minute": {
            "displayName": "minuta",
            "relative-type-0": "tuto minutu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} minutu",
              "relativeTimePattern-count-few": "za {0} minuty",
              "relativeTimePattern-count-many": "za {0} minuty",
              "relativeTimePattern-count-other": "za {0} minut"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} minutou",
              "relativeTimePattern-count-few": "před {0} minutami",
              "relativeTimePattern-count-many": "před {0} minuty",
              "relativeTimePattern-count-other": "před {0} minutami"
            }
          },
          "minute-short": {
            "displayName": "min",
            "relative-type-0": "tuto minutu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} min",
              "relativeTimePattern-count-few": "za {0} min",
              "relativeTimePattern-count-many": "za {0} min",
              "relativeTimePattern-count-other": "za {0} min"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} min",
              "relativeTimePattern-count-few": "před {0} min",
              "relativeTimePattern-count-many": "před {0} min",
              "relativeTimePattern-count-other": "před {0} min"
            }
          },
          "minute-narrow": {
            "displayName": "min",
            "relative-type-0": "tuto minutu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} min",
              "relativeTimePattern-count-few": "za {0} min",
              "relativeTimePattern-count-many": "za {0} min",
              "relativeTimePattern-count-other": "za {0} min"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} min",
              "relativeTimePattern-count-few": "před {0} min",
              "relativeTimePattern-count-many": "před {0} min",
              "relativeTimePattern-count-other": "před {0} min"
            }
          },
          "second": {
            "displayName": "sekunda",
            "relative-type-0": "nyní",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sekundu",
              "relativeTimePattern-count-few": "za {0} sekundy",
              "relativeTimePattern-count-many": "za {0} sekundy",
              "relativeTimePattern-count-other": "za {0} sekund"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sekundou",
              "relativeTimePattern-count-few": "před {0} sekundami",
              "relativeTimePattern-count-many": "před {0} sekundy",
              "relativeTimePattern-count-other": "před {0} sekundami"
            }
          },
          "second-short": {
            "displayName": "s",
            "relative-type-0": "nyní",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} s",
              "relativeTimePattern-count-few": "za {0} s",
              "relativeTimePattern-count-many": "za {0} s",
              "relativeTimePattern-count-other": "za {0} s"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} s",
              "relativeTimePattern-count-few": "před {0} s",
              "relativeTimePattern-count-many": "před {0} s",
              "relativeTimePattern-count-other": "před {0} s"
            }
          },
          "second-narrow": {
            "displayName": "s",
            "relative-type-0": "nyní",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} s",
              "relativeTimePattern-count-few": "za {0} s",
              "relativeTimePattern-count-many": "za {0} s",
              "relativeTimePattern-count-other": "za {0} s"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} s",
              "relativeTimePattern-count-few": "před {0} s",
              "relativeTimePattern-count-many": "před {0} s",
              "relativeTimePattern-count-other": "před {0} s"
            }
          },
          "zone": {
            "displayName": "časové pásmo"
          },
          "zone-short": {
            "displayName": "čas. pásmo"
          },
          "zone-narrow": {
            "displayName": "pásmo"
          }
        }
      }
    }
  }
}, {
  "main": {
    "cs": {
      "identity": {
        "version": {
          "_number": "$Revision: 14844 $",
          "_cldrVersion": "35.1"
        },
        "language": "cs"
      },
      "numbers": {
        "defaultNumberingSystem": "latn",
        "otherNumberingSystems": {
          "native": "latn"
        },
        "minimumGroupingDigits": "1",
        "symbols-numberSystem-latn": {
          "decimal": ",",
          "group": " ",
          "list": ";",
          "percentSign": "%",
          "plusSign": "+",
          "minusSign": "-",
          "exponential": "E",
          "superscriptingExponent": "×",
          "perMille": "‰",
          "infinity": "∞",
          "nan": "NaN",
          "timeSeparator": ":"
        },
        "decimalFormats-numberSystem-latn": {
          "standard": "#,##0.###",
          "long": {
            "decimalFormat": {
              "1000-count-one": "0 tisíc",
              "1000-count-few": "0 tisíce",
              "1000-count-many": "0 tisíce",
              "1000-count-other": "0 tisíc",
              "10000-count-one": "00 tisíc",
              "10000-count-few": "00 tisíc",
              "10000-count-many": "00 tisíce",
              "10000-count-other": "00 tisíc",
              "100000-count-one": "000 tisíc",
              "100000-count-few": "000 tisíc",
              "100000-count-many": "000 tisíce",
              "100000-count-other": "000 tisíc",
              "1000000-count-one": "0 milion",
              "1000000-count-few": "0 miliony",
              "1000000-count-many": "0 milionu",
              "1000000-count-other": "0 milionů",
              "10000000-count-one": "00 milionů",
              "10000000-count-few": "00 milionů",
              "10000000-count-many": "00 milionu",
              "10000000-count-other": "00 milionů",
              "100000000-count-one": "000 milionů",
              "100000000-count-few": "000 milionů",
              "100000000-count-many": "000 milionu",
              "100000000-count-other": "000 milionů",
              "1000000000-count-one": "0 miliarda",
              "1000000000-count-few": "0 miliardy",
              "1000000000-count-many": "0 miliardy",
              "1000000000-count-other": "0 miliard",
              "10000000000-count-one": "00 miliard",
              "10000000000-count-few": "00 miliard",
              "10000000000-count-many": "00 miliardy",
              "10000000000-count-other": "00 miliard",
              "100000000000-count-one": "000 miliard",
              "100000000000-count-few": "000 miliard",
              "100000000000-count-many": "000 miliardy",
              "100000000000-count-other": "000 miliard",
              "1000000000000-count-one": "0 bilion",
              "1000000000000-count-few": "0 biliony",
              "1000000000000-count-many": "0 bilionu",
              "1000000000000-count-other": "0 bilionů",
              "10000000000000-count-one": "00 bilionů",
              "10000000000000-count-few": "00 bilionů",
              "10000000000000-count-many": "00 bilionu",
              "10000000000000-count-other": "00 bilionů",
              "100000000000000-count-one": "000 bilionů",
              "100000000000000-count-few": "000 bilionů",
              "100000000000000-count-many": "000 bilionu",
              "100000000000000-count-other": "000 bilionů"
            }
          },
          "short": {
            "decimalFormat": {
              "1000-count-one": "0 tis'.'",
              "1000-count-few": "0 tis'.'",
              "1000-count-many": "0 tis'.'",
              "1000-count-other": "0 tis'.'",
              "10000-count-one": "00 tis'.'",
              "10000-count-few": "00 tis'.'",
              "10000-count-many": "00 tis'.'",
              "10000-count-other": "00 tis'.'",
              "100000-count-one": "000 tis'.'",
              "100000-count-few": "000 tis'.'",
              "100000-count-many": "000 tis'.'",
              "100000-count-other": "000 tis'.'",
              "1000000-count-one": "0 mil'.'",
              "1000000-count-few": "0 mil'.'",
              "1000000-count-many": "0 mil'.'",
              "1000000-count-other": "0 mil'.'",
              "10000000-count-one": "00 mil'.'",
              "10000000-count-few": "00 mil'.'",
              "10000000-count-many": "00 mil'.'",
              "10000000-count-other": "00 mil'.'",
              "100000000-count-one": "000 mil'.'",
              "100000000-count-few": "000 mil'.'",
              "100000000-count-many": "000 mil'.'",
              "100000000-count-other": "000 mil'.'",
              "1000000000-count-one": "0 mld'.'",
              "1000000000-count-few": "0 mld'.'",
              "1000000000-count-many": "0 mld'.'",
              "1000000000-count-other": "0 mld'.'",
              "10000000000-count-one": "00 mld'.'",
              "10000000000-count-few": "00 mld'.'",
              "10000000000-count-many": "00 mld'.'",
              "10000000000-count-other": "00 mld'.'",
              "100000000000-count-one": "000 mld'.'",
              "100000000000-count-few": "000 mld'.'",
              "100000000000-count-many": "000 mld'.'",
              "100000000000-count-other": "000 mld'.'",
              "1000000000000-count-one": "0 bil'.'",
              "1000000000000-count-few": "0 bil'.'",
              "1000000000000-count-many": "0 bil'.'",
              "1000000000000-count-other": "0 bil'.'",
              "10000000000000-count-one": "00 bil'.'",
              "10000000000000-count-few": "00 bil'.'",
              "10000000000000-count-many": "00 bil'.'",
              "10000000000000-count-other": "00 bil'.'",
              "100000000000000-count-one": "000 bil'.'",
              "100000000000000-count-few": "000 bil'.'",
              "100000000000000-count-many": "000 bil'.'",
              "100000000000000-count-other": "000 bil'.'"
            }
          }
        },
        "scientificFormats-numberSystem-latn": {
          "standard": "#E0"
        },
        "percentFormats-numberSystem-latn": {
          "standard": "#,##0 %"
        },
        "currencyFormats-numberSystem-latn": {
          "currencySpacing": {
            "beforeCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": " "
            },
            "afterCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": " "
            }
          },
          "standard": "#,##0.00 ¤",
          "accounting": "#,##0.00 ¤",
          "short": {
            "standard": {
              "1000-count-one": "0 tis'.' ¤",
              "1000-count-few": "0 tis'.' ¤",
              "1000-count-many": "0 tis'.' ¤",
              "1000-count-other": "0 tis'.' ¤",
              "10000-count-one": "00 tis'.' ¤",
              "10000-count-few": "00 tis'.' ¤",
              "10000-count-many": "00 tis'.' ¤",
              "10000-count-other": "00 tis'.' ¤",
              "100000-count-one": "000 tis'.' ¤",
              "100000-count-few": "000 tis'.' ¤",
              "100000-count-many": "000 tis'.' ¤",
              "100000-count-other": "000 tis'.' ¤",
              "1000000-count-one": "0 mil'.' ¤",
              "1000000-count-few": "0 mil'.' ¤",
              "1000000-count-many": "0 mil'.' ¤",
              "1000000-count-other": "0 mil'.' ¤",
              "10000000-count-one": "00 mil'.' ¤",
              "10000000-count-few": "00 mil'.' ¤",
              "10000000-count-many": "00 mil'.' ¤",
              "10000000-count-other": "00 mil'.' ¤",
              "100000000-count-one": "000 mil'.' ¤",
              "100000000-count-few": "000 mil'.' ¤",
              "100000000-count-many": "000 mil'.' ¤",
              "100000000-count-other": "000 mil'.' ¤",
              "1000000000-count-one": "0 mld'.' ¤",
              "1000000000-count-few": "0 mld'.' ¤",
              "1000000000-count-many": "0 mld'.' ¤",
              "1000000000-count-other": "0 mld'.' ¤",
              "10000000000-count-one": "00 mld'.' ¤",
              "10000000000-count-few": "00 mld'.' ¤",
              "10000000000-count-many": "00 mld'.' ¤",
              "10000000000-count-other": "00 mld'.' ¤",
              "100000000000-count-one": "000 mld'.' ¤",
              "100000000000-count-few": "000 mld'.' ¤",
              "100000000000-count-many": "000 mld'.' ¤",
              "100000000000-count-other": "000 mld'.' ¤",
              "1000000000000-count-one": "0 bil'.' ¤",
              "1000000000000-count-few": "0 bil'.' ¤",
              "1000000000000-count-many": "0 bil'.' ¤",
              "1000000000000-count-other": "0 bil'.' ¤",
              "10000000000000-count-one": "00 bil'.' ¤",
              "10000000000000-count-few": "00 bil'.' ¤",
              "10000000000000-count-many": "00 bil'.' ¤",
              "10000000000000-count-other": "00 bil'.' ¤",
              "100000000000000-count-one": "000 bil'.' ¤",
              "100000000000000-count-few": "000 bil'.' ¤",
              "100000000000000-count-many": "000 bil'.' ¤",
              "100000000000000-count-other": "000 bil'.' ¤"
            }
          },
          "unitPattern-count-one": "{0} {1}",
          "unitPattern-count-few": "{0} {1}",
          "unitPattern-count-many": "{0} {1}",
          "unitPattern-count-other": "{0} {1}"
        },
        "miscPatterns-numberSystem-latn": {
          "approximately": "~{0}",
          "atLeast": "≥{0}",
          "atMost": "≤{0}",
          "range": "{0}–{1}"
        },
        "minimalPairs": {
          "pluralMinimalPairs-count-one": "{0} den",
          "pluralMinimalPairs-count-few": "{0} dny",
          "pluralMinimalPairs-count-many": "{0} dne",
          "pluralMinimalPairs-count-other": "{0} dní",
          "other": "Na {0}. křižovatce odbočte vpravo."
        }
      }
    }
  }
}, {
  "main": {
    "cs": {
      "identity": {
        "version": {
          "_number": "$Revision: 14844 $",
          "_cldrVersion": "35.1"
        },
        "language": "cs"
      },
      "dates": {
        "timeZoneNames": {
          "hourFormat": "+H:mm;-H:mm",
          "gmtFormat": "GMT{0}",
          "gmtZeroFormat": "GMT",
          "regionFormat": "Časové pásmo {0}",
          "regionFormat-type-daylight": "{0} (+1)",
          "regionFormat-type-standard": "{0} (+0)",
          "fallbackFormat": "{1} ({0})",
          "zone": {
            "America": {
              "Adak": {
                "exemplarCity": "Adak"
              },
              "Anchorage": {
                "exemplarCity": "Anchorage"
              },
              "Anguilla": {
                "exemplarCity": "Anguilla"
              },
              "Antigua": {
                "exemplarCity": "Antigua"
              },
              "Araguaina": {
                "exemplarCity": "Araguaina"
              },
              "Argentina": {
                "Rio_Gallegos": {
                  "exemplarCity": "Rio Gallegos"
                },
                "San_Juan": {
                  "exemplarCity": "San Juan"
                },
                "Ushuaia": {
                  "exemplarCity": "Ushuaia"
                },
                "La_Rioja": {
                  "exemplarCity": "La Rioja"
                },
                "San_Luis": {
                  "exemplarCity": "San Luis"
                },
                "Salta": {
                  "exemplarCity": "Salta"
                },
                "Tucuman": {
                  "exemplarCity": "Tucuman"
                }
              },
              "Aruba": {
                "exemplarCity": "Aruba"
              },
              "Asuncion": {
                "exemplarCity": "Asunción"
              },
              "Bahia": {
                "exemplarCity": "Bahía"
              },
              "Bahia_Banderas": {
                "exemplarCity": "Bahia Banderas"
              },
              "Barbados": {
                "exemplarCity": "Barbados"
              },
              "Belem": {
                "exemplarCity": "Belém"
              },
              "Belize": {
                "exemplarCity": "Belize"
              },
              "Blanc-Sablon": {
                "exemplarCity": "Blanc-Sablon"
              },
              "Boa_Vista": {
                "exemplarCity": "Boa Vista"
              },
              "Bogota": {
                "exemplarCity": "Bogotá"
              },
              "Boise": {
                "exemplarCity": "Boise"
              },
              "Buenos_Aires": {
                "exemplarCity": "Buenos Aires"
              },
              "Cambridge_Bay": {
                "exemplarCity": "Cambridge Bay"
              },
              "Campo_Grande": {
                "exemplarCity": "Campo Grande"
              },
              "Cancun": {
                "exemplarCity": "Cancún"
              },
              "Caracas": {
                "exemplarCity": "Caracas"
              },
              "Catamarca": {
                "exemplarCity": "Catamarca"
              },
              "Cayenne": {
                "exemplarCity": "Cayenne"
              },
              "Cayman": {
                "exemplarCity": "Kajmanské ostrovy"
              },
              "Chicago": {
                "exemplarCity": "Chicago"
              },
              "Chihuahua": {
                "exemplarCity": "Chihuahua"
              },
              "Coral_Harbour": {
                "exemplarCity": "Atikokan"
              },
              "Cordoba": {
                "exemplarCity": "Córdoba"
              },
              "Costa_Rica": {
                "exemplarCity": "Kostarika"
              },
              "Creston": {
                "exemplarCity": "Creston"
              },
              "Cuiaba": {
                "exemplarCity": "Cuiaba"
              },
              "Curacao": {
                "exemplarCity": "Curaçao"
              },
              "Danmarkshavn": {
                "exemplarCity": "Danmarkshavn"
              },
              "Dawson": {
                "exemplarCity": "Dawson"
              },
              "Dawson_Creek": {
                "exemplarCity": "Dawson Creek"
              },
              "Denver": {
                "exemplarCity": "Denver"
              },
              "Detroit": {
                "exemplarCity": "Detroit"
              },
              "Dominica": {
                "exemplarCity": "Dominika"
              },
              "Edmonton": {
                "exemplarCity": "Edmonton"
              },
              "Eirunepe": {
                "exemplarCity": "Eirunepe"
              },
              "El_Salvador": {
                "exemplarCity": "Salvador"
              },
              "Fort_Nelson": {
                "exemplarCity": "Fort Nelson"
              },
              "Fortaleza": {
                "exemplarCity": "Fortaleza"
              },
              "Glace_Bay": {
                "exemplarCity": "Glace Bay"
              },
              "Godthab": {
                "exemplarCity": "Nuuk"
              },
              "Goose_Bay": {
                "exemplarCity": "Goose Bay"
              },
              "Grand_Turk": {
                "exemplarCity": "Grand Turk"
              },
              "Grenada": {
                "exemplarCity": "Grenada"
              },
              "Guadeloupe": {
                "exemplarCity": "Guadeloupe"
              },
              "Guatemala": {
                "exemplarCity": "Guatemala"
              },
              "Guayaquil": {
                "exemplarCity": "Guayaquil"
              },
              "Guyana": {
                "exemplarCity": "Guyana"
              },
              "Halifax": {
                "exemplarCity": "Halifax"
              },
              "Havana": {
                "exemplarCity": "Havana"
              },
              "Hermosillo": {
                "exemplarCity": "Hermosillo"
              },
              "Indiana": {
                "Vincennes": {
                  "exemplarCity": "Vincennes, Indiana"
                },
                "Petersburg": {
                  "exemplarCity": "Petersburg, Indiana"
                },
                "Tell_City": {
                  "exemplarCity": "Tell City, Indiana"
                },
                "Knox": {
                  "exemplarCity": "Knox, Indiana"
                },
                "Winamac": {
                  "exemplarCity": "Winamac, Indiana"
                },
                "Marengo": {
                  "exemplarCity": "Marengo, Indiana"
                },
                "Vevay": {
                  "exemplarCity": "Vevay, Indiana"
                }
              },
              "Indianapolis": {
                "exemplarCity": "Indianapolis"
              },
              "Inuvik": {
                "exemplarCity": "Inuvik"
              },
              "Iqaluit": {
                "exemplarCity": "Iqaluit"
              },
              "Jamaica": {
                "exemplarCity": "Jamajka"
              },
              "Jujuy": {
                "exemplarCity": "Jujuy"
              },
              "Juneau": {
                "exemplarCity": "Juneau"
              },
              "Kentucky": {
                "Monticello": {
                  "exemplarCity": "Monticello, Kentucky"
                }
              },
              "Kralendijk": {
                "exemplarCity": "Kralendijk"
              },
              "La_Paz": {
                "exemplarCity": "La Paz"
              },
              "Lima": {
                "exemplarCity": "Lima"
              },
              "Los_Angeles": {
                "exemplarCity": "Los Angeles"
              },
              "Louisville": {
                "exemplarCity": "Louisville"
              },
              "Lower_Princes": {
                "exemplarCity": "Lower Prince’s Quarter"
              },
              "Maceio": {
                "exemplarCity": "Maceio"
              },
              "Managua": {
                "exemplarCity": "Managua"
              },
              "Manaus": {
                "exemplarCity": "Manaus"
              },
              "Marigot": {
                "exemplarCity": "Marigot"
              },
              "Martinique": {
                "exemplarCity": "Martinik"
              },
              "Matamoros": {
                "exemplarCity": "Matamoros"
              },
              "Mazatlan": {
                "exemplarCity": "Mazatlán"
              },
              "Mendoza": {
                "exemplarCity": "Mendoza"
              },
              "Menominee": {
                "exemplarCity": "Menominee"
              },
              "Merida": {
                "exemplarCity": "Merida"
              },
              "Metlakatla": {
                "exemplarCity": "Metlakatla"
              },
              "Mexico_City": {
                "exemplarCity": "Ciudad de México"
              },
              "Miquelon": {
                "exemplarCity": "Miquelon"
              },
              "Moncton": {
                "exemplarCity": "Moncton"
              },
              "Monterrey": {
                "exemplarCity": "Monterrey"
              },
              "Montevideo": {
                "exemplarCity": "Montevideo"
              },
              "Montserrat": {
                "exemplarCity": "Montserrat"
              },
              "Nassau": {
                "exemplarCity": "Nassau"
              },
              "New_York": {
                "exemplarCity": "New York"
              },
              "Nipigon": {
                "exemplarCity": "Nipigon"
              },
              "Nome": {
                "exemplarCity": "Nome"
              },
              "Noronha": {
                "exemplarCity": "Noronha"
              },
              "North_Dakota": {
                "Beulah": {
                  "exemplarCity": "Beulah, Severní Dakota"
                },
                "New_Salem": {
                  "exemplarCity": "New Salem, Severní Dakota"
                },
                "Center": {
                  "exemplarCity": "Center, Severní Dakota"
                }
              },
              "Ojinaga": {
                "exemplarCity": "Ojinaga"
              },
              "Panama": {
                "exemplarCity": "Panama"
              },
              "Pangnirtung": {
                "exemplarCity": "Pangnirtung"
              },
              "Paramaribo": {
                "exemplarCity": "Paramaribo"
              },
              "Phoenix": {
                "exemplarCity": "Phoenix"
              },
              "Port-au-Prince": {
                "exemplarCity": "Port-au-Prince"
              },
              "Port_of_Spain": {
                "exemplarCity": "Port of Spain"
              },
              "Porto_Velho": {
                "exemplarCity": "Porto Velho"
              },
              "Puerto_Rico": {
                "exemplarCity": "Portoriko"
              },
              "Punta_Arenas": {
                "exemplarCity": "Punta Arenas"
              },
              "Rainy_River": {
                "exemplarCity": "Rainy River"
              },
              "Rankin_Inlet": {
                "exemplarCity": "Rankin Inlet"
              },
              "Recife": {
                "exemplarCity": "Recife"
              },
              "Regina": {
                "exemplarCity": "Regina"
              },
              "Resolute": {
                "exemplarCity": "Resolute"
              },
              "Rio_Branco": {
                "exemplarCity": "Rio Branco"
              },
              "Santa_Isabel": {
                "exemplarCity": "Santa Isabel"
              },
              "Santarem": {
                "exemplarCity": "Santarém"
              },
              "Santiago": {
                "exemplarCity": "Santiago"
              },
              "Santo_Domingo": {
                "exemplarCity": "Santo Domingo"
              },
              "Sao_Paulo": {
                "exemplarCity": "São Paulo"
              },
              "Scoresbysund": {
                "exemplarCity": "Ittoqqortoormiit"
              },
              "Sitka": {
                "exemplarCity": "Sitka"
              },
              "St_Barthelemy": {
                "exemplarCity": "Svatý Bartoloměj"
              },
              "St_Johns": {
                "exemplarCity": "St. John’s"
              },
              "St_Kitts": {
                "exemplarCity": "Svatý Kryštof"
              },
              "St_Lucia": {
                "exemplarCity": "Svatá Lucie"
              },
              "St_Thomas": {
                "exemplarCity": "Svatý Tomáš (Karibik)"
              },
              "St_Vincent": {
                "exemplarCity": "Svatý Vincenc"
              },
              "Swift_Current": {
                "exemplarCity": "Swift Current"
              },
              "Tegucigalpa": {
                "exemplarCity": "Tegucigalpa"
              },
              "Thule": {
                "exemplarCity": "Thule"
              },
              "Thunder_Bay": {
                "exemplarCity": "Thunder Bay"
              },
              "Tijuana": {
                "exemplarCity": "Tijuana"
              },
              "Toronto": {
                "exemplarCity": "Toronto"
              },
              "Tortola": {
                "exemplarCity": "Tortola"
              },
              "Vancouver": {
                "exemplarCity": "Vancouver"
              },
              "Whitehorse": {
                "exemplarCity": "Whitehorse"
              },
              "Winnipeg": {
                "exemplarCity": "Winnipeg"
              },
              "Yakutat": {
                "exemplarCity": "Yakutat"
              },
              "Yellowknife": {
                "exemplarCity": "Yellowknife"
              }
            },
            "Atlantic": {
              "Azores": {
                "exemplarCity": "Azorské ostrovy"
              },
              "Bermuda": {
                "exemplarCity": "Bermudy"
              },
              "Canary": {
                "exemplarCity": "Kanárské ostrovy"
              },
              "Cape_Verde": {
                "exemplarCity": "Kapverdy"
              },
              "Faeroe": {
                "exemplarCity": "Faerské ostrovy"
              },
              "Madeira": {
                "exemplarCity": "Madeira"
              },
              "Reykjavik": {
                "exemplarCity": "Reykjavík"
              },
              "South_Georgia": {
                "exemplarCity": "Jižní Georgie"
              },
              "St_Helena": {
                "exemplarCity": "Svatá Helena"
              },
              "Stanley": {
                "exemplarCity": "Stanley"
              }
            },
            "Europe": {
              "Amsterdam": {
                "exemplarCity": "Amsterdam"
              },
              "Andorra": {
                "exemplarCity": "Andorra"
              },
              "Astrakhan": {
                "exemplarCity": "Astrachaň"
              },
              "Athens": {
                "exemplarCity": "Athény"
              },
              "Belgrade": {
                "exemplarCity": "Bělehrad"
              },
              "Berlin": {
                "exemplarCity": "Berlín"
              },
              "Bratislava": {
                "exemplarCity": "Bratislava"
              },
              "Brussels": {
                "exemplarCity": "Brusel"
              },
              "Bucharest": {
                "exemplarCity": "Bukurešť"
              },
              "Budapest": {
                "exemplarCity": "Budapešť"
              },
              "Busingen": {
                "exemplarCity": "Busingen"
              },
              "Chisinau": {
                "exemplarCity": "Kišiněv"
              },
              "Copenhagen": {
                "exemplarCity": "Kodaň"
              },
              "Dublin": {
                "long": {
                  "daylight": "Irský letní čas"
                },
                "exemplarCity": "Dublin"
              },
              "Gibraltar": {
                "exemplarCity": "Gibraltar"
              },
              "Guernsey": {
                "exemplarCity": "Guernsey"
              },
              "Helsinki": {
                "exemplarCity": "Helsinky"
              },
              "Isle_of_Man": {
                "exemplarCity": "Ostrov Man"
              },
              "Istanbul": {
                "exemplarCity": "Istanbul"
              },
              "Jersey": {
                "exemplarCity": "Jersey"
              },
              "Kaliningrad": {
                "exemplarCity": "Kaliningrad"
              },
              "Kiev": {
                "exemplarCity": "Kyjev"
              },
              "Kirov": {
                "exemplarCity": "Kirov"
              },
              "Lisbon": {
                "exemplarCity": "Lisabon"
              },
              "Ljubljana": {
                "exemplarCity": "Lublaň"
              },
              "London": {
                "long": {
                  "daylight": "Britský letní čas"
                },
                "exemplarCity": "Londýn"
              },
              "Luxembourg": {
                "exemplarCity": "Lucemburk"
              },
              "Madrid": {
                "exemplarCity": "Madrid"
              },
              "Malta": {
                "exemplarCity": "Malta"
              },
              "Mariehamn": {
                "exemplarCity": "Mariehamn"
              },
              "Minsk": {
                "exemplarCity": "Minsk"
              },
              "Monaco": {
                "exemplarCity": "Monako"
              },
              "Moscow": {
                "exemplarCity": "Moskva"
              },
              "Oslo": {
                "exemplarCity": "Oslo"
              },
              "Paris": {
                "exemplarCity": "Paříž"
              },
              "Podgorica": {
                "exemplarCity": "Podgorica"
              },
              "Prague": {
                "exemplarCity": "Praha"
              },
              "Riga": {
                "exemplarCity": "Riga"
              },
              "Rome": {
                "exemplarCity": "Řím"
              },
              "Samara": {
                "exemplarCity": "Samara"
              },
              "San_Marino": {
                "exemplarCity": "San Marino"
              },
              "Sarajevo": {
                "exemplarCity": "Sarajevo"
              },
              "Saratov": {
                "exemplarCity": "Saratov"
              },
              "Simferopol": {
                "exemplarCity": "Simferopol"
              },
              "Skopje": {
                "exemplarCity": "Skopje"
              },
              "Sofia": {
                "exemplarCity": "Sofie"
              },
              "Stockholm": {
                "exemplarCity": "Stockholm"
              },
              "Tallinn": {
                "exemplarCity": "Tallinn"
              },
              "Tirane": {
                "exemplarCity": "Tirana"
              },
              "Ulyanovsk": {
                "exemplarCity": "Uljanovsk"
              },
              "Uzhgorod": {
                "exemplarCity": "Užhorod"
              },
              "Vaduz": {
                "exemplarCity": "Vaduz"
              },
              "Vatican": {
                "exemplarCity": "Vatikán"
              },
              "Vienna": {
                "exemplarCity": "Vídeň"
              },
              "Vilnius": {
                "exemplarCity": "Vilnius"
              },
              "Volgograd": {
                "exemplarCity": "Volgograd"
              },
              "Warsaw": {
                "exemplarCity": "Varšava"
              },
              "Zagreb": {
                "exemplarCity": "Záhřeb"
              },
              "Zaporozhye": {
                "exemplarCity": "Záporoží"
              },
              "Zurich": {
                "exemplarCity": "Curych"
              }
            },
            "Africa": {
              "Abidjan": {
                "exemplarCity": "Abidžan"
              },
              "Accra": {
                "exemplarCity": "Accra"
              },
              "Addis_Ababa": {
                "exemplarCity": "Addis Abeba"
              },
              "Algiers": {
                "exemplarCity": "Alžír"
              },
              "Asmera": {
                "exemplarCity": "Asmara"
              },
              "Bamako": {
                "exemplarCity": "Bamako"
              },
              "Bangui": {
                "exemplarCity": "Bangui"
              },
              "Banjul": {
                "exemplarCity": "Banjul"
              },
              "Bissau": {
                "exemplarCity": "Bissau"
              },
              "Blantyre": {
                "exemplarCity": "Blantyre"
              },
              "Brazzaville": {
                "exemplarCity": "Brazzaville"
              },
              "Bujumbura": {
                "exemplarCity": "Bujumbura"
              },
              "Cairo": {
                "exemplarCity": "Káhira"
              },
              "Casablanca": {
                "exemplarCity": "Casablanca"
              },
              "Ceuta": {
                "exemplarCity": "Ceuta"
              },
              "Conakry": {
                "exemplarCity": "Conakry"
              },
              "Dakar": {
                "exemplarCity": "Dakar"
              },
              "Dar_es_Salaam": {
                "exemplarCity": "Dar es Salaam"
              },
              "Djibouti": {
                "exemplarCity": "Džibuti"
              },
              "Douala": {
                "exemplarCity": "Douala"
              },
              "El_Aaiun": {
                "exemplarCity": "El Aaiun"
              },
              "Freetown": {
                "exemplarCity": "Freetown"
              },
              "Gaborone": {
                "exemplarCity": "Gaborone"
              },
              "Harare": {
                "exemplarCity": "Harare"
              },
              "Johannesburg": {
                "exemplarCity": "Johannesburg"
              },
              "Juba": {
                "exemplarCity": "Juba"
              },
              "Kampala": {
                "exemplarCity": "Kampala"
              },
              "Khartoum": {
                "exemplarCity": "Chartúm"
              },
              "Kigali": {
                "exemplarCity": "Kigali"
              },
              "Kinshasa": {
                "exemplarCity": "Kinshasa"
              },
              "Lagos": {
                "exemplarCity": "Lagos"
              },
              "Libreville": {
                "exemplarCity": "Libreville"
              },
              "Lome": {
                "exemplarCity": "Lomé"
              },
              "Luanda": {
                "exemplarCity": "Luanda"
              },
              "Lubumbashi": {
                "exemplarCity": "Lubumbashi"
              },
              "Lusaka": {
                "exemplarCity": "Lusaka"
              },
              "Malabo": {
                "exemplarCity": "Malabo"
              },
              "Maputo": {
                "exemplarCity": "Maputo"
              },
              "Maseru": {
                "exemplarCity": "Maseru"
              },
              "Mbabane": {
                "exemplarCity": "Mbabane"
              },
              "Mogadishu": {
                "exemplarCity": "Mogadišu"
              },
              "Monrovia": {
                "exemplarCity": "Monrovia"
              },
              "Nairobi": {
                "exemplarCity": "Nairobi"
              },
              "Ndjamena": {
                "exemplarCity": "Ndžamena"
              },
              "Niamey": {
                "exemplarCity": "Niamey"
              },
              "Nouakchott": {
                "exemplarCity": "Nuakšott"
              },
              "Ouagadougou": {
                "exemplarCity": "Ouagadougou"
              },
              "Porto-Novo": {
                "exemplarCity": "Porto-Novo"
              },
              "Sao_Tome": {
                "exemplarCity": "Svatý Tomáš"
              },
              "Tripoli": {
                "exemplarCity": "Tripolis"
              },
              "Tunis": {
                "exemplarCity": "Tunis"
              },
              "Windhoek": {
                "exemplarCity": "Windhoek"
              }
            },
            "Asia": {
              "Aden": {
                "exemplarCity": "Aden"
              },
              "Almaty": {
                "exemplarCity": "Almaty"
              },
              "Amman": {
                "exemplarCity": "Ammán"
              },
              "Anadyr": {
                "exemplarCity": "Anadyr"
              },
              "Aqtau": {
                "exemplarCity": "Aktau"
              },
              "Aqtobe": {
                "exemplarCity": "Aktobe"
              },
              "Ashgabat": {
                "exemplarCity": "Ašchabad"
              },
              "Atyrau": {
                "exemplarCity": "Atyrau"
              },
              "Baghdad": {
                "exemplarCity": "Bagdád"
              },
              "Bahrain": {
                "exemplarCity": "Bahrajn"
              },
              "Baku": {
                "exemplarCity": "Baku"
              },
              "Bangkok": {
                "exemplarCity": "Bangkok"
              },
              "Barnaul": {
                "exemplarCity": "Barnaul"
              },
              "Beirut": {
                "exemplarCity": "Bejrút"
              },
              "Bishkek": {
                "exemplarCity": "Biškek"
              },
              "Brunei": {
                "exemplarCity": "Brunej"
              },
              "Calcutta": {
                "exemplarCity": "Kalkata"
              },
              "Chita": {
                "exemplarCity": "Čita"
              },
              "Choibalsan": {
                "exemplarCity": "Čojbalsan"
              },
              "Colombo": {
                "exemplarCity": "Kolombo"
              },
              "Damascus": {
                "exemplarCity": "Damašek"
              },
              "Dhaka": {
                "exemplarCity": "Dháka"
              },
              "Dili": {
                "exemplarCity": "Dili"
              },
              "Dubai": {
                "exemplarCity": "Dubaj"
              },
              "Dushanbe": {
                "exemplarCity": "Dušanbe"
              },
              "Famagusta": {
                "exemplarCity": "Famagusta"
              },
              "Gaza": {
                "exemplarCity": "Gaza"
              },
              "Hebron": {
                "exemplarCity": "Hebron"
              },
              "Hong_Kong": {
                "exemplarCity": "Hongkong"
              },
              "Hovd": {
                "exemplarCity": "Hovd"
              },
              "Irkutsk": {
                "exemplarCity": "Irkutsk"
              },
              "Jakarta": {
                "exemplarCity": "Jakarta"
              },
              "Jayapura": {
                "exemplarCity": "Jayapura"
              },
              "Jerusalem": {
                "exemplarCity": "Jeruzalém"
              },
              "Kabul": {
                "exemplarCity": "Kábul"
              },
              "Kamchatka": {
                "exemplarCity": "Kamčatka"
              },
              "Karachi": {
                "exemplarCity": "Karáčí"
              },
              "Katmandu": {
                "exemplarCity": "Káthmándú"
              },
              "Khandyga": {
                "exemplarCity": "Chandyga"
              },
              "Krasnoyarsk": {
                "exemplarCity": "Krasnojarsk"
              },
              "Kuala_Lumpur": {
                "exemplarCity": "Kuala Lumpur"
              },
              "Kuching": {
                "exemplarCity": "Kučing"
              },
              "Kuwait": {
                "exemplarCity": "Kuvajt"
              },
              "Macau": {
                "exemplarCity": "Macao"
              },
              "Magadan": {
                "exemplarCity": "Magadan"
              },
              "Makassar": {
                "exemplarCity": "Makassar"
              },
              "Manila": {
                "exemplarCity": "Manila"
              },
              "Muscat": {
                "exemplarCity": "Maskat"
              },
              "Nicosia": {
                "exemplarCity": "Nikósie"
              },
              "Novokuznetsk": {
                "exemplarCity": "Novokuzněck"
              },
              "Novosibirsk": {
                "exemplarCity": "Novosibirsk"
              },
              "Omsk": {
                "exemplarCity": "Omsk"
              },
              "Oral": {
                "exemplarCity": "Uralsk"
              },
              "Phnom_Penh": {
                "exemplarCity": "Phnompenh"
              },
              "Pontianak": {
                "exemplarCity": "Pontianak"
              },
              "Pyongyang": {
                "exemplarCity": "Pchjongjang"
              },
              "Qatar": {
                "exemplarCity": "Katar"
              },
              "Qostanay": {
                "exemplarCity": "Kostanaj"
              },
              "Qyzylorda": {
                "exemplarCity": "Kyzylorda"
              },
              "Rangoon": {
                "exemplarCity": "Rangún"
              },
              "Riyadh": {
                "exemplarCity": "Rijád"
              },
              "Saigon": {
                "exemplarCity": "Ho Či Minovo město"
              },
              "Sakhalin": {
                "exemplarCity": "Sachalin"
              },
              "Samarkand": {
                "exemplarCity": "Samarkand"
              },
              "Seoul": {
                "exemplarCity": "Soul"
              },
              "Shanghai": {
                "exemplarCity": "Šanghaj"
              },
              "Singapore": {
                "exemplarCity": "Singapur"
              },
              "Srednekolymsk": {
                "exemplarCity": "Sredněkolymsk"
              },
              "Taipei": {
                "exemplarCity": "Tchaj-pej"
              },
              "Tashkent": {
                "exemplarCity": "Taškent"
              },
              "Tbilisi": {
                "exemplarCity": "Tbilisi"
              },
              "Tehran": {
                "exemplarCity": "Teherán"
              },
              "Thimphu": {
                "exemplarCity": "Thimbú"
              },
              "Tokyo": {
                "exemplarCity": "Tokio"
              },
              "Tomsk": {
                "exemplarCity": "Tomsk"
              },
              "Ulaanbaatar": {
                "exemplarCity": "Ulánbátar"
              },
              "Urumqi": {
                "exemplarCity": "Urumči"
              },
              "Ust-Nera": {
                "exemplarCity": "Ust-Nera"
              },
              "Vientiane": {
                "exemplarCity": "Vientiane"
              },
              "Vladivostok": {
                "exemplarCity": "Vladivostok"
              },
              "Yakutsk": {
                "exemplarCity": "Jakutsk"
              },
              "Yekaterinburg": {
                "exemplarCity": "Jekatěrinburg"
              },
              "Yerevan": {
                "exemplarCity": "Jerevan"
              }
            },
            "Indian": {
              "Antananarivo": {
                "exemplarCity": "Antananarivo"
              },
              "Chagos": {
                "exemplarCity": "Chagos"
              },
              "Christmas": {
                "exemplarCity": "Vánoční ostrov"
              },
              "Cocos": {
                "exemplarCity": "Kokosové ostrovy"
              },
              "Comoro": {
                "exemplarCity": "Komory"
              },
              "Kerguelen": {
                "exemplarCity": "Kerguelenovy ostrovy"
              },
              "Mahe": {
                "exemplarCity": "Mahé"
              },
              "Maldives": {
                "exemplarCity": "Maledivy"
              },
              "Mauritius": {
                "exemplarCity": "Mauricius"
              },
              "Mayotte": {
                "exemplarCity": "Mayotte"
              },
              "Reunion": {
                "exemplarCity": "Réunion"
              }
            },
            "Australia": {
              "Adelaide": {
                "exemplarCity": "Adelaide"
              },
              "Brisbane": {
                "exemplarCity": "Brisbane"
              },
              "Broken_Hill": {
                "exemplarCity": "Broken Hill"
              },
              "Currie": {
                "exemplarCity": "Currie"
              },
              "Darwin": {
                "exemplarCity": "Darwin"
              },
              "Eucla": {
                "exemplarCity": "Eucla"
              },
              "Hobart": {
                "exemplarCity": "Hobart"
              },
              "Lindeman": {
                "exemplarCity": "Lindeman"
              },
              "Lord_Howe": {
                "exemplarCity": "Lord Howe"
              },
              "Melbourne": {
                "exemplarCity": "Melbourne"
              },
              "Perth": {
                "exemplarCity": "Perth"
              },
              "Sydney": {
                "exemplarCity": "Sydney"
              }
            },
            "Pacific": {
              "Apia": {
                "exemplarCity": "Apia"
              },
              "Auckland": {
                "exemplarCity": "Auckland"
              },
              "Bougainville": {
                "exemplarCity": "Bougainville"
              },
              "Chatham": {
                "exemplarCity": "Chathamské ostrovy"
              },
              "Easter": {
                "exemplarCity": "Velikonoční ostrov"
              },
              "Efate": {
                "exemplarCity": "Éfaté"
              },
              "Enderbury": {
                "exemplarCity": "Enderbury"
              },
              "Fakaofo": {
                "exemplarCity": "Fakaofo"
              },
              "Fiji": {
                "exemplarCity": "Fidži"
              },
              "Funafuti": {
                "exemplarCity": "Funafuti"
              },
              "Galapagos": {
                "exemplarCity": "Galapágy"
              },
              "Gambier": {
                "exemplarCity": "Gambierovy ostrovy"
              },
              "Guadalcanal": {
                "exemplarCity": "Guadalcanal"
              },
              "Guam": {
                "exemplarCity": "Guam"
              },
              "Honolulu": {
                "short": {
                  "generic": "HST",
                  "standard": "HST",
                  "daylight": "HDT"
                },
                "exemplarCity": "Honolulu"
              },
              "Johnston": {
                "exemplarCity": "Johnston"
              },
              "Kiritimati": {
                "exemplarCity": "Kiritimati"
              },
              "Kosrae": {
                "exemplarCity": "Kosrae"
              },
              "Kwajalein": {
                "exemplarCity": "Kwajalein"
              },
              "Majuro": {
                "exemplarCity": "Majuro"
              },
              "Marquesas": {
                "exemplarCity": "Markézy"
              },
              "Midway": {
                "exemplarCity": "Midway"
              },
              "Nauru": {
                "exemplarCity": "Nauru"
              },
              "Niue": {
                "exemplarCity": "Niue"
              },
              "Norfolk": {
                "exemplarCity": "Norfolk"
              },
              "Noumea": {
                "exemplarCity": "Nouméa"
              },
              "Pago_Pago": {
                "exemplarCity": "Pago Pago"
              },
              "Palau": {
                "exemplarCity": "Palau"
              },
              "Pitcairn": {
                "exemplarCity": "Pitcairnovy ostrovy"
              },
              "Ponape": {
                "exemplarCity": "Pohnpei"
              },
              "Port_Moresby": {
                "exemplarCity": "Port Moresby"
              },
              "Rarotonga": {
                "exemplarCity": "Rarotonga"
              },
              "Saipan": {
                "exemplarCity": "Saipan"
              },
              "Tahiti": {
                "exemplarCity": "Tahiti"
              },
              "Tarawa": {
                "exemplarCity": "Tarawa"
              },
              "Tongatapu": {
                "exemplarCity": "Tongatapu"
              },
              "Truk": {
                "exemplarCity": "Chuukské ostrovy"
              },
              "Wake": {
                "exemplarCity": "Wake"
              },
              "Wallis": {
                "exemplarCity": "Wallis"
              }
            },
            "Arctic": {
              "Longyearbyen": {
                "exemplarCity": "Longyearbyen"
              }
            },
            "Antarctica": {
              "Casey": {
                "exemplarCity": "Casey"
              },
              "Davis": {
                "exemplarCity": "Davis"
              },
              "DumontDUrville": {
                "exemplarCity": "Dumont d’Urville"
              },
              "Macquarie": {
                "exemplarCity": "Macquarie"
              },
              "Mawson": {
                "exemplarCity": "Mawson"
              },
              "McMurdo": {
                "exemplarCity": "McMurdo"
              },
              "Palmer": {
                "exemplarCity": "Palmer"
              },
              "Rothera": {
                "exemplarCity": "Rothera"
              },
              "Syowa": {
                "exemplarCity": "Syowa"
              },
              "Troll": {
                "exemplarCity": "Troll"
              },
              "Vostok": {
                "exemplarCity": "Vostok"
              }
            },
            "Etc": {
              "UTC": {
                "long": {
                  "standard": "Koordinovaný světový čas"
                },
                "short": {
                  "standard": "UTC"
                }
              },
              "Unknown": {
                "exemplarCity": "neznámé město"
              }
            }
          },
          "metazone": {
            "Acre": {
              "long": {
                "generic": "Acrejský čas",
                "standard": "Acrejský standardní čas",
                "daylight": "Acrejský letní čas"
              }
            },
            "Afghanistan": {
              "long": {
                "standard": "Afghánský čas"
              }
            },
            "Africa_Central": {
              "long": {
                "standard": "Středoafrický čas"
              }
            },
            "Africa_Eastern": {
              "long": {
                "standard": "Východoafrický čas"
              }
            },
            "Africa_Southern": {
              "long": {
                "standard": "Jihoafrický čas"
              }
            },
            "Africa_Western": {
              "long": {
                "generic": "Západoafrický čas",
                "standard": "Západoafrický standardní čas",
                "daylight": "Západoafrický letní čas"
              }
            },
            "Alaska": {
              "long": {
                "generic": "Aljašský čas",
                "standard": "Aljašský standardní čas",
                "daylight": "Aljašský letní čas"
              },
              "short": {
                "generic": "AKT",
                "standard": "AKST",
                "daylight": "AKDT"
              }
            },
            "Almaty": {
              "long": {
                "generic": "Almatský čas",
                "standard": "Almatský standardní čas",
                "daylight": "Almatský letní čas"
              }
            },
            "Amazon": {
              "long": {
                "generic": "Amazonský čas",
                "standard": "Amazonský standardní čas",
                "daylight": "Amazonský letní čas"
              }
            },
            "America_Central": {
              "long": {
                "generic": "Severoamerický centrální čas",
                "standard": "Severoamerický centrální standardní čas",
                "daylight": "Severoamerický centrální letní čas"
              },
              "short": {
                "generic": "CT",
                "standard": "CST",
                "daylight": "CDT"
              }
            },
            "America_Eastern": {
              "long": {
                "generic": "Severoamerický východní čas",
                "standard": "Severoamerický východní standardní čas",
                "daylight": "Severoamerický východní letní čas"
              },
              "short": {
                "generic": "ET",
                "standard": "EST",
                "daylight": "EDT"
              }
            },
            "America_Mountain": {
              "long": {
                "generic": "Severoamerický horský čas",
                "standard": "Severoamerický horský standardní čas",
                "daylight": "Severoamerický horský letní čas"
              },
              "short": {
                "generic": "MT",
                "standard": "MST",
                "daylight": "MDT"
              }
            },
            "America_Pacific": {
              "long": {
                "generic": "Severoamerický pacifický čas",
                "standard": "Severoamerický pacifický standardní čas",
                "daylight": "Severoamerický pacifický letní čas"
              },
              "short": {
                "generic": "PT",
                "standard": "PST",
                "daylight": "PDT"
              }
            },
            "Anadyr": {
              "long": {
                "generic": "Anadyrský čas",
                "standard": "Anadyrský standardní čas",
                "daylight": "Anadyrský letní čas"
              }
            },
            "Apia": {
              "long": {
                "generic": "Apijský čas",
                "standard": "Apijský standardní čas",
                "daylight": "Apijský letní čas"
              }
            },
            "Aqtau": {
              "long": {
                "generic": "Aktauský čas",
                "standard": "Aktauský standardní čas",
                "daylight": "Aktauský letní čas"
              }
            },
            "Aqtobe": {
              "long": {
                "generic": "Aktobský čas",
                "standard": "Aktobský standardní čas",
                "daylight": "Aktobský letní čas"
              }
            },
            "Arabian": {
              "long": {
                "generic": "Arabský čas",
                "standard": "Arabský standardní čas",
                "daylight": "Arabský letní čas"
              }
            },
            "Argentina": {
              "long": {
                "generic": "Argentinský čas",
                "standard": "Argentinský standardní čas",
                "daylight": "Argentinský letní čas"
              }
            },
            "Argentina_Western": {
              "long": {
                "generic": "Západoargentinský čas",
                "standard": "Západoargentinský standardní čas",
                "daylight": "Západoargentinský letní čas"
              }
            },
            "Armenia": {
              "long": {
                "generic": "Arménský čas",
                "standard": "Arménský standardní čas",
                "daylight": "Arménský letní čas"
              }
            },
            "Atlantic": {
              "long": {
                "generic": "Atlantický čas",
                "standard": "Atlantický standardní čas",
                "daylight": "Atlantický letní čas"
              },
              "short": {
                "generic": "AT",
                "standard": "AST",
                "daylight": "ADT"
              }
            },
            "Australia_Central": {
              "long": {
                "generic": "Středoaustralský čas",
                "standard": "Středoaustralský standardní čas",
                "daylight": "Středoaustralský letní čas"
              }
            },
            "Australia_CentralWestern": {
              "long": {
                "generic": "Středozápadní australský čas",
                "standard": "Středozápadní australský standardní čas",
                "daylight": "Středozápadní australský letní čas"
              }
            },
            "Australia_Eastern": {
              "long": {
                "generic": "Východoaustralský čas",
                "standard": "Východoaustralský standardní čas",
                "daylight": "Východoaustralský letní čas"
              }
            },
            "Australia_Western": {
              "long": {
                "generic": "Západoaustralský čas",
                "standard": "Západoaustralský standardní čas",
                "daylight": "Západoaustralský letní čas"
              }
            },
            "Azerbaijan": {
              "long": {
                "generic": "Ázerbájdžánský čas",
                "standard": "Ázerbájdžánský standardní čas",
                "daylight": "Ázerbájdžánský letní čas"
              }
            },
            "Azores": {
              "long": {
                "generic": "Azorský čas",
                "standard": "Azorský standardní čas",
                "daylight": "Azorský letní čas"
              }
            },
            "Bangladesh": {
              "long": {
                "generic": "Bangladéšský čas",
                "standard": "Bangladéšský standardní čas",
                "daylight": "Bangladéšský letní čas"
              }
            },
            "Bhutan": {
              "long": {
                "standard": "Bhútánský čas"
              }
            },
            "Bolivia": {
              "long": {
                "standard": "Bolivijský čas"
              }
            },
            "Brasilia": {
              "long": {
                "generic": "Brasilijský čas",
                "standard": "Brasilijský standardní čas",
                "daylight": "Brasilijský letní čas"
              }
            },
            "Brunei": {
              "long": {
                "standard": "Brunejský čas"
              }
            },
            "Cape_Verde": {
              "long": {
                "generic": "Kapverdský čas",
                "standard": "Kapverdský standardní čas",
                "daylight": "Kapverdský letní čas"
              }
            },
            "Casey": {
              "long": {
                "standard": "Čas Caseyho stanice"
              }
            },
            "Chamorro": {
              "long": {
                "standard": "Chamorrský čas"
              }
            },
            "Chatham": {
              "long": {
                "generic": "Chathamský čas",
                "standard": "Chathamský standardní čas",
                "daylight": "Chathamský letní čas"
              }
            },
            "Chile": {
              "long": {
                "generic": "Chilský čas",
                "standard": "Chilský standardní čas",
                "daylight": "Chilský letní čas"
              }
            },
            "China": {
              "long": {
                "generic": "Čínský čas",
                "standard": "Čínský standardní čas",
                "daylight": "Čínský letní čas"
              }
            },
            "Choibalsan": {
              "long": {
                "generic": "Čojbalsanský čas",
                "standard": "Čojbalsanský standardní čas",
                "daylight": "Čojbalsanský letní čas"
              }
            },
            "Christmas": {
              "long": {
                "standard": "Čas Vánočního ostrova"
              }
            },
            "Cocos": {
              "long": {
                "standard": "Čas Kokosových ostrovů"
              }
            },
            "Colombia": {
              "long": {
                "generic": "Kolumbijský čas",
                "standard": "Kolumbijský standardní čas",
                "daylight": "Kolumbijský letní čas"
              }
            },
            "Cook": {
              "long": {
                "generic": "Čas Cookových ostrovů",
                "standard": "Standardní čas Cookových ostrovů",
                "daylight": "Letní čas Cookových ostrovů"
              }
            },
            "Cuba": {
              "long": {
                "generic": "Kubánský čas",
                "standard": "Kubánský standardní čas",
                "daylight": "Kubánský letní čas"
              }
            },
            "Davis": {
              "long": {
                "standard": "Čas Davisovy stanice"
              }
            },
            "DumontDUrville": {
              "long": {
                "standard": "Čas stanice Dumonta d’Urvilla"
              }
            },
            "East_Timor": {
              "long": {
                "standard": "Východotimorský čas"
              }
            },
            "Easter": {
              "long": {
                "generic": "Čas Velikonočního ostrova",
                "standard": "Standardní čas Velikonočního ostrova",
                "daylight": "Letní čas Velikonočního ostrova"
              }
            },
            "Ecuador": {
              "long": {
                "standard": "Ekvádorský čas"
              }
            },
            "Europe_Central": {
              "long": {
                "generic": "Středoevropský čas",
                "standard": "Středoevropský standardní čas",
                "daylight": "Středoevropský letní čas"
              },
              "short": {
                "generic": "SEČ",
                "standard": "SEČ",
                "daylight": "SELČ"
              }
            },
            "Europe_Eastern": {
              "long": {
                "generic": "Východoevropský čas",
                "standard": "Východoevropský standardní čas",
                "daylight": "Východoevropský letní čas"
              }
            },
            "Europe_Further_Eastern": {
              "long": {
                "standard": "Dálněvýchodoevropský čas"
              }
            },
            "Europe_Western": {
              "long": {
                "generic": "Západoevropský čas",
                "standard": "Západoevropský standardní čas",
                "daylight": "Západoevropský letní čas"
              }
            },
            "Falkland": {
              "long": {
                "generic": "Falklandský čas",
                "standard": "Falklandský standardní čas",
                "daylight": "Falklandský letní čas"
              }
            },
            "Fiji": {
              "long": {
                "generic": "Fidžijský čas",
                "standard": "Fidžijský standardní čas",
                "daylight": "Fidžijský letní čas"
              }
            },
            "French_Guiana": {
              "long": {
                "standard": "Francouzskoguyanský čas"
              }
            },
            "French_Southern": {
              "long": {
                "standard": "Čas Francouzských jižních a antarktických území"
              }
            },
            "Galapagos": {
              "long": {
                "standard": "Galapážský čas"
              }
            },
            "Gambier": {
              "long": {
                "standard": "Gambierský čas"
              }
            },
            "Georgia": {
              "long": {
                "generic": "Gruzínský čas",
                "standard": "Gruzínský standardní čas",
                "daylight": "Gruzínský letní čas"
              }
            },
            "Gilbert_Islands": {
              "long": {
                "standard": "Čas Gilbertových ostrovů"
              }
            },
            "GMT": {
              "long": {
                "standard": "Greenwichský střední čas"
              }
            },
            "Greenland_Eastern": {
              "long": {
                "generic": "Východogrónský čas",
                "standard": "Východogrónský standardní čas",
                "daylight": "Východogrónský letní čas"
              }
            },
            "Greenland_Western": {
              "long": {
                "generic": "Západogrónský čas",
                "standard": "Západogrónský standardní čas",
                "daylight": "Západogrónský letní čas"
              }
            },
            "Guam": {
              "long": {
                "standard": "Guamský čas"
              }
            },
            "Gulf": {
              "long": {
                "standard": "Standardní čas Perského zálivu"
              }
            },
            "Guyana": {
              "long": {
                "standard": "Guyanský čas"
              }
            },
            "Hawaii_Aleutian": {
              "long": {
                "generic": "Havajsko-aleutský čas",
                "standard": "Havajsko-aleutský standardní čas",
                "daylight": "Havajsko-aleutský letní čas"
              }
            },
            "Hong_Kong": {
              "long": {
                "generic": "Hongkongský čas",
                "standard": "Hongkongský standardní čas",
                "daylight": "Hongkongský letní čas"
              }
            },
            "Hovd": {
              "long": {
                "generic": "Hovdský čas",
                "standard": "Hovdský standardní čas",
                "daylight": "Hovdský letní čas"
              }
            },
            "India": {
              "long": {
                "standard": "Indický čas"
              }
            },
            "Indian_Ocean": {
              "long": {
                "standard": "Indickooceánský čas"
              }
            },
            "Indochina": {
              "long": {
                "standard": "Indočínský čas"
              }
            },
            "Indonesia_Central": {
              "long": {
                "standard": "Středoindonéský čas"
              }
            },
            "Indonesia_Eastern": {
              "long": {
                "standard": "Východoindonéský čas"
              }
            },
            "Indonesia_Western": {
              "long": {
                "standard": "Západoindonéský čas"
              }
            },
            "Iran": {
              "long": {
                "generic": "Íránský čas",
                "standard": "Íránský standardní čas",
                "daylight": "Íránský letní čas"
              }
            },
            "Irkutsk": {
              "long": {
                "generic": "Irkutský čas",
                "standard": "Irkutský standardní čas",
                "daylight": "Irkutský letní čas"
              }
            },
            "Israel": {
              "long": {
                "generic": "Izraelský čas",
                "standard": "Izraelský standardní čas",
                "daylight": "Izraelský letní čas"
              }
            },
            "Japan": {
              "long": {
                "generic": "Japonský čas",
                "standard": "Japonský standardní čas",
                "daylight": "Japonský letní čas"
              }
            },
            "Kamchatka": {
              "long": {
                "generic": "Petropavlovsko-kamčatský čas",
                "standard": "Petropavlovsko-kamčatský standardní čas",
                "daylight": "Petropavlovsko-kamčatský letní čas"
              }
            },
            "Kazakhstan_Eastern": {
              "long": {
                "standard": "Východokazachstánský čas"
              }
            },
            "Kazakhstan_Western": {
              "long": {
                "standard": "Západokazachstánský čas"
              }
            },
            "Korea": {
              "long": {
                "generic": "Korejský čas",
                "standard": "Korejský standardní čas",
                "daylight": "Korejský letní čas"
              }
            },
            "Kosrae": {
              "long": {
                "standard": "Kosrajský čas"
              }
            },
            "Krasnoyarsk": {
              "long": {
                "generic": "Krasnojarský čas",
                "standard": "Krasnojarský standardní čas",
                "daylight": "Krasnojarský letní čas"
              }
            },
            "Kyrgystan": {
              "long": {
                "standard": "Kyrgyzský čas"
              }
            },
            "Lanka": {
              "long": {
                "standard": "Srílanský čas"
              }
            },
            "Line_Islands": {
              "long": {
                "standard": "Čas Rovníkových ostrovů"
              }
            },
            "Lord_Howe": {
              "long": {
                "generic": "Čas ostrova lorda Howa",
                "standard": "Standardní čas ostrova lorda Howa",
                "daylight": "Letní čas ostrova lorda Howa"
              }
            },
            "Macau": {
              "long": {
                "generic": "Macajský čas",
                "standard": "Macajský standardní čas",
                "daylight": "Macajský letní čas"
              }
            },
            "Macquarie": {
              "long": {
                "standard": "Čas ostrova Macquarie"
              }
            },
            "Magadan": {
              "long": {
                "generic": "Magadanský čas",
                "standard": "Magadanský standardní čas",
                "daylight": "Magadanský letní čas"
              }
            },
            "Malaysia": {
              "long": {
                "standard": "Malajský čas"
              }
            },
            "Maldives": {
              "long": {
                "standard": "Maledivský čas"
              }
            },
            "Marquesas": {
              "long": {
                "standard": "Markézský čas"
              }
            },
            "Marshall_Islands": {
              "long": {
                "standard": "Čas Marshallových ostrovů"
              }
            },
            "Mauritius": {
              "long": {
                "generic": "Mauricijský čas",
                "standard": "Mauricijský standardní čas",
                "daylight": "Mauricijský letní čas"
              }
            },
            "Mawson": {
              "long": {
                "standard": "Čas Mawsonovy stanice"
              }
            },
            "Mexico_Northwest": {
              "long": {
                "generic": "Severozápadní mexický čas",
                "standard": "Severozápadní mexický standardní čas",
                "daylight": "Severozápadní mexický letní čas"
              }
            },
            "Mexico_Pacific": {
              "long": {
                "generic": "Mexický pacifický čas",
                "standard": "Mexický pacifický standardní čas",
                "daylight": "Mexický pacifický letní čas"
              }
            },
            "Mongolia": {
              "long": {
                "generic": "Ulánbátarský čas",
                "standard": "Ulánbátarský standardní čas",
                "daylight": "Ulánbátarský letní čas"
              }
            },
            "Moscow": {
              "long": {
                "generic": "Moskevský čas",
                "standard": "Moskevský standardní čas",
                "daylight": "Moskevský letní čas"
              }
            },
            "Myanmar": {
              "long": {
                "standard": "Myanmarský čas"
              }
            },
            "Nauru": {
              "long": {
                "standard": "Naurský čas"
              }
            },
            "Nepal": {
              "long": {
                "standard": "Nepálský čas"
              }
            },
            "New_Caledonia": {
              "long": {
                "generic": "Novokaledonský čas",
                "standard": "Novokaledonský standardní čas",
                "daylight": "Novokaledonský letní čas"
              }
            },
            "New_Zealand": {
              "long": {
                "generic": "Novozélandský čas",
                "standard": "Novozélandský standardní čas",
                "daylight": "Novozélandský letní čas"
              }
            },
            "Newfoundland": {
              "long": {
                "generic": "Newfoundlandský čas",
                "standard": "Newfoundlandský standardní čas",
                "daylight": "Newfoundlandský letní čas"
              }
            },
            "Niue": {
              "long": {
                "standard": "Niuejský čas"
              }
            },
            "Norfolk": {
              "long": {
                "standard": "Norfolský čas"
              }
            },
            "Noronha": {
              "long": {
                "generic": "Čas souostroví Fernando de Noronha",
                "standard": "Standardní čas souostroví Fernando de Noronha",
                "daylight": "Letní čas souostroví Fernando de Noronha"
              }
            },
            "North_Mariana": {
              "long": {
                "standard": "Severomariánský čas"
              }
            },
            "Novosibirsk": {
              "long": {
                "generic": "Novosibirský čas",
                "standard": "Novosibirský standardní čas",
                "daylight": "Novosibirský letní čas"
              }
            },
            "Omsk": {
              "long": {
                "generic": "Omský čas",
                "standard": "Omský standardní čas",
                "daylight": "Omský letní čas"
              }
            },
            "Pakistan": {
              "long": {
                "generic": "Pákistánský čas",
                "standard": "Pákistánský standardní čas",
                "daylight": "Pákistánský letní čas"
              }
            },
            "Palau": {
              "long": {
                "standard": "Palauský čas"
              }
            },
            "Papua_New_Guinea": {
              "long": {
                "standard": "Čas Papuy-Nové Guiney"
              }
            },
            "Paraguay": {
              "long": {
                "generic": "Paraguayský čas",
                "standard": "Paraguayský standardní čas",
                "daylight": "Paraguayský letní čas"
              }
            },
            "Peru": {
              "long": {
                "generic": "Peruánský čas",
                "standard": "Peruánský standardní čas",
                "daylight": "Peruánský letní čas"
              }
            },
            "Philippines": {
              "long": {
                "generic": "Filipínský čas",
                "standard": "Filipínský standardní čas",
                "daylight": "Filipínský letní čas"
              }
            },
            "Phoenix_Islands": {
              "long": {
                "standard": "Čas Fénixových ostrovů"
              }
            },
            "Pierre_Miquelon": {
              "long": {
                "generic": "Pierre-miquelonský čas",
                "standard": "Pierre-miquelonský standardní čas",
                "daylight": "Pierre-miquelonský letní čas"
              }
            },
            "Pitcairn": {
              "long": {
                "standard": "Čas Pitcairnova ostrova"
              }
            },
            "Ponape": {
              "long": {
                "standard": "Ponapský čas"
              }
            },
            "Pyongyang": {
              "long": {
                "standard": "Pchjongjangský čas"
              }
            },
            "Qyzylorda": {
              "long": {
                "generic": "Kyzylordský čas",
                "standard": "Kyzylordský standardní čas",
                "daylight": "Kyzylordský letní čas"
              }
            },
            "Reunion": {
              "long": {
                "standard": "Réunionský čas"
              }
            },
            "Rothera": {
              "long": {
                "standard": "Čas Rotherovy stanice"
              }
            },
            "Sakhalin": {
              "long": {
                "generic": "Sachalinský čas",
                "standard": "Sachalinský standardní čas",
                "daylight": "Sachalinský letní čas"
              }
            },
            "Samara": {
              "long": {
                "generic": "Samarský čas",
                "standard": "Samarský standardní čas",
                "daylight": "Samarský letní čas"
              }
            },
            "Samoa": {
              "long": {
                "generic": "Samojský čas",
                "standard": "Samojský standardní čas",
                "daylight": "Samojský letní čas"
              }
            },
            "Seychelles": {
              "long": {
                "standard": "Seychelský čas"
              }
            },
            "Singapore": {
              "long": {
                "standard": "Singapurský čas"
              }
            },
            "Solomon": {
              "long": {
                "standard": "Čas Šalamounových ostrovů"
              }
            },
            "South_Georgia": {
              "long": {
                "standard": "Čas Jižní Georgie"
              }
            },
            "Suriname": {
              "long": {
                "standard": "Surinamský čas"
              }
            },
            "Syowa": {
              "long": {
                "standard": "Čas stanice Šówa"
              }
            },
            "Tahiti": {
              "long": {
                "standard": "Tahitský čas"
              }
            },
            "Taipei": {
              "long": {
                "generic": "Tchajpejský čas",
                "standard": "Tchajpejský standardní čas",
                "daylight": "Tchajpejský letní čas"
              }
            },
            "Tajikistan": {
              "long": {
                "standard": "Tádžický čas"
              }
            },
            "Tokelau": {
              "long": {
                "standard": "Tokelauský čas"
              }
            },
            "Tonga": {
              "long": {
                "generic": "Tonžský čas",
                "standard": "Tonžský standardní čas",
                "daylight": "Tonžský letní čas"
              }
            },
            "Truk": {
              "long": {
                "standard": "Chuukský čas"
              }
            },
            "Turkmenistan": {
              "long": {
                "generic": "Turkmenský čas",
                "standard": "Turkmenský standardní čas",
                "daylight": "Turkmenský letní čas"
              }
            },
            "Tuvalu": {
              "long": {
                "standard": "Tuvalský čas"
              }
            },
            "Uruguay": {
              "long": {
                "generic": "Uruguayský čas",
                "standard": "Uruguayský standardní čas",
                "daylight": "Uruguayský letní čas"
              }
            },
            "Uzbekistan": {
              "long": {
                "generic": "Uzbecký čas",
                "standard": "Uzbecký standardní čas",
                "daylight": "Uzbecký letní čas"
              }
            },
            "Vanuatu": {
              "long": {
                "generic": "Vanuatský čas",
                "standard": "Vanuatský standardní čas",
                "daylight": "Vanuatský letní čas"
              }
            },
            "Venezuela": {
              "long": {
                "standard": "Venezuelský čas"
              }
            },
            "Vladivostok": {
              "long": {
                "generic": "Vladivostocký čas",
                "standard": "Vladivostocký standardní čas",
                "daylight": "Vladivostocký letní čas"
              }
            },
            "Volgograd": {
              "long": {
                "generic": "Volgogradský čas",
                "standard": "Volgogradský standardní čas",
                "daylight": "Volgogradský letní čas"
              }
            },
            "Vostok": {
              "long": {
                "standard": "Čas stanice Vostok"
              }
            },
            "Wake": {
              "long": {
                "standard": "Čas ostrova Wake"
              }
            },
            "Wallis": {
              "long": {
                "standard": "Čas ostrovů Wallis a Futuna"
              }
            },
            "Yakutsk": {
              "long": {
                "generic": "Jakutský čas",
                "standard": "Jakutský standardní čas",
                "daylight": "Jakutský letní čas"
              }
            },
            "Yekaterinburg": {
              "long": {
                "generic": "Jekatěrinburský čas",
                "standard": "Jekatěrinburský standardní čas",
                "daylight": "Jekatěrinburský letní čas"
              }
            }
          }
        }
      }
    }
  }
}, {
  "main": {
    "cs": {
      "identity": {
        "version": {
          "_number": "$Revision: 14844 $",
          "_cldrVersion": "35.1"
        },
        "language": "cs"
      },
      "units": {
        "long": {
          "per": {
            "compoundUnitPattern": "{0}/{1}"
          },
          "acceleration-g-force": {
            "displayName": "gravitační síla",
            "unitPattern-count-one": "{0} G",
            "unitPattern-count-few": "{0} G",
            "unitPattern-count-many": "{0} G",
            "unitPattern-count-other": "{0} G"
          },
          "acceleration-meter-per-second-squared": {
            "displayName": "metr za sekundu na druhou",
            "unitPattern-count-one": "{0} metr za sekundu na druhou",
            "unitPattern-count-few": "{0} metry za sekundu na druhou",
            "unitPattern-count-many": "{0} metru za sekundu na druhou",
            "unitPattern-count-other": "{0} metrů za sekundu na druhou"
          },
          "angle-revolution": {
            "displayName": "otáčky",
            "unitPattern-count-one": "{0} otáčka",
            "unitPattern-count-few": "{0} otáčky",
            "unitPattern-count-many": "{0} otáčky",
            "unitPattern-count-other": "{0} otáček"
          },
          "angle-radian": {
            "displayName": "radiány",
            "unitPattern-count-one": "{0} radián",
            "unitPattern-count-few": "{0} radiány",
            "unitPattern-count-many": "{0} radiánu",
            "unitPattern-count-other": "{0} radiánů"
          },
          "angle-degree": {
            "displayName": "stupně",
            "unitPattern-count-one": "{0} stupeň",
            "unitPattern-count-few": "{0} stupně",
            "unitPattern-count-many": "{0} stupně",
            "unitPattern-count-other": "{0} stupňů"
          },
          "angle-arc-minute": {
            "displayName": "minuty",
            "unitPattern-count-one": "{0} minuta",
            "unitPattern-count-few": "{0} minuty",
            "unitPattern-count-many": "{0} minuty",
            "unitPattern-count-other": "{0} minut"
          },
          "angle-arc-second": {
            "displayName": "vteřiny",
            "unitPattern-count-one": "{0} vteřina",
            "unitPattern-count-few": "{0} vteřiny",
            "unitPattern-count-many": "{0} vteřiny",
            "unitPattern-count-other": "{0} vteřin"
          },
          "area-square-kilometer": {
            "displayName": "kilometry čtvereční",
            "unitPattern-count-one": "{0} kilometr čtvereční",
            "unitPattern-count-few": "{0} kilometry čtvereční",
            "unitPattern-count-many": "{0} kilometru čtverečního",
            "unitPattern-count-other": "{0} kilometrů čtverečních",
            "perUnitPattern": "{0} na kilometr čtvereční"
          },
          "area-hectare": {
            "displayName": "hektary",
            "unitPattern-count-one": "{0} hektar",
            "unitPattern-count-few": "{0} hektary",
            "unitPattern-count-many": "{0} hektaru",
            "unitPattern-count-other": "{0} hektarů"
          },
          "area-square-meter": {
            "displayName": "metry čtvereční",
            "unitPattern-count-one": "{0} metr čtvereční",
            "unitPattern-count-few": "{0} metry čtvereční",
            "unitPattern-count-many": "{0} metru čtverečního",
            "unitPattern-count-other": "{0} metrů čtverečních",
            "perUnitPattern": "{0} na metr čtvereční"
          },
          "area-square-centimeter": {
            "displayName": "centimetry čtvereční",
            "unitPattern-count-one": "{0} centimetr čtvereční",
            "unitPattern-count-few": "{0} centimetry čtvereční",
            "unitPattern-count-many": "{0} centimetru čtverečního",
            "unitPattern-count-other": "{0} centimetrů čtverečních",
            "perUnitPattern": "{0} na centimetr čtvereční"
          },
          "area-square-mile": {
            "displayName": "míle čtvereční",
            "unitPattern-count-one": "{0} míle čtvereční",
            "unitPattern-count-few": "{0} míle čtvereční",
            "unitPattern-count-many": "{0} míle čtvereční",
            "unitPattern-count-other": "{0} mil čtverečních",
            "perUnitPattern": "{0} na míli čtvereční"
          },
          "area-acre": {
            "displayName": "akry",
            "unitPattern-count-one": "{0} akr",
            "unitPattern-count-few": "{0} akry",
            "unitPattern-count-many": "{0} akru",
            "unitPattern-count-other": "{0} akrů"
          },
          "area-square-yard": {
            "displayName": "yardy čtvereční",
            "unitPattern-count-one": "{0} yard čtvereční",
            "unitPattern-count-few": "{0} yardy čtvereční",
            "unitPattern-count-many": "{0} yardu čtverečního",
            "unitPattern-count-other": "{0} yardů čtverečních"
          },
          "area-square-foot": {
            "displayName": "stopy čtvereční",
            "unitPattern-count-one": "{0} stopa čtvereční",
            "unitPattern-count-few": "{0} stopy čtvereční",
            "unitPattern-count-many": "{0} stopy čtvereční",
            "unitPattern-count-other": "{0} stop čtverečních"
          },
          "area-square-inch": {
            "displayName": "palce čtvereční",
            "unitPattern-count-one": "{0} palec čtvereční",
            "unitPattern-count-few": "{0} palce čtvereční",
            "unitPattern-count-many": "{0} palce čtverečního",
            "unitPattern-count-other": "{0} palců čtverečních",
            "perUnitPattern": "{0} na palec čtvereční"
          },
          "area-dunam": {
            "displayName": "dunamy",
            "unitPattern-count-one": "{0} dunam",
            "unitPattern-count-few": "{0} dunamy",
            "unitPattern-count-many": "{0} dunamu",
            "unitPattern-count-other": "{0} dunamů"
          },
          "concentr-karat": {
            "displayName": "karáty",
            "unitPattern-count-one": "{0} karát",
            "unitPattern-count-few": "{0} karáty",
            "unitPattern-count-many": "{0} karátu",
            "unitPattern-count-other": "{0} karátů"
          },
          "concentr-milligram-per-deciliter": {
            "displayName": "miligramy na decilitr",
            "unitPattern-count-one": "{0} miligram na decilitr",
            "unitPattern-count-few": "{0} miligramy na decilitr",
            "unitPattern-count-many": "{0} miligramu na decilitr",
            "unitPattern-count-other": "{0} miligramů na decilitr"
          },
          "concentr-millimole-per-liter": {
            "displayName": "milimoly na litr",
            "unitPattern-count-one": "{0} milimol na litr",
            "unitPattern-count-few": "{0} milimoly na litr",
            "unitPattern-count-many": "{0} milimolu na litr",
            "unitPattern-count-other": "{0} milimolů na litr"
          },
          "concentr-part-per-million": {
            "displayName": "díly z milionu",
            "unitPattern-count-one": "{0} díl z milionu",
            "unitPattern-count-few": "{0} díly z milionu",
            "unitPattern-count-many": "{0} dílu z milionu",
            "unitPattern-count-other": "{0} dílů z milionu"
          },
          "concentr-percent": {
            "displayName": "procenta",
            "unitPattern-count-one": "{0} procento",
            "unitPattern-count-few": "{0} procenta",
            "unitPattern-count-many": "{0} procenta",
            "unitPattern-count-other": "{0} procent"
          },
          "concentr-permille": {
            "displayName": "promile",
            "unitPattern-count-one": "{0} promile",
            "unitPattern-count-few": "{0} promile",
            "unitPattern-count-many": "{0} promile",
            "unitPattern-count-other": "{0} promile"
          },
          "concentr-permyriad": {
            "displayName": "desetiny promile",
            "unitPattern-count-one": "{0} desetina promile",
            "unitPattern-count-few": "{0} desetiny promile",
            "unitPattern-count-many": "{0} desetiny promile",
            "unitPattern-count-other": "{0} desetin promile"
          },
          "concentr-mole": {
            "displayName": "moly",
            "unitPattern-count-one": "{0} mol",
            "unitPattern-count-few": "{0} moly",
            "unitPattern-count-many": "{0} molu",
            "unitPattern-count-other": "{0} molů"
          },
          "consumption-liter-per-kilometer": {
            "displayName": "litry na kilometr",
            "unitPattern-count-one": "{0} litr na kilometr",
            "unitPattern-count-few": "{0} litry na kilometr",
            "unitPattern-count-many": "{0} litru na kilometr",
            "unitPattern-count-other": "{0} litrů na kilometr"
          },
          "consumption-liter-per-100kilometers": {
            "displayName": "litry na sto kilometrů",
            "unitPattern-count-one": "{0} litr na sto kilometrů",
            "unitPattern-count-few": "{0} litry na sto kilometrů",
            "unitPattern-count-many": "{0} litru na sto kilometrů",
            "unitPattern-count-other": "{0} litrů na sto kilometrů"
          },
          "consumption-mile-per-gallon": {
            "displayName": "míle na galon",
            "unitPattern-count-one": "{0} míle na galon",
            "unitPattern-count-few": "{0} míle na galon",
            "unitPattern-count-many": "{0} míle na galon",
            "unitPattern-count-other": "{0} mil na galon"
          },
          "consumption-mile-per-gallon-imperial": {
            "displayName": "míle na imp. galon",
            "unitPattern-count-one": "{0} míle na imp. galon",
            "unitPattern-count-few": "{0} míle na imp. galon",
            "unitPattern-count-many": "{0} míle na imp. galon",
            "unitPattern-count-other": "{0} mil na imp. galon"
          },
          "digital-petabyte": {
            "displayName": "petabajty",
            "unitPattern-count-one": "{0} petabajt",
            "unitPattern-count-few": "{0} petabajty",
            "unitPattern-count-many": "{0} petabajtu",
            "unitPattern-count-other": "{0} petabajtů"
          },
          "digital-terabyte": {
            "displayName": "terabajty",
            "unitPattern-count-one": "{0} terabajt",
            "unitPattern-count-few": "{0} terabajty",
            "unitPattern-count-many": "{0} terabajtu",
            "unitPattern-count-other": "{0} terabajtů"
          },
          "digital-terabit": {
            "displayName": "terabity",
            "unitPattern-count-one": "{0} terabit",
            "unitPattern-count-few": "{0} terabity",
            "unitPattern-count-many": "{0} terabitu",
            "unitPattern-count-other": "{0} terabitů"
          },
          "digital-gigabyte": {
            "displayName": "gigabajty",
            "unitPattern-count-one": "{0} gigabajt",
            "unitPattern-count-few": "{0} gigabajty",
            "unitPattern-count-many": "{0} gigabajtu",
            "unitPattern-count-other": "{0} gigabajtů"
          },
          "digital-gigabit": {
            "displayName": "gigabity",
            "unitPattern-count-one": "{0} gigabit",
            "unitPattern-count-few": "{0} gigabity",
            "unitPattern-count-many": "{0} gigabitu",
            "unitPattern-count-other": "{0} gigabitů"
          },
          "digital-megabyte": {
            "displayName": "megabajty",
            "unitPattern-count-one": "{0} megabajt",
            "unitPattern-count-few": "{0} megabajty",
            "unitPattern-count-many": "{0} megabajtu",
            "unitPattern-count-other": "{0} megabajtů"
          },
          "digital-megabit": {
            "displayName": "megabity",
            "unitPattern-count-one": "{0} megabit",
            "unitPattern-count-few": "{0} megabity",
            "unitPattern-count-many": "{0} megabitu",
            "unitPattern-count-other": "{0} megabitů"
          },
          "digital-kilobyte": {
            "displayName": "kilobajty",
            "unitPattern-count-one": "{0} kilobajt",
            "unitPattern-count-few": "{0} kilobajty",
            "unitPattern-count-many": "{0} kilobajtu",
            "unitPattern-count-other": "{0} kilobajtů"
          },
          "digital-kilobit": {
            "displayName": "kilobity",
            "unitPattern-count-one": "{0} kilobit",
            "unitPattern-count-few": "{0} kilobity",
            "unitPattern-count-many": "{0} kilobitu",
            "unitPattern-count-other": "{0} kilobitů"
          },
          "digital-byte": {
            "displayName": "bajty",
            "unitPattern-count-one": "{0} bajt",
            "unitPattern-count-few": "{0} bajty",
            "unitPattern-count-many": "{0} bajtu",
            "unitPattern-count-other": "{0} bajtů"
          },
          "digital-bit": {
            "displayName": "bity",
            "unitPattern-count-one": "{0} bit",
            "unitPattern-count-few": "{0} bity",
            "unitPattern-count-many": "{0} bitu",
            "unitPattern-count-other": "{0} bitů"
          },
          "duration-century": {
            "displayName": "století",
            "unitPattern-count-one": "{0} století",
            "unitPattern-count-few": "{0} století",
            "unitPattern-count-many": "{0} století",
            "unitPattern-count-other": "{0} století"
          },
          "duration-year": {
            "displayName": "roky",
            "unitPattern-count-one": "{0} rok",
            "unitPattern-count-few": "{0} roky",
            "unitPattern-count-many": "{0} roku",
            "unitPattern-count-other": "{0} let",
            "perUnitPattern": "{0} za rok"
          },
          "duration-month": {
            "displayName": "měsíce",
            "unitPattern-count-one": "{0} měsíc",
            "unitPattern-count-few": "{0} měsíce",
            "unitPattern-count-many": "{0} měsíce",
            "unitPattern-count-other": "{0} měsíců",
            "perUnitPattern": "{0} za měsíc"
          },
          "duration-week": {
            "displayName": "týdny",
            "unitPattern-count-one": "{0} týden",
            "unitPattern-count-few": "{0} týdny",
            "unitPattern-count-many": "{0} týdne",
            "unitPattern-count-other": "{0} týdnů",
            "perUnitPattern": "{0} za týden"
          },
          "duration-day": {
            "displayName": "dny",
            "unitPattern-count-one": "{0} den",
            "unitPattern-count-few": "{0} dny",
            "unitPattern-count-many": "{0} dne",
            "unitPattern-count-other": "{0} dní",
            "perUnitPattern": "{0} za den"
          },
          "duration-hour": {
            "displayName": "hodiny",
            "unitPattern-count-one": "{0} hodina",
            "unitPattern-count-few": "{0} hodiny",
            "unitPattern-count-many": "{0} hodiny",
            "unitPattern-count-other": "{0} hodin",
            "perUnitPattern": "{0} za hodinu"
          },
          "duration-minute": {
            "displayName": "minuty",
            "unitPattern-count-one": "{0} minuta",
            "unitPattern-count-few": "{0} minuty",
            "unitPattern-count-many": "{0} minuty",
            "unitPattern-count-other": "{0} minut",
            "perUnitPattern": "{0} za minutu"
          },
          "duration-second": {
            "displayName": "sekundy",
            "unitPattern-count-one": "{0} sekunda",
            "unitPattern-count-few": "{0} sekundy",
            "unitPattern-count-many": "{0} sekundy",
            "unitPattern-count-other": "{0} sekund",
            "perUnitPattern": "{0} za sekundu"
          },
          "duration-millisecond": {
            "displayName": "milisekundy",
            "unitPattern-count-one": "{0} milisekunda",
            "unitPattern-count-few": "{0} milisekundy",
            "unitPattern-count-many": "{0} milisekundy",
            "unitPattern-count-other": "{0} milisekund"
          },
          "duration-microsecond": {
            "displayName": "mikrosekundy",
            "unitPattern-count-one": "{0} mikrosekunda",
            "unitPattern-count-few": "{0} mikrosekundy",
            "unitPattern-count-many": "{0} mikrosekundy",
            "unitPattern-count-other": "{0} mikrosekund"
          },
          "duration-nanosecond": {
            "displayName": "nanosekundy",
            "unitPattern-count-one": "{0} nanosekunda",
            "unitPattern-count-few": "{0} nanosekundy",
            "unitPattern-count-many": "{0} nanosekundy",
            "unitPattern-count-other": "{0} nanosekund"
          },
          "electric-ampere": {
            "displayName": "ampéry",
            "unitPattern-count-one": "{0} ampér",
            "unitPattern-count-few": "{0} ampéry",
            "unitPattern-count-many": "{0} ampéru",
            "unitPattern-count-other": "{0} ampérů"
          },
          "electric-milliampere": {
            "displayName": "miliampéry",
            "unitPattern-count-one": "{0} miliampér",
            "unitPattern-count-few": "{0} miliampéry",
            "unitPattern-count-many": "{0} miliampéru",
            "unitPattern-count-other": "{0} miliampérů"
          },
          "electric-ohm": {
            "displayName": "ohmy",
            "unitPattern-count-one": "{0} ohm",
            "unitPattern-count-few": "{0} ohmy",
            "unitPattern-count-many": "{0} ohmu",
            "unitPattern-count-other": "{0} ohmů"
          },
          "electric-volt": {
            "displayName": "volty",
            "unitPattern-count-one": "{0} volt",
            "unitPattern-count-few": "{0} volty",
            "unitPattern-count-many": "{0} voltu",
            "unitPattern-count-other": "{0} voltů"
          },
          "energy-kilocalorie": {
            "displayName": "kilokalorie",
            "unitPattern-count-one": "{0} kilokalorie",
            "unitPattern-count-few": "{0} kilokalorie",
            "unitPattern-count-many": "{0} kilokalorie",
            "unitPattern-count-other": "{0} kilokalorií"
          },
          "energy-calorie": {
            "displayName": "kalorie",
            "unitPattern-count-one": "{0} kalorie",
            "unitPattern-count-few": "{0} kalorie",
            "unitPattern-count-many": "{0} kalorie",
            "unitPattern-count-other": "{0} kalorií"
          },
          "energy-foodcalorie": {
            "displayName": "kilokalorie",
            "unitPattern-count-one": "{0} kilokalorie",
            "unitPattern-count-few": "{0} kilokalorie",
            "unitPattern-count-many": "{0} kilokalorie",
            "unitPattern-count-other": "{0} kilokalorií"
          },
          "energy-kilojoule": {
            "displayName": "kilojouly",
            "unitPattern-count-one": "{0} kilojoule",
            "unitPattern-count-few": "{0} kilojouly",
            "unitPattern-count-many": "{0} kilojoulu",
            "unitPattern-count-other": "{0} kilojoulů"
          },
          "energy-joule": {
            "displayName": "jouly",
            "unitPattern-count-one": "{0} joule",
            "unitPattern-count-few": "{0} jouly",
            "unitPattern-count-many": "{0} joulu",
            "unitPattern-count-other": "{0} joulů"
          },
          "energy-kilowatt-hour": {
            "displayName": "kilowatthodiny",
            "unitPattern-count-one": "{0} kilowatthodina",
            "unitPattern-count-few": "{0} kilowatthodiny",
            "unitPattern-count-many": "{0} kilowatthodiny",
            "unitPattern-count-other": "{0} kilowatthodin"
          },
          "energy-electronvolt": {
            "displayName": "elektronvolty",
            "unitPattern-count-one": "{0} elektronvolt",
            "unitPattern-count-few": "{0} elektronvolty",
            "unitPattern-count-many": "{0} elektronvoltu",
            "unitPattern-count-other": "{0} elektronvoltů"
          },
          "energy-british-thermal-unit": {
            "displayName": "britské tepelné jednotky",
            "unitPattern-count-one": "{0} britská tepelná jednotka",
            "unitPattern-count-few": "{0} britské tepelné jednotky",
            "unitPattern-count-many": "{0} britské tepelné jednotky",
            "unitPattern-count-other": "{0} britských tepelných jednotek"
          },
          "force-pound-force": {
            "displayName": "libry síly",
            "unitPattern-count-one": "{0} libra síly",
            "unitPattern-count-few": "{0} libry síly",
            "unitPattern-count-many": "{0} libry síly",
            "unitPattern-count-other": "{0} liber síly"
          },
          "force-newton": {
            "displayName": "newtony",
            "unitPattern-count-one": "{0} newton",
            "unitPattern-count-few": "{0} newtony",
            "unitPattern-count-many": "{0} newtonu",
            "unitPattern-count-other": "{0} newtonů"
          },
          "frequency-gigahertz": {
            "displayName": "gigahertzy",
            "unitPattern-count-one": "{0} gigahertz",
            "unitPattern-count-few": "{0} gigahertzy",
            "unitPattern-count-many": "{0} gigahertzu",
            "unitPattern-count-other": "{0} gigahertzů"
          },
          "frequency-megahertz": {
            "displayName": "megahertzy",
            "unitPattern-count-one": "{0} megahertz",
            "unitPattern-count-few": "{0} megahertzy",
            "unitPattern-count-many": "{0} megahertzu",
            "unitPattern-count-other": "{0} megahertzů"
          },
          "frequency-kilohertz": {
            "displayName": "kilohertzy",
            "unitPattern-count-one": "{0} kilohertz",
            "unitPattern-count-few": "{0} kilohertzy",
            "unitPattern-count-many": "{0} kilohertzu",
            "unitPattern-count-other": "{0} kilohertzů"
          },
          "frequency-hertz": {
            "displayName": "hertzy",
            "unitPattern-count-one": "{0} hertz",
            "unitPattern-count-few": "{0} hertzy",
            "unitPattern-count-many": "{0} hertzu",
            "unitPattern-count-other": "{0} hertzů"
          },
          "length-kilometer": {
            "displayName": "kilometry",
            "unitPattern-count-one": "{0} kilometr",
            "unitPattern-count-few": "{0} kilometry",
            "unitPattern-count-many": "{0} kilometru",
            "unitPattern-count-other": "{0} kilometrů",
            "perUnitPattern": "{0} na kilometr"
          },
          "length-meter": {
            "displayName": "metry",
            "unitPattern-count-one": "{0} metr",
            "unitPattern-count-few": "{0} metry",
            "unitPattern-count-many": "{0} metru",
            "unitPattern-count-other": "{0} metrů",
            "perUnitPattern": "{0} na metr"
          },
          "length-decimeter": {
            "displayName": "decimetry",
            "unitPattern-count-one": "{0} decimetr",
            "unitPattern-count-few": "{0} decimetry",
            "unitPattern-count-many": "{0} decimetru",
            "unitPattern-count-other": "{0} decimetrů"
          },
          "length-centimeter": {
            "displayName": "centimetry",
            "unitPattern-count-one": "{0} centimetr",
            "unitPattern-count-few": "{0} centimetry",
            "unitPattern-count-many": "{0} centimetru",
            "unitPattern-count-other": "{0} centimetrů",
            "perUnitPattern": "{0} na centimetr"
          },
          "length-millimeter": {
            "displayName": "milimetry",
            "unitPattern-count-one": "{0} milimetr",
            "unitPattern-count-few": "{0} milimetry",
            "unitPattern-count-many": "{0} milimetru",
            "unitPattern-count-other": "{0} milimetrů"
          },
          "length-micrometer": {
            "displayName": "mikrometry",
            "unitPattern-count-one": "{0} mikrometr",
            "unitPattern-count-few": "{0} mikrometry",
            "unitPattern-count-many": "{0} mikrometru",
            "unitPattern-count-other": "{0} mikrometrů"
          },
          "length-nanometer": {
            "displayName": "nanometry",
            "unitPattern-count-one": "{0} nanometr",
            "unitPattern-count-few": "{0} nanometry",
            "unitPattern-count-many": "{0} nanometru",
            "unitPattern-count-other": "{0} nanometrů"
          },
          "length-picometer": {
            "displayName": "pikometry",
            "unitPattern-count-one": "{0} pikometr",
            "unitPattern-count-few": "{0} pikometry",
            "unitPattern-count-many": "{0} pikometru",
            "unitPattern-count-other": "{0} pikometrů"
          },
          "length-mile": {
            "displayName": "míle",
            "unitPattern-count-one": "{0} míle",
            "unitPattern-count-few": "{0} míle",
            "unitPattern-count-many": "{0} míle",
            "unitPattern-count-other": "{0} mil"
          },
          "length-yard": {
            "displayName": "yardy",
            "unitPattern-count-one": "{0} yard",
            "unitPattern-count-few": "{0} yardy",
            "unitPattern-count-many": "{0} yardu",
            "unitPattern-count-other": "{0} yardů"
          },
          "length-foot": {
            "displayName": "stopy",
            "unitPattern-count-one": "{0} stopa",
            "unitPattern-count-few": "{0} stopy",
            "unitPattern-count-many": "{0} stopy",
            "unitPattern-count-other": "{0} stop",
            "perUnitPattern": "{0} na stopu"
          },
          "length-inch": {
            "displayName": "palce",
            "unitPattern-count-one": "{0} palec",
            "unitPattern-count-few": "{0} palce",
            "unitPattern-count-many": "{0} palce",
            "unitPattern-count-other": "{0} palců",
            "perUnitPattern": "{0} na palec"
          },
          "length-parsec": {
            "displayName": "parseky",
            "unitPattern-count-one": "{0} parsek",
            "unitPattern-count-few": "{0} parseky",
            "unitPattern-count-many": "{0} parseku",
            "unitPattern-count-other": "{0} parseků"
          },
          "length-light-year": {
            "displayName": "světelné roky",
            "unitPattern-count-one": "{0} světelný rok",
            "unitPattern-count-few": "{0} světelné roky",
            "unitPattern-count-many": "{0} světelného roku",
            "unitPattern-count-other": "{0} světelných let"
          },
          "length-astronomical-unit": {
            "displayName": "astronomické jednotky",
            "unitPattern-count-one": "{0} astronomická jednotka",
            "unitPattern-count-few": "{0} astronomické jednotky",
            "unitPattern-count-many": "{0} astronomické jednotky",
            "unitPattern-count-other": "{0} astronomických jednotek"
          },
          "length-furlong": {
            "displayName": "furlongy",
            "unitPattern-count-one": "{0} furlong",
            "unitPattern-count-few": "{0} furlongy",
            "unitPattern-count-many": "{0} furlongu",
            "unitPattern-count-other": "{0} furlongů"
          },
          "length-fathom": {
            "displayName": "fathomy",
            "unitPattern-count-one": "{0} fathom",
            "unitPattern-count-few": "{0} fathomy",
            "unitPattern-count-many": "{0} fathomu",
            "unitPattern-count-other": "{0} fathomů"
          },
          "length-nautical-mile": {
            "displayName": "námořní míle",
            "unitPattern-count-one": "{0} námořní míle",
            "unitPattern-count-few": "{0} námořní míle",
            "unitPattern-count-many": "{0} námořní míle",
            "unitPattern-count-other": "{0} námořních mil"
          },
          "length-mile-scandinavian": {
            "displayName": "skandinávské míle",
            "unitPattern-count-one": "{0} skandinávská míle",
            "unitPattern-count-few": "{0} skandinávské míle",
            "unitPattern-count-many": "{0} skandinávské míle",
            "unitPattern-count-other": "{0} skandinávských mil"
          },
          "length-point": {
            "displayName": "body",
            "unitPattern-count-one": "{0} bod",
            "unitPattern-count-few": "{0} body",
            "unitPattern-count-many": "{0} bodu",
            "unitPattern-count-other": "{0} bodů"
          },
          "length-solar-radius": {
            "displayName": "poloměr Slunce",
            "unitPattern-count-one": "{0} poloměr Slunce",
            "unitPattern-count-few": "{0} poloměry Slunce",
            "unitPattern-count-many": "{0} poloměru Slunce",
            "unitPattern-count-other": "{0} poloměrů Slunce"
          },
          "light-lux": {
            "displayName": "luxy",
            "unitPattern-count-one": "{0} lux",
            "unitPattern-count-few": "{0} luxy",
            "unitPattern-count-many": "{0} luxu",
            "unitPattern-count-other": "{0} luxů"
          },
          "light-solar-luminosity": {
            "displayName": "zářivé výkony Sllunce",
            "unitPattern-count-one": "{0} zářivý výkon Slunce",
            "unitPattern-count-few": "{0} zářivé výkony Slunce",
            "unitPattern-count-many": "{0} zářivého výkonu Slunce",
            "unitPattern-count-other": "{0} zářivých výkonů Slunce"
          },
          "mass-metric-ton": {
            "displayName": "metrické tuny",
            "unitPattern-count-one": "{0} metrická tuna",
            "unitPattern-count-few": "{0} metrické tuny",
            "unitPattern-count-many": "{0} metrické tuny",
            "unitPattern-count-other": "{0} metrických tun"
          },
          "mass-kilogram": {
            "displayName": "kilogramy",
            "unitPattern-count-one": "{0} kilogram",
            "unitPattern-count-few": "{0} kilogramy",
            "unitPattern-count-many": "{0} kilogramu",
            "unitPattern-count-other": "{0} kilogramů",
            "perUnitPattern": "{0} na kilogram"
          },
          "mass-gram": {
            "displayName": "gramy",
            "unitPattern-count-one": "{0} gram",
            "unitPattern-count-few": "{0} gramy",
            "unitPattern-count-many": "{0} gramu",
            "unitPattern-count-other": "{0} gramů",
            "perUnitPattern": "{0} na gram"
          },
          "mass-milligram": {
            "displayName": "miligramy",
            "unitPattern-count-one": "{0} miligram",
            "unitPattern-count-few": "{0} miligramy",
            "unitPattern-count-many": "{0} miligramu",
            "unitPattern-count-other": "{0} miligramů"
          },
          "mass-microgram": {
            "displayName": "mikrogramy",
            "unitPattern-count-one": "{0} mikrogram",
            "unitPattern-count-few": "{0} mikrogramy",
            "unitPattern-count-many": "{0} mikrogramu",
            "unitPattern-count-other": "{0} mikrogramů"
          },
          "mass-ton": {
            "displayName": "tuny",
            "unitPattern-count-one": "{0} tuna",
            "unitPattern-count-few": "{0} tuny",
            "unitPattern-count-many": "{0} tuny",
            "unitPattern-count-other": "{0} tun"
          },
          "mass-stone": {
            "displayName": "kameny",
            "unitPattern-count-one": "{0} kámen",
            "unitPattern-count-few": "{0} kameny",
            "unitPattern-count-many": "{0} kamene",
            "unitPattern-count-other": "{0} kamenů"
          },
          "mass-pound": {
            "displayName": "libra",
            "unitPattern-count-one": "{0} libra",
            "unitPattern-count-few": "{0} libry",
            "unitPattern-count-many": "{0} libry",
            "unitPattern-count-other": "{0} liber",
            "perUnitPattern": "{0} na libru"
          },
          "mass-ounce": {
            "displayName": "unce",
            "unitPattern-count-one": "{0} unce",
            "unitPattern-count-few": "{0} unce",
            "unitPattern-count-many": "{0} unce",
            "unitPattern-count-other": "{0} uncí",
            "perUnitPattern": "{0} na unci"
          },
          "mass-ounce-troy": {
            "displayName": "trojské unce",
            "unitPattern-count-one": "{0} trojská unce",
            "unitPattern-count-few": "{0} trojské unce",
            "unitPattern-count-many": "{0} trojské unce",
            "unitPattern-count-other": "{0} trojských uncí"
          },
          "mass-carat": {
            "displayName": "karáty",
            "unitPattern-count-one": "{0} karát",
            "unitPattern-count-few": "{0} karáty",
            "unitPattern-count-many": "{0} karátu",
            "unitPattern-count-other": "{0} karátů"
          },
          "mass-dalton": {
            "displayName": "daltony",
            "unitPattern-count-one": "{0} dalton",
            "unitPattern-count-few": "{0} daltony",
            "unitPattern-count-many": "{0} daltonu",
            "unitPattern-count-other": "{0} daltonů"
          },
          "mass-earth-mass": {
            "displayName": "hmotnosti Země",
            "unitPattern-count-one": "{0} hmotnost Země",
            "unitPattern-count-few": "{0} hmotnosti Země",
            "unitPattern-count-many": "{0} hmotnosti Země",
            "unitPattern-count-other": "{0} hmotností Země"
          },
          "mass-solar-mass": {
            "displayName": "hmotnosti Slunce",
            "unitPattern-count-one": "{0} hmotnost Slunce",
            "unitPattern-count-few": "{0} hmotnosti Slunce",
            "unitPattern-count-many": "{0} hmotnosti Slunce",
            "unitPattern-count-other": "{0} hmotností Slunce"
          },
          "power-gigawatt": {
            "displayName": "gigawatty",
            "unitPattern-count-one": "{0} gigawatt",
            "unitPattern-count-few": "{0} gigawatty",
            "unitPattern-count-many": "{0} gigawattu",
            "unitPattern-count-other": "{0} gigawattů"
          },
          "power-megawatt": {
            "displayName": "megawatty",
            "unitPattern-count-one": "{0} megawatt",
            "unitPattern-count-few": "{0} megawatty",
            "unitPattern-count-many": "{0} megawattu",
            "unitPattern-count-other": "{0} megawattů"
          },
          "power-kilowatt": {
            "displayName": "kilowatty",
            "unitPattern-count-one": "{0} kilowatt",
            "unitPattern-count-few": "{0} kilowatty",
            "unitPattern-count-many": "{0} kilowattu",
            "unitPattern-count-other": "{0} kilowattů"
          },
          "power-watt": {
            "displayName": "watty",
            "unitPattern-count-one": "{0} watt",
            "unitPattern-count-few": "{0} watty",
            "unitPattern-count-many": "{0} wattu",
            "unitPattern-count-other": "{0} wattů"
          },
          "power-milliwatt": {
            "displayName": "miliwatty",
            "unitPattern-count-one": "{0} miliwatt",
            "unitPattern-count-few": "{0} miliwatty",
            "unitPattern-count-many": "{0} miliwattu",
            "unitPattern-count-other": "{0} miliwattů"
          },
          "power-horsepower": {
            "displayName": "koňská síla",
            "unitPattern-count-one": "{0} koňská síla",
            "unitPattern-count-few": "{0} koňské síly",
            "unitPattern-count-many": "{0} koňské síly",
            "unitPattern-count-other": "{0} koňských sil"
          },
          "pressure-hectopascal": {
            "displayName": "hektopascaly",
            "unitPattern-count-one": "{0} hektopascal",
            "unitPattern-count-few": "{0} hektopascaly",
            "unitPattern-count-many": "{0} hektopascalu",
            "unitPattern-count-other": "{0} hektopascalů"
          },
          "pressure-millimeter-of-mercury": {
            "displayName": "milimetry rtuti",
            "unitPattern-count-one": "{0} milimetr rtuti",
            "unitPattern-count-few": "{0} milimetry rtuti",
            "unitPattern-count-many": "{0} milimetru rtuti",
            "unitPattern-count-other": "{0} milimetrů rtuti"
          },
          "pressure-pound-per-square-inch": {
            "displayName": "libry na čtvereční palec",
            "unitPattern-count-one": "{0} libra na čtvereční palec",
            "unitPattern-count-few": "{0} libry na čtvereční palec",
            "unitPattern-count-many": "{0} libry na čtvereční palec",
            "unitPattern-count-other": "{0} psi"
          },
          "pressure-inch-hg": {
            "displayName": "palce rtuti",
            "unitPattern-count-one": "{0} palec rtuti",
            "unitPattern-count-few": "{0} palce rtuti",
            "unitPattern-count-many": "{0} palce rtuti",
            "unitPattern-count-other": "{0} palců rtuti"
          },
          "pressure-millibar": {
            "displayName": "milibary",
            "unitPattern-count-one": "{0} milibar",
            "unitPattern-count-few": "{0} milibary",
            "unitPattern-count-many": "{0} milibaru",
            "unitPattern-count-other": "{0} milibarů"
          },
          "pressure-atmosphere": {
            "displayName": "atmosféry",
            "unitPattern-count-one": "{0} atmosféra",
            "unitPattern-count-few": "{0} atmosféry",
            "unitPattern-count-many": "{0} atmosféry",
            "unitPattern-count-other": "{0} atmosfér"
          },
          "pressure-kilopascal": {
            "displayName": "kilopascaly",
            "unitPattern-count-one": "{0} kilopascal",
            "unitPattern-count-few": "{0} kilopascaly",
            "unitPattern-count-many": "{0} kilopascalu",
            "unitPattern-count-other": "{0} kilopascalů"
          },
          "pressure-megapascal": {
            "displayName": "megapascaly",
            "unitPattern-count-one": "{0} megapascal",
            "unitPattern-count-few": "{0} megapascaly",
            "unitPattern-count-many": "{0} megapascalu",
            "unitPattern-count-other": "{0} megapascalů"
          },
          "speed-kilometer-per-hour": {
            "displayName": "kilometry za hodinu",
            "unitPattern-count-one": "{0} kilometr za hodinu",
            "unitPattern-count-few": "{0} kilometry za hodinu",
            "unitPattern-count-many": "{0} kilometru za hodinu",
            "unitPattern-count-other": "{0} kilometrů za hodinu"
          },
          "speed-meter-per-second": {
            "displayName": "metry za sekundu",
            "unitPattern-count-one": "{0} metr za sekundu",
            "unitPattern-count-few": "{0} metry za sekundu",
            "unitPattern-count-many": "{0} metru za sekundu",
            "unitPattern-count-other": "{0} metrů za sekundu"
          },
          "speed-mile-per-hour": {
            "displayName": "míle za hodinu",
            "unitPattern-count-one": "{0} míle za hodinu",
            "unitPattern-count-few": "{0} míle za hodinu",
            "unitPattern-count-many": "{0} míle za hodinu",
            "unitPattern-count-other": "{0} mil za hodinu"
          },
          "speed-knot": {
            "displayName": "uzly",
            "unitPattern-count-one": "{0} uzel",
            "unitPattern-count-few": "{0} uzly",
            "unitPattern-count-many": "{0} uzlu",
            "unitPattern-count-other": "{0} uzlů"
          },
          "temperature-generic": {
            "displayName": "stupně",
            "unitPattern-count-one": "{0} stupeň",
            "unitPattern-count-few": "{0} stupně",
            "unitPattern-count-many": "{0} stupně",
            "unitPattern-count-other": "{0} stupňů"
          },
          "temperature-celsius": {
            "displayName": "stupně Celsia",
            "unitPattern-count-one": "{0} stupeň Celsia",
            "unitPattern-count-few": "{0} stupně Celsia",
            "unitPattern-count-many": "{0} stupně Celsia",
            "unitPattern-count-other": "{0} stupňů Celsia"
          },
          "temperature-fahrenheit": {
            "displayName": "stupně Fahrenheita",
            "unitPattern-count-one": "{0} stupeň Fahrenheita",
            "unitPattern-count-few": "{0} stupně Fahrenheita",
            "unitPattern-count-many": "{0} stupně Fahrenheita",
            "unitPattern-count-other": "{0} stupňů Fahrenheita"
          },
          "temperature-kelvin": {
            "displayName": "kelviny",
            "unitPattern-count-one": "{0} kelvin",
            "unitPattern-count-few": "{0} kelviny",
            "unitPattern-count-many": "{0} kelvinu",
            "unitPattern-count-other": "{0} kelvinů"
          },
          "torque-pound-foot": {
            "displayName": "librostopy",
            "unitPattern-count-one": "{0} librostopa",
            "unitPattern-count-few": "{0} librostopy",
            "unitPattern-count-many": "{0} librostopy",
            "unitPattern-count-other": "{0} librostop"
          },
          "torque-newton-meter": {
            "displayName": "newtonmetry",
            "unitPattern-count-one": "{0} newtonmetr",
            "unitPattern-count-few": "{0} newtonmetry",
            "unitPattern-count-many": "{0} newtonmetru",
            "unitPattern-count-other": "{0} newtonmetrů"
          },
          "volume-cubic-kilometer": {
            "displayName": "kilometry krychlové",
            "unitPattern-count-one": "{0} kilometr krychlový",
            "unitPattern-count-few": "{0} kilometry krychlové",
            "unitPattern-count-many": "{0} kilometru krychlového",
            "unitPattern-count-other": "{0} kilometrů krychlových"
          },
          "volume-cubic-meter": {
            "displayName": "metry krychlové",
            "unitPattern-count-one": "{0} metr krychlový",
            "unitPattern-count-few": "{0} metry krychlové",
            "unitPattern-count-many": "{0} metru krychlového",
            "unitPattern-count-other": "{0} metrů krychlových",
            "perUnitPattern": "{0} na metr krychlový"
          },
          "volume-cubic-centimeter": {
            "displayName": "centimetry krychlové",
            "unitPattern-count-one": "{0} centimetr krychlový",
            "unitPattern-count-few": "{0} centimetry krychlové",
            "unitPattern-count-many": "{0} centimetru krychlového",
            "unitPattern-count-other": "{0} centimetrů krychlových",
            "perUnitPattern": "{0} na centimetr krychlový"
          },
          "volume-cubic-mile": {
            "displayName": "míle krychlové",
            "unitPattern-count-one": "{0} míle krychlová",
            "unitPattern-count-few": "{0} míle krychlové",
            "unitPattern-count-many": "{0} míle krychlové",
            "unitPattern-count-other": "{0} mil krychlových"
          },
          "volume-cubic-yard": {
            "displayName": "yardy krychlové",
            "unitPattern-count-one": "{0} yard krychlový",
            "unitPattern-count-few": "{0} yardy krychlové",
            "unitPattern-count-many": "{0} yardu krychlového",
            "unitPattern-count-other": "{0} yardů krychlových"
          },
          "volume-cubic-foot": {
            "displayName": "stopy krychlové",
            "unitPattern-count-one": "{0} stopa krychlová",
            "unitPattern-count-few": "{0} stopy krychlové",
            "unitPattern-count-many": "{0} stopy krychlové",
            "unitPattern-count-other": "{0} stop krychlových"
          },
          "volume-cubic-inch": {
            "displayName": "palce krychlové",
            "unitPattern-count-one": "{0} palec krychlový",
            "unitPattern-count-few": "{0} palce krychlové",
            "unitPattern-count-many": "{0} palce krychlového",
            "unitPattern-count-other": "{0} palců krychlových"
          },
          "volume-megaliter": {
            "displayName": "megalitry",
            "unitPattern-count-one": "{0} megalitr",
            "unitPattern-count-few": "{0} megalitry",
            "unitPattern-count-many": "{0} megalitru",
            "unitPattern-count-other": "{0} megalitrů"
          },
          "volume-hectoliter": {
            "displayName": "hektolitr",
            "unitPattern-count-one": "{0} hektolitr",
            "unitPattern-count-few": "{0} hektolitry",
            "unitPattern-count-many": "{0} hektolitru",
            "unitPattern-count-other": "{0} hektolitrů"
          },
          "volume-liter": {
            "displayName": "litry",
            "unitPattern-count-one": "{0} litr",
            "unitPattern-count-few": "{0} litry",
            "unitPattern-count-many": "{0} litru",
            "unitPattern-count-other": "{0} litrů",
            "perUnitPattern": "{0} na litr"
          },
          "volume-deciliter": {
            "displayName": "decilitry",
            "unitPattern-count-one": "{0} decilitr",
            "unitPattern-count-few": "{0} decilitry",
            "unitPattern-count-many": "{0} decilitru",
            "unitPattern-count-other": "{0} decilitrů"
          },
          "volume-centiliter": {
            "displayName": "centilitry",
            "unitPattern-count-one": "{0} centilitr",
            "unitPattern-count-few": "{0} centilitry",
            "unitPattern-count-many": "{0} centilitru",
            "unitPattern-count-other": "{0} centilitrů"
          },
          "volume-milliliter": {
            "displayName": "mililitry",
            "unitPattern-count-one": "{0} mililitr",
            "unitPattern-count-few": "{0} mililitry",
            "unitPattern-count-many": "{0} mililitru",
            "unitPattern-count-other": "{0} mililitrů"
          },
          "volume-pint-metric": {
            "displayName": "metrické pinty",
            "unitPattern-count-one": "{0} metrická pinta",
            "unitPattern-count-few": "{0} metrické pinty",
            "unitPattern-count-many": "{0} metrické pinty",
            "unitPattern-count-other": "{0} metrických pint"
          },
          "volume-cup-metric": {
            "displayName": "metrické šálky",
            "unitPattern-count-one": "{0} metrický šálek",
            "unitPattern-count-few": "{0} metrické šálky",
            "unitPattern-count-many": "{0} metrického šálku",
            "unitPattern-count-other": "{0} metrických šálků"
          },
          "volume-acre-foot": {
            "displayName": "akro-stopy",
            "unitPattern-count-one": "{0} akro-stopa",
            "unitPattern-count-few": "{0} akro-stopy",
            "unitPattern-count-many": "{0} akro-stopy",
            "unitPattern-count-other": "{0} akro-stop"
          },
          "volume-bushel": {
            "displayName": "bušly",
            "unitPattern-count-one": "{0} bušl",
            "unitPattern-count-few": "{0} bušly",
            "unitPattern-count-many": "{0} bušlu",
            "unitPattern-count-other": "{0} bušlů"
          },
          "volume-gallon": {
            "displayName": "galony",
            "unitPattern-count-one": "{0} galon",
            "unitPattern-count-few": "{0} galony",
            "unitPattern-count-many": "{0} galonu",
            "unitPattern-count-other": "{0} galonů",
            "perUnitPattern": "{0} na galon"
          },
          "volume-gallon-imperial": {
            "displayName": "imp. galony",
            "unitPattern-count-one": "{0} imp. galon",
            "unitPattern-count-few": "{0} imp. galony",
            "unitPattern-count-many": "{0} imp. galonu",
            "unitPattern-count-other": "{0} imp. galonů",
            "perUnitPattern": "{0} na imp. galon"
          },
          "volume-quart": {
            "displayName": "kvarty",
            "unitPattern-count-one": "{0} kvart",
            "unitPattern-count-few": "{0} kvarty",
            "unitPattern-count-many": "{0} kvartu",
            "unitPattern-count-other": "{0} kvartů"
          },
          "volume-pint": {
            "displayName": "pinty",
            "unitPattern-count-one": "{0} pinta",
            "unitPattern-count-few": "{0} pinty",
            "unitPattern-count-many": "{0} pinty",
            "unitPattern-count-other": "{0} pint"
          },
          "volume-cup": {
            "displayName": "šálek",
            "unitPattern-count-one": "{0} šálek",
            "unitPattern-count-few": "{0} šálky",
            "unitPattern-count-many": "{0} šálku",
            "unitPattern-count-other": "{0} šálků"
          },
          "volume-fluid-ounce": {
            "displayName": "kapalinové unce",
            "unitPattern-count-one": "{0} kapalinová unce",
            "unitPattern-count-few": "{0} kapalinové unce",
            "unitPattern-count-many": "{0} kapalinové unce",
            "unitPattern-count-other": "{0} kapalinových uncí"
          },
          "volume-fluid-ounce-imperial": {
            "displayName": "britské duté unce",
            "unitPattern-count-one": "{0} britská dutá unce",
            "unitPattern-count-few": "{0} britské duté unce",
            "unitPattern-count-many": "{0} britské duté unce",
            "unitPattern-count-other": "{0} britských dutých uncí"
          },
          "volume-tablespoon": {
            "displayName": "lžíce",
            "unitPattern-count-one": "{0} lžíce",
            "unitPattern-count-few": "{0} lžíce",
            "unitPattern-count-many": "{0} lžíce",
            "unitPattern-count-other": "{0} lžic"
          },
          "volume-teaspoon": {
            "displayName": "lžička",
            "unitPattern-count-one": "{0} lžička",
            "unitPattern-count-few": "{0} lžičky",
            "unitPattern-count-many": "{0} lžičky",
            "unitPattern-count-other": "{0} lžiček"
          },
          "volume-barrel": {
            "displayName": "barely",
            "unitPattern-count-one": "{0} barel",
            "unitPattern-count-few": "{0} barely",
            "unitPattern-count-many": "{0} barelu",
            "unitPattern-count-other": "{0} barelů"
          },
          "coordinateUnit": {
            "displayName": "světová strana",
            "east": "{0} východní délky",
            "north": "{0} severní šířky",
            "south": "{0} jižní šířky",
            "west": "{0} západní délky"
          }
        },
        "short": {
          "per": {
            "compoundUnitPattern": "{0}/{1}"
          },
          "acceleration-g-force": {
            "displayName": "G",
            "unitPattern-count-one": "{0} G",
            "unitPattern-count-few": "{0} G",
            "unitPattern-count-many": "{0} G",
            "unitPattern-count-other": "{0} G"
          },
          "acceleration-meter-per-second-squared": {
            "displayName": "m/s²",
            "unitPattern-count-one": "{0} m/s²",
            "unitPattern-count-few": "{0} m/s²",
            "unitPattern-count-many": "{0} m/s²",
            "unitPattern-count-other": "{0} m/s²"
          },
          "angle-revolution": {
            "displayName": "ot.",
            "unitPattern-count-one": "{0} ot.",
            "unitPattern-count-few": "{0} ot.",
            "unitPattern-count-many": "{0} ot.",
            "unitPattern-count-other": "{0} ot."
          },
          "angle-radian": {
            "displayName": "rad",
            "unitPattern-count-one": "{0} rad",
            "unitPattern-count-few": "{0} rad",
            "unitPattern-count-many": "{0} rad",
            "unitPattern-count-other": "{0} rad"
          },
          "angle-degree": {
            "displayName": "°",
            "unitPattern-count-one": "{0}°",
            "unitPattern-count-few": "{0}°",
            "unitPattern-count-many": "{0}°",
            "unitPattern-count-other": "{0}°"
          },
          "angle-arc-minute": {
            "displayName": "′",
            "unitPattern-count-one": "{0}′",
            "unitPattern-count-few": "{0}′",
            "unitPattern-count-many": "{0}′",
            "unitPattern-count-other": "{0}′"
          },
          "angle-arc-second": {
            "displayName": "″",
            "unitPattern-count-one": "{0}″",
            "unitPattern-count-few": "{0}″",
            "unitPattern-count-many": "{0}″",
            "unitPattern-count-other": "{0}″"
          },
          "area-square-kilometer": {
            "displayName": "km²",
            "unitPattern-count-one": "{0} km²",
            "unitPattern-count-few": "{0} km²",
            "unitPattern-count-many": "{0} km²",
            "unitPattern-count-other": "{0} km²",
            "perUnitPattern": "{0}/km²"
          },
          "area-hectare": {
            "displayName": "ha",
            "unitPattern-count-one": "{0} ha",
            "unitPattern-count-few": "{0} ha",
            "unitPattern-count-many": "{0} ha",
            "unitPattern-count-other": "{0} ha"
          },
          "area-square-meter": {
            "displayName": "m²",
            "unitPattern-count-one": "{0} m²",
            "unitPattern-count-few": "{0} m²",
            "unitPattern-count-many": "{0} m²",
            "unitPattern-count-other": "{0} m²",
            "perUnitPattern": "{0}/m²"
          },
          "area-square-centimeter": {
            "displayName": "cm²",
            "unitPattern-count-one": "{0} cm²",
            "unitPattern-count-few": "{0} cm²",
            "unitPattern-count-many": "{0} cm²",
            "unitPattern-count-other": "{0} cm²",
            "perUnitPattern": "{0}/cm²"
          },
          "area-square-mile": {
            "displayName": "mi²",
            "unitPattern-count-one": "{0} mi²",
            "unitPattern-count-few": "{0} mi²",
            "unitPattern-count-many": "{0} mi²",
            "unitPattern-count-other": "{0} mi²",
            "perUnitPattern": "{0}/mi²"
          },
          "area-acre": {
            "displayName": "ac",
            "unitPattern-count-one": "{0} ac",
            "unitPattern-count-few": "{0} ac",
            "unitPattern-count-many": "{0} ac",
            "unitPattern-count-other": "{0} ac"
          },
          "area-square-yard": {
            "displayName": "yd²",
            "unitPattern-count-one": "{0} yd²",
            "unitPattern-count-few": "{0} yd²",
            "unitPattern-count-many": "{0} yd²",
            "unitPattern-count-other": "{0} yd²"
          },
          "area-square-foot": {
            "displayName": "ft²",
            "unitPattern-count-one": "{0} ft²",
            "unitPattern-count-few": "{0} ft²",
            "unitPattern-count-many": "{0} ft²",
            "unitPattern-count-other": "{0} ft²"
          },
          "area-square-inch": {
            "displayName": "in²",
            "unitPattern-count-one": "{0} in²",
            "unitPattern-count-few": "{0} in²",
            "unitPattern-count-many": "{0} in²",
            "unitPattern-count-other": "{0} in²",
            "perUnitPattern": "{0}/in²"
          },
          "area-dunam": {
            "displayName": "dun.",
            "unitPattern-count-one": "{0} dun.",
            "unitPattern-count-few": "{0} dun.",
            "unitPattern-count-many": "{0} dun.",
            "unitPattern-count-other": "{0} dun."
          },
          "concentr-karat": {
            "displayName": "kt",
            "unitPattern-count-one": "{0} kt",
            "unitPattern-count-few": "{0} kt",
            "unitPattern-count-many": "{0} kt",
            "unitPattern-count-other": "{0} kt"
          },
          "concentr-milligram-per-deciliter": {
            "displayName": "mg/dl",
            "unitPattern-count-one": "{0} mg/dl",
            "unitPattern-count-few": "{0} mg/dl",
            "unitPattern-count-many": "{0} mg/dl",
            "unitPattern-count-other": "{0} mg/dl"
          },
          "concentr-millimole-per-liter": {
            "displayName": "mmol/l",
            "unitPattern-count-one": "{0} mmol/l",
            "unitPattern-count-few": "{0} mmol/l",
            "unitPattern-count-many": "{0} mmol/l",
            "unitPattern-count-other": "{0} mmol/l"
          },
          "concentr-part-per-million": {
            "displayName": "ppm",
            "unitPattern-count-one": "{0} ppm",
            "unitPattern-count-few": "{0} ppm",
            "unitPattern-count-many": "{0} ppm",
            "unitPattern-count-other": "{0} ppm"
          },
          "concentr-percent": {
            "displayName": "%",
            "unitPattern-count-one": "{0} %",
            "unitPattern-count-few": "{0} %",
            "unitPattern-count-many": "{0} %",
            "unitPattern-count-other": "{0} %"
          },
          "concentr-permille": {
            "displayName": "‰",
            "unitPattern-count-one": "{0} ‰",
            "unitPattern-count-few": "{0} ‰",
            "unitPattern-count-many": "{0} ‰",
            "unitPattern-count-other": "{0} ‰"
          },
          "concentr-permyriad": {
            "displayName": "‱",
            "unitPattern-count-one": "{0} ‱",
            "unitPattern-count-few": "{0} ‱",
            "unitPattern-count-many": "{0} ‱",
            "unitPattern-count-other": "{0} ‱"
          },
          "concentr-mole": {
            "displayName": "mol",
            "unitPattern-count-one": "{0} mol",
            "unitPattern-count-few": "{0} mol",
            "unitPattern-count-many": "{0} mol",
            "unitPattern-count-other": "{0} mol"
          },
          "consumption-liter-per-kilometer": {
            "displayName": "l/km",
            "unitPattern-count-one": "{0} l/km",
            "unitPattern-count-few": "{0} l/km",
            "unitPattern-count-many": "{0} l/km",
            "unitPattern-count-other": "{0} l/km"
          },
          "consumption-liter-per-100kilometers": {
            "displayName": "l/100 km",
            "unitPattern-count-one": "{0} l/100 km",
            "unitPattern-count-few": "{0} l/100 km",
            "unitPattern-count-many": "{0} l/100 km",
            "unitPattern-count-other": "{0} l/100 km"
          },
          "consumption-mile-per-gallon": {
            "displayName": "mpg",
            "unitPattern-count-one": "{0} mpg",
            "unitPattern-count-few": "{0} mpg",
            "unitPattern-count-many": "{0} mpg",
            "unitPattern-count-other": "{0} mpg"
          },
          "consumption-mile-per-gallon-imperial": {
            "displayName": "mpg Imp.",
            "unitPattern-count-one": "{0} mpg Imp.",
            "unitPattern-count-few": "{0} mpg Imp.",
            "unitPattern-count-many": "{0} mpg Imp.",
            "unitPattern-count-other": "{0} mpg Imp."
          },
          "digital-petabyte": {
            "displayName": "PB",
            "unitPattern-count-one": "{0} PB",
            "unitPattern-count-few": "{0} PB",
            "unitPattern-count-many": "{0} PB",
            "unitPattern-count-other": "{0} PB"
          },
          "digital-terabyte": {
            "displayName": "TB",
            "unitPattern-count-one": "{0} TB",
            "unitPattern-count-few": "{0} TB",
            "unitPattern-count-many": "{0} TB",
            "unitPattern-count-other": "{0} TB"
          },
          "digital-terabit": {
            "displayName": "Tb",
            "unitPattern-count-one": "{0} Tb",
            "unitPattern-count-few": "{0} Tb",
            "unitPattern-count-many": "{0} Tb",
            "unitPattern-count-other": "{0} Tb"
          },
          "digital-gigabyte": {
            "displayName": "GB",
            "unitPattern-count-one": "{0} GB",
            "unitPattern-count-few": "{0} GB",
            "unitPattern-count-many": "{0} GB",
            "unitPattern-count-other": "{0} GB"
          },
          "digital-gigabit": {
            "displayName": "Gb",
            "unitPattern-count-one": "{0} Gb",
            "unitPattern-count-few": "{0} Gb",
            "unitPattern-count-many": "{0} Gb",
            "unitPattern-count-other": "{0} Gb"
          },
          "digital-megabyte": {
            "displayName": "MB",
            "unitPattern-count-one": "{0} MB",
            "unitPattern-count-few": "{0} MB",
            "unitPattern-count-many": "{0} MB",
            "unitPattern-count-other": "{0} MB"
          },
          "digital-megabit": {
            "displayName": "Mb",
            "unitPattern-count-one": "{0} Mb",
            "unitPattern-count-few": "{0} Mb",
            "unitPattern-count-many": "{0} Mb",
            "unitPattern-count-other": "{0} Mb"
          },
          "digital-kilobyte": {
            "displayName": "kB",
            "unitPattern-count-one": "{0} kB",
            "unitPattern-count-few": "{0} kB",
            "unitPattern-count-many": "{0} kB",
            "unitPattern-count-other": "{0} kB"
          },
          "digital-kilobit": {
            "displayName": "kb",
            "unitPattern-count-one": "{0} kb",
            "unitPattern-count-few": "{0} kb",
            "unitPattern-count-many": "{0} kb",
            "unitPattern-count-other": "{0} kb"
          },
          "digital-byte": {
            "displayName": "bajt",
            "unitPattern-count-one": "{0} bajt",
            "unitPattern-count-few": "{0} bajty",
            "unitPattern-count-many": "{0} bajtu",
            "unitPattern-count-other": "{0} bajtů"
          },
          "digital-bit": {
            "displayName": "bit",
            "unitPattern-count-one": "{0} bit",
            "unitPattern-count-few": "{0} bity",
            "unitPattern-count-many": "{0} bitu",
            "unitPattern-count-other": "{0} bitů"
          },
          "duration-century": {
            "displayName": "stol.",
            "unitPattern-count-one": "{0} stol.",
            "unitPattern-count-few": "{0} stol.",
            "unitPattern-count-many": "{0} stol.",
            "unitPattern-count-other": "{0} stol."
          },
          "duration-year": {
            "displayName": "roky",
            "unitPattern-count-one": "{0} rok",
            "unitPattern-count-few": "{0} roky",
            "unitPattern-count-many": "{0} roku",
            "unitPattern-count-other": "{0} let",
            "perUnitPattern": "{0}/r"
          },
          "duration-month": {
            "displayName": "měs.",
            "unitPattern-count-one": "{0} měs.",
            "unitPattern-count-few": "{0} měs.",
            "unitPattern-count-many": "{0} měs.",
            "unitPattern-count-other": "{0} měs.",
            "perUnitPattern": "{0}/měs."
          },
          "duration-week": {
            "displayName": "týd.",
            "unitPattern-count-one": "{0} týd.",
            "unitPattern-count-few": "{0} týd.",
            "unitPattern-count-many": "{0} týd.",
            "unitPattern-count-other": "{0} týd.",
            "perUnitPattern": "{0}/týd."
          },
          "duration-day": {
            "displayName": "dny",
            "unitPattern-count-one": "{0} den",
            "unitPattern-count-few": "{0} dny",
            "unitPattern-count-many": "{0} dne",
            "unitPattern-count-other": "{0} dní",
            "perUnitPattern": "{0}/den"
          },
          "duration-hour": {
            "displayName": "h",
            "unitPattern-count-one": "{0} h",
            "unitPattern-count-few": "{0} h",
            "unitPattern-count-many": "{0} h",
            "unitPattern-count-other": "{0} h",
            "perUnitPattern": "{0}/h"
          },
          "duration-minute": {
            "displayName": "min",
            "unitPattern-count-one": "{0} min",
            "unitPattern-count-few": "{0} min",
            "unitPattern-count-many": "{0} min",
            "unitPattern-count-other": "{0} min",
            "perUnitPattern": "{0}/min"
          },
          "duration-second": {
            "displayName": "s",
            "unitPattern-count-one": "{0} s",
            "unitPattern-count-few": "{0} s",
            "unitPattern-count-many": "{0} s",
            "unitPattern-count-other": "{0} s",
            "perUnitPattern": "{0}/s"
          },
          "duration-millisecond": {
            "displayName": "ms",
            "unitPattern-count-one": "{0} ms",
            "unitPattern-count-few": "{0} ms",
            "unitPattern-count-many": "{0} ms",
            "unitPattern-count-other": "{0} ms"
          },
          "duration-microsecond": {
            "displayName": "μs",
            "unitPattern-count-one": "{0} μs",
            "unitPattern-count-few": "{0} μs",
            "unitPattern-count-many": "{0} μs",
            "unitPattern-count-other": "{0} μs"
          },
          "duration-nanosecond": {
            "displayName": "ns",
            "unitPattern-count-one": "{0} ns",
            "unitPattern-count-few": "{0} ns",
            "unitPattern-count-many": "{0} ns",
            "unitPattern-count-other": "{0} ns"
          },
          "electric-ampere": {
            "displayName": "A",
            "unitPattern-count-one": "{0} A",
            "unitPattern-count-few": "{0} A",
            "unitPattern-count-many": "{0} A",
            "unitPattern-count-other": "{0} A"
          },
          "electric-milliampere": {
            "displayName": "mA",
            "unitPattern-count-one": "{0} mA",
            "unitPattern-count-few": "{0} mA",
            "unitPattern-count-many": "{0} mA",
            "unitPattern-count-other": "{0} mA"
          },
          "electric-ohm": {
            "displayName": "Ω",
            "unitPattern-count-one": "{0} Ω",
            "unitPattern-count-few": "{0} Ω",
            "unitPattern-count-many": "{0} Ω",
            "unitPattern-count-other": "{0} Ω"
          },
          "electric-volt": {
            "displayName": "V",
            "unitPattern-count-one": "{0} V",
            "unitPattern-count-few": "{0} V",
            "unitPattern-count-many": "{0} V",
            "unitPattern-count-other": "{0} V"
          },
          "energy-kilocalorie": {
            "displayName": "kcal",
            "unitPattern-count-one": "{0} kcal",
            "unitPattern-count-few": "{0} kcal",
            "unitPattern-count-many": "{0} kcal",
            "unitPattern-count-other": "{0} kcal"
          },
          "energy-calorie": {
            "displayName": "cal",
            "unitPattern-count-one": "{0} cal",
            "unitPattern-count-few": "{0} cal",
            "unitPattern-count-many": "{0} cal",
            "unitPattern-count-other": "{0} cal"
          },
          "energy-foodcalorie": {
            "displayName": "kcal",
            "unitPattern-count-one": "{0} kcal",
            "unitPattern-count-few": "{0} kcal",
            "unitPattern-count-many": "{0} kcal",
            "unitPattern-count-other": "{0} kcal"
          },
          "energy-kilojoule": {
            "displayName": "kJ",
            "unitPattern-count-one": "{0} kJ",
            "unitPattern-count-few": "{0} kJ",
            "unitPattern-count-many": "{0} kJ",
            "unitPattern-count-other": "{0} kJ"
          },
          "energy-joule": {
            "displayName": "J",
            "unitPattern-count-one": "{0} J",
            "unitPattern-count-few": "{0} J",
            "unitPattern-count-many": "{0} J",
            "unitPattern-count-other": "{0} J"
          },
          "energy-kilowatt-hour": {
            "displayName": "kWh",
            "unitPattern-count-one": "{0} kWh",
            "unitPattern-count-few": "{0} kWh",
            "unitPattern-count-many": "{0} kWh",
            "unitPattern-count-other": "{0} kWh"
          },
          "energy-electronvolt": {
            "displayName": "eV",
            "unitPattern-count-one": "{0} eV",
            "unitPattern-count-few": "{0} eV",
            "unitPattern-count-many": "{0} eV",
            "unitPattern-count-other": "{0} eV"
          },
          "energy-british-thermal-unit": {
            "displayName": "BTU",
            "unitPattern-count-one": "{0} BTU",
            "unitPattern-count-few": "{0} BTU",
            "unitPattern-count-many": "{0} BTU",
            "unitPattern-count-other": "{0} BTU"
          },
          "force-pound-force": {
            "displayName": "lbf",
            "unitPattern-count-one": "{0} lbf",
            "unitPattern-count-few": "{0} lbf",
            "unitPattern-count-many": "{0} lbf",
            "unitPattern-count-other": "{0} lbf"
          },
          "force-newton": {
            "displayName": "N",
            "unitPattern-count-one": "{0} N",
            "unitPattern-count-few": "{0} N",
            "unitPattern-count-many": "{0} N",
            "unitPattern-count-other": "{0} N"
          },
          "frequency-gigahertz": {
            "displayName": "GHz",
            "unitPattern-count-one": "{0} GHz",
            "unitPattern-count-few": "{0} GHz",
            "unitPattern-count-many": "{0} GHz",
            "unitPattern-count-other": "{0} GHz"
          },
          "frequency-megahertz": {
            "displayName": "MHz",
            "unitPattern-count-one": "{0} MHz",
            "unitPattern-count-few": "{0} MHz",
            "unitPattern-count-many": "{0} MHz",
            "unitPattern-count-other": "{0} MHz"
          },
          "frequency-kilohertz": {
            "displayName": "kHz",
            "unitPattern-count-one": "{0} kHz",
            "unitPattern-count-few": "{0} kHz",
            "unitPattern-count-many": "{0} kHz",
            "unitPattern-count-other": "{0} kHz"
          },
          "frequency-hertz": {
            "displayName": "Hz",
            "unitPattern-count-one": "{0} Hz",
            "unitPattern-count-few": "{0} Hz",
            "unitPattern-count-many": "{0} Hz",
            "unitPattern-count-other": "{0} Hz"
          },
          "length-kilometer": {
            "displayName": "km",
            "unitPattern-count-one": "{0} km",
            "unitPattern-count-few": "{0} km",
            "unitPattern-count-many": "{0} km",
            "unitPattern-count-other": "{0} km",
            "perUnitPattern": "{0}/km"
          },
          "length-meter": {
            "displayName": "m",
            "unitPattern-count-one": "{0} m",
            "unitPattern-count-few": "{0} m",
            "unitPattern-count-many": "{0} m",
            "unitPattern-count-other": "{0} m",
            "perUnitPattern": "{0}/m"
          },
          "length-decimeter": {
            "displayName": "dm",
            "unitPattern-count-one": "{0} dm",
            "unitPattern-count-few": "{0} dm",
            "unitPattern-count-many": "{0} dm",
            "unitPattern-count-other": "{0} dm"
          },
          "length-centimeter": {
            "displayName": "cm",
            "unitPattern-count-one": "{0} cm",
            "unitPattern-count-few": "{0} cm",
            "unitPattern-count-many": "{0} cm",
            "unitPattern-count-other": "{0} cm",
            "perUnitPattern": "{0}/cm"
          },
          "length-millimeter": {
            "displayName": "mm",
            "unitPattern-count-one": "{0} mm",
            "unitPattern-count-few": "{0} mm",
            "unitPattern-count-many": "{0} mm",
            "unitPattern-count-other": "{0} mm"
          },
          "length-micrometer": {
            "displayName": "µm",
            "unitPattern-count-one": "{0} µm",
            "unitPattern-count-few": "{0} µm",
            "unitPattern-count-many": "{0} µm",
            "unitPattern-count-other": "{0} µm"
          },
          "length-nanometer": {
            "displayName": "nm",
            "unitPattern-count-one": "{0} nm",
            "unitPattern-count-few": "{0} nm",
            "unitPattern-count-many": "{0} nm",
            "unitPattern-count-other": "{0} nm"
          },
          "length-picometer": {
            "displayName": "pm",
            "unitPattern-count-one": "{0} pm",
            "unitPattern-count-few": "{0} pm",
            "unitPattern-count-many": "{0} pm",
            "unitPattern-count-other": "{0} pm"
          },
          "length-mile": {
            "displayName": "mi",
            "unitPattern-count-one": "{0} mi",
            "unitPattern-count-few": "{0} mi",
            "unitPattern-count-many": "{0} mi",
            "unitPattern-count-other": "{0} mi"
          },
          "length-yard": {
            "displayName": "yd",
            "unitPattern-count-one": "{0} yd",
            "unitPattern-count-few": "{0} yd",
            "unitPattern-count-many": "{0} yd",
            "unitPattern-count-other": "{0} yd"
          },
          "length-foot": {
            "displayName": "ft",
            "unitPattern-count-one": "{0} ft",
            "unitPattern-count-few": "{0} ft",
            "unitPattern-count-many": "{0} ft",
            "unitPattern-count-other": "{0} ft",
            "perUnitPattern": "{0}/ft"
          },
          "length-inch": {
            "displayName": "in",
            "unitPattern-count-one": "{0} in",
            "unitPattern-count-few": "{0} in",
            "unitPattern-count-many": "{0} in",
            "unitPattern-count-other": "{0} in",
            "perUnitPattern": "{0}/in"
          },
          "length-parsec": {
            "displayName": "pc",
            "unitPattern-count-one": "{0} pc",
            "unitPattern-count-few": "{0} pc",
            "unitPattern-count-many": "{0} pc",
            "unitPattern-count-other": "{0} pc"
          },
          "length-light-year": {
            "displayName": "ly",
            "unitPattern-count-one": "{0} ly",
            "unitPattern-count-few": "{0} ly",
            "unitPattern-count-many": "{0} ly",
            "unitPattern-count-other": "{0} ly"
          },
          "length-astronomical-unit": {
            "displayName": "au",
            "unitPattern-count-one": "{0} au",
            "unitPattern-count-few": "{0} au",
            "unitPattern-count-many": "{0} au",
            "unitPattern-count-other": "{0} au"
          },
          "length-furlong": {
            "displayName": "fur",
            "unitPattern-count-one": "{0} fur",
            "unitPattern-count-few": "{0} fur",
            "unitPattern-count-many": "{0} fur",
            "unitPattern-count-other": "{0} fur"
          },
          "length-fathom": {
            "displayName": "fm",
            "unitPattern-count-one": "{0} fth",
            "unitPattern-count-few": "{0} fth",
            "unitPattern-count-many": "{0} fth",
            "unitPattern-count-other": "{0} fth"
          },
          "length-nautical-mile": {
            "displayName": "nmi",
            "unitPattern-count-one": "{0} nmi",
            "unitPattern-count-few": "{0} nmi",
            "unitPattern-count-many": "{0} nmi",
            "unitPattern-count-other": "{0} nmi"
          },
          "length-mile-scandinavian": {
            "displayName": "smi",
            "unitPattern-count-one": "{0} smi",
            "unitPattern-count-few": "{0} smi",
            "unitPattern-count-many": "{0} smi",
            "unitPattern-count-other": "{0} smi"
          },
          "length-point": {
            "displayName": "pt",
            "unitPattern-count-one": "{0} pt",
            "unitPattern-count-few": "{0} pt",
            "unitPattern-count-many": "{0} pt",
            "unitPattern-count-other": "{0} pt"
          },
          "length-solar-radius": {
            "displayName": "R☉",
            "unitPattern-count-one": "{0} R☉",
            "unitPattern-count-few": "{0} R☉",
            "unitPattern-count-many": "{0} R☉",
            "unitPattern-count-other": "{0} R☉"
          },
          "light-lux": {
            "displayName": "lx",
            "unitPattern-count-one": "{0} lx",
            "unitPattern-count-few": "{0} lx",
            "unitPattern-count-many": "{0} lx",
            "unitPattern-count-other": "{0} lx"
          },
          "light-solar-luminosity": {
            "displayName": "L☉",
            "unitPattern-count-one": "{0} L☉",
            "unitPattern-count-few": "{0} L☉",
            "unitPattern-count-many": "{0} L☉",
            "unitPattern-count-other": "{0} L☉"
          },
          "mass-metric-ton": {
            "displayName": "mt",
            "unitPattern-count-one": "{0} mt",
            "unitPattern-count-few": "{0} mt",
            "unitPattern-count-many": "{0} mt",
            "unitPattern-count-other": "{0} mt"
          },
          "mass-kilogram": {
            "displayName": "kg",
            "unitPattern-count-one": "{0} kg",
            "unitPattern-count-few": "{0} kg",
            "unitPattern-count-many": "{0} kg",
            "unitPattern-count-other": "{0} kg",
            "perUnitPattern": "{0}/kg"
          },
          "mass-gram": {
            "displayName": "g",
            "unitPattern-count-one": "{0} g",
            "unitPattern-count-few": "{0} g",
            "unitPattern-count-many": "{0} g",
            "unitPattern-count-other": "{0} g",
            "perUnitPattern": "{0}/g"
          },
          "mass-milligram": {
            "displayName": "mg",
            "unitPattern-count-one": "{0} mg",
            "unitPattern-count-few": "{0} mg",
            "unitPattern-count-many": "{0} mg",
            "unitPattern-count-other": "{0} mg"
          },
          "mass-microgram": {
            "displayName": "µg",
            "unitPattern-count-one": "{0} µg",
            "unitPattern-count-few": "{0} µg",
            "unitPattern-count-many": "{0} µg",
            "unitPattern-count-other": "{0} µg"
          },
          "mass-ton": {
            "displayName": "t",
            "unitPattern-count-one": "{0} t",
            "unitPattern-count-few": "{0} t",
            "unitPattern-count-many": "{0} t",
            "unitPattern-count-other": "{0} t"
          },
          "mass-stone": {
            "displayName": "st",
            "unitPattern-count-one": "{0} st",
            "unitPattern-count-few": "{0} st",
            "unitPattern-count-many": "{0} st",
            "unitPattern-count-other": "{0} st"
          },
          "mass-pound": {
            "displayName": "lb",
            "unitPattern-count-one": "{0} lb",
            "unitPattern-count-few": "{0} lb",
            "unitPattern-count-many": "{0} lb",
            "unitPattern-count-other": "{0} lb",
            "perUnitPattern": "{0}/lb"
          },
          "mass-ounce": {
            "displayName": "oz",
            "unitPattern-count-one": "{0} oz",
            "unitPattern-count-few": "{0} oz",
            "unitPattern-count-many": "{0} oz",
            "unitPattern-count-other": "{0} oz",
            "perUnitPattern": "{0}/oz"
          },
          "mass-ounce-troy": {
            "displayName": "oz t",
            "unitPattern-count-one": "{0} oz t",
            "unitPattern-count-few": "{0} oz t",
            "unitPattern-count-many": "{0} oz t",
            "unitPattern-count-other": "{0} oz t"
          },
          "mass-carat": {
            "displayName": "CD",
            "unitPattern-count-one": "{0} CD",
            "unitPattern-count-few": "{0} CD",
            "unitPattern-count-many": "{0} CD",
            "unitPattern-count-other": "{0} CD"
          },
          "mass-dalton": {
            "displayName": "Da",
            "unitPattern-count-one": "{0} Da",
            "unitPattern-count-few": "{0} Da",
            "unitPattern-count-many": "{0} Da",
            "unitPattern-count-other": "{0} Da"
          },
          "mass-earth-mass": {
            "displayName": "M⊕",
            "unitPattern-count-one": "{0} M⊕",
            "unitPattern-count-few": "{0} M⊕",
            "unitPattern-count-many": "{0} M⊕",
            "unitPattern-count-other": "{0} M⊕"
          },
          "mass-solar-mass": {
            "displayName": "M☉",
            "unitPattern-count-one": "{0} M☉",
            "unitPattern-count-few": "{0} M☉",
            "unitPattern-count-many": "{0} M☉",
            "unitPattern-count-other": "{0} M☉"
          },
          "power-gigawatt": {
            "displayName": "GW",
            "unitPattern-count-one": "{0} GW",
            "unitPattern-count-few": "{0} GW",
            "unitPattern-count-many": "{0} GW",
            "unitPattern-count-other": "{0} GW"
          },
          "power-megawatt": {
            "displayName": "MW",
            "unitPattern-count-one": "{0} MW",
            "unitPattern-count-few": "{0} MW",
            "unitPattern-count-many": "{0} MW",
            "unitPattern-count-other": "{0} MW"
          },
          "power-kilowatt": {
            "displayName": "kW",
            "unitPattern-count-one": "{0} kW",
            "unitPattern-count-few": "{0} kW",
            "unitPattern-count-many": "{0} kW",
            "unitPattern-count-other": "{0} kW"
          },
          "power-watt": {
            "displayName": "W",
            "unitPattern-count-one": "{0} W",
            "unitPattern-count-few": "{0} W",
            "unitPattern-count-many": "{0} W",
            "unitPattern-count-other": "{0} W"
          },
          "power-milliwatt": {
            "displayName": "mW",
            "unitPattern-count-one": "{0} mW",
            "unitPattern-count-few": "{0} mW",
            "unitPattern-count-many": "{0} mW",
            "unitPattern-count-other": "{0} mW"
          },
          "power-horsepower": {
            "displayName": "hp",
            "unitPattern-count-one": "{0} hp",
            "unitPattern-count-few": "{0} hp",
            "unitPattern-count-many": "{0} hp",
            "unitPattern-count-other": "{0} hp"
          },
          "pressure-hectopascal": {
            "displayName": "hPa",
            "unitPattern-count-one": "{0} hPa",
            "unitPattern-count-few": "{0} hPa",
            "unitPattern-count-many": "{0} hPa",
            "unitPattern-count-other": "{0} hPa"
          },
          "pressure-millimeter-of-mercury": {
            "displayName": "mm Hg",
            "unitPattern-count-one": "{0} mm Hg",
            "unitPattern-count-few": "{0} mm Hg",
            "unitPattern-count-many": "{0} mm Hg",
            "unitPattern-count-other": "{0} mm Hg"
          },
          "pressure-pound-per-square-inch": {
            "displayName": "psi",
            "unitPattern-count-one": "{0} psi",
            "unitPattern-count-few": "{0} psi",
            "unitPattern-count-many": "{0} psi",
            "unitPattern-count-other": "{0} psi"
          },
          "pressure-inch-hg": {
            "displayName": "inHg",
            "unitPattern-count-one": "{0} inHg",
            "unitPattern-count-few": "{0} inHg",
            "unitPattern-count-many": "{0} inHg",
            "unitPattern-count-other": "{0} inHg"
          },
          "pressure-millibar": {
            "displayName": "mb",
            "unitPattern-count-one": "{0} mb",
            "unitPattern-count-few": "{0} mb",
            "unitPattern-count-many": "{0} mb",
            "unitPattern-count-other": "{0} mb"
          },
          "pressure-atmosphere": {
            "displayName": "atm",
            "unitPattern-count-one": "{0} atm",
            "unitPattern-count-few": "{0} atm",
            "unitPattern-count-many": "{0} atm",
            "unitPattern-count-other": "{0} atm"
          },
          "pressure-kilopascal": {
            "displayName": "kPa",
            "unitPattern-count-one": "{0} kPa",
            "unitPattern-count-few": "{0} kPa",
            "unitPattern-count-many": "{0} kPa",
            "unitPattern-count-other": "{0} kPa"
          },
          "pressure-megapascal": {
            "displayName": "MPa",
            "unitPattern-count-one": "{0} MPa",
            "unitPattern-count-few": "{0} MPa",
            "unitPattern-count-many": "{0} MPa",
            "unitPattern-count-other": "{0} MPa"
          },
          "speed-kilometer-per-hour": {
            "displayName": "km/h",
            "unitPattern-count-one": "{0} km/h",
            "unitPattern-count-few": "{0} km/h",
            "unitPattern-count-many": "{0} km/h",
            "unitPattern-count-other": "{0} km/h"
          },
          "speed-meter-per-second": {
            "displayName": "m/s",
            "unitPattern-count-one": "{0} m/s",
            "unitPattern-count-few": "{0} m/s",
            "unitPattern-count-many": "{0} m/s",
            "unitPattern-count-other": "{0} m/s"
          },
          "speed-mile-per-hour": {
            "displayName": "mi/h",
            "unitPattern-count-one": "{0} mi/h",
            "unitPattern-count-few": "{0} mi/h",
            "unitPattern-count-many": "{0} mi/h",
            "unitPattern-count-other": "{0} mi/h"
          },
          "speed-knot": {
            "displayName": "kn",
            "unitPattern-count-one": "{0} kn",
            "unitPattern-count-few": "{0} kn",
            "unitPattern-count-many": "{0} kn",
            "unitPattern-count-other": "{0} kn"
          },
          "temperature-generic": {
            "displayName": "°",
            "unitPattern-count-one": "{0}°",
            "unitPattern-count-few": "{0}°",
            "unitPattern-count-many": "{0}°",
            "unitPattern-count-other": "{0}°"
          },
          "temperature-celsius": {
            "displayName": "°C",
            "unitPattern-count-one": "{0} °C",
            "unitPattern-count-few": "{0} °C",
            "unitPattern-count-many": "{0} °C",
            "unitPattern-count-other": "{0} °C"
          },
          "temperature-fahrenheit": {
            "displayName": "°F",
            "unitPattern-count-one": "{0} °F",
            "unitPattern-count-few": "{0} °F",
            "unitPattern-count-many": "{0} °F",
            "unitPattern-count-other": "{0} °F"
          },
          "temperature-kelvin": {
            "displayName": "K",
            "unitPattern-count-one": "{0} K",
            "unitPattern-count-few": "{0} K",
            "unitPattern-count-many": "{0} K",
            "unitPattern-count-other": "{0} K"
          },
          "torque-pound-foot": {
            "displayName": "lbf⋅ft",
            "unitPattern-count-one": "{0} lbf⋅ft",
            "unitPattern-count-few": "{0} lbf⋅ft",
            "unitPattern-count-many": "{0} lbf⋅ft",
            "unitPattern-count-other": "{0} lbf⋅ft"
          },
          "torque-newton-meter": {
            "displayName": "Nm",
            "unitPattern-count-one": "{0} Nm",
            "unitPattern-count-few": "{0} Nm",
            "unitPattern-count-many": "{0} Nm",
            "unitPattern-count-other": "{0} Nm"
          },
          "volume-cubic-kilometer": {
            "displayName": "km³",
            "unitPattern-count-one": "{0} km³",
            "unitPattern-count-few": "{0} km³",
            "unitPattern-count-many": "{0} km³",
            "unitPattern-count-other": "{0} km³"
          },
          "volume-cubic-meter": {
            "displayName": "m³",
            "unitPattern-count-one": "{0} m³",
            "unitPattern-count-few": "{0} m³",
            "unitPattern-count-many": "{0} m³",
            "unitPattern-count-other": "{0} m³",
            "perUnitPattern": "{0}/m³"
          },
          "volume-cubic-centimeter": {
            "displayName": "cm³",
            "unitPattern-count-one": "{0} cm³",
            "unitPattern-count-few": "{0} cm³",
            "unitPattern-count-many": "{0} cm³",
            "unitPattern-count-other": "{0} cm³",
            "perUnitPattern": "{0}/cm³"
          },
          "volume-cubic-mile": {
            "displayName": "mi³",
            "unitPattern-count-one": "{0} mi³",
            "unitPattern-count-few": "{0} mi³",
            "unitPattern-count-many": "{0} mi³",
            "unitPattern-count-other": "{0} mi³"
          },
          "volume-cubic-yard": {
            "displayName": "yd³",
            "unitPattern-count-one": "{0} yd³",
            "unitPattern-count-few": "{0} yd³",
            "unitPattern-count-many": "{0} yd³",
            "unitPattern-count-other": "{0} yd³"
          },
          "volume-cubic-foot": {
            "displayName": "ft³",
            "unitPattern-count-one": "{0} ft³",
            "unitPattern-count-few": "{0} ft³",
            "unitPattern-count-many": "{0} ft³",
            "unitPattern-count-other": "{0} ft³"
          },
          "volume-cubic-inch": {
            "displayName": "in³",
            "unitPattern-count-one": "{0} in³",
            "unitPattern-count-few": "{0} in³",
            "unitPattern-count-many": "{0} in³",
            "unitPattern-count-other": "{0} in³"
          },
          "volume-megaliter": {
            "displayName": "Ml",
            "unitPattern-count-one": "{0} Ml",
            "unitPattern-count-few": "{0} Ml",
            "unitPattern-count-many": "{0} Ml",
            "unitPattern-count-other": "{0} Ml"
          },
          "volume-hectoliter": {
            "displayName": "hl",
            "unitPattern-count-one": "{0} hl",
            "unitPattern-count-few": "{0} hl",
            "unitPattern-count-many": "{0} hl",
            "unitPattern-count-other": "{0} hl"
          },
          "volume-liter": {
            "displayName": "l",
            "unitPattern-count-one": "{0} l",
            "unitPattern-count-few": "{0} l",
            "unitPattern-count-many": "{0} l",
            "unitPattern-count-other": "{0} l",
            "perUnitPattern": "{0}/l"
          },
          "volume-deciliter": {
            "displayName": "dl",
            "unitPattern-count-one": "{0} dl",
            "unitPattern-count-few": "{0} dl",
            "unitPattern-count-many": "{0} dl",
            "unitPattern-count-other": "{0} dl"
          },
          "volume-centiliter": {
            "displayName": "cl",
            "unitPattern-count-one": "{0} cl",
            "unitPattern-count-few": "{0} cl",
            "unitPattern-count-many": "{0} cl",
            "unitPattern-count-other": "{0} cl"
          },
          "volume-milliliter": {
            "displayName": "ml",
            "unitPattern-count-one": "{0} ml",
            "unitPattern-count-few": "{0} ml",
            "unitPattern-count-many": "{0} ml",
            "unitPattern-count-other": "{0} ml"
          },
          "volume-pint-metric": {
            "displayName": "mpt",
            "unitPattern-count-one": "{0} mpt",
            "unitPattern-count-few": "{0} mpt",
            "unitPattern-count-many": "{0} mpt",
            "unitPattern-count-other": "{0} mpt"
          },
          "volume-cup-metric": {
            "displayName": "mcup",
            "unitPattern-count-one": "{0} mc",
            "unitPattern-count-few": "{0} mc",
            "unitPattern-count-many": "{0} mc",
            "unitPattern-count-other": "{0} mc"
          },
          "volume-acre-foot": {
            "displayName": "ac ft",
            "unitPattern-count-one": "{0} ac ft",
            "unitPattern-count-few": "{0} ac ft",
            "unitPattern-count-many": "{0} ac ft",
            "unitPattern-count-other": "{0} ac ft"
          },
          "volume-bushel": {
            "displayName": "bu",
            "unitPattern-count-one": "{0} bu",
            "unitPattern-count-few": "{0} bu",
            "unitPattern-count-many": "{0} bu",
            "unitPattern-count-other": "{0} bu"
          },
          "volume-gallon": {
            "displayName": "gal",
            "unitPattern-count-one": "{0} gal",
            "unitPattern-count-few": "{0} gal",
            "unitPattern-count-many": "{0} gal",
            "unitPattern-count-other": "{0} gal",
            "perUnitPattern": "{0}/gal"
          },
          "volume-gallon-imperial": {
            "displayName": "gal Imp.",
            "unitPattern-count-one": "{0} gal Imp.",
            "unitPattern-count-few": "{0} gal Imp.",
            "unitPattern-count-many": "{0} gal Imp.",
            "unitPattern-count-other": "{0} gal Imp.",
            "perUnitPattern": "{0}/gal Imp."
          },
          "volume-quart": {
            "displayName": "qt",
            "unitPattern-count-one": "{0} qt",
            "unitPattern-count-few": "{0} qt",
            "unitPattern-count-many": "{0} qt",
            "unitPattern-count-other": "{0} qt"
          },
          "volume-pint": {
            "displayName": "pt",
            "unitPattern-count-one": "{0} pt",
            "unitPattern-count-few": "{0} pt",
            "unitPattern-count-many": "{0} pt",
            "unitPattern-count-other": "{0} pt"
          },
          "volume-cup": {
            "displayName": "c",
            "unitPattern-count-one": "{0} c",
            "unitPattern-count-few": "{0} c",
            "unitPattern-count-many": "{0} c",
            "unitPattern-count-other": "{0} c"
          },
          "volume-fluid-ounce": {
            "displayName": "fl oz",
            "unitPattern-count-one": "{0} fl oz",
            "unitPattern-count-few": "{0} fl oz",
            "unitPattern-count-many": "{0} fl oz",
            "unitPattern-count-other": "{0} fl oz"
          },
          "volume-fluid-ounce-imperial": {
            "displayName": "fl oz Imp.",
            "unitPattern-count-one": "{0} fl oz Imp.",
            "unitPattern-count-few": "{0} fl oz Imp.",
            "unitPattern-count-many": "{0} fl oz Imp.",
            "unitPattern-count-other": "{0} fl oz Imp."
          },
          "volume-tablespoon": {
            "displayName": "tbsp",
            "unitPattern-count-one": "{0} tbsp",
            "unitPattern-count-few": "{0} tbsp",
            "unitPattern-count-many": "{0} tbsp",
            "unitPattern-count-other": "{0} tbsp"
          },
          "volume-teaspoon": {
            "displayName": "tsp",
            "unitPattern-count-one": "{0} tsp",
            "unitPattern-count-few": "{0} tsp",
            "unitPattern-count-many": "{0} tsp",
            "unitPattern-count-other": "{0} tsp"
          },
          "volume-barrel": {
            "displayName": "bbl",
            "unitPattern-count-one": "{0} bbl",
            "unitPattern-count-few": "{0} bbl",
            "unitPattern-count-many": "{0} bbl",
            "unitPattern-count-other": "{0} bbl"
          },
          "coordinateUnit": {
            "displayName": "směr",
            "east": "{0} v. d.",
            "north": "{0} s. š.",
            "south": "{0} j. š.",
            "west": "{0} z. d."
          }
        },
        "narrow": {
          "per": {
            "compoundUnitPattern": "{0}/{1}"
          },
          "acceleration-g-force": {
            "displayName": "G",
            "unitPattern-count-one": "{0} G",
            "unitPattern-count-few": "{0} G",
            "unitPattern-count-many": "{0} G",
            "unitPattern-count-other": "{0} G"
          },
          "acceleration-meter-per-second-squared": {
            "displayName": "m/s²",
            "unitPattern-count-one": "{0} m/s²",
            "unitPattern-count-few": "{0} m/s²",
            "unitPattern-count-many": "{0} m/s²",
            "unitPattern-count-other": "{0} m/s²"
          },
          "angle-revolution": {
            "displayName": "ot.",
            "unitPattern-count-one": "{0} ot.",
            "unitPattern-count-few": "{0} ot.",
            "unitPattern-count-many": "{0} ot.",
            "unitPattern-count-other": "{0} ot."
          },
          "angle-radian": {
            "displayName": "rad",
            "unitPattern-count-one": "{0} rad",
            "unitPattern-count-few": "{0} rad",
            "unitPattern-count-many": "{0} rad",
            "unitPattern-count-other": "{0} rad"
          },
          "angle-degree": {
            "displayName": "°",
            "unitPattern-count-one": "{0}°",
            "unitPattern-count-few": "{0}°",
            "unitPattern-count-many": "{0}°",
            "unitPattern-count-other": "{0}°"
          },
          "angle-arc-minute": {
            "displayName": "′",
            "unitPattern-count-one": "{0}′",
            "unitPattern-count-few": "{0}′",
            "unitPattern-count-many": "{0}′",
            "unitPattern-count-other": "{0}′"
          },
          "angle-arc-second": {
            "displayName": "″",
            "unitPattern-count-one": "{0}″",
            "unitPattern-count-few": "{0}″",
            "unitPattern-count-many": "{0}″",
            "unitPattern-count-other": "{0}″"
          },
          "area-square-kilometer": {
            "displayName": "km²",
            "unitPattern-count-one": "{0} km²",
            "unitPattern-count-few": "{0} km²",
            "unitPattern-count-many": "{0} km²",
            "unitPattern-count-other": "{0} km²",
            "perUnitPattern": "{0}/km²"
          },
          "area-hectare": {
            "displayName": "ha",
            "unitPattern-count-one": "{0} ha",
            "unitPattern-count-few": "{0} ha",
            "unitPattern-count-many": "{0} ha",
            "unitPattern-count-other": "{0} ha"
          },
          "area-square-meter": {
            "displayName": "m²",
            "unitPattern-count-one": "{0} m²",
            "unitPattern-count-few": "{0} m²",
            "unitPattern-count-many": "{0} m²",
            "unitPattern-count-other": "{0} m²",
            "perUnitPattern": "{0}/m²"
          },
          "area-square-centimeter": {
            "displayName": "cm²",
            "unitPattern-count-one": "{0} cm²",
            "unitPattern-count-few": "{0} cm²",
            "unitPattern-count-many": "{0} cm²",
            "unitPattern-count-other": "{0} cm²",
            "perUnitPattern": "{0}/cm²"
          },
          "area-square-mile": {
            "displayName": "mi²",
            "unitPattern-count-one": "{0} mi²",
            "unitPattern-count-few": "{0} mi²",
            "unitPattern-count-many": "{0} mi²",
            "unitPattern-count-other": "{0} mi²",
            "perUnitPattern": "{0}/mi²"
          },
          "area-acre": {
            "displayName": "ac",
            "unitPattern-count-one": "{0} ac",
            "unitPattern-count-few": "{0} ac",
            "unitPattern-count-many": "{0} ac",
            "unitPattern-count-other": "{0} ac"
          },
          "area-square-yard": {
            "displayName": "yd²",
            "unitPattern-count-one": "{0} yd²",
            "unitPattern-count-few": "{0} yd²",
            "unitPattern-count-many": "{0} yd²",
            "unitPattern-count-other": "{0} yd²"
          },
          "area-square-foot": {
            "displayName": "ft²",
            "unitPattern-count-one": "{0} ft²",
            "unitPattern-count-few": "{0} ft²",
            "unitPattern-count-many": "{0} ft²",
            "unitPattern-count-other": "{0} ft²"
          },
          "area-square-inch": {
            "displayName": "in²",
            "unitPattern-count-one": "{0} in²",
            "unitPattern-count-few": "{0} in²",
            "unitPattern-count-many": "{0} in²",
            "unitPattern-count-other": "{0} in²",
            "perUnitPattern": "{0}/in²"
          },
          "area-dunam": {
            "displayName": "dun.",
            "unitPattern-count-one": "{0} dun.",
            "unitPattern-count-few": "{0} dun.",
            "unitPattern-count-many": "{0} dun.",
            "unitPattern-count-other": "{0} dun."
          },
          "concentr-karat": {
            "displayName": "kt",
            "unitPattern-count-one": "{0} kt",
            "unitPattern-count-few": "{0} kt",
            "unitPattern-count-many": "{0} kt",
            "unitPattern-count-other": "{0} kt"
          },
          "concentr-milligram-per-deciliter": {
            "displayName": "mg/dl",
            "unitPattern-count-one": "{0} mg/dl",
            "unitPattern-count-few": "{0} mg/dl",
            "unitPattern-count-many": "{0} mg/dl",
            "unitPattern-count-other": "{0} mg/dl"
          },
          "concentr-millimole-per-liter": {
            "displayName": "mmol/l",
            "unitPattern-count-one": "{0} mmol/l",
            "unitPattern-count-few": "{0} mmol/l",
            "unitPattern-count-many": "{0} mmol/l",
            "unitPattern-count-other": "{0} mmol/l"
          },
          "concentr-part-per-million": {
            "displayName": "ppm",
            "unitPattern-count-one": "{0} ppm",
            "unitPattern-count-few": "{0} ppm",
            "unitPattern-count-many": "{0} ppm",
            "unitPattern-count-other": "{0} ppm"
          },
          "concentr-percent": {
            "displayName": "%",
            "unitPattern-count-one": "{0} %",
            "unitPattern-count-few": "{0} %",
            "unitPattern-count-many": "{0} %",
            "unitPattern-count-other": "{0} %"
          },
          "concentr-permille": {
            "displayName": "‰",
            "unitPattern-count-one": "{0} ‰",
            "unitPattern-count-few": "{0} ‰",
            "unitPattern-count-many": "{0} ‰",
            "unitPattern-count-other": "{0} ‰"
          },
          "concentr-permyriad": {
            "displayName": "‱",
            "unitPattern-count-one": "{0} ‱",
            "unitPattern-count-few": "{0} ‱",
            "unitPattern-count-many": "{0} ‱",
            "unitPattern-count-other": "{0} ‱"
          },
          "concentr-mole": {
            "displayName": "mol",
            "unitPattern-count-one": "{0} mol",
            "unitPattern-count-few": "{0} mol",
            "unitPattern-count-many": "{0} mol",
            "unitPattern-count-other": "{0} mol"
          },
          "consumption-liter-per-kilometer": {
            "displayName": "l/km",
            "unitPattern-count-one": "{0} l/km",
            "unitPattern-count-few": "{0} l/km",
            "unitPattern-count-many": "{0} l/km",
            "unitPattern-count-other": "{0} l/km"
          },
          "consumption-liter-per-100kilometers": {
            "displayName": "l/100 km",
            "unitPattern-count-one": "{0} l/100 km",
            "unitPattern-count-few": "{0} l/100 km",
            "unitPattern-count-many": "{0} l/100 km",
            "unitPattern-count-other": "{0} l/100 km"
          },
          "consumption-mile-per-gallon": {
            "displayName": "mpg",
            "unitPattern-count-one": "{0} mpg",
            "unitPattern-count-few": "{0} mpg",
            "unitPattern-count-many": "{0} mpg",
            "unitPattern-count-other": "{0} mpg"
          },
          "consumption-mile-per-gallon-imperial": {
            "displayName": "mpg Imp.",
            "unitPattern-count-one": "{0} mpg Imp.",
            "unitPattern-count-few": "{0} mpg Imp.",
            "unitPattern-count-many": "{0} mpg Imp.",
            "unitPattern-count-other": "{0} mpg Imp."
          },
          "digital-petabyte": {
            "displayName": "PB",
            "unitPattern-count-one": "{0} PB",
            "unitPattern-count-few": "{0} PB",
            "unitPattern-count-many": "{0} PB",
            "unitPattern-count-other": "{0} PB"
          },
          "digital-terabyte": {
            "displayName": "TB",
            "unitPattern-count-one": "{0} TB",
            "unitPattern-count-few": "{0} TB",
            "unitPattern-count-many": "{0} TB",
            "unitPattern-count-other": "{0} TB"
          },
          "digital-terabit": {
            "displayName": "Tb",
            "unitPattern-count-one": "{0} Tb",
            "unitPattern-count-few": "{0} Tb",
            "unitPattern-count-many": "{0} Tb",
            "unitPattern-count-other": "{0} Tb"
          },
          "digital-gigabyte": {
            "displayName": "GB",
            "unitPattern-count-one": "{0} GB",
            "unitPattern-count-few": "{0} GB",
            "unitPattern-count-many": "{0} GB",
            "unitPattern-count-other": "{0} GB"
          },
          "digital-gigabit": {
            "displayName": "Gb",
            "unitPattern-count-one": "{0} Gb",
            "unitPattern-count-few": "{0} Gb",
            "unitPattern-count-many": "{0} Gb",
            "unitPattern-count-other": "{0} Gb"
          },
          "digital-megabyte": {
            "displayName": "MB",
            "unitPattern-count-one": "{0} MB",
            "unitPattern-count-few": "{0} MB",
            "unitPattern-count-many": "{0} MB",
            "unitPattern-count-other": "{0} MB"
          },
          "digital-megabit": {
            "displayName": "Mb",
            "unitPattern-count-one": "{0} Mb",
            "unitPattern-count-few": "{0} Mb",
            "unitPattern-count-many": "{0} Mb",
            "unitPattern-count-other": "{0} Mb"
          },
          "digital-kilobyte": {
            "displayName": "kB",
            "unitPattern-count-one": "{0} kB",
            "unitPattern-count-few": "{0} kB",
            "unitPattern-count-many": "{0} kB",
            "unitPattern-count-other": "{0} kB"
          },
          "digital-kilobit": {
            "displayName": "kb",
            "unitPattern-count-one": "{0} kb",
            "unitPattern-count-few": "{0} kb",
            "unitPattern-count-many": "{0} kb",
            "unitPattern-count-other": "{0} kb"
          },
          "digital-byte": {
            "displayName": "bajt",
            "unitPattern-count-one": "{0} bajt",
            "unitPattern-count-few": "{0} bajty",
            "unitPattern-count-many": "{0} bajtu",
            "unitPattern-count-other": "{0} bajtů"
          },
          "digital-bit": {
            "displayName": "bit",
            "unitPattern-count-one": "{0} bit",
            "unitPattern-count-few": "{0} bity",
            "unitPattern-count-many": "{0} bitu",
            "unitPattern-count-other": "{0} bitů"
          },
          "duration-century": {
            "displayName": "stol.",
            "unitPattern-count-one": "{0} stol.",
            "unitPattern-count-few": "{0} stol.",
            "unitPattern-count-many": "{0} stol.",
            "unitPattern-count-other": "{0} stol."
          },
          "duration-year": {
            "displayName": "r",
            "unitPattern-count-one": "{0} r",
            "unitPattern-count-few": "{0} r",
            "unitPattern-count-many": "{0} r",
            "unitPattern-count-other": "{0} r",
            "perUnitPattern": "{0}/r"
          },
          "duration-month": {
            "displayName": "m",
            "unitPattern-count-one": "{0} m",
            "unitPattern-count-few": "{0} m",
            "unitPattern-count-many": "{0} m",
            "unitPattern-count-other": "{0} m",
            "perUnitPattern": "{0}/měs."
          },
          "duration-week": {
            "displayName": "t",
            "unitPattern-count-one": "{0} t",
            "unitPattern-count-few": "{0} t",
            "unitPattern-count-many": "{0} t",
            "unitPattern-count-other": "{0} t",
            "perUnitPattern": "{0}/týd."
          },
          "duration-day": {
            "displayName": "d",
            "unitPattern-count-one": "{0} d",
            "unitPattern-count-few": "{0} d",
            "unitPattern-count-many": "{0} d",
            "unitPattern-count-other": "{0} d",
            "perUnitPattern": "{0}/d"
          },
          "duration-hour": {
            "displayName": "h",
            "unitPattern-count-one": "{0} h",
            "unitPattern-count-few": "{0} h",
            "unitPattern-count-many": "{0} h",
            "unitPattern-count-other": "{0} h",
            "perUnitPattern": "{0}/h"
          },
          "duration-minute": {
            "displayName": "m",
            "unitPattern-count-one": "{0} m",
            "unitPattern-count-few": "{0} m",
            "unitPattern-count-many": "{0} m",
            "unitPattern-count-other": "{0} m",
            "perUnitPattern": "{0}/m"
          },
          "duration-second": {
            "displayName": "s",
            "unitPattern-count-one": "{0} s",
            "unitPattern-count-few": "{0} s",
            "unitPattern-count-many": "{0} s",
            "unitPattern-count-other": "{0} s",
            "perUnitPattern": "{0}/s"
          },
          "duration-millisecond": {
            "displayName": "ms",
            "unitPattern-count-one": "{0} ms",
            "unitPattern-count-few": "{0} ms",
            "unitPattern-count-many": "{0} ms",
            "unitPattern-count-other": "{0} ms"
          },
          "duration-microsecond": {
            "displayName": "μs",
            "unitPattern-count-one": "{0} μs",
            "unitPattern-count-few": "{0} μs",
            "unitPattern-count-many": "{0} μs",
            "unitPattern-count-other": "{0} μs"
          },
          "duration-nanosecond": {
            "displayName": "ns",
            "unitPattern-count-one": "{0} ns",
            "unitPattern-count-few": "{0} ns",
            "unitPattern-count-many": "{0} ns",
            "unitPattern-count-other": "{0} ns"
          },
          "electric-ampere": {
            "displayName": "A",
            "unitPattern-count-one": "{0} A",
            "unitPattern-count-few": "{0} A",
            "unitPattern-count-many": "{0} A",
            "unitPattern-count-other": "{0} A"
          },
          "electric-milliampere": {
            "displayName": "mA",
            "unitPattern-count-one": "{0} mA",
            "unitPattern-count-few": "{0} mA",
            "unitPattern-count-many": "{0} mA",
            "unitPattern-count-other": "{0} mA"
          },
          "electric-ohm": {
            "displayName": "Ω",
            "unitPattern-count-one": "{0} Ω",
            "unitPattern-count-few": "{0} Ω",
            "unitPattern-count-many": "{0} Ω",
            "unitPattern-count-other": "{0} Ω"
          },
          "electric-volt": {
            "displayName": "V",
            "unitPattern-count-one": "{0} V",
            "unitPattern-count-few": "{0} V",
            "unitPattern-count-many": "{0} V",
            "unitPattern-count-other": "{0} V"
          },
          "energy-kilocalorie": {
            "displayName": "kcal",
            "unitPattern-count-one": "{0} kcal",
            "unitPattern-count-few": "{0} kcal",
            "unitPattern-count-many": "{0} kcal",
            "unitPattern-count-other": "{0} kcal"
          },
          "energy-calorie": {
            "displayName": "cal",
            "unitPattern-count-one": "{0} cal",
            "unitPattern-count-few": "{0} cal",
            "unitPattern-count-many": "{0} cal",
            "unitPattern-count-other": "{0} cal"
          },
          "energy-foodcalorie": {
            "displayName": "kcal",
            "unitPattern-count-one": "{0} kcal",
            "unitPattern-count-few": "{0} kcal",
            "unitPattern-count-many": "{0} kcal",
            "unitPattern-count-other": "{0} kcal"
          },
          "energy-kilojoule": {
            "displayName": "kJ",
            "unitPattern-count-one": "{0} kJ",
            "unitPattern-count-few": "{0} kJ",
            "unitPattern-count-many": "{0} kJ",
            "unitPattern-count-other": "{0} kJ"
          },
          "energy-joule": {
            "displayName": "J",
            "unitPattern-count-one": "{0} J",
            "unitPattern-count-few": "{0} J",
            "unitPattern-count-many": "{0} J",
            "unitPattern-count-other": "{0} J"
          },
          "energy-kilowatt-hour": {
            "displayName": "kWh",
            "unitPattern-count-one": "{0} kWh",
            "unitPattern-count-few": "{0} kWh",
            "unitPattern-count-many": "{0} kWh",
            "unitPattern-count-other": "{0} kWh"
          },
          "energy-electronvolt": {
            "displayName": "eV",
            "unitPattern-count-one": "{0} eV",
            "unitPattern-count-few": "{0} eV",
            "unitPattern-count-many": "{0} eV",
            "unitPattern-count-other": "{0} eV"
          },
          "energy-british-thermal-unit": {
            "displayName": "BTU",
            "unitPattern-count-one": "{0} BTU",
            "unitPattern-count-few": "{0} BTU",
            "unitPattern-count-many": "{0} BTU",
            "unitPattern-count-other": "{0} BTU"
          },
          "force-pound-force": {
            "displayName": "lbf",
            "unitPattern-count-one": "{0} lbf",
            "unitPattern-count-few": "{0} lbf",
            "unitPattern-count-many": "{0} lbf",
            "unitPattern-count-other": "{0} lbf"
          },
          "force-newton": {
            "displayName": "N",
            "unitPattern-count-one": "{0} N",
            "unitPattern-count-few": "{0} N",
            "unitPattern-count-many": "{0} N",
            "unitPattern-count-other": "{0} N"
          },
          "frequency-gigahertz": {
            "displayName": "GHz",
            "unitPattern-count-one": "{0} GHz",
            "unitPattern-count-few": "{0} GHz",
            "unitPattern-count-many": "{0} GHz",
            "unitPattern-count-other": "{0} GHz"
          },
          "frequency-megahertz": {
            "displayName": "MHz",
            "unitPattern-count-one": "{0} MHz",
            "unitPattern-count-few": "{0} MHz",
            "unitPattern-count-many": "{0} MHz",
            "unitPattern-count-other": "{0} MHz"
          },
          "frequency-kilohertz": {
            "displayName": "kHz",
            "unitPattern-count-one": "{0} kHz",
            "unitPattern-count-few": "{0} kHz",
            "unitPattern-count-many": "{0} kHz",
            "unitPattern-count-other": "{0} kHz"
          },
          "frequency-hertz": {
            "displayName": "Hz",
            "unitPattern-count-one": "{0} Hz",
            "unitPattern-count-few": "{0} Hz",
            "unitPattern-count-many": "{0} Hz",
            "unitPattern-count-other": "{0} Hz"
          },
          "length-kilometer": {
            "displayName": "km",
            "unitPattern-count-one": "{0} km",
            "unitPattern-count-few": "{0} km",
            "unitPattern-count-many": "{0} km",
            "unitPattern-count-other": "{0} km",
            "perUnitPattern": "{0}/km"
          },
          "length-meter": {
            "displayName": "m",
            "unitPattern-count-one": "{0} m",
            "unitPattern-count-few": "{0} m",
            "unitPattern-count-many": "{0} m",
            "unitPattern-count-other": "{0} m",
            "perUnitPattern": "{0}/m"
          },
          "length-decimeter": {
            "displayName": "dm",
            "unitPattern-count-one": "{0} dm",
            "unitPattern-count-few": "{0} dm",
            "unitPattern-count-many": "{0} dm",
            "unitPattern-count-other": "{0} dm"
          },
          "length-centimeter": {
            "displayName": "cm",
            "unitPattern-count-one": "{0} cm",
            "unitPattern-count-few": "{0} cm",
            "unitPattern-count-many": "{0} cm",
            "unitPattern-count-other": "{0} cm",
            "perUnitPattern": "{0}/cm"
          },
          "length-millimeter": {
            "displayName": "mm",
            "unitPattern-count-one": "{0} mm",
            "unitPattern-count-few": "{0} mm",
            "unitPattern-count-many": "{0} mm",
            "unitPattern-count-other": "{0} mm"
          },
          "length-micrometer": {
            "displayName": "µm",
            "unitPattern-count-one": "{0} µm",
            "unitPattern-count-few": "{0} µm",
            "unitPattern-count-many": "{0} µm",
            "unitPattern-count-other": "{0} µm"
          },
          "length-nanometer": {
            "displayName": "nm",
            "unitPattern-count-one": "{0} nm",
            "unitPattern-count-few": "{0} nm",
            "unitPattern-count-many": "{0} nm",
            "unitPattern-count-other": "{0} nm"
          },
          "length-picometer": {
            "displayName": "pm",
            "unitPattern-count-one": "{0} pm",
            "unitPattern-count-few": "{0} pm",
            "unitPattern-count-many": "{0} pm",
            "unitPattern-count-other": "{0} pm"
          },
          "length-mile": {
            "displayName": "mi",
            "unitPattern-count-one": "{0} mi",
            "unitPattern-count-few": "{0} mi",
            "unitPattern-count-many": "{0} mi",
            "unitPattern-count-other": "{0} mi"
          },
          "length-yard": {
            "displayName": "yd",
            "unitPattern-count-one": "{0} yd",
            "unitPattern-count-few": "{0} yd",
            "unitPattern-count-many": "{0} yd",
            "unitPattern-count-other": "{0} yd"
          },
          "length-foot": {
            "displayName": "ft",
            "unitPattern-count-one": "{0}′",
            "unitPattern-count-few": "{0}′",
            "unitPattern-count-many": "{0}′",
            "unitPattern-count-other": "{0}′",
            "perUnitPattern": "{0}/ft"
          },
          "length-inch": {
            "displayName": "in",
            "unitPattern-count-one": "{0}″",
            "unitPattern-count-few": "{0}″",
            "unitPattern-count-many": "{0}″",
            "unitPattern-count-other": "{0}″",
            "perUnitPattern": "{0}/in"
          },
          "length-parsec": {
            "displayName": "pc",
            "unitPattern-count-one": "{0} pc",
            "unitPattern-count-few": "{0} pc",
            "unitPattern-count-many": "{0} pc",
            "unitPattern-count-other": "{0} pc"
          },
          "length-light-year": {
            "displayName": "ly",
            "unitPattern-count-one": "{0} ly",
            "unitPattern-count-few": "{0} ly",
            "unitPattern-count-many": "{0} ly",
            "unitPattern-count-other": "{0} ly"
          },
          "length-astronomical-unit": {
            "displayName": "au",
            "unitPattern-count-one": "{0} au",
            "unitPattern-count-few": "{0} au",
            "unitPattern-count-many": "{0} au",
            "unitPattern-count-other": "{0} au"
          },
          "length-furlong": {
            "displayName": "fur",
            "unitPattern-count-one": "{0} fur",
            "unitPattern-count-few": "{0} fur",
            "unitPattern-count-many": "{0} fur",
            "unitPattern-count-other": "{0} fur"
          },
          "length-fathom": {
            "displayName": "fm",
            "unitPattern-count-one": "{0} fth",
            "unitPattern-count-few": "{0} fth",
            "unitPattern-count-many": "{0} fth",
            "unitPattern-count-other": "{0} fth"
          },
          "length-nautical-mile": {
            "displayName": "nmi",
            "unitPattern-count-one": "{0} nmi",
            "unitPattern-count-few": "{0} nmi",
            "unitPattern-count-many": "{0} nmi",
            "unitPattern-count-other": "{0} nmi"
          },
          "length-mile-scandinavian": {
            "displayName": "smi",
            "unitPattern-count-one": "{0} smi",
            "unitPattern-count-few": "{0} smi",
            "unitPattern-count-many": "{0} smi",
            "unitPattern-count-other": "{0} smi"
          },
          "length-point": {
            "displayName": "pt",
            "unitPattern-count-one": "{0} pt",
            "unitPattern-count-few": "{0} pt",
            "unitPattern-count-many": "{0} pt",
            "unitPattern-count-other": "{0} pt"
          },
          "length-solar-radius": {
            "displayName": "R☉",
            "unitPattern-count-one": "{0} R☉",
            "unitPattern-count-few": "{0} R☉",
            "unitPattern-count-many": "{0} R☉",
            "unitPattern-count-other": "{0} R☉"
          },
          "light-lux": {
            "displayName": "lx",
            "unitPattern-count-one": "{0} lx",
            "unitPattern-count-few": "{0} lx",
            "unitPattern-count-many": "{0} lx",
            "unitPattern-count-other": "{0} lx"
          },
          "light-solar-luminosity": {
            "displayName": "L☉",
            "unitPattern-count-one": "{0} L☉",
            "unitPattern-count-few": "{0} L☉",
            "unitPattern-count-many": "{0} L☉",
            "unitPattern-count-other": "{0} L☉"
          },
          "mass-metric-ton": {
            "displayName": "mt",
            "unitPattern-count-one": "{0} mt",
            "unitPattern-count-few": "{0} mt",
            "unitPattern-count-many": "{0} mt",
            "unitPattern-count-other": "{0} mt"
          },
          "mass-kilogram": {
            "displayName": "kg",
            "unitPattern-count-one": "{0} kg",
            "unitPattern-count-few": "{0} kg",
            "unitPattern-count-many": "{0} kg",
            "unitPattern-count-other": "{0} kg",
            "perUnitPattern": "{0}/kg"
          },
          "mass-gram": {
            "displayName": "g",
            "unitPattern-count-one": "{0} g",
            "unitPattern-count-few": "{0} g",
            "unitPattern-count-many": "{0} g",
            "unitPattern-count-other": "{0} g",
            "perUnitPattern": "{0}/g"
          },
          "mass-milligram": {
            "displayName": "mg",
            "unitPattern-count-one": "{0} mg",
            "unitPattern-count-few": "{0} mg",
            "unitPattern-count-many": "{0} mg",
            "unitPattern-count-other": "{0} mg"
          },
          "mass-microgram": {
            "displayName": "µg",
            "unitPattern-count-one": "{0} µg",
            "unitPattern-count-few": "{0} µg",
            "unitPattern-count-many": "{0} µg",
            "unitPattern-count-other": "{0} µg"
          },
          "mass-ton": {
            "displayName": "t",
            "unitPattern-count-one": "{0} t",
            "unitPattern-count-few": "{0} t",
            "unitPattern-count-many": "{0} t",
            "unitPattern-count-other": "{0} t"
          },
          "mass-stone": {
            "displayName": "st",
            "unitPattern-count-one": "{0} st",
            "unitPattern-count-few": "{0} st",
            "unitPattern-count-many": "{0} st",
            "unitPattern-count-other": "{0} st"
          },
          "mass-pound": {
            "displayName": "lb",
            "unitPattern-count-one": "{0} lb",
            "unitPattern-count-few": "{0} lb",
            "unitPattern-count-many": "{0} lb",
            "unitPattern-count-other": "{0} lb",
            "perUnitPattern": "{0}/lb"
          },
          "mass-ounce": {
            "displayName": "oz",
            "unitPattern-count-one": "{0} oz",
            "unitPattern-count-few": "{0} oz",
            "unitPattern-count-many": "{0} oz",
            "unitPattern-count-other": "{0} oz",
            "perUnitPattern": "{0}/oz"
          },
          "mass-ounce-troy": {
            "displayName": "oz t",
            "unitPattern-count-one": "{0} oz t",
            "unitPattern-count-few": "{0} oz t",
            "unitPattern-count-many": "{0} oz t",
            "unitPattern-count-other": "{0} oz t"
          },
          "mass-carat": {
            "displayName": "CD",
            "unitPattern-count-one": "{0} CD",
            "unitPattern-count-few": "{0} CD",
            "unitPattern-count-many": "{0} CD",
            "unitPattern-count-other": "{0} CD"
          },
          "mass-dalton": {
            "displayName": "Da",
            "unitPattern-count-one": "{0} Da",
            "unitPattern-count-few": "{0} Da",
            "unitPattern-count-many": "{0} Da",
            "unitPattern-count-other": "{0} Da"
          },
          "mass-earth-mass": {
            "displayName": "M⊕",
            "unitPattern-count-one": "{0} M⊕",
            "unitPattern-count-few": "{0} M⊕",
            "unitPattern-count-many": "{0} M⊕",
            "unitPattern-count-other": "{0} M⊕"
          },
          "mass-solar-mass": {
            "displayName": "M☉",
            "unitPattern-count-one": "{0} M☉",
            "unitPattern-count-few": "{0} M☉",
            "unitPattern-count-many": "{0} M☉",
            "unitPattern-count-other": "{0} M☉"
          },
          "power-gigawatt": {
            "displayName": "GW",
            "unitPattern-count-one": "{0} GW",
            "unitPattern-count-few": "{0} GW",
            "unitPattern-count-many": "{0} GW",
            "unitPattern-count-other": "{0} GW"
          },
          "power-megawatt": {
            "displayName": "MW",
            "unitPattern-count-one": "{0} MW",
            "unitPattern-count-few": "{0} MW",
            "unitPattern-count-many": "{0} MW",
            "unitPattern-count-other": "{0} MW"
          },
          "power-kilowatt": {
            "displayName": "kW",
            "unitPattern-count-one": "{0} kW",
            "unitPattern-count-few": "{0} kW",
            "unitPattern-count-many": "{0} kW",
            "unitPattern-count-other": "{0} kW"
          },
          "power-watt": {
            "displayName": "W",
            "unitPattern-count-one": "{0} W",
            "unitPattern-count-few": "{0} W",
            "unitPattern-count-many": "{0} W",
            "unitPattern-count-other": "{0} W"
          },
          "power-milliwatt": {
            "displayName": "mW",
            "unitPattern-count-one": "{0} mW",
            "unitPattern-count-few": "{0} mW",
            "unitPattern-count-many": "{0} mW",
            "unitPattern-count-other": "{0} mW"
          },
          "power-horsepower": {
            "displayName": "hp",
            "unitPattern-count-one": "{0} hp",
            "unitPattern-count-few": "{0} hp",
            "unitPattern-count-many": "{0} hp",
            "unitPattern-count-other": "{0} hp"
          },
          "pressure-hectopascal": {
            "displayName": "hPa",
            "unitPattern-count-one": "{0} hPa",
            "unitPattern-count-few": "{0} hPa",
            "unitPattern-count-many": "{0} hPa",
            "unitPattern-count-other": "{0} hPa"
          },
          "pressure-millimeter-of-mercury": {
            "displayName": "mm Hg",
            "unitPattern-count-one": "{0} mm Hg",
            "unitPattern-count-few": "{0} mm Hg",
            "unitPattern-count-many": "{0} mm Hg",
            "unitPattern-count-other": "{0} mm Hg"
          },
          "pressure-pound-per-square-inch": {
            "displayName": "psi",
            "unitPattern-count-one": "{0} psi",
            "unitPattern-count-few": "{0} psi",
            "unitPattern-count-many": "{0} psi",
            "unitPattern-count-other": "{0} psi"
          },
          "pressure-inch-hg": {
            "displayName": "inHg",
            "unitPattern-count-one": "{0} inHg",
            "unitPattern-count-few": "{0} inHg",
            "unitPattern-count-many": "{0} inHg",
            "unitPattern-count-other": "{0} inHg"
          },
          "pressure-millibar": {
            "displayName": "mb",
            "unitPattern-count-one": "{0} mb",
            "unitPattern-count-few": "{0} mb",
            "unitPattern-count-many": "{0} mb",
            "unitPattern-count-other": "{0} mb"
          },
          "pressure-atmosphere": {
            "displayName": "atm",
            "unitPattern-count-one": "{0} atm",
            "unitPattern-count-few": "{0} atm",
            "unitPattern-count-many": "{0} atm",
            "unitPattern-count-other": "{0} atm"
          },
          "pressure-kilopascal": {
            "displayName": "kPa",
            "unitPattern-count-one": "{0} kPa",
            "unitPattern-count-few": "{0} kPa",
            "unitPattern-count-many": "{0} kPa",
            "unitPattern-count-other": "{0} kPa"
          },
          "pressure-megapascal": {
            "displayName": "MPa",
            "unitPattern-count-one": "{0} MPa",
            "unitPattern-count-few": "{0} MPa",
            "unitPattern-count-many": "{0} MPa",
            "unitPattern-count-other": "{0} MPa"
          },
          "speed-kilometer-per-hour": {
            "displayName": "km/h",
            "unitPattern-count-one": "{0} km/h",
            "unitPattern-count-few": "{0} km/h",
            "unitPattern-count-many": "{0} km/h",
            "unitPattern-count-other": "{0} km/h"
          },
          "speed-meter-per-second": {
            "displayName": "m/s",
            "unitPattern-count-one": "{0} m/s",
            "unitPattern-count-few": "{0} m/s",
            "unitPattern-count-many": "{0} m/s",
            "unitPattern-count-other": "{0} m/s"
          },
          "speed-mile-per-hour": {
            "displayName": "mi/h",
            "unitPattern-count-one": "{0} mi/h",
            "unitPattern-count-few": "{0} mi/h",
            "unitPattern-count-many": "{0} mi/h",
            "unitPattern-count-other": "{0} mi/h"
          },
          "speed-knot": {
            "displayName": "kn",
            "unitPattern-count-one": "{0} kn",
            "unitPattern-count-few": "{0} kn",
            "unitPattern-count-many": "{0} kn",
            "unitPattern-count-other": "{0} kn"
          },
          "temperature-generic": {
            "displayName": "°",
            "unitPattern-count-one": "{0}°",
            "unitPattern-count-few": "{0}°",
            "unitPattern-count-many": "{0}°",
            "unitPattern-count-other": "{0}°"
          },
          "temperature-celsius": {
            "displayName": "°C",
            "unitPattern-count-one": "{0} °C",
            "unitPattern-count-few": "{0} °C",
            "unitPattern-count-many": "{0} °C",
            "unitPattern-count-other": "{0} °C"
          },
          "temperature-fahrenheit": {
            "displayName": "°F",
            "unitPattern-count-one": "{0} °F",
            "unitPattern-count-few": "{0} °F",
            "unitPattern-count-many": "{0} °F",
            "unitPattern-count-other": "{0} °F"
          },
          "temperature-kelvin": {
            "displayName": "K",
            "unitPattern-count-one": "{0} K",
            "unitPattern-count-few": "{0} K",
            "unitPattern-count-many": "{0} K",
            "unitPattern-count-other": "{0} K"
          },
          "torque-pound-foot": {
            "displayName": "lbf⋅ft",
            "unitPattern-count-one": "{0} lbf⋅ft",
            "unitPattern-count-few": "{0} lbf⋅ft",
            "unitPattern-count-many": "{0} lbf⋅ft",
            "unitPattern-count-other": "{0} lbf⋅ft"
          },
          "torque-newton-meter": {
            "displayName": "Nm",
            "unitPattern-count-one": "{0} Nm",
            "unitPattern-count-few": "{0} Nm",
            "unitPattern-count-many": "{0} Nm",
            "unitPattern-count-other": "{0} Nm"
          },
          "volume-cubic-kilometer": {
            "displayName": "km³",
            "unitPattern-count-one": "{0} km³",
            "unitPattern-count-few": "{0} km³",
            "unitPattern-count-many": "{0} km³",
            "unitPattern-count-other": "{0} km³"
          },
          "volume-cubic-meter": {
            "displayName": "m³",
            "unitPattern-count-one": "{0} m³",
            "unitPattern-count-few": "{0} m³",
            "unitPattern-count-many": "{0} m³",
            "unitPattern-count-other": "{0} m³",
            "perUnitPattern": "{0}/m³"
          },
          "volume-cubic-centimeter": {
            "displayName": "cm³",
            "unitPattern-count-one": "{0} cm³",
            "unitPattern-count-few": "{0} cm³",
            "unitPattern-count-many": "{0} cm³",
            "unitPattern-count-other": "{0} cm³",
            "perUnitPattern": "{0}/cm³"
          },
          "volume-cubic-mile": {
            "displayName": "mi³",
            "unitPattern-count-one": "{0} mi³",
            "unitPattern-count-few": "{0} mi³",
            "unitPattern-count-many": "{0} mi³",
            "unitPattern-count-other": "{0} mi³"
          },
          "volume-cubic-yard": {
            "displayName": "yd³",
            "unitPattern-count-one": "{0} yd³",
            "unitPattern-count-few": "{0} yd³",
            "unitPattern-count-many": "{0} yd³",
            "unitPattern-count-other": "{0} yd³"
          },
          "volume-cubic-foot": {
            "displayName": "ft³",
            "unitPattern-count-one": "{0} ft³",
            "unitPattern-count-few": "{0} ft³",
            "unitPattern-count-many": "{0} ft³",
            "unitPattern-count-other": "{0} ft³"
          },
          "volume-cubic-inch": {
            "displayName": "in³",
            "unitPattern-count-one": "{0} in³",
            "unitPattern-count-few": "{0} in³",
            "unitPattern-count-many": "{0} in³",
            "unitPattern-count-other": "{0} in³"
          },
          "volume-megaliter": {
            "displayName": "Ml",
            "unitPattern-count-one": "{0} Ml",
            "unitPattern-count-few": "{0} Ml",
            "unitPattern-count-many": "{0} Ml",
            "unitPattern-count-other": "{0} Ml"
          },
          "volume-hectoliter": {
            "displayName": "hl",
            "unitPattern-count-one": "{0} hl",
            "unitPattern-count-few": "{0} hl",
            "unitPattern-count-many": "{0} hl",
            "unitPattern-count-other": "{0} hl"
          },
          "volume-liter": {
            "displayName": "l",
            "unitPattern-count-one": "{0} l",
            "unitPattern-count-few": "{0} l",
            "unitPattern-count-many": "{0} l",
            "unitPattern-count-other": "{0} l",
            "perUnitPattern": "{0}/l"
          },
          "volume-deciliter": {
            "displayName": "dl",
            "unitPattern-count-one": "{0} dl",
            "unitPattern-count-few": "{0} dl",
            "unitPattern-count-many": "{0} dl",
            "unitPattern-count-other": "{0} dl"
          },
          "volume-centiliter": {
            "displayName": "cl",
            "unitPattern-count-one": "{0} cl",
            "unitPattern-count-few": "{0} cl",
            "unitPattern-count-many": "{0} cl",
            "unitPattern-count-other": "{0} cl"
          },
          "volume-milliliter": {
            "displayName": "ml",
            "unitPattern-count-one": "{0} ml",
            "unitPattern-count-few": "{0} ml",
            "unitPattern-count-many": "{0} ml",
            "unitPattern-count-other": "{0} ml"
          },
          "volume-pint-metric": {
            "displayName": "mpt",
            "unitPattern-count-one": "{0} mpt",
            "unitPattern-count-few": "{0} mpt",
            "unitPattern-count-many": "{0} mpt",
            "unitPattern-count-other": "{0} mpt"
          },
          "volume-cup-metric": {
            "displayName": "mcup",
            "unitPattern-count-one": "{0} mc",
            "unitPattern-count-few": "{0} mc",
            "unitPattern-count-many": "{0} mc",
            "unitPattern-count-other": "{0} mc"
          },
          "volume-acre-foot": {
            "displayName": "ac ft",
            "unitPattern-count-one": "{0} ac ft",
            "unitPattern-count-few": "{0} ac ft",
            "unitPattern-count-many": "{0} ac ft",
            "unitPattern-count-other": "{0} ac ft"
          },
          "volume-bushel": {
            "displayName": "bu",
            "unitPattern-count-one": "{0} bu",
            "unitPattern-count-few": "{0} bu",
            "unitPattern-count-many": "{0} bu",
            "unitPattern-count-other": "{0} bu"
          },
          "volume-gallon": {
            "displayName": "gal",
            "unitPattern-count-one": "{0} gal",
            "unitPattern-count-few": "{0} gal",
            "unitPattern-count-many": "{0} gal",
            "unitPattern-count-other": "{0} gal",
            "perUnitPattern": "{0}/gal"
          },
          "volume-gallon-imperial": {
            "displayName": "gal Imp.",
            "unitPattern-count-one": "{0} gal Imp.",
            "unitPattern-count-few": "{0} gal Imp.",
            "unitPattern-count-many": "{0} gal Imp.",
            "unitPattern-count-other": "{0} gal Imp.",
            "perUnitPattern": "{0}/gal Imp."
          },
          "volume-quart": {
            "displayName": "qt",
            "unitPattern-count-one": "{0} qt",
            "unitPattern-count-few": "{0} qt",
            "unitPattern-count-many": "{0} qt",
            "unitPattern-count-other": "{0} qt"
          },
          "volume-pint": {
            "displayName": "pt",
            "unitPattern-count-one": "{0} pt",
            "unitPattern-count-few": "{0} pt",
            "unitPattern-count-many": "{0} pt",
            "unitPattern-count-other": "{0} pt"
          },
          "volume-cup": {
            "displayName": "c",
            "unitPattern-count-one": "{0} c",
            "unitPattern-count-few": "{0} c",
            "unitPattern-count-many": "{0} c",
            "unitPattern-count-other": "{0} c"
          },
          "volume-fluid-ounce": {
            "displayName": "fl oz",
            "unitPattern-count-one": "{0} fl oz",
            "unitPattern-count-few": "{0} fl oz",
            "unitPattern-count-many": "{0} fl oz",
            "unitPattern-count-other": "{0} fl oz"
          },
          "volume-fluid-ounce-imperial": {
            "displayName": "fl oz Imp.",
            "unitPattern-count-one": "{0} fl oz Imp.",
            "unitPattern-count-few": "{0} fl oz Imp.",
            "unitPattern-count-many": "{0} fl oz Imp.",
            "unitPattern-count-other": "{0} fl oz Imp."
          },
          "volume-tablespoon": {
            "displayName": "tbsp",
            "unitPattern-count-one": "{0} tbsp",
            "unitPattern-count-few": "{0} tbsp",
            "unitPattern-count-many": "{0} tbsp",
            "unitPattern-count-other": "{0} tbsp"
          },
          "volume-teaspoon": {
            "displayName": "tsp",
            "unitPattern-count-one": "{0} tsp",
            "unitPattern-count-few": "{0} tsp",
            "unitPattern-count-many": "{0} tsp",
            "unitPattern-count-other": "{0} tsp"
          },
          "volume-barrel": {
            "displayName": "bbl",
            "unitPattern-count-one": "{0} bbl",
            "unitPattern-count-few": "{0} bbl",
            "unitPattern-count-many": "{0} bbl",
            "unitPattern-count-other": "{0} bbl"
          },
          "coordinateUnit": {
            "displayName": "směr",
            "east": "{0}E",
            "north": "{0}N",
            "south": "{0}S",
            "west": "{0}W"
          }
        },
        "durationUnit-type-hm": {
          "durationUnitPattern": "h:mm"
        },
        "durationUnit-type-hms": {
          "durationUnitPattern": "h:mm:ss"
        },
        "durationUnit-type-ms": {
          "durationUnitPattern": "m:ss"
        }
      }
    }
  }
}]);
Globalize.loadMessages({
  "cs": {
    "asdf": "asdf"
  }
});
Globalize.loadTimeZone({
  "version": "2018f",
  "zoneData": {
    "Africa": {
      "Abidjan": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Accra": {
        "abbrs": ["LMT", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT", "+0020", "GMT"],
        "untils": [-1640995148000, -1556841600000, -1546388400000, -1525305600000, -1514852400000, -1493769600000, -1483316400000, -1462233600000, -1451780400000, -1430611200000, -1420158000000, -1399075200000, -1388622000000, -1367539200000, -1357086000000, -1336003200000, -1325550000000, -1304380800000, -1293927600000, -1272844800000, -1262391600000, -1241308800000, -1230855600000, -1209772800000, -1199319600000, -1178150400000, -1167697200000, -1146614400000, -1136161200000, -1115078400000, -1104625200000, -1083542400000, -1073089200000, -1051920000000, -1041466800000, -1020384000000, -1009930800000, -988848000000, -978394800000, -957312000000, -946858800000, -925689600000, -915236400000, -894153600000, -883700400000, -862617600000, -852164400000, null],
        "offsets": [0.8667, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0, -20, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Addis_Ababa": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Algiers": {
        "abbrs": ["PMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "CET", "CEST", "CET", "CEST", "CET", "WET", "CET", "WET", "WEST", "WET", "WEST", "CET", "CEST", "CET", "WET", "WEST", "WET", "CET"],
        "untils": [-1855958961000, -1689814800000, -1680397200000, -1665363600000, -1648342800000, -1635123600000, -1616893200000, -1604278800000, -1585443600000, -1574038800000, -1552266000000, -1539997200000, -1531443600000, -956365200000, -950486400000, -942012000000, -812502000000, -796262400000, -781052400000, -766630800000, -733280400000, -439430400000, -212029200000, 41468400000, 54774000000, 231724800000, 246236400000, 259545600000, 275274000000, 309740400000, 325468800000, 341802000000, 357523200000, null],
        "offsets": [-9.35, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, 0, -60, 0, -60, 0, -60, -60, -120, -60, 0, -60, 0, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 0]
      },
      "Asmara": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Asmera": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Bamako": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Bangui": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Banjul": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Bissau": {
        "abbrs": ["LMT", "-01", "GMT"],
        "untils": [-1830380400000, 157770000000, null],
        "offsets": [62.3333, 60, 0],
        "isdsts": [0, 0, 0]
      },
      "Blantyre": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Brazzaville": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Bujumbura": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Cairo": {
        "abbrs": ["EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-929844000000, -923108400000, -906170400000, -892868400000, -875844000000, -857790000000, -844308000000, -825822000000, -812685600000, -794199600000, -779853600000, -762663600000, -399088800000, -386650800000, -368330400000, -355114800000, -336790800000, -323654400000, -305168400000, -292032000000, -273632400000, -260496000000, -242096400000, -228960000000, -210560400000, -197424000000, -178938000000, -165801600000, -147402000000, -134265600000, -115866000000, -102643200000, -84330000000, -71107200000, -52707600000, -39484800000, -21171600000, -7948800000, 10364400000, 23587200000, 41900400000, 55123200000, 73522800000, 86745600000, 105058800000, 118281600000, 136594800000, 149817600000, 168130800000, 181353600000, 199753200000, 212976000000, 231289200000, 244512000000, 262825200000, 276048000000, 294361200000, 307584000000, 325983600000, 339206400000, 357519600000, 370742400000, 396399600000, 402278400000, 426812400000, 433814400000, 452214000000, 465436800000, 483750000000, 496972800000, 515286000000, 528508800000, 546822000000, 560044800000, 578444400000, 591667200000, 610412400000, 623203200000, 641516400000, 654739200000, 673052400000, 686275200000, 704674800000, 717897600000, 736210800000, 749433600000, 767746800000, 780969600000, 799020000000, 812322000000, 830469600000, 843771600000, 861919200000, 875221200000, 893368800000, 906670800000, 925423200000, 938725200000, 956872800000, 970174800000, 988322400000, 1001624400000, 1019772000000, 1033074000000, 1051221600000, 1064523600000, 1083276000000, 1096578000000, 1114725600000, 1128027600000, 1146175200000, 1158872400000, 1177624800000, 1189112400000, 1209074400000, 1219957200000, 1240524000000, 1250802000000, 1272578400000, 1281474000000, 1284069600000, 1285880400000, 1400191200000, 1403816400000, 1406844000000, 1411678800000, null],
        "offsets": [-120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Casablanca": {
        "abbrs": ["LMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "CET", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
        "untils": [-1773012580000, -956361600000, -950490000000, -942019200000, -761187600000, -617241600000, -605149200000, -81432000000, -71110800000, 141264000000, 147222000000, 199756800000, 207702000000, 231292800000, 244249200000, 265507200000, 271033200000, 448243200000, 504918000000, 1212278400000, 1220223600000, 1243814400000, 1250809200000, 1272758400000, 1281222000000, 1301788800000, 1312066800000, 1335664800000, 1342749600000, 1345428000000, 1348970400000, 1367114400000, 1373162400000, 1376100000000, 1382839200000, 1396144800000, 1403920800000, 1406944800000, 1414288800000, 1427594400000, 1434247200000, 1437271200000, 1445738400000, 1459044000000, 1465092000000, 1468116000000, 1477792800000, 1490493600000, 1495332000000, 1498960800000, 1509242400000, 1521943200000, 1526176800000, 1529200800000, 1540692000000, 1553997600000, 1557021600000, 1560045600000, 1572141600000, 1585447200000, 1587261600000, 1590285600000, 1603591200000, 1616896800000, 1618106400000, 1621130400000, 1635645600000, 1651975200000, 1667095200000, 1682215200000, 1698544800000, 1713060000000, 1729994400000, 1743904800000, 1761444000000, 1774749600000, 1792893600000, 1806199200000, 1824948000000, 1837648800000, 1856397600000, 1869098400000, 1887847200000, 1901152800000, 1919296800000, 1932602400000, 1950746400000, 1964052000000, 1982800800000, 1995501600000, 2014250400000, 2026951200000, 2045700000000, 2058400800000, 2077149600000, 2090455200000, 2107994400000, 2121904800000, 2138234400000, null],
        "offsets": [30.3333, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Ceuta": {
        "abbrs": ["WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1630112400000, -1616810400000, -1442451600000, -1427673600000, -1379293200000, -1364774400000, -1348448400000, -1333324800000, -1316390400000, -1301270400000, -81432000000, -71110800000, 141264000000, 147222000000, 199756800000, 207702000000, 231292800000, 244249200000, 265507200000, 271033200000, 448243200000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Conakry": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Dakar": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Dar_es_Salaam": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Djibouti": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Douala": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "El_Aaiun": {
        "abbrs": ["LMT", "-01", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
        "untils": [-1136070432000, 198291600000, 199756800000, 207702000000, 231292800000, 244249200000, 265507200000, 271033200000, 1212278400000, 1220223600000, 1243814400000, 1250809200000, 1272758400000, 1281222000000, 1301788800000, 1312066800000, 1335664800000, 1342749600000, 1345428000000, 1348970400000, 1367114400000, 1373162400000, 1376100000000, 1382839200000, 1396144800000, 1403920800000, 1406944800000, 1414288800000, 1427594400000, 1434247200000, 1437271200000, 1445738400000, 1459044000000, 1465092000000, 1468116000000, 1477792800000, 1490493600000, 1495332000000, 1498960800000, 1509242400000, 1521943200000, 1526176800000, 1529200800000, 1540692000000, 1553997600000, 1557021600000, 1560045600000, 1572141600000, 1585447200000, 1587261600000, 1590285600000, 1603591200000, 1616896800000, 1618106400000, 1621130400000, 1635645600000, 1651975200000, 1667095200000, 1682215200000, 1698544800000, 1713060000000, 1729994400000, 1743904800000, 1761444000000, 1774749600000, 1792893600000, 1806199200000, 1824948000000, 1837648800000, 1856397600000, 1869098400000, 1887847200000, 1901152800000, 1919296800000, 1932602400000, 1950746400000, 1964052000000, 1982800800000, 1995501600000, 2014250400000, 2026951200000, 2045700000000, 2058400800000, 2077149600000, 2090455200000, 2107994400000, 2121904800000, 2138234400000, null],
        "offsets": [52.8, 60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Freetown": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Gaborone": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Harare": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Johannesburg": {
        "abbrs": ["SAST", "SAST", "SAST", "SAST", "SAST", "SAST"],
        "untils": [-2109288600000, -860976000000, -845254800000, -829526400000, -813805200000, null],
        "offsets": [-90, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0]
      },
      "Juba": {
        "abbrs": ["LMT", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "EAT"],
        "untils": [-1230775588000, 10360800000, 24786000000, 41810400000, 56322000000, 73432800000, 87944400000, 104882400000, 119480400000, 136332000000, 151016400000, 167781600000, 182552400000, 199231200000, 214174800000, 230680800000, 245710800000, 262735200000, 277246800000, 294184800000, 308782800000, 325634400000, 340405200000, 357084000000, 371941200000, 388533600000, 403477200000, 419983200000, 435013200000, 452037600000, 466635600000, 483487200000, 498171600000, 947930400000, null],
        "offsets": [-126.4667, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Kampala": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Khartoum": {
        "abbrs": ["LMT", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "CAST", "CAT", "EAT", "CAT"],
        "untils": [-1230775808000, 10360800000, 24786000000, 41810400000, 56322000000, 73432800000, 87944400000, 104882400000, 119480400000, 136332000000, 151016400000, 167781600000, 182552400000, 199231200000, 214174800000, 230680800000, 245710800000, 262735200000, 277246800000, 294184800000, 308782800000, 325634400000, 340405200000, 357084000000, 371941200000, 388533600000, 403477200000, 419983200000, 435013200000, 452037600000, 466635600000, 483487200000, 498171600000, 947930400000, 1509483600000, null],
        "offsets": [-130.1333, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Kigali": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Kinshasa": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Lagos": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Libreville": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Lome": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Luanda": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Lubumbashi": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Lusaka": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Malabo": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Maputo": {
        "abbrs": ["LMT", "CAT"],
        "untils": [-2109291020000, null],
        "offsets": [-130.3333, -120],
        "isdsts": [0, 0]
      },
      "Maseru": {
        "abbrs": ["SAST", "SAST", "SAST", "SAST", "SAST", "SAST"],
        "untils": [-2109288600000, -860976000000, -845254800000, -829526400000, -813805200000, null],
        "offsets": [-90, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0]
      },
      "Mbabane": {
        "abbrs": ["SAST", "SAST", "SAST", "SAST", "SAST", "SAST"],
        "untils": [-2109288600000, -860976000000, -845254800000, -829526400000, -813805200000, null],
        "offsets": [-90, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0]
      },
      "Mogadishu": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Monrovia": {
        "abbrs": ["MMT", "MMT", "GMT"],
        "untils": [-1604359012000, 63593070000, null],
        "offsets": [43.1333, 44.5, 0],
        "isdsts": [0, 0, 0]
      },
      "Nairobi": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Ndjamena": {
        "abbrs": ["LMT", "WAT", "WAST", "WAT"],
        "untils": [-1830387612000, 308703600000, 321314400000, null],
        "offsets": [-60.2, -60, -120, -60],
        "isdsts": [0, 0, 1, 0]
      },
      "Niamey": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Nouakchott": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Ouagadougou": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Porto-Novo": {
        "abbrs": ["LMT", "WAT"],
        "untils": [-1588464816000, null],
        "offsets": [-13.6, -60],
        "isdsts": [0, 0]
      },
      "Sao_Tome": {
        "abbrs": ["LMT", "GMT", "WAT"],
        "untils": [-1830384000000, 1514768400000, null],
        "offsets": [36.75, 0, -60],
        "isdsts": [0, 0, 0]
      },
      "Timbuktu": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Tripoli": {
        "abbrs": ["LMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "EET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "EET", "CET", "CEST", "EET", "CET", "CEST", "EET"],
        "untils": [-1577926364000, -574902000000, -568087200000, -512175600000, -504928800000, -449888400000, -441856800000, -347158800000, 378684000000, 386463600000, 402271200000, 417999600000, 433807200000, 449622000000, 465429600000, 481590000000, 496965600000, 512953200000, 528674400000, 544230000000, 560037600000, 575852400000, 591660000000, 607388400000, 623196000000, 641775600000, 844034400000, 860108400000, 875916000000, 1352505600000, 1364515200000, 1382659200000, null],
        "offsets": [-52.7333, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -120, -60, -120, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0]
      },
      "Tunis": {
        "abbrs": ["PMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1855958961000, -969242400000, -950493600000, -941940000000, -891136800000, -877827600000, -857257200000, -844556400000, -842918400000, -842223600000, -828230400000, -812502000000, -796269600000, -781052400000, -766634400000, 231202800000, 243903600000, 262825200000, 276044400000, 581122800000, 591145200000, 606870000000, 622594800000, 641516400000, 654649200000, 1114902000000, 1128038400000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, null],
        "offsets": [-9.35, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Windhoek": {
        "abbrs": ["+0130", "SAST", "SAST", "SAST", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT", "WAT", "CAT"],
        "untils": [-2109288600000, -860976000000, -845254800000, 637970400000, 764200800000, 778640400000, 796780800000, 810090000000, 828835200000, 841539600000, 860284800000, 873594000000, 891734400000, 905043600000, 923184000000, 936493200000, 954633600000, 967942800000, 986083200000, 999392400000, 1018137600000, 1030842000000, 1049587200000, 1062896400000, 1081036800000, 1094346000000, 1112486400000, 1125795600000, 1143936000000, 1157245200000, 1175385600000, 1188694800000, 1207440000000, 1220749200000, 1238889600000, 1252198800000, 1270339200000, 1283648400000, 1301788800000, 1315098000000, 1333238400000, 1346547600000, 1365292800000, 1377997200000, 1396742400000, 1410051600000, 1428192000000, 1441501200000, 1459641600000, 1472950800000, 1491091200000, 1504400400000, null],
        "offsets": [-90, -120, -180, -120, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120],
        "isdsts": [0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "America": {
      "Adak": {
        "abbrs": ["NST", "NWT", "NPT", "NST", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "AHST", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST"],
        "untils": [-880196400000, -769395600000, -765374400000, -86878800000, -21466800000, -5745600000, 9982800000, 25704000000, 41432400000, 57758400000, 73486800000, 89208000000, 104936400000, 120657600000, 126709200000, 152107200000, 162392400000, 183556800000, 199285200000, 215611200000, 230734800000, 247060800000, 262789200000, 278510400000, 294238800000, 309960000000, 325688400000, 341409600000, 357138000000, 372859200000, 388587600000, 404913600000, 420037200000, 436363200000, 439034400000, 452088000000, 467809200000, 483537600000, 499258800000, 514987200000, 530708400000, 544622400000, 562158000000, 576072000000, 594212400000, 607521600000, 625662000000, 638971200000, 657111600000, 671025600000, 688561200000, 702475200000, 720010800000, 733924800000, 752065200000, 765374400000, 783514800000, 796824000000, 814964400000, 828878400000, 846414000000, 860328000000, 877863600000, 891777600000, 909313200000, 923227200000, 941367600000, 954676800000, 972817200000, 986126400000, 1004266800000, 1018180800000, 1035716400000, 1049630400000, 1067166000000, 1081080000000, 1099220400000, 1112529600000, 1130670000000, 1143979200000, 1162119600000, 1173614400000, 1194174000000, 1205064000000, 1225623600000, 1236513600000, 1257073200000, 1268568000000, 1289127600000, 1300017600000, 1320577200000, 1331467200000, 1352026800000, 1362916800000, 1383476400000, 1394366400000, 1414926000000, 1425816000000, 1446375600000, 1457870400000, 1478430000000, 1489320000000, 1509879600000, 1520769600000, 1541329200000, 1552219200000, 1572778800000, 1583668800000, 1604228400000, 1615723200000, 1636282800000, 1647172800000, 1667732400000, 1678622400000, 1699182000000, 1710072000000, 1730631600000, 1741521600000, 1762081200000, 1772971200000, 1793530800000, 1805025600000, 1825585200000, 1836475200000, 1857034800000, 1867924800000, 1888484400000, 1899374400000, 1919934000000, 1930824000000, 1951383600000, 1962878400000, 1983438000000, 1994328000000, 2014887600000, 2025777600000, 2046337200000, 2057227200000, 2077786800000, 2088676800000, 2109236400000, 2120126400000, 2140686000000, null],
        "offsets": [660, 600, 600, 660, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 600, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600],
        "isdsts": [0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Anchorage": {
        "abbrs": ["AST", "AWT", "APT", "AST", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "YST", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST"],
        "untils": [-880200000000, -769395600000, -765378000000, -86882400000, -21470400000, -5749200000, 9979200000, 25700400000, 41428800000, 57754800000, 73483200000, 89204400000, 104932800000, 120654000000, 126705600000, 152103600000, 162388800000, 183553200000, 199281600000, 215607600000, 230731200000, 247057200000, 262785600000, 278506800000, 294235200000, 309956400000, 325684800000, 341406000000, 357134400000, 372855600000, 388584000000, 404910000000, 420033600000, 436359600000, 439030800000, 452084400000, 467805600000, 483534000000, 499255200000, 514983600000, 530704800000, 544618800000, 562154400000, 576068400000, 594208800000, 607518000000, 625658400000, 638967600000, 657108000000, 671022000000, 688557600000, 702471600000, 720007200000, 733921200000, 752061600000, 765370800000, 783511200000, 796820400000, 814960800000, 828874800000, 846410400000, 860324400000, 877860000000, 891774000000, 909309600000, 923223600000, 941364000000, 954673200000, 972813600000, 986122800000, 1004263200000, 1018177200000, 1035712800000, 1049626800000, 1067162400000, 1081076400000, 1099216800000, 1112526000000, 1130666400000, 1143975600000, 1162116000000, 1173610800000, 1194170400000, 1205060400000, 1225620000000, 1236510000000, 1257069600000, 1268564400000, 1289124000000, 1300014000000, 1320573600000, 1331463600000, 1352023200000, 1362913200000, 1383472800000, 1394362800000, 1414922400000, 1425812400000, 1446372000000, 1457866800000, 1478426400000, 1489316400000, 1509876000000, 1520766000000, 1541325600000, 1552215600000, 1572775200000, 1583665200000, 1604224800000, 1615719600000, 1636279200000, 1647169200000, 1667728800000, 1678618800000, 1699178400000, 1710068400000, 1730628000000, 1741518000000, 1762077600000, 1772967600000, 1793527200000, 1805022000000, 1825581600000, 1836471600000, 1857031200000, 1867921200000, 1888480800000, 1899370800000, 1919930400000, 1930820400000, 1951380000000, 1962874800000, 1983434400000, 1994324400000, 2014884000000, 2025774000000, 2046333600000, 2057223600000, 2077783200000, 2088673200000, 2109232800000, 2120122800000, 2140682400000, null],
        "offsets": [600, 540, 540, 600, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 540, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540],
        "isdsts": [0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Anguilla": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Antigua": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Araguaina": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1767214032000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -191365200000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, 592974000000, 602042400000, 624423600000, 634701600000, 813726000000, 824004000000, 844570800000, 856058400000, 876106800000, 888717600000, 908074800000, 919562400000, 938919600000, 951616800000, 970974000000, 982461600000, 1003028400000, 1013911200000, 1036292400000, 1045360800000, 1350788400000, 1361066400000, null],
        "offsets": [192.8, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Argentina": {
        "Buenos_Aires": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687927600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, 1224385200000, 1237082400000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 180, 180, 120, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Catamarca": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1086058800000, 1087704000000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
        },
        "ComodRivadavia": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1086058800000, 1087704000000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
        },
        "Cordoba": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, 1224385200000, 1237082400000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 120, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Jujuy": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-03", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 657086400000, 669178800000, 686721600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 240, 180, 240, 120, 180, 120, 180, 180, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "La_Rioja": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-03", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667792800000, 673588800000, 687927600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1086058800000, 1087704000000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 180, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
        },
        "Mendoza": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-03", "-04", "-03", "-04", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 655963200000, 667796400000, 687499200000, 699418800000, 719380800000, 731469600000, 938919600000, 952052400000, 1085281200000, 1096171200000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 240, 180, 240, 180, 240, 120, 180, 180, 180, 240, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
        },
        "Rio_Gallegos": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687927600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1086058800000, 1087704000000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
        },
        "Salta": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "San_Juan": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-03", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667792800000, 673588800000, 687927600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1085972400000, 1090728000000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 180, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
        },
        "San_Luis": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-03", "-04", "-03", "-03", "-03", "-04", "-03", "-02", "-03", "-04", "-03", "-04", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 637380000000, 655963200000, 667796400000, 675748800000, 938919600000, 952052400000, 1085972400000, 1090728000000, 1198983600000, 1200880800000, 1205031600000, 1223784000000, 1236481200000, 1255233600000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 240, 180, 240, 180, 180, 180, 240, 180, 120, 180, 240, 180, 240, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 1, 1, 0, 1, 0, 0]
        },
        "Tucuman": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1086058800000, 1087099200000, 1198983600000, 1205632800000, 1224385200000, 1237082400000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0]
        },
        "Ushuaia": {
          "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
          "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687927600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1085886000000, 1087704000000, 1198983600000, 1205632800000, null],
          "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180],
          "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
        }
      },
      "Aruba": {
        "abbrs": ["LMT", "-0430", "AST"],
        "untils": [-1826738653000, -157750200000, null],
        "offsets": [275.7833, 270, 240],
        "isdsts": [0, 0, 0]
      },
      "Asuncion": {
        "abbrs": ["AMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03"],
        "untils": [-1206389360000, 86760000000, 134017200000, 181368000000, 194497200000, 212990400000, 226033200000, 244526400000, 257569200000, 276062400000, 291783600000, 307598400000, 323406000000, 339220800000, 354942000000, 370756800000, 386478000000, 402292800000, 418014000000, 433828800000, 449636400000, 465451200000, 481172400000, 496987200000, 512708400000, 528523200000, 544244400000, 560059200000, 575866800000, 591681600000, 607402800000, 625032000000, 638938800000, 654753600000, 670474800000, 686721600000, 699418800000, 718257600000, 733546800000, 749448000000, 762318000000, 780984000000, 793767600000, 812520000000, 825649200000, 844574400000, 856666800000, 876024000000, 888721200000, 907473600000, 920775600000, 938923200000, 952225200000, 970372800000, 983674800000, 1002427200000, 1018148400000, 1030852800000, 1049598000000, 1062907200000, 1081047600000, 1097985600000, 1110682800000, 1129435200000, 1142132400000, 1160884800000, 1173582000000, 1192939200000, 1205031600000, 1224388800000, 1236481200000, 1255838400000, 1270954800000, 1286078400000, 1302404400000, 1317528000000, 1333854000000, 1349582400000, 1364094000000, 1381032000000, 1395543600000, 1412481600000, 1426993200000, 1443931200000, 1459047600000, 1475380800000, 1490497200000, 1506830400000, 1521946800000, 1538884800000, 1553396400000, 1570334400000, 1584846000000, 1601784000000, 1616900400000, 1633233600000, 1648350000000, 1664683200000, 1679799600000, 1696132800000, 1711249200000, 1728187200000, 1742698800000, 1759636800000, 1774148400000, 1791086400000, 1806202800000, 1822536000000, 1837652400000, 1853985600000, 1869102000000, 1886040000000, 1900551600000, 1917489600000, 1932001200000, 1948939200000, 1964055600000, 1980388800000, 1995505200000, 2011838400000, 2026954800000, 2043288000000, 2058404400000, 2075342400000, 2089854000000, 2106792000000, 2121303600000, 2138241600000, null],
        "offsets": [230.6667, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180],
        "isdsts": [0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Atikokan": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CWT", "CPT", "EST"],
        "untils": [-1632067200000, -1615136400000, -923248800000, -880214400000, -769395600000, -765392400000, null],
        "offsets": [360, 300, 360, 300, 300, 300, 300],
        "isdsts": [0, 1, 0, 1, 1, 1, 0]
      },
      "Atka": {
        "abbrs": ["NST", "NWT", "NPT", "NST", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "AHST", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST"],
        "untils": [-880196400000, -769395600000, -765374400000, -86878800000, -21466800000, -5745600000, 9982800000, 25704000000, 41432400000, 57758400000, 73486800000, 89208000000, 104936400000, 120657600000, 126709200000, 152107200000, 162392400000, 183556800000, 199285200000, 215611200000, 230734800000, 247060800000, 262789200000, 278510400000, 294238800000, 309960000000, 325688400000, 341409600000, 357138000000, 372859200000, 388587600000, 404913600000, 420037200000, 436363200000, 439034400000, 452088000000, 467809200000, 483537600000, 499258800000, 514987200000, 530708400000, 544622400000, 562158000000, 576072000000, 594212400000, 607521600000, 625662000000, 638971200000, 657111600000, 671025600000, 688561200000, 702475200000, 720010800000, 733924800000, 752065200000, 765374400000, 783514800000, 796824000000, 814964400000, 828878400000, 846414000000, 860328000000, 877863600000, 891777600000, 909313200000, 923227200000, 941367600000, 954676800000, 972817200000, 986126400000, 1004266800000, 1018180800000, 1035716400000, 1049630400000, 1067166000000, 1081080000000, 1099220400000, 1112529600000, 1130670000000, 1143979200000, 1162119600000, 1173614400000, 1194174000000, 1205064000000, 1225623600000, 1236513600000, 1257073200000, 1268568000000, 1289127600000, 1300017600000, 1320577200000, 1331467200000, 1352026800000, 1362916800000, 1383476400000, 1394366400000, 1414926000000, 1425816000000, 1446375600000, 1457870400000, 1478430000000, 1489320000000, 1509879600000, 1520769600000, 1541329200000, 1552219200000, 1572778800000, 1583668800000, 1604228400000, 1615723200000, 1636282800000, 1647172800000, 1667732400000, 1678622400000, 1699182000000, 1710072000000, 1730631600000, 1741521600000, 1762081200000, 1772971200000, 1793530800000, 1805025600000, 1825585200000, 1836475200000, 1857034800000, 1867924800000, 1888484400000, 1899374400000, 1919934000000, 1930824000000, 1951383600000, 1962878400000, 1983438000000, 1994328000000, 2014887600000, 2025777600000, 2046337200000, 2057227200000, 2077786800000, 2088676800000, 2109236400000, 2120126400000, 2140686000000, null],
        "offsets": [660, 600, 600, 660, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 600, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600],
        "isdsts": [0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bahia": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1767216356000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -191365200000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, 592974000000, 602042400000, 624423600000, 634701600000, 656478000000, 666756000000, 687927600000, 697600800000, 719982000000, 728445600000, 750826800000, 761709600000, 782276400000, 793159200000, 813726000000, 824004000000, 844570800000, 856058400000, 876106800000, 888717600000, 908074800000, 919562400000, 938919600000, 951616800000, 970974000000, 982461600000, 1003028400000, 1013911200000, 1036292400000, 1045360800000, 1318734000000, 1330221600000, null],
        "offsets": [154.0667, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bahia_Banderas": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "MST", "PST", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, -873828000000, -661539600000, 28800000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 989139600000, 1001836800000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1175418000000, 1193558400000, 1207472400000, 1225008000000, 1238922000000, 1256457600000, 1270371600000, 1288508400000, 1301817600000, 1319958000000, 1333267200000, 1351407600000, 1365321600000, 1382857200000, 1396771200000, 1414306800000, 1428220800000, 1445756400000, 1459670400000, 1477810800000, 1491120000000, 1509260400000, 1522569600000, 1540710000000, 1554624000000, 1572159600000, 1586073600000, 1603609200000, 1617523200000, 1635663600000, 1648972800000, 1667113200000, 1680422400000, 1698562800000, 1712476800000, 1730012400000, 1743926400000, 1761462000000, 1775376000000, 1792911600000, 1806825600000, 1824966000000, 1838275200000, 1856415600000, 1869724800000, 1887865200000, 1901779200000, 1919314800000, 1933228800000, 1950764400000, 1964678400000, 1982818800000, 1996128000000, 2014268400000, 2027577600000, 2045718000000, 2059027200000, 2077167600000, 2091081600000, 2108617200000, 2122531200000, 2140066800000, null],
        "offsets": [421, 420, 360, 420, 360, 420, 360, 420, 480, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Barbados": {
        "abbrs": ["LMT", "BMT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-1451678491000, -1199217691000, 234943200000, 244616400000, 261554400000, 276066000000, 293004000000, 307515600000, 325058400000, 338706000000, null],
        "offsets": [238.4833, 238.4833, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Belem": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1767213964000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -191365200000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, null],
        "offsets": [193.9333, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Belize": {
        "abbrs": ["LMT", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "-0530", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1822500432000, -1616954400000, -1606069800000, -1585504800000, -1574015400000, -1554055200000, -1542565800000, -1522605600000, -1511116200000, -1490551200000, -1479666600000, -1459101600000, -1448217000000, -1427652000000, -1416162600000, -1396202400000, -1384713000000, -1364752800000, -1353263400000, -1333303200000, -1321813800000, -1301248800000, -1290364200000, -1269799200000, -1258914600000, -1238349600000, -1226860200000, -1206900000000, -1195410600000, -1175450400000, -1163961000000, -1143396000000, -1132511400000, -1111946400000, -1101061800000, -1080496800000, -1069612200000, -1049047200000, -1037557800000, -1017597600000, -1006108200000, -986148000000, -974658600000, -954093600000, -943209000000, -922644000000, -911759400000, -891194400000, -879705000000, -859744800000, -848255400000, 123919200000, 129618000000, 409039200000, 413874000000, null],
        "offsets": [352.8, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 330, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Blanc-Sablon": {
        "abbrs": ["AST", "ADT", "AST", "AWT", "APT", "AST"],
        "untils": [-1632074400000, -1615143600000, -880221600000, -769395600000, -765399600000, null],
        "offsets": [240, 180, 240, 180, 180, 240],
        "isdsts": [0, 1, 0, 1, 1, 0]
      },
      "Boa_Vista": {
        "abbrs": ["LMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04"],
        "untils": [-1767211040000, -1206954000000, -1191358800000, -1175371200000, -1159822800000, -633816000000, -622065600000, -602280000000, -591829200000, -570744000000, -560206800000, -539121600000, -531349200000, -191361600000, -184194000000, -155160000000, -150066000000, -128894400000, -121122000000, -99950400000, -89586000000, -68414400000, -57963600000, 499752000000, 511239600000, 530596800000, 540270000000, 562132800000, 571201200000, 938923200000, 951620400000, 970977600000, 971578800000, null],
        "offsets": [242.6667, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bogota": {
        "abbrs": ["BMT", "-05", "-04", "-05"],
        "untils": [-1739041424000, 704869200000, 733896000000, null],
        "offsets": [296.2667, 300, 240, 300],
        "isdsts": [0, 0, 1, 0]
      },
      "Boise": {
        "abbrs": ["PST", "PDT", "PST", "PDT", "PST", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1633269600000, -1615129200000, -1601820000000, -1583679600000, -1471788000000, -880210800000, -769395600000, -765388800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 129114000000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [480, 420, 480, 420, 480, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Buenos_Aires": {
        "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687927600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, 1224385200000, 1237082400000, null],
        "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 180, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Cambridge_Bay": {
        "abbrs": ["-00", "MST", "MWT", "MPT", "MST", "MDDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "CST", "CDT", "EST", "CST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1577923200000, -880210800000, -769395600000, -765388800000, -147891600000, -131562000000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954662400000, 972802800000, 973400400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [0, 420, 360, 360, 420, 300, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 300, 300, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Campo_Grande": {
        "abbrs": ["LMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03"],
        "untils": [-1767212492000, -1206954000000, -1191358800000, -1175371200000, -1159822800000, -633816000000, -622065600000, -602280000000, -591829200000, -570744000000, -560206800000, -539121600000, -531349200000, -191361600000, -184194000000, -155160000000, -150066000000, -128894400000, -121122000000, -99950400000, -89586000000, -68414400000, -57963600000, 499752000000, 511239600000, 530596800000, 540270000000, 562132800000, 571201200000, 592977600000, 602046000000, 624427200000, 634705200000, 656481600000, 666759600000, 687931200000, 697604400000, 719985600000, 728449200000, 750830400000, 761713200000, 782280000000, 793162800000, 813729600000, 824007600000, 844574400000, 856062000000, 876110400000, 888721200000, 908078400000, 919566000000, 938923200000, 951620400000, 970977600000, 982465200000, 1003032000000, 1013914800000, 1036296000000, 1045364400000, 1066536000000, 1076814000000, 1099368000000, 1108868400000, 1129435200000, 1140318000000, 1162699200000, 1172372400000, 1192334400000, 1203217200000, 1224388800000, 1234666800000, 1255838400000, 1266721200000, 1287288000000, 1298170800000, 1318737600000, 1330225200000, 1350792000000, 1361070000000, 1382241600000, 1392519600000, 1413691200000, 1424574000000, 1445140800000, 1456023600000, 1476590400000, 1487473200000, 1508040000000, 1518922800000, 1541304000000, 1550372400000, 1572753600000, 1581822000000, 1604203200000, 1613876400000, 1636257600000, 1645326000000, 1667707200000, 1677380400000, 1699156800000, 1708225200000, 1730606400000, 1739674800000, 1762056000000, 1771729200000, 1793505600000, 1803178800000, 1825560000000, 1834628400000, 1857009600000, 1866078000000, 1888459200000, 1897527600000, 1919908800000, 1928977200000, 1951358400000, 1960426800000, 1983412800000, 1992481200000, 2014862400000, 2024535600000, 2046312000000, 2055380400000, 2077761600000, 2086830000000, 2109211200000, 2118884400000, 2140660800000, null],
        "offsets": [218.4667, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Cancun": {
        "abbrs": ["LMT", "CST", "EST", "EDT", "EST", "EDT", "EST", "EDT", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST"],
        "untils": [-1514743200000, 377935200000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 902037600000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 989136000000, 1001833200000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1175414400000, 1193554800000, 1207468800000, 1225004400000, 1238918400000, 1256454000000, 1270368000000, 1288508400000, 1301817600000, 1319958000000, 1333267200000, 1351407600000, 1365321600000, 1382857200000, 1396771200000, 1414306800000, 1422777600000, null],
        "offsets": [347.0667, 360, 300, 240, 300, 240, 300, 240, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Caracas": {
        "abbrs": ["CMT", "-0430", "-04", "-0430", "-04"],
        "untils": [-1826739140000, -157750200000, 1197183600000, 1462086000000, null],
        "offsets": [267.6667, 270, 240, 270, 240],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Catamarca": {
        "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
        "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1086058800000, 1087704000000, 1198983600000, 1205632800000, null],
        "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 240, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
      },
      "Cayenne": {
        "abbrs": ["LMT", "-04", "-03"],
        "untils": [-1846269040000, -71092800000, null],
        "offsets": [209.3333, 240, 180],
        "isdsts": [0, 0, 0]
      },
      "Cayman": {
        "abbrs": ["CMT", "EST"],
        "untils": [-1946918424000, null],
        "offsets": [319.6, 300],
        "isdsts": [0, 0]
      },
      "Chicago": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -1563724800000, -1551632400000, -1538928000000, -1520182800000, -1504454400000, -1491757200000, -1473004800000, -1459702800000, -1441555200000, -1428253200000, -1410105600000, -1396803600000, -1378656000000, -1365354000000, -1347206400000, -1333904400000, -1315152000000, -1301850000000, -1283702400000, -1270400400000, -1252252800000, -1238950800000, -1220803200000, -1207501200000, -1189353600000, -1176051600000, -1157299200000, -1144602000000, -1125849600000, -1112547600000, -1094400000000, -1081098000000, -1067788800000, -1045414800000, -1031500800000, -1018198800000, -1000051200000, -986749200000, -967996800000, -955299600000, -936547200000, -923245200000, -905097600000, -891795600000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -447267600000, -431539200000, -415818000000, -400089600000, -384368400000, -368640000000, -352918800000, -337190400000, -321469200000, -305740800000, -289414800000, -273686400000, -257965200000, -242236800000, -226515600000, -210787200000, -195066000000, -179337600000, -163616400000, -147888000000, -131562000000, -116438400000, -100112400000, -84384000000, -68662800000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Chihuahua": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "CDT", "CST", "CDT", "CST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, 828864000000, 846399600000, 860313600000, 877849200000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 989139600000, 1001836800000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1175418000000, 1193558400000, 1207472400000, 1225008000000, 1238922000000, 1256457600000, 1270371600000, 1288512000000, 1301821200000, 1319961600000, 1333270800000, 1351411200000, 1365325200000, 1382860800000, 1396774800000, 1414310400000, 1428224400000, 1445760000000, 1459674000000, 1477814400000, 1491123600000, 1509264000000, 1522573200000, 1540713600000, 1554627600000, 1572163200000, 1586077200000, 1603612800000, 1617526800000, 1635667200000, 1648976400000, 1667116800000, 1680426000000, 1698566400000, 1712480400000, 1730016000000, 1743930000000, 1761465600000, 1775379600000, 1792915200000, 1806829200000, 1824969600000, 1838278800000, 1856419200000, 1869728400000, 1887868800000, 1901782800000, 1919318400000, 1933232400000, 1950768000000, 1964682000000, 1982822400000, 1996131600000, 2014272000000, 2027581200000, 2045721600000, 2059030800000, 2077171200000, 2091085200000, 2108620800000, 2122534800000, 2140070400000, null],
        "offsets": [424.3333, 420, 360, 420, 360, 420, 360, 300, 360, 300, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Coral_Harbour": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CWT", "CPT", "EST"],
        "untils": [-1632067200000, -1615136400000, -923248800000, -880214400000, -769395600000, -765392400000, null],
        "offsets": [360, 300, 360, 300, 300, 300, 300],
        "isdsts": [0, 1, 0, 1, 1, 1, 0]
      },
      "Cordoba": {
        "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, 1224385200000, 1237082400000, null],
        "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Costa_Rica": {
        "abbrs": ["SJMT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1545071027000, 288770400000, 297234000000, 320220000000, 328683600000, 664264800000, 678344400000, 695714400000, 700635600000, null],
        "offsets": [336.2167, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Creston": {
        "abbrs": ["MST", "PST", "MST"],
        "untils": [-1680454800000, -1627833600000, null],
        "offsets": [420, 480, 420],
        "isdsts": [0, 0, 0]
      },
      "Cuiaba": {
        "abbrs": ["LMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03"],
        "untils": [-1767212140000, -1206954000000, -1191358800000, -1175371200000, -1159822800000, -633816000000, -622065600000, -602280000000, -591829200000, -570744000000, -560206800000, -539121600000, -531349200000, -191361600000, -184194000000, -155160000000, -150066000000, -128894400000, -121122000000, -99950400000, -89586000000, -68414400000, -57963600000, 499752000000, 511239600000, 530596800000, 540270000000, 562132800000, 571201200000, 592977600000, 602046000000, 624427200000, 634705200000, 656481600000, 666759600000, 687931200000, 697604400000, 719985600000, 728449200000, 750830400000, 761713200000, 782280000000, 793162800000, 813729600000, 824007600000, 844574400000, 856062000000, 876110400000, 888721200000, 908078400000, 919566000000, 938923200000, 951620400000, 970977600000, 982465200000, 1003032000000, 1013914800000, 1036296000000, 1045364400000, 1099368000000, 1108868400000, 1129435200000, 1140318000000, 1162699200000, 1172372400000, 1192334400000, 1203217200000, 1224388800000, 1234666800000, 1255838400000, 1266721200000, 1287288000000, 1298170800000, 1318737600000, 1330225200000, 1350792000000, 1361070000000, 1382241600000, 1392519600000, 1413691200000, 1424574000000, 1445140800000, 1456023600000, 1476590400000, 1487473200000, 1508040000000, 1518922800000, 1541304000000, 1550372400000, 1572753600000, 1581822000000, 1604203200000, 1613876400000, 1636257600000, 1645326000000, 1667707200000, 1677380400000, 1699156800000, 1708225200000, 1730606400000, 1739674800000, 1762056000000, 1771729200000, 1793505600000, 1803178800000, 1825560000000, 1834628400000, 1857009600000, 1866078000000, 1888459200000, 1897527600000, 1919908800000, 1928977200000, 1951358400000, 1960426800000, 1983412800000, 1992481200000, 2014862400000, 2024535600000, 2046312000000, 2055380400000, 2077761600000, 2086830000000, 2109211200000, 2118884400000, 2140660800000, null],
        "offsets": [224.3333, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Curacao": {
        "abbrs": ["LMT", "-0430", "AST"],
        "untils": [-1826738653000, -157750200000, null],
        "offsets": [275.7833, 270, 240],
        "isdsts": [0, 0, 0]
      },
      "Danmarkshavn": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "GMT"],
        "untils": [-1686091520000, 323845200000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 820465200000, null],
        "offsets": [74.6667, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Dawson": {
        "abbrs": ["YST", "YDT", "YST", "YDT", "YST", "YWT", "YPT", "YST", "YDDT", "YST", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1632056400000, -1615125600000, -1596978000000, -1583164800000, -880203600000, -769395600000, -765381600000, -147884400000, -131554800000, 120646800000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [540, 480, 540, 480, 540, 480, 480, 540, 420, 540, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Dawson_Creek": {
        "abbrs": ["PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "MST"],
        "untils": [-1632060000000, -1615129200000, -880207200000, -769395600000, -765385200000, -715788000000, -702486000000, -684338400000, -671036400000, -652888800000, -639586800000, -620834400000, -608137200000, -589384800000, -576082800000, -557935200000, -544633200000, -526485600000, -513183600000, -495036000000, -481734000000, -463586400000, -450284400000, -431532000000, -418230000000, -400082400000, -386780400000, -368632800000, -355330800000, -337183200000, -323881200000, -305733600000, -292431600000, -273679200000, -260982000000, -242229600000, -226508400000, -210780000000, -195058800000, -179330400000, -163609200000, -147880800000, -131554800000, -116431200000, -100105200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 84013200000, null],
        "offsets": [480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 420],
        "isdsts": [0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Denver": {
        "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -1570374000000, -1551628800000, -1538924400000, -1534089600000, -880210800000, -769395600000, -765388800000, -147884400000, -131558400000, -116434800000, -100108800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Detroit": {
        "abbrs": ["LMT", "CST", "EST", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-2051202469000, -1724083200000, -880218000000, -769395600000, -765396000000, -684349200000, -671047200000, 104914800000, 120636000000, 126687600000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [332.1833, 360, 300, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Dominica": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Edmonton": {
        "abbrs": ["LMT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1998663968000, -1632063600000, -1615132800000, -1600614000000, -1596816000000, -1567954800000, -1551628800000, -1536505200000, -1523203200000, -1504450800000, -1491753600000, -1473001200000, -1459699200000, -880210800000, -769395600000, -765388800000, -715791600000, -702489600000, -84380400000, -68659200000, -21481200000, -5760000000, 73472400000, 89193600000, 104922000000, 120643200000, 136371600000, 152092800000, 167821200000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [453.8667, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Eirunepe": {
        "abbrs": ["LMT", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05"],
        "untils": [-1767208832000, -1206950400000, -1191355200000, -1175367600000, -1159819200000, -633812400000, -622062000000, -602276400000, -591825600000, -570740400000, -560203200000, -539118000000, -531345600000, -191358000000, -184190400000, -155156400000, -150062400000, -128890800000, -121118400000, -99946800000, -89582400000, -68410800000, -57960000000, 499755600000, 511243200000, 530600400000, 540273600000, 562136400000, 571204800000, 750834000000, 761716800000, 1214283600000, 1384056000000, null],
        "offsets": [279.4667, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "El_Salvador": {
        "abbrs": ["LMT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1546279392000, 547020000000, 559717200000, 578469600000, 591166800000, null],
        "offsets": [356.8, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0]
      },
      "Ensenada": {
        "abbrs": ["LMT", "MST", "PST", "MST", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1514736000000, -1451667600000, -1343062800000, -1234803600000, -1222963200000, -1207242000000, -873820800000, -769395600000, -761677200000, -686073600000, -661539600000, -495039600000, -481734000000, -463590000000, -450284400000, -431535600000, -418230000000, -400086000000, -386780400000, -368636400000, -355330800000, -337186800000, -323881200000, -305737200000, -292431600000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1175421600000, 1193562000000, 1207476000000, 1225011600000, 1238925600000, 1256461200000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [468.0667, 420, 480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Fort_Nelson": {
        "abbrs": ["PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "MST"],
        "untils": [-1632060000000, -1615129200000, -880207200000, -769395600000, -765385200000, -715788000000, -702486000000, -684338400000, -671036400000, -652888800000, -639586800000, -620834400000, -608137200000, -589384800000, -576082800000, -557935200000, -544633200000, -526485600000, -513183600000, -495036000000, -481734000000, -463586400000, -450284400000, -431532000000, -418230000000, -400082400000, -386780400000, -368632800000, -355330800000, -337183200000, -323881200000, -305733600000, -292431600000, -273679200000, -260982000000, -242229600000, -226508400000, -210780000000, -195058800000, -179330400000, -163609200000, -147880800000, -131554800000, -116431200000, -100105200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 136375200000, 152096400000, 167824800000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, null],
        "offsets": [480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420],
        "isdsts": [0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Fort_Wayne": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -900259200000, -891795600000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -386787600000, -368640000000, -21488400000, -5767200000, 9961200000, 25682400000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Fortaleza": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1767216360000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -191365200000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, 592974000000, 602042400000, 624423600000, 634701600000, 938919600000, 951616800000, 970974000000, 972180000000, 1003028400000, 1013911200000, null],
        "offsets": [154, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Glace_Bay": {
        "abbrs": ["LMT", "AST", "ADT", "AST", "AWT", "APT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-2131646412000, -1632074400000, -1615143600000, -880221600000, -769395600000, -765399600000, -526500000000, -513198000000, 73461600000, 89182800000, 104911200000, 120632400000, 136360800000, 152082000000, 167810400000, 183531600000, 199260000000, 215586000000, 230709600000, 247035600000, 262764000000, 278485200000, 294213600000, 309934800000, 325663200000, 341384400000, 357112800000, 372834000000, 388562400000, 404888400000, 420012000000, 436338000000, 452066400000, 467787600000, 483516000000, 499237200000, 514965600000, 530686800000, 544600800000, 562136400000, 576050400000, 594190800000, 607500000000, 625640400000, 638949600000, 657090000000, 671004000000, 688539600000, 702453600000, 719989200000, 733903200000, 752043600000, 765352800000, 783493200000, 796802400000, 814942800000, 828856800000, 846392400000, 860306400000, 877842000000, 891756000000, 909291600000, 923205600000, 941346000000, 954655200000, 972795600000, 986104800000, 1004245200000, 1018159200000, 1035694800000, 1049608800000, 1067144400000, 1081058400000, 1099198800000, 1112508000000, 1130648400000, 1143957600000, 1162098000000, 1173592800000, 1194152400000, 1205042400000, 1225602000000, 1236492000000, 1257051600000, 1268546400000, 1289106000000, 1299996000000, 1320555600000, 1331445600000, 1352005200000, 1362895200000, 1383454800000, 1394344800000, 1414904400000, 1425794400000, 1446354000000, 1457848800000, 1478408400000, 1489298400000, 1509858000000, 1520748000000, 1541307600000, 1552197600000, 1572757200000, 1583647200000, 1604206800000, 1615701600000, 1636261200000, 1647151200000, 1667710800000, 1678600800000, 1699160400000, 1710050400000, 1730610000000, 1741500000000, 1762059600000, 1772949600000, 1793509200000, 1805004000000, 1825563600000, 1836453600000, 1857013200000, 1867903200000, 1888462800000, 1899352800000, 1919912400000, 1930802400000, 1951362000000, 1962856800000, 1983416400000, 1994306400000, 2014866000000, 2025756000000, 2046315600000, 2057205600000, 2077765200000, 2088655200000, 2109214800000, 2120104800000, 2140664400000, null],
        "offsets": [239.8, 240, 180, 240, 180, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Godthab": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1686083584000, 323845200000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [206.9333, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Goose_Bay": {
        "abbrs": ["NST", "NDT", "NST", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NWT", "NPT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADDT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-1632076148000, -1615145348000, -1096921748000, -1061670600000, -1048973400000, -1030221000000, -1017523800000, -998771400000, -986074200000, -966717000000, -954624600000, -935267400000, -922570200000, -903817800000, -891120600000, -872368200000, -769395600000, -765401400000, -746044200000, -733347000000, -714594600000, -701897400000, -683145000000, -670447800000, -651695400000, -638998200000, -619641000000, -606943800000, -589401000000, -576099000000, -557951400000, -544649400000, -526501800000, -513199800000, -495052200000, -481750200000, -463602600000, -450300600000, -431548200000, -418246200000, -400098600000, -386796600000, -368649000000, -355347000000, -337199400000, -323897400000, -305749800000, -289423800000, -273695400000, -257974200000, -242245800000, -226524600000, -210796200000, -195075000000, -179346600000, -163625400000, -147897000000, -131571000000, -119903400000, -116445600000, -100119600000, -84391200000, -68670000000, -52941600000, -37220400000, -21492000000, -5770800000, 9957600000, 25678800000, 41407200000, 57733200000, 73461600000, 89182800000, 104911200000, 120632400000, 136360800000, 152082000000, 167810400000, 183531600000, 199260000000, 215586000000, 230709600000, 247035600000, 262764000000, 278485200000, 294213600000, 309934800000, 325663200000, 341384400000, 357112800000, 372834000000, 388562400000, 404888400000, 420012000000, 436338000000, 452066400000, 467787600000, 483516000000, 499237200000, 514965600000, 530686800000, 544593660000, 562129260000, 576043260000, 594180060000, 607492860000, 625633260000, 638942460000, 657082860000, 670996860000, 688532460000, 702446460000, 719982060000, 733896060000, 752036460000, 765345660000, 783486060000, 796795260000, 814935660000, 828849660000, 846385260000, 860299260000, 877834860000, 891748860000, 909284460000, 923198460000, 941338860000, 954648060000, 972788460000, 986097660000, 1004238060000, 1018152060000, 1035687660000, 1049601660000, 1067137260000, 1081051260000, 1099191660000, 1112500860000, 1130641260000, 1143950460000, 1162090860000, 1173585660000, 1194145260000, 1205035260000, 1225594860000, 1236484860000, 1257044460000, 1268539260000, 1289098860000, 1299988860000, 1320555600000, 1331445600000, 1352005200000, 1362895200000, 1383454800000, 1394344800000, 1414904400000, 1425794400000, 1446354000000, 1457848800000, 1478408400000, 1489298400000, 1509858000000, 1520748000000, 1541307600000, 1552197600000, 1572757200000, 1583647200000, 1604206800000, 1615701600000, 1636261200000, 1647151200000, 1667710800000, 1678600800000, 1699160400000, 1710050400000, 1730610000000, 1741500000000, 1762059600000, 1772949600000, 1793509200000, 1805004000000, 1825563600000, 1836453600000, 1857013200000, 1867903200000, 1888462800000, 1899352800000, 1919912400000, 1930802400000, 1951362000000, 1962856800000, 1983416400000, 1994306400000, 2014866000000, 2025756000000, 2046315600000, 2057205600000, 2077765200000, 2088655200000, 2109214800000, 2120104800000, 2140664400000, null],
        "offsets": [210.8667, 150.8667, 210.8667, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 120, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Grand_Turk": {
        "abbrs": ["KMT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "AST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1827687170000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [307.1667, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Grenada": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Guadeloupe": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Guatemala": {
        "abbrs": ["LMT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1617040676000, 123055200000, 130914000000, 422344800000, 433054800000, 669708000000, 684219600000, 1146376800000, 1159678800000, null],
        "offsets": [362.0667, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Guayaquil": {
        "abbrs": ["QMT", "-05", "-04", "-05"],
        "untils": [-1230749160000, 722926800000, 728884800000, null],
        "offsets": [314, 300, 240, 300],
        "isdsts": [0, 0, 1, 0]
      },
      "Guyana": {
        "abbrs": ["LMT", "-0345", "-03", "-04"],
        "untils": [-1730578040000, 176010300000, 662698800000, null],
        "offsets": [232.6667, 225, 180, 240],
        "isdsts": [0, 0, 0, 0]
      },
      "Halifax": {
        "abbrs": ["LMT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "AWT", "APT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-2131645536000, -1696276800000, -1680469200000, -1632074400000, -1615143600000, -1566763200000, -1557090000000, -1535486400000, -1524949200000, -1504468800000, -1493413200000, -1472414400000, -1461963600000, -1440964800000, -1429390800000, -1409515200000, -1396731600000, -1376856000000, -1366491600000, -1346616000000, -1333832400000, -1313956800000, -1303678800000, -1282507200000, -1272661200000, -1251057600000, -1240088400000, -1219608000000, -1207429200000, -1188763200000, -1175979600000, -1157313600000, -1143925200000, -1124049600000, -1113771600000, -1091390400000, -1081026000000, -1059854400000, -1050786000000, -1030910400000, -1018126800000, -999460800000, -986677200000, -965592000000, -955227600000, -935956800000, -923173200000, -904507200000, -891723600000, -880221600000, -769395600000, -765399600000, -747252000000, -733950000000, -715802400000, -702500400000, -684352800000, -671050800000, -652903200000, -639601200000, -589399200000, -576097200000, -557949600000, -544647600000, -526500000000, -513198000000, -495050400000, -481748400000, -431546400000, -418244400000, -400096800000, -386794800000, -368647200000, -355345200000, -337197600000, -323895600000, -242244000000, -226522800000, -210794400000, -195073200000, -179344800000, -163623600000, -147895200000, -131569200000, -116445600000, -100119600000, -84391200000, -68670000000, -52941600000, -37220400000, -21492000000, -5770800000, 9957600000, 25678800000, 41407200000, 57733200000, 73461600000, 89182800000, 104911200000, 120632400000, 136360800000, 152082000000, 167810400000, 183531600000, 199260000000, 215586000000, 230709600000, 247035600000, 262764000000, 278485200000, 294213600000, 309934800000, 325663200000, 341384400000, 357112800000, 372834000000, 388562400000, 404888400000, 420012000000, 436338000000, 452066400000, 467787600000, 483516000000, 499237200000, 514965600000, 530686800000, 544600800000, 562136400000, 576050400000, 594190800000, 607500000000, 625640400000, 638949600000, 657090000000, 671004000000, 688539600000, 702453600000, 719989200000, 733903200000, 752043600000, 765352800000, 783493200000, 796802400000, 814942800000, 828856800000, 846392400000, 860306400000, 877842000000, 891756000000, 909291600000, 923205600000, 941346000000, 954655200000, 972795600000, 986104800000, 1004245200000, 1018159200000, 1035694800000, 1049608800000, 1067144400000, 1081058400000, 1099198800000, 1112508000000, 1130648400000, 1143957600000, 1162098000000, 1173592800000, 1194152400000, 1205042400000, 1225602000000, 1236492000000, 1257051600000, 1268546400000, 1289106000000, 1299996000000, 1320555600000, 1331445600000, 1352005200000, 1362895200000, 1383454800000, 1394344800000, 1414904400000, 1425794400000, 1446354000000, 1457848800000, 1478408400000, 1489298400000, 1509858000000, 1520748000000, 1541307600000, 1552197600000, 1572757200000, 1583647200000, 1604206800000, 1615701600000, 1636261200000, 1647151200000, 1667710800000, 1678600800000, 1699160400000, 1710050400000, 1730610000000, 1741500000000, 1762059600000, 1772949600000, 1793509200000, 1805004000000, 1825563600000, 1836453600000, 1857013200000, 1867903200000, 1888462800000, 1899352800000, 1919912400000, 1930802400000, 1951362000000, 1962856800000, 1983416400000, 1994306400000, 2014866000000, 2025756000000, 2046315600000, 2057205600000, 2077765200000, 2088655200000, 2109214800000, 2120104800000, 2140664400000, null],
        "offsets": [254.4, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Havana": {
        "abbrs": ["HMT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1402813824000, -1311534000000, -1300996800000, -933534000000, -925675200000, -902084400000, -893620800000, -870030000000, -862171200000, -775681200000, -767822400000, -744231600000, -736372800000, -144702000000, -134251200000, -113425200000, -102542400000, -86295600000, -72907200000, -54154800000, -41457600000, -21495600000, -5774400000, 9954000000, 25675200000, 41403600000, 57729600000, 73458000000, 87364800000, 104907600000, 118900800000, 136357200000, 150436800000, 167806800000, 183528000000, 199256400000, 215582400000, 230706000000, 247032000000, 263365200000, 276667200000, 290581200000, 308721600000, 322030800000, 340171200000, 358318800000, 371620800000, 389768400000, 403070400000, 421218000000, 434520000000, 452667600000, 466574400000, 484117200000, 498024000000, 511333200000, 529473600000, 542782800000, 560923200000, 574837200000, 592372800000, 606286800000, 623822400000, 638946000000, 655876800000, 671000400000, 687330000000, 702450000000, 718779600000, 733899600000, 750229200000, 765349200000, 781678800000, 796798800000, 813128400000, 828853200000, 844578000000, 860302800000, 876632400000, 891147600000, 909291600000, 922597200000, 941346000000, 954651600000, 972795600000, 986101200000, 1004245200000, 1018155600000, 1035694800000, 1049605200000, 1067144400000, 1080450000000, 1162098000000, 1173589200000, 1193547600000, 1205643600000, 1224997200000, 1236488400000, 1256446800000, 1268542800000, 1288501200000, 1300597200000, 1321160400000, 1333256400000, 1352005200000, 1362891600000, 1383454800000, 1394341200000, 1414904400000, 1425790800000, 1446354000000, 1457845200000, 1478408400000, 1489294800000, 1509858000000, 1520744400000, 1541307600000, 1552194000000, 1572757200000, 1583643600000, 1604206800000, 1615698000000, 1636261200000, 1647147600000, 1667710800000, 1678597200000, 1699160400000, 1710046800000, 1730610000000, 1741496400000, 1762059600000, 1772946000000, 1793509200000, 1805000400000, 1825563600000, 1836450000000, 1857013200000, 1867899600000, 1888462800000, 1899349200000, 1919912400000, 1930798800000, 1951362000000, 1962853200000, 1983416400000, 1994302800000, 2014866000000, 2025752400000, 2046315600000, 2057202000000, 2077765200000, 2088651600000, 2109214800000, 2120101200000, 2140664400000, null],
        "offsets": [329.6, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Hermosillo": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "MST", "PST", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, -873828000000, -661539600000, 28800000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, null],
        "offsets": [443.8667, 420, 360, 420, 360, 420, 360, 420, 480, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0]
      },
      "Indiana": {
        "Indianapolis": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -900259200000, -891795600000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -386787600000, -368640000000, -21488400000, -5767200000, 9961200000, 25682400000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Knox": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -447267600000, -431539200000, -415818000000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -321469200000, -305740800000, -289414800000, -273686400000, -257965200000, -242236800000, -195066000000, -84384000000, -68662800000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 1143961200000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Marengo": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -589392000000, -576090000000, -495043200000, -481741200000, -463593600000, -450291600000, -431539200000, -418237200000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -323888400000, -305740800000, -292438800000, -273686400000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 126687600000, 152089200000, 162370800000, 183535200000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Petersburg": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "CDT", "CST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -462996000000, -450291600000, -431539200000, -418237200000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -323888400000, -305740800000, -292438800000, -273686400000, -257965200000, -242236800000, -226515600000, -210787200000, -195066000000, -179337600000, -163616400000, -147888000000, -100112400000, -84384000000, -68662800000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 1143961200000, 1162105200000, 1173600000000, 1194159600000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 300, 360, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Tell_City": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "EDT", "EST", "EDT", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -526492800000, -513190800000, -495043200000, -481741200000, -462996000000, -450291600000, -431539200000, -418237200000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -323888400000, -305740800000, -289414800000, -273686400000, -260989200000, -242236800000, -226515600000, -210787200000, -195066000000, -179337600000, -21488400000, -5767200000, 9961200000, 25682400000, 1143961200000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Vevay": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -495043200000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Vincennes": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "EDT", "EST", "EDT", "EST", "CDT", "CST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -526492800000, -513190800000, -495043200000, -481741200000, -462996000000, -450291600000, -431539200000, -418237200000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -323888400000, -305740800000, -289414800000, -273686400000, -260989200000, -242236800000, -226515600000, -210787200000, -195066000000, -179337600000, -21488400000, -5767200000, 9961200000, 25682400000, 1143961200000, 1162105200000, 1173600000000, 1194159600000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 300, 360, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Winamac": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "EDT", "EST", "EDT", "EST", "CDT", "CST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -447267600000, -431539200000, -415818000000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -323888400000, -305740800000, -292438800000, -273686400000, -21488400000, -5767200000, 9961200000, 25682400000, 1143961200000, 1162105200000, 1173600000000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 300, 360, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        }
      },
      "Indianapolis": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -900259200000, -891795600000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -386787600000, -368640000000, -21488400000, -5767200000, 9961200000, 25682400000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Inuvik": {
        "abbrs": ["-00", "PST", "PDDT", "PST", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-536457600000, -147888000000, -131558400000, 294228000000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [0, 480, 360, 480, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Iqaluit": {
        "abbrs": ["-00", "EWT", "EPT", "EST", "EDDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "CST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-865296000000, -769395600000, -765396000000, -147898800000, -131569200000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954662400000, 972802800000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [0, 240, 240, 300, 180, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 360, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Jamaica": {
        "abbrs": ["KMT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1827687170000, 126687600000, 152085600000, 162370800000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, null],
        "offsets": [307.1667, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Jujuy": {
        "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-03", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03"],
        "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 657086400000, 669178800000, 686721600000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, null],
        "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 240, 180, 240, 120, 180, 120, 180, 180, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Juneau": {
        "abbrs": ["PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "YDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "YST", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST"],
        "untils": [-880207200000, -769395600000, -765385200000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 126698400000, 152096400000, 162381600000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341402400000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 439030800000, 452084400000, 467805600000, 483534000000, 499255200000, 514983600000, 530704800000, 544618800000, 562154400000, 576068400000, 594208800000, 607518000000, 625658400000, 638967600000, 657108000000, 671022000000, 688557600000, 702471600000, 720007200000, 733921200000, 752061600000, 765370800000, 783511200000, 796820400000, 814960800000, 828874800000, 846410400000, 860324400000, 877860000000, 891774000000, 909309600000, 923223600000, 941364000000, 954673200000, 972813600000, 986122800000, 1004263200000, 1018177200000, 1035712800000, 1049626800000, 1067162400000, 1081076400000, 1099216800000, 1112526000000, 1130666400000, 1143975600000, 1162116000000, 1173610800000, 1194170400000, 1205060400000, 1225620000000, 1236510000000, 1257069600000, 1268564400000, 1289124000000, 1300014000000, 1320573600000, 1331463600000, 1352023200000, 1362913200000, 1383472800000, 1394362800000, 1414922400000, 1425812400000, 1446372000000, 1457866800000, 1478426400000, 1489316400000, 1509876000000, 1520766000000, 1541325600000, 1552215600000, 1572775200000, 1583665200000, 1604224800000, 1615719600000, 1636279200000, 1647169200000, 1667728800000, 1678618800000, 1699178400000, 1710068400000, 1730628000000, 1741518000000, 1762077600000, 1772967600000, 1793527200000, 1805022000000, 1825581600000, 1836471600000, 1857031200000, 1867921200000, 1888480800000, 1899370800000, 1919930400000, 1930820400000, 1951380000000, 1962874800000, 1983434400000, 1994324400000, 2014884000000, 2025774000000, 2046333600000, 2057223600000, 2077783200000, 2088673200000, 2109232800000, 2120122800000, 2140682400000, null],
        "offsets": [480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 480, 480, 420, 480, 420, 480, 420, 540, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540],
        "isdsts": [0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Kentucky": {
        "Louisville": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -1535904000000, -1525280400000, -905097600000, -891795600000, -880214400000, -769395600000, -765392400000, -757360800000, -744224400000, -715795200000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -450291600000, -431539200000, -415818000000, -400089600000, -384368400000, -368640000000, -352918800000, -337190400000, -321469200000, -305740800000, -289414800000, -273686400000, -266432400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 126687600000, 152089200000, 162370800000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Monticello": {
          "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
          "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
          "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        }
      },
      "Knox_IN": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -447267600000, -431539200000, -415818000000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -321469200000, -305740800000, -289414800000, -273686400000, -257965200000, -242236800000, -195066000000, -84384000000, -68662800000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 1143961200000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Kralendijk": {
        "abbrs": ["LMT", "-0430", "AST"],
        "untils": [-1826738653000, -157750200000, null],
        "offsets": [275.7833, 270, 240],
        "isdsts": [0, 0, 0]
      },
      "La_Paz": {
        "abbrs": ["CMT", "BST", "-04"],
        "untils": [-1205954844000, -1192307244000, null],
        "offsets": [272.6, 212.6, 240],
        "isdsts": [0, 1, 0]
      },
      "Lima": {
        "abbrs": ["LMT", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05"],
        "untils": [-1938538284000, -1009825200000, -1002052800000, -986756400000, -971035200000, -955306800000, -939585600000, 504939600000, 512712000000, 536475600000, 544248000000, 631170000000, 638942400000, 757400400000, 765172800000, null],
        "offsets": [308.6, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Los_Angeles": {
        "abbrs": ["PST", "PDT", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1633269600000, -1615129200000, -1601820000000, -1583679600000, -880207200000, -769395600000, -765385200000, -687967140000, -662655600000, -620838000000, -608137200000, -589388400000, -576082800000, -557938800000, -544633200000, -526489200000, -513183600000, -495039600000, -481734000000, -463590000000, -450284400000, -431535600000, -418230000000, -400086000000, -386780400000, -368636400000, -355330800000, -337186800000, -323881200000, -305737200000, -292431600000, -273682800000, -260982000000, -242233200000, -226508400000, -210783600000, -195058800000, -179334000000, -163609200000, -147884400000, -131554800000, -116434800000, -100105200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 126698400000, 152096400000, 162381600000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Louisville": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -1535904000000, -1525280400000, -905097600000, -891795600000, -880214400000, -769395600000, -765392400000, -757360800000, -744224400000, -715795200000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -450291600000, -431539200000, -415818000000, -400089600000, -384368400000, -368640000000, -352918800000, -337190400000, -321469200000, -305740800000, -289414800000, -273686400000, -266432400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 126687600000, 152089200000, 162370800000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Lower_Princes": {
        "abbrs": ["LMT", "-0430", "AST"],
        "untils": [-1826738653000, -157750200000, null],
        "offsets": [275.7833, 270, 240],
        "isdsts": [0, 0, 0]
      },
      "Maceio": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1767217028000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -191365200000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, 592974000000, 602042400000, 624423600000, 634701600000, 813726000000, 824004000000, 938919600000, 951616800000, 970974000000, 972180000000, 1003028400000, 1013911200000, null],
        "offsets": [142.8667, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Managua": {
        "abbrs": ["MMT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1121105688000, 105084000000, 161758800000, 290584800000, 299134800000, 322034400000, 330584400000, 694260000000, 717310800000, 725868000000, 852094800000, 1113112800000, 1128229200000, 1146384000000, 1159682400000, null],
        "offsets": [345.2, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0]
      },
      "Manaus": {
        "abbrs": ["LMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04"],
        "untils": [-1767211196000, -1206954000000, -1191358800000, -1175371200000, -1159822800000, -633816000000, -622065600000, -602280000000, -591829200000, -570744000000, -560206800000, -539121600000, -531349200000, -191361600000, -184194000000, -155160000000, -150066000000, -128894400000, -121122000000, -99950400000, -89586000000, -68414400000, -57963600000, 499752000000, 511239600000, 530596800000, 540270000000, 562132800000, 571201200000, 750830400000, 761713200000, null],
        "offsets": [240.0667, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Marigot": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Martinique": {
        "abbrs": ["FFMT", "AST", "ADT", "AST"],
        "untils": [-1851537340000, 323841600000, 338958000000, null],
        "offsets": [244.3333, 240, 180, 240],
        "isdsts": [0, 0, 1, 0]
      },
      "Matamoros": {
        "abbrs": ["LMT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1514743200000, 576057600000, 594198000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 989136000000, 1001833200000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1175414400000, 1193554800000, 1207468800000, 1225004400000, 1238918400000, 1256454000000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [400, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Mazatlan": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "MST", "PST", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, -873828000000, -661539600000, 28800000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 989139600000, 1001836800000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1175418000000, 1193558400000, 1207472400000, 1225008000000, 1238922000000, 1256457600000, 1270371600000, 1288512000000, 1301821200000, 1319961600000, 1333270800000, 1351411200000, 1365325200000, 1382860800000, 1396774800000, 1414310400000, 1428224400000, 1445760000000, 1459674000000, 1477814400000, 1491123600000, 1509264000000, 1522573200000, 1540713600000, 1554627600000, 1572163200000, 1586077200000, 1603612800000, 1617526800000, 1635667200000, 1648976400000, 1667116800000, 1680426000000, 1698566400000, 1712480400000, 1730016000000, 1743930000000, 1761465600000, 1775379600000, 1792915200000, 1806829200000, 1824969600000, 1838278800000, 1856419200000, 1869728400000, 1887868800000, 1901782800000, 1919318400000, 1933232400000, 1950768000000, 1964682000000, 1982822400000, 1996131600000, 2014272000000, 2027581200000, 2045721600000, 2059030800000, 2077171200000, 2091085200000, 2108620800000, 2122534800000, 2140070400000, null],
        "offsets": [425.6667, 420, 360, 420, 360, 420, 360, 420, 480, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Mendoza": {
        "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-03", "-04", "-03", "-04", "-02", "-03", "-03", "-03", "-04", "-03", "-02", "-03"],
        "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 655963200000, 667796400000, 687499200000, 699418800000, 719380800000, 731469600000, 938919600000, 952052400000, 1085281200000, 1096171200000, 1198983600000, 1205632800000, null],
        "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 240, 180, 240, 180, 240, 120, 180, 180, 180, 240, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0]
      },
      "Menominee": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -116438400000, -100112400000, -21484800000, 104914800000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Merida": {
        "abbrs": ["LMT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1514743200000, 377935200000, 407653200000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 989136000000, 1001833200000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1175414400000, 1193554800000, 1207468800000, 1225004400000, 1238918400000, 1256454000000, 1270368000000, 1288508400000, 1301817600000, 1319958000000, 1333267200000, 1351407600000, 1365321600000, 1382857200000, 1396771200000, 1414306800000, 1428220800000, 1445756400000, 1459670400000, 1477810800000, 1491120000000, 1509260400000, 1522569600000, 1540710000000, 1554624000000, 1572159600000, 1586073600000, 1603609200000, 1617523200000, 1635663600000, 1648972800000, 1667113200000, 1680422400000, 1698562800000, 1712476800000, 1730012400000, 1743926400000, 1761462000000, 1775376000000, 1792911600000, 1806825600000, 1824966000000, 1838275200000, 1856415600000, 1869724800000, 1887865200000, 1901779200000, 1919314800000, 1933228800000, 1950764400000, 1964678400000, 1982818800000, 1996128000000, 2014268400000, 2027577600000, 2045718000000, 2059027200000, 2077167600000, 2091081600000, 2108617200000, 2122531200000, 2140066800000, null],
        "offsets": [358.4667, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Metlakatla": {
        "abbrs": ["PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST"],
        "untils": [-880207200000, -769395600000, -765385200000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 126698400000, 152096400000, 162381600000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 1446372000000, 1457866800000, 1478426400000, 1489316400000, 1509876000000, 1520766000000, 1541325600000, 1552215600000, 1572775200000, 1583665200000, 1604224800000, 1615719600000, 1636279200000, 1647169200000, 1667728800000, 1678618800000, 1699178400000, 1710068400000, 1730628000000, 1741518000000, 1762077600000, 1772967600000, 1793527200000, 1805022000000, 1825581600000, 1836471600000, 1857031200000, 1867921200000, 1888480800000, 1899370800000, 1919930400000, 1930820400000, 1951380000000, 1962874800000, 1983434400000, 1994324400000, 2014884000000, 2025774000000, 2046333600000, 2057223600000, 2077783200000, 2088673200000, 2109232800000, 2120122800000, 2140682400000, null],
        "offsets": [480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540],
        "isdsts": [0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Mexico_City": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, -975261600000, -963169200000, -917114400000, -907354800000, -821901600000, -810068400000, -627501600000, -612990000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 989136000000, 1001833200000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1175414400000, 1193554800000, 1207468800000, 1225004400000, 1238918400000, 1256454000000, 1270368000000, 1288508400000, 1301817600000, 1319958000000, 1333267200000, 1351407600000, 1365321600000, 1382857200000, 1396771200000, 1414306800000, 1428220800000, 1445756400000, 1459670400000, 1477810800000, 1491120000000, 1509260400000, 1522569600000, 1540710000000, 1554624000000, 1572159600000, 1586073600000, 1603609200000, 1617523200000, 1635663600000, 1648972800000, 1667113200000, 1680422400000, 1698562800000, 1712476800000, 1730012400000, 1743926400000, 1761462000000, 1775376000000, 1792911600000, 1806825600000, 1824966000000, 1838275200000, 1856415600000, 1869724800000, 1887865200000, 1901779200000, 1919314800000, 1933228800000, 1950764400000, 1964678400000, 1982818800000, 1996128000000, 2014268400000, 2027577600000, 2045718000000, 2059027200000, 2077167600000, 2091081600000, 2108617200000, 2122531200000, 2140066800000, null],
        "offsets": [396.6, 420, 360, 420, 360, 420, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Miquelon": {
        "abbrs": ["LMT", "AST", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1850328920000, 326001600000, 544597200000, 562132800000, 576046800000, 594187200000, 607496400000, 625636800000, 638946000000, 657086400000, 671000400000, 688536000000, 702450000000, 719985600000, 733899600000, 752040000000, 765349200000, 783489600000, 796798800000, 814939200000, 828853200000, 846388800000, 860302800000, 877838400000, 891752400000, 909288000000, 923202000000, 941342400000, 954651600000, 972792000000, 986101200000, 1004241600000, 1018155600000, 1035691200000, 1049605200000, 1067140800000, 1081054800000, 1099195200000, 1112504400000, 1130644800000, 1143954000000, 1162094400000, 1173589200000, 1194148800000, 1205038800000, 1225598400000, 1236488400000, 1257048000000, 1268542800000, 1289102400000, 1299992400000, 1320552000000, 1331442000000, 1352001600000, 1362891600000, 1383451200000, 1394341200000, 1414900800000, 1425790800000, 1446350400000, 1457845200000, 1478404800000, 1489294800000, 1509854400000, 1520744400000, 1541304000000, 1552194000000, 1572753600000, 1583643600000, 1604203200000, 1615698000000, 1636257600000, 1647147600000, 1667707200000, 1678597200000, 1699156800000, 1710046800000, 1730606400000, 1741496400000, 1762056000000, 1772946000000, 1793505600000, 1805000400000, 1825560000000, 1836450000000, 1857009600000, 1867899600000, 1888459200000, 1899349200000, 1919908800000, 1930798800000, 1951358400000, 1962853200000, 1983412800000, 1994302800000, 2014862400000, 2025752400000, 2046312000000, 2057202000000, 2077761600000, 2088651600000, 2109211200000, 2120101200000, 2140660800000, null],
        "offsets": [224.6667, 240, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Moncton": {
        "abbrs": ["EST", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "AWT", "APT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-2131642800000, -1632074400000, -1615143600000, -1153681200000, -1145822400000, -1122231600000, -1114372800000, -1090782000000, -1082923200000, -1059332400000, -1051473600000, -1027882800000, -1020024000000, -996433200000, -988574400000, -965674800000, -955396800000, -934743600000, -923947200000, -904503600000, -891892800000, -880221600000, -769395600000, -765399600000, -747252000000, -733950000000, -715802400000, -702500400000, -684352800000, -671050800000, -652903200000, -639601200000, -620848800000, -608151600000, -589399200000, -576097200000, -557949600000, -544647600000, -526500000000, -513198000000, -495050400000, -481748400000, -463600800000, -450298800000, -431546400000, -418244400000, -400096800000, -384375600000, -368647200000, -352926000000, -337197600000, -321476400000, -305748000000, -289422000000, -273693600000, -257972400000, -242244000000, -226522800000, -210794400000, -195073200000, -179344800000, -163623600000, -147895200000, -131569200000, -116445600000, -100119600000, -84391200000, -68670000000, -52941600000, -37220400000, -21492000000, -5770800000, 9957600000, 25678800000, 41407200000, 57733200000, 73461600000, 89182800000, 136360800000, 152082000000, 167810400000, 183531600000, 199260000000, 215586000000, 230709600000, 247035600000, 262764000000, 278485200000, 294213600000, 309934800000, 325663200000, 341384400000, 357112800000, 372834000000, 388562400000, 404888400000, 420012000000, 436338000000, 452066400000, 467787600000, 483516000000, 499237200000, 514965600000, 530686800000, 544600800000, 562136400000, 576050400000, 594190800000, 607500000000, 625640400000, 638949600000, 657090000000, 671004000000, 688539600000, 702453600000, 719989200000, 733896060000, 752036460000, 765345660000, 783486060000, 796795260000, 814935660000, 828849660000, 846385260000, 860299260000, 877834860000, 891748860000, 909284460000, 923198460000, 941338860000, 954648060000, 972788460000, 986097660000, 1004238060000, 1018152060000, 1035687660000, 1049601660000, 1067137260000, 1081051260000, 1099191660000, 1112500860000, 1130641260000, 1143950460000, 1162090860000, 1173592800000, 1194152400000, 1205042400000, 1225602000000, 1236492000000, 1257051600000, 1268546400000, 1289106000000, 1299996000000, 1320555600000, 1331445600000, 1352005200000, 1362895200000, 1383454800000, 1394344800000, 1414904400000, 1425794400000, 1446354000000, 1457848800000, 1478408400000, 1489298400000, 1509858000000, 1520748000000, 1541307600000, 1552197600000, 1572757200000, 1583647200000, 1604206800000, 1615701600000, 1636261200000, 1647151200000, 1667710800000, 1678600800000, 1699160400000, 1710050400000, 1730610000000, 1741500000000, 1762059600000, 1772949600000, 1793509200000, 1805004000000, 1825563600000, 1836453600000, 1857013200000, 1867903200000, 1888462800000, 1899352800000, 1919912400000, 1930802400000, 1951362000000, 1962856800000, 1983416400000, 1994306400000, 2014866000000, 2025756000000, 2046315600000, 2057205600000, 2077765200000, 2088655200000, 2109214800000, 2120104800000, 2140664400000, null],
        "offsets": [300, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Monterrey": {
        "abbrs": ["LMT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1514743200000, 576057600000, 594198000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 989136000000, 1001833200000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1175414400000, 1193554800000, 1207468800000, 1225004400000, 1238918400000, 1256454000000, 1270368000000, 1288508400000, 1301817600000, 1319958000000, 1333267200000, 1351407600000, 1365321600000, 1382857200000, 1396771200000, 1414306800000, 1428220800000, 1445756400000, 1459670400000, 1477810800000, 1491120000000, 1509260400000, 1522569600000, 1540710000000, 1554624000000, 1572159600000, 1586073600000, 1603609200000, 1617523200000, 1635663600000, 1648972800000, 1667113200000, 1680422400000, 1698562800000, 1712476800000, 1730012400000, 1743926400000, 1761462000000, 1775376000000, 1792911600000, 1806825600000, 1824966000000, 1838275200000, 1856415600000, 1869724800000, 1887865200000, 1901779200000, 1919314800000, 1933228800000, 1950764400000, 1964678400000, 1982818800000, 1996128000000, 2014268400000, 2027577600000, 2045718000000, 2059027200000, 2077167600000, 2091081600000, 2108617200000, 2122531200000, 2140066800000, null],
        "offsets": [401.2667, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Montevideo": {
        "abbrs": ["LMT", "MMT", "-04", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0330", "-03", "-0230", "-03", "-0230", "-03", "-02", "-03", "-02", "-03", "-0230", "-03", "-02", "-03", "-02", "-03", "-0130", "-0230", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1942690509000, -1567455309000, -1459627200000, -1443819600000, -1428006600000, -1412283600000, -1396470600000, -1380747600000, -1141590600000, -1128286800000, -1110141000000, -1096837200000, -1078691400000, -1065387600000, -1047241800000, -1033938000000, -1015187400000, -1002488400000, -983737800000, -971038800000, -954707400000, -938984400000, -920838600000, -907534800000, -896819400000, -853621200000, -845847000000, -334789200000, -319671000000, -314226000000, -309996000000, -149720400000, -134604000000, -50446800000, -34205400000, 9860400000, 14176800000, 72846000000, 80100000000, 127278000000, 132111000000, 147234600000, 156913200000, 165376800000, 219812400000, 226461600000, 250052400000, 257911200000, 282711600000, 289360800000, 294202800000, 322020000000, 566449200000, 573012000000, 597812400000, 605066400000, 625633200000, 635911200000, 656478000000, 667965600000, 688532400000, 699415200000, 719377200000, 730864800000, 1095562800000, 1111896000000, 1128834000000, 1142136000000, 1159678800000, 1173585600000, 1191733200000, 1205035200000, 1223182800000, 1236484800000, 1254632400000, 1268539200000, 1286082000000, 1299988800000, 1317531600000, 1331438400000, 1349586000000, 1362888000000, 1381035600000, 1394337600000, 1412485200000, 1425787200000, null],
        "offsets": [224.85, 224.85, 240, 180, 210, 180, 210, 180, 210, 180, 210, 180, 210, 180, 210, 180, 210, 180, 210, 180, 210, 180, 210, 180, 210, 180, 150, 180, 150, 180, 120, 180, 120, 180, 150, 180, 120, 180, 120, 180, 90, 150, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Montreal": {
        "abbrs": ["EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1632070800000, -1615140000000, -1601753400000, -1583697600000, -1567357200000, -1554667200000, -1534698000000, -1524074400000, -1503248400000, -1492365600000, -1471798800000, -1460916000000, -1440954000000, -1428861600000, -1409504400000, -1397412000000, -1378054800000, -1365962400000, -1346605200000, -1333908000000, -1315155600000, -1301853600000, -1283706000000, -1270404000000, -1252256400000, -1238954400000, -1220806800000, -1207504800000, -1188752400000, -1176055200000, -1157302800000, -1144000800000, -1125853200000, -1112551200000, -1094403600000, -1081101600000, -1062954000000, -1049652000000, -1031504400000, -1018202400000, -1000054800000, -986752800000, -968000400000, -955303200000, -936550800000, -880218000000, -769395600000, -765396000000, -747248400000, -733946400000, -715806000000, -702504000000, -684356400000, -671054400000, -652906800000, -634161600000, -620845200000, -602704800000, -589395600000, -576093600000, -557946000000, -544644000000, -526496400000, -513194400000, -495046800000, -481744800000, -463597200000, -450295200000, -431542800000, -418240800000, -400093200000, -384372000000, -368643600000, -352922400000, -337194000000, -321472800000, -305744400000, -289418400000, -273690000000, -257968800000, -242240400000, -226519200000, -210790800000, -195069600000, -179341200000, -163620000000, -147891600000, -131565600000, -116442000000, -100116000000, -84387600000, -68666400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 136364400000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Montserrat": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Nassau": {
        "abbrs": ["LMT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1825095030000, -179341200000, -163620000000, -147891600000, -131565600000, -116442000000, -100116000000, -84387600000, -68666400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 136364400000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [309.5, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "New_York": {
        "abbrs": ["EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1633280400000, -1615140000000, -1601830800000, -1583690400000, -1570381200000, -1551636000000, -1536512400000, -1523210400000, -1504458000000, -1491760800000, -1473008400000, -1459706400000, -1441558800000, -1428256800000, -1410109200000, -1396807200000, -1378659600000, -1365357600000, -1347210000000, -1333908000000, -1315155600000, -1301853600000, -1283706000000, -1270404000000, -1252256400000, -1238954400000, -1220806800000, -1207504800000, -1189357200000, -1176055200000, -1157302800000, -1144605600000, -1125853200000, -1112551200000, -1094403600000, -1081101600000, -1062954000000, -1049652000000, -1031504400000, -1018202400000, -1000054800000, -986752800000, -968000400000, -955303200000, -936550800000, -923248800000, -905101200000, -891799200000, -880218000000, -769395600000, -765396000000, -747248400000, -733946400000, -715798800000, -702496800000, -684349200000, -671047200000, -652899600000, -639597600000, -620845200000, -608148000000, -589395600000, -576093600000, -557946000000, -544644000000, -526496400000, -513194400000, -495046800000, -481744800000, -463597200000, -447271200000, -431542800000, -415821600000, -400093200000, -384372000000, -368643600000, -352922400000, -337194000000, -321472800000, -305744400000, -289418400000, -273690000000, -257968800000, -242240400000, -226519200000, -210790800000, -195069600000, -179341200000, -163620000000, -147891600000, -131565600000, -116442000000, -100116000000, -84387600000, -68666400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 126687600000, 152085600000, 162370800000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Nipigon": {
        "abbrs": ["EST", "EDT", "EST", "EDT", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1632070800000, -1615140000000, -923252400000, -880218000000, -769395600000, -765396000000, 136364400000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [300, 240, 300, 240, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Nome": {
        "abbrs": ["NST", "NWT", "NPT", "NST", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "YST", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST"],
        "untils": [-880196400000, -769395600000, -765374400000, -86878800000, -21466800000, -5745600000, 9982800000, 25704000000, 41432400000, 57758400000, 73486800000, 89208000000, 104936400000, 120657600000, 126709200000, 152107200000, 162392400000, 183556800000, 199285200000, 215611200000, 230734800000, 247060800000, 262789200000, 278510400000, 294238800000, 309960000000, 325688400000, 341409600000, 357138000000, 372859200000, 388587600000, 404913600000, 420037200000, 436363200000, 439030800000, 452084400000, 467805600000, 483534000000, 499255200000, 514983600000, 530704800000, 544618800000, 562154400000, 576068400000, 594208800000, 607518000000, 625658400000, 638967600000, 657108000000, 671022000000, 688557600000, 702471600000, 720007200000, 733921200000, 752061600000, 765370800000, 783511200000, 796820400000, 814960800000, 828874800000, 846410400000, 860324400000, 877860000000, 891774000000, 909309600000, 923223600000, 941364000000, 954673200000, 972813600000, 986122800000, 1004263200000, 1018177200000, 1035712800000, 1049626800000, 1067162400000, 1081076400000, 1099216800000, 1112526000000, 1130666400000, 1143975600000, 1162116000000, 1173610800000, 1194170400000, 1205060400000, 1225620000000, 1236510000000, 1257069600000, 1268564400000, 1289124000000, 1300014000000, 1320573600000, 1331463600000, 1352023200000, 1362913200000, 1383472800000, 1394362800000, 1414922400000, 1425812400000, 1446372000000, 1457866800000, 1478426400000, 1489316400000, 1509876000000, 1520766000000, 1541325600000, 1552215600000, 1572775200000, 1583665200000, 1604224800000, 1615719600000, 1636279200000, 1647169200000, 1667728800000, 1678618800000, 1699178400000, 1710068400000, 1730628000000, 1741518000000, 1762077600000, 1772967600000, 1793527200000, 1805022000000, 1825581600000, 1836471600000, 1857031200000, 1867921200000, 1888480800000, 1899370800000, 1919930400000, 1930820400000, 1951380000000, 1962874800000, 1983434400000, 1994324400000, 2014884000000, 2025774000000, 2046333600000, 2057223600000, 2077783200000, 2088673200000, 2109232800000, 2120122800000, 2140682400000, null],
        "offsets": [660, 600, 600, 660, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 540, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540],
        "isdsts": [0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Noronha": {
        "abbrs": ["LMT", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02"],
        "untils": [-1767217820000, -1206961200000, -1191366000000, -1175378400000, -1159830000000, -633823200000, -622072800000, -602287200000, -591836400000, -570751200000, -560214000000, -539128800000, -531356400000, -191368800000, -184201200000, -155167200000, -150073200000, -128901600000, -121129200000, -99957600000, -89593200000, -68421600000, -57970800000, 499744800000, 511232400000, 530589600000, 540262800000, 562125600000, 571194000000, 592970400000, 602038800000, 624420000000, 634698000000, 938916000000, 951613200000, 970970400000, 971571600000, 1003024800000, 1013907600000, null],
        "offsets": [129.6667, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "North_Dakota": {
        "Beulah": {
          "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
          "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -880210800000, -769395600000, -765388800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
          "offsets": [420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "Center": {
          "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
          "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -880210800000, -769395600000, -765388800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
          "offsets": [420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        },
        "New_Salem": {
          "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
          "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -880210800000, -769395600000, -765388800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
          "offsets": [420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
          "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
        }
      },
      "Ojinaga": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "CDT", "CST", "CDT", "CST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, 828864000000, 846399600000, 860313600000, 877849200000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 989139600000, 1001836800000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1175418000000, 1193558400000, 1207472400000, 1225008000000, 1238922000000, 1256457600000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [417.6667, 420, 360, 420, 360, 420, 360, 300, 360, 300, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Panama": {
        "abbrs": ["CMT", "EST"],
        "untils": [-1946918424000, null],
        "offsets": [319.6, 300],
        "isdsts": [0, 0]
      },
      "Pangnirtung": {
        "abbrs": ["-00", "AST", "AWT", "APT", "AST", "ADDT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "CST", "CDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1546300800000, -880221600000, -769395600000, -765399600000, -147902400000, -131572800000, 325663200000, 341384400000, 357112800000, 372834000000, 388562400000, 404888400000, 420012000000, 436338000000, 452066400000, 467787600000, 483516000000, 499237200000, 514965600000, 530686800000, 544600800000, 562136400000, 576050400000, 594190800000, 607500000000, 625640400000, 638949600000, 657090000000, 671004000000, 688539600000, 702453600000, 719989200000, 733903200000, 752043600000, 765352800000, 783493200000, 796802400000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954662400000, 972802800000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [0, 240, 180, 180, 240, 120, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 360, 300, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Paramaribo": {
        "abbrs": ["LMT", "PMT", "PMT", "-0330", "-03"],
        "untils": [-1861906760000, -1104524348000, -765317964000, 465449400000, null],
        "offsets": [220.6667, 220.8667, 220.6, 210, 180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Phoenix": {
        "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MWT", "MST", "MWT", "MST", "MDT", "MST"],
        "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -880210800000, -820519140000, -812653140000, -796845540000, -84380400000, -68659200000, null],
        "offsets": [420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Port-au-Prince": {
        "abbrs": ["PPMT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1670483460000, 421218000000, 436334400000, 452062800000, 467784000000, 483512400000, 499233600000, 514962000000, 530683200000, 546411600000, 562132800000, 576050400000, 594194400000, 607500000000, 625644000000, 638949600000, 657093600000, 671004000000, 688543200000, 702453600000, 719992800000, 733903200000, 752047200000, 765352800000, 783496800000, 796802400000, 814946400000, 828856800000, 846396000000, 860306400000, 877845600000, 1112504400000, 1130644800000, 1143954000000, 1162094400000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [289, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Port_of_Spain": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Porto_Acre": {
        "abbrs": ["LMT", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05"],
        "untils": [-1767209328000, -1206950400000, -1191355200000, -1175367600000, -1159819200000, -633812400000, -622062000000, -602276400000, -591825600000, -570740400000, -560203200000, -539118000000, -531345600000, -191358000000, -184190400000, -155156400000, -150062400000, -128890800000, -121118400000, -99946800000, -89582400000, -68410800000, -57960000000, 499755600000, 511243200000, 530600400000, 540273600000, 562136400000, 571204800000, 1214283600000, 1384056000000, null],
        "offsets": [271.2, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Porto_Velho": {
        "abbrs": ["LMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04"],
        "untils": [-1767210264000, -1206954000000, -1191358800000, -1175371200000, -1159822800000, -633816000000, -622065600000, -602280000000, -591829200000, -570744000000, -560206800000, -539121600000, -531349200000, -191361600000, -184194000000, -155160000000, -150066000000, -128894400000, -121122000000, -99950400000, -89586000000, -68414400000, -57963600000, 499752000000, 511239600000, 530596800000, 540270000000, 562132800000, 571201200000, null],
        "offsets": [255.6, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Puerto_Rico": {
        "abbrs": ["AST", "AWT", "APT", "AST"],
        "untils": [-873057600000, -769395600000, -765399600000, null],
        "offsets": [240, 180, 180, 240],
        "isdsts": [0, 1, 1, 0]
      },
      "Punta_Arenas": {
        "abbrs": ["SMT", "-05", "SMT", "-04", "SMT", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-03"],
        "untils": [-1892661434000, -1688410800000, -1619205434000, -1593806400000, -1335986234000, -1317585600000, -1304362800000, -1286049600000, -1272826800000, -1254513600000, -1241290800000, -1222977600000, -1209754800000, -1191355200000, -1178132400000, -870552000000, -865278000000, -718056000000, -713649600000, -36619200000, -23922000000, -3355200000, 7527600000, 24465600000, 37767600000, 55915200000, 69217200000, 87969600000, 100666800000, 118209600000, 132116400000, 150868800000, 163566000000, 182318400000, 195620400000, 213768000000, 227070000000, 245217600000, 258519600000, 277272000000, 289969200000, 308721600000, 321418800000, 340171200000, 353473200000, 371620800000, 384922800000, 403070400000, 416372400000, 434520000000, 447822000000, 466574400000, 479271600000, 498024000000, 510721200000, 529473600000, 545194800000, 560923200000, 574225200000, 592372800000, 605674800000, 624427200000, 637124400000, 653457600000, 668574000000, 687326400000, 700628400000, 718776000000, 732078000000, 750225600000, 763527600000, 781675200000, 794977200000, 813729600000, 826426800000, 845179200000, 859690800000, 876628800000, 889930800000, 906868800000, 923194800000, 939528000000, 952830000000, 971582400000, 984279600000, 1003032000000, 1015729200000, 1034481600000, 1047178800000, 1065931200000, 1079233200000, 1097380800000, 1110682800000, 1128830400000, 1142132400000, 1160884800000, 1173582000000, 1192334400000, 1206846000000, 1223784000000, 1237086000000, 1255233600000, 1270350000000, 1286683200000, 1304823600000, 1313899200000, 1335668400000, 1346558400000, 1367118000000, 1378612800000, 1398567600000, 1410062400000, 1463281200000, 1471147200000, 1480820400000, null],
        "offsets": [282.7667, 300, 282.7667, 240, 282.7667, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 180],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Rainy_River": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1632067200000, -1615136400000, -923248800000, -880214400000, -769395600000, -765392400000, 136368000000, 152089200000, 167817600000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Rankin_Inlet": {
        "abbrs": ["-00", "CST", "CDDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-410227200000, -147895200000, -131565600000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [0, 360, 240, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Recife": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1767217224000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -191365200000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, 592974000000, 602042400000, 624423600000, 634701600000, 938919600000, 951616800000, 970974000000, 971575200000, 1003028400000, 1013911200000, null],
        "offsets": [139.6, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Regina": {
        "abbrs": ["LMT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "CST"],
        "untils": [-2030202084000, -1632063600000, -1615132800000, -1251651600000, -1238349600000, -1220202000000, -1206900000000, -1188752400000, -1175450400000, -1156698000000, -1144000800000, -1125248400000, -1111946400000, -1032714000000, -1016992800000, -1001264400000, -986148000000, -969814800000, -954093600000, -937760400000, -922039200000, -906310800000, -890589600000, -880210800000, -769395600000, -765388800000, -748450800000, -732729600000, -715791600000, -702489600000, -684342000000, -671040000000, -652892400000, -639590400000, -620838000000, -608140800000, -589388400000, -576086400000, -557938800000, -544636800000, -526489200000, -513187200000, -495039600000, -481737600000, -463590000000, -450288000000, -431535600000, -418233600000, -400086000000, -386784000000, -337186800000, -321465600000, -305737200000, null],
        "offsets": [418.6, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Resolute": {
        "abbrs": ["-00", "CST", "CDDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-704937600000, -147895200000, -131565600000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [0, 360, 240, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Rio_Branco": {
        "abbrs": ["LMT", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05"],
        "untils": [-1767209328000, -1206950400000, -1191355200000, -1175367600000, -1159819200000, -633812400000, -622062000000, -602276400000, -591825600000, -570740400000, -560203200000, -539118000000, -531345600000, -191358000000, -184190400000, -155156400000, -150062400000, -128890800000, -121118400000, -99946800000, -89582400000, -68410800000, -57960000000, 499755600000, 511243200000, 530600400000, 540273600000, 562136400000, 571204800000, 1214283600000, 1384056000000, null],
        "offsets": [271.2, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Rosario": {
        "abbrs": ["CMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-04", "-02", "-03", "-02", "-03", "-03", "-03", "-02", "-03", "-02", "-03"],
        "untils": [-1567453392000, -1233432000000, -1222981200000, -1205956800000, -1194037200000, -1172865600000, -1162501200000, -1141329600000, -1130965200000, -1109793600000, -1099429200000, -1078257600000, -1067806800000, -1046635200000, -1036270800000, -1015099200000, -1004734800000, -983563200000, -973198800000, -952027200000, -941576400000, -931032000000, -900882000000, -890337600000, -833749200000, -827265600000, -752274000000, -733780800000, -197326800000, -190843200000, -184194000000, -164491200000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 596948400000, 605066400000, 624423600000, 636516000000, 656478000000, 667965600000, 687931200000, 699415200000, 719377200000, 731469600000, 938919600000, 952052400000, 1198983600000, 1205632800000, 1224385200000, 1237082400000, null],
        "offsets": [256.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 120, 180, 120, 240, 120, 180, 120, 180, 180, 180, 120, 180, 120, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Santa_Isabel": {
        "abbrs": ["LMT", "MST", "PST", "MST", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1514736000000, -1451667600000, -1343062800000, -1234803600000, -1222963200000, -1207242000000, -873820800000, -769395600000, -761677200000, -686073600000, -661539600000, -495039600000, -481734000000, -463590000000, -450284400000, -431535600000, -418230000000, -400086000000, -386780400000, -368636400000, -355330800000, -337186800000, -323881200000, -305737200000, -292431600000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1175421600000, 1193562000000, 1207476000000, 1225011600000, 1238925600000, 1256461200000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [468.0667, 420, 480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Santarem": {
        "abbrs": ["LMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03"],
        "untils": [-1767212472000, -1206954000000, -1191358800000, -1175371200000, -1159822800000, -633816000000, -622065600000, -602280000000, -591829200000, -570744000000, -560206800000, -539121600000, -531349200000, -191361600000, -184194000000, -155160000000, -150066000000, -128894400000, -121122000000, -99950400000, -89586000000, -68414400000, -57963600000, 499752000000, 511239600000, 530596800000, 540270000000, 562132800000, 571201200000, 1214280000000, null],
        "offsets": [218.8, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Santiago": {
        "abbrs": ["SMT", "-05", "SMT", "-04", "SMT", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-03", "-04", "-05", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03"],
        "untils": [-1892661434000, -1688410800000, -1619205434000, -1593806400000, -1335986234000, -1317585600000, -1304362800000, -1286049600000, -1272826800000, -1254513600000, -1241290800000, -1222977600000, -1209754800000, -1191355200000, -1178132400000, -870552000000, -865278000000, -740520000000, -736376400000, -718056000000, -713649600000, -36619200000, -23922000000, -3355200000, 7527600000, 24465600000, 37767600000, 55915200000, 69217200000, 87969600000, 100666800000, 118209600000, 132116400000, 150868800000, 163566000000, 182318400000, 195620400000, 213768000000, 227070000000, 245217600000, 258519600000, 277272000000, 289969200000, 308721600000, 321418800000, 340171200000, 353473200000, 371620800000, 384922800000, 403070400000, 416372400000, 434520000000, 447822000000, 466574400000, 479271600000, 498024000000, 510721200000, 529473600000, 545194800000, 560923200000, 574225200000, 592372800000, 605674800000, 624427200000, 637124400000, 653457600000, 668574000000, 687326400000, 700628400000, 718776000000, 732078000000, 750225600000, 763527600000, 781675200000, 794977200000, 813729600000, 826426800000, 845179200000, 859690800000, 876628800000, 889930800000, 906868800000, 923194800000, 939528000000, 952830000000, 971582400000, 984279600000, 1003032000000, 1015729200000, 1034481600000, 1047178800000, 1065931200000, 1079233200000, 1097380800000, 1110682800000, 1128830400000, 1142132400000, 1160884800000, 1173582000000, 1192334400000, 1206846000000, 1223784000000, 1237086000000, 1255233600000, 1270350000000, 1286683200000, 1304823600000, 1313899200000, 1335668400000, 1346558400000, 1367118000000, 1378612800000, 1398567600000, 1410062400000, 1463281200000, 1471147200000, 1494730800000, 1502596800000, 1526180400000, 1534046400000, 1554606000000, 1567915200000, 1586055600000, 1599364800000, 1617505200000, 1630814400000, 1648954800000, 1662264000000, 1680404400000, 1693713600000, 1712458800000, 1725768000000, 1743908400000, 1757217600000, 1775358000000, 1788667200000, 1806807600000, 1820116800000, 1838257200000, 1851566400000, 1870311600000, 1883016000000, 1901761200000, 1915070400000, 1933210800000, 1946520000000, 1964660400000, 1977969600000, 1996110000000, 2009419200000, 2027559600000, 2040868800000, 2059614000000, 2072318400000, 2091063600000, 2104372800000, 2122513200000, 2135822400000, null],
        "offsets": [282.7667, 300, 282.7667, 240, 282.7667, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 180, 240, 300, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Santo_Domingo": {
        "abbrs": ["SDMT", "EST", "EDT", "EST", "-0430", "EST", "-0430", "EST", "-0430", "EST", "-0430", "EST", "-0430", "EST", "AST", "EST", "AST"],
        "untils": [-1159773600000, -100119600000, -89668800000, -5770800000, 4422600000, 25678800000, 33193800000, 57733200000, 64816200000, 89182800000, 96438600000, 120632400000, 127974600000, 152082000000, 972799200000, 975823200000, null],
        "offsets": [280, 300, 240, 300, 270, 300, 270, 300, 270, 300, 270, 300, 270, 300, 240, 300, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Sao_Paulo": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02"],
        "untils": [-1767214412000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -195426000000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, 592974000000, 602042400000, 624423600000, 634701600000, 656478000000, 666756000000, 687927600000, 697600800000, 719982000000, 728445600000, 750826800000, 761709600000, 782276400000, 793159200000, 813726000000, 824004000000, 844570800000, 856058400000, 876106800000, 888717600000, 908074800000, 919562400000, 938919600000, 951616800000, 970974000000, 982461600000, 1003028400000, 1013911200000, 1036292400000, 1045360800000, 1066532400000, 1076810400000, 1099364400000, 1108864800000, 1129431600000, 1140314400000, 1162695600000, 1172368800000, 1192330800000, 1203213600000, 1224385200000, 1234663200000, 1255834800000, 1266717600000, 1287284400000, 1298167200000, 1318734000000, 1330221600000, 1350788400000, 1361066400000, 1382238000000, 1392516000000, 1413687600000, 1424570400000, 1445137200000, 1456020000000, 1476586800000, 1487469600000, 1508036400000, 1518919200000, 1541300400000, 1550368800000, 1572750000000, 1581818400000, 1604199600000, 1613872800000, 1636254000000, 1645322400000, 1667703600000, 1677376800000, 1699153200000, 1708221600000, 1730602800000, 1739671200000, 1762052400000, 1771725600000, 1793502000000, 1803175200000, 1825556400000, 1834624800000, 1857006000000, 1866074400000, 1888455600000, 1897524000000, 1919905200000, 1928973600000, 1951354800000, 1960423200000, 1983409200000, 1992477600000, 2014858800000, 2024532000000, 2046308400000, 2055376800000, 2077758000000, 2086826400000, 2109207600000, 2118880800000, 2140657200000, null],
        "offsets": [186.4667, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Scoresbysund": {
        "abbrs": ["LMT", "-02", "-01", "-02", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01"],
        "untils": [-1686090728000, 323841600000, 338961600000, 354679200000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [87.8667, 120, 60, 120, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Shiprock": {
        "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -1570374000000, -1551628800000, -1538924400000, -1534089600000, -880210800000, -769395600000, -765388800000, -147884400000, -131558400000, -116434800000, -100108800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Sitka": {
        "abbrs": ["PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "YST", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST"],
        "untils": [-880207200000, -769395600000, -765385200000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 126698400000, 152096400000, 162381600000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 439030800000, 452084400000, 467805600000, 483534000000, 499255200000, 514983600000, 530704800000, 544618800000, 562154400000, 576068400000, 594208800000, 607518000000, 625658400000, 638967600000, 657108000000, 671022000000, 688557600000, 702471600000, 720007200000, 733921200000, 752061600000, 765370800000, 783511200000, 796820400000, 814960800000, 828874800000, 846410400000, 860324400000, 877860000000, 891774000000, 909309600000, 923223600000, 941364000000, 954673200000, 972813600000, 986122800000, 1004263200000, 1018177200000, 1035712800000, 1049626800000, 1067162400000, 1081076400000, 1099216800000, 1112526000000, 1130666400000, 1143975600000, 1162116000000, 1173610800000, 1194170400000, 1205060400000, 1225620000000, 1236510000000, 1257069600000, 1268564400000, 1289124000000, 1300014000000, 1320573600000, 1331463600000, 1352023200000, 1362913200000, 1383472800000, 1394362800000, 1414922400000, 1425812400000, 1446372000000, 1457866800000, 1478426400000, 1489316400000, 1509876000000, 1520766000000, 1541325600000, 1552215600000, 1572775200000, 1583665200000, 1604224800000, 1615719600000, 1636279200000, 1647169200000, 1667728800000, 1678618800000, 1699178400000, 1710068400000, 1730628000000, 1741518000000, 1762077600000, 1772967600000, 1793527200000, 1805022000000, 1825581600000, 1836471600000, 1857031200000, 1867921200000, 1888480800000, 1899370800000, 1919930400000, 1930820400000, 1951380000000, 1962874800000, 1983434400000, 1994324400000, 2014884000000, 2025774000000, 2046333600000, 2057223600000, 2077783200000, 2088673200000, 2109232800000, 2120122800000, 2140682400000, null],
        "offsets": [480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 540, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540],
        "isdsts": [0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "St_Barthelemy": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "St_Johns": {
        "abbrs": ["NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NWT", "NPT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST"],
        "untils": [-1664130548000, -1650137348000, -1632076148000, -1615145348000, -1598650148000, -1590100148000, -1567286948000, -1551565748000, -1535837348000, -1520116148000, -1503782948000, -1488666548000, -1472333348000, -1457216948000, -1440883748000, -1425767348000, -1409434148000, -1394317748000, -1377984548000, -1362263348000, -1346534948000, -1330813748000, -1314480548000, -1299364148000, -1283030948000, -1267914548000, -1251581348000, -1236464948000, -1220131748000, -1205015348000, -1188682148000, -1172960948000, -1156627748000, -1141511348000, -1125178148000, -1110061748000, -1096921748000, -1093728600000, -1078612200000, -1061670600000, -1048973400000, -1030221000000, -1017523800000, -998771400000, -986074200000, -966717000000, -954624600000, -935267400000, -922570200000, -903817800000, -891120600000, -872368200000, -769395600000, -765401400000, -746044200000, -733347000000, -714594600000, -701897400000, -683145000000, -670447800000, -651695400000, -638998200000, -619641000000, -606943800000, -589401000000, -576099000000, -557951400000, -544649400000, -526501800000, -513199800000, -495052200000, -481750200000, -463602600000, -450300600000, -431548200000, -418246200000, -400098600000, -386796600000, -368649000000, -355347000000, -337199400000, -323897400000, -305749800000, -289423800000, -273695400000, -257974200000, -242245800000, -226524600000, -210796200000, -195075000000, -179346600000, -163625400000, -147897000000, -131571000000, -116447400000, -100121400000, -84393000000, -68671800000, -52943400000, -37222200000, -21493800000, -5772600000, 9955800000, 25677000000, 41405400000, 57731400000, 73459800000, 89181000000, 104909400000, 120630600000, 136359000000, 152080200000, 167808600000, 183529800000, 199258200000, 215584200000, 230707800000, 247033800000, 262762200000, 278483400000, 294211800000, 309933000000, 325661400000, 341382600000, 357111000000, 372832200000, 388560600000, 404886600000, 420010200000, 436336200000, 452064600000, 467785800000, 483514200000, 499235400000, 514963800000, 530685000000, 544591860000, 562127460000, 576041460000, 594178260000, 607491060000, 625631460000, 638940660000, 657081060000, 670995060000, 688530660000, 702444660000, 719980260000, 733894260000, 752034660000, 765343860000, 783484260000, 796793460000, 814933860000, 828847860000, 846383460000, 860297460000, 877833060000, 891747060000, 909282660000, 923196660000, 941337060000, 954646260000, 972786660000, 986095860000, 1004236260000, 1018150260000, 1035685860000, 1049599860000, 1067135460000, 1081049460000, 1099189860000, 1112499060000, 1130639460000, 1143948660000, 1162089060000, 1173583860000, 1194143460000, 1205033460000, 1225593060000, 1236483060000, 1257042660000, 1268537460000, 1289097060000, 1299987060000, 1320553800000, 1331443800000, 1352003400000, 1362893400000, 1383453000000, 1394343000000, 1414902600000, 1425792600000, 1446352200000, 1457847000000, 1478406600000, 1489296600000, 1509856200000, 1520746200000, 1541305800000, 1552195800000, 1572755400000, 1583645400000, 1604205000000, 1615699800000, 1636259400000, 1647149400000, 1667709000000, 1678599000000, 1699158600000, 1710048600000, 1730608200000, 1741498200000, 1762057800000, 1772947800000, 1793507400000, 1805002200000, 1825561800000, 1836451800000, 1857011400000, 1867901400000, 1888461000000, 1899351000000, 1919910600000, 1930800600000, 1951360200000, 1962855000000, 1983414600000, 1994304600000, 2014864200000, 2025754200000, 2046313800000, 2057203800000, 2077763400000, 2088653400000, 2109213000000, 2120103000000, 2140662600000, null],
        "offsets": [210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 90, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "St_Kitts": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "St_Lucia": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "St_Thomas": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "St_Vincent": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Swift_Current": {
        "abbrs": ["LMT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "CST"],
        "untils": [-2030201320000, -1632063600000, -1615132800000, -880210800000, -769395600000, -765388800000, -747241200000, -732729600000, -715791600000, -702489600000, -684342000000, -671040000000, -652892400000, -639590400000, -400086000000, -384364800000, -337186800000, -321465600000, -305737200000, -292435200000, -273682800000, -260985600000, 73472400000, null],
        "offsets": [431.3333, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360],
        "isdsts": [0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Tegucigalpa": {
        "abbrs": ["LMT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1538503868000, 547020000000, 559717200000, 578469600000, 591166800000, 1146981600000, 1154926800000, null],
        "offsets": [348.8667, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0]
      },
      "Thule": {
        "abbrs": ["LMT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-1686079492000, 670399200000, 686120400000, 701848800000, 717570000000, 733903200000, 752043600000, 765352800000, 783493200000, 796802400000, 814942800000, 828856800000, 846392400000, 860306400000, 877842000000, 891756000000, 909291600000, 923205600000, 941346000000, 954655200000, 972795600000, 986104800000, 1004245200000, 1018159200000, 1035694800000, 1049608800000, 1067144400000, 1081058400000, 1099198800000, 1112508000000, 1130648400000, 1143957600000, 1162098000000, 1173592800000, 1194152400000, 1205042400000, 1225602000000, 1236492000000, 1257051600000, 1268546400000, 1289106000000, 1299996000000, 1320555600000, 1331445600000, 1352005200000, 1362895200000, 1383454800000, 1394344800000, 1414904400000, 1425794400000, 1446354000000, 1457848800000, 1478408400000, 1489298400000, 1509858000000, 1520748000000, 1541307600000, 1552197600000, 1572757200000, 1583647200000, 1604206800000, 1615701600000, 1636261200000, 1647151200000, 1667710800000, 1678600800000, 1699160400000, 1710050400000, 1730610000000, 1741500000000, 1762059600000, 1772949600000, 1793509200000, 1805004000000, 1825563600000, 1836453600000, 1857013200000, 1867903200000, 1888462800000, 1899352800000, 1919912400000, 1930802400000, 1951362000000, 1962856800000, 1983416400000, 1994306400000, 2014866000000, 2025756000000, 2046315600000, 2057205600000, 2077765200000, 2088655200000, 2109214800000, 2120104800000, 2140664400000, null],
        "offsets": [275.1333, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Thunder_Bay": {
        "abbrs": ["CST", "EST", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1893434400000, -880218000000, -769395600000, -765396000000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 136364400000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [360, 300, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tijuana": {
        "abbrs": ["LMT", "MST", "PST", "MST", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1514736000000, -1451667600000, -1343062800000, -1234803600000, -1222963200000, -1207242000000, -873820800000, -769395600000, -761677200000, -686073600000, -661539600000, -495039600000, -481734000000, -463590000000, -450284400000, -431535600000, -418230000000, -400086000000, -386780400000, -368636400000, -355330800000, -337186800000, -323881200000, -305737200000, -292431600000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1175421600000, 1193562000000, 1207476000000, 1225011600000, 1238925600000, 1256461200000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [468.0667, 420, 480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Toronto": {
        "abbrs": ["EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1632070800000, -1615140000000, -1601753400000, -1583697600000, -1567357200000, -1554667200000, -1534698000000, -1524074400000, -1503248400000, -1492365600000, -1471798800000, -1460916000000, -1440954000000, -1428861600000, -1409504400000, -1397412000000, -1378054800000, -1365962400000, -1346605200000, -1333908000000, -1315155600000, -1301853600000, -1283706000000, -1270404000000, -1252256400000, -1238954400000, -1220806800000, -1207504800000, -1188752400000, -1176055200000, -1157302800000, -1144000800000, -1125853200000, -1112551200000, -1094403600000, -1081101600000, -1062954000000, -1049652000000, -1031504400000, -1018202400000, -1000054800000, -986752800000, -968000400000, -955303200000, -936550800000, -880218000000, -769395600000, -765396000000, -747248400000, -733946400000, -715806000000, -702504000000, -684356400000, -671054400000, -652906800000, -634161600000, -620845200000, -602704800000, -589395600000, -576093600000, -557946000000, -544644000000, -526496400000, -513194400000, -495046800000, -481744800000, -463597200000, -450295200000, -431542800000, -418240800000, -400093200000, -384372000000, -368643600000, -352922400000, -337194000000, -321472800000, -305744400000, -289418400000, -273690000000, -257968800000, -242240400000, -226519200000, -210790800000, -195069600000, -179341200000, -163620000000, -147891600000, -131565600000, -116442000000, -100116000000, -84387600000, -68666400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 136364400000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tortola": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Vancouver": {
        "abbrs": ["PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1632060000000, -1615129200000, -880207200000, -769395600000, -765385200000, -747237600000, -732726000000, -715788000000, -702486000000, -684338400000, -671036400000, -652888800000, -639586800000, -620834400000, -608137200000, -589384800000, -576082800000, -557935200000, -544633200000, -526485600000, -513183600000, -495036000000, -481734000000, -463586400000, -450284400000, -431532000000, -418230000000, -400082400000, -386780400000, -368632800000, -355330800000, -337183200000, -323881200000, -305733600000, -292431600000, -273679200000, -260982000000, -242229600000, -226508400000, -210780000000, -195058800000, -179330400000, -163609200000, -147880800000, -131554800000, -116431200000, -100105200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 136375200000, 152096400000, 167824800000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Virgin": {
        "abbrs": ["LMT", "AST"],
        "untils": [-1825098836000, null],
        "offsets": [246.0667, 240],
        "isdsts": [0, 0]
      },
      "Whitehorse": {
        "abbrs": ["YST", "YDT", "YST", "YDT", "YST", "YWT", "YPT", "YST", "YDDT", "YST", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1632056400000, -1615125600000, -1596978000000, -1583164800000, -880203600000, -769395600000, -765381600000, -147884400000, -131554800000, -81961200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [540, 480, 540, 480, 540, 480, 480, 540, 420, 540, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Winnipeg": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1694368800000, -1681671600000, -1632067200000, -1615136400000, -1029686400000, -1018198800000, -880214400000, -769395600000, -765392400000, -746035200000, -732733200000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620755200000, -607626000000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -450291600000, -431539200000, -418237200000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -321469200000, -305740800000, -292438800000, -210787200000, -198090000000, -116438400000, -100108800000, -84384000000, -68659200000, -52934400000, -37209600000, -21484800000, -5760000000, 9964800000, 25689600000, 41414400000, 57744000000, 73468800000, 89193600000, 104918400000, 120643200000, 136368000000, 152092800000, 167817600000, 183542400000, 199267200000, 215596800000, 230716800000, 247046400000, 262771200000, 278496000000, 294220800000, 309945600000, 325670400000, 341395200000, 357120000000, 372844800000, 388569600000, 404899200000, 420019200000, 436348800000, 452073600000, 467798400000, 483523200000, 499248000000, 514972800000, 530697600000, 544608000000, 562147200000, 576057600000, 594201600000, 607507200000, 625651200000, 638956800000, 657100800000, 671011200000, 688550400000, 702460800000, 720000000000, 733910400000, 752054400000, 765360000000, 783504000000, 796809600000, 814953600000, 828864000000, 846403200000, 860313600000, 877852800000, 891763200000, 909302400000, 923212800000, 941356800000, 954662400000, 972806400000, 986112000000, 1004256000000, 1018166400000, 1035705600000, 1049616000000, 1067155200000, 1081065600000, 1099209600000, 1112515200000, 1130659200000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Yakutat": {
        "abbrs": ["YST", "YWT", "YPT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "YDT", "YST", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST"],
        "untils": [-880203600000, -769395600000, -765381600000, -21474000000, -5752800000, 9975600000, 25696800000, 41425200000, 57751200000, 73479600000, 89200800000, 104929200000, 120650400000, 126702000000, 152100000000, 162385200000, 183549600000, 199278000000, 215604000000, 230727600000, 247053600000, 262782000000, 278503200000, 294231600000, 309952800000, 325681200000, 341402400000, 357130800000, 372852000000, 388580400000, 404906400000, 420030000000, 436356000000, 439030800000, 452084400000, 467805600000, 483534000000, 499255200000, 514983600000, 530704800000, 544618800000, 562154400000, 576068400000, 594208800000, 607518000000, 625658400000, 638967600000, 657108000000, 671022000000, 688557600000, 702471600000, 720007200000, 733921200000, 752061600000, 765370800000, 783511200000, 796820400000, 814960800000, 828874800000, 846410400000, 860324400000, 877860000000, 891774000000, 909309600000, 923223600000, 941364000000, 954673200000, 972813600000, 986122800000, 1004263200000, 1018177200000, 1035712800000, 1049626800000, 1067162400000, 1081076400000, 1099216800000, 1112526000000, 1130666400000, 1143975600000, 1162116000000, 1173610800000, 1194170400000, 1205060400000, 1225620000000, 1236510000000, 1257069600000, 1268564400000, 1289124000000, 1300014000000, 1320573600000, 1331463600000, 1352023200000, 1362913200000, 1383472800000, 1394362800000, 1414922400000, 1425812400000, 1446372000000, 1457866800000, 1478426400000, 1489316400000, 1509876000000, 1520766000000, 1541325600000, 1552215600000, 1572775200000, 1583665200000, 1604224800000, 1615719600000, 1636279200000, 1647169200000, 1667728800000, 1678618800000, 1699178400000, 1710068400000, 1730628000000, 1741518000000, 1762077600000, 1772967600000, 1793527200000, 1805022000000, 1825581600000, 1836471600000, 1857031200000, 1867921200000, 1888480800000, 1899370800000, 1919930400000, 1930820400000, 1951380000000, 1962874800000, 1983434400000, 1994324400000, 2014884000000, 2025774000000, 2046333600000, 2057223600000, 2077783200000, 2088673200000, 2109232800000, 2120122800000, 2140682400000, null],
        "offsets": [540, 480, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540],
        "isdsts": [0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Yellowknife": {
        "abbrs": ["-00", "MST", "MWT", "MPT", "MST", "MDDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1104537600000, -880210800000, -769395600000, -765388800000, -147891600000, -131562000000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [0, 420, 360, 360, 420, 300, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "Antarctica": {
      "Casey": {
        "abbrs": ["-00", "+08", "+11", "+08", "+11", "+08", "+11", "+08"],
        "untils": [-31536000000, 1255802400000, 1267714800000, 1319738400000, 1329843600000, 1477065600000, 1520701200000, null],
        "offsets": [0, -480, -660, -480, -660, -480, -660, -480],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0]
      },
      "Davis": {
        "abbrs": ["-00", "+07", "-00", "+07", "+05", "+07", "+05", "+07"],
        "untils": [-409190400000, -163062000000, -28857600000, 1255806000000, 1268251200000, 1319742000000, 1329854400000, null],
        "offsets": [0, -420, 0, -420, -300, -420, -300, -420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0]
      },
      "DumontDUrville": {
        "abbrs": ["-00", "+10", "-00", "+10"],
        "untils": [-725846400000, -566992800000, -415497600000, null],
        "offsets": [0, -600, 0, -600],
        "isdsts": [0, 0, 0, 0]
      },
      "Macquarie": {
        "abbrs": ["AEST", "AEDT", "AEST", "-00", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "+11"],
        "untils": [-1680508800000, -1665392400000, -1601719200000, -687052800000, -71136000000, -55411200000, -37267200000, -25776000000, -5817600000, 5673600000, 25632000000, 37728000000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386092800000, 404841600000, 417542400000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 510076800000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 637689600000, 657043200000, 670348800000, 686678400000, 701798400000, 718128000000, 733248000000, 749577600000, 764697600000, 781027200000, 796147200000, 812476800000, 828201600000, 844531200000, 859651200000, 875980800000, 891100800000, 907430400000, 922550400000, 938880000000, 954000000000, 967305600000, 985449600000, 1002384000000, 1017504000000, 1033833600000, 1048953600000, 1065283200000, 1080403200000, 1096732800000, 1111852800000, 1128182400000, 1143907200000, 1159632000000, 1174752000000, 1191686400000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, null],
        "offsets": [-600, -660, -600, 0, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -660],
        "isdsts": [0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Mawson": {
        "abbrs": ["-00", "+06", "+05"],
        "untils": [-501206400000, 1255809600000, null],
        "offsets": [0, -360, -300],
        "isdsts": [0, 0, 0]
      },
      "McMurdo": {
        "abbrs": ["NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT"],
        "untils": [-1330335000000, -1320057000000, -1300699800000, -1287396000000, -1269250200000, -1255946400000, -1237800600000, -1224496800000, -1206351000000, -1192442400000, -1174901400000, -1160992800000, -1143451800000, -1125914400000, -1112607000000, -1094464800000, -1081157400000, -1063015200000, -1049707800000, -1031565600000, -1018258200000, -1000116000000, -986808600000, -968061600000, -955359000000, -936612000000, -923304600000, -757425600000, 152632800000, 162309600000, 183477600000, 194968800000, 215532000000, 226418400000, 246981600000, 257868000000, 278431200000, 289317600000, 309880800000, 320767200000, 341330400000, 352216800000, 372780000000, 384271200000, 404834400000, 415720800000, 436284000000, 447170400000, 467733600000, 478620000000, 499183200000, 510069600000, 530632800000, 541519200000, 562082400000, 573573600000, 594136800000, 605023200000, 623772000000, 637682400000, 655221600000, 669132000000, 686671200000, 700581600000, 718120800000, 732636000000, 749570400000, 764085600000, 781020000000, 795535200000, 812469600000, 826984800000, 844524000000, 858434400000, 875973600000, 889884000000, 907423200000, 921938400000, 938872800000, 953388000000, 970322400000, 984837600000, 1002376800000, 1016287200000, 1033826400000, 1047736800000, 1065276000000, 1079791200000, 1096725600000, 1111240800000, 1128175200000, 1142690400000, 1159624800000, 1174140000000, 1191074400000, 1207404000000, 1222524000000, 1238853600000, 1253973600000, 1270303200000, 1285423200000, 1301752800000, 1316872800000, 1333202400000, 1348927200000, 1365256800000, 1380376800000, 1396706400000, 1411826400000, 1428156000000, 1443276000000, 1459605600000, 1474725600000, 1491055200000, 1506175200000, 1522504800000, 1538229600000, 1554559200000, 1569679200000, 1586008800000, 1601128800000, 1617458400000, 1632578400000, 1648908000000, 1664028000000, 1680357600000, 1695477600000, 1712412000000, 1727532000000, 1743861600000, 1758981600000, 1775311200000, 1790431200000, 1806760800000, 1821880800000, 1838210400000, 1853330400000, 1869660000000, 1885384800000, 1901714400000, 1916834400000, 1933164000000, 1948284000000, 1964613600000, 1979733600000, 1996063200000, 2011183200000, 2027512800000, 2042632800000, 2058962400000, 2074687200000, 2091016800000, 2106136800000, 2122466400000, 2137586400000, null],
        "offsets": [-690, -750, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Palmer": {
        "abbrs": ["-00", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-03"],
        "untils": [-157766400000, -152658000000, -132955200000, -121122000000, -101419200000, -86821200000, -71092800000, -54766800000, -39038400000, -23317200000, -7588800000, 128142000000, 136605600000, 389070000000, 403070400000, 416372400000, 434520000000, 447822000000, 466574400000, 479271600000, 498024000000, 510721200000, 529473600000, 545194800000, 560923200000, 574225200000, 592372800000, 605674800000, 624427200000, 637124400000, 653457600000, 668574000000, 687326400000, 700628400000, 718776000000, 732078000000, 750225600000, 763527600000, 781675200000, 794977200000, 813729600000, 826426800000, 845179200000, 859690800000, 876628800000, 889930800000, 906868800000, 923194800000, 939528000000, 952830000000, 971582400000, 984279600000, 1003032000000, 1015729200000, 1034481600000, 1047178800000, 1065931200000, 1079233200000, 1097380800000, 1110682800000, 1128830400000, 1142132400000, 1160884800000, 1173582000000, 1192334400000, 1206846000000, 1223784000000, 1237086000000, 1255233600000, 1270350000000, 1286683200000, 1304823600000, 1313899200000, 1335668400000, 1346558400000, 1367118000000, 1378612800000, 1398567600000, 1410062400000, 1463281200000, 1471147200000, 1480820400000, null],
        "offsets": [0, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 180],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Rothera": {
        "abbrs": ["-00", "-03"],
        "untils": [218246400000, null],
        "offsets": [0, 180],
        "isdsts": [0, 0]
      },
      "South_Pole": {
        "abbrs": ["NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT"],
        "untils": [-1330335000000, -1320057000000, -1300699800000, -1287396000000, -1269250200000, -1255946400000, -1237800600000, -1224496800000, -1206351000000, -1192442400000, -1174901400000, -1160992800000, -1143451800000, -1125914400000, -1112607000000, -1094464800000, -1081157400000, -1063015200000, -1049707800000, -1031565600000, -1018258200000, -1000116000000, -986808600000, -968061600000, -955359000000, -936612000000, -923304600000, -757425600000, 152632800000, 162309600000, 183477600000, 194968800000, 215532000000, 226418400000, 246981600000, 257868000000, 278431200000, 289317600000, 309880800000, 320767200000, 341330400000, 352216800000, 372780000000, 384271200000, 404834400000, 415720800000, 436284000000, 447170400000, 467733600000, 478620000000, 499183200000, 510069600000, 530632800000, 541519200000, 562082400000, 573573600000, 594136800000, 605023200000, 623772000000, 637682400000, 655221600000, 669132000000, 686671200000, 700581600000, 718120800000, 732636000000, 749570400000, 764085600000, 781020000000, 795535200000, 812469600000, 826984800000, 844524000000, 858434400000, 875973600000, 889884000000, 907423200000, 921938400000, 938872800000, 953388000000, 970322400000, 984837600000, 1002376800000, 1016287200000, 1033826400000, 1047736800000, 1065276000000, 1079791200000, 1096725600000, 1111240800000, 1128175200000, 1142690400000, 1159624800000, 1174140000000, 1191074400000, 1207404000000, 1222524000000, 1238853600000, 1253973600000, 1270303200000, 1285423200000, 1301752800000, 1316872800000, 1333202400000, 1348927200000, 1365256800000, 1380376800000, 1396706400000, 1411826400000, 1428156000000, 1443276000000, 1459605600000, 1474725600000, 1491055200000, 1506175200000, 1522504800000, 1538229600000, 1554559200000, 1569679200000, 1586008800000, 1601128800000, 1617458400000, 1632578400000, 1648908000000, 1664028000000, 1680357600000, 1695477600000, 1712412000000, 1727532000000, 1743861600000, 1758981600000, 1775311200000, 1790431200000, 1806760800000, 1821880800000, 1838210400000, 1853330400000, 1869660000000, 1885384800000, 1901714400000, 1916834400000, 1933164000000, 1948284000000, 1964613600000, 1979733600000, 1996063200000, 2011183200000, 2027512800000, 2042632800000, 2058962400000, 2074687200000, 2091016800000, 2106136800000, 2122466400000, 2137586400000, null],
        "offsets": [-690, -750, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Syowa": {
        "abbrs": ["-00", "+03"],
        "untils": [-407808000000, null],
        "offsets": [0, -180],
        "isdsts": [0, 0]
      },
      "Troll": {
        "abbrs": ["-00", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00", "+02", "+00"],
        "untils": [1108166400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0, -120, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Vostok": {
        "abbrs": ["-00", "+06"],
        "untils": [-380073600000, null],
        "offsets": [0, -360],
        "isdsts": [0, 0]
      }
    },
    "Arctic": {
      "Longyearbyen": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1691884800000, -1680573600000, -927511200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -765327600000, -340844400000, -324514800000, -308790000000, -293065200000, -277340400000, -261615600000, -245890800000, -230166000000, -214441200000, -198716400000, -182991600000, -166662000000, -147913200000, -135212400000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "Asia": {
      "Aden": {
        "abbrs": ["LMT", "+03"],
        "untils": [-719636812000, null],
        "offsets": [-186.8667, -180],
        "isdsts": [0, 0]
      },
      "Almaty": {
        "abbrs": ["LMT", "+05", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+06", "+05", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06"],
        "untils": [-1441170468000, -1247547600000, 354909600000, 370717200000, 386445600000, 402253200000, 417981600000, 433789200000, 449604000000, 465336000000, 481060800000, 496785600000, 512510400000, 528235200000, 543960000000, 559684800000, 575409600000, 591134400000, 606859200000, 622584000000, 638308800000, 654638400000, 670363200000, 686091600000, 695768400000, 701812800000, 717537600000, 733262400000, 748987200000, 764712000000, 780436800000, 796161600000, 811886400000, 828216000000, 846360000000, 859665600000, 877809600000, 891115200000, 909259200000, 922564800000, 941313600000, 954014400000, 972763200000, 985464000000, 1004212800000, 1017518400000, 1035662400000, 1048968000000, 1067112000000, 1080417600000, 1099166400000, null],
        "offsets": [-307.8, -300, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -360, -300, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Amman": {
        "abbrs": ["LMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1230776624000, 108165600000, 118270800000, 136591200000, 149806800000, 168127200000, 181342800000, 199749600000, 215643600000, 231285600000, 244501200000, 262735200000, 275950800000, 481154400000, 496962000000, 512949600000, 528670800000, 544399200000, 560120400000, 575848800000, 592174800000, 610581600000, 623624400000, 641167200000, 655074000000, 671839200000, 685918800000, 702856800000, 717973200000, 733701600000, 749422800000, 765151200000, 779662800000, 797205600000, 811116000000, 828655200000, 843170400000, 860104800000, 874620000000, 891554400000, 906069600000, 930780000000, 938124000000, 954367200000, 970178400000, 985816800000, 1001628000000, 1017352800000, 1033077600000, 1048802400000, 1066946400000, 1080252000000, 1097791200000, 1112306400000, 1128031200000, 1143756000000, 1161900000000, 1175205600000, 1193349600000, 1206655200000, 1225404000000, 1238104800000, 1256853600000, 1269554400000, 1288303200000, 1301608800000, 1319752800000, 1333058400000, 1387486800000, 1395957600000, 1414706400000, 1427407200000, 1446156000000, 1459461600000, 1477605600000, 1490911200000, 1509055200000, 1522360800000, 1540504800000, 1553810400000, 1571954400000, 1585260000000, 1604008800000, 1616709600000, 1635458400000, 1648764000000, 1666908000000, 1680213600000, 1698357600000, 1711663200000, 1729807200000, 1743112800000, 1761861600000, 1774562400000, 1793311200000, 1806012000000, 1824760800000, 1838066400000, 1856210400000, 1869516000000, 1887660000000, 1900965600000, 1919109600000, 1932415200000, 1951164000000, 1963864800000, 1982613600000, 1995919200000, 2014063200000, 2027368800000, 2045512800000, 2058818400000, 2076962400000, 2090268000000, 2109016800000, 2121717600000, 2140466400000, null],
        "offsets": [-143.7333, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Anadyr": {
        "abbrs": ["LMT", "+12", "+13", "+14", "+13", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+12", "+11", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+12", "+11", "+12"],
        "untils": [-1441194596000, -1247572800000, 354884400000, 370692000000, 386420400000, 402231600000, 417960000000, 433767600000, 449582400000, 465314400000, 481039200000, 496764000000, 512488800000, 528213600000, 543938400000, 559663200000, 575388000000, 591112800000, 606837600000, 622562400000, 638287200000, 654616800000, 670341600000, 686070000000, 695746800000, 701791200000, 717516000000, 733240800000, 748965600000, 764690400000, 780415200000, 796140000000, 811864800000, 828194400000, 846338400000, 859644000000, 877788000000, 891093600000, 909237600000, 922543200000, 941292000000, 953992800000, 972741600000, 985442400000, 1004191200000, 1017496800000, 1035640800000, 1048946400000, 1067090400000, 1080396000000, 1099144800000, 1111845600000, 1130594400000, 1143295200000, 1162044000000, 1174744800000, 1193493600000, 1206799200000, 1224943200000, 1238248800000, 1256392800000, 1269698400000, 1288450800000, 1301151600000, null],
        "offsets": [-709.9333, -720, -780, -840, -780, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -720, -660, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -720, -660, -720],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Aqtau": {
        "abbrs": ["LMT", "+04", "+05", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05", "+06", "+05", "+06", "+05", "+06", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+05"],
        "untils": [-1441164064000, -1247544000000, 370724400000, 386445600000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686095200000, 695772000000, 701816400000, 717541200000, 733266000000, 748990800000, 764715600000, 780440400000, 796168800000, 811893600000, 828223200000, 846367200000, 859672800000, 877816800000, 891122400000, 909266400000, 922572000000, 941320800000, 954021600000, 972770400000, 985471200000, 1004220000000, 1017525600000, 1035669600000, 1048975200000, 1067119200000, 1080424800000, 1099173600000, null],
        "offsets": [-201.0667, -240, -300, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300, -360, -300, -360, -300, -360, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -300],
        "isdsts": [0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Aqtobe": {
        "abbrs": ["LMT", "+04", "+05", "+06", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05"],
        "untils": [-1441165720000, -1247544000000, 354913200000, 370720800000, 386445600000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686095200000, 695772000000, 701816400000, 717541200000, 733266000000, 748990800000, 764715600000, 780440400000, 796165200000, 811890000000, 828219600000, 846363600000, 859669200000, 877813200000, 891118800000, 909262800000, 922568400000, 941317200000, 954018000000, 972766800000, 985467600000, 1004216400000, 1017522000000, 1035666000000, 1048971600000, 1067115600000, 1080421200000, 1099170000000, null],
        "offsets": [-228.6667, -240, -300, -360, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Ashgabat": {
        "abbrs": ["LMT", "+04", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05"],
        "untils": [-1441166012000, -1247544000000, 354913200000, 370720800000, 386449200000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686095200000, 695772000000, null],
        "offsets": [-233.5333, -240, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Ashkhabad": {
        "abbrs": ["LMT", "+04", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05"],
        "untils": [-1441166012000, -1247544000000, 354913200000, 370720800000, 386449200000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686095200000, 695772000000, null],
        "offsets": [-233.5333, -240, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Atyrau": {
        "abbrs": ["LMT", "+03", "+05", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+05"],
        "untils": [-1441164464000, -1247540400000, 370724400000, 386445600000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686095200000, 695772000000, 701816400000, 717541200000, 733266000000, 748990800000, 764715600000, 780440400000, 796165200000, 811890000000, 828219600000, 846363600000, 859669200000, 877813200000, 891118800000, 909262800000, 922568400000, 941320800000, 954021600000, 972770400000, 985471200000, 1004220000000, 1017525600000, 1035669600000, 1048975200000, 1067119200000, 1080424800000, 1099173600000, null],
        "offsets": [-207.7333, -180, -300, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -300],
        "isdsts": [0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Baghdad": {
        "abbrs": ["BMT", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03"],
        "untils": [-1641005856000, 389048400000, 402264000000, 417906000000, 433800000000, 449614800000, 465422400000, 481150800000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622591200000, 638316000000, 654645600000, 670464000000, 686275200000, 702086400000, 717897600000, 733622400000, 749433600000, 765158400000, 780969600000, 796694400000, 812505600000, 828316800000, 844128000000, 859852800000, 875664000000, 891388800000, 907200000000, 922924800000, 938736000000, 954547200000, 970358400000, 986083200000, 1001894400000, 1017619200000, 1033430400000, 1049155200000, 1064966400000, 1080777600000, 1096588800000, 1112313600000, 1128124800000, 1143849600000, 1159660800000, 1175385600000, 1191196800000, null],
        "offsets": [-177.6, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bahrain": {
        "abbrs": ["LMT", "+04", "+03"],
        "untils": [-1577935568000, 76190400000, null],
        "offsets": [-206.1333, -240, -180],
        "isdsts": [0, 0, 0]
      },
      "Baku": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04"],
        "untils": [-1441163964000, -405140400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622591200000, 638316000000, 654645600000, 670370400000, 686098800000, 701823600000, 717548400000, 828234000000, 846378000000, 859680000000, 877824000000, 891129600000, 909273600000, 922579200000, 941328000000, 954028800000, 972777600000, 985478400000, 1004227200000, 1017532800000, 1035676800000, 1048982400000, 1067126400000, 1080432000000, 1099180800000, 1111881600000, 1130630400000, 1143331200000, 1162080000000, 1174780800000, 1193529600000, 1206835200000, 1224979200000, 1238284800000, 1256428800000, 1269734400000, 1288483200000, 1301184000000, 1319932800000, 1332633600000, 1351382400000, 1364688000000, 1382832000000, 1396137600000, 1414281600000, 1427587200000, 1445731200000, null],
        "offsets": [-199.4, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bangkok": {
        "abbrs": ["BMT", "+07"],
        "untils": [-1570084924000, null],
        "offsets": [-402.0667, -420],
        "isdsts": [0, 0]
      },
      "Barnaul": {
        "abbrs": ["LMT", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+07", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07"],
        "untils": [-1579844100000, -1247551200000, 354906000000, 370713600000, 386442000000, 402249600000, 417978000000, 433785600000, 449600400000, 465332400000, 481057200000, 496782000000, 512506800000, 528231600000, 543956400000, 559681200000, 575406000000, 591130800000, 606855600000, 622580400000, 638305200000, 654634800000, 670359600000, 686088000000, 695764800000, 701809200000, 717534000000, 733258800000, 748983600000, 764708400000, 780433200000, 796158000000, 801590400000, 811886400000, 828216000000, 846360000000, 859665600000, 877809600000, 891115200000, 909259200000, 922564800000, 941313600000, 954014400000, 972763200000, 985464000000, 1004212800000, 1017518400000, 1035662400000, 1048968000000, 1067112000000, 1080417600000, 1099166400000, 1111867200000, 1130616000000, 1143316800000, 1162065600000, 1174766400000, 1193515200000, 1206820800000, 1224964800000, 1238270400000, 1256414400000, 1269720000000, 1288468800000, 1301169600000, 1414263600000, 1459022400000, null],
        "offsets": [-335, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -420, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Beirut": {
        "abbrs": ["EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1570413600000, -1552186800000, -1538359200000, -1522551600000, -1507514400000, -1490583600000, -1473645600000, -1460948400000, -399866400000, -386650800000, -368330400000, -355114800000, -336794400000, -323578800000, -305172000000, -291956400000, -273636000000, -260420400000, 78012000000, 86734800000, 105055200000, 118270800000, 136591200000, 149806800000, 168127200000, 181342800000, 199749600000, 212965200000, 231285600000, 244501200000, 262735200000, 275950800000, 452210400000, 466722000000, 483746400000, 498258000000, 515282400000, 529794000000, 546818400000, 561330000000, 581119200000, 592952400000, 610754400000, 624488400000, 641512800000, 656024400000, 673048800000, 687560400000, 704671200000, 718146000000, 733269600000, 748990800000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 843944400000, 859672800000, 875394000000, 891122400000, 906843600000, 922572000000, 941317200000, 954021600000, 972766800000, 985471200000, 1004216400000, 1017525600000, 1035666000000, 1048975200000, 1067115600000, 1080424800000, 1099170000000, 1111874400000, 1130619600000, 1143324000000, 1162069200000, 1174773600000, 1193518800000, 1206828000000, 1224968400000, 1238277600000, 1256418000000, 1269727200000, 1288472400000, 1301176800000, 1319922000000, 1332626400000, 1351371600000, 1364680800000, 1382821200000, 1396130400000, 1414270800000, 1427580000000, 1445720400000, 1459029600000, 1477774800000, 1490479200000, 1509224400000, 1521928800000, 1540674000000, 1553983200000, 1572123600000, 1585432800000, 1603573200000, 1616882400000, 1635627600000, 1648332000000, 1667077200000, 1679781600000, 1698526800000, 1711836000000, 1729976400000, 1743285600000, 1761426000000, 1774735200000, 1792875600000, 1806184800000, 1824930000000, 1837634400000, 1856379600000, 1869084000000, 1887829200000, 1901138400000, 1919278800000, 1932588000000, 1950728400000, 1964037600000, 1982782800000, 1995487200000, 2014232400000, 2026936800000, 2045682000000, 2058386400000, 2077131600000, 2090440800000, 2108581200000, 2121890400000, 2140030800000, null],
        "offsets": [-120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bishkek": {
        "abbrs": ["LMT", "+05", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+06"],
        "untils": [-1441169904000, -1247547600000, 354909600000, 370717200000, 386445600000, 402253200000, 417981600000, 433789200000, 449604000000, 465336000000, 481060800000, 496785600000, 512510400000, 528235200000, 543960000000, 559684800000, 575409600000, 591134400000, 606859200000, 622584000000, 638308800000, 654638400000, 670363200000, 683582400000, 703018800000, 717530400000, 734468400000, 748980000000, 765918000000, 780429600000, 797367600000, 811879200000, 828817200000, 843933600000, 859671000000, 877811400000, 891120600000, 909261000000, 922570200000, 941315400000, 954019800000, 972765000000, 985469400000, 1004214600000, 1017523800000, 1035664200000, 1048973400000, 1067113800000, 1080423000000, 1099168200000, 1111872600000, 1123783200000, null],
        "offsets": [-298.4, -300, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -360],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Brunei": {
        "abbrs": ["LMT", "+0730", "+08"],
        "untils": [-1383464380000, -1167636600000, null],
        "offsets": [-459.6667, -450, -480],
        "isdsts": [0, 0, 0]
      },
      "Calcutta": {
        "abbrs": ["MMT", "IST", "+0630", "IST", "+0630", "IST"],
        "untils": [-2019705670000, -891581400000, -872058600000, -862637400000, -764145000000, null],
        "offsets": [-321.1667, -330, -390, -330, -390, -330],
        "isdsts": [0, 0, 1, 0, 1, 0]
      },
      "Chita": {
        "abbrs": ["LMT", "+08", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+09", "+08", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+08", "+09"],
        "untils": [-1579419232000, -1247558400000, 354898800000, 370706400000, 386434800000, 402242400000, 417970800000, 433778400000, 449593200000, 465325200000, 481050000000, 496774800000, 512499600000, 528224400000, 543949200000, 559674000000, 575398800000, 591123600000, 606848400000, 622573200000, 638298000000, 654627600000, 670352400000, 686080800000, 695757600000, 701802000000, 717526800000, 733251600000, 748976400000, 764701200000, 780426000000, 796150800000, 811875600000, 828205200000, 846349200000, 859654800000, 877798800000, 891104400000, 909248400000, 922554000000, 941302800000, 954003600000, 972752400000, 985453200000, 1004202000000, 1017507600000, 1035651600000, 1048957200000, 1067101200000, 1080406800000, 1099155600000, 1111856400000, 1130605200000, 1143306000000, 1162054800000, 1174755600000, 1193504400000, 1206810000000, 1224954000000, 1238259600000, 1256403600000, 1269709200000, 1288458000000, 1301158800000, 1414252800000, 1459015200000, null],
        "offsets": [-453.8667, -480, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -540, -480, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -480, -540],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Choibalsan": {
        "abbrs": ["LMT", "+07", "+08", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+08", "+09", "+08", "+09", "+08"],
        "untils": [-2032933080000, 252435600000, 417974400000, 433778400000, 449593200000, 465314400000, 481042800000, 496764000000, 512492400000, 528213600000, 543942000000, 559663200000, 575391600000, 591112800000, 606841200000, 622562400000, 638290800000, 654616800000, 670345200000, 686066400000, 701794800000, 717516000000, 733244400000, 748965600000, 764694000000, 780415200000, 796143600000, 811864800000, 828198000000, 843919200000, 859647600000, 875368800000, 891097200000, 906818400000, 988390800000, 1001692800000, 1017421200000, 1033142400000, 1048870800000, 1064592000000, 1080320400000, 1096041600000, 1111770000000, 1127491200000, 1143219600000, 1159545600000, 1206889200000, 1427479200000, 1443193200000, 1458928800000, 1474642800000, null],
        "offsets": [-458, -420, -480, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0]
      },
      "Chongqing": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-933667200000, -922093200000, -908870400000, -888829200000, -881049600000, -767869200000, -745833600000, -733827600000, -716889600000, -699613200000, -683884800000, -670669200000, -652348800000, -650019600000, 515527200000, 527014800000, 545162400000, 558464400000, 577216800000, 589914000000, 608666400000, 621968400000, 640116000000, 653418000000, 671565600000, 684867600000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Chungking": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-933667200000, -922093200000, -908870400000, -888829200000, -881049600000, -767869200000, -745833600000, -733827600000, -716889600000, -699613200000, -683884800000, -670669200000, -652348800000, -650019600000, 515527200000, 527014800000, 545162400000, 558464400000, 577216800000, 589914000000, 608666400000, 621968400000, 640116000000, 653418000000, 671565600000, 684867600000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Colombo": {
        "abbrs": ["MMT", "+0530", "+06", "+0630", "+0530", "+0630", "+06", "+0530"],
        "untils": [-2019705572000, -883287000000, -862639200000, -764051400000, 832962600000, 846266400000, 1145039400000, null],
        "offsets": [-319.5333, -330, -360, -390, -330, -390, -360, -330],
        "isdsts": [0, 0, 1, 1, 0, 0, 0, 0]
      },
      "Dacca": {
        "abbrs": ["HMT", "+0630", "+0530", "+0630", "+06", "+07", "+06"],
        "untils": [-891582800000, -872058600000, -862637400000, -576138600000, 1245430800000, 1262278800000, null],
        "offsets": [-353.3333, -390, -330, -390, -360, -420, -360],
        "isdsts": [0, 0, 0, 0, 0, 1, 0]
      },
      "Damascus": {
        "abbrs": ["LMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1577931912000, -1568592000000, -1554080400000, -1537142400000, -1522630800000, -1505692800000, -1491181200000, -1474243200000, -1459126800000, -242265600000, -228877200000, -210556800000, -197427600000, -178934400000, -165718800000, -147398400000, -134269200000, -116467200000, -102646800000, -84326400000, -71110800000, -52704000000, -39488400000, -21168000000, -7952400000, 10368000000, 23583600000, 41904000000, 55119600000, 73526400000, 86742000000, 105062400000, 118278000000, 136598400000, 149814000000, 168134400000, 181350000000, 199756800000, 212972400000, 231292800000, 241916400000, 262828800000, 273452400000, 418694400000, 433810800000, 450316800000, 465433200000, 508896000000, 529196400000, 541555200000, 562633200000, 574387200000, 594255600000, 607305600000, 623199600000, 638928000000, 654649200000, 670456800000, 686264400000, 702684000000, 717886800000, 733096800000, 748904400000, 765151200000, 780958800000, 796687200000, 812494800000, 828309600000, 844117200000, 859759200000, 875653200000, 891208800000, 907189200000, 922917600000, 938725200000, 954540000000, 970347600000, 986076000000, 1001883600000, 1017612000000, 1033419600000, 1049148000000, 1064955600000, 1080770400000, 1096578000000, 1112306400000, 1128114000000, 1143842400000, 1158872400000, 1175205600000, 1193950800000, 1207260000000, 1225486800000, 1238104800000, 1256850000000, 1270159200000, 1288299600000, 1301608800000, 1319749200000, 1333058400000, 1351198800000, 1364508000000, 1382648400000, 1395957600000, 1414702800000, 1427407200000, 1446152400000, 1458856800000, 1477602000000, 1490911200000, 1509051600000, 1522360800000, 1540501200000, 1553810400000, 1571950800000, 1585260000000, 1604005200000, 1616709600000, 1635454800000, 1648159200000, 1666904400000, 1680213600000, 1698354000000, 1711663200000, 1729803600000, 1743112800000, 1761858000000, 1774562400000, 1793307600000, 1806012000000, 1824757200000, 1838066400000, 1856206800000, 1869516000000, 1887656400000, 1900965600000, 1919106000000, 1932415200000, 1951160400000, 1963864800000, 1982610000000, 1995314400000, 2014059600000, 2027368800000, 2045509200000, 2058818400000, 2076958800000, 2090268000000, 2109013200000, 2121717600000, 2140462800000, null],
        "offsets": [-145.2, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Dhaka": {
        "abbrs": ["HMT", "+0630", "+0530", "+0630", "+06", "+07", "+06"],
        "untils": [-891582800000, -872058600000, -862637400000, -576138600000, 1245430800000, 1262278800000, null],
        "offsets": [-353.3333, -390, -330, -390, -360, -420, -360],
        "isdsts": [0, 0, 0, 0, 0, 1, 0]
      },
      "Dili": {
        "abbrs": ["LMT", "+08", "+09", "+08", "+09"],
        "untils": [-1830414140000, -879152400000, 199897200000, 969120000000, null],
        "offsets": [-502.3333, -480, -540, -480, -540],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Dubai": {
        "abbrs": ["LMT", "+04"],
        "untils": [-1577936472000, null],
        "offsets": [-221.2, -240],
        "isdsts": [0, 0]
      },
      "Dushanbe": {
        "abbrs": ["LMT", "+05", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+06", "+05"],
        "untils": [-1441168512000, -1247547600000, 354909600000, 370717200000, 386445600000, 402253200000, 417981600000, 433789200000, 449604000000, 465336000000, 481060800000, 496785600000, 512510400000, 528235200000, 543960000000, 559684800000, 575409600000, 591134400000, 606859200000, 622584000000, 638308800000, 654638400000, 670363200000, 684363600000, null],
        "offsets": [-275.2, -300, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -360, -300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Famagusta": {
        "abbrs": ["LMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "+03", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1518920148000, 166572000000, 182293200000, 200959200000, 213829200000, 228866400000, 243982800000, 260316000000, 276123600000, 291765600000, 307486800000, 323820000000, 338936400000, 354664800000, 370386000000, 386114400000, 401835600000, 417564000000, 433285200000, 449013600000, 465339600000, 481068000000, 496789200000, 512517600000, 528238800000, 543967200000, 559688400000, 575416800000, 591138000000, 606866400000, 622587600000, 638316000000, 654642000000, 670370400000, 686091600000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 843944400000, 859672800000, 875394000000, 891122400000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1473282000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-135.8, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Gaza": {
        "abbrs": ["EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-933645600000, -857358000000, -844300800000, -825822000000, -812685600000, -794199600000, -779853600000, -762656400000, -748310400000, -731127600000, -399088800000, -386650800000, -368330400000, -355114800000, -336790800000, -323654400000, -305168400000, -292032000000, -273632400000, -260496000000, -242096400000, -228960000000, -210560400000, -197424000000, -178938000000, -165801600000, -147402000000, -134265600000, -115866000000, -102643200000, -84330000000, -81313200000, 142380000000, 150843600000, 167176800000, 178664400000, 482277600000, 495579600000, 516751200000, 526424400000, 545436000000, 558478800000, 576626400000, 589323600000, 609890400000, 620773200000, 638316000000, 651618000000, 669765600000, 683672400000, 701820000000, 715726800000, 733701600000, 747176400000, 765151200000, 778021200000, 796600800000, 810075600000, 820447200000, 828655200000, 843170400000, 860104800000, 874620000000, 891554400000, 906069600000, 924213600000, 939934800000, 956268000000, 971989200000, 987717600000, 1003438800000, 1019167200000, 1034888400000, 1050616800000, 1066338000000, 1082066400000, 1096581600000, 1113516000000, 1128380400000, 1143842400000, 1158872400000, 1175378400000, 1189638000000, 1206655200000, 1219957200000, 1238104800000, 1252015200000, 1269640860000, 1281474000000, 1301608860000, 1312146000000, 1333058400000, 1348178400000, 1364508000000, 1380229200000, 1395957600000, 1414098000000, 1427493600000, 1445547600000, 1458946800000, 1477692000000, 1490396400000, 1509141600000, 1521846000000, 1540591200000, 1553295600000, 1572040800000, 1585350000000, 1604095200000, 1616799600000, 1635544800000, 1648249200000, 1666994400000, 1679698800000, 1698444000000, 1711148400000, 1729893600000, 1742598000000, 1761343200000, 1774652400000, 1793397600000, 1806102000000, 1824847200000, 1837551600000, 1856296800000, 1869001200000, 1887746400000, 1900450800000, 1919196000000, 1931900400000, 1950645600000, 1963954800000, 1982700000000, 1995404400000, 2014149600000, 2026854000000, 2045599200000, 2058303600000, 2077048800000, 2089753200000, 2108498400000, 2121807600000, 2140552800000, null],
        "offsets": [-120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Harbin": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-933667200000, -922093200000, -908870400000, -888829200000, -881049600000, -767869200000, -745833600000, -733827600000, -716889600000, -699613200000, -683884800000, -670669200000, -652348800000, -650019600000, 515527200000, 527014800000, 545162400000, 558464400000, 577216800000, 589914000000, 608666400000, 621968400000, 640116000000, 653418000000, 671565600000, 684867600000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Hebron": {
        "abbrs": ["EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-933645600000, -857358000000, -844300800000, -825822000000, -812685600000, -794199600000, -779853600000, -762656400000, -748310400000, -731127600000, -399088800000, -386650800000, -368330400000, -355114800000, -336790800000, -323654400000, -305168400000, -292032000000, -273632400000, -260496000000, -242096400000, -228960000000, -210560400000, -197424000000, -178938000000, -165801600000, -147402000000, -134265600000, -115866000000, -102643200000, -84330000000, -81313200000, 142380000000, 150843600000, 167176800000, 178664400000, 482277600000, 495579600000, 516751200000, 526424400000, 545436000000, 558478800000, 576626400000, 589323600000, 609890400000, 620773200000, 638316000000, 651618000000, 669765600000, 683672400000, 701820000000, 715726800000, 733701600000, 747176400000, 765151200000, 778021200000, 796600800000, 810075600000, 820447200000, 828655200000, 843170400000, 860104800000, 874620000000, 891554400000, 906069600000, 924213600000, 939934800000, 956268000000, 971989200000, 987717600000, 1003438800000, 1019167200000, 1034888400000, 1050616800000, 1066338000000, 1082066400000, 1096581600000, 1113516000000, 1128380400000, 1143842400000, 1158872400000, 1175378400000, 1189638000000, 1206655200000, 1220216400000, 1238104800000, 1252015200000, 1269554400000, 1281474000000, 1301608860000, 1312146000000, 1314655200000, 1317330000000, 1333058400000, 1348178400000, 1364508000000, 1380229200000, 1395957600000, 1414098000000, 1427493600000, 1445547600000, 1458946800000, 1477692000000, 1490396400000, 1509141600000, 1521846000000, 1540591200000, 1553295600000, 1572040800000, 1585350000000, 1604095200000, 1616799600000, 1635544800000, 1648249200000, 1666994400000, 1679698800000, 1698444000000, 1711148400000, 1729893600000, 1742598000000, 1761343200000, 1774652400000, 1793397600000, 1806102000000, 1824847200000, 1837551600000, 1856296800000, 1869001200000, 1887746400000, 1900450800000, 1919196000000, 1931900400000, 1950645600000, 1963954800000, 1982700000000, 1995404400000, 2014149600000, 2026854000000, 2045599200000, 2058303600000, 2077048800000, 2089753200000, 2108498400000, 2121807600000, 2140552800000, null],
        "offsets": [-120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Ho_Chi_Minh": {
        "abbrs": ["LMT", "PLMT", "+07", "+08", "+09", "+07", "+08", "+07", "+08", "+07"],
        "untils": [-2004073600000, -1851577590000, -852105600000, -782643600000, -767869200000, -718095600000, -457776000000, -315648000000, 171820800000, null],
        "offsets": [-426.6667, -426.5, -420, -480, -540, -420, -480, -420, -480, -420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      "Hong_Kong": {
        "abbrs": ["LMT", "HKT", "HKST", "HKT", "JST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT"],
        "untils": [-2056693002000, -907389000000, -891667800000, -884246400000, -766746000000, -747981000000, -728544600000, -717049800000, -694503000000, -683785800000, -668064600000, -654755400000, -636615000000, -623305800000, -605165400000, -591856200000, -573715800000, -559801800000, -542352600000, -528352200000, -510211800000, -498112200000, -478762200000, -466662600000, -446707800000, -435213000000, -415258200000, -403158600000, -383808600000, -371709000000, -352359000000, -340259400000, -320909400000, -308809800000, -288855000000, -277360200000, -257405400000, -245910600000, -225955800000, -213856200000, -194506200000, -182406600000, -163056600000, -148537800000, -132816600000, -117088200000, -101367000000, -85638600000, -69312600000, -53584200000, -37863000000, -22134600000, -6413400000, 9315000000, 25036200000, 40764600000, 56485800000, 72214200000, 88540200000, 104268600000, 119989800000, 126041400000, 151439400000, 167167800000, 182889000000, 198617400000, 214338600000, 295385400000, 309292200000, null],
        "offsets": [-456.7, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Hovd": {
        "abbrs": ["LMT", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07"],
        "untils": [-2032927596000, 252439200000, 417978000000, 433785600000, 449600400000, 465321600000, 481050000000, 496771200000, 512499600000, 528220800000, 543949200000, 559670400000, 575398800000, 591120000000, 606848400000, 622569600000, 638298000000, 654624000000, 670352400000, 686073600000, 701802000000, 717523200000, 733251600000, 748972800000, 764701200000, 780422400000, 796150800000, 811872000000, 828205200000, 843926400000, 859654800000, 875376000000, 891104400000, 906825600000, 988398000000, 1001700000000, 1017428400000, 1033149600000, 1048878000000, 1064599200000, 1080327600000, 1096048800000, 1111777200000, 1127498400000, 1143226800000, 1159552800000, 1427482800000, 1443196800000, 1458932400000, 1474646400000, null],
        "offsets": [-366.6, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Irkutsk": {
        "abbrs": ["IMT", "+07", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+08", "+07", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08"],
        "untils": [-1575874625000, -1247554800000, 354902400000, 370710000000, 386438400000, 402246000000, 417974400000, 433782000000, 449596800000, 465328800000, 481053600000, 496778400000, 512503200000, 528228000000, 543952800000, 559677600000, 575402400000, 591127200000, 606852000000, 622576800000, 638301600000, 654631200000, 670356000000, 686084400000, 695761200000, 701805600000, 717530400000, 733255200000, 748980000000, 764704800000, 780429600000, 796154400000, 811879200000, 828208800000, 846352800000, 859658400000, 877802400000, 891108000000, 909252000000, 922557600000, 941306400000, 954007200000, 972756000000, 985456800000, 1004205600000, 1017511200000, 1035655200000, 1048960800000, 1067104800000, 1080410400000, 1099159200000, 1111860000000, 1130608800000, 1143309600000, 1162058400000, 1174759200000, 1193508000000, 1206813600000, 1224957600000, 1238263200000, 1256407200000, 1269712800000, 1288461600000, 1301162400000, 1414256400000, null],
        "offsets": [-417.0833, -420, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -480, -420, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Istanbul": {
        "abbrs": ["IMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "+03"],
        "untils": [-1869875816000, -1693706400000, -1680490800000, -1570413600000, -1552186800000, -1538359200000, -1522551600000, -1507514400000, -1490583600000, -1440208800000, -1428030000000, -1409709600000, -1396494000000, -931140000000, -922762800000, -917834400000, -892436400000, -875844000000, -857358000000, -781063200000, -764737200000, -744343200000, -733806000000, -716436000000, -701924400000, -684986400000, -670474800000, -654141600000, -639025200000, -621828000000, -606970800000, -590032800000, -575434800000, -235620000000, -228279600000, -177732000000, -165726000000, 10533600000, 23835600000, 41983200000, 55285200000, 74037600000, 87339600000, 107910000000, 121219200000, 133920000000, 152676000000, 165362400000, 183502800000, 202428000000, 215557200000, 228866400000, 245797200000, 260316000000, 277246800000, 308779200000, 323827200000, 340228800000, 354672000000, 371678400000, 386121600000, 403128000000, 428446800000, 433886400000, 482792400000, 496702800000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 686098800000, 701823600000, 717548400000, 733273200000, 748998000000, 764118000000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301274000000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396227600000, 1414285200000, 1427590800000, 1446944400000, 1459040400000, 1473195600000, null],
        "offsets": [-116.9333, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Jakarta": {
        "abbrs": ["BMT", "+0720", "+0730", "+09", "+0730", "+08", "+0730", "WIB"],
        "untils": [-1451719200000, -1172906400000, -876641400000, -766054800000, -683883000000, -620812800000, -189415800000, null],
        "offsets": [-427.2, -440, -450, -540, -450, -480, -450, -420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0]
      },
      "Jayapura": {
        "abbrs": ["LMT", "+09", "+0930", "WIT"],
        "untils": [-1172913768000, -799491600000, -189423000000, null],
        "offsets": [-562.8, -540, -570, -540],
        "isdsts": [0, 0, 0, 0]
      },
      "Jerusalem": {
        "abbrs": ["JMT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDDT", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST"],
        "untils": [-1641003640000, -933645600000, -857358000000, -844300800000, -825822000000, -812685600000, -794199600000, -779853600000, -762656400000, -748310400000, -731127600000, -681962400000, -673243200000, -667962000000, -652327200000, -636426000000, -622087200000, -608947200000, -591847200000, -572486400000, -558576000000, -542851200000, -527731200000, -514425600000, -490845600000, -482986800000, -459475200000, -451537200000, -428551200000, -418262400000, -400032000000, -387428400000, 142380000000, 150843600000, 167176800000, 178664400000, 482277600000, 495579600000, 516751200000, 526424400000, 545436000000, 558478800000, 576626400000, 589323600000, 609890400000, 620773200000, 638316000000, 651618000000, 669765600000, 683672400000, 701820000000, 715726800000, 733701600000, 747176400000, 765151200000, 778021200000, 796600800000, 810075600000, 826840800000, 842821200000, 858895200000, 874184400000, 890344800000, 905029200000, 923011200000, 936313200000, 955670400000, 970783200000, 986770800000, 1001282400000, 1017356400000, 1033941600000, 1048806000000, 1065132000000, 1081292400000, 1095804000000, 1112313600000, 1128812400000, 1143763200000, 1159657200000, 1175212800000, 1189897200000, 1206662400000, 1223161200000, 1238112000000, 1254006000000, 1269561600000, 1284246000000, 1301616000000, 1317510000000, 1333065600000, 1348354800000, 1364515200000, 1382828400000, 1395964800000, 1414278000000, 1427414400000, 1445727600000, 1458864000000, 1477782000000, 1490313600000, 1509231600000, 1521763200000, 1540681200000, 1553817600000, 1572130800000, 1585267200000, 1603580400000, 1616716800000, 1635634800000, 1648166400000, 1667084400000, 1679616000000, 1698534000000, 1711670400000, 1729983600000, 1743120000000, 1761433200000, 1774569600000, 1792882800000, 1806019200000, 1824937200000, 1837468800000, 1856386800000, 1868918400000, 1887836400000, 1900972800000, 1919286000000, 1932422400000, 1950735600000, 1963872000000, 1982790000000, 1995321600000, 2014239600000, 2026771200000, 2045689200000, 2058220800000, 2077138800000, 2090275200000, 2108588400000, 2121724800000, 2140038000000, null],
        "offsets": [-140.6667, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -240, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Kabul": {
        "abbrs": ["+04", "+0430"],
        "untils": [-788932800000, null],
        "offsets": [-240, -270],
        "isdsts": [0, 0]
      },
      "Kamchatka": {
        "abbrs": ["LMT", "+11", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+12", "+11", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+12", "+11", "+12"],
        "untils": [-1487759676000, -1247569200000, 354888000000, 370695600000, 386424000000, 402231600000, 417960000000, 433767600000, 449582400000, 465314400000, 481039200000, 496764000000, 512488800000, 528213600000, 543938400000, 559663200000, 575388000000, 591112800000, 606837600000, 622562400000, 638287200000, 654616800000, 670341600000, 686070000000, 695746800000, 701791200000, 717516000000, 733240800000, 748965600000, 764690400000, 780415200000, 796140000000, 811864800000, 828194400000, 846338400000, 859644000000, 877788000000, 891093600000, 909237600000, 922543200000, 941292000000, 953992800000, 972741600000, 985442400000, 1004191200000, 1017496800000, 1035640800000, 1048946400000, 1067090400000, 1080396000000, 1099144800000, 1111845600000, 1130594400000, 1143295200000, 1162044000000, 1174744800000, 1193493600000, 1206799200000, 1224943200000, 1238248800000, 1256392800000, 1269698400000, 1288450800000, 1301151600000, null],
        "offsets": [-634.6, -660, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -720, -660, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -720, -660, -720],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Karachi": {
        "abbrs": ["LMT", "+0530", "+0630", "+0530", "+05", "PKT", "PKST", "PKT", "PKST", "PKT", "PKST", "PKT"],
        "untils": [-1988166492000, -862637400000, -764145000000, -576135000000, 38775600000, 1018119600000, 1033840800000, 1212260400000, 1225476000000, 1239735600000, 1257012000000, null],
        "offsets": [-268.2, -330, -390, -330, -300, -300, -360, -300, -360, -300, -360, -300],
        "isdsts": [0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0]
      },
      "Kashgar": {
        "abbrs": ["LMT", "+06"],
        "untils": [-1325483420000, null],
        "offsets": [-350.3333, -360],
        "isdsts": [0, 0]
      },
      "Kathmandu": {
        "abbrs": ["LMT", "+0530", "+0545"],
        "untils": [-1577943676000, 504901800000, null],
        "offsets": [-341.2667, -330, -345],
        "isdsts": [0, 0, 0]
      },
      "Katmandu": {
        "abbrs": ["LMT", "+0530", "+0545"],
        "untils": [-1577943676000, 504901800000, null],
        "offsets": [-341.2667, -330, -345],
        "isdsts": [0, 0, 0]
      },
      "Khandyga": {
        "abbrs": ["LMT", "+08", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+09", "+08", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+09"],
        "untils": [-1579424533000, -1247558400000, 354898800000, 370706400000, 386434800000, 402242400000, 417970800000, 433778400000, 449593200000, 465325200000, 481050000000, 496774800000, 512499600000, 528224400000, 543949200000, 559674000000, 575398800000, 591123600000, 606848400000, 622573200000, 638298000000, 654627600000, 670352400000, 686080800000, 695757600000, 701802000000, 717526800000, 733251600000, 748976400000, 764701200000, 780426000000, 796150800000, 811875600000, 828205200000, 846349200000, 859654800000, 877798800000, 891104400000, 909248400000, 922554000000, 941302800000, 954003600000, 972752400000, 985453200000, 1004202000000, 1017507600000, 1035651600000, 1048957200000, 1067101200000, 1072882800000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143302400000, 1162051200000, 1174752000000, 1193500800000, 1206806400000, 1224950400000, 1238256000000, 1256400000000, 1269705600000, 1288454400000, 1301155200000, 1315832400000, 1414252800000, null],
        "offsets": [-542.2167, -480, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -540, -480, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -540],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Kolkata": {
        "abbrs": ["MMT", "IST", "+0630", "IST", "+0630", "IST"],
        "untils": [-2019705670000, -891581400000, -872058600000, -862637400000, -764145000000, null],
        "offsets": [-321.1667, -330, -390, -330, -390, -330],
        "isdsts": [0, 0, 1, 0, 1, 0]
      },
      "Krasnoyarsk": {
        "abbrs": ["LMT", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+07", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07"],
        "untils": [-1577513486000, -1247551200000, 354906000000, 370713600000, 386442000000, 402249600000, 417978000000, 433785600000, 449600400000, 465332400000, 481057200000, 496782000000, 512506800000, 528231600000, 543956400000, 559681200000, 575406000000, 591130800000, 606855600000, 622580400000, 638305200000, 654634800000, 670359600000, 686088000000, 695764800000, 701809200000, 717534000000, 733258800000, 748983600000, 764708400000, 780433200000, 796158000000, 811882800000, 828212400000, 846356400000, 859662000000, 877806000000, 891111600000, 909255600000, 922561200000, 941310000000, 954010800000, 972759600000, 985460400000, 1004209200000, 1017514800000, 1035658800000, 1048964400000, 1067108400000, 1080414000000, 1099162800000, 1111863600000, 1130612400000, 1143313200000, 1162062000000, 1174762800000, 1193511600000, 1206817200000, 1224961200000, 1238266800000, 1256410800000, 1269716400000, 1288465200000, 1301166000000, 1414260000000, null],
        "offsets": [-371.4333, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -420, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Kuala_Lumpur": {
        "abbrs": ["SMT", "+07", "+0720", "+0720", "+0730", "+09", "+0730", "+08"],
        "untils": [-2038200925000, -1167634800000, -1073028000000, -894180000000, -879665400000, -767005200000, 378664200000, null],
        "offsets": [-415.4167, -420, -440, -440, -450, -540, -450, -480],
        "isdsts": [0, 0, 1, 0, 0, 0, 0, 0]
      },
      "Kuching": {
        "abbrs": ["LMT", "+0730", "+08", "+0820", "+08", "+0820", "+08", "+0820", "+08", "+0820", "+08", "+0820", "+08", "+0820", "+08", "+0820", "+08", "+09", "+08"],
        "untils": [-1383463280000, -1167636600000, -1082448000000, -1074586800000, -1050825600000, -1042964400000, -1019289600000, -1011428400000, -987753600000, -979892400000, -956217600000, -948356400000, -924595200000, -916734000000, -893059200000, -885198000000, -879667200000, -767005200000, null],
        "offsets": [-441.3333, -450, -480, -500, -480, -500, -480, -500, -480, -500, -480, -500, -480, -500, -480, -500, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Kuwait": {
        "abbrs": ["LMT", "+03"],
        "untils": [-719636812000, null],
        "offsets": [-186.8667, -180],
        "isdsts": [0, 0]
      },
      "Macao": {
        "abbrs": ["LMT", "CST", "+09", "+10", "+09", "+10", "+09", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-2056692850000, -884509200000, -873280800000, -855918000000, -841744800000, -828529200000, -765363600000, -747046800000, -733827600000, -716461200000, -697021200000, -683715600000, -667990800000, -654771600000, -636627600000, -623322000000, -605178000000, -591872400000, -573642000000, -559818000000, -541674000000, -528368400000, -510224400000, -498128400000, -478774800000, -466678800000, -446720400000, -435229200000, -415258200000, -403158600000, -383808600000, -371709000000, -352359000000, -340259400000, -320909400000, -308809800000, -288855000000, -277360200000, -257405400000, -245910600000, -225955800000, -213856200000, -194506200000, -182406600000, -163056600000, -148537800000, -132820200000, -117088200000, -101370600000, -85638600000, -69312600000, -53584200000, -37863000000, -22134600000, -6413400000, 9315000000, 25036200000, 40764600000, 56485800000, 72214200000, 88540200000, 104268600000, 119989800000, 126041400000, 151439400000, 167167800000, 182889000000, 198617400000, 214338600000, 295385400000, 309292200000, null],
        "offsets": [-454.1667, -480, -540, -600, -540, -600, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Macau": {
        "abbrs": ["LMT", "CST", "+09", "+10", "+09", "+10", "+09", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-2056692850000, -884509200000, -873280800000, -855918000000, -841744800000, -828529200000, -765363600000, -747046800000, -733827600000, -716461200000, -697021200000, -683715600000, -667990800000, -654771600000, -636627600000, -623322000000, -605178000000, -591872400000, -573642000000, -559818000000, -541674000000, -528368400000, -510224400000, -498128400000, -478774800000, -466678800000, -446720400000, -435229200000, -415258200000, -403158600000, -383808600000, -371709000000, -352359000000, -340259400000, -320909400000, -308809800000, -288855000000, -277360200000, -257405400000, -245910600000, -225955800000, -213856200000, -194506200000, -182406600000, -163056600000, -148537800000, -132820200000, -117088200000, -101370600000, -85638600000, -69312600000, -53584200000, -37863000000, -22134600000, -6413400000, 9315000000, 25036200000, 40764600000, 56485800000, 72214200000, 88540200000, 104268600000, 119989800000, 126041400000, 151439400000, 167167800000, 182889000000, 198617400000, 214338600000, 295385400000, 309292200000, null],
        "offsets": [-454.1667, -480, -540, -600, -540, -600, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Magadan": {
        "abbrs": ["LMT", "+10", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+11", "+10", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+10", "+11"],
        "untils": [-1441188192000, -1247565600000, 354891600000, 370699200000, 386427600000, 402235200000, 417963600000, 433771200000, 449586000000, 465318000000, 481042800000, 496767600000, 512492400000, 528217200000, 543942000000, 559666800000, 575391600000, 591116400000, 606841200000, 622566000000, 638290800000, 654620400000, 670345200000, 686073600000, 695750400000, 701794800000, 717519600000, 733244400000, 748969200000, 764694000000, 780418800000, 796143600000, 811868400000, 828198000000, 846342000000, 859647600000, 877791600000, 891097200000, 909241200000, 922546800000, 941295600000, 953996400000, 972745200000, 985446000000, 1004194800000, 1017500400000, 1035644400000, 1048950000000, 1067094000000, 1080399600000, 1099148400000, 1111849200000, 1130598000000, 1143298800000, 1162047600000, 1174748400000, 1193497200000, 1206802800000, 1224946800000, 1238252400000, 1256396400000, 1269702000000, 1288450800000, 1301151600000, 1414245600000, 1461427200000, null],
        "offsets": [-603.2, -600, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -660, -600, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -600, -660],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Makassar": {
        "abbrs": ["LMT", "MMT", "+08", "+09", "WITA"],
        "untils": [-1577951856000, -1172908656000, -880272000000, -766054800000, null],
        "offsets": [-477.6, -477.6, -480, -540, -480],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Manila": {
        "abbrs": ["PST", "PDT", "PST", "JST", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1046678400000, -1038733200000, -873273600000, -794221200000, -496224000000, -489315600000, 259344000000, 275151600000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 1, 0, 0, 0, 1, 0, 1, 0]
      },
      "Muscat": {
        "abbrs": ["LMT", "+04"],
        "untils": [-1577936472000, null],
        "offsets": [-221.2, -240],
        "isdsts": [0, 0]
      },
      "Nicosia": {
        "abbrs": ["LMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1518920008000, 166572000000, 182293200000, 200959200000, 213829200000, 228866400000, 243982800000, 260316000000, 276123600000, 291765600000, 307486800000, 323820000000, 338936400000, 354664800000, 370386000000, 386114400000, 401835600000, 417564000000, 433285200000, 449013600000, 465339600000, 481068000000, 496789200000, 512517600000, 528238800000, 543967200000, 559688400000, 575416800000, 591138000000, 606866400000, 622587600000, 638316000000, 654642000000, 670370400000, 686091600000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 843944400000, 859672800000, 875394000000, 891122400000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-133.4667, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Novokuznetsk": {
        "abbrs": ["LMT", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+07", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+07", "+06", "+07"],
        "untils": [-1441259328000, -1247551200000, 354906000000, 370713600000, 386442000000, 402249600000, 417978000000, 433785600000, 449600400000, 465332400000, 481057200000, 496782000000, 512506800000, 528231600000, 543956400000, 559681200000, 575406000000, 591130800000, 606855600000, 622580400000, 638305200000, 654634800000, 670359600000, 686088000000, 695764800000, 701809200000, 717534000000, 733258800000, 748983600000, 764708400000, 780433200000, 796158000000, 811882800000, 828212400000, 846356400000, 859662000000, 877806000000, 891111600000, 909255600000, 922561200000, 941310000000, 954010800000, 972759600000, 985460400000, 1004209200000, 1017514800000, 1035658800000, 1048964400000, 1067108400000, 1080414000000, 1099162800000, 1111863600000, 1130612400000, 1143313200000, 1162062000000, 1174762800000, 1193511600000, 1206817200000, 1224961200000, 1238266800000, 1256410800000, 1269716400000, 1288468800000, 1301169600000, null],
        "offsets": [-348.8, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -420, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -420, -360, -420],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Novosibirsk": {
        "abbrs": ["LMT", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+07", "+06", "+07", "+08", "+07", "+08", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07"],
        "untils": [-1579476700000, -1247551200000, 354906000000, 370713600000, 386442000000, 402249600000, 417978000000, 433785600000, 449600400000, 465332400000, 481057200000, 496782000000, 512506800000, 528231600000, 543956400000, 559681200000, 575406000000, 591130800000, 606855600000, 622580400000, 638305200000, 654634800000, 670359600000, 686088000000, 695764800000, 701809200000, 717534000000, 733258800000, 738086400000, 748987200000, 764712000000, 780436800000, 796161600000, 811886400000, 828216000000, 846360000000, 859665600000, 877809600000, 891115200000, 909259200000, 922564800000, 941313600000, 954014400000, 972763200000, 985464000000, 1004212800000, 1017518400000, 1035662400000, 1048968000000, 1067112000000, 1080417600000, 1099166400000, 1111867200000, 1130616000000, 1143316800000, 1162065600000, 1174766400000, 1193515200000, 1206820800000, 1224964800000, 1238270400000, 1256414400000, 1269720000000, 1288468800000, 1301169600000, 1414263600000, 1469304000000, null],
        "offsets": [-331.6667, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -420, -360, -420, -480, -420, -480, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Omsk": {
        "abbrs": ["LMT", "+05", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+06", "+05", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06"],
        "untils": [-1582088010000, -1247547600000, 354909600000, 370717200000, 386445600000, 402253200000, 417981600000, 433789200000, 449604000000, 465336000000, 481060800000, 496785600000, 512510400000, 528235200000, 543960000000, 559684800000, 575409600000, 591134400000, 606859200000, 622584000000, 638308800000, 654638400000, 670363200000, 686091600000, 695768400000, 701812800000, 717537600000, 733262400000, 748987200000, 764712000000, 780436800000, 796161600000, 811886400000, 828216000000, 846360000000, 859665600000, 877809600000, 891115200000, 909259200000, 922564800000, 941313600000, 954014400000, 972763200000, 985464000000, 1004212800000, 1017518400000, 1035662400000, 1048968000000, 1067112000000, 1080417600000, 1099166400000, 1111867200000, 1130616000000, 1143316800000, 1162065600000, 1174766400000, 1193515200000, 1206820800000, 1224964800000, 1238270400000, 1256414400000, 1269720000000, 1288468800000, 1301169600000, 1414263600000, null],
        "offsets": [-293.5, -300, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -360, -300, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Oral": {
        "abbrs": ["LMT", "+03", "+05", "+06", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+05"],
        "untils": [-1441164324000, -1247540400000, 354913200000, 370720800000, 386445600000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622591200000, 638316000000, 654645600000, 670370400000, 686095200000, 695772000000, 701816400000, 717544800000, 733269600000, 748994400000, 764719200000, 780444000000, 796168800000, 811893600000, 828223200000, 846367200000, 859672800000, 877816800000, 891122400000, 909266400000, 922572000000, 941320800000, 954021600000, 972770400000, 985471200000, 1004220000000, 1017525600000, 1035669600000, 1048975200000, 1067119200000, 1080424800000, 1099173600000, null],
        "offsets": [-205.4, -180, -300, -360, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300, -240, -300, -240, -300, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Phnom_Penh": {
        "abbrs": ["BMT", "+07"],
        "untils": [-1570084924000, null],
        "offsets": [-402.0667, -420],
        "isdsts": [0, 0]
      },
      "Pontianak": {
        "abbrs": ["LMT", "PMT", "+0730", "+09", "+0730", "+08", "+0730", "WITA", "WIB"],
        "untils": [-1946186240000, -1172906240000, -881220600000, -766054800000, -683883000000, -620812800000, -189415800000, 567964800000, null],
        "offsets": [-437.3333, -437.3333, -450, -540, -450, -480, -450, -480, -420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      "Pyongyang": {
        "abbrs": ["LMT", "KST", "JST", "KST", "KST", "KST"],
        "untils": [-1948782180000, -1830414600000, -768646800000, 1439564400000, 1525446000000, null],
        "offsets": [-503, -510, -540, -540, -510, -540],
        "isdsts": [0, 0, 0, 0, 0, 0]
      },
      "Qatar": {
        "abbrs": ["LMT", "+04", "+03"],
        "untils": [-1577935568000, 76190400000, null],
        "offsets": [-206.1333, -240, -180],
        "isdsts": [0, 0, 0]
      },
      "Qyzylorda": {
        "abbrs": ["LMT", "+04", "+05", "+06", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+05", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+06"],
        "untils": [-1441167712000, -1247544000000, 354913200000, 370720800000, 386445600000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686095200000, 695768400000, 701812800000, 717541200000, 733266000000, 748990800000, 764715600000, 780440400000, 796165200000, 811890000000, 828219600000, 846363600000, 859669200000, 877813200000, 891118800000, 909262800000, 922568400000, 941317200000, 954018000000, 972766800000, 985467600000, 1004216400000, 1017522000000, 1035666000000, 1048971600000, 1067115600000, 1080421200000, 1099170000000, null],
        "offsets": [-261.8667, -240, -300, -360, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -300, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -360],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Rangoon": {
        "abbrs": ["RMT", "+0630", "+09", "+0630"],
        "untils": [-1577946287000, -873268200000, -778410000000, null],
        "offsets": [-384.7833, -390, -540, -390],
        "isdsts": [0, 0, 0, 0]
      },
      "Riyadh": {
        "abbrs": ["LMT", "+03"],
        "untils": [-719636812000, null],
        "offsets": [-186.8667, -180],
        "isdsts": [0, 0]
      },
      "Saigon": {
        "abbrs": ["LMT", "PLMT", "+07", "+08", "+09", "+07", "+08", "+07", "+08", "+07"],
        "untils": [-2004073600000, -1851577590000, -852105600000, -782643600000, -767869200000, -718095600000, -457776000000, -315648000000, 171820800000, null],
        "offsets": [-426.6667, -426.5, -420, -480, -540, -420, -480, -420, -480, -420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      "Sakhalin": {
        "abbrs": ["LMT", "+09", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+11", "+10", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11"],
        "untils": [-2031039048000, -768560400000, 354891600000, 370699200000, 386427600000, 402235200000, 417963600000, 433771200000, 449586000000, 465318000000, 481042800000, 496767600000, 512492400000, 528217200000, 543942000000, 559666800000, 575391600000, 591116400000, 606841200000, 622566000000, 638290800000, 654620400000, 670345200000, 686073600000, 695750400000, 701794800000, 717519600000, 733244400000, 748969200000, 764694000000, 780418800000, 796143600000, 811868400000, 828198000000, 846342000000, 859647600000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 972748800000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143302400000, 1162051200000, 1174752000000, 1193500800000, 1206806400000, 1224950400000, 1238256000000, 1256400000000, 1269705600000, 1288454400000, 1301155200000, 1414249200000, 1459008000000, null],
        "offsets": [-570.8, -540, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -660, -600, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Samarkand": {
        "abbrs": ["LMT", "+04", "+05", "+06", "+06", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05"],
        "untils": [-1441168073000, -1247544000000, 354913200000, 370720800000, 386445600000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686091600000, null],
        "offsets": [-267.8833, -240, -300, -360, -360, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Seoul": {
        "abbrs": ["LMT", "KST", "JST", "KST", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KST", "KDT", "KST", "KDT", "KST"],
        "untils": [-1948782472000, -1830414600000, -767350800000, -498128400000, -462702600000, -451733400000, -429784200000, -418296600000, -399544200000, -387451800000, -368094600000, -356002200000, -336645000000, -324552600000, -305195400000, -293103000000, -264933000000, 547578000000, 560883600000, 579027600000, 592333200000, null],
        "offsets": [-507.8667, -510, -540, -540, -510, -570, -510, -570, -510, -570, -510, -570, -510, -570, -510, -570, -510, -540, -600, -540, -600, -540],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0]
      },
      "Shanghai": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-933667200000, -922093200000, -908870400000, -888829200000, -881049600000, -767869200000, -745833600000, -733827600000, -716889600000, -699613200000, -683884800000, -670669200000, -652348800000, -650019600000, 515527200000, 527014800000, 545162400000, 558464400000, 577216800000, 589914000000, 608666400000, 621968400000, 640116000000, 653418000000, 671565600000, 684867600000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Singapore": {
        "abbrs": ["SMT", "+07", "+0720", "+0720", "+0730", "+09", "+0730", "+08"],
        "untils": [-2038200925000, -1167634800000, -1073028000000, -894180000000, -879665400000, -767005200000, 378664200000, null],
        "offsets": [-415.4167, -420, -440, -440, -450, -540, -450, -480],
        "isdsts": [0, 0, 1, 0, 0, 0, 0, 0]
      },
      "Srednekolymsk": {
        "abbrs": ["LMT", "+10", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+11", "+10", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11"],
        "untils": [-1441188892000, -1247565600000, 354891600000, 370699200000, 386427600000, 402235200000, 417963600000, 433771200000, 449586000000, 465318000000, 481042800000, 496767600000, 512492400000, 528217200000, 543942000000, 559666800000, 575391600000, 591116400000, 606841200000, 622566000000, 638290800000, 654620400000, 670345200000, 686073600000, 695750400000, 701794800000, 717519600000, 733244400000, 748969200000, 764694000000, 780418800000, 796143600000, 811868400000, 828198000000, 846342000000, 859647600000, 877791600000, 891097200000, 909241200000, 922546800000, 941295600000, 953996400000, 972745200000, 985446000000, 1004194800000, 1017500400000, 1035644400000, 1048950000000, 1067094000000, 1080399600000, 1099148400000, 1111849200000, 1130598000000, 1143298800000, 1162047600000, 1174748400000, 1193497200000, 1206802800000, 1224946800000, 1238252400000, 1256396400000, 1269702000000, 1288450800000, 1301151600000, 1414245600000, null],
        "offsets": [-614.8667, -600, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -660, -600, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Taipei": {
        "abbrs": ["CST", "JST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1017820800000, -766224000000, -745833600000, -733827600000, -716889600000, -699613200000, -683884800000, -670669200000, -652348800000, -639133200000, -620812800000, -607597200000, -589276800000, -576061200000, -562924800000, -541760400000, -528710400000, -510224400000, -497174400000, -478688400000, -465638400000, -449830800000, -434016000000, -418208400000, -402480000000, -386672400000, -370944000000, -355136400000, -339408000000, -323600400000, -302515200000, -291978000000, -270979200000, -260442000000, 133977600000, 149785200000, 165513600000, 181321200000, 299606400000, 307551600000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tashkent": {
        "abbrs": ["LMT", "+05", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+06", "+05"],
        "untils": [-1441168631000, -1247547600000, 354909600000, 370717200000, 386445600000, 402253200000, 417981600000, 433789200000, 449604000000, 465336000000, 481060800000, 496785600000, 512510400000, 528235200000, 543960000000, 559684800000, 575409600000, 591134400000, 606859200000, 622584000000, 638308800000, 654638400000, 670363200000, 686091600000, null],
        "offsets": [-277.1833, -300, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -360, -300],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tbilisi": {
        "abbrs": ["TBMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+03", "+04"],
        "untils": [-1441162751000, -405140400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622591200000, 638316000000, 654645600000, 670370400000, 686098800000, 701816400000, 717537600000, 733266000000, 748987200000, 764715600000, 780436800000, 796161600000, 811882800000, 828216000000, 877806000000, 891115200000, 909255600000, 922564800000, 941310000000, 954014400000, 972759600000, 985464000000, 1004209200000, 1017518400000, 1035658800000, 1048968000000, 1067108400000, 1080417600000, 1088276400000, 1099177200000, 1111878000000, null],
        "offsets": [-179.1833, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -240, -180, -240, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -180, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0]
      },
      "Tehran": {
        "abbrs": ["LMT", "TMT", "+0330", "+04", "+05", "+04", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330"],
        "untils": [-1704165944000, -757394744000, 247177800000, 259272000000, 277758000000, 283982400000, 290809800000, 306531000000, 322432200000, 338499000000, 673216200000, 685481400000, 701209800000, 717103800000, 732745800000, 748639800000, 764281800000, 780175800000, 795817800000, 811711800000, 827353800000, 843247800000, 858976200000, 874870200000, 890512200000, 906406200000, 922048200000, 937942200000, 953584200000, 969478200000, 985206600000, 1001100600000, 1016742600000, 1032636600000, 1048278600000, 1064172600000, 1079814600000, 1095708600000, 1111437000000, 1127331000000, 1206045000000, 1221939000000, 1237667400000, 1253561400000, 1269203400000, 1285097400000, 1300739400000, 1316633400000, 1332275400000, 1348169400000, 1363897800000, 1379791800000, 1395433800000, 1411327800000, 1426969800000, 1442863800000, 1458505800000, 1474399800000, 1490128200000, 1506022200000, 1521664200000, 1537558200000, 1553200200000, 1569094200000, 1584736200000, 1600630200000, 1616358600000, 1632252600000, 1647894600000, 1663788600000, 1679430600000, 1695324600000, 1710966600000, 1726860600000, 1742589000000, 1758483000000, 1774125000000, 1790019000000, 1805661000000, 1821555000000, 1837197000000, 1853091000000, 1868733000000, 1884627000000, 1900355400000, 1916249400000, 1931891400000, 1947785400000, 1963427400000, 1979321400000, 1994963400000, 2010857400000, 2026585800000, 2042479800000, 2058121800000, 2074015800000, 2089657800000, 2105551800000, 2121193800000, 2137087800000, null],
        "offsets": [-205.7333, -205.7333, -210, -240, -300, -240, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210],
        "isdsts": [0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tel_Aviv": {
        "abbrs": ["JMT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDDT", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST"],
        "untils": [-1641003640000, -933645600000, -857358000000, -844300800000, -825822000000, -812685600000, -794199600000, -779853600000, -762656400000, -748310400000, -731127600000, -681962400000, -673243200000, -667962000000, -652327200000, -636426000000, -622087200000, -608947200000, -591847200000, -572486400000, -558576000000, -542851200000, -527731200000, -514425600000, -490845600000, -482986800000, -459475200000, -451537200000, -428551200000, -418262400000, -400032000000, -387428400000, 142380000000, 150843600000, 167176800000, 178664400000, 482277600000, 495579600000, 516751200000, 526424400000, 545436000000, 558478800000, 576626400000, 589323600000, 609890400000, 620773200000, 638316000000, 651618000000, 669765600000, 683672400000, 701820000000, 715726800000, 733701600000, 747176400000, 765151200000, 778021200000, 796600800000, 810075600000, 826840800000, 842821200000, 858895200000, 874184400000, 890344800000, 905029200000, 923011200000, 936313200000, 955670400000, 970783200000, 986770800000, 1001282400000, 1017356400000, 1033941600000, 1048806000000, 1065132000000, 1081292400000, 1095804000000, 1112313600000, 1128812400000, 1143763200000, 1159657200000, 1175212800000, 1189897200000, 1206662400000, 1223161200000, 1238112000000, 1254006000000, 1269561600000, 1284246000000, 1301616000000, 1317510000000, 1333065600000, 1348354800000, 1364515200000, 1382828400000, 1395964800000, 1414278000000, 1427414400000, 1445727600000, 1458864000000, 1477782000000, 1490313600000, 1509231600000, 1521763200000, 1540681200000, 1553817600000, 1572130800000, 1585267200000, 1603580400000, 1616716800000, 1635634800000, 1648166400000, 1667084400000, 1679616000000, 1698534000000, 1711670400000, 1729983600000, 1743120000000, 1761433200000, 1774569600000, 1792882800000, 1806019200000, 1824937200000, 1837468800000, 1856386800000, 1868918400000, 1887836400000, 1900972800000, 1919286000000, 1932422400000, 1950735600000, 1963872000000, 1982790000000, 1995321600000, 2014239600000, 2026771200000, 2045689200000, 2058220800000, 2077138800000, 2090275200000, 2108588400000, 2121724800000, 2140038000000, null],
        "offsets": [-140.6667, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -240, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Thimbu": {
        "abbrs": ["LMT", "+0530", "+06"],
        "untils": [-706341516000, 560025000000, null],
        "offsets": [-358.6, -330, -360],
        "isdsts": [0, 0, 0]
      },
      "Thimphu": {
        "abbrs": ["LMT", "+0530", "+06"],
        "untils": [-706341516000, 560025000000, null],
        "offsets": [-358.6, -330, -360],
        "isdsts": [0, 0, 0]
      },
      "Tokyo": {
        "abbrs": ["JST", "JDT", "JST", "JDT", "JST", "JDT", "JST", "JDT", "JST"],
        "untils": [-683802000000, -672310800000, -654771600000, -640861200000, -620298000000, -609411600000, -588848400000, -577962000000, null],
        "offsets": [-540, -600, -540, -600, -540, -600, -540, -600, -540],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tomsk": {
        "abbrs": ["LMT", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+07", "+06", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+08", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07", "+06", "+07"],
        "untils": [-1578807591000, -1247551200000, 354906000000, 370713600000, 386442000000, 402249600000, 417978000000, 433785600000, 449600400000, 465332400000, 481057200000, 496782000000, 512506800000, 528231600000, 543956400000, 559681200000, 575406000000, 591130800000, 606855600000, 622580400000, 638305200000, 654634800000, 670359600000, 686088000000, 695764800000, 701809200000, 717534000000, 733258800000, 748983600000, 764708400000, 780433200000, 796158000000, 811882800000, 828212400000, 846356400000, 859662000000, 877806000000, 891111600000, 909255600000, 922561200000, 941310000000, 954010800000, 972759600000, 985460400000, 1004209200000, 1017514800000, 1020193200000, 1035662400000, 1048968000000, 1067112000000, 1080417600000, 1099166400000, 1111867200000, 1130616000000, 1143316800000, 1162065600000, 1174766400000, 1193515200000, 1206820800000, 1224964800000, 1238270400000, 1256414400000, 1269720000000, 1288468800000, 1301169600000, 1414263600000, 1464465600000, null],
        "offsets": [-339.85, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -420, -360, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -480, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420, -360, -420],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Ujung_Pandang": {
        "abbrs": ["LMT", "MMT", "+08", "+09", "WITA"],
        "untils": [-1577951856000, -1172908656000, -880272000000, -766054800000, null],
        "offsets": [-477.6, -477.6, -480, -540, -480],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Ulaanbaatar": {
        "abbrs": ["LMT", "+07", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08"],
        "untils": [-2032931252000, 252435600000, 417974400000, 433782000000, 449596800000, 465318000000, 481046400000, 496767600000, 512496000000, 528217200000, 543945600000, 559666800000, 575395200000, 591116400000, 606844800000, 622566000000, 638294400000, 654620400000, 670348800000, 686070000000, 701798400000, 717519600000, 733248000000, 748969200000, 764697600000, 780418800000, 796147200000, 811868400000, 828201600000, 843922800000, 859651200000, 875372400000, 891100800000, 906822000000, 988394400000, 1001696400000, 1017424800000, 1033146000000, 1048874400000, 1064595600000, 1080324000000, 1096045200000, 1111773600000, 1127494800000, 1143223200000, 1159549200000, 1427479200000, 1443193200000, 1458928800000, 1474642800000, null],
        "offsets": [-427.5333, -420, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Ulan_Bator": {
        "abbrs": ["LMT", "+07", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08", "+09", "+08"],
        "untils": [-2032931252000, 252435600000, 417974400000, 433782000000, 449596800000, 465318000000, 481046400000, 496767600000, 512496000000, 528217200000, 543945600000, 559666800000, 575395200000, 591116400000, 606844800000, 622566000000, 638294400000, 654620400000, 670348800000, 686070000000, 701798400000, 717519600000, 733248000000, 748969200000, 764697600000, 780418800000, 796147200000, 811868400000, 828201600000, 843922800000, 859651200000, 875372400000, 891100800000, 906822000000, 988394400000, 1001696400000, 1017424800000, 1033146000000, 1048874400000, 1064595600000, 1080324000000, 1096045200000, 1111773600000, 1127494800000, 1143223200000, 1159549200000, 1427479200000, 1443193200000, 1458928800000, 1474642800000, null],
        "offsets": [-427.5333, -420, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Urumqi": {
        "abbrs": ["LMT", "+06"],
        "untils": [-1325483420000, null],
        "offsets": [-350.3333, -360],
        "isdsts": [0, 0]
      },
      "Ust-Nera": {
        "abbrs": ["LMT", "+08", "+09", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+11", "+10", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+10"],
        "untils": [-1579426374000, -1247558400000, 354898800000, 370699200000, 386427600000, 402235200000, 417963600000, 433771200000, 449586000000, 465318000000, 481042800000, 496767600000, 512492400000, 528217200000, 543942000000, 559666800000, 575391600000, 591116400000, 606841200000, 622566000000, 638290800000, 654620400000, 670345200000, 686073600000, 695750400000, 701794800000, 717519600000, 733244400000, 748969200000, 764694000000, 780418800000, 796143600000, 811868400000, 828198000000, 846342000000, 859647600000, 877791600000, 891097200000, 909241200000, 922546800000, 941295600000, 953996400000, 972745200000, 985446000000, 1004194800000, 1017500400000, 1035644400000, 1048950000000, 1067094000000, 1080399600000, 1099148400000, 1111849200000, 1130598000000, 1143298800000, 1162047600000, 1174748400000, 1193497200000, 1206802800000, 1224946800000, 1238252400000, 1256396400000, 1269702000000, 1288450800000, 1301151600000, 1315828800000, 1414249200000, null],
        "offsets": [-572.9, -480, -540, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -660, -600, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -600],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Vientiane": {
        "abbrs": ["BMT", "+07"],
        "untils": [-1570084924000, null],
        "offsets": [-402.0667, -420],
        "isdsts": [0, 0]
      },
      "Vladivostok": {
        "abbrs": ["LMT", "+09", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+10", "+09", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10", "+11", "+10"],
        "untils": [-1487321251000, -1247562000000, 354895200000, 370702800000, 386431200000, 402238800000, 417967200000, 433774800000, 449589600000, 465321600000, 481046400000, 496771200000, 512496000000, 528220800000, 543945600000, 559670400000, 575395200000, 591120000000, 606844800000, 622569600000, 638294400000, 654624000000, 670348800000, 686077200000, 695754000000, 701798400000, 717523200000, 733248000000, 748972800000, 764697600000, 780422400000, 796147200000, 811872000000, 828201600000, 846345600000, 859651200000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 972748800000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143302400000, 1162051200000, 1174752000000, 1193500800000, 1206806400000, 1224950400000, 1238256000000, 1256400000000, 1269705600000, 1288454400000, 1301155200000, 1414249200000, null],
        "offsets": [-527.5167, -540, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -600, -540, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Yakutsk": {
        "abbrs": ["LMT", "+08", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+09", "+08", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09", "+10", "+09"],
        "untils": [-1579423138000, -1247558400000, 354898800000, 370706400000, 386434800000, 402242400000, 417970800000, 433778400000, 449593200000, 465325200000, 481050000000, 496774800000, 512499600000, 528224400000, 543949200000, 559674000000, 575398800000, 591123600000, 606848400000, 622573200000, 638298000000, 654627600000, 670352400000, 686080800000, 695757600000, 701802000000, 717526800000, 733251600000, 748976400000, 764701200000, 780426000000, 796150800000, 811875600000, 828205200000, 846349200000, 859654800000, 877798800000, 891104400000, 909248400000, 922554000000, 941302800000, 954003600000, 972752400000, 985453200000, 1004202000000, 1017507600000, 1035651600000, 1048957200000, 1067101200000, 1080406800000, 1099155600000, 1111856400000, 1130605200000, 1143306000000, 1162054800000, 1174755600000, 1193504400000, 1206810000000, 1224954000000, 1238259600000, 1256403600000, 1269709200000, 1288458000000, 1301158800000, 1414252800000, null],
        "offsets": [-518.9667, -480, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -540, -480, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540, -600, -540],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Yangon": {
        "abbrs": ["RMT", "+0630", "+09", "+0630"],
        "untils": [-1577946287000, -873268200000, -778410000000, null],
        "offsets": [-384.7833, -390, -540, -390],
        "isdsts": [0, 0, 0, 0]
      },
      "Yekaterinburg": {
        "abbrs": ["LMT", "PMT", "+04", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+05", "+04", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05", "+06", "+05"],
        "untils": [-1688270553000, -1592610305000, -1247544000000, 354913200000, 370720800000, 386449200000, 402256800000, 417985200000, 433792800000, 449607600000, 465339600000, 481064400000, 496789200000, 512514000000, 528238800000, 543963600000, 559688400000, 575413200000, 591138000000, 606862800000, 622587600000, 638312400000, 654642000000, 670366800000, 686095200000, 695772000000, 701816400000, 717541200000, 733266000000, 748990800000, 764715600000, 780440400000, 796165200000, 811890000000, 828219600000, 846363600000, 859669200000, 877813200000, 891118800000, 909262800000, 922568400000, 941317200000, 954018000000, 972766800000, 985467600000, 1004216400000, 1017522000000, 1035666000000, 1048971600000, 1067115600000, 1080421200000, 1099170000000, 1111870800000, 1130619600000, 1143320400000, 1162069200000, 1174770000000, 1193518800000, 1206824400000, 1224968400000, 1238274000000, 1256418000000, 1269723600000, 1288472400000, 1301173200000, 1414267200000, null],
        "offsets": [-242.55, -225.0833, -240, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -300, -240, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300, -360, -300],
        "isdsts": [0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Yerevan": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04"],
        "untils": [-1441162680000, -405140400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622591200000, 638316000000, 654645600000, 670370400000, 686098800000, 701823600000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 859672800000, 877816800000, 891122400000, 909266400000, 922572000000, 941320800000, 954021600000, 972770400000, 985471200000, 1004220000000, 1017525600000, 1035669600000, 1048975200000, 1067119200000, 1080424800000, 1099173600000, 1111874400000, 1130623200000, 1143324000000, 1162072800000, 1174773600000, 1193522400000, 1206828000000, 1224972000000, 1238277600000, 1256421600000, 1269727200000, 1288476000000, 1301176800000, 1319925600000, null],
        "offsets": [-178, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -240, -180, -240, -180, -240, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "Atlantic": {
      "Azores": {
        "abbrs": ["HMT", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "+00", "-01", "-02", "-01", "+00", "-01", "-02", "-01", "+00", "-01", "-02", "-01", "+00", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "WET", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01"],
        "untils": [-1830376800000, -1689548400000, -1677794400000, -1667430000000, -1647730800000, -1635807600000, -1616194800000, -1604358000000, -1584658800000, -1572735600000, -1553036400000, -1541199600000, -1521500400000, -1442444400000, -1426806000000, -1379286000000, -1364770800000, -1348441200000, -1333321200000, -1316386800000, -1301266800000, -1284332400000, -1269817200000, -1221433200000, -1206918000000, -1191193200000, -1175468400000, -1127689200000, -1111964400000, -1096844400000, -1080514800000, -1063580400000, -1049065200000, -1033340400000, -1017615600000, -1002495600000, -986166000000, -969231600000, -950482800000, -942015600000, -922662000000, -906937200000, -891126000000, -877302000000, -873676800000, -864000000000, -857948400000, -845852400000, -842832000000, -831340800000, -825894000000, -814402800000, -810777600000, -799891200000, -794444400000, -782953200000, -779328000000, -768441600000, -762994800000, -749084400000, -733359600000, -717624000000, -701899200000, -686174400000, -670449600000, -654724800000, -639000000000, -591825600000, -575496000000, -559771200000, -544046400000, -528321600000, -512596800000, -496872000000, -481147200000, -465422400000, -449697600000, -433972800000, -417643200000, -401918400000, -386193600000, -370468800000, -354744000000, -339019200000, -323294400000, -307569600000, -291844800000, -276120000000, -260395200000, -244670400000, -228340800000, -212616000000, -196891200000, -181166400000, -165441600000, -149716800000, -133992000000, -118267200000, 228272400000, 243997200000, 260326800000, 276051600000, 291776400000, 307504800000, 323226000000, 338954400000, 354679200000, 370404000000, 386128800000, 401853600000, 417582000000, 433303200000, 449028000000, 465357600000, 481082400000, 496807200000, 512532000000, 528256800000, 543981600000, 559706400000, 575431200000, 591156000000, 606880800000, 622605600000, 638330400000, 654660000000, 670384800000, 686109600000, 701834400000, 717559200000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [114.5333, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 0, 60, 120, 60, 0, 60, 120, 60, 0, 60, 120, 60, 0, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 0, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bermuda": {
        "abbrs": ["LMT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-1262281242000, 136360800000, 152082000000, 167810400000, 183531600000, 199260000000, 215586000000, 230709600000, 247035600000, 262764000000, 278485200000, 294213600000, 309934800000, 325663200000, 341384400000, 357112800000, 372834000000, 388562400000, 404888400000, 420012000000, 436338000000, 452066400000, 467787600000, 483516000000, 499237200000, 514965600000, 530686800000, 544600800000, 562136400000, 576050400000, 594190800000, 607500000000, 625640400000, 638949600000, 657090000000, 671004000000, 688539600000, 702453600000, 719989200000, 733903200000, 752043600000, 765352800000, 783493200000, 796802400000, 814942800000, 828856800000, 846392400000, 860306400000, 877842000000, 891756000000, 909291600000, 923205600000, 941346000000, 954655200000, 972795600000, 986104800000, 1004245200000, 1018159200000, 1035694800000, 1049608800000, 1067144400000, 1081058400000, 1099198800000, 1112508000000, 1130648400000, 1143957600000, 1162098000000, 1173592800000, 1194152400000, 1205042400000, 1225602000000, 1236492000000, 1257051600000, 1268546400000, 1289106000000, 1299996000000, 1320555600000, 1331445600000, 1352005200000, 1362895200000, 1383454800000, 1394344800000, 1414904400000, 1425794400000, 1446354000000, 1457848800000, 1478408400000, 1489298400000, 1509858000000, 1520748000000, 1541307600000, 1552197600000, 1572757200000, 1583647200000, 1604206800000, 1615701600000, 1636261200000, 1647151200000, 1667710800000, 1678600800000, 1699160400000, 1710050400000, 1730610000000, 1741500000000, 1762059600000, 1772949600000, 1793509200000, 1805004000000, 1825563600000, 1836453600000, 1857013200000, 1867903200000, 1888462800000, 1899352800000, 1919912400000, 1930802400000, 1951362000000, 1962856800000, 1983416400000, 1994306400000, 2014866000000, 2025756000000, 2046315600000, 2057205600000, 2077765200000, 2088655200000, 2109214800000, 2120104800000, 2140664400000, null],
        "offsets": [259.3, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Canary": {
        "abbrs": ["LMT", "-01", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
        "untils": [-1509663504000, -733874400000, 323827200000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [61.6, 60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Cape_Verde": {
        "abbrs": ["LMT", "-02", "-01", "-02", "-01"],
        "untils": [-1830376800000, -862610400000, -764118000000, 186120000000, null],
        "offsets": [94.0667, 120, 60, 120, 60],
        "isdsts": [0, 0, 1, 0, 0]
      },
      "Faeroe": {
        "abbrs": ["LMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
        "untils": [-1955748776000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [27.0667, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Faroe": {
        "abbrs": ["LMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
        "untils": [-1955748776000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [27.0667, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Jan_Mayen": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1691884800000, -1680573600000, -927511200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -765327600000, -340844400000, -324514800000, -308790000000, -293065200000, -277340400000, -261615600000, -245890800000, -230166000000, -214441200000, -198716400000, -182991600000, -166662000000, -147913200000, -135212400000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Madeira": {
        "abbrs": ["FMT", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "+01", "+00", "-01", "+00", "+01", "+00", "-01", "+00", "+01", "+00", "-01", "+00", "+01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
        "untils": [-1830380400000, -1689552000000, -1677798000000, -1667433600000, -1647734400000, -1635811200000, -1616198400000, -1604361600000, -1584662400000, -1572739200000, -1553040000000, -1541203200000, -1521504000000, -1442448000000, -1426809600000, -1379289600000, -1364774400000, -1348444800000, -1333324800000, -1316390400000, -1301270400000, -1284336000000, -1269820800000, -1221436800000, -1206921600000, -1191196800000, -1175472000000, -1127692800000, -1111968000000, -1096848000000, -1080518400000, -1063584000000, -1049068800000, -1033344000000, -1017619200000, -1002499200000, -986169600000, -969235200000, -950486400000, -942019200000, -922665600000, -906940800000, -891129600000, -877305600000, -873680400000, -864003600000, -857952000000, -845856000000, -842835600000, -831344400000, -825897600000, -814406400000, -810781200000, -799894800000, -794448000000, -782956800000, -779331600000, -768445200000, -762998400000, -749088000000, -733363200000, -717627600000, -701902800000, -686178000000, -670453200000, -654728400000, -639003600000, -591829200000, -575499600000, -559774800000, -544050000000, -528325200000, -512600400000, -496875600000, -481150800000, -465426000000, -449701200000, -433976400000, -417646800000, -401922000000, -386197200000, -370472400000, -354747600000, -339022800000, -323298000000, -307573200000, -291848400000, -276123600000, -260398800000, -244674000000, -228344400000, -212619600000, -196894800000, -181170000000, -165445200000, -149720400000, -133995600000, -118270800000, 228268800000, 243993600000, 260323200000, 276048000000, 291772800000, 307501200000, 323222400000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417578400000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [67.6, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, -60, 0, 60, 0, -60, 0, 60, 0, -60, 0, 60, 0, -60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Reykjavik": {
        "abbrs": ["LMT", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "GMT"],
        "untils": [-1956609120000, -1668211200000, -1647212400000, -1636675200000, -1613430000000, -1605139200000, -1581894000000, -1539561600000, -1531350000000, -968025600000, -952293600000, -942008400000, -920239200000, -909957600000, -888789600000, -877903200000, -857944800000, -846453600000, -826495200000, -815004000000, -795045600000, -783554400000, -762991200000, -752104800000, -731541600000, -717631200000, -700092000000, -686181600000, -668642400000, -654732000000, -636588000000, -623282400000, -605743200000, -591832800000, -573688800000, -559778400000, -542239200000, -528328800000, -510789600000, -496879200000, -479340000000, -465429600000, -447890400000, -433980000000, -415836000000, -401925600000, -384386400000, -370476000000, -352936800000, -339026400000, -321487200000, -307576800000, -290037600000, -276127200000, -258588000000, -244677600000, -226533600000, -212623200000, -195084000000, -181173600000, -163634400000, -149724000000, -132184800000, -118274400000, -100735200000, -86824800000, -68680800000, -54770400000, null],
        "offsets": [88, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "South_Georgia": {
        "abbrs": ["-02"],
        "untils": [null],
        "offsets": [120],
        "isdsts": [0]
      },
      "St_Helena": {
        "abbrs": ["LMT", "GMT"],
        "untils": [-1830383032000, null],
        "offsets": [16.1333, 0],
        "isdsts": [0, 0]
      },
      "Stanley": {
        "abbrs": ["SMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-02", "-03", "-02", "-03", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03"],
        "untils": [-1824235716000, -1018209600000, -1003093200000, -986760000000, -971643600000, -954705600000, -939589200000, -923256000000, -908139600000, -891806400000, -876690000000, -860356800000, -852066000000, 420609600000, 433306800000, 452052000000, 464151600000, 483501600000, 495601200000, 514350000000, 527054400000, 545799600000, 558504000000, 577249200000, 589953600000, 608698800000, 621403200000, 640753200000, 652852800000, 672202800000, 684907200000, 703652400000, 716356800000, 735102000000, 747806400000, 766551600000, 779256000000, 798001200000, 810705600000, 830055600000, 842760000000, 861505200000, 874209600000, 892954800000, 905659200000, 924404400000, 937108800000, 955854000000, 968558400000, 987310800000, 999410400000, 1019365200000, 1030860000000, 1050814800000, 1062914400000, 1082264400000, 1094364000000, 1113714000000, 1125813600000, 1145163600000, 1157263200000, 1176613200000, 1188712800000, 1208667600000, 1220767200000, 1240117200000, 1252216800000, 1271566800000, 1283666400000, null],
        "offsets": [231.4, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 120, 180, 120, 180, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      }
    },
    "Australia": {
      "ACT": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386697600000, 404841600000, 415728000000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 511286400000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 636480000000, 657043200000, 667929600000, 688492800000, 699379200000, 719942400000, 731433600000, 751996800000, 762883200000, 783446400000, 794332800000, 814896000000, 828201600000, 846345600000, 859651200000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 967305600000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143907200000, 1162051200000, 1174752000000, 1193500800000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Adelaide": {
        "abbrs": ["ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT"],
        "untils": [-1672565340000, -1665390600000, -883639800000, -876126600000, -860398200000, -844677000000, -828343800000, -813227400000, 57688200000, 67969800000, 89137800000, 100024200000, 120587400000, 131473800000, 152037000000, 162923400000, 183486600000, 194977800000, 215541000000, 226427400000, 246990600000, 257877000000, 278440200000, 289326600000, 309889800000, 320776200000, 341339400000, 352225800000, 372789000000, 384280200000, 404843400000, 415729800000, 436293000000, 447179400000, 467742600000, 478629000000, 499192200000, 511288200000, 530037000000, 542737800000, 562091400000, 574792200000, 594145800000, 606241800000, 625595400000, 637691400000, 657045000000, 667931400000, 688494600000, 701195400000, 719944200000, 731435400000, 751998600000, 764094600000, 783448200000, 796149000000, 814897800000, 828203400000, 846347400000, 859653000000, 877797000000, 891102600000, 909246600000, 922552200000, 941301000000, 954001800000, 972750600000, 985451400000, 1004200200000, 1017505800000, 1035649800000, 1048955400000, 1067099400000, 1080405000000, 1099153800000, 1111854600000, 1130603400000, 1143909000000, 1162053000000, 1174753800000, 1193502600000, 1207413000000, 1223137800000, 1238862600000, 1254587400000, 1270312200000, 1286037000000, 1301761800000, 1317486600000, 1333211400000, 1349541000000, 1365265800000, 1380990600000, 1396715400000, 1412440200000, 1428165000000, 1443889800000, 1459614600000, 1475339400000, 1491064200000, 1506789000000, 1522513800000, 1538843400000, 1554568200000, 1570293000000, 1586017800000, 1601742600000, 1617467400000, 1633192200000, 1648917000000, 1664641800000, 1680366600000, 1696091400000, 1712421000000, 1728145800000, 1743870600000, 1759595400000, 1775320200000, 1791045000000, 1806769800000, 1822494600000, 1838219400000, 1853944200000, 1869669000000, 1885998600000, 1901723400000, 1917448200000, 1933173000000, 1948897800000, 1964622600000, 1980347400000, 1996072200000, 2011797000000, 2027521800000, 2043246600000, 2058971400000, 2075301000000, 2091025800000, 2106750600000, 2122475400000, 2138200200000, null],
        "offsets": [-570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Brisbane": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 625593600000, 636480000000, 657043200000, 667929600000, 688492800000, 699379200000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Broken_Hill": {
        "abbrs": ["ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT"],
        "untils": [-1672565340000, -1665390600000, -883639800000, -876126600000, -860398200000, -844677000000, -828343800000, -813227400000, 57688200000, 67969800000, 89137800000, 100024200000, 120587400000, 131473800000, 152037000000, 162923400000, 183486600000, 194977800000, 215541000000, 226427400000, 246990600000, 257877000000, 278440200000, 289326600000, 309889800000, 320776200000, 341339400000, 352225800000, 372789000000, 386699400000, 404843400000, 415729800000, 436293000000, 447179400000, 467742600000, 478629000000, 499192200000, 511288200000, 530037000000, 542737800000, 562091400000, 574792200000, 594145800000, 606241800000, 625595400000, 636481800000, 657045000000, 667931400000, 688494600000, 699381000000, 719944200000, 731435400000, 751998600000, 762885000000, 783448200000, 794334600000, 814897800000, 828203400000, 846347400000, 859653000000, 877797000000, 891102600000, 909246600000, 922552200000, 941301000000, 954001800000, 972750600000, 985451400000, 1004200200000, 1017505800000, 1035649800000, 1048955400000, 1067099400000, 1080405000000, 1099153800000, 1111854600000, 1130603400000, 1143909000000, 1162053000000, 1174753800000, 1193502600000, 1207413000000, 1223137800000, 1238862600000, 1254587400000, 1270312200000, 1286037000000, 1301761800000, 1317486600000, 1333211400000, 1349541000000, 1365265800000, 1380990600000, 1396715400000, 1412440200000, 1428165000000, 1443889800000, 1459614600000, 1475339400000, 1491064200000, 1506789000000, 1522513800000, 1538843400000, 1554568200000, 1570293000000, 1586017800000, 1601742600000, 1617467400000, 1633192200000, 1648917000000, 1664641800000, 1680366600000, 1696091400000, 1712421000000, 1728145800000, 1743870600000, 1759595400000, 1775320200000, 1791045000000, 1806769800000, 1822494600000, 1838219400000, 1853944200000, 1869669000000, 1885998600000, 1901723400000, 1917448200000, 1933173000000, 1948897800000, 1964622600000, 1980347400000, 1996072200000, 2011797000000, 2027521800000, 2043246600000, 2058971400000, 2075301000000, 2091025800000, 2106750600000, 2122475400000, 2138200200000, null],
        "offsets": [-570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Canberra": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386697600000, 404841600000, 415728000000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 511286400000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 636480000000, 657043200000, 667929600000, 688492800000, 699379200000, 719942400000, 731433600000, 751996800000, 762883200000, 783446400000, 794332800000, 814896000000, 828201600000, 846345600000, 859651200000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 967305600000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143907200000, 1162051200000, 1174752000000, 1193500800000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Currie": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1680508800000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386092800000, 404841600000, 417542400000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 510076800000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 637689600000, 657043200000, 670348800000, 686678400000, 701798400000, 718128000000, 733248000000, 749577600000, 764697600000, 781027200000, 796147200000, 812476800000, 828201600000, 844531200000, 859651200000, 875980800000, 891100800000, 907430400000, 922550400000, 938880000000, 954000000000, 967305600000, 985449600000, 1002384000000, 1017504000000, 1033833600000, 1048953600000, 1065283200000, 1080403200000, 1096732800000, 1111852800000, 1128182400000, 1143907200000, 1159632000000, 1174752000000, 1191686400000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Darwin": {
        "abbrs": ["ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST"],
        "untils": [-1672565340000, -1665390600000, -883639800000, -876126600000, -860398200000, -844677000000, -828343800000, -813227400000, null],
        "offsets": [-570, -630, -570, -630, -570, -630, -570, -630, -570],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Eucla": {
        "abbrs": ["+0845", "+0945", "+0845", "+0945", "+0845", "+0945", "+0845", "+0945", "+0845", "+0945", "+0845", "+0945", "+0845", "+0945", "+0845", "+0945", "+0845", "+0945", "+0845"],
        "untils": [-1672562640000, -1665387900000, -883637100000, -876123900000, -860395500000, -844674300000, 152039700000, 162926100000, 436295700000, 447182100000, 690311700000, 699383700000, 1165079700000, 1174756500000, 1193505300000, 1206810900000, 1224954900000, 1238260500000, null],
        "offsets": [-525, -585, -525, -585, -525, -585, -525, -585, -525, -585, -525, -585, -525, -585, -525, -585, -525, -585, -525],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Hobart": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1680508800000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, -71136000000, -55411200000, -37267200000, -25776000000, -5817600000, 5673600000, 25632000000, 37728000000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386092800000, 404841600000, 417542400000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 510076800000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 637689600000, 657043200000, 670348800000, 686678400000, 701798400000, 718128000000, 733248000000, 749577600000, 764697600000, 781027200000, 796147200000, 812476800000, 828201600000, 844531200000, 859651200000, 875980800000, 891100800000, 907430400000, 922550400000, 938880000000, 954000000000, 967305600000, 985449600000, 1002384000000, 1017504000000, 1033833600000, 1048953600000, 1065283200000, 1080403200000, 1096732800000, 1111852800000, 1128182400000, 1143907200000, 1159632000000, 1174752000000, 1191686400000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "LHI": {
        "abbrs": ["AEST", "+1030", "+1130", "+1030", "+1130", "+1030", "+1130", "+1030", "+1130", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11"],
        "untils": [352216800000, 372785400000, 384273000000, 404839800000, 415722600000, 436289400000, 447172200000, 467739000000, 478621800000, 499188600000, 511282800000, 530033400000, 542732400000, 562087800000, 574786800000, 594142200000, 606236400000, 625591800000, 636476400000, 657041400000, 667926000000, 688491000000, 699375600000, 719940600000, 731430000000, 751995000000, 762879600000, 783444600000, 794329200000, 814894200000, 828198000000, 846343800000, 859647600000, 877793400000, 891097200000, 909243000000, 922546800000, 941297400000, 953996400000, 967303800000, 985446000000, 1004196600000, 1017500400000, 1035646200000, 1048950000000, 1067095800000, 1080399600000, 1099150200000, 1111849200000, 1130599800000, 1143903600000, 1162049400000, 1174748400000, 1193499000000, 1207407600000, 1223134200000, 1238857200000, 1254583800000, 1270306800000, 1286033400000, 1301756400000, 1317483000000, 1333206000000, 1349537400000, 1365260400000, 1380987000000, 1396710000000, 1412436600000, 1428159600000, 1443886200000, 1459609200000, 1475335800000, 1491058800000, 1506785400000, 1522508400000, 1538839800000, 1554562800000, 1570289400000, 1586012400000, 1601739000000, 1617462000000, 1633188600000, 1648911600000, 1664638200000, 1680361200000, 1696087800000, 1712415600000, 1728142200000, 1743865200000, 1759591800000, 1775314800000, 1791041400000, 1806764400000, 1822491000000, 1838214000000, 1853940600000, 1869663600000, 1885995000000, 1901718000000, 1917444600000, 1933167600000, 1948894200000, 1964617200000, 1980343800000, 1996066800000, 2011793400000, 2027516400000, 2043243000000, 2058966000000, 2075297400000, 2091020400000, 2106747000000, 2122470000000, 2138196600000, null],
        "offsets": [-600, -630, -690, -630, -690, -630, -690, -630, -690, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Lindeman": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 625593600000, 636480000000, 657043200000, 667929600000, 688492800000, 699379200000, 719942400000, 731433600000, 751996800000, 762883200000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Lord_Howe": {
        "abbrs": ["AEST", "+1030", "+1130", "+1030", "+1130", "+1030", "+1130", "+1030", "+1130", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11", "+1030", "+11"],
        "untils": [352216800000, 372785400000, 384273000000, 404839800000, 415722600000, 436289400000, 447172200000, 467739000000, 478621800000, 499188600000, 511282800000, 530033400000, 542732400000, 562087800000, 574786800000, 594142200000, 606236400000, 625591800000, 636476400000, 657041400000, 667926000000, 688491000000, 699375600000, 719940600000, 731430000000, 751995000000, 762879600000, 783444600000, 794329200000, 814894200000, 828198000000, 846343800000, 859647600000, 877793400000, 891097200000, 909243000000, 922546800000, 941297400000, 953996400000, 967303800000, 985446000000, 1004196600000, 1017500400000, 1035646200000, 1048950000000, 1067095800000, 1080399600000, 1099150200000, 1111849200000, 1130599800000, 1143903600000, 1162049400000, 1174748400000, 1193499000000, 1207407600000, 1223134200000, 1238857200000, 1254583800000, 1270306800000, 1286033400000, 1301756400000, 1317483000000, 1333206000000, 1349537400000, 1365260400000, 1380987000000, 1396710000000, 1412436600000, 1428159600000, 1443886200000, 1459609200000, 1475335800000, 1491058800000, 1506785400000, 1522508400000, 1538839800000, 1554562800000, 1570289400000, 1586012400000, 1601739000000, 1617462000000, 1633188600000, 1648911600000, 1664638200000, 1680361200000, 1696087800000, 1712415600000, 1728142200000, 1743865200000, 1759591800000, 1775314800000, 1791041400000, 1806764400000, 1822491000000, 1838214000000, 1853940600000, 1869663600000, 1885995000000, 1901718000000, 1917444600000, 1933167600000, 1948894200000, 1964617200000, 1980343800000, 1996066800000, 2011793400000, 2027516400000, 2043243000000, 2058966000000, 2075297400000, 2091020400000, 2106747000000, 2122470000000, 2138196600000, null],
        "offsets": [-600, -630, -690, -630, -690, -630, -690, -630, -690, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660, -630, -660],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Melbourne": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 384278400000, 404841600000, 415728000000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 511286400000, 530035200000, 542736000000, 561484800000, 574790400000, 594144000000, 606240000000, 625593600000, 637689600000, 657043200000, 667929600000, 688492800000, 699379200000, 719942400000, 731433600000, 751996800000, 762883200000, 783446400000, 796147200000, 814896000000, 828201600000, 846345600000, 859651200000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 967305600000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143907200000, 1162051200000, 1174752000000, 1193500800000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "NSW": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386697600000, 404841600000, 415728000000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 511286400000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 636480000000, 657043200000, 667929600000, 688492800000, 699379200000, 719942400000, 731433600000, 751996800000, 762883200000, 783446400000, 794332800000, 814896000000, 828201600000, 846345600000, 859651200000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 967305600000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143907200000, 1162051200000, 1174752000000, 1193500800000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "North": {
        "abbrs": ["ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST"],
        "untils": [-1672565340000, -1665390600000, -883639800000, -876126600000, -860398200000, -844677000000, -828343800000, -813227400000, null],
        "offsets": [-570, -630, -570, -630, -570, -630, -570, -630, -570],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Perth": {
        "abbrs": ["AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST"],
        "untils": [-1672559940000, -1665385200000, -883634400000, -876121200000, -860392800000, -844671600000, 152042400000, 162928800000, 436298400000, 447184800000, 690314400000, 699386400000, 1165082400000, 1174759200000, 1193508000000, 1206813600000, 1224957600000, 1238263200000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Queensland": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 625593600000, 636480000000, 657043200000, 667929600000, 688492800000, 699379200000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "South": {
        "abbrs": ["ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT"],
        "untils": [-1672565340000, -1665390600000, -883639800000, -876126600000, -860398200000, -844677000000, -828343800000, -813227400000, 57688200000, 67969800000, 89137800000, 100024200000, 120587400000, 131473800000, 152037000000, 162923400000, 183486600000, 194977800000, 215541000000, 226427400000, 246990600000, 257877000000, 278440200000, 289326600000, 309889800000, 320776200000, 341339400000, 352225800000, 372789000000, 384280200000, 404843400000, 415729800000, 436293000000, 447179400000, 467742600000, 478629000000, 499192200000, 511288200000, 530037000000, 542737800000, 562091400000, 574792200000, 594145800000, 606241800000, 625595400000, 637691400000, 657045000000, 667931400000, 688494600000, 701195400000, 719944200000, 731435400000, 751998600000, 764094600000, 783448200000, 796149000000, 814897800000, 828203400000, 846347400000, 859653000000, 877797000000, 891102600000, 909246600000, 922552200000, 941301000000, 954001800000, 972750600000, 985451400000, 1004200200000, 1017505800000, 1035649800000, 1048955400000, 1067099400000, 1080405000000, 1099153800000, 1111854600000, 1130603400000, 1143909000000, 1162053000000, 1174753800000, 1193502600000, 1207413000000, 1223137800000, 1238862600000, 1254587400000, 1270312200000, 1286037000000, 1301761800000, 1317486600000, 1333211400000, 1349541000000, 1365265800000, 1380990600000, 1396715400000, 1412440200000, 1428165000000, 1443889800000, 1459614600000, 1475339400000, 1491064200000, 1506789000000, 1522513800000, 1538843400000, 1554568200000, 1570293000000, 1586017800000, 1601742600000, 1617467400000, 1633192200000, 1648917000000, 1664641800000, 1680366600000, 1696091400000, 1712421000000, 1728145800000, 1743870600000, 1759595400000, 1775320200000, 1791045000000, 1806769800000, 1822494600000, 1838219400000, 1853944200000, 1869669000000, 1885998600000, 1901723400000, 1917448200000, 1933173000000, 1948897800000, 1964622600000, 1980347400000, 1996072200000, 2011797000000, 2027521800000, 2043246600000, 2058971400000, 2075301000000, 2091025800000, 2106750600000, 2122475400000, 2138200200000, null],
        "offsets": [-570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Sydney": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386697600000, 404841600000, 415728000000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 511286400000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 636480000000, 657043200000, 667929600000, 688492800000, 699379200000, 719942400000, 731433600000, 751996800000, 762883200000, 783446400000, 794332800000, 814896000000, 828201600000, 846345600000, 859651200000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 967305600000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143907200000, 1162051200000, 1174752000000, 1193500800000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Tasmania": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1680508800000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, -71136000000, -55411200000, -37267200000, -25776000000, -5817600000, 5673600000, 25632000000, 37728000000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 386092800000, 404841600000, 417542400000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 510076800000, 530035200000, 542736000000, 562089600000, 574790400000, 594144000000, 606240000000, 625593600000, 637689600000, 657043200000, 670348800000, 686678400000, 701798400000, 718128000000, 733248000000, 749577600000, 764697600000, 781027200000, 796147200000, 812476800000, 828201600000, 844531200000, 859651200000, 875980800000, 891100800000, 907430400000, 922550400000, 938880000000, 954000000000, 967305600000, 985449600000, 1002384000000, 1017504000000, 1033833600000, 1048953600000, 1065283200000, 1080403200000, 1096732800000, 1111852800000, 1128182400000, 1143907200000, 1159632000000, 1174752000000, 1191686400000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Victoria": {
        "abbrs": ["AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT", "AEST", "AEDT"],
        "untils": [-1672567140000, -1665392400000, -883641600000, -876128400000, -860400000000, -844678800000, -828345600000, -813229200000, 57686400000, 67968000000, 89136000000, 100022400000, 120585600000, 131472000000, 152035200000, 162921600000, 183484800000, 194976000000, 215539200000, 226425600000, 246988800000, 257875200000, 278438400000, 289324800000, 309888000000, 320774400000, 341337600000, 352224000000, 372787200000, 384278400000, 404841600000, 415728000000, 436291200000, 447177600000, 467740800000, 478627200000, 499190400000, 511286400000, 530035200000, 542736000000, 561484800000, 574790400000, 594144000000, 606240000000, 625593600000, 637689600000, 657043200000, 667929600000, 688492800000, 699379200000, 719942400000, 731433600000, 751996800000, 762883200000, 783446400000, 796147200000, 814896000000, 828201600000, 846345600000, 859651200000, 877795200000, 891100800000, 909244800000, 922550400000, 941299200000, 954000000000, 967305600000, 985449600000, 1004198400000, 1017504000000, 1035648000000, 1048953600000, 1067097600000, 1080403200000, 1099152000000, 1111852800000, 1130601600000, 1143907200000, 1162051200000, 1174752000000, 1193500800000, 1207411200000, 1223136000000, 1238860800000, 1254585600000, 1270310400000, 1286035200000, 1301760000000, 1317484800000, 1333209600000, 1349539200000, 1365264000000, 1380988800000, 1396713600000, 1412438400000, 1428163200000, 1443888000000, 1459612800000, 1475337600000, 1491062400000, 1506787200000, 1522512000000, 1538841600000, 1554566400000, 1570291200000, 1586016000000, 1601740800000, 1617465600000, 1633190400000, 1648915200000, 1664640000000, 1680364800000, 1696089600000, 1712419200000, 1728144000000, 1743868800000, 1759593600000, 1775318400000, 1791043200000, 1806768000000, 1822492800000, 1838217600000, 1853942400000, 1869667200000, 1885996800000, 1901721600000, 1917446400000, 1933171200000, 1948896000000, 1964620800000, 1980345600000, 1996070400000, 2011795200000, 2027520000000, 2043244800000, 2058969600000, 2075299200000, 2091024000000, 2106748800000, 2122473600000, 2138198400000, null],
        "offsets": [-600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660, -600, -660],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "West": {
        "abbrs": ["AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST", "AWDT", "AWST"],
        "untils": [-1672559940000, -1665385200000, -883634400000, -876121200000, -860392800000, -844671600000, 152042400000, 162928800000, 436298400000, 447184800000, 690314400000, 699386400000, 1165082400000, 1174759200000, 1193508000000, 1206813600000, 1224957600000, 1238263200000, null],
        "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Yancowinna": {
        "abbrs": ["ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT", "ACST", "ACDT"],
        "untils": [-1672565340000, -1665390600000, -883639800000, -876126600000, -860398200000, -844677000000, -828343800000, -813227400000, 57688200000, 67969800000, 89137800000, 100024200000, 120587400000, 131473800000, 152037000000, 162923400000, 183486600000, 194977800000, 215541000000, 226427400000, 246990600000, 257877000000, 278440200000, 289326600000, 309889800000, 320776200000, 341339400000, 352225800000, 372789000000, 386699400000, 404843400000, 415729800000, 436293000000, 447179400000, 467742600000, 478629000000, 499192200000, 511288200000, 530037000000, 542737800000, 562091400000, 574792200000, 594145800000, 606241800000, 625595400000, 636481800000, 657045000000, 667931400000, 688494600000, 699381000000, 719944200000, 731435400000, 751998600000, 762885000000, 783448200000, 794334600000, 814897800000, 828203400000, 846347400000, 859653000000, 877797000000, 891102600000, 909246600000, 922552200000, 941301000000, 954001800000, 972750600000, 985451400000, 1004200200000, 1017505800000, 1035649800000, 1048955400000, 1067099400000, 1080405000000, 1099153800000, 1111854600000, 1130603400000, 1143909000000, 1162053000000, 1174753800000, 1193502600000, 1207413000000, 1223137800000, 1238862600000, 1254587400000, 1270312200000, 1286037000000, 1301761800000, 1317486600000, 1333211400000, 1349541000000, 1365265800000, 1380990600000, 1396715400000, 1412440200000, 1428165000000, 1443889800000, 1459614600000, 1475339400000, 1491064200000, 1506789000000, 1522513800000, 1538843400000, 1554568200000, 1570293000000, 1586017800000, 1601742600000, 1617467400000, 1633192200000, 1648917000000, 1664641800000, 1680366600000, 1696091400000, 1712421000000, 1728145800000, 1743870600000, 1759595400000, 1775320200000, 1791045000000, 1806769800000, 1822494600000, 1838219400000, 1853944200000, 1869669000000, 1885998600000, 1901723400000, 1917448200000, 1933173000000, 1948897800000, 1964622600000, 1980347400000, 1996072200000, 2011797000000, 2027521800000, 2043246600000, 2058971400000, 2075301000000, 2091025800000, 2106750600000, 2122475400000, 2138200200000, null],
        "offsets": [-570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630, -570, -630],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      }
    },
    "Brazil": {
      "Acre": {
        "abbrs": ["LMT", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05"],
        "untils": [-1767209328000, -1206950400000, -1191355200000, -1175367600000, -1159819200000, -633812400000, -622062000000, -602276400000, -591825600000, -570740400000, -560203200000, -539118000000, -531345600000, -191358000000, -184190400000, -155156400000, -150062400000, -128890800000, -121118400000, -99946800000, -89582400000, -68410800000, -57960000000, 499755600000, 511243200000, 530600400000, 540273600000, 562136400000, 571204800000, 1214283600000, 1384056000000, null],
        "offsets": [271.2, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "DeNoronha": {
        "abbrs": ["LMT", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02", "-01", "-02"],
        "untils": [-1767217820000, -1206961200000, -1191366000000, -1175378400000, -1159830000000, -633823200000, -622072800000, -602287200000, -591836400000, -570751200000, -560214000000, -539128800000, -531356400000, -191368800000, -184201200000, -155167200000, -150073200000, -128901600000, -121129200000, -99957600000, -89593200000, -68421600000, -57970800000, 499744800000, 511232400000, 530589600000, 540262800000, 562125600000, 571194000000, 592970400000, 602038800000, 624420000000, 634698000000, 938916000000, 951613200000, 970970400000, 971571600000, 1003024800000, 1013907600000, null],
        "offsets": [129.6667, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120, 60, 120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "East": {
        "abbrs": ["LMT", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02", "-03", "-02"],
        "untils": [-1767214412000, -1206957600000, -1191362400000, -1175374800000, -1159826400000, -633819600000, -622069200000, -602283600000, -591832800000, -570747600000, -560210400000, -539125200000, -531352800000, -195426000000, -184197600000, -155163600000, -150069600000, -128898000000, -121125600000, -99954000000, -89589600000, -68418000000, -57967200000, 499748400000, 511236000000, 530593200000, 540266400000, 562129200000, 571197600000, 592974000000, 602042400000, 624423600000, 634701600000, 656478000000, 666756000000, 687927600000, 697600800000, 719982000000, 728445600000, 750826800000, 761709600000, 782276400000, 793159200000, 813726000000, 824004000000, 844570800000, 856058400000, 876106800000, 888717600000, 908074800000, 919562400000, 938919600000, 951616800000, 970974000000, 982461600000, 1003028400000, 1013911200000, 1036292400000, 1045360800000, 1066532400000, 1076810400000, 1099364400000, 1108864800000, 1129431600000, 1140314400000, 1162695600000, 1172368800000, 1192330800000, 1203213600000, 1224385200000, 1234663200000, 1255834800000, 1266717600000, 1287284400000, 1298167200000, 1318734000000, 1330221600000, 1350788400000, 1361066400000, 1382238000000, 1392516000000, 1413687600000, 1424570400000, 1445137200000, 1456020000000, 1476586800000, 1487469600000, 1508036400000, 1518919200000, 1541300400000, 1550368800000, 1572750000000, 1581818400000, 1604199600000, 1613872800000, 1636254000000, 1645322400000, 1667703600000, 1677376800000, 1699153200000, 1708221600000, 1730602800000, 1739671200000, 1762052400000, 1771725600000, 1793502000000, 1803175200000, 1825556400000, 1834624800000, 1857006000000, 1866074400000, 1888455600000, 1897524000000, 1919905200000, 1928973600000, 1951354800000, 1960423200000, 1983409200000, 1992477600000, 2014858800000, 2024532000000, 2046308400000, 2055376800000, 2077758000000, 2086826400000, 2109207600000, 2118880800000, 2140657200000, null],
        "offsets": [186.4667, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120, 180, 120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "West": {
        "abbrs": ["LMT", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04"],
        "untils": [-1767211196000, -1206954000000, -1191358800000, -1175371200000, -1159822800000, -633816000000, -622065600000, -602280000000, -591829200000, -570744000000, -560206800000, -539121600000, -531349200000, -191361600000, -184194000000, -155160000000, -150066000000, -128894400000, -121122000000, -99950400000, -89586000000, -68414400000, -57963600000, 499752000000, 511239600000, 530596800000, 540270000000, 562132800000, 571201200000, 750830400000, 761713200000, null],
        "offsets": [240.0667, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "CET": {
      "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
      "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -766623600000, 228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "CST6CDT": {
      "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
      "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -84384000000, -68662800000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
      "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
      "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Canada": {
      "Atlantic": {
        "abbrs": ["LMT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "AWT", "APT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST", "ADT", "AST"],
        "untils": [-2131645536000, -1696276800000, -1680469200000, -1632074400000, -1615143600000, -1566763200000, -1557090000000, -1535486400000, -1524949200000, -1504468800000, -1493413200000, -1472414400000, -1461963600000, -1440964800000, -1429390800000, -1409515200000, -1396731600000, -1376856000000, -1366491600000, -1346616000000, -1333832400000, -1313956800000, -1303678800000, -1282507200000, -1272661200000, -1251057600000, -1240088400000, -1219608000000, -1207429200000, -1188763200000, -1175979600000, -1157313600000, -1143925200000, -1124049600000, -1113771600000, -1091390400000, -1081026000000, -1059854400000, -1050786000000, -1030910400000, -1018126800000, -999460800000, -986677200000, -965592000000, -955227600000, -935956800000, -923173200000, -904507200000, -891723600000, -880221600000, -769395600000, -765399600000, -747252000000, -733950000000, -715802400000, -702500400000, -684352800000, -671050800000, -652903200000, -639601200000, -589399200000, -576097200000, -557949600000, -544647600000, -526500000000, -513198000000, -495050400000, -481748400000, -431546400000, -418244400000, -400096800000, -386794800000, -368647200000, -355345200000, -337197600000, -323895600000, -242244000000, -226522800000, -210794400000, -195073200000, -179344800000, -163623600000, -147895200000, -131569200000, -116445600000, -100119600000, -84391200000, -68670000000, -52941600000, -37220400000, -21492000000, -5770800000, 9957600000, 25678800000, 41407200000, 57733200000, 73461600000, 89182800000, 104911200000, 120632400000, 136360800000, 152082000000, 167810400000, 183531600000, 199260000000, 215586000000, 230709600000, 247035600000, 262764000000, 278485200000, 294213600000, 309934800000, 325663200000, 341384400000, 357112800000, 372834000000, 388562400000, 404888400000, 420012000000, 436338000000, 452066400000, 467787600000, 483516000000, 499237200000, 514965600000, 530686800000, 544600800000, 562136400000, 576050400000, 594190800000, 607500000000, 625640400000, 638949600000, 657090000000, 671004000000, 688539600000, 702453600000, 719989200000, 733903200000, 752043600000, 765352800000, 783493200000, 796802400000, 814942800000, 828856800000, 846392400000, 860306400000, 877842000000, 891756000000, 909291600000, 923205600000, 941346000000, 954655200000, 972795600000, 986104800000, 1004245200000, 1018159200000, 1035694800000, 1049608800000, 1067144400000, 1081058400000, 1099198800000, 1112508000000, 1130648400000, 1143957600000, 1162098000000, 1173592800000, 1194152400000, 1205042400000, 1225602000000, 1236492000000, 1257051600000, 1268546400000, 1289106000000, 1299996000000, 1320555600000, 1331445600000, 1352005200000, 1362895200000, 1383454800000, 1394344800000, 1414904400000, 1425794400000, 1446354000000, 1457848800000, 1478408400000, 1489298400000, 1509858000000, 1520748000000, 1541307600000, 1552197600000, 1572757200000, 1583647200000, 1604206800000, 1615701600000, 1636261200000, 1647151200000, 1667710800000, 1678600800000, 1699160400000, 1710050400000, 1730610000000, 1741500000000, 1762059600000, 1772949600000, 1793509200000, 1805004000000, 1825563600000, 1836453600000, 1857013200000, 1867903200000, 1888462800000, 1899352800000, 1919912400000, 1930802400000, 1951362000000, 1962856800000, 1983416400000, 1994306400000, 2014866000000, 2025756000000, 2046315600000, 2057205600000, 2077765200000, 2088655200000, 2109214800000, 2120104800000, 2140664400000, null],
        "offsets": [254.4, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Central": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1694368800000, -1681671600000, -1632067200000, -1615136400000, -1029686400000, -1018198800000, -880214400000, -769395600000, -765392400000, -746035200000, -732733200000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620755200000, -607626000000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -450291600000, -431539200000, -418237200000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -321469200000, -305740800000, -292438800000, -210787200000, -198090000000, -116438400000, -100108800000, -84384000000, -68659200000, -52934400000, -37209600000, -21484800000, -5760000000, 9964800000, 25689600000, 41414400000, 57744000000, 73468800000, 89193600000, 104918400000, 120643200000, 136368000000, 152092800000, 167817600000, 183542400000, 199267200000, 215596800000, 230716800000, 247046400000, 262771200000, 278496000000, 294220800000, 309945600000, 325670400000, 341395200000, 357120000000, 372844800000, 388569600000, 404899200000, 420019200000, 436348800000, 452073600000, 467798400000, 483523200000, 499248000000, 514972800000, 530697600000, 544608000000, 562147200000, 576057600000, 594201600000, 607507200000, 625651200000, 638956800000, 657100800000, 671011200000, 688550400000, 702460800000, 720000000000, 733910400000, 752054400000, 765360000000, 783504000000, 796809600000, 814953600000, 828864000000, 846403200000, 860313600000, 877852800000, 891763200000, 909302400000, 923212800000, 941356800000, 954662400000, 972806400000, 986112000000, 1004256000000, 1018166400000, 1035705600000, 1049616000000, 1067155200000, 1081065600000, 1099209600000, 1112515200000, 1130659200000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Eastern": {
        "abbrs": ["EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1632070800000, -1615140000000, -1601753400000, -1583697600000, -1567357200000, -1554667200000, -1534698000000, -1524074400000, -1503248400000, -1492365600000, -1471798800000, -1460916000000, -1440954000000, -1428861600000, -1409504400000, -1397412000000, -1378054800000, -1365962400000, -1346605200000, -1333908000000, -1315155600000, -1301853600000, -1283706000000, -1270404000000, -1252256400000, -1238954400000, -1220806800000, -1207504800000, -1188752400000, -1176055200000, -1157302800000, -1144000800000, -1125853200000, -1112551200000, -1094403600000, -1081101600000, -1062954000000, -1049652000000, -1031504400000, -1018202400000, -1000054800000, -986752800000, -968000400000, -955303200000, -936550800000, -880218000000, -769395600000, -765396000000, -747248400000, -733946400000, -715806000000, -702504000000, -684356400000, -671054400000, -652906800000, -634161600000, -620845200000, -602704800000, -589395600000, -576093600000, -557946000000, -544644000000, -526496400000, -513194400000, -495046800000, -481744800000, -463597200000, -450295200000, -431542800000, -418240800000, -400093200000, -384372000000, -368643600000, -352922400000, -337194000000, -321472800000, -305744400000, -289418400000, -273690000000, -257968800000, -242240400000, -226519200000, -210790800000, -195069600000, -179341200000, -163620000000, -147891600000, -131565600000, -116442000000, -100116000000, -84387600000, -68666400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 136364400000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Mountain": {
        "abbrs": ["LMT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1998663968000, -1632063600000, -1615132800000, -1600614000000, -1596816000000, -1567954800000, -1551628800000, -1536505200000, -1523203200000, -1504450800000, -1491753600000, -1473001200000, -1459699200000, -880210800000, -769395600000, -765388800000, -715791600000, -702489600000, -84380400000, -68659200000, -21481200000, -5760000000, 73472400000, 89193600000, 104922000000, 120643200000, 136371600000, 152092800000, 167821200000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [453.8667, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Newfoundland": {
        "abbrs": ["NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NWT", "NPT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST", "NDT", "NST"],
        "untils": [-1664130548000, -1650137348000, -1632076148000, -1615145348000, -1598650148000, -1590100148000, -1567286948000, -1551565748000, -1535837348000, -1520116148000, -1503782948000, -1488666548000, -1472333348000, -1457216948000, -1440883748000, -1425767348000, -1409434148000, -1394317748000, -1377984548000, -1362263348000, -1346534948000, -1330813748000, -1314480548000, -1299364148000, -1283030948000, -1267914548000, -1251581348000, -1236464948000, -1220131748000, -1205015348000, -1188682148000, -1172960948000, -1156627748000, -1141511348000, -1125178148000, -1110061748000, -1096921748000, -1093728600000, -1078612200000, -1061670600000, -1048973400000, -1030221000000, -1017523800000, -998771400000, -986074200000, -966717000000, -954624600000, -935267400000, -922570200000, -903817800000, -891120600000, -872368200000, -769395600000, -765401400000, -746044200000, -733347000000, -714594600000, -701897400000, -683145000000, -670447800000, -651695400000, -638998200000, -619641000000, -606943800000, -589401000000, -576099000000, -557951400000, -544649400000, -526501800000, -513199800000, -495052200000, -481750200000, -463602600000, -450300600000, -431548200000, -418246200000, -400098600000, -386796600000, -368649000000, -355347000000, -337199400000, -323897400000, -305749800000, -289423800000, -273695400000, -257974200000, -242245800000, -226524600000, -210796200000, -195075000000, -179346600000, -163625400000, -147897000000, -131571000000, -116447400000, -100121400000, -84393000000, -68671800000, -52943400000, -37222200000, -21493800000, -5772600000, 9955800000, 25677000000, 41405400000, 57731400000, 73459800000, 89181000000, 104909400000, 120630600000, 136359000000, 152080200000, 167808600000, 183529800000, 199258200000, 215584200000, 230707800000, 247033800000, 262762200000, 278483400000, 294211800000, 309933000000, 325661400000, 341382600000, 357111000000, 372832200000, 388560600000, 404886600000, 420010200000, 436336200000, 452064600000, 467785800000, 483514200000, 499235400000, 514963800000, 530685000000, 544591860000, 562127460000, 576041460000, 594178260000, 607491060000, 625631460000, 638940660000, 657081060000, 670995060000, 688530660000, 702444660000, 719980260000, 733894260000, 752034660000, 765343860000, 783484260000, 796793460000, 814933860000, 828847860000, 846383460000, 860297460000, 877833060000, 891747060000, 909282660000, 923196660000, 941337060000, 954646260000, 972786660000, 986095860000, 1004236260000, 1018150260000, 1035685860000, 1049599860000, 1067135460000, 1081049460000, 1099189860000, 1112499060000, 1130639460000, 1143948660000, 1162089060000, 1173583860000, 1194143460000, 1205033460000, 1225593060000, 1236483060000, 1257042660000, 1268537460000, 1289097060000, 1299987060000, 1320553800000, 1331443800000, 1352003400000, 1362893400000, 1383453000000, 1394343000000, 1414902600000, 1425792600000, 1446352200000, 1457847000000, 1478406600000, 1489296600000, 1509856200000, 1520746200000, 1541305800000, 1552195800000, 1572755400000, 1583645400000, 1604205000000, 1615699800000, 1636259400000, 1647149400000, 1667709000000, 1678599000000, 1699158600000, 1710048600000, 1730608200000, 1741498200000, 1762057800000, 1772947800000, 1793507400000, 1805002200000, 1825561800000, 1836451800000, 1857011400000, 1867901400000, 1888461000000, 1899351000000, 1919910600000, 1930800600000, 1951360200000, 1962855000000, 1983414600000, 1994304600000, 2014864200000, 2025754200000, 2046313800000, 2057203800000, 2077763400000, 2088653400000, 2109213000000, 2120103000000, 2140662600000, null],
        "offsets": [210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 150.8667, 210.8667, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 90, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210, 150, 210],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Pacific": {
        "abbrs": ["PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1632060000000, -1615129200000, -880207200000, -769395600000, -765385200000, -747237600000, -732726000000, -715788000000, -702486000000, -684338400000, -671036400000, -652888800000, -639586800000, -620834400000, -608137200000, -589384800000, -576082800000, -557935200000, -544633200000, -526485600000, -513183600000, -495036000000, -481734000000, -463586400000, -450284400000, -431532000000, -418230000000, -400082400000, -386780400000, -368632800000, -355330800000, -337183200000, -323881200000, -305733600000, -292431600000, -273679200000, -260982000000, -242229600000, -226508400000, -210780000000, -195058800000, -179330400000, -163609200000, -147880800000, -131554800000, -116431200000, -100105200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 136375200000, 152096400000, 167824800000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Saskatchewan": {
        "abbrs": ["LMT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "CST"],
        "untils": [-2030202084000, -1632063600000, -1615132800000, -1251651600000, -1238349600000, -1220202000000, -1206900000000, -1188752400000, -1175450400000, -1156698000000, -1144000800000, -1125248400000, -1111946400000, -1032714000000, -1016992800000, -1001264400000, -986148000000, -969814800000, -954093600000, -937760400000, -922039200000, -906310800000, -890589600000, -880210800000, -769395600000, -765388800000, -748450800000, -732729600000, -715791600000, -702489600000, -684342000000, -671040000000, -652892400000, -639590400000, -620838000000, -608140800000, -589388400000, -576086400000, -557938800000, -544636800000, -526489200000, -513187200000, -495039600000, -481737600000, -463590000000, -450288000000, -431535600000, -418233600000, -400086000000, -386784000000, -337186800000, -321465600000, -305737200000, null],
        "offsets": [418.6, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Yukon": {
        "abbrs": ["YST", "YDT", "YST", "YDT", "YST", "YWT", "YPT", "YST", "YDDT", "YST", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1632056400000, -1615125600000, -1596978000000, -1583164800000, -880203600000, -769395600000, -765381600000, -147884400000, -131554800000, -81961200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [540, 480, 540, 480, 540, 480, 480, 540, 420, 540, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "Chile": {
      "Continental": {
        "abbrs": ["SMT", "-05", "SMT", "-04", "SMT", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-05", "-04", "-03", "-04", "-05", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03", "-04", "-03"],
        "untils": [-1892661434000, -1688410800000, -1619205434000, -1593806400000, -1335986234000, -1317585600000, -1304362800000, -1286049600000, -1272826800000, -1254513600000, -1241290800000, -1222977600000, -1209754800000, -1191355200000, -1178132400000, -870552000000, -865278000000, -740520000000, -736376400000, -718056000000, -713649600000, -36619200000, -23922000000, -3355200000, 7527600000, 24465600000, 37767600000, 55915200000, 69217200000, 87969600000, 100666800000, 118209600000, 132116400000, 150868800000, 163566000000, 182318400000, 195620400000, 213768000000, 227070000000, 245217600000, 258519600000, 277272000000, 289969200000, 308721600000, 321418800000, 340171200000, 353473200000, 371620800000, 384922800000, 403070400000, 416372400000, 434520000000, 447822000000, 466574400000, 479271600000, 498024000000, 510721200000, 529473600000, 545194800000, 560923200000, 574225200000, 592372800000, 605674800000, 624427200000, 637124400000, 653457600000, 668574000000, 687326400000, 700628400000, 718776000000, 732078000000, 750225600000, 763527600000, 781675200000, 794977200000, 813729600000, 826426800000, 845179200000, 859690800000, 876628800000, 889930800000, 906868800000, 923194800000, 939528000000, 952830000000, 971582400000, 984279600000, 1003032000000, 1015729200000, 1034481600000, 1047178800000, 1065931200000, 1079233200000, 1097380800000, 1110682800000, 1128830400000, 1142132400000, 1160884800000, 1173582000000, 1192334400000, 1206846000000, 1223784000000, 1237086000000, 1255233600000, 1270350000000, 1286683200000, 1304823600000, 1313899200000, 1335668400000, 1346558400000, 1367118000000, 1378612800000, 1398567600000, 1410062400000, 1463281200000, 1471147200000, 1494730800000, 1502596800000, 1526180400000, 1534046400000, 1554606000000, 1567915200000, 1586055600000, 1599364800000, 1617505200000, 1630814400000, 1648954800000, 1662264000000, 1680404400000, 1693713600000, 1712458800000, 1725768000000, 1743908400000, 1757217600000, 1775358000000, 1788667200000, 1806807600000, 1820116800000, 1838257200000, 1851566400000, 1870311600000, 1883016000000, 1901761200000, 1915070400000, 1933210800000, 1946520000000, 1964660400000, 1977969600000, 1996110000000, 2009419200000, 2027559600000, 2040868800000, 2059614000000, 2072318400000, 2091063600000, 2104372800000, 2122513200000, 2135822400000, null],
        "offsets": [282.7667, 300, 282.7667, 240, 282.7667, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 180, 240, 300, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180, 240, 180],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "EasterIsland": {
        "abbrs": ["EMT", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05"],
        "untils": [-1178124152000, -36619200000, -23922000000, -3355200000, 7527600000, 24465600000, 37767600000, 55915200000, 69217200000, 87969600000, 100666800000, 118209600000, 132116400000, 150868800000, 163566000000, 182318400000, 195620400000, 213768000000, 227070000000, 245217600000, 258519600000, 277272000000, 289969200000, 308721600000, 321418800000, 340171200000, 353473200000, 371620800000, 384922800000, 403070400000, 416372400000, 434520000000, 447822000000, 466574400000, 479271600000, 498024000000, 510721200000, 529473600000, 545194800000, 560923200000, 574225200000, 592372800000, 605674800000, 624427200000, 637124400000, 653457600000, 668574000000, 687326400000, 700628400000, 718776000000, 732078000000, 750225600000, 763527600000, 781675200000, 794977200000, 813729600000, 826426800000, 845179200000, 859690800000, 876628800000, 889930800000, 906868800000, 923194800000, 939528000000, 952830000000, 971582400000, 984279600000, 1003032000000, 1015729200000, 1034481600000, 1047178800000, 1065931200000, 1079233200000, 1097380800000, 1110682800000, 1128830400000, 1142132400000, 1160884800000, 1173582000000, 1192334400000, 1206846000000, 1223784000000, 1237086000000, 1255233600000, 1270350000000, 1286683200000, 1304823600000, 1313899200000, 1335668400000, 1346558400000, 1367118000000, 1378612800000, 1398567600000, 1410062400000, 1463281200000, 1471147200000, 1494730800000, 1502596800000, 1526180400000, 1534046400000, 1554606000000, 1567915200000, 1586055600000, 1599364800000, 1617505200000, 1630814400000, 1648954800000, 1662264000000, 1680404400000, 1693713600000, 1712458800000, 1725768000000, 1743908400000, 1757217600000, 1775358000000, 1788667200000, 1806807600000, 1820116800000, 1838257200000, 1851566400000, 1870311600000, 1883016000000, 1901761200000, 1915070400000, 1933210800000, 1946520000000, 1964660400000, 1977969600000, 1996110000000, 2009419200000, 2027559600000, 2040868800000, 2059614000000, 2072318400000, 2091063600000, 2104372800000, 2122513200000, 2135822400000, null],
        "offsets": [437.4667, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      }
    },
    "Cuba": {
      "abbrs": ["HMT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
      "untils": [-1402813824000, -1311534000000, -1300996800000, -933534000000, -925675200000, -902084400000, -893620800000, -870030000000, -862171200000, -775681200000, -767822400000, -744231600000, -736372800000, -144702000000, -134251200000, -113425200000, -102542400000, -86295600000, -72907200000, -54154800000, -41457600000, -21495600000, -5774400000, 9954000000, 25675200000, 41403600000, 57729600000, 73458000000, 87364800000, 104907600000, 118900800000, 136357200000, 150436800000, 167806800000, 183528000000, 199256400000, 215582400000, 230706000000, 247032000000, 263365200000, 276667200000, 290581200000, 308721600000, 322030800000, 340171200000, 358318800000, 371620800000, 389768400000, 403070400000, 421218000000, 434520000000, 452667600000, 466574400000, 484117200000, 498024000000, 511333200000, 529473600000, 542782800000, 560923200000, 574837200000, 592372800000, 606286800000, 623822400000, 638946000000, 655876800000, 671000400000, 687330000000, 702450000000, 718779600000, 733899600000, 750229200000, 765349200000, 781678800000, 796798800000, 813128400000, 828853200000, 844578000000, 860302800000, 876632400000, 891147600000, 909291600000, 922597200000, 941346000000, 954651600000, 972795600000, 986101200000, 1004245200000, 1018155600000, 1035694800000, 1049605200000, 1067144400000, 1080450000000, 1162098000000, 1173589200000, 1193547600000, 1205643600000, 1224997200000, 1236488400000, 1256446800000, 1268542800000, 1288501200000, 1300597200000, 1321160400000, 1333256400000, 1352005200000, 1362891600000, 1383454800000, 1394341200000, 1414904400000, 1425790800000, 1446354000000, 1457845200000, 1478408400000, 1489294800000, 1509858000000, 1520744400000, 1541307600000, 1552194000000, 1572757200000, 1583643600000, 1604206800000, 1615698000000, 1636261200000, 1647147600000, 1667710800000, 1678597200000, 1699160400000, 1710046800000, 1730610000000, 1741496400000, 1762059600000, 1772946000000, 1793509200000, 1805000400000, 1825563600000, 1836450000000, 1857013200000, 1867899600000, 1888462800000, 1899349200000, 1919912400000, 1930798800000, 1951362000000, 1962853200000, 1983416400000, 1994302800000, 2014866000000, 2025752400000, 2046315600000, 2057202000000, 2077765200000, 2088651600000, 2109214800000, 2120101200000, 2140664400000, null],
      "offsets": [329.6, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "EET": {
      "abbrs": ["EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
      "untils": [228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [-120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "EST": {
      "abbrs": ["EST"],
      "untils": [null],
      "offsets": [300],
      "isdsts": [0]
    },
    "EST5EDT": {
      "abbrs": ["EST", "EDT", "EST", "EDT", "EST", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
      "untils": [-1633280400000, -1615140000000, -1601830800000, -1583690400000, -880218000000, -769395600000, -765396000000, -84387600000, -68666400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 126687600000, 152085600000, 162370800000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
      "offsets": [300, 240, 300, 240, 300, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
      "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Egypt": {
      "abbrs": ["EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
      "untils": [-929844000000, -923108400000, -906170400000, -892868400000, -875844000000, -857790000000, -844308000000, -825822000000, -812685600000, -794199600000, -779853600000, -762663600000, -399088800000, -386650800000, -368330400000, -355114800000, -336790800000, -323654400000, -305168400000, -292032000000, -273632400000, -260496000000, -242096400000, -228960000000, -210560400000, -197424000000, -178938000000, -165801600000, -147402000000, -134265600000, -115866000000, -102643200000, -84330000000, -71107200000, -52707600000, -39484800000, -21171600000, -7948800000, 10364400000, 23587200000, 41900400000, 55123200000, 73522800000, 86745600000, 105058800000, 118281600000, 136594800000, 149817600000, 168130800000, 181353600000, 199753200000, 212976000000, 231289200000, 244512000000, 262825200000, 276048000000, 294361200000, 307584000000, 325983600000, 339206400000, 357519600000, 370742400000, 396399600000, 402278400000, 426812400000, 433814400000, 452214000000, 465436800000, 483750000000, 496972800000, 515286000000, 528508800000, 546822000000, 560044800000, 578444400000, 591667200000, 610412400000, 623203200000, 641516400000, 654739200000, 673052400000, 686275200000, 704674800000, 717897600000, 736210800000, 749433600000, 767746800000, 780969600000, 799020000000, 812322000000, 830469600000, 843771600000, 861919200000, 875221200000, 893368800000, 906670800000, 925423200000, 938725200000, 956872800000, 970174800000, 988322400000, 1001624400000, 1019772000000, 1033074000000, 1051221600000, 1064523600000, 1083276000000, 1096578000000, 1114725600000, 1128027600000, 1146175200000, 1158872400000, 1177624800000, 1189112400000, 1209074400000, 1219957200000, 1240524000000, 1250802000000, 1272578400000, 1281474000000, 1284069600000, 1285880400000, 1400191200000, 1403816400000, 1406844000000, 1411678800000, null],
      "offsets": [-120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Eire": {
      "abbrs": ["DMT", "IST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT"],
      "untils": [-1691962479000, -1680471279000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -733356000000, -719445600000, -699487200000, -684972000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [25.35, -34.65, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
    },
    "Etc": {
      "GMT+0": {
        "abbrs": ["GMT"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "GMT+1": {
        "abbrs": ["-01"],
        "untils": [null],
        "offsets": [60],
        "isdsts": [0]
      },
      "GMT+10": {
        "abbrs": ["-10"],
        "untils": [null],
        "offsets": [600],
        "isdsts": [0]
      },
      "GMT+11": {
        "abbrs": ["-11"],
        "untils": [null],
        "offsets": [660],
        "isdsts": [0]
      },
      "GMT+12": {
        "abbrs": ["-12"],
        "untils": [null],
        "offsets": [720],
        "isdsts": [0]
      },
      "GMT+2": {
        "abbrs": ["-02"],
        "untils": [null],
        "offsets": [120],
        "isdsts": [0]
      },
      "GMT+3": {
        "abbrs": ["-03"],
        "untils": [null],
        "offsets": [180],
        "isdsts": [0]
      },
      "GMT+4": {
        "abbrs": ["-04"],
        "untils": [null],
        "offsets": [240],
        "isdsts": [0]
      },
      "GMT+5": {
        "abbrs": ["-05"],
        "untils": [null],
        "offsets": [300],
        "isdsts": [0]
      },
      "GMT+6": {
        "abbrs": ["-06"],
        "untils": [null],
        "offsets": [360],
        "isdsts": [0]
      },
      "GMT+7": {
        "abbrs": ["-07"],
        "untils": [null],
        "offsets": [420],
        "isdsts": [0]
      },
      "GMT+8": {
        "abbrs": ["-08"],
        "untils": [null],
        "offsets": [480],
        "isdsts": [0]
      },
      "GMT+9": {
        "abbrs": ["-09"],
        "untils": [null],
        "offsets": [540],
        "isdsts": [0]
      },
      "GMT-0": {
        "abbrs": ["GMT"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "GMT-1": {
        "abbrs": ["+01"],
        "untils": [null],
        "offsets": [-60],
        "isdsts": [0]
      },
      "GMT-10": {
        "abbrs": ["+10"],
        "untils": [null],
        "offsets": [-600],
        "isdsts": [0]
      },
      "GMT-11": {
        "abbrs": ["+11"],
        "untils": [null],
        "offsets": [-660],
        "isdsts": [0]
      },
      "GMT-12": {
        "abbrs": ["+12"],
        "untils": [null],
        "offsets": [-720],
        "isdsts": [0]
      },
      "GMT-13": {
        "abbrs": ["+13"],
        "untils": [null],
        "offsets": [-780],
        "isdsts": [0]
      },
      "GMT-14": {
        "abbrs": ["+14"],
        "untils": [null],
        "offsets": [-840],
        "isdsts": [0]
      },
      "GMT-2": {
        "abbrs": ["+02"],
        "untils": [null],
        "offsets": [-120],
        "isdsts": [0]
      },
      "GMT-3": {
        "abbrs": ["+03"],
        "untils": [null],
        "offsets": [-180],
        "isdsts": [0]
      },
      "GMT-4": {
        "abbrs": ["+04"],
        "untils": [null],
        "offsets": [-240],
        "isdsts": [0]
      },
      "GMT-5": {
        "abbrs": ["+05"],
        "untils": [null],
        "offsets": [-300],
        "isdsts": [0]
      },
      "GMT-6": {
        "abbrs": ["+06"],
        "untils": [null],
        "offsets": [-360],
        "isdsts": [0]
      },
      "GMT-7": {
        "abbrs": ["+07"],
        "untils": [null],
        "offsets": [-420],
        "isdsts": [0]
      },
      "GMT-8": {
        "abbrs": ["+08"],
        "untils": [null],
        "offsets": [-480],
        "isdsts": [0]
      },
      "GMT-9": {
        "abbrs": ["+09"],
        "untils": [null],
        "offsets": [-540],
        "isdsts": [0]
      },
      "GMT": {
        "abbrs": ["GMT"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "GMT0": {
        "abbrs": ["GMT"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "Greenwich": {
        "abbrs": ["GMT"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "UCT": {
        "abbrs": ["UCT"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "UTC": {
        "abbrs": ["UTC"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "Universal": {
        "abbrs": ["UTC"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      },
      "Zulu": {
        "abbrs": ["UTC"],
        "untils": [null],
        "offsets": [0],
        "isdsts": [0]
      }
    },
    "Europe": {
      "Amsterdam": {
        "abbrs": ["AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "AMT", "NST", "+0120", "+0020", "+0120", "+0020", "+0120", "+0020", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1693700372000, -1680484772000, -1663453172000, -1650147572000, -1633213172000, -1617488372000, -1601158772000, -1586038772000, -1569709172000, -1554589172000, -1538259572000, -1523139572000, -1507501172000, -1490566772000, -1470176372000, -1459117172000, -1443997172000, -1427667572000, -1406672372000, -1396217972000, -1376950772000, -1364768372000, -1345414772000, -1333318772000, -1313792372000, -1301264372000, -1282256372000, -1269814772000, -1250720372000, -1238365172000, -1219184372000, -1206915572000, -1186957172000, -1175465972000, -1156025972000, -1143411572000, -1124489972000, -1111961972000, -1092953972000, -1080512372000, -1061331572000, -1049062772000, -1029190772000, -1025745572000, -1017613200000, -998259600000, -986163600000, -966723600000, -954109200000, -935022000000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -766623600000, 228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -19.5333, -79.5333, -80, -20, -80, -20, -80, -20, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Andorra": {
        "abbrs": ["WET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-733881600000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Astrakhan": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04"],
        "untils": [-1441249932000, -1247540400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622594800000, 638319600000, 654649200000, 670374000000, 701820000000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174777200000, 1193526000000, 1206831600000, 1224975600000, 1238281200000, 1256425200000, 1269730800000, 1288479600000, 1301180400000, 1414274400000, 1459033200000, null],
        "offsets": [-192.2, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -240, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Athens": {
        "abbrs": ["AMT", "EET", "EEST", "EET", "EEST", "CEST", "CET", "CEST", "CET", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1686101632000, -1182996000000, -1178161200000, -906861600000, -904878000000, -857257200000, -844477200000, -828237600000, -812422800000, -552362400000, -541652400000, 166485600000, 186184800000, 198028800000, 213753600000, 228873600000, 244080000000, 260323200000, 275446800000, 291798000000, 307407600000, 323388000000, 338936400000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-94.8667, -120, -180, -120, -180, -120, -60, -120, -60, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Belfast": {
        "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT"],
        "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Belgrade": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-905824800000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -777942000000, -766623600000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Berlin": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CEMT", "CEST", "CET", "CEST", "CET", "CEST", "CEMT", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -776563200000, -765936000000, -761180400000, -748479600000, -733273200000, -717631200000, -714610800000, -710380800000, -701910000000, -684975600000, -670460400000, -654130800000, -639010800000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -180, -120, -60, -120, -60, -120, -180, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bratislava": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "GMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -765327600000, -746578800000, -733359600000, -728517600000, -721260000000, -716425200000, -701910000000, -684975600000, -670460400000, -654217200000, -639010800000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Brussels": {
        "abbrs": ["WET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1740355200000, -1693702800000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -1613826000000, -1604278800000, -1585530000000, -1574038800000, -1552266000000, -1539997200000, -1520557200000, -1507510800000, -1490576400000, -1473642000000, -1459126800000, -1444006800000, -1427677200000, -1411952400000, -1396227600000, -1379293200000, -1364778000000, -1348448400000, -1333328400000, -1316394000000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1191189600000, -1175464800000, -1160344800000, -1143410400000, -1127685600000, -1111960800000, -1096840800000, -1080511200000, -1063576800000, -1049061600000, -1033336800000, -1017612000000, -1002492000000, -986162400000, -969228000000, -950479200000, -942012000000, -934668000000, -857257200000, -844556400000, -828226800000, -812502000000, -798073200000, -781052400000, -766623600000, -745455600000, -733273200000, 228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Bucharest": {
        "abbrs": ["BMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1213148664000, -1187056800000, -1175479200000, -1159754400000, -1144029600000, -1127700000000, -1111975200000, -1096250400000, -1080525600000, -1064800800000, -1049076000000, -1033351200000, -1017626400000, -1001901600000, -986176800000, -970452000000, -954727200000, 296604000000, 307486800000, 323816400000, 338940000000, 354672000000, 370396800000, 386121600000, 401846400000, 417571200000, 433296000000, 449020800000, 465350400000, 481075200000, 496800000000, 512524800000, 528249600000, 543974400000, 559699200000, 575424000000, 591148800000, 606873600000, 622598400000, 638323200000, 654652800000, 670370400000, 686095200000, 701820000000, 717544800000, 733269600000, 748994400000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 846363600000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-104.4, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Budapest": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1633212000000, -1618700400000, -1600466400000, -1581202800000, -906771600000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -778471200000, -762660000000, -749689200000, -733359600000, -717634800000, -701910000000, -686185200000, -670460400000, -654130800000, -639010800000, -621990000000, -605660400000, -492656400000, -481168800000, -461120400000, -449632800000, -428547600000, -418269600000, -397094400000, -386809200000, 323827200000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Busingen": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-904435200000, -891129600000, -872985600000, -859680000000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Chisinau": {
        "abbrs": ["CMT", "BMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "CEST", "CET", "CEST", "CET", "CEST", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1637114100000, -1213148664000, -1187056800000, -1175479200000, -1159754400000, -1144029600000, -1127700000000, -1111975200000, -1096250400000, -1080525600000, -1064800800000, -1049076000000, -1033351200000, -1017626400000, -1001901600000, -986176800000, -970452000000, -954727200000, -927165600000, -898138800000, -857257200000, -844556400000, -828226800000, -812502000000, -800157600000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 641944800000, 654652800000, 670377600000, 686102400000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 846363600000, 859680000000, 877824000000, 891129600000, 909273600000, 922579200000, 941328000000, 954028800000, 972777600000, 985478400000, 1004227200000, 1017532800000, 1035676800000, 1048982400000, 1067126400000, 1080432000000, 1099180800000, 1111881600000, 1130630400000, 1143331200000, 1162080000000, 1174780800000, 1193529600000, 1206835200000, 1224979200000, 1238284800000, 1256428800000, 1269734400000, 1288483200000, 1301184000000, 1319932800000, 1332633600000, 1351382400000, 1364688000000, 1382832000000, 1396137600000, 1414281600000, 1427587200000, 1445731200000, 1459036800000, 1477785600000, 1490486400000, 1509235200000, 1521936000000, 1540684800000, 1553990400000, 1572134400000, 1585440000000, 1603584000000, 1616889600000, 1635638400000, 1648339200000, 1667088000000, 1679788800000, 1698537600000, 1711843200000, 1729987200000, 1743292800000, 1761436800000, 1774742400000, 1792886400000, 1806192000000, 1824940800000, 1837641600000, 1856390400000, 1869091200000, 1887840000000, 1901145600000, 1919289600000, 1932595200000, 1950739200000, 1964044800000, 1982793600000, 1995494400000, 2014243200000, 2026944000000, 2045692800000, 2058393600000, 2077142400000, 2090448000000, 2108592000000, 2121897600000, 2140041600000, null],
        "offsets": [-115, -104.4, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -60, -120, -60, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Copenhagen": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1692496800000, -1680490800000, -935110800000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -769388400000, -747010800000, -736383600000, -715215600000, -706748400000, -683161200000, -675298800000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Dublin": {
        "abbrs": ["DMT", "IST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT", "IST", "GMT"],
        "untils": [-1691962479000, -1680471279000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -733356000000, -719445600000, -699487200000, -684972000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [25.35, -34.65, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Gibraltar": {
        "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Guernsey": {
        "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT"],
        "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Helsinki": {
        "abbrs": ["HMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1535938789000, -875671200000, -859773600000, 354672000000, 370396800000, 386121600000, 401846400000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-99.8167, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Isle_of_Man": {
        "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT"],
        "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Istanbul": {
        "abbrs": ["IMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "+03"],
        "untils": [-1869875816000, -1693706400000, -1680490800000, -1570413600000, -1552186800000, -1538359200000, -1522551600000, -1507514400000, -1490583600000, -1440208800000, -1428030000000, -1409709600000, -1396494000000, -931140000000, -922762800000, -917834400000, -892436400000, -875844000000, -857358000000, -781063200000, -764737200000, -744343200000, -733806000000, -716436000000, -701924400000, -684986400000, -670474800000, -654141600000, -639025200000, -621828000000, -606970800000, -590032800000, -575434800000, -235620000000, -228279600000, -177732000000, -165726000000, 10533600000, 23835600000, 41983200000, 55285200000, 74037600000, 87339600000, 107910000000, 121219200000, 133920000000, 152676000000, 165362400000, 183502800000, 202428000000, 215557200000, 228866400000, 245797200000, 260316000000, 277246800000, 308779200000, 323827200000, 340228800000, 354672000000, 371678400000, 386121600000, 403128000000, 428446800000, 433886400000, 482792400000, 496702800000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 686098800000, 701823600000, 717548400000, 733273200000, 748998000000, 764118000000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301274000000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396227600000, 1414285200000, 1427590800000, 1446944400000, 1459040400000, 1473195600000, null],
        "offsets": [-116.9333, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -180],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Jersey": {
        "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT"],
        "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Kaliningrad": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CET", "CEST", "CET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "+03", "EET"],
        "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -788922000000, -778730400000, -762663600000, -757389600000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622598400000, 638323200000, 654652800000, 670377600000, 686102400000, 701827200000, 717552000000, 733276800000, 749001600000, 764726400000, 780451200000, 796176000000, 811900800000, 828230400000, 846374400000, 859680000000, 877824000000, 891129600000, 909273600000, 922579200000, 941328000000, 954028800000, 972777600000, 985478400000, 1004227200000, 1017532800000, 1035676800000, 1048982400000, 1067126400000, 1080432000000, 1099180800000, 1111881600000, 1130630400000, 1143331200000, 1162080000000, 1174780800000, 1193529600000, 1206835200000, 1224979200000, 1238284800000, 1256428800000, 1269734400000, 1288483200000, 1301184000000, 1414278000000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Kiev": {
        "abbrs": ["KMT", "EET", "MSK", "CEST", "CET", "CEST", "CET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1441159324000, -1247536800000, -892522800000, -857257200000, -844556400000, -828226800000, -825382800000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 646783200000, 686102400000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-122.0667, -120, -180, -120, -60, -120, -60, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Kirov": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03"],
        "untils": [-1593820800000, -1247540400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622594800000, 638319600000, 654649200000, 670374000000, 701820000000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174777200000, 1193526000000, 1206831600000, 1224975600000, 1238281200000, 1256425200000, 1269730800000, 1288479600000, 1301180400000, 1414274400000, null],
        "offsets": [-198.8, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -240, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Lisbon": {
        "abbrs": ["LMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "CET", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
        "untils": [-1830384000000, -1689555600000, -1677801600000, -1667437200000, -1647738000000, -1635814800000, -1616202000000, -1604365200000, -1584666000000, -1572742800000, -1553043600000, -1541206800000, -1521507600000, -1442451600000, -1426813200000, -1379293200000, -1364778000000, -1348448400000, -1333328400000, -1316394000000, -1301274000000, -1284339600000, -1269824400000, -1221440400000, -1206925200000, -1191200400000, -1175475600000, -1127696400000, -1111971600000, -1096851600000, -1080522000000, -1063587600000, -1049072400000, -1033347600000, -1017622800000, -1002502800000, -986173200000, -969238800000, -950490000000, -942022800000, -922669200000, -906944400000, -891133200000, -877309200000, -873684000000, -864007200000, -857955600000, -845859600000, -842839200000, -831348000000, -825901200000, -814410000000, -810784800000, -799898400000, -794451600000, -782960400000, -779335200000, -768448800000, -763002000000, -749091600000, -733366800000, -717631200000, -701906400000, -686181600000, -670456800000, -654732000000, -639007200000, -591832800000, -575503200000, -559778400000, -544053600000, -528328800000, -512604000000, -496879200000, -481154400000, -465429600000, -449704800000, -433980000000, -417650400000, -401925600000, -386200800000, -370476000000, -354751200000, -339026400000, -323301600000, -307576800000, -291852000000, -276127200000, -260402400000, -244677600000, -228348000000, -212623200000, -196898400000, -181173600000, -165448800000, -149724000000, -133999200000, -118274400000, 212544000000, 228268800000, 243993600000, 260323200000, 276048000000, 291772800000, 307501200000, 323222400000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417578400000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [36.75, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, 0, -60, -120, -60, 0, -60, -120, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, -120, -60, -120, -60, -120, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Ljubljana": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-905824800000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -777942000000, -766623600000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "London": {
        "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT"],
        "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Luxembourg": {
        "abbrs": ["LMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WEST", "WET", "WEST", "WET", "WEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-2069713476000, -1692496800000, -1680483600000, -1662343200000, -1650157200000, -1632006000000, -1618700400000, -1612659600000, -1604278800000, -1585519200000, -1574038800000, -1552258800000, -1539997200000, -1520550000000, -1507510800000, -1490572800000, -1473642000000, -1459119600000, -1444006800000, -1427673600000, -1411866000000, -1396224000000, -1379293200000, -1364774400000, -1348448400000, -1333324800000, -1316394000000, -1301270400000, -1284339600000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1191189600000, -1175464800000, -1160344800000, -1143410400000, -1127685600000, -1111960800000, -1096840800000, -1080511200000, -1063576800000, -1049061600000, -1033336800000, -1017612000000, -1002492000000, -986162400000, -969228000000, -950479200000, -942012000000, -935186400000, -857257200000, -844556400000, -828226800000, -812502000000, -797986800000, -781052400000, -766623600000, -745455600000, -733273200000, 228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-24.6, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Madrid": {
        "abbrs": ["WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1631926800000, -1616889600000, -1601168400000, -1585353600000, -1442451600000, -1427673600000, -1379293200000, -1364774400000, -1348448400000, -1333324800000, -1316390400000, -1301270400000, -1284339600000, -1269820800000, -1026954000000, -1017619200000, -1001898000000, -999482400000, -986090400000, -954115200000, -940208400000, -873079200000, -862621200000, -842839200000, -828320400000, -811389600000, -796870800000, -779940000000, -765421200000, -748490400000, -733971600000, -652327200000, -639018000000, 135122400000, 150246000000, 166572000000, 181695600000, 196812000000, 212540400000, 228866400000, 243990000000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Malta": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1690765200000, -1680487200000, -1664758800000, -1648951200000, -1635123600000, -1616896800000, -1604278800000, -1585533600000, -1571014800000, -1555293600000, -932432400000, -857257200000, -844556400000, -828226800000, -812588400000, -798073200000, -781052400000, -766717200000, -750898800000, -733359600000, -719456400000, -701917200000, -689209200000, -670460400000, -114051600000, -103168800000, -81997200000, -71715600000, -50547600000, -40266000000, -18493200000, -8211600000, 12956400000, 23238000000, 43801200000, 54687600000, 75855600000, 86742000000, 102380400000, 118105200000, 135730800000, 148518000000, 167187600000, 180489600000, 198637200000, 211939200000, 230086800000, 243388800000, 261536400000, 274838400000, 292986000000, 306288000000, 323312400000, 338342400000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Mariehamn": {
        "abbrs": ["HMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1535938789000, -875671200000, -859773600000, 354672000000, 370396800000, 386121600000, 401846400000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-99.8167, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Minsk": {
        "abbrs": ["MMT", "EET", "MSK", "CEST", "CET", "CEST", "CET", "CEST", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "+03"],
        "untils": [-1441158600000, -1247536800000, -899780400000, -857257200000, -844556400000, -828226800000, -812502000000, -804650400000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 670374000000, 686102400000, 701827200000, 717552000000, 733276800000, 749001600000, 764726400000, 780451200000, 796176000000, 811900800000, 828230400000, 846374400000, 859680000000, 877824000000, 891129600000, 909273600000, 922579200000, 941328000000, 954028800000, 972777600000, 985478400000, 1004227200000, 1017532800000, 1035676800000, 1048982400000, 1067126400000, 1080432000000, 1099180800000, 1111881600000, 1130630400000, 1143331200000, 1162080000000, 1174780800000, 1193529600000, 1206835200000, 1224979200000, 1238284800000, 1256428800000, 1269734400000, 1288483200000, 1301184000000, null],
        "offsets": [-110, -120, -180, -120, -60, -120, -60, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "Monaco": {
        "abbrs": ["PMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WEMT", "WEST", "WEMT", "WEST", "WEMT", "WEST", "WEMT", "WEST", "WEMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1855958961000, -1689814800000, -1680397200000, -1665363600000, -1648342800000, -1635123600000, -1616893200000, -1604278800000, -1585443600000, -1574038800000, -1552266000000, -1539997200000, -1520557200000, -1507510800000, -1490576400000, -1470618000000, -1459126800000, -1444006800000, -1427677200000, -1411952400000, -1396227600000, -1379293200000, -1364778000000, -1348448400000, -1333328400000, -1316394000000, -1301274000000, -1284339600000, -1269824400000, -1253494800000, -1238374800000, -1221440400000, -1206925200000, -1191200400000, -1175475600000, -1160355600000, -1143421200000, -1127696400000, -1111971600000, -1096851600000, -1080522000000, -1063587600000, -1049072400000, -1033347600000, -1017622800000, -1002502800000, -986173200000, -969238800000, -950490000000, -942012000000, -904438800000, -891136800000, -877827600000, -857257200000, -844556400000, -828226800000, -812502000000, -796266000000, -781052400000, -766623600000, 196819200000, 212540400000, 228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-9.35, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Moscow": {
        "abbrs": ["MMT", "MMT", "MST", "MMT", "MDST", "MST", "MDST", "MSD", "MSK", "MSD", "+05", "MSD", "MSK", "EET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSK", "MSK"],
        "untils": [-1688265017000, -1656819079000, -1641353479000, -1627965079000, -1618716679000, -1596429079000, -1593820800000, -1589860800000, -1542427200000, -1539493200000, -1525323600000, -1522728000000, -1491188400000, -1247536800000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 686102400000, 695779200000, 701823600000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174777200000, 1193526000000, 1206831600000, 1224975600000, 1238281200000, 1256425200000, 1269730800000, 1288479600000, 1301180400000, 1414274400000, null],
        "offsets": [-150.2833, -151.3167, -211.3167, -151.3167, -271.3167, -211.3167, -271.3167, -240, -180, -240, -300, -240, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180],
        "isdsts": [0, 0, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Nicosia": {
        "abbrs": ["LMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1518920008000, 166572000000, 182293200000, 200959200000, 213829200000, 228866400000, 243982800000, 260316000000, 276123600000, 291765600000, 307486800000, 323820000000, 338936400000, 354664800000, 370386000000, 386114400000, 401835600000, 417564000000, 433285200000, 449013600000, 465339600000, 481068000000, 496789200000, 512517600000, 528238800000, 543967200000, 559688400000, 575416800000, 591138000000, 606866400000, 622587600000, 638316000000, 654642000000, 670370400000, 686091600000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 843944400000, 859672800000, 875394000000, 891122400000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-133.4667, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Oslo": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1691884800000, -1680573600000, -927511200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -765327600000, -340844400000, -324514800000, -308790000000, -293065200000, -277340400000, -261615600000, -245890800000, -230166000000, -214441200000, -198716400000, -182991600000, -166662000000, -147913200000, -135212400000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Paris": {
        "abbrs": ["PMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "CEST", "CET", "CEST", "CET", "CEST", "WEMT", "WEST", "WEMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1855958901000, -1689814800000, -1680397200000, -1665363600000, -1648342800000, -1635123600000, -1616893200000, -1604278800000, -1585443600000, -1574038800000, -1552266000000, -1539997200000, -1520557200000, -1507510800000, -1490576400000, -1470618000000, -1459126800000, -1444006800000, -1427677200000, -1411952400000, -1396227600000, -1379293200000, -1364778000000, -1348448400000, -1333328400000, -1316394000000, -1301274000000, -1284339600000, -1269824400000, -1253494800000, -1238374800000, -1221440400000, -1206925200000, -1191200400000, -1175475600000, -1160355600000, -1143421200000, -1127696400000, -1111971600000, -1096851600000, -1080522000000, -1063587600000, -1049072400000, -1033347600000, -1017622800000, -1002502800000, -986173200000, -969238800000, -950490000000, -942012000000, -932436000000, -857257200000, -844556400000, -828226800000, -812502000000, -800071200000, -796266000000, -781052400000, -766623600000, 196819200000, 212540400000, 228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-9.35, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Podgorica": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-905824800000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -777942000000, -766623600000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Prague": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "GMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -765327600000, -746578800000, -733359600000, -728517600000, -721260000000, -716425200000, -701910000000, -684975600000, -670460400000, -654217200000, -639010800000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Riga": {
        "abbrs": ["RMT", "LST", "RMT", "LST", "RMT", "EET", "MSK", "CEST", "CET", "CEST", "CET", "CEST", "CET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1632008194000, -1618702594000, -1601681794000, -1597275394000, -1377308194000, -928029600000, -899521200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -795834000000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622598400000, 638323200000, 654652800000, 670377600000, 686102400000, 701827200000, 717552000000, 733276800000, 749001600000, 764726400000, 780451200000, 796176000000, 811900800000, 828230400000, 843955200000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-96.5667, -156.5667, -96.5667, -156.5667, -96.5667, -120, -180, -120, -60, -120, -60, -120, -60, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Rome": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1690765200000, -1680487200000, -1664758800000, -1648951200000, -1635123600000, -1616896800000, -1604278800000, -1585533600000, -1571014800000, -1555293600000, -932432400000, -857257200000, -844556400000, -828226800000, -812502000000, -798073200000, -781052400000, -766717200000, -750898800000, -733359600000, -719456400000, -701917200000, -689209200000, -670460400000, -114051600000, -103168800000, -81997200000, -71715600000, -50547600000, -40266000000, -18493200000, -8211600000, 12956400000, 23238000000, 43801200000, 54687600000, 75855600000, 86742000000, 107910000000, 118191600000, 138754800000, 149641200000, 170809200000, 181090800000, 202258800000, 212540400000, 233103600000, 243990000000, 265158000000, 276044400000, 296607600000, 307494000000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Samara": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+03", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04"],
        "untils": [-1593820800000, -1247540400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622594800000, 638319600000, 654649200000, 670374000000, 686102400000, 687916800000, 701820000000, 717544800000, 733269600000, 748994400000, 764719200000, 780444000000, 796168800000, 811893600000, 828223200000, 846367200000, 859672800000, 877816800000, 891122400000, 909266400000, 922572000000, 941320800000, 954021600000, 972770400000, 985471200000, 1004220000000, 1017525600000, 1035669600000, 1048975200000, 1067119200000, 1080424800000, 1099173600000, 1111874400000, 1130623200000, 1143324000000, 1162072800000, 1174773600000, 1193522400000, 1206828000000, 1224972000000, 1238277600000, 1256421600000, 1269727200000, 1288479600000, 1301180400000, null],
        "offsets": [-200.3333, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -180, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
      },
      "San_Marino": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1690765200000, -1680487200000, -1664758800000, -1648951200000, -1635123600000, -1616896800000, -1604278800000, -1585533600000, -1571014800000, -1555293600000, -932432400000, -857257200000, -844556400000, -828226800000, -812502000000, -798073200000, -781052400000, -766717200000, -750898800000, -733359600000, -719456400000, -701917200000, -689209200000, -670460400000, -114051600000, -103168800000, -81997200000, -71715600000, -50547600000, -40266000000, -18493200000, -8211600000, 12956400000, 23238000000, 43801200000, 54687600000, 75855600000, 86742000000, 107910000000, 118191600000, 138754800000, 149641200000, 170809200000, 181090800000, 202258800000, 212540400000, 233103600000, 243990000000, 265158000000, 276044400000, 296607600000, 307494000000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Sarajevo": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-905824800000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -777942000000, -766623600000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Saratov": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04"],
        "untils": [-1593820800000, -1247540400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 701820000000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174777200000, 1193526000000, 1206831600000, 1224975600000, 1238281200000, 1256425200000, 1269730800000, 1288479600000, 1301180400000, 1414274400000, 1480806000000, null],
        "offsets": [-184.3, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -240, -180, -240, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Simferopol": {
        "abbrs": ["SMT", "EET", "MSK", "CEST", "CET", "CEST", "CET", "CEST", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EET", "EEST", "EET", "EEST", "EET", "EEST", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "MSK", "MSK"],
        "untils": [-1441160160000, -1247536800000, -888894000000, -857257200000, -844556400000, -828226800000, -812502000000, -811648800000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 646786800000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 767739600000, 780436800000, 796165200000, 811886400000, 828219600000, 846374400000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396137600000, 1414274400000, null],
        "offsets": [-136, -120, -180, -120, -60, -120, -60, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -120, -180, -120, -180, -120, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -240, -180],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
      },
      "Skopje": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-905824800000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -777942000000, -766623600000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Sofia": {
        "abbrs": ["EET", "CET", "CEST", "CET", "CEST", "CET", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781048800000, 291762000000, 307576800000, 323816400000, 339026400000, 355266000000, 370393200000, 386715600000, 401846400000, 417571200000, 433296000000, 449020800000, 465350400000, 481075200000, 496800000000, 512524800000, 528249600000, 543974400000, 559699200000, 575424000000, 591148800000, 606873600000, 622598400000, 638323200000, 654652800000, 670370400000, 686091600000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 846363600000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-120, -60, -120, -60, -120, -60, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Stockholm": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1692496800000, -1680483600000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tallinn": {
        "abbrs": ["TMT", "CET", "CEST", "CET", "TMT", "EET", "MSK", "CEST", "CET", "CEST", "CET", "CEST", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1638322740000, -1632006000000, -1618700400000, -1593824400000, -1535938740000, -927943200000, -892954800000, -857257200000, -844556400000, -828226800000, -812502000000, -797652000000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622598400000, 638323200000, 654652800000, 670377600000, 686102400000, 701827200000, 717552000000, 733276800000, 749001600000, 764726400000, 780451200000, 796176000000, 811900800000, 828230400000, 846374400000, 859680000000, 877824000000, 891129600000, 909277200000, 922582800000, 941331600000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-99, -60, -120, -60, -99, -120, -180, -120, -60, -120, -60, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tirane": {
        "abbrs": ["LMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1767230360000, -932346000000, -857257200000, -844556400000, -843519600000, 136854000000, 149896800000, 168130800000, 181432800000, 199839600000, 213141600000, 231894000000, 244591200000, 263257200000, 276040800000, 294706800000, 307490400000, 326156400000, 339458400000, 357087600000, 370389600000, 389142000000, 402444000000, 419468400000, 433807200000, 449622000000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-79.3333, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Tiraspol": {
        "abbrs": ["CMT", "BMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "CEST", "CET", "CEST", "CET", "CEST", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1637114100000, -1213148664000, -1187056800000, -1175479200000, -1159754400000, -1144029600000, -1127700000000, -1111975200000, -1096250400000, -1080525600000, -1064800800000, -1049076000000, -1033351200000, -1017626400000, -1001901600000, -986176800000, -970452000000, -954727200000, -927165600000, -898138800000, -857257200000, -844556400000, -828226800000, -812502000000, -800157600000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 641944800000, 654652800000, 670377600000, 686102400000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796168800000, 811890000000, 828223200000, 846363600000, 859680000000, 877824000000, 891129600000, 909273600000, 922579200000, 941328000000, 954028800000, 972777600000, 985478400000, 1004227200000, 1017532800000, 1035676800000, 1048982400000, 1067126400000, 1080432000000, 1099180800000, 1111881600000, 1130630400000, 1143331200000, 1162080000000, 1174780800000, 1193529600000, 1206835200000, 1224979200000, 1238284800000, 1256428800000, 1269734400000, 1288483200000, 1301184000000, 1319932800000, 1332633600000, 1351382400000, 1364688000000, 1382832000000, 1396137600000, 1414281600000, 1427587200000, 1445731200000, 1459036800000, 1477785600000, 1490486400000, 1509235200000, 1521936000000, 1540684800000, 1553990400000, 1572134400000, 1585440000000, 1603584000000, 1616889600000, 1635638400000, 1648339200000, 1667088000000, 1679788800000, 1698537600000, 1711843200000, 1729987200000, 1743292800000, 1761436800000, 1774742400000, 1792886400000, 1806192000000, 1824940800000, 1837641600000, 1856390400000, 1869091200000, 1887840000000, 1901145600000, 1919289600000, 1932595200000, 1950739200000, 1964044800000, 1982793600000, 1995494400000, 2014243200000, 2026944000000, 2045692800000, 2058393600000, 2077142400000, 2090448000000, 2108592000000, 2121897600000, 2140041600000, null],
        "offsets": [-115, -104.4, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -60, -120, -60, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Ulyanovsk": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+03", "+02", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04"],
        "untils": [-1593820800000, -1247540400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591141600000, 606866400000, 622594800000, 638319600000, 654649200000, 670374000000, 686102400000, 695779200000, 701823600000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174777200000, 1193526000000, 1206831600000, 1224975600000, 1238281200000, 1256425200000, 1269730800000, 1288479600000, 1301180400000, 1414274400000, 1459033200000, null],
        "offsets": [-193.6, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Uzhgorod": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "CET", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -794714400000, -773456400000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 646786800000, 670384800000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -60, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Vaduz": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-904435200000, -891129600000, -872985600000, -859680000000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Vatican": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1690765200000, -1680487200000, -1664758800000, -1648951200000, -1635123600000, -1616896800000, -1604278800000, -1585533600000, -1571014800000, -1555293600000, -932432400000, -857257200000, -844556400000, -828226800000, -812502000000, -798073200000, -781052400000, -766717200000, -750898800000, -733359600000, -719456400000, -701917200000, -689209200000, -670460400000, -114051600000, -103168800000, -81997200000, -71715600000, -50547600000, -40266000000, -18493200000, -8211600000, 12956400000, 23238000000, 43801200000, 54687600000, 75855600000, 86742000000, 107910000000, 118191600000, 138754800000, 149641200000, 170809200000, 181090800000, 202258800000, 212540400000, 233103600000, 243990000000, 265158000000, 276044400000, 296607600000, 307494000000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Vienna": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -1569711600000, -1555801200000, -938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -780188400000, -748479600000, -733359600000, -717634800000, -701910000000, -684975600000, -670460400000, 323823600000, 338940000000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Vilnius": {
        "abbrs": ["WMT", "KMT", "CET", "EET", "CET", "MSK", "CEST", "CET", "CEST", "CET", "CEST", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "CEST", "CET", "CEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1672536240000, -1585100136000, -1561251600000, -1553565600000, -928198800000, -900126000000, -857257200000, -844556400000, -828226800000, -812502000000, -802144800000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622598400000, 638323200000, 654652800000, 670377600000, 686102400000, 701827200000, 717552000000, 733276800000, 749001600000, 764726400000, 780451200000, 796176000000, 811900800000, 828230400000, 846374400000, 859680000000, 877824000000, 891133200000, 909277200000, 922582800000, 941331600000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-84, -95.6, -60, -120, -60, -180, -120, -60, -120, -60, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -120, -60, -120, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Volgograd": {
        "abbrs": ["LMT", "+03", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+05", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04"],
        "untils": [-1577761060000, -1247540400000, 354916800000, 370724400000, 386452800000, 402260400000, 417988800000, 433796400000, 449611200000, 465343200000, 481068000000, 496792800000, 512517600000, 528242400000, 543967200000, 559692000000, 575416800000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 701820000000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174777200000, 1193526000000, 1206831600000, 1224975600000, 1238281200000, 1256425200000, 1269730800000, 1288479600000, 1301180400000, 1414274400000, 1540681200000, null],
        "offsets": [-177.6667, -180, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -300, -240, -240, -180, -240, -180, -240, -180, -240, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0]
      },
      "Warsaw": {
        "abbrs": ["WMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "EET", "EEST", "EET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-1717032240000, -1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -1600473600000, -1587168000000, -1501725600000, -931734000000, -857257200000, -844556400000, -828226800000, -812502000000, -796608000000, -778726800000, -762660000000, -748486800000, -733273200000, -715215600000, -701910000000, -684975600000, -670460400000, -654130800000, -639010800000, -397094400000, -386812800000, -371088000000, -355363200000, -334195200000, -323308800000, -307584000000, -291859200000, -271296000000, -260409600000, -239846400000, -228960000000, -208396800000, -197510400000, -176342400000, -166060800000, 228873600000, 243993600000, 260323200000, 276048000000, 291772800000, 307497600000, 323827200000, 338947200000, 354672000000, 370396800000, 386121600000, 401846400000, 417571200000, 433296000000, 449020800000, 465350400000, 481075200000, 496800000000, 512524800000, 528249600000, 543974400000, 559699200000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-84, -60, -120, -60, -120, -60, -120, -120, -180, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Zagreb": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-905824800000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -777942000000, -766623600000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Zaporozhye": {
        "abbrs": ["+0220", "EET", "MSK", "CEST", "CET", "CEST", "CET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET"],
        "untils": [-1441160400000, -1247536800000, -894769200000, -857257200000, -844556400000, -828226800000, -826419600000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 686091600000, 701820000000, 717541200000, 733269600000, 748990800000, 764719200000, 780440400000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-140, -120, -180, -120, -60, -120, -60, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
        "isdsts": [0, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Zurich": {
        "abbrs": ["CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
        "untils": [-904435200000, -891129600000, -872985600000, -859680000000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
        "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "GB-Eire": {
      "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT"],
      "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "GB": {
      "abbrs": ["GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "BDST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT", "BST", "GMT"],
      "untils": [-1691964000000, -1680472800000, -1664143200000, -1650146400000, -1633903200000, -1617487200000, -1601848800000, -1586037600000, -1570399200000, -1552168800000, -1538344800000, -1522533600000, -1507500000000, -1490565600000, -1473631200000, -1460930400000, -1442786400000, -1428876000000, -1410732000000, -1396216800000, -1379282400000, -1364767200000, -1348437600000, -1333317600000, -1315778400000, -1301263200000, -1284328800000, -1269813600000, -1253484000000, -1238364000000, -1221429600000, -1206914400000, -1189980000000, -1175464800000, -1159135200000, -1143410400000, -1126476000000, -1111960800000, -1095631200000, -1080511200000, -1063576800000, -1049061600000, -1032127200000, -1017612000000, -1001282400000, -986162400000, -969228000000, -950479200000, -942012000000, -904518000000, -896050800000, -875487600000, -864601200000, -844038000000, -832546800000, -812588400000, -798073200000, -781052400000, -772066800000, -764805600000, -748476000000, -733356000000, -719445600000, -717030000000, -706748400000, -699487200000, -687996000000, -668037600000, -654732000000, -636588000000, -622072800000, -605743200000, -590623200000, -574293600000, -558568800000, -542239200000, -527119200000, -512604000000, -496274400000, -481154400000, -464220000000, -449704800000, -432165600000, -417650400000, -401320800000, -386200800000, -369266400000, -354751200000, -337816800000, -323301600000, -306972000000, -291852000000, -276732000000, -257983200000, -245282400000, -226533600000, -213228000000, -195084000000, -182383200000, -163634400000, -150933600000, -132184800000, -119484000000, -100735200000, -88034400000, -68680800000, -59004000000, -37242000000, 57722400000, 69818400000, 89172000000, 101268000000, 120621600000, 132717600000, 152071200000, 164167200000, 183520800000, 196221600000, 214970400000, 227671200000, 246420000000, 259120800000, 278474400000, 290570400000, 309924000000, 322020000000, 341373600000, 354675600000, 372819600000, 386125200000, 404269200000, 417574800000, 435718800000, 449024400000, 467773200000, 481078800000, 499222800000, 512528400000, 530672400000, 543978000000, 562122000000, 575427600000, 593571600000, 606877200000, 625626000000, 638326800000, 657075600000, 670381200000, 688525200000, 701830800000, 719974800000, 733280400000, 751424400000, 764730000000, 782874000000, 796179600000, 814323600000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, 0, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "GMT+0": {
      "abbrs": ["GMT"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "GMT-0": {
      "abbrs": ["GMT"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "GMT": {
      "abbrs": ["GMT"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "GMT0": {
      "abbrs": ["GMT"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "Greenwich": {
      "abbrs": ["GMT"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "HST": {
      "abbrs": ["HST"],
      "untils": [null],
      "offsets": [600],
      "isdsts": [0]
    },
    "Hongkong": {
      "abbrs": ["LMT", "HKT", "HKST", "HKT", "JST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT", "HKST", "HKT"],
      "untils": [-2056693002000, -907389000000, -891667800000, -884246400000, -766746000000, -747981000000, -728544600000, -717049800000, -694503000000, -683785800000, -668064600000, -654755400000, -636615000000, -623305800000, -605165400000, -591856200000, -573715800000, -559801800000, -542352600000, -528352200000, -510211800000, -498112200000, -478762200000, -466662600000, -446707800000, -435213000000, -415258200000, -403158600000, -383808600000, -371709000000, -352359000000, -340259400000, -320909400000, -308809800000, -288855000000, -277360200000, -257405400000, -245910600000, -225955800000, -213856200000, -194506200000, -182406600000, -163056600000, -148537800000, -132816600000, -117088200000, -101367000000, -85638600000, -69312600000, -53584200000, -37863000000, -22134600000, -6413400000, 9315000000, 25036200000, 40764600000, 56485800000, 72214200000, 88540200000, 104268600000, 119989800000, 126041400000, 151439400000, 167167800000, 182889000000, 198617400000, 214338600000, 295385400000, 309292200000, null],
      "offsets": [-456.7, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
      "isdsts": [0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Iceland": {
      "abbrs": ["LMT", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "+00", "-01", "GMT"],
      "untils": [-1956609120000, -1668211200000, -1647212400000, -1636675200000, -1613430000000, -1605139200000, -1581894000000, -1539561600000, -1531350000000, -968025600000, -952293600000, -942008400000, -920239200000, -909957600000, -888789600000, -877903200000, -857944800000, -846453600000, -826495200000, -815004000000, -795045600000, -783554400000, -762991200000, -752104800000, -731541600000, -717631200000, -700092000000, -686181600000, -668642400000, -654732000000, -636588000000, -623282400000, -605743200000, -591832800000, -573688800000, -559778400000, -542239200000, -528328800000, -510789600000, -496879200000, -479340000000, -465429600000, -447890400000, -433980000000, -415836000000, -401925600000, -384386400000, -370476000000, -352936800000, -339026400000, -321487200000, -307576800000, -290037600000, -276127200000, -258588000000, -244677600000, -226533600000, -212623200000, -195084000000, -181173600000, -163634400000, -149724000000, -132184800000, -118274400000, -100735200000, -86824800000, -68680800000, -54770400000, null],
      "offsets": [88, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0, 60, 0],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0]
    },
    "Indian": {
      "Antananarivo": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Chagos": {
        "abbrs": ["LMT", "+05", "+06"],
        "untils": [-1988167780000, 820436400000, null],
        "offsets": [-289.6667, -300, -360],
        "isdsts": [0, 0, 0]
      },
      "Christmas": {
        "abbrs": ["+07"],
        "untils": [null],
        "offsets": [-420],
        "isdsts": [0]
      },
      "Cocos": {
        "abbrs": ["+0630"],
        "untils": [null],
        "offsets": [-390],
        "isdsts": [0]
      },
      "Comoro": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Kerguelen": {
        "abbrs": ["-00", "+05"],
        "untils": [-631152000000, null],
        "offsets": [0, -300],
        "isdsts": [0, 0]
      },
      "Mahe": {
        "abbrs": ["LMT", "+04"],
        "untils": [-2006653308000, null],
        "offsets": [-221.8, -240],
        "isdsts": [0, 0]
      },
      "Maldives": {
        "abbrs": ["MMT", "+05"],
        "untils": [-315636840000, null],
        "offsets": [-294, -300],
        "isdsts": [0, 0]
      },
      "Mauritius": {
        "abbrs": ["LMT", "+04", "+05", "+04", "+05", "+04"],
        "untils": [-1988164200000, 403041600000, 417034800000, 1224972000000, 1238274000000, null],
        "offsets": [-230, -240, -300, -240, -300, -240],
        "isdsts": [0, 0, 1, 0, 1, 0]
      },
      "Mayotte": {
        "abbrs": ["LMT", "EAT", "+0230", "+0245", "EAT"],
        "untils": [-1309746436000, -1262314800000, -946780200000, -315629100000, null],
        "offsets": [-147.2667, -180, -150, -165, -180],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Reunion": {
        "abbrs": ["LMT", "+04"],
        "untils": [-1848886912000, null],
        "offsets": [-221.8667, -240],
        "isdsts": [0, 0]
      }
    },
    "Iran": {
      "abbrs": ["LMT", "TMT", "+0330", "+04", "+05", "+04", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330", "+0430", "+0330"],
      "untils": [-1704165944000, -757394744000, 247177800000, 259272000000, 277758000000, 283982400000, 290809800000, 306531000000, 322432200000, 338499000000, 673216200000, 685481400000, 701209800000, 717103800000, 732745800000, 748639800000, 764281800000, 780175800000, 795817800000, 811711800000, 827353800000, 843247800000, 858976200000, 874870200000, 890512200000, 906406200000, 922048200000, 937942200000, 953584200000, 969478200000, 985206600000, 1001100600000, 1016742600000, 1032636600000, 1048278600000, 1064172600000, 1079814600000, 1095708600000, 1111437000000, 1127331000000, 1206045000000, 1221939000000, 1237667400000, 1253561400000, 1269203400000, 1285097400000, 1300739400000, 1316633400000, 1332275400000, 1348169400000, 1363897800000, 1379791800000, 1395433800000, 1411327800000, 1426969800000, 1442863800000, 1458505800000, 1474399800000, 1490128200000, 1506022200000, 1521664200000, 1537558200000, 1553200200000, 1569094200000, 1584736200000, 1600630200000, 1616358600000, 1632252600000, 1647894600000, 1663788600000, 1679430600000, 1695324600000, 1710966600000, 1726860600000, 1742589000000, 1758483000000, 1774125000000, 1790019000000, 1805661000000, 1821555000000, 1837197000000, 1853091000000, 1868733000000, 1884627000000, 1900355400000, 1916249400000, 1931891400000, 1947785400000, 1963427400000, 1979321400000, 1994963400000, 2010857400000, 2026585800000, 2042479800000, 2058121800000, 2074015800000, 2089657800000, 2105551800000, 2121193800000, 2137087800000, null],
      "offsets": [-205.7333, -205.7333, -210, -240, -300, -240, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210, -270, -210],
      "isdsts": [0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Israel": {
      "abbrs": ["JMT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDDT", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST", "IDT", "IST"],
      "untils": [-1641003640000, -933645600000, -857358000000, -844300800000, -825822000000, -812685600000, -794199600000, -779853600000, -762656400000, -748310400000, -731127600000, -681962400000, -673243200000, -667962000000, -652327200000, -636426000000, -622087200000, -608947200000, -591847200000, -572486400000, -558576000000, -542851200000, -527731200000, -514425600000, -490845600000, -482986800000, -459475200000, -451537200000, -428551200000, -418262400000, -400032000000, -387428400000, 142380000000, 150843600000, 167176800000, 178664400000, 482277600000, 495579600000, 516751200000, 526424400000, 545436000000, 558478800000, 576626400000, 589323600000, 609890400000, 620773200000, 638316000000, 651618000000, 669765600000, 683672400000, 701820000000, 715726800000, 733701600000, 747176400000, 765151200000, 778021200000, 796600800000, 810075600000, 826840800000, 842821200000, 858895200000, 874184400000, 890344800000, 905029200000, 923011200000, 936313200000, 955670400000, 970783200000, 986770800000, 1001282400000, 1017356400000, 1033941600000, 1048806000000, 1065132000000, 1081292400000, 1095804000000, 1112313600000, 1128812400000, 1143763200000, 1159657200000, 1175212800000, 1189897200000, 1206662400000, 1223161200000, 1238112000000, 1254006000000, 1269561600000, 1284246000000, 1301616000000, 1317510000000, 1333065600000, 1348354800000, 1364515200000, 1382828400000, 1395964800000, 1414278000000, 1427414400000, 1445727600000, 1458864000000, 1477782000000, 1490313600000, 1509231600000, 1521763200000, 1540681200000, 1553817600000, 1572130800000, 1585267200000, 1603580400000, 1616716800000, 1635634800000, 1648166400000, 1667084400000, 1679616000000, 1698534000000, 1711670400000, 1729983600000, 1743120000000, 1761433200000, 1774569600000, 1792882800000, 1806019200000, 1824937200000, 1837468800000, 1856386800000, 1868918400000, 1887836400000, 1900972800000, 1919286000000, 1932422400000, 1950735600000, 1963872000000, 1982790000000, 1995321600000, 2014239600000, 2026771200000, 2045689200000, 2058220800000, 2077138800000, 2090275200000, 2108588400000, 2121724800000, 2140038000000, null],
      "offsets": [-140.6667, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -240, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Jamaica": {
      "abbrs": ["KMT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
      "untils": [-1827687170000, 126687600000, 152085600000, 162370800000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, null],
      "offsets": [307.1667, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Japan": {
      "abbrs": ["JST", "JDT", "JST", "JDT", "JST", "JDT", "JST", "JDT", "JST"],
      "untils": [-683802000000, -672310800000, -654771600000, -640861200000, -620298000000, -609411600000, -588848400000, -577962000000, null],
      "offsets": [-540, -600, -540, -600, -540, -600, -540, -600, -540],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Kwajalein": {
      "abbrs": ["+11", "-12", "+12"],
      "untils": [-7988400000, 745848000000, null],
      "offsets": [-660, 720, -720],
      "isdsts": [0, 0, 0]
    },
    "Libya": {
      "abbrs": ["LMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "EET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "EET", "CET", "CEST", "EET", "CET", "CEST", "EET"],
      "untils": [-1577926364000, -574902000000, -568087200000, -512175600000, -504928800000, -449888400000, -441856800000, -347158800000, 378684000000, 386463600000, 402271200000, 417999600000, 433807200000, 449622000000, 465429600000, 481590000000, 496965600000, 512953200000, 528674400000, 544230000000, 560037600000, 575852400000, 591660000000, 607388400000, 623196000000, 641775600000, 844034400000, 860108400000, 875916000000, 1352505600000, 1364515200000, 1382659200000, null],
      "offsets": [-52.7333, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -120, -60, -120, -120],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0]
    },
    "MET": {
      "abbrs": ["MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET", "MEST", "MET"],
      "untils": [-1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -938905200000, -857257200000, -844556400000, -828226800000, -812502000000, -796777200000, -781052400000, -766623600000, 228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [-60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "MST": {
      "abbrs": ["MST"],
      "untils": [null],
      "offsets": [420],
      "isdsts": [0]
    },
    "MST7MDT": {
      "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
      "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -880210800000, -769395600000, -765388800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
      "offsets": [420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
      "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Mexico": {
      "BajaNorte": {
        "abbrs": ["LMT", "MST", "PST", "MST", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1514736000000, -1451667600000, -1343062800000, -1234803600000, -1222963200000, -1207242000000, -873820800000, -769395600000, -761677200000, -686073600000, -661539600000, -495039600000, -481734000000, -463590000000, -450284400000, -431535600000, -418230000000, -400086000000, -386780400000, -368636400000, -355330800000, -337186800000, -323881200000, -305737200000, -292431600000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1175421600000, 1193562000000, 1207476000000, 1225011600000, 1238925600000, 1256461200000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [468.0667, 420, 480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "BajaSur": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "MST", "PST", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, -873828000000, -661539600000, 28800000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 989139600000, 1001836800000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1175418000000, 1193558400000, 1207472400000, 1225008000000, 1238922000000, 1256457600000, 1270371600000, 1288512000000, 1301821200000, 1319961600000, 1333270800000, 1351411200000, 1365325200000, 1382860800000, 1396774800000, 1414310400000, 1428224400000, 1445760000000, 1459674000000, 1477814400000, 1491123600000, 1509264000000, 1522573200000, 1540713600000, 1554627600000, 1572163200000, 1586077200000, 1603612800000, 1617526800000, 1635667200000, 1648976400000, 1667116800000, 1680426000000, 1698566400000, 1712480400000, 1730016000000, 1743930000000, 1761465600000, 1775379600000, 1792915200000, 1806829200000, 1824969600000, 1838278800000, 1856419200000, 1869728400000, 1887868800000, 1901782800000, 1919318400000, 1933232400000, 1950768000000, 1964682000000, 1982822400000, 1996131600000, 2014272000000, 2027581200000, 2045721600000, 2059030800000, 2077171200000, 2091085200000, 2108620800000, 2122534800000, 2140070400000, null],
        "offsets": [425.6667, 420, 360, 420, 360, 420, 360, 420, 480, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "General": {
        "abbrs": ["LMT", "MST", "CST", "MST", "CST", "MST", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1514739600000, -1343066400000, -1234807200000, -1220292000000, -1207159200000, -1191344400000, -975261600000, -963169200000, -917114400000, -907354800000, -821901600000, -810068400000, -627501600000, -612990000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 989136000000, 1001833200000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1175414400000, 1193554800000, 1207468800000, 1225004400000, 1238918400000, 1256454000000, 1270368000000, 1288508400000, 1301817600000, 1319958000000, 1333267200000, 1351407600000, 1365321600000, 1382857200000, 1396771200000, 1414306800000, 1428220800000, 1445756400000, 1459670400000, 1477810800000, 1491120000000, 1509260400000, 1522569600000, 1540710000000, 1554624000000, 1572159600000, 1586073600000, 1603609200000, 1617523200000, 1635663600000, 1648972800000, 1667113200000, 1680422400000, 1698562800000, 1712476800000, 1730012400000, 1743926400000, 1761462000000, 1775376000000, 1792911600000, 1806825600000, 1824966000000, 1838275200000, 1856415600000, 1869724800000, 1887865200000, 1901779200000, 1919314800000, 1933228800000, 1950764400000, 1964678400000, 1982818800000, 1996128000000, 2014268400000, 2027577600000, 2045718000000, 2059027200000, 2077167600000, 2091081600000, 2108617200000, 2122531200000, 2140066800000, null],
        "offsets": [396.6, 420, 360, 420, 360, 420, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      }
    },
    "NZ-CHAT": {
      "abbrs": ["+1215", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345"],
      "untils": [-757426500000, 152632800000, 162309600000, 183477600000, 194968800000, 215532000000, 226418400000, 246981600000, 257868000000, 278431200000, 289317600000, 309880800000, 320767200000, 341330400000, 352216800000, 372780000000, 384271200000, 404834400000, 415720800000, 436284000000, 447170400000, 467733600000, 478620000000, 499183200000, 510069600000, 530632800000, 541519200000, 562082400000, 573573600000, 594136800000, 605023200000, 623772000000, 637682400000, 655221600000, 669132000000, 686671200000, 700581600000, 718120800000, 732636000000, 749570400000, 764085600000, 781020000000, 795535200000, 812469600000, 826984800000, 844524000000, 858434400000, 875973600000, 889884000000, 907423200000, 921938400000, 938872800000, 953388000000, 970322400000, 984837600000, 1002376800000, 1016287200000, 1033826400000, 1047736800000, 1065276000000, 1079791200000, 1096725600000, 1111240800000, 1128175200000, 1142690400000, 1159624800000, 1174140000000, 1191074400000, 1207404000000, 1222524000000, 1238853600000, 1253973600000, 1270303200000, 1285423200000, 1301752800000, 1316872800000, 1333202400000, 1348927200000, 1365256800000, 1380376800000, 1396706400000, 1411826400000, 1428156000000, 1443276000000, 1459605600000, 1474725600000, 1491055200000, 1506175200000, 1522504800000, 1538229600000, 1554559200000, 1569679200000, 1586008800000, 1601128800000, 1617458400000, 1632578400000, 1648908000000, 1664028000000, 1680357600000, 1695477600000, 1712412000000, 1727532000000, 1743861600000, 1758981600000, 1775311200000, 1790431200000, 1806760800000, 1821880800000, 1838210400000, 1853330400000, 1869660000000, 1885384800000, 1901714400000, 1916834400000, 1933164000000, 1948284000000, 1964613600000, 1979733600000, 1996063200000, 2011183200000, 2027512800000, 2042632800000, 2058962400000, 2074687200000, 2091016800000, 2106136800000, 2122466400000, 2137586400000, null],
      "offsets": [-735, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
    },
    "NZ": {
      "abbrs": ["NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT"],
      "untils": [-1330335000000, -1320057000000, -1300699800000, -1287396000000, -1269250200000, -1255946400000, -1237800600000, -1224496800000, -1206351000000, -1192442400000, -1174901400000, -1160992800000, -1143451800000, -1125914400000, -1112607000000, -1094464800000, -1081157400000, -1063015200000, -1049707800000, -1031565600000, -1018258200000, -1000116000000, -986808600000, -968061600000, -955359000000, -936612000000, -923304600000, -757425600000, 152632800000, 162309600000, 183477600000, 194968800000, 215532000000, 226418400000, 246981600000, 257868000000, 278431200000, 289317600000, 309880800000, 320767200000, 341330400000, 352216800000, 372780000000, 384271200000, 404834400000, 415720800000, 436284000000, 447170400000, 467733600000, 478620000000, 499183200000, 510069600000, 530632800000, 541519200000, 562082400000, 573573600000, 594136800000, 605023200000, 623772000000, 637682400000, 655221600000, 669132000000, 686671200000, 700581600000, 718120800000, 732636000000, 749570400000, 764085600000, 781020000000, 795535200000, 812469600000, 826984800000, 844524000000, 858434400000, 875973600000, 889884000000, 907423200000, 921938400000, 938872800000, 953388000000, 970322400000, 984837600000, 1002376800000, 1016287200000, 1033826400000, 1047736800000, 1065276000000, 1079791200000, 1096725600000, 1111240800000, 1128175200000, 1142690400000, 1159624800000, 1174140000000, 1191074400000, 1207404000000, 1222524000000, 1238853600000, 1253973600000, 1270303200000, 1285423200000, 1301752800000, 1316872800000, 1333202400000, 1348927200000, 1365256800000, 1380376800000, 1396706400000, 1411826400000, 1428156000000, 1443276000000, 1459605600000, 1474725600000, 1491055200000, 1506175200000, 1522504800000, 1538229600000, 1554559200000, 1569679200000, 1586008800000, 1601128800000, 1617458400000, 1632578400000, 1648908000000, 1664028000000, 1680357600000, 1695477600000, 1712412000000, 1727532000000, 1743861600000, 1758981600000, 1775311200000, 1790431200000, 1806760800000, 1821880800000, 1838210400000, 1853330400000, 1869660000000, 1885384800000, 1901714400000, 1916834400000, 1933164000000, 1948284000000, 1964613600000, 1979733600000, 1996063200000, 2011183200000, 2027512800000, 2042632800000, 2058962400000, 2074687200000, 2091016800000, 2106136800000, 2122466400000, 2137586400000, null],
      "offsets": [-690, -750, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
    },
    "Navajo": {
      "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
      "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -1570374000000, -1551628800000, -1538924400000, -1534089600000, -880210800000, -769395600000, -765388800000, -147884400000, -131558400000, -116434800000, -100108800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
      "offsets": [420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "PRC": {
      "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
      "untils": [-933667200000, -922093200000, -908870400000, -888829200000, -881049600000, -767869200000, -745833600000, -733827600000, -716889600000, -699613200000, -683884800000, -670669200000, -652348800000, -650019600000, 515527200000, 527014800000, 545162400000, 558464400000, 577216800000, 589914000000, 608666400000, 621968400000, 640116000000, 653418000000, 671565600000, 684867600000, null],
      "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "PST8PDT": {
      "abbrs": ["PST", "PDT", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
      "untils": [-1633269600000, -1615129200000, -1601820000000, -1583679600000, -880207200000, -769395600000, -765385200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 126698400000, 152096400000, 162381600000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
      "offsets": [480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
      "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Pacific": {
      "Apia": {
        "abbrs": ["LMT", "-1130", "-11", "-10", "-11", "-10", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14"],
        "untils": [-1861878784000, -631110600000, 1285498800000, 1301752800000, 1316872800000, 1325239200000, 1333202400000, 1348927200000, 1365256800000, 1380376800000, 1396706400000, 1411826400000, 1428156000000, 1443276000000, 1459605600000, 1474725600000, 1491055200000, 1506175200000, 1522504800000, 1538229600000, 1554559200000, 1569679200000, 1586008800000, 1601128800000, 1617458400000, 1632578400000, 1648908000000, 1664028000000, 1680357600000, 1695477600000, 1712412000000, 1727532000000, 1743861600000, 1758981600000, 1775311200000, 1790431200000, 1806760800000, 1821880800000, 1838210400000, 1853330400000, 1869660000000, 1885384800000, 1901714400000, 1916834400000, 1933164000000, 1948284000000, 1964613600000, 1979733600000, 1996063200000, 2011183200000, 2027512800000, 2042632800000, 2058962400000, 2074687200000, 2091016800000, 2106136800000, 2122466400000, 2137586400000, null],
        "offsets": [686.9333, 690, 660, 600, 660, 600, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840, -780, -840],
        "isdsts": [0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Auckland": {
        "abbrs": ["NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZMT", "NZST", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT", "NZST", "NZDT"],
        "untils": [-1330335000000, -1320057000000, -1300699800000, -1287396000000, -1269250200000, -1255946400000, -1237800600000, -1224496800000, -1206351000000, -1192442400000, -1174901400000, -1160992800000, -1143451800000, -1125914400000, -1112607000000, -1094464800000, -1081157400000, -1063015200000, -1049707800000, -1031565600000, -1018258200000, -1000116000000, -986808600000, -968061600000, -955359000000, -936612000000, -923304600000, -757425600000, 152632800000, 162309600000, 183477600000, 194968800000, 215532000000, 226418400000, 246981600000, 257868000000, 278431200000, 289317600000, 309880800000, 320767200000, 341330400000, 352216800000, 372780000000, 384271200000, 404834400000, 415720800000, 436284000000, 447170400000, 467733600000, 478620000000, 499183200000, 510069600000, 530632800000, 541519200000, 562082400000, 573573600000, 594136800000, 605023200000, 623772000000, 637682400000, 655221600000, 669132000000, 686671200000, 700581600000, 718120800000, 732636000000, 749570400000, 764085600000, 781020000000, 795535200000, 812469600000, 826984800000, 844524000000, 858434400000, 875973600000, 889884000000, 907423200000, 921938400000, 938872800000, 953388000000, 970322400000, 984837600000, 1002376800000, 1016287200000, 1033826400000, 1047736800000, 1065276000000, 1079791200000, 1096725600000, 1111240800000, 1128175200000, 1142690400000, 1159624800000, 1174140000000, 1191074400000, 1207404000000, 1222524000000, 1238853600000, 1253973600000, 1270303200000, 1285423200000, 1301752800000, 1316872800000, 1333202400000, 1348927200000, 1365256800000, 1380376800000, 1396706400000, 1411826400000, 1428156000000, 1443276000000, 1459605600000, 1474725600000, 1491055200000, 1506175200000, 1522504800000, 1538229600000, 1554559200000, 1569679200000, 1586008800000, 1601128800000, 1617458400000, 1632578400000, 1648908000000, 1664028000000, 1680357600000, 1695477600000, 1712412000000, 1727532000000, 1743861600000, 1758981600000, 1775311200000, 1790431200000, 1806760800000, 1821880800000, 1838210400000, 1853330400000, 1869660000000, 1885384800000, 1901714400000, 1916834400000, 1933164000000, 1948284000000, 1964613600000, 1979733600000, 1996063200000, 2011183200000, 2027512800000, 2042632800000, 2058962400000, 2074687200000, 2091016800000, 2106136800000, 2122466400000, 2137586400000, null],
        "offsets": [-690, -750, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -690, -720, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Bougainville": {
        "abbrs": ["+10", "+09", "+10", "+11"],
        "untils": [-868010400000, -768906000000, 1419696000000, null],
        "offsets": [-600, -540, -600, -660],
        "isdsts": [0, 0, 0, 0]
      },
      "Chatham": {
        "abbrs": ["+1215", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345", "+1245", "+1345"],
        "untils": [-757426500000, 152632800000, 162309600000, 183477600000, 194968800000, 215532000000, 226418400000, 246981600000, 257868000000, 278431200000, 289317600000, 309880800000, 320767200000, 341330400000, 352216800000, 372780000000, 384271200000, 404834400000, 415720800000, 436284000000, 447170400000, 467733600000, 478620000000, 499183200000, 510069600000, 530632800000, 541519200000, 562082400000, 573573600000, 594136800000, 605023200000, 623772000000, 637682400000, 655221600000, 669132000000, 686671200000, 700581600000, 718120800000, 732636000000, 749570400000, 764085600000, 781020000000, 795535200000, 812469600000, 826984800000, 844524000000, 858434400000, 875973600000, 889884000000, 907423200000, 921938400000, 938872800000, 953388000000, 970322400000, 984837600000, 1002376800000, 1016287200000, 1033826400000, 1047736800000, 1065276000000, 1079791200000, 1096725600000, 1111240800000, 1128175200000, 1142690400000, 1159624800000, 1174140000000, 1191074400000, 1207404000000, 1222524000000, 1238853600000, 1253973600000, 1270303200000, 1285423200000, 1301752800000, 1316872800000, 1333202400000, 1348927200000, 1365256800000, 1380376800000, 1396706400000, 1411826400000, 1428156000000, 1443276000000, 1459605600000, 1474725600000, 1491055200000, 1506175200000, 1522504800000, 1538229600000, 1554559200000, 1569679200000, 1586008800000, 1601128800000, 1617458400000, 1632578400000, 1648908000000, 1664028000000, 1680357600000, 1695477600000, 1712412000000, 1727532000000, 1743861600000, 1758981600000, 1775311200000, 1790431200000, 1806760800000, 1821880800000, 1838210400000, 1853330400000, 1869660000000, 1885384800000, 1901714400000, 1916834400000, 1933164000000, 1948284000000, 1964613600000, 1979733600000, 1996063200000, 2011183200000, 2027512800000, 2042632800000, 2058962400000, 2074687200000, 2091016800000, 2106136800000, 2122466400000, 2137586400000, null],
        "offsets": [-735, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825, -765, -825],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Chuuk": {
        "abbrs": ["+10"],
        "untils": [null],
        "offsets": [-600],
        "isdsts": [0]
      },
      "Easter": {
        "abbrs": ["EMT", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-07", "-06", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05", "-06", "-05"],
        "untils": [-1178124152000, -36619200000, -23922000000, -3355200000, 7527600000, 24465600000, 37767600000, 55915200000, 69217200000, 87969600000, 100666800000, 118209600000, 132116400000, 150868800000, 163566000000, 182318400000, 195620400000, 213768000000, 227070000000, 245217600000, 258519600000, 277272000000, 289969200000, 308721600000, 321418800000, 340171200000, 353473200000, 371620800000, 384922800000, 403070400000, 416372400000, 434520000000, 447822000000, 466574400000, 479271600000, 498024000000, 510721200000, 529473600000, 545194800000, 560923200000, 574225200000, 592372800000, 605674800000, 624427200000, 637124400000, 653457600000, 668574000000, 687326400000, 700628400000, 718776000000, 732078000000, 750225600000, 763527600000, 781675200000, 794977200000, 813729600000, 826426800000, 845179200000, 859690800000, 876628800000, 889930800000, 906868800000, 923194800000, 939528000000, 952830000000, 971582400000, 984279600000, 1003032000000, 1015729200000, 1034481600000, 1047178800000, 1065931200000, 1079233200000, 1097380800000, 1110682800000, 1128830400000, 1142132400000, 1160884800000, 1173582000000, 1192334400000, 1206846000000, 1223784000000, 1237086000000, 1255233600000, 1270350000000, 1286683200000, 1304823600000, 1313899200000, 1335668400000, 1346558400000, 1367118000000, 1378612800000, 1398567600000, 1410062400000, 1463281200000, 1471147200000, 1494730800000, 1502596800000, 1526180400000, 1534046400000, 1554606000000, 1567915200000, 1586055600000, 1599364800000, 1617505200000, 1630814400000, 1648954800000, 1662264000000, 1680404400000, 1693713600000, 1712458800000, 1725768000000, 1743908400000, 1757217600000, 1775358000000, 1788667200000, 1806807600000, 1820116800000, 1838257200000, 1851566400000, 1870311600000, 1883016000000, 1901761200000, 1915070400000, 1933210800000, 1946520000000, 1964660400000, 1977969600000, 1996110000000, 2009419200000, 2027559600000, 2040868800000, 2059614000000, 2072318400000, 2091063600000, 2104372800000, 2122513200000, 2135822400000, null],
        "offsets": [437.4667, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1]
      },
      "Efate": {
        "abbrs": ["LMT", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11", "+12", "+11"],
        "untils": [-1829387596000, 433256400000, 448977600000, 467298000000, 480427200000, 496760400000, 511876800000, 528210000000, 543931200000, 559659600000, 575380800000, 591109200000, 606830400000, 622558800000, 638280000000, 654008400000, 669729600000, 686062800000, 696340800000, 719931600000, 727790400000, null],
        "offsets": [-673.2667, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660, -720, -660],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Enderbury": {
        "abbrs": ["-12", "-11", "+13"],
        "untils": [307627200000, 788871600000, null],
        "offsets": [720, 660, -780],
        "isdsts": [0, 0, 0]
      },
      "Fakaofo": {
        "abbrs": ["-11", "+13"],
        "untils": [1325242800000, null],
        "offsets": [660, -780],
        "isdsts": [0, 0]
      },
      "Fiji": {
        "abbrs": ["LMT", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12", "+13", "+12"],
        "untils": [-1709985344000, 909842400000, 920124000000, 941896800000, 951573600000, 1259416800000, 1269698400000, 1287842400000, 1299333600000, 1319292000000, 1327154400000, 1350741600000, 1358604000000, 1382796000000, 1390050000000, 1414850400000, 1421503200000, 1446300000000, 1452952800000, 1478354400000, 1484402400000, 1509804000000, 1515852000000, 1541253600000, 1547301600000, 1572703200000, 1579356000000, 1604152800000, 1610805600000, 1636207200000, 1642255200000, 1667656800000, 1673704800000, 1699106400000, 1705154400000, 1730556000000, 1737208800000, 1762005600000, 1768658400000, 1793455200000, 1800108000000, 1825509600000, 1831557600000, 1856959200000, 1863007200000, 1888408800000, 1894456800000, 1919858400000, 1926511200000, 1951308000000, 1957960800000, 1983362400000, 1989410400000, 2014812000000, 2020860000000, 2046261600000, 2052309600000, 2077711200000, 2083759200000, 2109160800000, 2115813600000, 2140610400000, 2147263200000, null],
        "offsets": [-715.7333, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720, -780, -720],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Funafuti": {
        "abbrs": ["+12"],
        "untils": [null],
        "offsets": [-720],
        "isdsts": [0]
      },
      "Galapagos": {
        "abbrs": ["LMT", "-05", "-06", "-05", "-06"],
        "untils": [-1230746496000, 504939600000, 722930400000, 728888400000, null],
        "offsets": [358.4, 300, 360, 300, 360],
        "isdsts": [0, 0, 0, 1, 0]
      },
      "Gambier": {
        "abbrs": ["LMT", "-09"],
        "untils": [-1806678012000, null],
        "offsets": [539.8, 540],
        "isdsts": [0, 0]
      },
      "Guadalcanal": {
        "abbrs": ["LMT", "+11"],
        "untils": [-1806748788000, null],
        "offsets": [-639.8, -660],
        "isdsts": [0, 0]
      },
      "Guam": {
        "abbrs": ["GST", "ChST"],
        "untils": [977493600000, null],
        "offsets": [-600, -600],
        "isdsts": [0, 0]
      },
      "Honolulu": {
        "abbrs": ["HST", "HDT", "HST", "HDT", "HST", "HST"],
        "untils": [-1157283000000, -1155436200000, -880198200000, -765376200000, -712150200000, null],
        "offsets": [630, 570, 630, 570, 630, 600],
        "isdsts": [0, 1, 0, 1, 0, 0]
      },
      "Johnston": {
        "abbrs": ["HST", "HDT", "HST", "HDT", "HST", "HST"],
        "untils": [-1157283000000, -1155436200000, -880198200000, -765376200000, -712150200000, null],
        "offsets": [630, 570, 630, 570, 630, 600],
        "isdsts": [0, 1, 0, 1, 0, 0]
      },
      "Kiritimati": {
        "abbrs": ["-1040", "-10", "+14"],
        "untils": [307622400000, 788868000000, null],
        "offsets": [640, 600, -840],
        "isdsts": [0, 0, 0]
      },
      "Kosrae": {
        "abbrs": ["+11", "+12", "+11"],
        "untils": [-7988400000, 915105600000, null],
        "offsets": [-660, -720, -660],
        "isdsts": [0, 0, 0]
      },
      "Kwajalein": {
        "abbrs": ["+11", "-12", "+12"],
        "untils": [-7988400000, 745848000000, null],
        "offsets": [-660, 720, -720],
        "isdsts": [0, 0, 0]
      },
      "Majuro": {
        "abbrs": ["+11", "+12"],
        "untils": [-7988400000, null],
        "offsets": [-660, -720],
        "isdsts": [0, 0]
      },
      "Marquesas": {
        "abbrs": ["LMT", "-0930"],
        "untils": [-1806676920000, null],
        "offsets": [558, 570],
        "isdsts": [0, 0]
      },
      "Midway": {
        "abbrs": ["LMT", "SST"],
        "untils": [-1861879032000, null],
        "offsets": [682.8, 660],
        "isdsts": [0, 0]
      },
      "Nauru": {
        "abbrs": ["LMT", "+1130", "+09", "+1130", "+12"],
        "untils": [-1545131260000, -877347000000, -800960400000, 294323400000, null],
        "offsets": [-667.6667, -690, -540, -690, -720],
        "isdsts": [0, 0, 0, 0, 0]
      },
      "Niue": {
        "abbrs": ["-1120", "-1130", "-11"],
        "untils": [-599575200000, 276089400000, null],
        "offsets": [680, 690, 660],
        "isdsts": [0, 0, 0]
      },
      "Norfolk": {
        "abbrs": ["+1112", "+1130", "+1230", "+1130", "+11"],
        "untils": [-599656320000, 152029800000, 162912600000, 1443882600000, null],
        "offsets": [-672, -690, -750, -690, -660],
        "isdsts": [0, 0, 1, 0, 0]
      },
      "Noumea": {
        "abbrs": ["LMT", "+11", "+12", "+11", "+12", "+11", "+12", "+11"],
        "untils": [-1829387148000, 250002000000, 257342400000, 281451600000, 288878400000, 849366000000, 857228400000, null],
        "offsets": [-665.8, -660, -720, -660, -720, -660, -720, -660],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0]
      },
      "Pago_Pago": {
        "abbrs": ["LMT", "SST"],
        "untils": [-1861879032000, null],
        "offsets": [682.8, 660],
        "isdsts": [0, 0]
      },
      "Palau": {
        "abbrs": ["+09"],
        "untils": [null],
        "offsets": [-540],
        "isdsts": [0]
      },
      "Pitcairn": {
        "abbrs": ["-0830", "-08"],
        "untils": [893665800000, null],
        "offsets": [510, 480],
        "isdsts": [0, 0]
      },
      "Pohnpei": {
        "abbrs": ["+11"],
        "untils": [null],
        "offsets": [-660],
        "isdsts": [0]
      },
      "Ponape": {
        "abbrs": ["+11"],
        "untils": [null],
        "offsets": [-660],
        "isdsts": [0]
      },
      "Port_Moresby": {
        "abbrs": ["+10"],
        "untils": [null],
        "offsets": [-600],
        "isdsts": [0]
      },
      "Rarotonga": {
        "abbrs": ["-1030", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10", "-0930", "-10"],
        "untils": [279714600000, 289387800000, 309952800000, 320837400000, 341402400000, 352287000000, 372852000000, 384341400000, 404906400000, 415791000000, 436356000000, 447240600000, 467805600000, 478690200000, 499255200000, 510139800000, 530704800000, 541589400000, 562154400000, 573643800000, 594208800000, 605093400000, 625658400000, 636543000000, 657108000000, 667992600000, null],
        "offsets": [630, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600, 570, 600],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Saipan": {
        "abbrs": ["GST", "ChST"],
        "untils": [977493600000, null],
        "offsets": [-600, -600],
        "isdsts": [0, 0]
      },
      "Samoa": {
        "abbrs": ["LMT", "SST"],
        "untils": [-1861879032000, null],
        "offsets": [682.8, 660],
        "isdsts": [0, 0]
      },
      "Tahiti": {
        "abbrs": ["LMT", "-10"],
        "untils": [-1806674504000, null],
        "offsets": [598.2667, 600],
        "isdsts": [0, 0]
      },
      "Tarawa": {
        "abbrs": ["+12"],
        "untils": [null],
        "offsets": [-720],
        "isdsts": [0]
      },
      "Tongatapu": {
        "abbrs": ["+1220", "+13", "+14", "+13", "+14", "+13", "+14", "+13", "+14", "+13"],
        "untils": [-915193200000, 939214800000, 953384400000, 973342800000, 980596800000, 1004792400000, 1012046400000, 1478350800000, 1484398800000, null],
        "offsets": [-740, -780, -840, -780, -840, -780, -840, -780, -840, -780],
        "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Truk": {
        "abbrs": ["+10"],
        "untils": [null],
        "offsets": [-600],
        "isdsts": [0]
      },
      "Wake": {
        "abbrs": ["+12"],
        "untils": [null],
        "offsets": [-720],
        "isdsts": [0]
      },
      "Wallis": {
        "abbrs": ["+12"],
        "untils": [null],
        "offsets": [-720],
        "isdsts": [0]
      },
      "Yap": {
        "abbrs": ["+10"],
        "untils": [null],
        "offsets": [-600],
        "isdsts": [0]
      }
    },
    "Poland": {
      "abbrs": ["WMT", "CET", "CEST", "CET", "CEST", "CET", "CEST", "EET", "EEST", "EET", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET"],
      "untils": [-1717032240000, -1693706400000, -1680483600000, -1663455600000, -1650150000000, -1632006000000, -1618700400000, -1600473600000, -1587168000000, -1501725600000, -931734000000, -857257200000, -844556400000, -828226800000, -812502000000, -796608000000, -778726800000, -762660000000, -748486800000, -733273200000, -715215600000, -701910000000, -684975600000, -670460400000, -654130800000, -639010800000, -397094400000, -386812800000, -371088000000, -355363200000, -334195200000, -323308800000, -307584000000, -291859200000, -271296000000, -260409600000, -239846400000, -228960000000, -208396800000, -197510400000, -176342400000, -166060800000, 228873600000, 243993600000, 260323200000, 276048000000, 291772800000, 307497600000, 323827200000, 338947200000, 354672000000, 370396800000, 386121600000, 401846400000, 417571200000, 433296000000, 449020800000, 465350400000, 481075200000, 496800000000, 512524800000, 528249600000, 543974400000, 559699200000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [-84, -60, -120, -60, -120, -60, -120, -120, -180, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60, -120, -60],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Portugal": {
      "abbrs": ["LMT", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WEMT", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "CET", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "CET", "CEST", "CET", "CEST", "CET", "CEST", "CET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
      "untils": [-1830384000000, -1689555600000, -1677801600000, -1667437200000, -1647738000000, -1635814800000, -1616202000000, -1604365200000, -1584666000000, -1572742800000, -1553043600000, -1541206800000, -1521507600000, -1442451600000, -1426813200000, -1379293200000, -1364778000000, -1348448400000, -1333328400000, -1316394000000, -1301274000000, -1284339600000, -1269824400000, -1221440400000, -1206925200000, -1191200400000, -1175475600000, -1127696400000, -1111971600000, -1096851600000, -1080522000000, -1063587600000, -1049072400000, -1033347600000, -1017622800000, -1002502800000, -986173200000, -969238800000, -950490000000, -942022800000, -922669200000, -906944400000, -891133200000, -877309200000, -873684000000, -864007200000, -857955600000, -845859600000, -842839200000, -831348000000, -825901200000, -814410000000, -810784800000, -799898400000, -794451600000, -782960400000, -779335200000, -768448800000, -763002000000, -749091600000, -733366800000, -717631200000, -701906400000, -686181600000, -670456800000, -654732000000, -639007200000, -591832800000, -575503200000, -559778400000, -544053600000, -528328800000, -512604000000, -496879200000, -481154400000, -465429600000, -449704800000, -433980000000, -417650400000, -401925600000, -386200800000, -370476000000, -354751200000, -339026400000, -323301600000, -307576800000, -291852000000, -276127200000, -260402400000, -244677600000, -228348000000, -212623200000, -196898400000, -181173600000, -165448800000, -149724000000, -133999200000, -118274400000, 212544000000, 228268800000, 243993600000, 260323200000, 276048000000, 291772800000, 307501200000, 323222400000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417578400000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [36.75, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -120, -60, 0, -60, -120, -60, 0, -60, -120, -60, 0, -60, -120, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, -60, -120, -60, -120, -60, -120, -60, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "ROC": {
      "abbrs": ["CST", "JST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
      "untils": [-1017820800000, -766224000000, -745833600000, -733827600000, -716889600000, -699613200000, -683884800000, -670669200000, -652348800000, -639133200000, -620812800000, -607597200000, -589276800000, -576061200000, -562924800000, -541760400000, -528710400000, -510224400000, -497174400000, -478688400000, -465638400000, -449830800000, -434016000000, -418208400000, -402480000000, -386672400000, -370944000000, -355136400000, -339408000000, -323600400000, -302515200000, -291978000000, -270979200000, -260442000000, 133977600000, 149785200000, 165513600000, 181321200000, 299606400000, 307551600000, null],
      "offsets": [-480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480, -540, -480],
      "isdsts": [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "ROK": {
      "abbrs": ["LMT", "KST", "JST", "KST", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KDT", "KST", "KST", "KDT", "KST", "KDT", "KST"],
      "untils": [-1948782472000, -1830414600000, -767350800000, -498128400000, -462702600000, -451733400000, -429784200000, -418296600000, -399544200000, -387451800000, -368094600000, -356002200000, -336645000000, -324552600000, -305195400000, -293103000000, -264933000000, 547578000000, 560883600000, 579027600000, 592333200000, null],
      "offsets": [-507.8667, -510, -540, -540, -510, -570, -510, -570, -510, -570, -510, -570, -510, -570, -510, -570, -510, -540, -600, -540, -600, -540],
      "isdsts": [0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0]
    },
    "Singapore": {
      "abbrs": ["SMT", "+07", "+0720", "+0720", "+0730", "+09", "+0730", "+08"],
      "untils": [-2038200925000, -1167634800000, -1073028000000, -894180000000, -879665400000, -767005200000, 378664200000, null],
      "offsets": [-415.4167, -420, -440, -440, -450, -540, -450, -480],
      "isdsts": [0, 0, 1, 0, 0, 0, 0, 0]
    },
    "Turkey": {
      "abbrs": ["IMT", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "+04", "+03", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "EET", "EEST", "+03"],
      "untils": [-1869875816000, -1693706400000, -1680490800000, -1570413600000, -1552186800000, -1538359200000, -1522551600000, -1507514400000, -1490583600000, -1440208800000, -1428030000000, -1409709600000, -1396494000000, -931140000000, -922762800000, -917834400000, -892436400000, -875844000000, -857358000000, -781063200000, -764737200000, -744343200000, -733806000000, -716436000000, -701924400000, -684986400000, -670474800000, -654141600000, -639025200000, -621828000000, -606970800000, -590032800000, -575434800000, -235620000000, -228279600000, -177732000000, -165726000000, 10533600000, 23835600000, 41983200000, 55285200000, 74037600000, 87339600000, 107910000000, 121219200000, 133920000000, 152676000000, 165362400000, 183502800000, 202428000000, 215557200000, 228866400000, 245797200000, 260316000000, 277246800000, 308779200000, 323827200000, 340228800000, 354672000000, 371678400000, 386121600000, 403128000000, 428446800000, 433886400000, 482792400000, 496702800000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 686098800000, 701823600000, 717548400000, 733273200000, 748998000000, 764118000000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301274000000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396227600000, 1414285200000, 1427590800000, 1446944400000, 1459040400000, 1473195600000, null],
      "offsets": [-116.9333, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -120, -180, -180],
      "isdsts": [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "UCT": {
      "abbrs": ["UCT"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "US": {
      "Alaska": {
        "abbrs": ["AST", "AWT", "APT", "AST", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "AHST", "AHDT", "YST", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST", "AKDT", "AKST"],
        "untils": [-880200000000, -769395600000, -765378000000, -86882400000, -21470400000, -5749200000, 9979200000, 25700400000, 41428800000, 57754800000, 73483200000, 89204400000, 104932800000, 120654000000, 126705600000, 152103600000, 162388800000, 183553200000, 199281600000, 215607600000, 230731200000, 247057200000, 262785600000, 278506800000, 294235200000, 309956400000, 325684800000, 341406000000, 357134400000, 372855600000, 388584000000, 404910000000, 420033600000, 436359600000, 439030800000, 452084400000, 467805600000, 483534000000, 499255200000, 514983600000, 530704800000, 544618800000, 562154400000, 576068400000, 594208800000, 607518000000, 625658400000, 638967600000, 657108000000, 671022000000, 688557600000, 702471600000, 720007200000, 733921200000, 752061600000, 765370800000, 783511200000, 796820400000, 814960800000, 828874800000, 846410400000, 860324400000, 877860000000, 891774000000, 909309600000, 923223600000, 941364000000, 954673200000, 972813600000, 986122800000, 1004263200000, 1018177200000, 1035712800000, 1049626800000, 1067162400000, 1081076400000, 1099216800000, 1112526000000, 1130666400000, 1143975600000, 1162116000000, 1173610800000, 1194170400000, 1205060400000, 1225620000000, 1236510000000, 1257069600000, 1268564400000, 1289124000000, 1300014000000, 1320573600000, 1331463600000, 1352023200000, 1362913200000, 1383472800000, 1394362800000, 1414922400000, 1425812400000, 1446372000000, 1457866800000, 1478426400000, 1489316400000, 1509876000000, 1520766000000, 1541325600000, 1552215600000, 1572775200000, 1583665200000, 1604224800000, 1615719600000, 1636279200000, 1647169200000, 1667728800000, 1678618800000, 1699178400000, 1710068400000, 1730628000000, 1741518000000, 1762077600000, 1772967600000, 1793527200000, 1805022000000, 1825581600000, 1836471600000, 1857031200000, 1867921200000, 1888480800000, 1899370800000, 1919930400000, 1930820400000, 1951380000000, 1962874800000, 1983434400000, 1994324400000, 2014884000000, 2025774000000, 2046333600000, 2057223600000, 2077783200000, 2088673200000, 2109232800000, 2120122800000, 2140682400000, null],
        "offsets": [600, 540, 540, 600, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 540, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540, 480, 540],
        "isdsts": [0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Aleutian": {
        "abbrs": ["NST", "NWT", "NPT", "NST", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "BST", "BDT", "AHST", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST", "HDT", "HST"],
        "untils": [-880196400000, -769395600000, -765374400000, -86878800000, -21466800000, -5745600000, 9982800000, 25704000000, 41432400000, 57758400000, 73486800000, 89208000000, 104936400000, 120657600000, 126709200000, 152107200000, 162392400000, 183556800000, 199285200000, 215611200000, 230734800000, 247060800000, 262789200000, 278510400000, 294238800000, 309960000000, 325688400000, 341409600000, 357138000000, 372859200000, 388587600000, 404913600000, 420037200000, 436363200000, 439034400000, 452088000000, 467809200000, 483537600000, 499258800000, 514987200000, 530708400000, 544622400000, 562158000000, 576072000000, 594212400000, 607521600000, 625662000000, 638971200000, 657111600000, 671025600000, 688561200000, 702475200000, 720010800000, 733924800000, 752065200000, 765374400000, 783514800000, 796824000000, 814964400000, 828878400000, 846414000000, 860328000000, 877863600000, 891777600000, 909313200000, 923227200000, 941367600000, 954676800000, 972817200000, 986126400000, 1004266800000, 1018180800000, 1035716400000, 1049630400000, 1067166000000, 1081080000000, 1099220400000, 1112529600000, 1130670000000, 1143979200000, 1162119600000, 1173614400000, 1194174000000, 1205064000000, 1225623600000, 1236513600000, 1257073200000, 1268568000000, 1289127600000, 1300017600000, 1320577200000, 1331467200000, 1352026800000, 1362916800000, 1383476400000, 1394366400000, 1414926000000, 1425816000000, 1446375600000, 1457870400000, 1478430000000, 1489320000000, 1509879600000, 1520769600000, 1541329200000, 1552219200000, 1572778800000, 1583668800000, 1604228400000, 1615723200000, 1636282800000, 1647172800000, 1667732400000, 1678622400000, 1699182000000, 1710072000000, 1730631600000, 1741521600000, 1762081200000, 1772971200000, 1793530800000, 1805025600000, 1825585200000, 1836475200000, 1857034800000, 1867924800000, 1888484400000, 1899374400000, 1919934000000, 1930824000000, 1951383600000, 1962878400000, 1983438000000, 1994328000000, 2014887600000, 2025777600000, 2046337200000, 2057227200000, 2077786800000, 2088676800000, 2109236400000, 2120126400000, 2140686000000, null],
        "offsets": [660, 600, 600, 660, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 660, 600, 600, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600, 540, 600],
        "isdsts": [0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Arizona": {
        "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MWT", "MST", "MWT", "MST", "MDT", "MST"],
        "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -880210800000, -820519140000, -812653140000, -796845540000, -84380400000, -68659200000, null],
        "offsets": [420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Central": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -1563724800000, -1551632400000, -1538928000000, -1520182800000, -1504454400000, -1491757200000, -1473004800000, -1459702800000, -1441555200000, -1428253200000, -1410105600000, -1396803600000, -1378656000000, -1365354000000, -1347206400000, -1333904400000, -1315152000000, -1301850000000, -1283702400000, -1270400400000, -1252252800000, -1238950800000, -1220803200000, -1207501200000, -1189353600000, -1176051600000, -1157299200000, -1144602000000, -1125849600000, -1112547600000, -1094400000000, -1081098000000, -1067788800000, -1045414800000, -1031500800000, -1018198800000, -1000051200000, -986749200000, -967996800000, -955299600000, -936547200000, -923245200000, -905097600000, -891795600000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -447267600000, -431539200000, -415818000000, -400089600000, -384368400000, -368640000000, -352918800000, -337190400000, -321469200000, -305740800000, -289414800000, -273686400000, -257965200000, -242236800000, -226515600000, -210787200000, -195066000000, -179337600000, -163616400000, -147888000000, -131562000000, -116438400000, -100112400000, -84384000000, -68662800000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 702460800000, 719996400000, 733910400000, 752050800000, 765360000000, 783500400000, 796809600000, 814950000000, 828864000000, 846399600000, 860313600000, 877849200000, 891763200000, 909298800000, 923212800000, 941353200000, 954662400000, 972802800000, 986112000000, 1004252400000, 1018166400000, 1035702000000, 1049616000000, 1067151600000, 1081065600000, 1099206000000, 1112515200000, 1130655600000, 1143964800000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "East-Indiana": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -900259200000, -891795600000, -880214400000, -769395600000, -765392400000, -747244800000, -733942800000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -386787600000, -368640000000, -21488400000, -5767200000, 9961200000, 25682400000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Eastern": {
        "abbrs": ["EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-1633280400000, -1615140000000, -1601830800000, -1583690400000, -1570381200000, -1551636000000, -1536512400000, -1523210400000, -1504458000000, -1491760800000, -1473008400000, -1459706400000, -1441558800000, -1428256800000, -1410109200000, -1396807200000, -1378659600000, -1365357600000, -1347210000000, -1333908000000, -1315155600000, -1301853600000, -1283706000000, -1270404000000, -1252256400000, -1238954400000, -1220806800000, -1207504800000, -1189357200000, -1176055200000, -1157302800000, -1144605600000, -1125853200000, -1112551200000, -1094403600000, -1081101600000, -1062954000000, -1049652000000, -1031504400000, -1018202400000, -1000054800000, -986752800000, -968000400000, -955303200000, -936550800000, -923248800000, -905101200000, -891799200000, -880218000000, -769395600000, -765396000000, -747248400000, -733946400000, -715798800000, -702496800000, -684349200000, -671047200000, -652899600000, -639597600000, -620845200000, -608148000000, -589395600000, -576093600000, -557946000000, -544644000000, -526496400000, -513194400000, -495046800000, -481744800000, -463597200000, -447271200000, -431542800000, -415821600000, -400093200000, -384372000000, -368643600000, -352922400000, -337194000000, -321472800000, -305744400000, -289418400000, -273690000000, -257968800000, -242240400000, -226519200000, -210790800000, -195069600000, -179341200000, -163620000000, -147891600000, -131565600000, -116442000000, -100116000000, -84387600000, -68666400000, -52938000000, -37216800000, -21488400000, -5767200000, 9961200000, 25682400000, 41410800000, 57736800000, 73465200000, 89186400000, 104914800000, 120636000000, 126687600000, 152085600000, 162370800000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Hawaii": {
        "abbrs": ["HST", "HDT", "HST", "HDT", "HST", "HST"],
        "untils": [-1157283000000, -1155436200000, -880198200000, -765376200000, -712150200000, null],
        "offsets": [630, 570, 630, 570, 630, 600],
        "isdsts": [0, 1, 0, 1, 0, 0]
      },
      "Indiana-Starke": {
        "abbrs": ["CST", "CDT", "CST", "CDT", "CST", "CWT", "CPT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "EST", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "EST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST", "CDT", "CST"],
        "untils": [-1633276800000, -1615136400000, -1601827200000, -1583686800000, -880214400000, -769395600000, -765392400000, -715795200000, -702493200000, -684345600000, -671043600000, -652896000000, -639594000000, -620841600000, -608144400000, -589392000000, -576090000000, -557942400000, -544640400000, -526492800000, -513190800000, -495043200000, -481741200000, -463593600000, -447267600000, -431539200000, -415818000000, -400089600000, -386787600000, -368640000000, -355338000000, -337190400000, -321469200000, -305740800000, -289414800000, -273686400000, -257965200000, -242236800000, -195066000000, -84384000000, -68662800000, -52934400000, -37213200000, -21484800000, -5763600000, 9964800000, 25686000000, 41414400000, 57740400000, 73468800000, 89190000000, 104918400000, 120639600000, 126691200000, 152089200000, 162374400000, 183538800000, 199267200000, 215593200000, 230716800000, 247042800000, 262771200000, 278492400000, 294220800000, 309942000000, 325670400000, 341391600000, 357120000000, 372841200000, 388569600000, 404895600000, 420019200000, 436345200000, 452073600000, 467794800000, 483523200000, 499244400000, 514972800000, 530694000000, 544608000000, 562143600000, 576057600000, 594198000000, 607507200000, 625647600000, 638956800000, 657097200000, 671011200000, 688546800000, 1143961200000, 1162105200000, 1173600000000, 1194159600000, 1205049600000, 1225609200000, 1236499200000, 1257058800000, 1268553600000, 1289113200000, 1300003200000, 1320562800000, 1331452800000, 1352012400000, 1362902400000, 1383462000000, 1394352000000, 1414911600000, 1425801600000, 1446361200000, 1457856000000, 1478415600000, 1489305600000, 1509865200000, 1520755200000, 1541314800000, 1552204800000, 1572764400000, 1583654400000, 1604214000000, 1615708800000, 1636268400000, 1647158400000, 1667718000000, 1678608000000, 1699167600000, 1710057600000, 1730617200000, 1741507200000, 1762066800000, 1772956800000, 1793516400000, 1805011200000, 1825570800000, 1836460800000, 1857020400000, 1867910400000, 1888470000000, 1899360000000, 1919919600000, 1930809600000, 1951369200000, 1962864000000, 1983423600000, 1994313600000, 2014873200000, 2025763200000, 2046322800000, 2057212800000, 2077772400000, 2088662400000, 2109222000000, 2120112000000, 2140671600000, null],
        "offsets": [360, 300, 360, 300, 360, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 300, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360, 300, 360],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Michigan": {
        "abbrs": ["LMT", "CST", "EST", "EWT", "EPT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST", "EDT", "EST"],
        "untils": [-2051202469000, -1724083200000, -880218000000, -769395600000, -765396000000, -684349200000, -671047200000, 104914800000, 120636000000, 126687600000, 152085600000, 167814000000, 183535200000, 199263600000, 215589600000, 230713200000, 247039200000, 262767600000, 278488800000, 294217200000, 309938400000, 325666800000, 341388000000, 357116400000, 372837600000, 388566000000, 404892000000, 420015600000, 436341600000, 452070000000, 467791200000, 483519600000, 499240800000, 514969200000, 530690400000, 544604400000, 562140000000, 576054000000, 594194400000, 607503600000, 625644000000, 638953200000, 657093600000, 671007600000, 688543200000, 702457200000, 719992800000, 733906800000, 752047200000, 765356400000, 783496800000, 796806000000, 814946400000, 828860400000, 846396000000, 860310000000, 877845600000, 891759600000, 909295200000, 923209200000, 941349600000, 954658800000, 972799200000, 986108400000, 1004248800000, 1018162800000, 1035698400000, 1049612400000, 1067148000000, 1081062000000, 1099202400000, 1112511600000, 1130652000000, 1143961200000, 1162101600000, 1173596400000, 1194156000000, 1205046000000, 1225605600000, 1236495600000, 1257055200000, 1268550000000, 1289109600000, 1299999600000, 1320559200000, 1331449200000, 1352008800000, 1362898800000, 1383458400000, 1394348400000, 1414908000000, 1425798000000, 1446357600000, 1457852400000, 1478412000000, 1489302000000, 1509861600000, 1520751600000, 1541311200000, 1552201200000, 1572760800000, 1583650800000, 1604210400000, 1615705200000, 1636264800000, 1647154800000, 1667714400000, 1678604400000, 1699164000000, 1710054000000, 1730613600000, 1741503600000, 1762063200000, 1772953200000, 1793512800000, 1805007600000, 1825567200000, 1836457200000, 1857016800000, 1867906800000, 1888466400000, 1899356400000, 1919916000000, 1930806000000, 1951365600000, 1962860400000, 1983420000000, 1994310000000, 2014869600000, 2025759600000, 2046319200000, 2057209200000, 2077768800000, 2088658800000, 2109218400000, 2120108400000, 2140668000000, null],
        "offsets": [332.1833, 360, 300, 240, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300, 240, 300],
        "isdsts": [0, 0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Mountain": {
        "abbrs": ["MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MWT", "MPT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST", "MDT", "MST"],
        "untils": [-1633273200000, -1615132800000, -1601823600000, -1583683200000, -1570374000000, -1551628800000, -1538924400000, -1534089600000, -880210800000, -769395600000, -765388800000, -147884400000, -131558400000, -116434800000, -100108800000, -84380400000, -68659200000, -52930800000, -37209600000, -21481200000, -5760000000, 9968400000, 25689600000, 41418000000, 57744000000, 73472400000, 89193600000, 104922000000, 120643200000, 126694800000, 152092800000, 162378000000, 183542400000, 199270800000, 215596800000, 230720400000, 247046400000, 262774800000, 278496000000, 294224400000, 309945600000, 325674000000, 341395200000, 357123600000, 372844800000, 388573200000, 404899200000, 420022800000, 436348800000, 452077200000, 467798400000, 483526800000, 499248000000, 514976400000, 530697600000, 544611600000, 562147200000, 576061200000, 594201600000, 607510800000, 625651200000, 638960400000, 657100800000, 671014800000, 688550400000, 702464400000, 720000000000, 733914000000, 752054400000, 765363600000, 783504000000, 796813200000, 814953600000, 828867600000, 846403200000, 860317200000, 877852800000, 891766800000, 909302400000, 923216400000, 941356800000, 954666000000, 972806400000, 986115600000, 1004256000000, 1018170000000, 1035705600000, 1049619600000, 1067155200000, 1081069200000, 1099209600000, 1112518800000, 1130659200000, 1143968400000, 1162108800000, 1173603600000, 1194163200000, 1205053200000, 1225612800000, 1236502800000, 1257062400000, 1268557200000, 1289116800000, 1300006800000, 1320566400000, 1331456400000, 1352016000000, 1362906000000, 1383465600000, 1394355600000, 1414915200000, 1425805200000, 1446364800000, 1457859600000, 1478419200000, 1489309200000, 1509868800000, 1520758800000, 1541318400000, 1552208400000, 1572768000000, 1583658000000, 1604217600000, 1615712400000, 1636272000000, 1647162000000, 1667721600000, 1678611600000, 1699171200000, 1710061200000, 1730620800000, 1741510800000, 1762070400000, 1772960400000, 1793520000000, 1805014800000, 1825574400000, 1836464400000, 1857024000000, 1867914000000, 1888473600000, 1899363600000, 1919923200000, 1930813200000, 1951372800000, 1962867600000, 1983427200000, 1994317200000, 2014876800000, 2025766800000, 2046326400000, 2057216400000, 2077776000000, 2088666000000, 2109225600000, 2120115600000, 2140675200000, null],
        "offsets": [420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420, 360, 420],
        "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Pacific-New": {
        "abbrs": ["PST", "PDT", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1633269600000, -1615129200000, -1601820000000, -1583679600000, -880207200000, -769395600000, -765385200000, -687967140000, -662655600000, -620838000000, -608137200000, -589388400000, -576082800000, -557938800000, -544633200000, -526489200000, -513183600000, -495039600000, -481734000000, -463590000000, -450284400000, -431535600000, -418230000000, -400086000000, -386780400000, -368636400000, -355330800000, -337186800000, -323881200000, -305737200000, -292431600000, -273682800000, -260982000000, -242233200000, -226508400000, -210783600000, -195058800000, -179334000000, -163609200000, -147884400000, -131554800000, -116434800000, -100105200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 126698400000, 152096400000, 162381600000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Pacific": {
        "abbrs": ["PST", "PDT", "PST", "PDT", "PST", "PWT", "PPT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST", "PDT", "PST"],
        "untils": [-1633269600000, -1615129200000, -1601820000000, -1583679600000, -880207200000, -769395600000, -765385200000, -687967140000, -662655600000, -620838000000, -608137200000, -589388400000, -576082800000, -557938800000, -544633200000, -526489200000, -513183600000, -495039600000, -481734000000, -463590000000, -450284400000, -431535600000, -418230000000, -400086000000, -386780400000, -368636400000, -355330800000, -337186800000, -323881200000, -305737200000, -292431600000, -273682800000, -260982000000, -242233200000, -226508400000, -210783600000, -195058800000, -179334000000, -163609200000, -147884400000, -131554800000, -116434800000, -100105200000, -84376800000, -68655600000, -52927200000, -37206000000, -21477600000, -5756400000, 9972000000, 25693200000, 41421600000, 57747600000, 73476000000, 89197200000, 104925600000, 120646800000, 126698400000, 152096400000, 162381600000, 183546000000, 199274400000, 215600400000, 230724000000, 247050000000, 262778400000, 278499600000, 294228000000, 309949200000, 325677600000, 341398800000, 357127200000, 372848400000, 388576800000, 404902800000, 420026400000, 436352400000, 452080800000, 467802000000, 483530400000, 499251600000, 514980000000, 530701200000, 544615200000, 562150800000, 576064800000, 594205200000, 607514400000, 625654800000, 638964000000, 657104400000, 671018400000, 688554000000, 702468000000, 720003600000, 733917600000, 752058000000, 765367200000, 783507600000, 796816800000, 814957200000, 828871200000, 846406800000, 860320800000, 877856400000, 891770400000, 909306000000, 923220000000, 941360400000, 954669600000, 972810000000, 986119200000, 1004259600000, 1018173600000, 1035709200000, 1049623200000, 1067158800000, 1081072800000, 1099213200000, 1112522400000, 1130662800000, 1143972000000, 1162112400000, 1173607200000, 1194166800000, 1205056800000, 1225616400000, 1236506400000, 1257066000000, 1268560800000, 1289120400000, 1300010400000, 1320570000000, 1331460000000, 1352019600000, 1362909600000, 1383469200000, 1394359200000, 1414918800000, 1425808800000, 1446368400000, 1457863200000, 1478422800000, 1489312800000, 1509872400000, 1520762400000, 1541322000000, 1552212000000, 1572771600000, 1583661600000, 1604221200000, 1615716000000, 1636275600000, 1647165600000, 1667725200000, 1678615200000, 1699174800000, 1710064800000, 1730624400000, 1741514400000, 1762074000000, 1772964000000, 1793523600000, 1805018400000, 1825578000000, 1836468000000, 1857027600000, 1867917600000, 1888477200000, 1899367200000, 1919926800000, 1930816800000, 1951376400000, 1962871200000, 1983430800000, 1994320800000, 2014880400000, 2025770400000, 2046330000000, 2057220000000, 2077779600000, 2088669600000, 2109229200000, 2120119200000, 2140678800000, null],
        "offsets": [480, 420, 480, 420, 480, 420, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480, 420, 480],
        "isdsts": [0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
      },
      "Samoa": {
        "abbrs": ["LMT", "SST"],
        "untils": [-1861879032000, null],
        "offsets": [682.8, 660],
        "isdsts": [0, 0]
      }
    },
    "UTC": {
      "abbrs": ["UTC"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "Universal": {
      "abbrs": ["UTC"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    },
    "W-SU": {
      "abbrs": ["MMT", "MMT", "MST", "MMT", "MDST", "MST", "MDST", "MSD", "MSK", "MSD", "+05", "MSD", "MSK", "EET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "EEST", "EET", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSD", "MSK", "MSK", "MSK"],
      "untils": [-1688265017000, -1656819079000, -1641353479000, -1627965079000, -1618716679000, -1596429079000, -1593820800000, -1589860800000, -1542427200000, -1539493200000, -1525323600000, -1522728000000, -1491188400000, -1247536800000, 354920400000, 370728000000, 386456400000, 402264000000, 417992400000, 433800000000, 449614800000, 465346800000, 481071600000, 496796400000, 512521200000, 528246000000, 543970800000, 559695600000, 575420400000, 591145200000, 606870000000, 622594800000, 638319600000, 654649200000, 670374000000, 686102400000, 695779200000, 701823600000, 717548400000, 733273200000, 748998000000, 764722800000, 780447600000, 796172400000, 811897200000, 828226800000, 846370800000, 859676400000, 877820400000, 891126000000, 909270000000, 922575600000, 941324400000, 954025200000, 972774000000, 985474800000, 1004223600000, 1017529200000, 1035673200000, 1048978800000, 1067122800000, 1080428400000, 1099177200000, 1111878000000, 1130626800000, 1143327600000, 1162076400000, 1174777200000, 1193526000000, 1206831600000, 1224975600000, 1238281200000, 1256425200000, 1269730800000, 1288479600000, 1301180400000, 1414274400000, null],
      "offsets": [-150.2833, -151.3167, -211.3167, -151.3167, -271.3167, -211.3167, -271.3167, -240, -180, -240, -300, -240, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -180, -120, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180, -240, -180],
      "isdsts": [0, 0, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0]
    },
    "WET": {
      "abbrs": ["WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET", "WEST", "WET"],
      "untils": [228877200000, 243997200000, 260326800000, 276051600000, 291776400000, 307501200000, 323830800000, 338950800000, 354675600000, 370400400000, 386125200000, 401850000000, 417574800000, 433299600000, 449024400000, 465354000000, 481078800000, 496803600000, 512528400000, 528253200000, 543978000000, 559702800000, 575427600000, 591152400000, 606877200000, 622602000000, 638326800000, 654656400000, 670381200000, 686106000000, 701830800000, 717555600000, 733280400000, 749005200000, 764730000000, 780454800000, 796179600000, 811904400000, 828234000000, 846378000000, 859683600000, 877827600000, 891133200000, 909277200000, 922582800000, 941331600000, 954032400000, 972781200000, 985482000000, 1004230800000, 1017536400000, 1035680400000, 1048986000000, 1067130000000, 1080435600000, 1099184400000, 1111885200000, 1130634000000, 1143334800000, 1162083600000, 1174784400000, 1193533200000, 1206838800000, 1224982800000, 1238288400000, 1256432400000, 1269738000000, 1288486800000, 1301187600000, 1319936400000, 1332637200000, 1351386000000, 1364691600000, 1382835600000, 1396141200000, 1414285200000, 1427590800000, 1445734800000, 1459040400000, 1477789200000, 1490490000000, 1509238800000, 1521939600000, 1540688400000, 1553994000000, 1572138000000, 1585443600000, 1603587600000, 1616893200000, 1635642000000, 1648342800000, 1667091600000, 1679792400000, 1698541200000, 1711846800000, 1729990800000, 1743296400000, 1761440400000, 1774746000000, 1792890000000, 1806195600000, 1824944400000, 1837645200000, 1856394000000, 1869094800000, 1887843600000, 1901149200000, 1919293200000, 1932598800000, 1950742800000, 1964048400000, 1982797200000, 1995498000000, 2014246800000, 2026947600000, 2045696400000, 2058397200000, 2077146000000, 2090451600000, 2108595600000, 2121901200000, 2140045200000, null],
      "offsets": [0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0, -60, 0],
      "isdsts": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0]
    },
    "Zulu": {
      "abbrs": ["UTC"],
      "untils": [null],
      "offsets": [0],
      "isdsts": [0]
    }
  }
});
Globalize.locale("cs");
module.exports = Globalize;